
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5ce2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5ce2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4mwsf", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ivxNE"));

});
parcelRegister("ivxNE", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $d795572f61e107c9$export$ffb0004e005737fa, (v) => $d795572f61e107c9$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $d795572f61e107c9$export$34b9dba7ce09269b, (v) => $d795572f61e107c9$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $d795572f61e107c9$export$25062201e9e25d76, (v) => $d795572f61e107c9$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d795572f61e107c9$export$ffb0004e005737fa;
var $d795572f61e107c9$export$34b9dba7ce09269b;
var $d795572f61e107c9$export$25062201e9e25d76;
"use strict";

var $3qjKr = parcelRequire("3qjKr");
var $d795572f61e107c9$var$k = Symbol.for("react.element"), $d795572f61e107c9$var$l = Symbol.for("react.fragment"), $d795572f61e107c9$var$m = Object.prototype.hasOwnProperty, $d795572f61e107c9$var$n = $3qjKr.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $d795572f61e107c9$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $d795572f61e107c9$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$d795572f61e107c9$var$m.call(a, b) && !$d795572f61e107c9$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $d795572f61e107c9$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $d795572f61e107c9$var$n.current
    };
}
$d795572f61e107c9$export$ffb0004e005737fa = $d795572f61e107c9$var$l;
$d795572f61e107c9$export$34b9dba7ce09269b = $d795572f61e107c9$var$q;
$d795572f61e107c9$export$25062201e9e25d76 = $d795572f61e107c9$var$q;

});
parcelRegister("3qjKr", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4UOTC"));

});
parcelRegister("4UOTC", function(module, exports) {

$parcel$export(module.exports, "Children", () => $3943df4ce293c770$export$dca3b0875bd9a954, (v) => $3943df4ce293c770$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $3943df4ce293c770$export$16fa2f45be04daa8, (v) => $3943df4ce293c770$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $3943df4ce293c770$export$ffb0004e005737fa, (v) => $3943df4ce293c770$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $3943df4ce293c770$export$e2c29f18771995cb, (v) => $3943df4ce293c770$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $3943df4ce293c770$export$221d75b3f55bb0bd, (v) => $3943df4ce293c770$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $3943df4ce293c770$export$5f8d39834fd61797, (v) => $3943df4ce293c770$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $3943df4ce293c770$export$74bf444e3cd11ea5, (v) => $3943df4ce293c770$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $3943df4ce293c770$export$ae55be85d98224ed, (v) => $3943df4ce293c770$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $3943df4ce293c770$export$e530037191fcd5d7, (v) => $3943df4ce293c770$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $3943df4ce293c770$export$fd42f52fd3ae1109, (v) => $3943df4ce293c770$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $3943df4ce293c770$export$c8a8987d4410bf2d, (v) => $3943df4ce293c770$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $3943df4ce293c770$export$d38cd72104c1f0e9, (v) => $3943df4ce293c770$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $3943df4ce293c770$export$7d1e3a5e95ceca43, (v) => $3943df4ce293c770$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $3943df4ce293c770$export$257a8862b851cb5b, (v) => $3943df4ce293c770$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $3943df4ce293c770$export$a8257692ac88316c, (v) => $3943df4ce293c770$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $3943df4ce293c770$export$488013bae63b21da, (v) => $3943df4ce293c770$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $3943df4ce293c770$export$7c73462e0d25e514, (v) => $3943df4ce293c770$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $3943df4ce293c770$export$7568632d0d33d16d, (v) => $3943df4ce293c770$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $3943df4ce293c770$export$88948ce120ea2619, (v) => $3943df4ce293c770$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $3943df4ce293c770$export$35808ee640e87ca7, (v) => $3943df4ce293c770$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $3943df4ce293c770$export$fae74005e78b1a27, (v) => $3943df4ce293c770$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $3943df4ce293c770$export$dc8fbce3eb94dc1e, (v) => $3943df4ce293c770$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $3943df4ce293c770$export$6a7bc4e911dc01cf, (v) => $3943df4ce293c770$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $3943df4ce293c770$export$6d9c69b0de29b591, (v) => $3943df4ce293c770$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $3943df4ce293c770$export$f680877a34711e37, (v) => $3943df4ce293c770$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $3943df4ce293c770$export$d5a552a76deda3c2, (v) => $3943df4ce293c770$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $3943df4ce293c770$export$aaabe4eda9ed9969, (v) => $3943df4ce293c770$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $3943df4ce293c770$export$e5c5a5f917a5871c, (v) => $3943df4ce293c770$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $3943df4ce293c770$export$1538c33de8887b59, (v) => $3943df4ce293c770$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $3943df4ce293c770$export$13e3392192263954, (v) => $3943df4ce293c770$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $3943df4ce293c770$export$b8f5890fc79d6aca, (v) => $3943df4ce293c770$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $3943df4ce293c770$export$60241385465d0a34, (v) => $3943df4ce293c770$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $3943df4ce293c770$export$306c0aa65ff9ec16, (v) => $3943df4ce293c770$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $3943df4ce293c770$export$7b286972b8d8ccbf, (v) => $3943df4ce293c770$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $3943df4ce293c770$export$83d89fbfd8236492, (v) => $3943df4ce293c770$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3943df4ce293c770$export$dca3b0875bd9a954;
var $3943df4ce293c770$export$16fa2f45be04daa8;
var $3943df4ce293c770$export$ffb0004e005737fa;
var $3943df4ce293c770$export$e2c29f18771995cb;
var $3943df4ce293c770$export$221d75b3f55bb0bd;
var $3943df4ce293c770$export$5f8d39834fd61797;
var $3943df4ce293c770$export$74bf444e3cd11ea5;
var $3943df4ce293c770$export$ae55be85d98224ed;
var $3943df4ce293c770$export$e530037191fcd5d7;
var $3943df4ce293c770$export$fd42f52fd3ae1109;
var $3943df4ce293c770$export$c8a8987d4410bf2d;
var $3943df4ce293c770$export$d38cd72104c1f0e9;
var $3943df4ce293c770$export$7d1e3a5e95ceca43;
var $3943df4ce293c770$export$257a8862b851cb5b;
var $3943df4ce293c770$export$a8257692ac88316c;
var $3943df4ce293c770$export$488013bae63b21da;
var $3943df4ce293c770$export$7c73462e0d25e514;
var $3943df4ce293c770$export$7568632d0d33d16d;
var $3943df4ce293c770$export$88948ce120ea2619;
var $3943df4ce293c770$export$35808ee640e87ca7;
var $3943df4ce293c770$export$fae74005e78b1a27;
var $3943df4ce293c770$export$dc8fbce3eb94dc1e;
var $3943df4ce293c770$export$6a7bc4e911dc01cf;
var $3943df4ce293c770$export$6d9c69b0de29b591;
var $3943df4ce293c770$export$f680877a34711e37;
var $3943df4ce293c770$export$d5a552a76deda3c2;
var $3943df4ce293c770$export$aaabe4eda9ed9969;
var $3943df4ce293c770$export$e5c5a5f917a5871c;
var $3943df4ce293c770$export$1538c33de8887b59;
var $3943df4ce293c770$export$13e3392192263954;
var $3943df4ce293c770$export$b8f5890fc79d6aca;
var $3943df4ce293c770$export$60241385465d0a34;
var $3943df4ce293c770$export$306c0aa65ff9ec16;
var $3943df4ce293c770$export$7b286972b8d8ccbf;
var $3943df4ce293c770$export$83d89fbfd8236492;
"use strict";
var $3943df4ce293c770$var$l = Symbol.for("react.element"), $3943df4ce293c770$var$n = Symbol.for("react.portal"), $3943df4ce293c770$var$p = Symbol.for("react.fragment"), $3943df4ce293c770$var$q = Symbol.for("react.strict_mode"), $3943df4ce293c770$var$r = Symbol.for("react.profiler"), $3943df4ce293c770$var$t = Symbol.for("react.provider"), $3943df4ce293c770$var$u = Symbol.for("react.context"), $3943df4ce293c770$var$v = Symbol.for("react.forward_ref"), $3943df4ce293c770$var$w = Symbol.for("react.suspense"), $3943df4ce293c770$var$x = Symbol.for("react.memo"), $3943df4ce293c770$var$y = Symbol.for("react.lazy"), $3943df4ce293c770$var$z = Symbol.iterator;
function $3943df4ce293c770$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $3943df4ce293c770$var$z && a[$3943df4ce293c770$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $3943df4ce293c770$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $3943df4ce293c770$var$C = Object.assign, $3943df4ce293c770$var$D = {};
function $3943df4ce293c770$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $3943df4ce293c770$var$D;
    this.updater = e || $3943df4ce293c770$var$B;
}
$3943df4ce293c770$var$E.prototype.isReactComponent = {};
$3943df4ce293c770$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$3943df4ce293c770$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $3943df4ce293c770$var$F() {}
$3943df4ce293c770$var$F.prototype = $3943df4ce293c770$var$E.prototype;
function $3943df4ce293c770$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $3943df4ce293c770$var$D;
    this.updater = e || $3943df4ce293c770$var$B;
}
var $3943df4ce293c770$var$H = $3943df4ce293c770$var$G.prototype = new $3943df4ce293c770$var$F;
$3943df4ce293c770$var$H.constructor = $3943df4ce293c770$var$G;
$3943df4ce293c770$var$C($3943df4ce293c770$var$H, $3943df4ce293c770$var$E.prototype);
$3943df4ce293c770$var$H.isPureReactComponent = !0;
var $3943df4ce293c770$var$I = Array.isArray, $3943df4ce293c770$var$J = Object.prototype.hasOwnProperty, $3943df4ce293c770$var$K = {
    current: null
}, $3943df4ce293c770$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $3943df4ce293c770$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$3943df4ce293c770$var$J.call(b, d) && !$3943df4ce293c770$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $3943df4ce293c770$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $3943df4ce293c770$var$K.current
    };
}
function $3943df4ce293c770$var$N(a, b) {
    return {
        $$typeof: $3943df4ce293c770$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $3943df4ce293c770$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $3943df4ce293c770$var$l;
}
function $3943df4ce293c770$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $3943df4ce293c770$var$P = /\/+/g;
function $3943df4ce293c770$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $3943df4ce293c770$var$escape("" + a.key) : b.toString(36);
}
function $3943df4ce293c770$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $3943df4ce293c770$var$l:
                case $3943df4ce293c770$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $3943df4ce293c770$var$Q(h, 0) : d, $3943df4ce293c770$var$I(c) ? (e = "", null != a && (e = a.replace($3943df4ce293c770$var$P, "$&/") + "/"), $3943df4ce293c770$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($3943df4ce293c770$var$O(c) && (c = $3943df4ce293c770$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($3943df4ce293c770$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($3943df4ce293c770$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $3943df4ce293c770$var$Q(k, g);
        h += $3943df4ce293c770$var$R(k, b, e, f, c);
    }
    else if (f = $3943df4ce293c770$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $3943df4ce293c770$var$Q(k, g++), h += $3943df4ce293c770$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $3943df4ce293c770$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $3943df4ce293c770$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $3943df4ce293c770$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $3943df4ce293c770$var$U = {
    current: null
}, $3943df4ce293c770$var$V = {
    transition: null
}, $3943df4ce293c770$var$W = {
    ReactCurrentDispatcher: $3943df4ce293c770$var$U,
    ReactCurrentBatchConfig: $3943df4ce293c770$var$V,
    ReactCurrentOwner: $3943df4ce293c770$var$K
};
$3943df4ce293c770$export$dca3b0875bd9a954 = {
    map: $3943df4ce293c770$var$S,
    forEach: function(a, b, e) {
        $3943df4ce293c770$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $3943df4ce293c770$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $3943df4ce293c770$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$3943df4ce293c770$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$3943df4ce293c770$export$16fa2f45be04daa8 = $3943df4ce293c770$var$E;
$3943df4ce293c770$export$ffb0004e005737fa = $3943df4ce293c770$var$p;
$3943df4ce293c770$export$e2c29f18771995cb = $3943df4ce293c770$var$r;
$3943df4ce293c770$export$221d75b3f55bb0bd = $3943df4ce293c770$var$G;
$3943df4ce293c770$export$5f8d39834fd61797 = $3943df4ce293c770$var$q;
$3943df4ce293c770$export$74bf444e3cd11ea5 = $3943df4ce293c770$var$w;
$3943df4ce293c770$export$ae55be85d98224ed = $3943df4ce293c770$var$W;
$3943df4ce293c770$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $3943df4ce293c770$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $3943df4ce293c770$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$3943df4ce293c770$var$J.call(b, f) && !$3943df4ce293c770$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $3943df4ce293c770$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$3943df4ce293c770$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $3943df4ce293c770$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $3943df4ce293c770$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$3943df4ce293c770$export$c8a8987d4410bf2d = $3943df4ce293c770$var$M;
$3943df4ce293c770$export$d38cd72104c1f0e9 = function(a) {
    var b = $3943df4ce293c770$var$M.bind(null, a);
    b.type = a;
    return b;
};
$3943df4ce293c770$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$3943df4ce293c770$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $3943df4ce293c770$var$v,
        render: a
    };
};
$3943df4ce293c770$export$a8257692ac88316c = $3943df4ce293c770$var$O;
$3943df4ce293c770$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $3943df4ce293c770$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $3943df4ce293c770$var$T
    };
};
$3943df4ce293c770$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $3943df4ce293c770$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$3943df4ce293c770$export$7568632d0d33d16d = function(a) {
    var b = $3943df4ce293c770$var$V.transition;
    $3943df4ce293c770$var$V.transition = {};
    try {
        a();
    } finally{
        $3943df4ce293c770$var$V.transition = b;
    }
};
$3943df4ce293c770$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$3943df4ce293c770$export$35808ee640e87ca7 = function(a, b) {
    return $3943df4ce293c770$var$U.current.useCallback(a, b);
};
$3943df4ce293c770$export$fae74005e78b1a27 = function(a) {
    return $3943df4ce293c770$var$U.current.useContext(a);
};
$3943df4ce293c770$export$dc8fbce3eb94dc1e = function() {};
$3943df4ce293c770$export$6a7bc4e911dc01cf = function(a) {
    return $3943df4ce293c770$var$U.current.useDeferredValue(a);
};
$3943df4ce293c770$export$6d9c69b0de29b591 = function(a, b) {
    return $3943df4ce293c770$var$U.current.useEffect(a, b);
};
$3943df4ce293c770$export$f680877a34711e37 = function() {
    return $3943df4ce293c770$var$U.current.useId();
};
$3943df4ce293c770$export$d5a552a76deda3c2 = function(a, b, e) {
    return $3943df4ce293c770$var$U.current.useImperativeHandle(a, b, e);
};
$3943df4ce293c770$export$aaabe4eda9ed9969 = function(a, b) {
    return $3943df4ce293c770$var$U.current.useInsertionEffect(a, b);
};
$3943df4ce293c770$export$e5c5a5f917a5871c = function(a, b) {
    return $3943df4ce293c770$var$U.current.useLayoutEffect(a, b);
};
$3943df4ce293c770$export$1538c33de8887b59 = function(a, b) {
    return $3943df4ce293c770$var$U.current.useMemo(a, b);
};
$3943df4ce293c770$export$13e3392192263954 = function(a, b, e) {
    return $3943df4ce293c770$var$U.current.useReducer(a, b, e);
};
$3943df4ce293c770$export$b8f5890fc79d6aca = function(a) {
    return $3943df4ce293c770$var$U.current.useRef(a);
};
$3943df4ce293c770$export$60241385465d0a34 = function(a) {
    return $3943df4ce293c770$var$U.current.useState(a);
};
$3943df4ce293c770$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $3943df4ce293c770$var$U.current.useSyncExternalStore(a, b, e);
};
$3943df4ce293c770$export$7b286972b8d8ccbf = function() {
    return $3943df4ce293c770$var$U.current.useTransition();
};
$3943df4ce293c770$export$83d89fbfd8236492 = "18.2.0";

});




parcelRegister("270oX", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $189c8bfad96741a8$export$ae55be85d98224ed, (v) => $189c8bfad96741a8$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $189c8bfad96741a8$export$d39a5bbd09211389, (v) => $189c8bfad96741a8$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $189c8bfad96741a8$export$882461b6382ed46c, (v) => $189c8bfad96741a8$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $189c8bfad96741a8$export$466bfc07425424d5, (v) => $189c8bfad96741a8$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $189c8bfad96741a8$export$cd75ccfd720a3cd4, (v) => $189c8bfad96741a8$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $189c8bfad96741a8$export$fa8d919ba61d84db, (v) => $189c8bfad96741a8$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $189c8bfad96741a8$export$757ceba2d55c277e, (v) => $189c8bfad96741a8$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $189c8bfad96741a8$export$b3890eb0ae9dca99, (v) => $189c8bfad96741a8$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $189c8bfad96741a8$export$502457920280e6be, (v) => $189c8bfad96741a8$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $189c8bfad96741a8$export$c78a37762a8d58e1, (v) => $189c8bfad96741a8$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $189c8bfad96741a8$export$dc54d992c10e8a18, (v) => $189c8bfad96741a8$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $189c8bfad96741a8$export$83d89fbfd8236492, (v) => $189c8bfad96741a8$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $189c8bfad96741a8$export$ae55be85d98224ed;
var $189c8bfad96741a8$export$d39a5bbd09211389;
var $189c8bfad96741a8$export$882461b6382ed46c;
var $189c8bfad96741a8$export$466bfc07425424d5;
var $189c8bfad96741a8$export$cd75ccfd720a3cd4;
var $189c8bfad96741a8$export$fa8d919ba61d84db;
var $189c8bfad96741a8$export$757ceba2d55c277e;
var $189c8bfad96741a8$export$b3890eb0ae9dca99;
var $189c8bfad96741a8$export$502457920280e6be;
var $189c8bfad96741a8$export$c78a37762a8d58e1;
var $189c8bfad96741a8$export$dc54d992c10e8a18;
var $189c8bfad96741a8$export$83d89fbfd8236492;
"use strict";

var $3qjKr = parcelRequire("3qjKr");

var $9LeLq = parcelRequire("9LeLq");
function $189c8bfad96741a8$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $189c8bfad96741a8$var$da = new Set, $189c8bfad96741a8$var$ea = {};
function $189c8bfad96741a8$var$fa(a, b) {
    $189c8bfad96741a8$var$ha(a, b);
    $189c8bfad96741a8$var$ha(a + "Capture", b);
}
function $189c8bfad96741a8$var$ha(a, b) {
    $189c8bfad96741a8$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$189c8bfad96741a8$var$da.add(b[a]);
}
var $189c8bfad96741a8$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $189c8bfad96741a8$var$ja = Object.prototype.hasOwnProperty, $189c8bfad96741a8$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $189c8bfad96741a8$var$la = {}, $189c8bfad96741a8$var$ma = {};
function $189c8bfad96741a8$var$oa(a) {
    if ($189c8bfad96741a8$var$ja.call($189c8bfad96741a8$var$ma, a)) return !0;
    if ($189c8bfad96741a8$var$ja.call($189c8bfad96741a8$var$la, a)) return !1;
    if ($189c8bfad96741a8$var$ka.test(a)) return $189c8bfad96741a8$var$ma[a] = !0;
    $189c8bfad96741a8$var$la[a] = !0;
    return !1;
}
function $189c8bfad96741a8$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $189c8bfad96741a8$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $189c8bfad96741a8$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $189c8bfad96741a8$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $189c8bfad96741a8$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $189c8bfad96741a8$var$z[a] = new $189c8bfad96741a8$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $189c8bfad96741a8$var$z[b] = new $189c8bfad96741a8$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $189c8bfad96741a8$var$z[a] = new $189c8bfad96741a8$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $189c8bfad96741a8$var$z[a] = new $189c8bfad96741a8$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $189c8bfad96741a8$var$z[a] = new $189c8bfad96741a8$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $189c8bfad96741a8$var$z[a] = new $189c8bfad96741a8$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $189c8bfad96741a8$var$z[a] = new $189c8bfad96741a8$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $189c8bfad96741a8$var$z[a] = new $189c8bfad96741a8$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $189c8bfad96741a8$var$z[a] = new $189c8bfad96741a8$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $189c8bfad96741a8$var$ra = /[\-:]([a-z])/g;
function $189c8bfad96741a8$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($189c8bfad96741a8$var$ra, $189c8bfad96741a8$var$sa);
    $189c8bfad96741a8$var$z[b] = new $189c8bfad96741a8$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($189c8bfad96741a8$var$ra, $189c8bfad96741a8$var$sa);
    $189c8bfad96741a8$var$z[b] = new $189c8bfad96741a8$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($189c8bfad96741a8$var$ra, $189c8bfad96741a8$var$sa);
    $189c8bfad96741a8$var$z[b] = new $189c8bfad96741a8$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $189c8bfad96741a8$var$z[a] = new $189c8bfad96741a8$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$189c8bfad96741a8$var$z.xlinkHref = new $189c8bfad96741a8$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $189c8bfad96741a8$var$z[a] = new $189c8bfad96741a8$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $189c8bfad96741a8$var$ta(a, b, c, d) {
    var e = $189c8bfad96741a8$var$z.hasOwnProperty(b) ? $189c8bfad96741a8$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $189c8bfad96741a8$var$qa(b, c, e, d) && (c = null), d || null === e ? $189c8bfad96741a8$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $189c8bfad96741a8$var$ua = $3qjKr.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $189c8bfad96741a8$var$va = Symbol.for("react.element"), $189c8bfad96741a8$var$wa = Symbol.for("react.portal"), $189c8bfad96741a8$var$ya = Symbol.for("react.fragment"), $189c8bfad96741a8$var$za = Symbol.for("react.strict_mode"), $189c8bfad96741a8$var$Aa = Symbol.for("react.profiler"), $189c8bfad96741a8$var$Ba = Symbol.for("react.provider"), $189c8bfad96741a8$var$Ca = Symbol.for("react.context"), $189c8bfad96741a8$var$Da = Symbol.for("react.forward_ref"), $189c8bfad96741a8$var$Ea = Symbol.for("react.suspense"), $189c8bfad96741a8$var$Fa = Symbol.for("react.suspense_list"), $189c8bfad96741a8$var$Ga = Symbol.for("react.memo"), $189c8bfad96741a8$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $189c8bfad96741a8$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $189c8bfad96741a8$var$Ja = Symbol.iterator;
function $189c8bfad96741a8$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $189c8bfad96741a8$var$Ja && a[$189c8bfad96741a8$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $189c8bfad96741a8$var$A = Object.assign, $189c8bfad96741a8$var$La;
function $189c8bfad96741a8$var$Ma(a) {
    if (void 0 === $189c8bfad96741a8$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $189c8bfad96741a8$var$La = b && b[1] || "";
    }
    return "\n" + $189c8bfad96741a8$var$La + a;
}
var $189c8bfad96741a8$var$Na = !1;
function $189c8bfad96741a8$var$Oa(a, b) {
    if (!a || $189c8bfad96741a8$var$Na) return "";
    $189c8bfad96741a8$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $189c8bfad96741a8$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $189c8bfad96741a8$var$Ma(a) : "";
}
function $189c8bfad96741a8$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $189c8bfad96741a8$var$Ma(a.type);
        case 16:
            return $189c8bfad96741a8$var$Ma("Lazy");
        case 13:
            return $189c8bfad96741a8$var$Ma("Suspense");
        case 19:
            return $189c8bfad96741a8$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $189c8bfad96741a8$var$Oa(a.type, !1), a;
        case 11:
            return a = $189c8bfad96741a8$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $189c8bfad96741a8$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $189c8bfad96741a8$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $189c8bfad96741a8$var$ya:
            return "Fragment";
        case $189c8bfad96741a8$var$wa:
            return "Portal";
        case $189c8bfad96741a8$var$Aa:
            return "Profiler";
        case $189c8bfad96741a8$var$za:
            return "StrictMode";
        case $189c8bfad96741a8$var$Ea:
            return "Suspense";
        case $189c8bfad96741a8$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $189c8bfad96741a8$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $189c8bfad96741a8$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $189c8bfad96741a8$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $189c8bfad96741a8$var$Ga:
            return b = a.displayName || null, null !== b ? b : $189c8bfad96741a8$var$Qa(a.type) || "Memo";
        case $189c8bfad96741a8$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $189c8bfad96741a8$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $189c8bfad96741a8$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $189c8bfad96741a8$var$Qa(b);
        case 8:
            return b === $189c8bfad96741a8$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $189c8bfad96741a8$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $189c8bfad96741a8$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $189c8bfad96741a8$var$Ua(a) {
    var b = $189c8bfad96741a8$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $189c8bfad96741a8$var$Va(a) {
    a._valueTracker || (a._valueTracker = $189c8bfad96741a8$var$Ua(a));
}
function $189c8bfad96741a8$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $189c8bfad96741a8$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $189c8bfad96741a8$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $189c8bfad96741a8$var$Ya(a, b) {
    var c = b.checked;
    return $189c8bfad96741a8$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $189c8bfad96741a8$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $189c8bfad96741a8$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $189c8bfad96741a8$var$ab(a, b) {
    b = b.checked;
    null != b && $189c8bfad96741a8$var$ta(a, "checked", b, !1);
}
function $189c8bfad96741a8$var$bb(a, b) {
    $189c8bfad96741a8$var$ab(a, b);
    var c = $189c8bfad96741a8$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $189c8bfad96741a8$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $189c8bfad96741a8$var$cb(a, b.type, $189c8bfad96741a8$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $189c8bfad96741a8$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $189c8bfad96741a8$var$cb(a, b, c) {
    if ("number" !== b || $189c8bfad96741a8$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $189c8bfad96741a8$var$eb = Array.isArray;
function $189c8bfad96741a8$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $189c8bfad96741a8$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $189c8bfad96741a8$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($189c8bfad96741a8$var$p(91));
    return $189c8bfad96741a8$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $189c8bfad96741a8$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($189c8bfad96741a8$var$p(92));
            if ($189c8bfad96741a8$var$eb(c)) {
                if (1 < c.length) throw Error($189c8bfad96741a8$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $189c8bfad96741a8$var$Sa(c)
    };
}
function $189c8bfad96741a8$var$ib(a, b) {
    var c = $189c8bfad96741a8$var$Sa(b.value), d = $189c8bfad96741a8$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $189c8bfad96741a8$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $189c8bfad96741a8$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $189c8bfad96741a8$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $189c8bfad96741a8$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $189c8bfad96741a8$var$mb, $189c8bfad96741a8$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $189c8bfad96741a8$var$mb = $189c8bfad96741a8$var$mb || document.createElement("div");
        $189c8bfad96741a8$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $189c8bfad96741a8$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $189c8bfad96741a8$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $189c8bfad96741a8$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $189c8bfad96741a8$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($189c8bfad96741a8$var$pb).forEach(function(a) {
    $189c8bfad96741a8$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $189c8bfad96741a8$var$pb[b] = $189c8bfad96741a8$var$pb[a];
    });
});
function $189c8bfad96741a8$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $189c8bfad96741a8$var$pb.hasOwnProperty(a) && $189c8bfad96741a8$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $189c8bfad96741a8$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $189c8bfad96741a8$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $189c8bfad96741a8$var$tb = $189c8bfad96741a8$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $189c8bfad96741a8$var$ub(a, b) {
    if (b) {
        if ($189c8bfad96741a8$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($189c8bfad96741a8$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($189c8bfad96741a8$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($189c8bfad96741a8$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($189c8bfad96741a8$var$p(62));
    }
}
function $189c8bfad96741a8$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $189c8bfad96741a8$var$wb = null;
function $189c8bfad96741a8$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $189c8bfad96741a8$var$yb = null, $189c8bfad96741a8$var$zb = null, $189c8bfad96741a8$var$Ab = null;
function $189c8bfad96741a8$var$Bb(a) {
    if (a = $189c8bfad96741a8$var$Cb(a)) {
        if ("function" !== typeof $189c8bfad96741a8$var$yb) throw Error($189c8bfad96741a8$var$p(280));
        var b = a.stateNode;
        b && (b = $189c8bfad96741a8$var$Db(b), $189c8bfad96741a8$var$yb(a.stateNode, a.type, b));
    }
}
function $189c8bfad96741a8$var$Eb(a) {
    $189c8bfad96741a8$var$zb ? $189c8bfad96741a8$var$Ab ? $189c8bfad96741a8$var$Ab.push(a) : $189c8bfad96741a8$var$Ab = [
        a
    ] : $189c8bfad96741a8$var$zb = a;
}
function $189c8bfad96741a8$var$Fb() {
    if ($189c8bfad96741a8$var$zb) {
        var a = $189c8bfad96741a8$var$zb, b = $189c8bfad96741a8$var$Ab;
        $189c8bfad96741a8$var$Ab = $189c8bfad96741a8$var$zb = null;
        $189c8bfad96741a8$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$189c8bfad96741a8$var$Bb(b[a]);
    }
}
function $189c8bfad96741a8$var$Gb(a, b) {
    return a(b);
}
function $189c8bfad96741a8$var$Hb() {}
var $189c8bfad96741a8$var$Ib = !1;
function $189c8bfad96741a8$var$Jb(a, b, c) {
    if ($189c8bfad96741a8$var$Ib) return a(b, c);
    $189c8bfad96741a8$var$Ib = !0;
    try {
        return $189c8bfad96741a8$var$Gb(a, b, c);
    } finally{
        if ($189c8bfad96741a8$var$Ib = !1, null !== $189c8bfad96741a8$var$zb || null !== $189c8bfad96741a8$var$Ab) $189c8bfad96741a8$var$Hb(), $189c8bfad96741a8$var$Fb();
    }
}
function $189c8bfad96741a8$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $189c8bfad96741a8$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($189c8bfad96741a8$var$p(231, b, typeof c));
    return c;
}
var $189c8bfad96741a8$var$Lb = !1;
if ($189c8bfad96741a8$var$ia) try {
    var $189c8bfad96741a8$var$Mb = {};
    Object.defineProperty($189c8bfad96741a8$var$Mb, "passive", {
        get: function() {
            $189c8bfad96741a8$var$Lb = !0;
        }
    });
    window.addEventListener("test", $189c8bfad96741a8$var$Mb, $189c8bfad96741a8$var$Mb);
    window.removeEventListener("test", $189c8bfad96741a8$var$Mb, $189c8bfad96741a8$var$Mb);
} catch (a) {
    $189c8bfad96741a8$var$Lb = !1;
}
function $189c8bfad96741a8$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $189c8bfad96741a8$var$Ob = !1, $189c8bfad96741a8$var$Pb = null, $189c8bfad96741a8$var$Qb = !1, $189c8bfad96741a8$var$Rb = null, $189c8bfad96741a8$var$Sb = {
    onError: function(a) {
        $189c8bfad96741a8$var$Ob = !0;
        $189c8bfad96741a8$var$Pb = a;
    }
};
function $189c8bfad96741a8$var$Tb(a, b, c, d, e, f, g, h, k) {
    $189c8bfad96741a8$var$Ob = !1;
    $189c8bfad96741a8$var$Pb = null;
    $189c8bfad96741a8$var$Nb.apply($189c8bfad96741a8$var$Sb, arguments);
}
function $189c8bfad96741a8$var$Ub(a, b, c, d, e, f, g, h, k) {
    $189c8bfad96741a8$var$Tb.apply(this, arguments);
    if ($189c8bfad96741a8$var$Ob) {
        if ($189c8bfad96741a8$var$Ob) {
            var l = $189c8bfad96741a8$var$Pb;
            $189c8bfad96741a8$var$Ob = !1;
            $189c8bfad96741a8$var$Pb = null;
        } else throw Error($189c8bfad96741a8$var$p(198));
        $189c8bfad96741a8$var$Qb || ($189c8bfad96741a8$var$Qb = !0, $189c8bfad96741a8$var$Rb = l);
    }
}
function $189c8bfad96741a8$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $189c8bfad96741a8$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $189c8bfad96741a8$var$Xb(a) {
    if ($189c8bfad96741a8$var$Vb(a) !== a) throw Error($189c8bfad96741a8$var$p(188));
}
function $189c8bfad96741a8$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $189c8bfad96741a8$var$Vb(a);
        if (null === b) throw Error($189c8bfad96741a8$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $189c8bfad96741a8$var$Xb(e), a;
                if (f === d) return $189c8bfad96741a8$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($189c8bfad96741a8$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($189c8bfad96741a8$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($189c8bfad96741a8$var$p(190));
    }
    if (3 !== c.tag) throw Error($189c8bfad96741a8$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $189c8bfad96741a8$var$Zb(a) {
    a = $189c8bfad96741a8$var$Yb(a);
    return null !== a ? $189c8bfad96741a8$var$$b(a) : null;
}
function $189c8bfad96741a8$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $189c8bfad96741a8$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $189c8bfad96741a8$var$ac = $9LeLq.unstable_scheduleCallback, $189c8bfad96741a8$var$bc = $9LeLq.unstable_cancelCallback, $189c8bfad96741a8$var$cc = $9LeLq.unstable_shouldYield, $189c8bfad96741a8$var$dc = $9LeLq.unstable_requestPaint, $189c8bfad96741a8$var$B = $9LeLq.unstable_now, $189c8bfad96741a8$var$ec = $9LeLq.unstable_getCurrentPriorityLevel, $189c8bfad96741a8$var$fc = $9LeLq.unstable_ImmediatePriority, $189c8bfad96741a8$var$gc = $9LeLq.unstable_UserBlockingPriority, $189c8bfad96741a8$var$hc = $9LeLq.unstable_NormalPriority, $189c8bfad96741a8$var$ic = $9LeLq.unstable_LowPriority, $189c8bfad96741a8$var$jc = $9LeLq.unstable_IdlePriority, $189c8bfad96741a8$var$kc = null, $189c8bfad96741a8$var$lc = null;
function $189c8bfad96741a8$var$mc(a) {
    if ($189c8bfad96741a8$var$lc && "function" === typeof $189c8bfad96741a8$var$lc.onCommitFiberRoot) try {
        $189c8bfad96741a8$var$lc.onCommitFiberRoot($189c8bfad96741a8$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $189c8bfad96741a8$var$oc = Math.clz32 ? Math.clz32 : $189c8bfad96741a8$var$nc, $189c8bfad96741a8$var$pc = Math.log, $189c8bfad96741a8$var$qc = Math.LN2;
function $189c8bfad96741a8$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($189c8bfad96741a8$var$pc(a) / $189c8bfad96741a8$var$qc | 0) | 0;
}
var $189c8bfad96741a8$var$rc = 64, $189c8bfad96741a8$var$sc = 4194304;
function $189c8bfad96741a8$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $189c8bfad96741a8$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $189c8bfad96741a8$var$tc(h) : (f &= g, 0 !== f && (d = $189c8bfad96741a8$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $189c8bfad96741a8$var$tc(g) : 0 !== f && (d = $189c8bfad96741a8$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $189c8bfad96741a8$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $189c8bfad96741a8$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $189c8bfad96741a8$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $189c8bfad96741a8$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $189c8bfad96741a8$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $189c8bfad96741a8$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $189c8bfad96741a8$var$yc() {
    var a = $189c8bfad96741a8$var$rc;
    $189c8bfad96741a8$var$rc <<= 1;
    0 === ($189c8bfad96741a8$var$rc & 4194240) && ($189c8bfad96741a8$var$rc = 64);
    return a;
}
function $189c8bfad96741a8$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $189c8bfad96741a8$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $189c8bfad96741a8$var$oc(b);
    a[b] = c;
}
function $189c8bfad96741a8$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $189c8bfad96741a8$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $189c8bfad96741a8$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $189c8bfad96741a8$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $189c8bfad96741a8$var$C = 0;
function $189c8bfad96741a8$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $189c8bfad96741a8$var$Ec, $189c8bfad96741a8$var$Fc, $189c8bfad96741a8$var$Gc, $189c8bfad96741a8$var$Hc, $189c8bfad96741a8$var$Ic, $189c8bfad96741a8$var$Jc = !1, $189c8bfad96741a8$var$Kc = [], $189c8bfad96741a8$var$Lc = null, $189c8bfad96741a8$var$Mc = null, $189c8bfad96741a8$var$Nc = null, $189c8bfad96741a8$var$Oc = new Map, $189c8bfad96741a8$var$Pc = new Map, $189c8bfad96741a8$var$Qc = [], $189c8bfad96741a8$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $189c8bfad96741a8$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $189c8bfad96741a8$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $189c8bfad96741a8$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $189c8bfad96741a8$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $189c8bfad96741a8$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $189c8bfad96741a8$var$Pc.delete(b.pointerId);
    }
}
function $189c8bfad96741a8$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $189c8bfad96741a8$var$Cb(b), null !== b && $189c8bfad96741a8$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $189c8bfad96741a8$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $189c8bfad96741a8$var$Lc = $189c8bfad96741a8$var$Tc($189c8bfad96741a8$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $189c8bfad96741a8$var$Mc = $189c8bfad96741a8$var$Tc($189c8bfad96741a8$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $189c8bfad96741a8$var$Nc = $189c8bfad96741a8$var$Tc($189c8bfad96741a8$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $189c8bfad96741a8$var$Oc.set(f, $189c8bfad96741a8$var$Tc($189c8bfad96741a8$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $189c8bfad96741a8$var$Pc.set(f, $189c8bfad96741a8$var$Tc($189c8bfad96741a8$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $189c8bfad96741a8$var$Vc(a) {
    var b = $189c8bfad96741a8$var$Wc(a.target);
    if (null !== b) {
        var c = $189c8bfad96741a8$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $189c8bfad96741a8$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $189c8bfad96741a8$var$Ic(a.priority, function() {
                        $189c8bfad96741a8$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $189c8bfad96741a8$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $189c8bfad96741a8$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $189c8bfad96741a8$var$wb = d;
            c.target.dispatchEvent(d);
            $189c8bfad96741a8$var$wb = null;
        } else return b = $189c8bfad96741a8$var$Cb(c), null !== b && $189c8bfad96741a8$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $189c8bfad96741a8$var$Zc(a, b, c) {
    $189c8bfad96741a8$var$Xc(a) && c.delete(b);
}
function $189c8bfad96741a8$var$$c() {
    $189c8bfad96741a8$var$Jc = !1;
    null !== $189c8bfad96741a8$var$Lc && $189c8bfad96741a8$var$Xc($189c8bfad96741a8$var$Lc) && ($189c8bfad96741a8$var$Lc = null);
    null !== $189c8bfad96741a8$var$Mc && $189c8bfad96741a8$var$Xc($189c8bfad96741a8$var$Mc) && ($189c8bfad96741a8$var$Mc = null);
    null !== $189c8bfad96741a8$var$Nc && $189c8bfad96741a8$var$Xc($189c8bfad96741a8$var$Nc) && ($189c8bfad96741a8$var$Nc = null);
    $189c8bfad96741a8$var$Oc.forEach($189c8bfad96741a8$var$Zc);
    $189c8bfad96741a8$var$Pc.forEach($189c8bfad96741a8$var$Zc);
}
function $189c8bfad96741a8$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $189c8bfad96741a8$var$Jc || ($189c8bfad96741a8$var$Jc = !0, $9LeLq.unstable_scheduleCallback($9LeLq.unstable_NormalPriority, $189c8bfad96741a8$var$$c)));
}
function $189c8bfad96741a8$var$bd(a) {
    function b(b) {
        return $189c8bfad96741a8$var$ad(b, a);
    }
    if (0 < $189c8bfad96741a8$var$Kc.length) {
        $189c8bfad96741a8$var$ad($189c8bfad96741a8$var$Kc[0], a);
        for(var c = 1; c < $189c8bfad96741a8$var$Kc.length; c++){
            var d = $189c8bfad96741a8$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $189c8bfad96741a8$var$Lc && $189c8bfad96741a8$var$ad($189c8bfad96741a8$var$Lc, a);
    null !== $189c8bfad96741a8$var$Mc && $189c8bfad96741a8$var$ad($189c8bfad96741a8$var$Mc, a);
    null !== $189c8bfad96741a8$var$Nc && $189c8bfad96741a8$var$ad($189c8bfad96741a8$var$Nc, a);
    $189c8bfad96741a8$var$Oc.forEach(b);
    $189c8bfad96741a8$var$Pc.forEach(b);
    for(c = 0; c < $189c8bfad96741a8$var$Qc.length; c++)d = $189c8bfad96741a8$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $189c8bfad96741a8$var$Qc.length && (c = $189c8bfad96741a8$var$Qc[0], null === c.blockedOn);)$189c8bfad96741a8$var$Vc(c), null === c.blockedOn && $189c8bfad96741a8$var$Qc.shift();
}
var $189c8bfad96741a8$var$cd = $189c8bfad96741a8$var$ua.ReactCurrentBatchConfig, $189c8bfad96741a8$var$dd = !0;
function $189c8bfad96741a8$var$ed(a, b, c, d) {
    var e = $189c8bfad96741a8$var$C, f = $189c8bfad96741a8$var$cd.transition;
    $189c8bfad96741a8$var$cd.transition = null;
    try {
        $189c8bfad96741a8$var$C = 1, $189c8bfad96741a8$var$fd(a, b, c, d);
    } finally{
        $189c8bfad96741a8$var$C = e, $189c8bfad96741a8$var$cd.transition = f;
    }
}
function $189c8bfad96741a8$var$gd(a, b, c, d) {
    var e = $189c8bfad96741a8$var$C, f = $189c8bfad96741a8$var$cd.transition;
    $189c8bfad96741a8$var$cd.transition = null;
    try {
        $189c8bfad96741a8$var$C = 4, $189c8bfad96741a8$var$fd(a, b, c, d);
    } finally{
        $189c8bfad96741a8$var$C = e, $189c8bfad96741a8$var$cd.transition = f;
    }
}
function $189c8bfad96741a8$var$fd(a, b, c, d) {
    if ($189c8bfad96741a8$var$dd) {
        var e = $189c8bfad96741a8$var$Yc(a, b, c, d);
        if (null === e) $189c8bfad96741a8$var$hd(a, b, d, $189c8bfad96741a8$var$id, c), $189c8bfad96741a8$var$Sc(a, d);
        else if ($189c8bfad96741a8$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($189c8bfad96741a8$var$Sc(a, d), b & 4 && -1 < $189c8bfad96741a8$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $189c8bfad96741a8$var$Cb(e);
                null !== f && $189c8bfad96741a8$var$Ec(f);
                f = $189c8bfad96741a8$var$Yc(a, b, c, d);
                null === f && $189c8bfad96741a8$var$hd(a, b, d, $189c8bfad96741a8$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $189c8bfad96741a8$var$hd(a, b, d, null, c);
    }
}
var $189c8bfad96741a8$var$id = null;
function $189c8bfad96741a8$var$Yc(a, b, c, d) {
    $189c8bfad96741a8$var$id = null;
    a = $189c8bfad96741a8$var$xb(d);
    a = $189c8bfad96741a8$var$Wc(a);
    if (null !== a) {
        if (b = $189c8bfad96741a8$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $189c8bfad96741a8$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $189c8bfad96741a8$var$id = a;
    return null;
}
function $189c8bfad96741a8$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($189c8bfad96741a8$var$ec()){
                case $189c8bfad96741a8$var$fc:
                    return 1;
                case $189c8bfad96741a8$var$gc:
                    return 4;
                case $189c8bfad96741a8$var$hc:
                case $189c8bfad96741a8$var$ic:
                    return 16;
                case $189c8bfad96741a8$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $189c8bfad96741a8$var$kd = null, $189c8bfad96741a8$var$ld = null, $189c8bfad96741a8$var$md = null;
function $189c8bfad96741a8$var$nd() {
    if ($189c8bfad96741a8$var$md) return $189c8bfad96741a8$var$md;
    var a, b = $189c8bfad96741a8$var$ld, c = b.length, d, e = "value" in $189c8bfad96741a8$var$kd ? $189c8bfad96741a8$var$kd.value : $189c8bfad96741a8$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $189c8bfad96741a8$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $189c8bfad96741a8$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $189c8bfad96741a8$var$pd() {
    return !0;
}
function $189c8bfad96741a8$var$qd() {
    return !1;
}
function $189c8bfad96741a8$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $189c8bfad96741a8$var$pd : $189c8bfad96741a8$var$qd;
        this.isPropagationStopped = $189c8bfad96741a8$var$qd;
        return this;
    }
    $189c8bfad96741a8$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $189c8bfad96741a8$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $189c8bfad96741a8$var$pd);
        },
        persist: function() {},
        isPersistent: $189c8bfad96741a8$var$pd
    });
    return b;
}
var $189c8bfad96741a8$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $189c8bfad96741a8$var$td = $189c8bfad96741a8$var$rd($189c8bfad96741a8$var$sd), $189c8bfad96741a8$var$ud = $189c8bfad96741a8$var$A({}, $189c8bfad96741a8$var$sd, {
    view: 0,
    detail: 0
}), $189c8bfad96741a8$var$vd = $189c8bfad96741a8$var$rd($189c8bfad96741a8$var$ud), $189c8bfad96741a8$var$wd, $189c8bfad96741a8$var$xd, $189c8bfad96741a8$var$yd, $189c8bfad96741a8$var$Ad = $189c8bfad96741a8$var$A({}, $189c8bfad96741a8$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $189c8bfad96741a8$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $189c8bfad96741a8$var$yd && ($189c8bfad96741a8$var$yd && "mousemove" === a.type ? ($189c8bfad96741a8$var$wd = a.screenX - $189c8bfad96741a8$var$yd.screenX, $189c8bfad96741a8$var$xd = a.screenY - $189c8bfad96741a8$var$yd.screenY) : $189c8bfad96741a8$var$xd = $189c8bfad96741a8$var$wd = 0, $189c8bfad96741a8$var$yd = a);
        return $189c8bfad96741a8$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $189c8bfad96741a8$var$xd;
    }
}), $189c8bfad96741a8$var$Bd = $189c8bfad96741a8$var$rd($189c8bfad96741a8$var$Ad), $189c8bfad96741a8$var$Cd = $189c8bfad96741a8$var$A({}, $189c8bfad96741a8$var$Ad, {
    dataTransfer: 0
}), $189c8bfad96741a8$var$Dd = $189c8bfad96741a8$var$rd($189c8bfad96741a8$var$Cd), $189c8bfad96741a8$var$Ed = $189c8bfad96741a8$var$A({}, $189c8bfad96741a8$var$ud, {
    relatedTarget: 0
}), $189c8bfad96741a8$var$Fd = $189c8bfad96741a8$var$rd($189c8bfad96741a8$var$Ed), $189c8bfad96741a8$var$Gd = $189c8bfad96741a8$var$A({}, $189c8bfad96741a8$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $189c8bfad96741a8$var$Hd = $189c8bfad96741a8$var$rd($189c8bfad96741a8$var$Gd), $189c8bfad96741a8$var$Id = $189c8bfad96741a8$var$A({}, $189c8bfad96741a8$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $189c8bfad96741a8$var$Jd = $189c8bfad96741a8$var$rd($189c8bfad96741a8$var$Id), $189c8bfad96741a8$var$Kd = $189c8bfad96741a8$var$A({}, $189c8bfad96741a8$var$sd, {
    data: 0
}), $189c8bfad96741a8$var$Ld = $189c8bfad96741a8$var$rd($189c8bfad96741a8$var$Kd), $189c8bfad96741a8$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $189c8bfad96741a8$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $189c8bfad96741a8$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $189c8bfad96741a8$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $189c8bfad96741a8$var$Od[a]) ? !!b[a] : !1;
}
function $189c8bfad96741a8$var$zd() {
    return $189c8bfad96741a8$var$Pd;
}
var $189c8bfad96741a8$var$Qd = $189c8bfad96741a8$var$A({}, $189c8bfad96741a8$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $189c8bfad96741a8$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $189c8bfad96741a8$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $189c8bfad96741a8$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $189c8bfad96741a8$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $189c8bfad96741a8$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $189c8bfad96741a8$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $189c8bfad96741a8$var$Rd = $189c8bfad96741a8$var$rd($189c8bfad96741a8$var$Qd), $189c8bfad96741a8$var$Sd = $189c8bfad96741a8$var$A({}, $189c8bfad96741a8$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $189c8bfad96741a8$var$Td = $189c8bfad96741a8$var$rd($189c8bfad96741a8$var$Sd), $189c8bfad96741a8$var$Ud = $189c8bfad96741a8$var$A({}, $189c8bfad96741a8$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $189c8bfad96741a8$var$zd
}), $189c8bfad96741a8$var$Vd = $189c8bfad96741a8$var$rd($189c8bfad96741a8$var$Ud), $189c8bfad96741a8$var$Wd = $189c8bfad96741a8$var$A({}, $189c8bfad96741a8$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $189c8bfad96741a8$var$Xd = $189c8bfad96741a8$var$rd($189c8bfad96741a8$var$Wd), $189c8bfad96741a8$var$Yd = $189c8bfad96741a8$var$A({}, $189c8bfad96741a8$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $189c8bfad96741a8$var$Zd = $189c8bfad96741a8$var$rd($189c8bfad96741a8$var$Yd), $189c8bfad96741a8$var$$d = [
    9,
    13,
    27,
    32
], $189c8bfad96741a8$var$ae = $189c8bfad96741a8$var$ia && "CompositionEvent" in window, $189c8bfad96741a8$var$be = null;
$189c8bfad96741a8$var$ia && "documentMode" in document && ($189c8bfad96741a8$var$be = document.documentMode);
var $189c8bfad96741a8$var$ce = $189c8bfad96741a8$var$ia && "TextEvent" in window && !$189c8bfad96741a8$var$be, $189c8bfad96741a8$var$de = $189c8bfad96741a8$var$ia && (!$189c8bfad96741a8$var$ae || $189c8bfad96741a8$var$be && 8 < $189c8bfad96741a8$var$be && 11 >= $189c8bfad96741a8$var$be), $189c8bfad96741a8$var$ee = String.fromCharCode(32), $189c8bfad96741a8$var$fe = !1;
function $189c8bfad96741a8$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $189c8bfad96741a8$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $189c8bfad96741a8$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $189c8bfad96741a8$var$ie = !1;
function $189c8bfad96741a8$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $189c8bfad96741a8$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $189c8bfad96741a8$var$fe = !0;
            return $189c8bfad96741a8$var$ee;
        case "textInput":
            return a = b.data, a === $189c8bfad96741a8$var$ee && $189c8bfad96741a8$var$fe ? null : a;
        default:
            return null;
    }
}
function $189c8bfad96741a8$var$ke(a, b) {
    if ($189c8bfad96741a8$var$ie) return "compositionend" === a || !$189c8bfad96741a8$var$ae && $189c8bfad96741a8$var$ge(a, b) ? (a = $189c8bfad96741a8$var$nd(), $189c8bfad96741a8$var$md = $189c8bfad96741a8$var$ld = $189c8bfad96741a8$var$kd = null, $189c8bfad96741a8$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $189c8bfad96741a8$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $189c8bfad96741a8$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $189c8bfad96741a8$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$189c8bfad96741a8$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $189c8bfad96741a8$var$ne(a, b, c, d) {
    $189c8bfad96741a8$var$Eb(d);
    b = $189c8bfad96741a8$var$oe(b, "onChange");
    0 < b.length && (c = new $189c8bfad96741a8$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $189c8bfad96741a8$var$pe = null, $189c8bfad96741a8$var$qe = null;
function $189c8bfad96741a8$var$re(a) {
    $189c8bfad96741a8$var$se(a, 0);
}
function $189c8bfad96741a8$var$te(a) {
    var b = $189c8bfad96741a8$var$ue(a);
    if ($189c8bfad96741a8$var$Wa(b)) return a;
}
function $189c8bfad96741a8$var$ve(a, b) {
    if ("change" === a) return b;
}
var $189c8bfad96741a8$var$we = !1;
if ($189c8bfad96741a8$var$ia) {
    var $189c8bfad96741a8$var$xe;
    if ($189c8bfad96741a8$var$ia) {
        var $189c8bfad96741a8$var$ye = "oninput" in document;
        if (!$189c8bfad96741a8$var$ye) {
            var $189c8bfad96741a8$var$ze = document.createElement("div");
            $189c8bfad96741a8$var$ze.setAttribute("oninput", "return;");
            $189c8bfad96741a8$var$ye = "function" === typeof $189c8bfad96741a8$var$ze.oninput;
        }
        $189c8bfad96741a8$var$xe = $189c8bfad96741a8$var$ye;
    } else $189c8bfad96741a8$var$xe = !1;
    $189c8bfad96741a8$var$we = $189c8bfad96741a8$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $189c8bfad96741a8$var$Ae() {
    $189c8bfad96741a8$var$pe && ($189c8bfad96741a8$var$pe.detachEvent("onpropertychange", $189c8bfad96741a8$var$Be), $189c8bfad96741a8$var$qe = $189c8bfad96741a8$var$pe = null);
}
function $189c8bfad96741a8$var$Be(a) {
    if ("value" === a.propertyName && $189c8bfad96741a8$var$te($189c8bfad96741a8$var$qe)) {
        var b = [];
        $189c8bfad96741a8$var$ne(b, $189c8bfad96741a8$var$qe, a, $189c8bfad96741a8$var$xb(a));
        $189c8bfad96741a8$var$Jb($189c8bfad96741a8$var$re, b);
    }
}
function $189c8bfad96741a8$var$Ce(a, b, c) {
    "focusin" === a ? ($189c8bfad96741a8$var$Ae(), $189c8bfad96741a8$var$pe = b, $189c8bfad96741a8$var$qe = c, $189c8bfad96741a8$var$pe.attachEvent("onpropertychange", $189c8bfad96741a8$var$Be)) : "focusout" === a && $189c8bfad96741a8$var$Ae();
}
function $189c8bfad96741a8$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $189c8bfad96741a8$var$te($189c8bfad96741a8$var$qe);
}
function $189c8bfad96741a8$var$Ee(a, b) {
    if ("click" === a) return $189c8bfad96741a8$var$te(b);
}
function $189c8bfad96741a8$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $189c8bfad96741a8$var$te(b);
}
function $189c8bfad96741a8$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $189c8bfad96741a8$var$He = "function" === typeof Object.is ? Object.is : $189c8bfad96741a8$var$Ge;
function $189c8bfad96741a8$var$Ie(a, b) {
    if ($189c8bfad96741a8$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$189c8bfad96741a8$var$ja.call(b, e) || !$189c8bfad96741a8$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $189c8bfad96741a8$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $189c8bfad96741a8$var$Ke(a, b) {
    var c = $189c8bfad96741a8$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $189c8bfad96741a8$var$Je(c);
    }
}
function $189c8bfad96741a8$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $189c8bfad96741a8$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $189c8bfad96741a8$var$Me() {
    for(var a = window, b = $189c8bfad96741a8$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $189c8bfad96741a8$var$Xa(a.document);
    }
    return b;
}
function $189c8bfad96741a8$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $189c8bfad96741a8$var$Oe(a) {
    var b = $189c8bfad96741a8$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $189c8bfad96741a8$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $189c8bfad96741a8$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $189c8bfad96741a8$var$Ke(c, f);
                var g = $189c8bfad96741a8$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $189c8bfad96741a8$var$Pe = $189c8bfad96741a8$var$ia && "documentMode" in document && 11 >= document.documentMode, $189c8bfad96741a8$var$Qe = null, $189c8bfad96741a8$var$Re = null, $189c8bfad96741a8$var$Se = null, $189c8bfad96741a8$var$Te = !1;
function $189c8bfad96741a8$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $189c8bfad96741a8$var$Te || null == $189c8bfad96741a8$var$Qe || $189c8bfad96741a8$var$Qe !== $189c8bfad96741a8$var$Xa(d) || (d = $189c8bfad96741a8$var$Qe, "selectionStart" in d && $189c8bfad96741a8$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $189c8bfad96741a8$var$Se && $189c8bfad96741a8$var$Ie($189c8bfad96741a8$var$Se, d) || ($189c8bfad96741a8$var$Se = d, d = $189c8bfad96741a8$var$oe($189c8bfad96741a8$var$Re, "onSelect"), 0 < d.length && (b = new $189c8bfad96741a8$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $189c8bfad96741a8$var$Qe)));
}
function $189c8bfad96741a8$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $189c8bfad96741a8$var$We = {
    animationend: $189c8bfad96741a8$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $189c8bfad96741a8$var$Ve("Animation", "AnimationIteration"),
    animationstart: $189c8bfad96741a8$var$Ve("Animation", "AnimationStart"),
    transitionend: $189c8bfad96741a8$var$Ve("Transition", "TransitionEnd")
}, $189c8bfad96741a8$var$Xe = {}, $189c8bfad96741a8$var$Ye = {};
$189c8bfad96741a8$var$ia && ($189c8bfad96741a8$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $189c8bfad96741a8$var$We.animationend.animation, delete $189c8bfad96741a8$var$We.animationiteration.animation, delete $189c8bfad96741a8$var$We.animationstart.animation), "TransitionEvent" in window || delete $189c8bfad96741a8$var$We.transitionend.transition);
function $189c8bfad96741a8$var$Ze(a) {
    if ($189c8bfad96741a8$var$Xe[a]) return $189c8bfad96741a8$var$Xe[a];
    if (!$189c8bfad96741a8$var$We[a]) return a;
    var b = $189c8bfad96741a8$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $189c8bfad96741a8$var$Ye) return $189c8bfad96741a8$var$Xe[a] = b[c];
    return a;
}
var $189c8bfad96741a8$var$$e = $189c8bfad96741a8$var$Ze("animationend"), $189c8bfad96741a8$var$af = $189c8bfad96741a8$var$Ze("animationiteration"), $189c8bfad96741a8$var$bf = $189c8bfad96741a8$var$Ze("animationstart"), $189c8bfad96741a8$var$cf = $189c8bfad96741a8$var$Ze("transitionend"), $189c8bfad96741a8$var$df = new Map, $189c8bfad96741a8$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $189c8bfad96741a8$var$ff(a, b) {
    $189c8bfad96741a8$var$df.set(a, b);
    $189c8bfad96741a8$var$fa(b, [
        a
    ]);
}
for(var $189c8bfad96741a8$var$gf = 0; $189c8bfad96741a8$var$gf < $189c8bfad96741a8$var$ef.length; $189c8bfad96741a8$var$gf++){
    var $189c8bfad96741a8$var$hf = $189c8bfad96741a8$var$ef[$189c8bfad96741a8$var$gf], $189c8bfad96741a8$var$jf = $189c8bfad96741a8$var$hf.toLowerCase(), $189c8bfad96741a8$var$kf = $189c8bfad96741a8$var$hf[0].toUpperCase() + $189c8bfad96741a8$var$hf.slice(1);
    $189c8bfad96741a8$var$ff($189c8bfad96741a8$var$jf, "on" + $189c8bfad96741a8$var$kf);
}
$189c8bfad96741a8$var$ff($189c8bfad96741a8$var$$e, "onAnimationEnd");
$189c8bfad96741a8$var$ff($189c8bfad96741a8$var$af, "onAnimationIteration");
$189c8bfad96741a8$var$ff($189c8bfad96741a8$var$bf, "onAnimationStart");
$189c8bfad96741a8$var$ff("dblclick", "onDoubleClick");
$189c8bfad96741a8$var$ff("focusin", "onFocus");
$189c8bfad96741a8$var$ff("focusout", "onBlur");
$189c8bfad96741a8$var$ff($189c8bfad96741a8$var$cf, "onTransitionEnd");
$189c8bfad96741a8$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$189c8bfad96741a8$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$189c8bfad96741a8$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$189c8bfad96741a8$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$189c8bfad96741a8$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$189c8bfad96741a8$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$189c8bfad96741a8$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$189c8bfad96741a8$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$189c8bfad96741a8$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$189c8bfad96741a8$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $189c8bfad96741a8$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $189c8bfad96741a8$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($189c8bfad96741a8$var$lf));
function $189c8bfad96741a8$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $189c8bfad96741a8$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $189c8bfad96741a8$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $189c8bfad96741a8$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $189c8bfad96741a8$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($189c8bfad96741a8$var$Qb) throw a = $189c8bfad96741a8$var$Rb, $189c8bfad96741a8$var$Qb = !1, $189c8bfad96741a8$var$Rb = null, a;
}
function $189c8bfad96741a8$var$D(a, b) {
    var c = b[$189c8bfad96741a8$var$of];
    void 0 === c && (c = b[$189c8bfad96741a8$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($189c8bfad96741a8$var$pf(b, a, 2, !1), c.add(d));
}
function $189c8bfad96741a8$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $189c8bfad96741a8$var$pf(c, a, d, b);
}
var $189c8bfad96741a8$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $189c8bfad96741a8$var$sf(a) {
    if (!a[$189c8bfad96741a8$var$rf]) {
        a[$189c8bfad96741a8$var$rf] = !0;
        $189c8bfad96741a8$var$da.forEach(function(b) {
            "selectionchange" !== b && ($189c8bfad96741a8$var$mf.has(b) || $189c8bfad96741a8$var$qf(b, !1, a), $189c8bfad96741a8$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$189c8bfad96741a8$var$rf] || (b[$189c8bfad96741a8$var$rf] = !0, $189c8bfad96741a8$var$qf("selectionchange", !1, b));
    }
}
function $189c8bfad96741a8$var$pf(a, b, c, d) {
    switch($189c8bfad96741a8$var$jd(b)){
        case 1:
            var e = $189c8bfad96741a8$var$ed;
            break;
        case 4:
            e = $189c8bfad96741a8$var$gd;
            break;
        default:
            e = $189c8bfad96741a8$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$189c8bfad96741a8$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $189c8bfad96741a8$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $189c8bfad96741a8$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $189c8bfad96741a8$var$Jb(function() {
        var d = f, e = $189c8bfad96741a8$var$xb(c), g = [];
        a: {
            var h = $189c8bfad96741a8$var$df.get(a);
            if (void 0 !== h) {
                var k = $189c8bfad96741a8$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $189c8bfad96741a8$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $189c8bfad96741a8$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $189c8bfad96741a8$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $189c8bfad96741a8$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $189c8bfad96741a8$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $189c8bfad96741a8$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $189c8bfad96741a8$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $189c8bfad96741a8$var$Vd;
                        break;
                    case $189c8bfad96741a8$var$$e:
                    case $189c8bfad96741a8$var$af:
                    case $189c8bfad96741a8$var$bf:
                        k = $189c8bfad96741a8$var$Hd;
                        break;
                    case $189c8bfad96741a8$var$cf:
                        k = $189c8bfad96741a8$var$Xd;
                        break;
                    case "scroll":
                        k = $189c8bfad96741a8$var$vd;
                        break;
                    case "wheel":
                        k = $189c8bfad96741a8$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $189c8bfad96741a8$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $189c8bfad96741a8$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $189c8bfad96741a8$var$Kb(w, x), null != F && t.push($189c8bfad96741a8$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $189c8bfad96741a8$var$wb && (n = c.relatedTarget || c.fromElement) && ($189c8bfad96741a8$var$Wc(n) || n[$189c8bfad96741a8$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $189c8bfad96741a8$var$Wc(n) : null, null !== n && (J = $189c8bfad96741a8$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $189c8bfad96741a8$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $189c8bfad96741a8$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $189c8bfad96741a8$var$ue(k);
                        u = null == n ? h : $189c8bfad96741a8$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $189c8bfad96741a8$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $189c8bfad96741a8$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $189c8bfad96741a8$var$vf(F))u++;
                            for(; 0 < w - u;)t = $189c8bfad96741a8$var$vf(t), w--;
                            for(; 0 < u - w;)x = $189c8bfad96741a8$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $189c8bfad96741a8$var$vf(t);
                                x = $189c8bfad96741a8$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $189c8bfad96741a8$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $189c8bfad96741a8$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $189c8bfad96741a8$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $189c8bfad96741a8$var$ve;
                else if ($189c8bfad96741a8$var$me(h)) {
                    if ($189c8bfad96741a8$var$we) na = $189c8bfad96741a8$var$Fe;
                    else {
                        na = $189c8bfad96741a8$var$De;
                        var xa = $189c8bfad96741a8$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $189c8bfad96741a8$var$Ee);
                if (na && (na = na(a, d))) {
                    $189c8bfad96741a8$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $189c8bfad96741a8$var$cb(h, "number", h.value);
            }
            xa = d ? $189c8bfad96741a8$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($189c8bfad96741a8$var$me(xa) || "true" === xa.contentEditable) $189c8bfad96741a8$var$Qe = xa, $189c8bfad96741a8$var$Re = d, $189c8bfad96741a8$var$Se = null;
                    break;
                case "focusout":
                    $189c8bfad96741a8$var$Se = $189c8bfad96741a8$var$Re = $189c8bfad96741a8$var$Qe = null;
                    break;
                case "mousedown":
                    $189c8bfad96741a8$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $189c8bfad96741a8$var$Te = !1;
                    $189c8bfad96741a8$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($189c8bfad96741a8$var$Pe) break;
                case "keydown":
                case "keyup":
                    $189c8bfad96741a8$var$Ue(g, c, e);
            }
            var $a;
            if ($189c8bfad96741a8$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $189c8bfad96741a8$var$ie ? $189c8bfad96741a8$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($189c8bfad96741a8$var$de && "ko" !== c.locale && ($189c8bfad96741a8$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $189c8bfad96741a8$var$ie && ($a = $189c8bfad96741a8$var$nd()) : ($189c8bfad96741a8$var$kd = e, $189c8bfad96741a8$var$ld = "value" in $189c8bfad96741a8$var$kd ? $189c8bfad96741a8$var$kd.value : $189c8bfad96741a8$var$kd.textContent, $189c8bfad96741a8$var$ie = !0)), xa = $189c8bfad96741a8$var$oe(d, ba), 0 < xa.length && (ba = new $189c8bfad96741a8$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $189c8bfad96741a8$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $189c8bfad96741a8$var$ce ? $189c8bfad96741a8$var$je(a, c) : $189c8bfad96741a8$var$ke(a, c)) d = $189c8bfad96741a8$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $189c8bfad96741a8$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $189c8bfad96741a8$var$se(g, b);
    });
}
function $189c8bfad96741a8$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $189c8bfad96741a8$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $189c8bfad96741a8$var$Kb(a, c), null != f && d.unshift($189c8bfad96741a8$var$tf(a, f, e)), f = $189c8bfad96741a8$var$Kb(a, b), null != f && d.push($189c8bfad96741a8$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $189c8bfad96741a8$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $189c8bfad96741a8$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $189c8bfad96741a8$var$Kb(c, f), null != k && g.unshift($189c8bfad96741a8$var$tf(c, k, h))) : e || (k = $189c8bfad96741a8$var$Kb(c, f), null != k && g.push($189c8bfad96741a8$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $189c8bfad96741a8$var$xf = /\r\n?/g, $189c8bfad96741a8$var$yf = /\u0000|\uFFFD/g;
function $189c8bfad96741a8$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($189c8bfad96741a8$var$xf, "\n").replace($189c8bfad96741a8$var$yf, "");
}
function $189c8bfad96741a8$var$Af(a, b, c) {
    b = $189c8bfad96741a8$var$zf(b);
    if ($189c8bfad96741a8$var$zf(a) !== b && c) throw Error($189c8bfad96741a8$var$p(425));
}
function $189c8bfad96741a8$var$Bf() {}
var $189c8bfad96741a8$var$Cf = null, $189c8bfad96741a8$var$Df = null;
function $189c8bfad96741a8$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $189c8bfad96741a8$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $189c8bfad96741a8$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $189c8bfad96741a8$var$Hf = "function" === typeof Promise ? Promise : void 0, $189c8bfad96741a8$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $189c8bfad96741a8$var$Hf ? function(a) {
    return $189c8bfad96741a8$var$Hf.resolve(null).then(a).catch($189c8bfad96741a8$var$If);
} : $189c8bfad96741a8$var$Ff;
function $189c8bfad96741a8$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $189c8bfad96741a8$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $189c8bfad96741a8$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $189c8bfad96741a8$var$bd(b);
}
function $189c8bfad96741a8$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $189c8bfad96741a8$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $189c8bfad96741a8$var$Nf = Math.random().toString(36).slice(2), $189c8bfad96741a8$var$Of = "__reactFiber$" + $189c8bfad96741a8$var$Nf, $189c8bfad96741a8$var$Pf = "__reactProps$" + $189c8bfad96741a8$var$Nf, $189c8bfad96741a8$var$uf = "__reactContainer$" + $189c8bfad96741a8$var$Nf, $189c8bfad96741a8$var$of = "__reactEvents$" + $189c8bfad96741a8$var$Nf, $189c8bfad96741a8$var$Qf = "__reactListeners$" + $189c8bfad96741a8$var$Nf, $189c8bfad96741a8$var$Rf = "__reactHandles$" + $189c8bfad96741a8$var$Nf;
function $189c8bfad96741a8$var$Wc(a) {
    var b = a[$189c8bfad96741a8$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$189c8bfad96741a8$var$uf] || c[$189c8bfad96741a8$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $189c8bfad96741a8$var$Mf(a); null !== a;){
                if (c = a[$189c8bfad96741a8$var$Of]) return c;
                a = $189c8bfad96741a8$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $189c8bfad96741a8$var$Cb(a) {
    a = a[$189c8bfad96741a8$var$Of] || a[$189c8bfad96741a8$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $189c8bfad96741a8$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($189c8bfad96741a8$var$p(33));
}
function $189c8bfad96741a8$var$Db(a) {
    return a[$189c8bfad96741a8$var$Pf] || null;
}
var $189c8bfad96741a8$var$Sf = [], $189c8bfad96741a8$var$Tf = -1;
function $189c8bfad96741a8$var$Uf(a) {
    return {
        current: a
    };
}
function $189c8bfad96741a8$var$E(a) {
    0 > $189c8bfad96741a8$var$Tf || (a.current = $189c8bfad96741a8$var$Sf[$189c8bfad96741a8$var$Tf], $189c8bfad96741a8$var$Sf[$189c8bfad96741a8$var$Tf] = null, $189c8bfad96741a8$var$Tf--);
}
function $189c8bfad96741a8$var$G(a, b) {
    $189c8bfad96741a8$var$Tf++;
    $189c8bfad96741a8$var$Sf[$189c8bfad96741a8$var$Tf] = a.current;
    a.current = b;
}
var $189c8bfad96741a8$var$Vf = {}, $189c8bfad96741a8$var$H = $189c8bfad96741a8$var$Uf($189c8bfad96741a8$var$Vf), $189c8bfad96741a8$var$Wf = $189c8bfad96741a8$var$Uf(!1), $189c8bfad96741a8$var$Xf = $189c8bfad96741a8$var$Vf;
function $189c8bfad96741a8$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $189c8bfad96741a8$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $189c8bfad96741a8$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $189c8bfad96741a8$var$$f() {
    $189c8bfad96741a8$var$E($189c8bfad96741a8$var$Wf);
    $189c8bfad96741a8$var$E($189c8bfad96741a8$var$H);
}
function $189c8bfad96741a8$var$ag(a, b, c) {
    if ($189c8bfad96741a8$var$H.current !== $189c8bfad96741a8$var$Vf) throw Error($189c8bfad96741a8$var$p(168));
    $189c8bfad96741a8$var$G($189c8bfad96741a8$var$H, b);
    $189c8bfad96741a8$var$G($189c8bfad96741a8$var$Wf, c);
}
function $189c8bfad96741a8$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($189c8bfad96741a8$var$p(108, $189c8bfad96741a8$var$Ra(a) || "Unknown", e));
    return $189c8bfad96741a8$var$A({}, c, d);
}
function $189c8bfad96741a8$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $189c8bfad96741a8$var$Vf;
    $189c8bfad96741a8$var$Xf = $189c8bfad96741a8$var$H.current;
    $189c8bfad96741a8$var$G($189c8bfad96741a8$var$H, a);
    $189c8bfad96741a8$var$G($189c8bfad96741a8$var$Wf, $189c8bfad96741a8$var$Wf.current);
    return !0;
}
function $189c8bfad96741a8$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($189c8bfad96741a8$var$p(169));
    c ? (a = $189c8bfad96741a8$var$bg(a, b, $189c8bfad96741a8$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $189c8bfad96741a8$var$E($189c8bfad96741a8$var$Wf), $189c8bfad96741a8$var$E($189c8bfad96741a8$var$H), $189c8bfad96741a8$var$G($189c8bfad96741a8$var$H, a)) : $189c8bfad96741a8$var$E($189c8bfad96741a8$var$Wf);
    $189c8bfad96741a8$var$G($189c8bfad96741a8$var$Wf, c);
}
var $189c8bfad96741a8$var$eg = null, $189c8bfad96741a8$var$fg = !1, $189c8bfad96741a8$var$gg = !1;
function $189c8bfad96741a8$var$hg(a) {
    null === $189c8bfad96741a8$var$eg ? $189c8bfad96741a8$var$eg = [
        a
    ] : $189c8bfad96741a8$var$eg.push(a);
}
function $189c8bfad96741a8$var$ig(a) {
    $189c8bfad96741a8$var$fg = !0;
    $189c8bfad96741a8$var$hg(a);
}
function $189c8bfad96741a8$var$jg() {
    if (!$189c8bfad96741a8$var$gg && null !== $189c8bfad96741a8$var$eg) {
        $189c8bfad96741a8$var$gg = !0;
        var a = 0, b = $189c8bfad96741a8$var$C;
        try {
            var c = $189c8bfad96741a8$var$eg;
            for($189c8bfad96741a8$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $189c8bfad96741a8$var$eg = null;
            $189c8bfad96741a8$var$fg = !1;
        } catch (e) {
            throw null !== $189c8bfad96741a8$var$eg && ($189c8bfad96741a8$var$eg = $189c8bfad96741a8$var$eg.slice(a + 1)), $189c8bfad96741a8$var$ac($189c8bfad96741a8$var$fc, $189c8bfad96741a8$var$jg), e;
        } finally{
            $189c8bfad96741a8$var$C = b, $189c8bfad96741a8$var$gg = !1;
        }
    }
    return null;
}
var $189c8bfad96741a8$var$kg = [], $189c8bfad96741a8$var$lg = 0, $189c8bfad96741a8$var$mg = null, $189c8bfad96741a8$var$ng = 0, $189c8bfad96741a8$var$og = [], $189c8bfad96741a8$var$pg = 0, $189c8bfad96741a8$var$qg = null, $189c8bfad96741a8$var$rg = 1, $189c8bfad96741a8$var$sg = "";
function $189c8bfad96741a8$var$tg(a, b) {
    $189c8bfad96741a8$var$kg[$189c8bfad96741a8$var$lg++] = $189c8bfad96741a8$var$ng;
    $189c8bfad96741a8$var$kg[$189c8bfad96741a8$var$lg++] = $189c8bfad96741a8$var$mg;
    $189c8bfad96741a8$var$mg = a;
    $189c8bfad96741a8$var$ng = b;
}
function $189c8bfad96741a8$var$ug(a, b, c) {
    $189c8bfad96741a8$var$og[$189c8bfad96741a8$var$pg++] = $189c8bfad96741a8$var$rg;
    $189c8bfad96741a8$var$og[$189c8bfad96741a8$var$pg++] = $189c8bfad96741a8$var$sg;
    $189c8bfad96741a8$var$og[$189c8bfad96741a8$var$pg++] = $189c8bfad96741a8$var$qg;
    $189c8bfad96741a8$var$qg = a;
    var d = $189c8bfad96741a8$var$rg;
    a = $189c8bfad96741a8$var$sg;
    var e = 32 - $189c8bfad96741a8$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $189c8bfad96741a8$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $189c8bfad96741a8$var$rg = 1 << 32 - $189c8bfad96741a8$var$oc(b) + e | c << e | d;
        $189c8bfad96741a8$var$sg = f + a;
    } else $189c8bfad96741a8$var$rg = 1 << f | c << e | d, $189c8bfad96741a8$var$sg = a;
}
function $189c8bfad96741a8$var$vg(a) {
    null !== a.return && ($189c8bfad96741a8$var$tg(a, 1), $189c8bfad96741a8$var$ug(a, 1, 0));
}
function $189c8bfad96741a8$var$wg(a) {
    for(; a === $189c8bfad96741a8$var$mg;)$189c8bfad96741a8$var$mg = $189c8bfad96741a8$var$kg[--$189c8bfad96741a8$var$lg], $189c8bfad96741a8$var$kg[$189c8bfad96741a8$var$lg] = null, $189c8bfad96741a8$var$ng = $189c8bfad96741a8$var$kg[--$189c8bfad96741a8$var$lg], $189c8bfad96741a8$var$kg[$189c8bfad96741a8$var$lg] = null;
    for(; a === $189c8bfad96741a8$var$qg;)$189c8bfad96741a8$var$qg = $189c8bfad96741a8$var$og[--$189c8bfad96741a8$var$pg], $189c8bfad96741a8$var$og[$189c8bfad96741a8$var$pg] = null, $189c8bfad96741a8$var$sg = $189c8bfad96741a8$var$og[--$189c8bfad96741a8$var$pg], $189c8bfad96741a8$var$og[$189c8bfad96741a8$var$pg] = null, $189c8bfad96741a8$var$rg = $189c8bfad96741a8$var$og[--$189c8bfad96741a8$var$pg], $189c8bfad96741a8$var$og[$189c8bfad96741a8$var$pg] = null;
}
var $189c8bfad96741a8$var$xg = null, $189c8bfad96741a8$var$yg = null, $189c8bfad96741a8$var$I = !1, $189c8bfad96741a8$var$zg = null;
function $189c8bfad96741a8$var$Ag(a, b) {
    var c = $189c8bfad96741a8$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $189c8bfad96741a8$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $189c8bfad96741a8$var$xg = a, $189c8bfad96741a8$var$yg = $189c8bfad96741a8$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $189c8bfad96741a8$var$xg = a, $189c8bfad96741a8$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $189c8bfad96741a8$var$qg ? {
                id: $189c8bfad96741a8$var$rg,
                overflow: $189c8bfad96741a8$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $189c8bfad96741a8$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $189c8bfad96741a8$var$xg = a, $189c8bfad96741a8$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $189c8bfad96741a8$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $189c8bfad96741a8$var$Eg(a) {
    if ($189c8bfad96741a8$var$I) {
        var b = $189c8bfad96741a8$var$yg;
        if (b) {
            var c = b;
            if (!$189c8bfad96741a8$var$Cg(a, b)) {
                if ($189c8bfad96741a8$var$Dg(a)) throw Error($189c8bfad96741a8$var$p(418));
                b = $189c8bfad96741a8$var$Lf(c.nextSibling);
                var d = $189c8bfad96741a8$var$xg;
                b && $189c8bfad96741a8$var$Cg(a, b) ? $189c8bfad96741a8$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $189c8bfad96741a8$var$I = !1, $189c8bfad96741a8$var$xg = a);
            }
        } else {
            if ($189c8bfad96741a8$var$Dg(a)) throw Error($189c8bfad96741a8$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $189c8bfad96741a8$var$I = !1;
            $189c8bfad96741a8$var$xg = a;
        }
    }
}
function $189c8bfad96741a8$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $189c8bfad96741a8$var$xg = a;
}
function $189c8bfad96741a8$var$Gg(a) {
    if (a !== $189c8bfad96741a8$var$xg) return !1;
    if (!$189c8bfad96741a8$var$I) return $189c8bfad96741a8$var$Fg(a), $189c8bfad96741a8$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$189c8bfad96741a8$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $189c8bfad96741a8$var$yg)) {
        if ($189c8bfad96741a8$var$Dg(a)) throw $189c8bfad96741a8$var$Hg(), Error($189c8bfad96741a8$var$p(418));
        for(; b;)$189c8bfad96741a8$var$Ag(a, b), b = $189c8bfad96741a8$var$Lf(b.nextSibling);
    }
    $189c8bfad96741a8$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($189c8bfad96741a8$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $189c8bfad96741a8$var$yg = $189c8bfad96741a8$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $189c8bfad96741a8$var$yg = null;
        }
    } else $189c8bfad96741a8$var$yg = $189c8bfad96741a8$var$xg ? $189c8bfad96741a8$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $189c8bfad96741a8$var$Hg() {
    for(var a = $189c8bfad96741a8$var$yg; a;)a = $189c8bfad96741a8$var$Lf(a.nextSibling);
}
function $189c8bfad96741a8$var$Ig() {
    $189c8bfad96741a8$var$yg = $189c8bfad96741a8$var$xg = null;
    $189c8bfad96741a8$var$I = !1;
}
function $189c8bfad96741a8$var$Jg(a) {
    null === $189c8bfad96741a8$var$zg ? $189c8bfad96741a8$var$zg = [
        a
    ] : $189c8bfad96741a8$var$zg.push(a);
}
var $189c8bfad96741a8$var$Kg = $189c8bfad96741a8$var$ua.ReactCurrentBatchConfig;
function $189c8bfad96741a8$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $189c8bfad96741a8$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $189c8bfad96741a8$var$Mg = $189c8bfad96741a8$var$Uf(null), $189c8bfad96741a8$var$Ng = null, $189c8bfad96741a8$var$Og = null, $189c8bfad96741a8$var$Pg = null;
function $189c8bfad96741a8$var$Qg() {
    $189c8bfad96741a8$var$Pg = $189c8bfad96741a8$var$Og = $189c8bfad96741a8$var$Ng = null;
}
function $189c8bfad96741a8$var$Rg(a) {
    var b = $189c8bfad96741a8$var$Mg.current;
    $189c8bfad96741a8$var$E($189c8bfad96741a8$var$Mg);
    a._currentValue = b;
}
function $189c8bfad96741a8$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $189c8bfad96741a8$var$Tg(a, b) {
    $189c8bfad96741a8$var$Ng = a;
    $189c8bfad96741a8$var$Pg = $189c8bfad96741a8$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($189c8bfad96741a8$var$Ug = !0), a.firstContext = null);
}
function $189c8bfad96741a8$var$Vg(a) {
    var b = a._currentValue;
    if ($189c8bfad96741a8$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $189c8bfad96741a8$var$Og) {
            if (null === $189c8bfad96741a8$var$Ng) throw Error($189c8bfad96741a8$var$p(308));
            $189c8bfad96741a8$var$Og = a;
            $189c8bfad96741a8$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $189c8bfad96741a8$var$Og = $189c8bfad96741a8$var$Og.next = a;
    }
    return b;
}
var $189c8bfad96741a8$var$Wg = null;
function $189c8bfad96741a8$var$Xg(a) {
    null === $189c8bfad96741a8$var$Wg ? $189c8bfad96741a8$var$Wg = [
        a
    ] : $189c8bfad96741a8$var$Wg.push(a);
}
function $189c8bfad96741a8$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $189c8bfad96741a8$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $189c8bfad96741a8$var$Zg(a, d);
}
function $189c8bfad96741a8$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $189c8bfad96741a8$var$$g = !1;
function $189c8bfad96741a8$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $189c8bfad96741a8$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $189c8bfad96741a8$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $189c8bfad96741a8$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($189c8bfad96741a8$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $189c8bfad96741a8$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $189c8bfad96741a8$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $189c8bfad96741a8$var$Zg(a, c);
}
function $189c8bfad96741a8$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $189c8bfad96741a8$var$Cc(a, c);
    }
}
function $189c8bfad96741a8$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $189c8bfad96741a8$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $189c8bfad96741a8$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $189c8bfad96741a8$var$A({}, q, r);
                            break a;
                        case 2:
                            $189c8bfad96741a8$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $189c8bfad96741a8$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $189c8bfad96741a8$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($189c8bfad96741a8$var$p(191, e));
            e.call(d);
        }
    }
}
var $189c8bfad96741a8$var$jh = (new $3qjKr.Component).refs;
function $189c8bfad96741a8$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $189c8bfad96741a8$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $189c8bfad96741a8$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $189c8bfad96741a8$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $189c8bfad96741a8$var$L(), e = $189c8bfad96741a8$var$lh(a), f = $189c8bfad96741a8$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $189c8bfad96741a8$var$dh(a, f, e);
        null !== b && ($189c8bfad96741a8$var$mh(b, a, e, d), $189c8bfad96741a8$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $189c8bfad96741a8$var$L(), e = $189c8bfad96741a8$var$lh(a), f = $189c8bfad96741a8$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $189c8bfad96741a8$var$dh(a, f, e);
        null !== b && ($189c8bfad96741a8$var$mh(b, a, e, d), $189c8bfad96741a8$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $189c8bfad96741a8$var$L(), d = $189c8bfad96741a8$var$lh(a), e = $189c8bfad96741a8$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $189c8bfad96741a8$var$dh(a, e, d);
        null !== b && ($189c8bfad96741a8$var$mh(b, a, d, c), $189c8bfad96741a8$var$eh(b, a, d));
    }
};
function $189c8bfad96741a8$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$189c8bfad96741a8$var$Ie(c, d) || !$189c8bfad96741a8$var$Ie(e, f) : !0;
}
function $189c8bfad96741a8$var$ph(a, b, c) {
    var d = !1, e = $189c8bfad96741a8$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $189c8bfad96741a8$var$Vg(f) : (e = $189c8bfad96741a8$var$Zf(b) ? $189c8bfad96741a8$var$Xf : $189c8bfad96741a8$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $189c8bfad96741a8$var$Yf(a, e) : $189c8bfad96741a8$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $189c8bfad96741a8$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $189c8bfad96741a8$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $189c8bfad96741a8$var$nh.enqueueReplaceState(b, b.state, null);
}
function $189c8bfad96741a8$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $189c8bfad96741a8$var$jh;
    $189c8bfad96741a8$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $189c8bfad96741a8$var$Vg(f) : (f = $189c8bfad96741a8$var$Zf(b) ? $189c8bfad96741a8$var$Xf : $189c8bfad96741a8$var$H.current, e.context = $189c8bfad96741a8$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($189c8bfad96741a8$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $189c8bfad96741a8$var$nh.enqueueReplaceState(e, e.state, null), $189c8bfad96741a8$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $189c8bfad96741a8$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($189c8bfad96741a8$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($189c8bfad96741a8$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $189c8bfad96741a8$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($189c8bfad96741a8$var$p(284));
        if (!c._owner) throw Error($189c8bfad96741a8$var$p(290, a));
    }
    return a;
}
function $189c8bfad96741a8$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($189c8bfad96741a8$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $189c8bfad96741a8$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $189c8bfad96741a8$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $189c8bfad96741a8$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $189c8bfad96741a8$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $189c8bfad96741a8$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $189c8bfad96741a8$var$Ha && $189c8bfad96741a8$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $189c8bfad96741a8$var$sh(a, b, c), d.return = a, d;
        d = $189c8bfad96741a8$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $189c8bfad96741a8$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $189c8bfad96741a8$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $189c8bfad96741a8$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $189c8bfad96741a8$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $189c8bfad96741a8$var$va:
                    return c = $189c8bfad96741a8$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $189c8bfad96741a8$var$sh(a, null, b), c.return = a, c;
                case $189c8bfad96741a8$var$wa:
                    return b = $189c8bfad96741a8$var$zh(b, a.mode, c), b.return = a, b;
                case $189c8bfad96741a8$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($189c8bfad96741a8$var$eb(b) || $189c8bfad96741a8$var$Ka(b)) return b = $189c8bfad96741a8$var$Ah(b, a.mode, c, null), b.return = a, b;
            $189c8bfad96741a8$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $189c8bfad96741a8$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $189c8bfad96741a8$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $189c8bfad96741a8$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($189c8bfad96741a8$var$eb(c) || $189c8bfad96741a8$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $189c8bfad96741a8$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $189c8bfad96741a8$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $189c8bfad96741a8$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $189c8bfad96741a8$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($189c8bfad96741a8$var$eb(d) || $189c8bfad96741a8$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $189c8bfad96741a8$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $189c8bfad96741a8$var$I && $189c8bfad96741a8$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $189c8bfad96741a8$var$I && $189c8bfad96741a8$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $189c8bfad96741a8$var$I && $189c8bfad96741a8$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $189c8bfad96741a8$var$Ka(h);
        if ("function" !== typeof l) throw Error($189c8bfad96741a8$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($189c8bfad96741a8$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $189c8bfad96741a8$var$I && $189c8bfad96741a8$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $189c8bfad96741a8$var$I && $189c8bfad96741a8$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $189c8bfad96741a8$var$I && $189c8bfad96741a8$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $189c8bfad96741a8$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $189c8bfad96741a8$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $189c8bfad96741a8$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $189c8bfad96741a8$var$Ha && $189c8bfad96741a8$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $189c8bfad96741a8$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $189c8bfad96741a8$var$ya ? (d = $189c8bfad96741a8$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $189c8bfad96741a8$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $189c8bfad96741a8$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $189c8bfad96741a8$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $189c8bfad96741a8$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $189c8bfad96741a8$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($189c8bfad96741a8$var$eb(f)) return n(a, d, f, h);
            if ($189c8bfad96741a8$var$Ka(f)) return t(a, d, f, h);
            $189c8bfad96741a8$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $189c8bfad96741a8$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $189c8bfad96741a8$var$Bh = $189c8bfad96741a8$var$vh(!0), $189c8bfad96741a8$var$Ch = $189c8bfad96741a8$var$vh(!1), $189c8bfad96741a8$var$Dh = {}, $189c8bfad96741a8$var$Eh = $189c8bfad96741a8$var$Uf($189c8bfad96741a8$var$Dh), $189c8bfad96741a8$var$Fh = $189c8bfad96741a8$var$Uf($189c8bfad96741a8$var$Dh), $189c8bfad96741a8$var$Gh = $189c8bfad96741a8$var$Uf($189c8bfad96741a8$var$Dh);
function $189c8bfad96741a8$var$Hh(a) {
    if (a === $189c8bfad96741a8$var$Dh) throw Error($189c8bfad96741a8$var$p(174));
    return a;
}
function $189c8bfad96741a8$var$Ih(a, b) {
    $189c8bfad96741a8$var$G($189c8bfad96741a8$var$Gh, b);
    $189c8bfad96741a8$var$G($189c8bfad96741a8$var$Fh, a);
    $189c8bfad96741a8$var$G($189c8bfad96741a8$var$Eh, $189c8bfad96741a8$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $189c8bfad96741a8$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $189c8bfad96741a8$var$lb(b, a);
    }
    $189c8bfad96741a8$var$E($189c8bfad96741a8$var$Eh);
    $189c8bfad96741a8$var$G($189c8bfad96741a8$var$Eh, b);
}
function $189c8bfad96741a8$var$Jh() {
    $189c8bfad96741a8$var$E($189c8bfad96741a8$var$Eh);
    $189c8bfad96741a8$var$E($189c8bfad96741a8$var$Fh);
    $189c8bfad96741a8$var$E($189c8bfad96741a8$var$Gh);
}
function $189c8bfad96741a8$var$Kh(a) {
    $189c8bfad96741a8$var$Hh($189c8bfad96741a8$var$Gh.current);
    var b = $189c8bfad96741a8$var$Hh($189c8bfad96741a8$var$Eh.current);
    var c = $189c8bfad96741a8$var$lb(b, a.type);
    b !== c && ($189c8bfad96741a8$var$G($189c8bfad96741a8$var$Fh, a), $189c8bfad96741a8$var$G($189c8bfad96741a8$var$Eh, c));
}
function $189c8bfad96741a8$var$Lh(a) {
    $189c8bfad96741a8$var$Fh.current === a && ($189c8bfad96741a8$var$E($189c8bfad96741a8$var$Eh), $189c8bfad96741a8$var$E($189c8bfad96741a8$var$Fh));
}
var $189c8bfad96741a8$var$M = $189c8bfad96741a8$var$Uf(0);
function $189c8bfad96741a8$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $189c8bfad96741a8$var$Nh = [];
function $189c8bfad96741a8$var$Oh() {
    for(var a = 0; a < $189c8bfad96741a8$var$Nh.length; a++)$189c8bfad96741a8$var$Nh[a]._workInProgressVersionPrimary = null;
    $189c8bfad96741a8$var$Nh.length = 0;
}
var $189c8bfad96741a8$var$Ph = $189c8bfad96741a8$var$ua.ReactCurrentDispatcher, $189c8bfad96741a8$var$Qh = $189c8bfad96741a8$var$ua.ReactCurrentBatchConfig, $189c8bfad96741a8$var$Rh = 0, $189c8bfad96741a8$var$N = null, $189c8bfad96741a8$var$O = null, $189c8bfad96741a8$var$P = null, $189c8bfad96741a8$var$Sh = !1, $189c8bfad96741a8$var$Th = !1, $189c8bfad96741a8$var$Uh = 0, $189c8bfad96741a8$var$Vh = 0;
function $189c8bfad96741a8$var$Q() {
    throw Error($189c8bfad96741a8$var$p(321));
}
function $189c8bfad96741a8$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$189c8bfad96741a8$var$He(a[c], b[c])) return !1;
    return !0;
}
function $189c8bfad96741a8$var$Xh(a, b, c, d, e, f) {
    $189c8bfad96741a8$var$Rh = f;
    $189c8bfad96741a8$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $189c8bfad96741a8$var$Ph.current = null === a || null === a.memoizedState ? $189c8bfad96741a8$var$Yh : $189c8bfad96741a8$var$Zh;
    a = c(d, e);
    if ($189c8bfad96741a8$var$Th) {
        f = 0;
        do {
            $189c8bfad96741a8$var$Th = !1;
            $189c8bfad96741a8$var$Uh = 0;
            if (25 <= f) throw Error($189c8bfad96741a8$var$p(301));
            f += 1;
            $189c8bfad96741a8$var$P = $189c8bfad96741a8$var$O = null;
            b.updateQueue = null;
            $189c8bfad96741a8$var$Ph.current = $189c8bfad96741a8$var$$h;
            a = c(d, e);
        }while ($189c8bfad96741a8$var$Th);
    }
    $189c8bfad96741a8$var$Ph.current = $189c8bfad96741a8$var$ai;
    b = null !== $189c8bfad96741a8$var$O && null !== $189c8bfad96741a8$var$O.next;
    $189c8bfad96741a8$var$Rh = 0;
    $189c8bfad96741a8$var$P = $189c8bfad96741a8$var$O = $189c8bfad96741a8$var$N = null;
    $189c8bfad96741a8$var$Sh = !1;
    if (b) throw Error($189c8bfad96741a8$var$p(300));
    return a;
}
function $189c8bfad96741a8$var$bi() {
    var a = 0 !== $189c8bfad96741a8$var$Uh;
    $189c8bfad96741a8$var$Uh = 0;
    return a;
}
function $189c8bfad96741a8$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $189c8bfad96741a8$var$P ? $189c8bfad96741a8$var$N.memoizedState = $189c8bfad96741a8$var$P = a : $189c8bfad96741a8$var$P = $189c8bfad96741a8$var$P.next = a;
    return $189c8bfad96741a8$var$P;
}
function $189c8bfad96741a8$var$di() {
    if (null === $189c8bfad96741a8$var$O) {
        var a = $189c8bfad96741a8$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $189c8bfad96741a8$var$O.next;
    var b = null === $189c8bfad96741a8$var$P ? $189c8bfad96741a8$var$N.memoizedState : $189c8bfad96741a8$var$P.next;
    if (null !== b) $189c8bfad96741a8$var$P = b, $189c8bfad96741a8$var$O = a;
    else {
        if (null === a) throw Error($189c8bfad96741a8$var$p(310));
        $189c8bfad96741a8$var$O = a;
        a = {
            memoizedState: $189c8bfad96741a8$var$O.memoizedState,
            baseState: $189c8bfad96741a8$var$O.baseState,
            baseQueue: $189c8bfad96741a8$var$O.baseQueue,
            queue: $189c8bfad96741a8$var$O.queue,
            next: null
        };
        null === $189c8bfad96741a8$var$P ? $189c8bfad96741a8$var$N.memoizedState = $189c8bfad96741a8$var$P = a : $189c8bfad96741a8$var$P = $189c8bfad96741a8$var$P.next = a;
    }
    return $189c8bfad96741a8$var$P;
}
function $189c8bfad96741a8$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $189c8bfad96741a8$var$fi(a) {
    var b = $189c8bfad96741a8$var$di(), c = b.queue;
    if (null === c) throw Error($189c8bfad96741a8$var$p(311));
    c.lastRenderedReducer = a;
    var d = $189c8bfad96741a8$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($189c8bfad96741a8$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $189c8bfad96741a8$var$N.lanes |= m;
                $189c8bfad96741a8$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $189c8bfad96741a8$var$He(d, b.memoizedState) || ($189c8bfad96741a8$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $189c8bfad96741a8$var$N.lanes |= f, $189c8bfad96741a8$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $189c8bfad96741a8$var$gi(a) {
    var b = $189c8bfad96741a8$var$di(), c = b.queue;
    if (null === c) throw Error($189c8bfad96741a8$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $189c8bfad96741a8$var$He(f, b.memoizedState) || ($189c8bfad96741a8$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $189c8bfad96741a8$var$hi() {}
function $189c8bfad96741a8$var$ii(a, b) {
    var c = $189c8bfad96741a8$var$N, d = $189c8bfad96741a8$var$di(), e = b(), f = !$189c8bfad96741a8$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $189c8bfad96741a8$var$Ug = !0);
    d = d.queue;
    $189c8bfad96741a8$var$ji($189c8bfad96741a8$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $189c8bfad96741a8$var$P && $189c8bfad96741a8$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $189c8bfad96741a8$var$li(9, $189c8bfad96741a8$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $189c8bfad96741a8$var$R) throw Error($189c8bfad96741a8$var$p(349));
        0 !== ($189c8bfad96741a8$var$Rh & 30) || $189c8bfad96741a8$var$ni(c, b, e);
    }
    return e;
}
function $189c8bfad96741a8$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $189c8bfad96741a8$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $189c8bfad96741a8$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $189c8bfad96741a8$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $189c8bfad96741a8$var$oi(b) && $189c8bfad96741a8$var$pi(a);
}
function $189c8bfad96741a8$var$ki(a, b, c) {
    return c(function() {
        $189c8bfad96741a8$var$oi(b) && $189c8bfad96741a8$var$pi(a);
    });
}
function $189c8bfad96741a8$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$189c8bfad96741a8$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $189c8bfad96741a8$var$pi(a) {
    var b = $189c8bfad96741a8$var$Zg(a, 1);
    null !== b && $189c8bfad96741a8$var$mh(b, a, 1, -1);
}
function $189c8bfad96741a8$var$qi(a) {
    var b = $189c8bfad96741a8$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $189c8bfad96741a8$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $189c8bfad96741a8$var$ri.bind(null, $189c8bfad96741a8$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $189c8bfad96741a8$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $189c8bfad96741a8$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $189c8bfad96741a8$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $189c8bfad96741a8$var$si() {
    return $189c8bfad96741a8$var$di().memoizedState;
}
function $189c8bfad96741a8$var$ti(a, b, c, d) {
    var e = $189c8bfad96741a8$var$ci();
    $189c8bfad96741a8$var$N.flags |= a;
    e.memoizedState = $189c8bfad96741a8$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $189c8bfad96741a8$var$ui(a, b, c, d) {
    var e = $189c8bfad96741a8$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $189c8bfad96741a8$var$O) {
        var g = $189c8bfad96741a8$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $189c8bfad96741a8$var$Wh(d, g.deps)) {
            e.memoizedState = $189c8bfad96741a8$var$li(b, c, f, d);
            return;
        }
    }
    $189c8bfad96741a8$var$N.flags |= a;
    e.memoizedState = $189c8bfad96741a8$var$li(1 | b, c, f, d);
}
function $189c8bfad96741a8$var$vi(a, b) {
    return $189c8bfad96741a8$var$ti(8390656, 8, a, b);
}
function $189c8bfad96741a8$var$ji(a, b) {
    return $189c8bfad96741a8$var$ui(2048, 8, a, b);
}
function $189c8bfad96741a8$var$wi(a, b) {
    return $189c8bfad96741a8$var$ui(4, 2, a, b);
}
function $189c8bfad96741a8$var$xi(a, b) {
    return $189c8bfad96741a8$var$ui(4, 4, a, b);
}
function $189c8bfad96741a8$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $189c8bfad96741a8$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $189c8bfad96741a8$var$ui(4, 4, $189c8bfad96741a8$var$yi.bind(null, b, a), c);
}
function $189c8bfad96741a8$var$Ai() {}
function $189c8bfad96741a8$var$Bi(a, b) {
    var c = $189c8bfad96741a8$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $189c8bfad96741a8$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $189c8bfad96741a8$var$Ci(a, b) {
    var c = $189c8bfad96741a8$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $189c8bfad96741a8$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $189c8bfad96741a8$var$Di(a, b, c) {
    if (0 === ($189c8bfad96741a8$var$Rh & 21)) return a.baseState && (a.baseState = !1, $189c8bfad96741a8$var$Ug = !0), a.memoizedState = c;
    $189c8bfad96741a8$var$He(c, b) || (c = $189c8bfad96741a8$var$yc(), $189c8bfad96741a8$var$N.lanes |= c, $189c8bfad96741a8$var$hh |= c, a.baseState = !0);
    return b;
}
function $189c8bfad96741a8$var$Ei(a, b) {
    var c = $189c8bfad96741a8$var$C;
    $189c8bfad96741a8$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $189c8bfad96741a8$var$Qh.transition;
    $189c8bfad96741a8$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $189c8bfad96741a8$var$C = c, $189c8bfad96741a8$var$Qh.transition = d;
    }
}
function $189c8bfad96741a8$var$Fi() {
    return $189c8bfad96741a8$var$di().memoizedState;
}
function $189c8bfad96741a8$var$Gi(a, b, c) {
    var d = $189c8bfad96741a8$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($189c8bfad96741a8$var$Hi(a)) $189c8bfad96741a8$var$Ii(b, c);
    else if (c = $189c8bfad96741a8$var$Yg(a, b, c, d), null !== c) {
        var e = $189c8bfad96741a8$var$L();
        $189c8bfad96741a8$var$mh(c, a, d, e);
        $189c8bfad96741a8$var$Ji(c, b, d);
    }
}
function $189c8bfad96741a8$var$ri(a, b, c) {
    var d = $189c8bfad96741a8$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($189c8bfad96741a8$var$Hi(a)) $189c8bfad96741a8$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($189c8bfad96741a8$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $189c8bfad96741a8$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $189c8bfad96741a8$var$Yg(a, b, e, d);
        null !== c && (e = $189c8bfad96741a8$var$L(), $189c8bfad96741a8$var$mh(c, a, d, e), $189c8bfad96741a8$var$Ji(c, b, d));
    }
}
function $189c8bfad96741a8$var$Hi(a) {
    var b = a.alternate;
    return a === $189c8bfad96741a8$var$N || null !== b && b === $189c8bfad96741a8$var$N;
}
function $189c8bfad96741a8$var$Ii(a, b) {
    $189c8bfad96741a8$var$Th = $189c8bfad96741a8$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $189c8bfad96741a8$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $189c8bfad96741a8$var$Cc(a, c);
    }
}
var $189c8bfad96741a8$var$ai = {
    readContext: $189c8bfad96741a8$var$Vg,
    useCallback: $189c8bfad96741a8$var$Q,
    useContext: $189c8bfad96741a8$var$Q,
    useEffect: $189c8bfad96741a8$var$Q,
    useImperativeHandle: $189c8bfad96741a8$var$Q,
    useInsertionEffect: $189c8bfad96741a8$var$Q,
    useLayoutEffect: $189c8bfad96741a8$var$Q,
    useMemo: $189c8bfad96741a8$var$Q,
    useReducer: $189c8bfad96741a8$var$Q,
    useRef: $189c8bfad96741a8$var$Q,
    useState: $189c8bfad96741a8$var$Q,
    useDebugValue: $189c8bfad96741a8$var$Q,
    useDeferredValue: $189c8bfad96741a8$var$Q,
    useTransition: $189c8bfad96741a8$var$Q,
    useMutableSource: $189c8bfad96741a8$var$Q,
    useSyncExternalStore: $189c8bfad96741a8$var$Q,
    useId: $189c8bfad96741a8$var$Q,
    unstable_isNewReconciler: !1
}, $189c8bfad96741a8$var$Yh = {
    readContext: $189c8bfad96741a8$var$Vg,
    useCallback: function(a, b) {
        $189c8bfad96741a8$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $189c8bfad96741a8$var$Vg,
    useEffect: $189c8bfad96741a8$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $189c8bfad96741a8$var$ti(4194308, 4, $189c8bfad96741a8$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $189c8bfad96741a8$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $189c8bfad96741a8$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $189c8bfad96741a8$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $189c8bfad96741a8$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $189c8bfad96741a8$var$Gi.bind(null, $189c8bfad96741a8$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $189c8bfad96741a8$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $189c8bfad96741a8$var$qi,
    useDebugValue: $189c8bfad96741a8$var$Ai,
    useDeferredValue: function(a) {
        return $189c8bfad96741a8$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $189c8bfad96741a8$var$qi(!1), b = a[0];
        a = $189c8bfad96741a8$var$Ei.bind(null, a[1]);
        $189c8bfad96741a8$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $189c8bfad96741a8$var$N, e = $189c8bfad96741a8$var$ci();
        if ($189c8bfad96741a8$var$I) {
            if (void 0 === c) throw Error($189c8bfad96741a8$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $189c8bfad96741a8$var$R) throw Error($189c8bfad96741a8$var$p(349));
            0 !== ($189c8bfad96741a8$var$Rh & 30) || $189c8bfad96741a8$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $189c8bfad96741a8$var$vi($189c8bfad96741a8$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $189c8bfad96741a8$var$li(9, $189c8bfad96741a8$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $189c8bfad96741a8$var$ci(), b = $189c8bfad96741a8$var$R.identifierPrefix;
        if ($189c8bfad96741a8$var$I) {
            var c = $189c8bfad96741a8$var$sg;
            var d = $189c8bfad96741a8$var$rg;
            c = (d & ~(1 << 32 - $189c8bfad96741a8$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $189c8bfad96741a8$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $189c8bfad96741a8$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $189c8bfad96741a8$var$Zh = {
    readContext: $189c8bfad96741a8$var$Vg,
    useCallback: $189c8bfad96741a8$var$Bi,
    useContext: $189c8bfad96741a8$var$Vg,
    useEffect: $189c8bfad96741a8$var$ji,
    useImperativeHandle: $189c8bfad96741a8$var$zi,
    useInsertionEffect: $189c8bfad96741a8$var$wi,
    useLayoutEffect: $189c8bfad96741a8$var$xi,
    useMemo: $189c8bfad96741a8$var$Ci,
    useReducer: $189c8bfad96741a8$var$fi,
    useRef: $189c8bfad96741a8$var$si,
    useState: function() {
        return $189c8bfad96741a8$var$fi($189c8bfad96741a8$var$ei);
    },
    useDebugValue: $189c8bfad96741a8$var$Ai,
    useDeferredValue: function(a) {
        var b = $189c8bfad96741a8$var$di();
        return $189c8bfad96741a8$var$Di(b, $189c8bfad96741a8$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $189c8bfad96741a8$var$fi($189c8bfad96741a8$var$ei)[0], b = $189c8bfad96741a8$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $189c8bfad96741a8$var$hi,
    useSyncExternalStore: $189c8bfad96741a8$var$ii,
    useId: $189c8bfad96741a8$var$Fi,
    unstable_isNewReconciler: !1
}, $189c8bfad96741a8$var$$h = {
    readContext: $189c8bfad96741a8$var$Vg,
    useCallback: $189c8bfad96741a8$var$Bi,
    useContext: $189c8bfad96741a8$var$Vg,
    useEffect: $189c8bfad96741a8$var$ji,
    useImperativeHandle: $189c8bfad96741a8$var$zi,
    useInsertionEffect: $189c8bfad96741a8$var$wi,
    useLayoutEffect: $189c8bfad96741a8$var$xi,
    useMemo: $189c8bfad96741a8$var$Ci,
    useReducer: $189c8bfad96741a8$var$gi,
    useRef: $189c8bfad96741a8$var$si,
    useState: function() {
        return $189c8bfad96741a8$var$gi($189c8bfad96741a8$var$ei);
    },
    useDebugValue: $189c8bfad96741a8$var$Ai,
    useDeferredValue: function(a) {
        var b = $189c8bfad96741a8$var$di();
        return null === $189c8bfad96741a8$var$O ? b.memoizedState = a : $189c8bfad96741a8$var$Di(b, $189c8bfad96741a8$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $189c8bfad96741a8$var$gi($189c8bfad96741a8$var$ei)[0], b = $189c8bfad96741a8$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $189c8bfad96741a8$var$hi,
    useSyncExternalStore: $189c8bfad96741a8$var$ii,
    useId: $189c8bfad96741a8$var$Fi,
    unstable_isNewReconciler: !1
};
function $189c8bfad96741a8$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $189c8bfad96741a8$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $189c8bfad96741a8$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $189c8bfad96741a8$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $189c8bfad96741a8$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $189c8bfad96741a8$var$Oi(a, b, c) {
    c = $189c8bfad96741a8$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $189c8bfad96741a8$var$Pi || ($189c8bfad96741a8$var$Pi = !0, $189c8bfad96741a8$var$Qi = d);
        $189c8bfad96741a8$var$Mi(a, b);
    };
    return c;
}
function $189c8bfad96741a8$var$Ri(a, b, c) {
    c = $189c8bfad96741a8$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $189c8bfad96741a8$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $189c8bfad96741a8$var$Mi(a, b);
        "function" !== typeof d && (null === $189c8bfad96741a8$var$Si ? $189c8bfad96741a8$var$Si = new Set([
            this
        ]) : $189c8bfad96741a8$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $189c8bfad96741a8$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $189c8bfad96741a8$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $189c8bfad96741a8$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $189c8bfad96741a8$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $189c8bfad96741a8$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $189c8bfad96741a8$var$ch(-1, 1), b.tag = 2, $189c8bfad96741a8$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $189c8bfad96741a8$var$Xi = $189c8bfad96741a8$var$ua.ReactCurrentOwner, $189c8bfad96741a8$var$Ug = !1;
function $189c8bfad96741a8$var$Yi(a, b, c, d) {
    b.child = null === a ? $189c8bfad96741a8$var$Ch(b, null, c, d) : $189c8bfad96741a8$var$Bh(b, a.child, c, d);
}
function $189c8bfad96741a8$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $189c8bfad96741a8$var$Tg(b, e);
    d = $189c8bfad96741a8$var$Xh(a, b, c, d, f, e);
    c = $189c8bfad96741a8$var$bi();
    if (null !== a && !$189c8bfad96741a8$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $189c8bfad96741a8$var$$i(a, b, e);
    $189c8bfad96741a8$var$I && c && $189c8bfad96741a8$var$vg(b);
    b.flags |= 1;
    $189c8bfad96741a8$var$Yi(a, b, d, e);
    return b.child;
}
function $189c8bfad96741a8$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$189c8bfad96741a8$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $189c8bfad96741a8$var$cj(a, b, f, d, e);
        a = $189c8bfad96741a8$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $189c8bfad96741a8$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $189c8bfad96741a8$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $189c8bfad96741a8$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $189c8bfad96741a8$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($189c8bfad96741a8$var$Ie(f, d) && a.ref === b.ref) {
            if ($189c8bfad96741a8$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($189c8bfad96741a8$var$Ug = !0);
            else return b.lanes = a.lanes, $189c8bfad96741a8$var$$i(a, b, e);
        }
    }
    return $189c8bfad96741a8$var$dj(a, b, c, d, e);
}
function $189c8bfad96741a8$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $189c8bfad96741a8$var$G($189c8bfad96741a8$var$fj, $189c8bfad96741a8$var$gj), $189c8bfad96741a8$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $189c8bfad96741a8$var$G($189c8bfad96741a8$var$fj, $189c8bfad96741a8$var$gj), $189c8bfad96741a8$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $189c8bfad96741a8$var$G($189c8bfad96741a8$var$fj, $189c8bfad96741a8$var$gj);
            $189c8bfad96741a8$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $189c8bfad96741a8$var$G($189c8bfad96741a8$var$fj, $189c8bfad96741a8$var$gj), $189c8bfad96741a8$var$gj |= d;
    $189c8bfad96741a8$var$Yi(a, b, e, c);
    return b.child;
}
function $189c8bfad96741a8$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $189c8bfad96741a8$var$dj(a, b, c, d, e) {
    var f = $189c8bfad96741a8$var$Zf(c) ? $189c8bfad96741a8$var$Xf : $189c8bfad96741a8$var$H.current;
    f = $189c8bfad96741a8$var$Yf(b, f);
    $189c8bfad96741a8$var$Tg(b, e);
    c = $189c8bfad96741a8$var$Xh(a, b, c, d, f, e);
    d = $189c8bfad96741a8$var$bi();
    if (null !== a && !$189c8bfad96741a8$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $189c8bfad96741a8$var$$i(a, b, e);
    $189c8bfad96741a8$var$I && d && $189c8bfad96741a8$var$vg(b);
    b.flags |= 1;
    $189c8bfad96741a8$var$Yi(a, b, c, e);
    return b.child;
}
function $189c8bfad96741a8$var$ij(a, b, c, d, e) {
    if ($189c8bfad96741a8$var$Zf(c)) {
        var f = !0;
        $189c8bfad96741a8$var$cg(b);
    } else f = !1;
    $189c8bfad96741a8$var$Tg(b, e);
    if (null === b.stateNode) $189c8bfad96741a8$var$jj(a, b), $189c8bfad96741a8$var$ph(b, c, d), $189c8bfad96741a8$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $189c8bfad96741a8$var$Vg(l) : (l = $189c8bfad96741a8$var$Zf(c) ? $189c8bfad96741a8$var$Xf : $189c8bfad96741a8$var$H.current, l = $189c8bfad96741a8$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $189c8bfad96741a8$var$qh(b, g, d, l);
        $189c8bfad96741a8$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $189c8bfad96741a8$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $189c8bfad96741a8$var$Wf.current || $189c8bfad96741a8$var$$g ? ("function" === typeof m && ($189c8bfad96741a8$var$kh(b, c, m, d), k = b.memoizedState), (h = $189c8bfad96741a8$var$$g || $189c8bfad96741a8$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $189c8bfad96741a8$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $189c8bfad96741a8$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $189c8bfad96741a8$var$Vg(k) : (k = $189c8bfad96741a8$var$Zf(c) ? $189c8bfad96741a8$var$Xf : $189c8bfad96741a8$var$H.current, k = $189c8bfad96741a8$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $189c8bfad96741a8$var$qh(b, g, d, k);
        $189c8bfad96741a8$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $189c8bfad96741a8$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $189c8bfad96741a8$var$Wf.current || $189c8bfad96741a8$var$$g ? ("function" === typeof y && ($189c8bfad96741a8$var$kh(b, c, y, d), n = b.memoizedState), (l = $189c8bfad96741a8$var$$g || $189c8bfad96741a8$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $189c8bfad96741a8$var$kj(a, b, c, d, f, e);
}
function $189c8bfad96741a8$var$kj(a, b, c, d, e, f) {
    $189c8bfad96741a8$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $189c8bfad96741a8$var$dg(b, c, !1), $189c8bfad96741a8$var$$i(a, b, f);
    d = b.stateNode;
    $189c8bfad96741a8$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $189c8bfad96741a8$var$Bh(b, a.child, null, f), b.child = $189c8bfad96741a8$var$Bh(b, null, h, f)) : $189c8bfad96741a8$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $189c8bfad96741a8$var$dg(b, c, !0);
    return b.child;
}
function $189c8bfad96741a8$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $189c8bfad96741a8$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $189c8bfad96741a8$var$ag(a, b.context, !1);
    $189c8bfad96741a8$var$Ih(a, b.containerInfo);
}
function $189c8bfad96741a8$var$mj(a, b, c, d, e) {
    $189c8bfad96741a8$var$Ig();
    $189c8bfad96741a8$var$Jg(e);
    b.flags |= 256;
    $189c8bfad96741a8$var$Yi(a, b, c, d);
    return b.child;
}
var $189c8bfad96741a8$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $189c8bfad96741a8$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $189c8bfad96741a8$var$pj(a, b, c) {
    var d = b.pendingProps, e = $189c8bfad96741a8$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $189c8bfad96741a8$var$G($189c8bfad96741a8$var$M, e & 1);
    if (null === a) {
        $189c8bfad96741a8$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $189c8bfad96741a8$var$qj(g, d, 0, null), a = $189c8bfad96741a8$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $189c8bfad96741a8$var$oj(c), b.memoizedState = $189c8bfad96741a8$var$nj, a) : $189c8bfad96741a8$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $189c8bfad96741a8$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $189c8bfad96741a8$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $189c8bfad96741a8$var$wh(h, f) : (f = $189c8bfad96741a8$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $189c8bfad96741a8$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $189c8bfad96741a8$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $189c8bfad96741a8$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $189c8bfad96741a8$var$rj(a, b) {
    b = $189c8bfad96741a8$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $189c8bfad96741a8$var$tj(a, b, c, d) {
    null !== d && $189c8bfad96741a8$var$Jg(d);
    $189c8bfad96741a8$var$Bh(b, a.child, null, c);
    a = $189c8bfad96741a8$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $189c8bfad96741a8$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $189c8bfad96741a8$var$Li(Error($189c8bfad96741a8$var$p(422))), $189c8bfad96741a8$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $189c8bfad96741a8$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $189c8bfad96741a8$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $189c8bfad96741a8$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $189c8bfad96741a8$var$oj(g);
        b.memoizedState = $189c8bfad96741a8$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $189c8bfad96741a8$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($189c8bfad96741a8$var$p(419));
        d = $189c8bfad96741a8$var$Li(f, d, void 0);
        return $189c8bfad96741a8$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($189c8bfad96741a8$var$Ug || h) {
        d = $189c8bfad96741a8$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $189c8bfad96741a8$var$Zg(a, e), $189c8bfad96741a8$var$mh(d, a, e, -1));
        }
        $189c8bfad96741a8$var$uj();
        d = $189c8bfad96741a8$var$Li(Error($189c8bfad96741a8$var$p(421)));
        return $189c8bfad96741a8$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $189c8bfad96741a8$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $189c8bfad96741a8$var$yg = $189c8bfad96741a8$var$Lf(e.nextSibling);
    $189c8bfad96741a8$var$xg = b;
    $189c8bfad96741a8$var$I = !0;
    $189c8bfad96741a8$var$zg = null;
    null !== a && ($189c8bfad96741a8$var$og[$189c8bfad96741a8$var$pg++] = $189c8bfad96741a8$var$rg, $189c8bfad96741a8$var$og[$189c8bfad96741a8$var$pg++] = $189c8bfad96741a8$var$sg, $189c8bfad96741a8$var$og[$189c8bfad96741a8$var$pg++] = $189c8bfad96741a8$var$qg, $189c8bfad96741a8$var$rg = a.id, $189c8bfad96741a8$var$sg = a.overflow, $189c8bfad96741a8$var$qg = b);
    b = $189c8bfad96741a8$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $189c8bfad96741a8$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $189c8bfad96741a8$var$Sg(a.return, b, c);
}
function $189c8bfad96741a8$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $189c8bfad96741a8$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $189c8bfad96741a8$var$Yi(a, b, d.children, c);
    d = $189c8bfad96741a8$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $189c8bfad96741a8$var$wj(a, c, b);
            else if (19 === a.tag) $189c8bfad96741a8$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $189c8bfad96741a8$var$G($189c8bfad96741a8$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $189c8bfad96741a8$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $189c8bfad96741a8$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $189c8bfad96741a8$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $189c8bfad96741a8$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $189c8bfad96741a8$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $189c8bfad96741a8$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $189c8bfad96741a8$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $189c8bfad96741a8$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($189c8bfad96741a8$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $189c8bfad96741a8$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $189c8bfad96741a8$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $189c8bfad96741a8$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $189c8bfad96741a8$var$lj(b);
            $189c8bfad96741a8$var$Ig();
            break;
        case 5:
            $189c8bfad96741a8$var$Kh(b);
            break;
        case 1:
            $189c8bfad96741a8$var$Zf(b.type) && $189c8bfad96741a8$var$cg(b);
            break;
        case 4:
            $189c8bfad96741a8$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $189c8bfad96741a8$var$G($189c8bfad96741a8$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $189c8bfad96741a8$var$G($189c8bfad96741a8$var$M, $189c8bfad96741a8$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $189c8bfad96741a8$var$pj(a, b, c);
                $189c8bfad96741a8$var$G($189c8bfad96741a8$var$M, $189c8bfad96741a8$var$M.current & 1);
                a = $189c8bfad96741a8$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $189c8bfad96741a8$var$G($189c8bfad96741a8$var$M, $189c8bfad96741a8$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $189c8bfad96741a8$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $189c8bfad96741a8$var$G($189c8bfad96741a8$var$M, $189c8bfad96741a8$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $189c8bfad96741a8$var$ej(a, b, c);
    }
    return $189c8bfad96741a8$var$$i(a, b, c);
}
var $189c8bfad96741a8$var$Aj, $189c8bfad96741a8$var$Bj, $189c8bfad96741a8$var$Cj, $189c8bfad96741a8$var$Dj;
$189c8bfad96741a8$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$189c8bfad96741a8$var$Bj = function() {};
$189c8bfad96741a8$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $189c8bfad96741a8$var$Hh($189c8bfad96741a8$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $189c8bfad96741a8$var$Ya(a, e);
                d = $189c8bfad96741a8$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $189c8bfad96741a8$var$A({}, e, {
                    value: void 0
                });
                d = $189c8bfad96741a8$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $189c8bfad96741a8$var$gb(a, e);
                d = $189c8bfad96741a8$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $189c8bfad96741a8$var$Bf);
        }
        $189c8bfad96741a8$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($189c8bfad96741a8$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($189c8bfad96741a8$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $189c8bfad96741a8$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$189c8bfad96741a8$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $189c8bfad96741a8$var$Ej(a, b) {
    if (!$189c8bfad96741a8$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $189c8bfad96741a8$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $189c8bfad96741a8$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $189c8bfad96741a8$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $189c8bfad96741a8$var$S(b), null;
        case 1:
            return $189c8bfad96741a8$var$Zf(b.type) && $189c8bfad96741a8$var$$f(), $189c8bfad96741a8$var$S(b), null;
        case 3:
            d = b.stateNode;
            $189c8bfad96741a8$var$Jh();
            $189c8bfad96741a8$var$E($189c8bfad96741a8$var$Wf);
            $189c8bfad96741a8$var$E($189c8bfad96741a8$var$H);
            $189c8bfad96741a8$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $189c8bfad96741a8$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $189c8bfad96741a8$var$zg && ($189c8bfad96741a8$var$Gj($189c8bfad96741a8$var$zg), $189c8bfad96741a8$var$zg = null));
            $189c8bfad96741a8$var$Bj(a, b);
            $189c8bfad96741a8$var$S(b);
            return null;
        case 5:
            $189c8bfad96741a8$var$Lh(b);
            var e = $189c8bfad96741a8$var$Hh($189c8bfad96741a8$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $189c8bfad96741a8$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($189c8bfad96741a8$var$p(166));
                    $189c8bfad96741a8$var$S(b);
                    return null;
                }
                a = $189c8bfad96741a8$var$Hh($189c8bfad96741a8$var$Eh.current);
                if ($189c8bfad96741a8$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$189c8bfad96741a8$var$Of] = b;
                    d[$189c8bfad96741a8$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $189c8bfad96741a8$var$D("cancel", d);
                            $189c8bfad96741a8$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $189c8bfad96741a8$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $189c8bfad96741a8$var$lf.length; e++)$189c8bfad96741a8$var$D($189c8bfad96741a8$var$lf[e], d);
                            break;
                        case "source":
                            $189c8bfad96741a8$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $189c8bfad96741a8$var$D("error", d);
                            $189c8bfad96741a8$var$D("load", d);
                            break;
                        case "details":
                            $189c8bfad96741a8$var$D("toggle", d);
                            break;
                        case "input":
                            $189c8bfad96741a8$var$Za(d, f);
                            $189c8bfad96741a8$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $189c8bfad96741a8$var$D("invalid", d);
                            break;
                        case "textarea":
                            $189c8bfad96741a8$var$hb(d, f), $189c8bfad96741a8$var$D("invalid", d);
                    }
                    $189c8bfad96741a8$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $189c8bfad96741a8$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $189c8bfad96741a8$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $189c8bfad96741a8$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $189c8bfad96741a8$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $189c8bfad96741a8$var$Va(d);
                            $189c8bfad96741a8$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $189c8bfad96741a8$var$Va(d);
                            $189c8bfad96741a8$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $189c8bfad96741a8$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $189c8bfad96741a8$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$189c8bfad96741a8$var$Of] = b;
                    a[$189c8bfad96741a8$var$Pf] = d;
                    $189c8bfad96741a8$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $189c8bfad96741a8$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $189c8bfad96741a8$var$D("cancel", a);
                                $189c8bfad96741a8$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $189c8bfad96741a8$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $189c8bfad96741a8$var$lf.length; e++)$189c8bfad96741a8$var$D($189c8bfad96741a8$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $189c8bfad96741a8$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $189c8bfad96741a8$var$D("error", a);
                                $189c8bfad96741a8$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $189c8bfad96741a8$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $189c8bfad96741a8$var$Za(a, d);
                                e = $189c8bfad96741a8$var$Ya(a, d);
                                $189c8bfad96741a8$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $189c8bfad96741a8$var$A({}, d, {
                                    value: void 0
                                });
                                $189c8bfad96741a8$var$D("invalid", a);
                                break;
                            case "textarea":
                                $189c8bfad96741a8$var$hb(a, d);
                                e = $189c8bfad96741a8$var$gb(a, d);
                                $189c8bfad96741a8$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $189c8bfad96741a8$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $189c8bfad96741a8$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $189c8bfad96741a8$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $189c8bfad96741a8$var$ob(a, k) : "number" === typeof k && $189c8bfad96741a8$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($189c8bfad96741a8$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $189c8bfad96741a8$var$D("scroll", a) : null != k && $189c8bfad96741a8$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $189c8bfad96741a8$var$Va(a);
                                $189c8bfad96741a8$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $189c8bfad96741a8$var$Va(a);
                                $189c8bfad96741a8$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $189c8bfad96741a8$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $189c8bfad96741a8$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $189c8bfad96741a8$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $189c8bfad96741a8$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $189c8bfad96741a8$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $189c8bfad96741a8$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($189c8bfad96741a8$var$p(166));
                c = $189c8bfad96741a8$var$Hh($189c8bfad96741a8$var$Gh.current);
                $189c8bfad96741a8$var$Hh($189c8bfad96741a8$var$Eh.current);
                if ($189c8bfad96741a8$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$189c8bfad96741a8$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $189c8bfad96741a8$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $189c8bfad96741a8$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $189c8bfad96741a8$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$189c8bfad96741a8$var$Of] = b, b.stateNode = d;
            }
            $189c8bfad96741a8$var$S(b);
            return null;
        case 13:
            $189c8bfad96741a8$var$E($189c8bfad96741a8$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($189c8bfad96741a8$var$I && null !== $189c8bfad96741a8$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $189c8bfad96741a8$var$Hg(), $189c8bfad96741a8$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $189c8bfad96741a8$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($189c8bfad96741a8$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($189c8bfad96741a8$var$p(317));
                        f[$189c8bfad96741a8$var$Of] = b;
                    } else $189c8bfad96741a8$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $189c8bfad96741a8$var$S(b);
                    f = !1;
                } else null !== $189c8bfad96741a8$var$zg && ($189c8bfad96741a8$var$Gj($189c8bfad96741a8$var$zg), $189c8bfad96741a8$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($189c8bfad96741a8$var$M.current & 1) ? 0 === $189c8bfad96741a8$var$T && ($189c8bfad96741a8$var$T = 3) : $189c8bfad96741a8$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $189c8bfad96741a8$var$S(b);
            return null;
        case 4:
            return $189c8bfad96741a8$var$Jh(), $189c8bfad96741a8$var$Bj(a, b), null === a && $189c8bfad96741a8$var$sf(b.stateNode.containerInfo), $189c8bfad96741a8$var$S(b), null;
        case 10:
            return $189c8bfad96741a8$var$Rg(b.type._context), $189c8bfad96741a8$var$S(b), null;
        case 17:
            return $189c8bfad96741a8$var$Zf(b.type) && $189c8bfad96741a8$var$$f(), $189c8bfad96741a8$var$S(b), null;
        case 19:
            $189c8bfad96741a8$var$E($189c8bfad96741a8$var$M);
            f = b.memoizedState;
            if (null === f) return $189c8bfad96741a8$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $189c8bfad96741a8$var$Ej(f, !1);
                else {
                    if (0 !== $189c8bfad96741a8$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $189c8bfad96741a8$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $189c8bfad96741a8$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $189c8bfad96741a8$var$G($189c8bfad96741a8$var$M, $189c8bfad96741a8$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $189c8bfad96741a8$var$B() > $189c8bfad96741a8$var$Hj && (b.flags |= 128, d = !0, $189c8bfad96741a8$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $189c8bfad96741a8$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $189c8bfad96741a8$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$189c8bfad96741a8$var$I) return $189c8bfad96741a8$var$S(b), null;
                    } else 2 * $189c8bfad96741a8$var$B() - f.renderingStartTime > $189c8bfad96741a8$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $189c8bfad96741a8$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $189c8bfad96741a8$var$B(), b.sibling = null, c = $189c8bfad96741a8$var$M.current, $189c8bfad96741a8$var$G($189c8bfad96741a8$var$M, d ? c & 1 | 2 : c & 1), b;
            $189c8bfad96741a8$var$S(b);
            return null;
        case 22:
        case 23:
            return $189c8bfad96741a8$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($189c8bfad96741a8$var$gj & 1073741824) && ($189c8bfad96741a8$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $189c8bfad96741a8$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($189c8bfad96741a8$var$p(156, b.tag));
}
function $189c8bfad96741a8$var$Jj(a, b) {
    $189c8bfad96741a8$var$wg(b);
    switch(b.tag){
        case 1:
            return $189c8bfad96741a8$var$Zf(b.type) && $189c8bfad96741a8$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $189c8bfad96741a8$var$Jh(), $189c8bfad96741a8$var$E($189c8bfad96741a8$var$Wf), $189c8bfad96741a8$var$E($189c8bfad96741a8$var$H), $189c8bfad96741a8$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $189c8bfad96741a8$var$Lh(b), null;
        case 13:
            $189c8bfad96741a8$var$E($189c8bfad96741a8$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($189c8bfad96741a8$var$p(340));
                $189c8bfad96741a8$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $189c8bfad96741a8$var$E($189c8bfad96741a8$var$M), null;
        case 4:
            return $189c8bfad96741a8$var$Jh(), null;
        case 10:
            return $189c8bfad96741a8$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $189c8bfad96741a8$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $189c8bfad96741a8$var$Kj = !1, $189c8bfad96741a8$var$U = !1, $189c8bfad96741a8$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $189c8bfad96741a8$var$V = null;
function $189c8bfad96741a8$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $189c8bfad96741a8$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $189c8bfad96741a8$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $189c8bfad96741a8$var$W(a, b, d);
    }
}
var $189c8bfad96741a8$var$Oj = !1;
function $189c8bfad96741a8$var$Pj(a, b) {
    $189c8bfad96741a8$var$Cf = $189c8bfad96741a8$var$dd;
    a = $189c8bfad96741a8$var$Me();
    if ($189c8bfad96741a8$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $189c8bfad96741a8$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $189c8bfad96741a8$var$dd = !1;
    for($189c8bfad96741a8$var$V = b; null !== $189c8bfad96741a8$var$V;)if (b = $189c8bfad96741a8$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $189c8bfad96741a8$var$V = a;
    else for(; null !== $189c8bfad96741a8$var$V;){
        b = $189c8bfad96741a8$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $189c8bfad96741a8$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($189c8bfad96741a8$var$p(163));
            }
        } catch (F) {
            $189c8bfad96741a8$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $189c8bfad96741a8$var$V = a;
            break;
        }
        $189c8bfad96741a8$var$V = b.return;
    }
    n = $189c8bfad96741a8$var$Oj;
    $189c8bfad96741a8$var$Oj = !1;
    return n;
}
function $189c8bfad96741a8$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $189c8bfad96741a8$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $189c8bfad96741a8$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $189c8bfad96741a8$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $189c8bfad96741a8$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $189c8bfad96741a8$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$189c8bfad96741a8$var$Of], delete b[$189c8bfad96741a8$var$Pf], delete b[$189c8bfad96741a8$var$of], delete b[$189c8bfad96741a8$var$Qf], delete b[$189c8bfad96741a8$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $189c8bfad96741a8$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $189c8bfad96741a8$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $189c8bfad96741a8$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $189c8bfad96741a8$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $189c8bfad96741a8$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($189c8bfad96741a8$var$Wj(a, b, c), a = a.sibling; null !== a;)$189c8bfad96741a8$var$Wj(a, b, c), a = a.sibling;
}
function $189c8bfad96741a8$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($189c8bfad96741a8$var$Xj(a, b, c), a = a.sibling; null !== a;)$189c8bfad96741a8$var$Xj(a, b, c), a = a.sibling;
}
var $189c8bfad96741a8$var$X = null, $189c8bfad96741a8$var$Yj = !1;
function $189c8bfad96741a8$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$189c8bfad96741a8$var$ak(a, b, c), c = c.sibling;
}
function $189c8bfad96741a8$var$ak(a, b, c) {
    if ($189c8bfad96741a8$var$lc && "function" === typeof $189c8bfad96741a8$var$lc.onCommitFiberUnmount) try {
        $189c8bfad96741a8$var$lc.onCommitFiberUnmount($189c8bfad96741a8$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $189c8bfad96741a8$var$U || $189c8bfad96741a8$var$Mj(c, b);
        case 6:
            var d = $189c8bfad96741a8$var$X, e = $189c8bfad96741a8$var$Yj;
            $189c8bfad96741a8$var$X = null;
            $189c8bfad96741a8$var$Zj(a, b, c);
            $189c8bfad96741a8$var$X = d;
            $189c8bfad96741a8$var$Yj = e;
            null !== $189c8bfad96741a8$var$X && ($189c8bfad96741a8$var$Yj ? (a = $189c8bfad96741a8$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $189c8bfad96741a8$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $189c8bfad96741a8$var$X && ($189c8bfad96741a8$var$Yj ? (a = $189c8bfad96741a8$var$X, c = c.stateNode, 8 === a.nodeType ? $189c8bfad96741a8$var$Kf(a.parentNode, c) : 1 === a.nodeType && $189c8bfad96741a8$var$Kf(a, c), $189c8bfad96741a8$var$bd(a)) : $189c8bfad96741a8$var$Kf($189c8bfad96741a8$var$X, c.stateNode));
            break;
        case 4:
            d = $189c8bfad96741a8$var$X;
            e = $189c8bfad96741a8$var$Yj;
            $189c8bfad96741a8$var$X = c.stateNode.containerInfo;
            $189c8bfad96741a8$var$Yj = !0;
            $189c8bfad96741a8$var$Zj(a, b, c);
            $189c8bfad96741a8$var$X = d;
            $189c8bfad96741a8$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$189c8bfad96741a8$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $189c8bfad96741a8$var$Nj(c, b, g) : 0 !== (f & 4) && $189c8bfad96741a8$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $189c8bfad96741a8$var$Zj(a, b, c);
            break;
        case 1:
            if (!$189c8bfad96741a8$var$U && ($189c8bfad96741a8$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $189c8bfad96741a8$var$W(c, b, h);
            }
            $189c8bfad96741a8$var$Zj(a, b, c);
            break;
        case 21:
            $189c8bfad96741a8$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($189c8bfad96741a8$var$U = (d = $189c8bfad96741a8$var$U) || null !== c.memoizedState, $189c8bfad96741a8$var$Zj(a, b, c), $189c8bfad96741a8$var$U = d) : $189c8bfad96741a8$var$Zj(a, b, c);
            break;
        default:
            $189c8bfad96741a8$var$Zj(a, b, c);
    }
}
function $189c8bfad96741a8$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $189c8bfad96741a8$var$Lj);
        b.forEach(function(b) {
            var d = $189c8bfad96741a8$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $189c8bfad96741a8$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $189c8bfad96741a8$var$X = h.stateNode;
                        $189c8bfad96741a8$var$Yj = !1;
                        break a;
                    case 3:
                        $189c8bfad96741a8$var$X = h.stateNode.containerInfo;
                        $189c8bfad96741a8$var$Yj = !0;
                        break a;
                    case 4:
                        $189c8bfad96741a8$var$X = h.stateNode.containerInfo;
                        $189c8bfad96741a8$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $189c8bfad96741a8$var$X) throw Error($189c8bfad96741a8$var$p(160));
            $189c8bfad96741a8$var$ak(f, g, e);
            $189c8bfad96741a8$var$X = null;
            $189c8bfad96741a8$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $189c8bfad96741a8$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$189c8bfad96741a8$var$ek(b, a), b = b.sibling;
}
function $189c8bfad96741a8$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $189c8bfad96741a8$var$dk(b, a);
            $189c8bfad96741a8$var$fk(a);
            if (d & 4) {
                try {
                    $189c8bfad96741a8$var$Qj(3, a, a.return), $189c8bfad96741a8$var$Rj(3, a);
                } catch (t) {
                    $189c8bfad96741a8$var$W(a, a.return, t);
                }
                try {
                    $189c8bfad96741a8$var$Qj(5, a, a.return);
                } catch (t) {
                    $189c8bfad96741a8$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $189c8bfad96741a8$var$dk(b, a);
            $189c8bfad96741a8$var$fk(a);
            d & 512 && null !== c && $189c8bfad96741a8$var$Mj(c, c.return);
            break;
        case 5:
            $189c8bfad96741a8$var$dk(b, a);
            $189c8bfad96741a8$var$fk(a);
            d & 512 && null !== c && $189c8bfad96741a8$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $189c8bfad96741a8$var$ob(e, "");
                } catch (t) {
                    $189c8bfad96741a8$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $189c8bfad96741a8$var$ab(e, f);
                    $189c8bfad96741a8$var$vb(h, g);
                    var l = $189c8bfad96741a8$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $189c8bfad96741a8$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $189c8bfad96741a8$var$nb(e, q) : "children" === m ? $189c8bfad96741a8$var$ob(e, q) : $189c8bfad96741a8$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $189c8bfad96741a8$var$bb(e, f);
                            break;
                        case "textarea":
                            $189c8bfad96741a8$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $189c8bfad96741a8$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $189c8bfad96741a8$var$fb(e, !!f.multiple, f.defaultValue, !0) : $189c8bfad96741a8$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$189c8bfad96741a8$var$Pf] = f;
                } catch (t) {
                    $189c8bfad96741a8$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $189c8bfad96741a8$var$dk(b, a);
            $189c8bfad96741a8$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($189c8bfad96741a8$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $189c8bfad96741a8$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $189c8bfad96741a8$var$dk(b, a);
            $189c8bfad96741a8$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $189c8bfad96741a8$var$bd(b.containerInfo);
            } catch (t) {
                $189c8bfad96741a8$var$W(a, a.return, t);
            }
            break;
        case 4:
            $189c8bfad96741a8$var$dk(b, a);
            $189c8bfad96741a8$var$fk(a);
            break;
        case 13:
            $189c8bfad96741a8$var$dk(b, a);
            $189c8bfad96741a8$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($189c8bfad96741a8$var$gk = $189c8bfad96741a8$var$B()));
            d & 4 && $189c8bfad96741a8$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($189c8bfad96741a8$var$U = (l = $189c8bfad96741a8$var$U) || m, $189c8bfad96741a8$var$dk(b, a), $189c8bfad96741a8$var$U = l) : $189c8bfad96741a8$var$dk(b, a);
            $189c8bfad96741a8$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($189c8bfad96741a8$var$V = a, m = a.child; null !== m;){
                    for(q = $189c8bfad96741a8$var$V = m; null !== $189c8bfad96741a8$var$V;){
                        r = $189c8bfad96741a8$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $189c8bfad96741a8$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $189c8bfad96741a8$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $189c8bfad96741a8$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $189c8bfad96741a8$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $189c8bfad96741a8$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $189c8bfad96741a8$var$V = y) : $189c8bfad96741a8$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $189c8bfad96741a8$var$rb("display", g));
                            } catch (t) {
                                $189c8bfad96741a8$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $189c8bfad96741a8$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $189c8bfad96741a8$var$dk(b, a);
            $189c8bfad96741a8$var$fk(a);
            d & 4 && $189c8bfad96741a8$var$bk(a);
            break;
        case 21:
            break;
        default:
            $189c8bfad96741a8$var$dk(b, a), $189c8bfad96741a8$var$fk(a);
    }
}
function $189c8bfad96741a8$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($189c8bfad96741a8$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($189c8bfad96741a8$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($189c8bfad96741a8$var$ob(e, ""), d.flags &= -33);
                    var f = $189c8bfad96741a8$var$Vj(a);
                    $189c8bfad96741a8$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $189c8bfad96741a8$var$Vj(a);
                    $189c8bfad96741a8$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($189c8bfad96741a8$var$p(161));
            }
        } catch (k) {
            $189c8bfad96741a8$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $189c8bfad96741a8$var$ik(a, b, c) {
    $189c8bfad96741a8$var$V = a;
    $189c8bfad96741a8$var$jk(a, b, c);
}
function $189c8bfad96741a8$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $189c8bfad96741a8$var$V;){
        var e = $189c8bfad96741a8$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $189c8bfad96741a8$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $189c8bfad96741a8$var$U;
                h = $189c8bfad96741a8$var$Kj;
                var l = $189c8bfad96741a8$var$U;
                $189c8bfad96741a8$var$Kj = g;
                if (($189c8bfad96741a8$var$U = k) && !l) for($189c8bfad96741a8$var$V = e; null !== $189c8bfad96741a8$var$V;)g = $189c8bfad96741a8$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $189c8bfad96741a8$var$kk(e) : null !== k ? (k.return = g, $189c8bfad96741a8$var$V = k) : $189c8bfad96741a8$var$kk(e);
                for(; null !== f;)$189c8bfad96741a8$var$V = f, $189c8bfad96741a8$var$jk(f, b, c), f = f.sibling;
                $189c8bfad96741a8$var$V = e;
                $189c8bfad96741a8$var$Kj = h;
                $189c8bfad96741a8$var$U = l;
            }
            $189c8bfad96741a8$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $189c8bfad96741a8$var$V = f) : $189c8bfad96741a8$var$lk(a, b, c);
    }
}
function $189c8bfad96741a8$var$lk(a) {
    for(; null !== $189c8bfad96741a8$var$V;){
        var b = $189c8bfad96741a8$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $189c8bfad96741a8$var$U || $189c8bfad96741a8$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$189c8bfad96741a8$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $189c8bfad96741a8$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $189c8bfad96741a8$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $189c8bfad96741a8$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $189c8bfad96741a8$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($189c8bfad96741a8$var$p(163));
                }
                $189c8bfad96741a8$var$U || b.flags & 512 && $189c8bfad96741a8$var$Sj(b);
            } catch (r) {
                $189c8bfad96741a8$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $189c8bfad96741a8$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $189c8bfad96741a8$var$V = c;
            break;
        }
        $189c8bfad96741a8$var$V = b.return;
    }
}
function $189c8bfad96741a8$var$hk(a) {
    for(; null !== $189c8bfad96741a8$var$V;){
        var b = $189c8bfad96741a8$var$V;
        if (b === a) {
            $189c8bfad96741a8$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $189c8bfad96741a8$var$V = c;
            break;
        }
        $189c8bfad96741a8$var$V = b.return;
    }
}
function $189c8bfad96741a8$var$kk(a) {
    for(; null !== $189c8bfad96741a8$var$V;){
        var b = $189c8bfad96741a8$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $189c8bfad96741a8$var$Rj(4, b);
                    } catch (k) {
                        $189c8bfad96741a8$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $189c8bfad96741a8$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $189c8bfad96741a8$var$Sj(b);
                    } catch (k) {
                        $189c8bfad96741a8$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $189c8bfad96741a8$var$Sj(b);
                    } catch (k) {
                        $189c8bfad96741a8$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $189c8bfad96741a8$var$W(b, b.return, k);
        }
        if (b === a) {
            $189c8bfad96741a8$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $189c8bfad96741a8$var$V = h;
            break;
        }
        $189c8bfad96741a8$var$V = b.return;
    }
}
var $189c8bfad96741a8$var$mk = Math.ceil, $189c8bfad96741a8$var$nk = $189c8bfad96741a8$var$ua.ReactCurrentDispatcher, $189c8bfad96741a8$var$ok = $189c8bfad96741a8$var$ua.ReactCurrentOwner, $189c8bfad96741a8$var$pk = $189c8bfad96741a8$var$ua.ReactCurrentBatchConfig, $189c8bfad96741a8$var$K = 0, $189c8bfad96741a8$var$R = null, $189c8bfad96741a8$var$Y = null, $189c8bfad96741a8$var$Z = 0, $189c8bfad96741a8$var$gj = 0, $189c8bfad96741a8$var$fj = $189c8bfad96741a8$var$Uf(0), $189c8bfad96741a8$var$T = 0, $189c8bfad96741a8$var$qk = null, $189c8bfad96741a8$var$hh = 0, $189c8bfad96741a8$var$rk = 0, $189c8bfad96741a8$var$sk = 0, $189c8bfad96741a8$var$tk = null, $189c8bfad96741a8$var$uk = null, $189c8bfad96741a8$var$gk = 0, $189c8bfad96741a8$var$Hj = Infinity, $189c8bfad96741a8$var$vk = null, $189c8bfad96741a8$var$Pi = !1, $189c8bfad96741a8$var$Qi = null, $189c8bfad96741a8$var$Si = null, $189c8bfad96741a8$var$wk = !1, $189c8bfad96741a8$var$xk = null, $189c8bfad96741a8$var$yk = 0, $189c8bfad96741a8$var$zk = 0, $189c8bfad96741a8$var$Ak = null, $189c8bfad96741a8$var$Bk = -1, $189c8bfad96741a8$var$Ck = 0;
function $189c8bfad96741a8$var$L() {
    return 0 !== ($189c8bfad96741a8$var$K & 6) ? $189c8bfad96741a8$var$B() : -1 !== $189c8bfad96741a8$var$Bk ? $189c8bfad96741a8$var$Bk : $189c8bfad96741a8$var$Bk = $189c8bfad96741a8$var$B();
}
function $189c8bfad96741a8$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($189c8bfad96741a8$var$K & 2) && 0 !== $189c8bfad96741a8$var$Z) return $189c8bfad96741a8$var$Z & -$189c8bfad96741a8$var$Z;
    if (null !== $189c8bfad96741a8$var$Kg.transition) return 0 === $189c8bfad96741a8$var$Ck && ($189c8bfad96741a8$var$Ck = $189c8bfad96741a8$var$yc()), $189c8bfad96741a8$var$Ck;
    a = $189c8bfad96741a8$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $189c8bfad96741a8$var$jd(a.type);
    return a;
}
function $189c8bfad96741a8$var$mh(a, b, c, d) {
    if (50 < $189c8bfad96741a8$var$zk) throw $189c8bfad96741a8$var$zk = 0, $189c8bfad96741a8$var$Ak = null, Error($189c8bfad96741a8$var$p(185));
    $189c8bfad96741a8$var$Ac(a, c, d);
    if (0 === ($189c8bfad96741a8$var$K & 2) || a !== $189c8bfad96741a8$var$R) a === $189c8bfad96741a8$var$R && (0 === ($189c8bfad96741a8$var$K & 2) && ($189c8bfad96741a8$var$rk |= c), 4 === $189c8bfad96741a8$var$T && $189c8bfad96741a8$var$Dk(a, $189c8bfad96741a8$var$Z)), $189c8bfad96741a8$var$Ek(a, d), 1 === c && 0 === $189c8bfad96741a8$var$K && 0 === (b.mode & 1) && ($189c8bfad96741a8$var$Hj = $189c8bfad96741a8$var$B() + 500, $189c8bfad96741a8$var$fg && $189c8bfad96741a8$var$jg());
}
function $189c8bfad96741a8$var$Ek(a, b) {
    var c = a.callbackNode;
    $189c8bfad96741a8$var$wc(a, b);
    var d = $189c8bfad96741a8$var$uc(a, a === $189c8bfad96741a8$var$R ? $189c8bfad96741a8$var$Z : 0);
    if (0 === d) null !== c && $189c8bfad96741a8$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $189c8bfad96741a8$var$bc(c);
        if (1 === b) 0 === a.tag ? $189c8bfad96741a8$var$ig($189c8bfad96741a8$var$Fk.bind(null, a)) : $189c8bfad96741a8$var$hg($189c8bfad96741a8$var$Fk.bind(null, a)), $189c8bfad96741a8$var$Jf(function() {
            0 === ($189c8bfad96741a8$var$K & 6) && $189c8bfad96741a8$var$jg();
        }), c = null;
        else {
            switch($189c8bfad96741a8$var$Dc(d)){
                case 1:
                    c = $189c8bfad96741a8$var$fc;
                    break;
                case 4:
                    c = $189c8bfad96741a8$var$gc;
                    break;
                case 16:
                    c = $189c8bfad96741a8$var$hc;
                    break;
                case 536870912:
                    c = $189c8bfad96741a8$var$jc;
                    break;
                default:
                    c = $189c8bfad96741a8$var$hc;
            }
            c = $189c8bfad96741a8$var$Gk(c, $189c8bfad96741a8$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $189c8bfad96741a8$var$Hk(a, b) {
    $189c8bfad96741a8$var$Bk = -1;
    $189c8bfad96741a8$var$Ck = 0;
    if (0 !== ($189c8bfad96741a8$var$K & 6)) throw Error($189c8bfad96741a8$var$p(327));
    var c = a.callbackNode;
    if ($189c8bfad96741a8$var$Ik() && a.callbackNode !== c) return null;
    var d = $189c8bfad96741a8$var$uc(a, a === $189c8bfad96741a8$var$R ? $189c8bfad96741a8$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $189c8bfad96741a8$var$Jk(a, d);
    else {
        b = d;
        var e = $189c8bfad96741a8$var$K;
        $189c8bfad96741a8$var$K |= 2;
        var f = $189c8bfad96741a8$var$Kk();
        if ($189c8bfad96741a8$var$R !== a || $189c8bfad96741a8$var$Z !== b) $189c8bfad96741a8$var$vk = null, $189c8bfad96741a8$var$Hj = $189c8bfad96741a8$var$B() + 500, $189c8bfad96741a8$var$Lk(a, b);
        for(;;)try {
            $189c8bfad96741a8$var$Mk();
            break;
        } catch (h) {
            $189c8bfad96741a8$var$Nk(a, h);
        }
        $189c8bfad96741a8$var$Qg();
        $189c8bfad96741a8$var$nk.current = f;
        $189c8bfad96741a8$var$K = e;
        null !== $189c8bfad96741a8$var$Y ? b = 0 : ($189c8bfad96741a8$var$R = null, $189c8bfad96741a8$var$Z = 0, b = $189c8bfad96741a8$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $189c8bfad96741a8$var$xc(a), 0 !== e && (d = e, b = $189c8bfad96741a8$var$Ok(a, e)));
        if (1 === b) throw c = $189c8bfad96741a8$var$qk, $189c8bfad96741a8$var$Lk(a, 0), $189c8bfad96741a8$var$Dk(a, d), $189c8bfad96741a8$var$Ek(a, $189c8bfad96741a8$var$B()), c;
        if (6 === b) $189c8bfad96741a8$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$189c8bfad96741a8$var$Pk(e) && (b = $189c8bfad96741a8$var$Jk(a, d), 2 === b && (f = $189c8bfad96741a8$var$xc(a), 0 !== f && (d = f, b = $189c8bfad96741a8$var$Ok(a, f))), 1 === b)) throw c = $189c8bfad96741a8$var$qk, $189c8bfad96741a8$var$Lk(a, 0), $189c8bfad96741a8$var$Dk(a, d), $189c8bfad96741a8$var$Ek(a, $189c8bfad96741a8$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($189c8bfad96741a8$var$p(345));
                case 2:
                    $189c8bfad96741a8$var$Qk(a, $189c8bfad96741a8$var$uk, $189c8bfad96741a8$var$vk);
                    break;
                case 3:
                    $189c8bfad96741a8$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $189c8bfad96741a8$var$gk + 500 - $189c8bfad96741a8$var$B(), 10 < b)) {
                        if (0 !== $189c8bfad96741a8$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $189c8bfad96741a8$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $189c8bfad96741a8$var$Ff($189c8bfad96741a8$var$Qk.bind(null, a, $189c8bfad96741a8$var$uk, $189c8bfad96741a8$var$vk), b);
                        break;
                    }
                    $189c8bfad96741a8$var$Qk(a, $189c8bfad96741a8$var$uk, $189c8bfad96741a8$var$vk);
                    break;
                case 4:
                    $189c8bfad96741a8$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $189c8bfad96741a8$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $189c8bfad96741a8$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $189c8bfad96741a8$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $189c8bfad96741a8$var$Ff($189c8bfad96741a8$var$Qk.bind(null, a, $189c8bfad96741a8$var$uk, $189c8bfad96741a8$var$vk), d);
                        break;
                    }
                    $189c8bfad96741a8$var$Qk(a, $189c8bfad96741a8$var$uk, $189c8bfad96741a8$var$vk);
                    break;
                case 5:
                    $189c8bfad96741a8$var$Qk(a, $189c8bfad96741a8$var$uk, $189c8bfad96741a8$var$vk);
                    break;
                default:
                    throw Error($189c8bfad96741a8$var$p(329));
            }
        }
    }
    $189c8bfad96741a8$var$Ek(a, $189c8bfad96741a8$var$B());
    return a.callbackNode === c ? $189c8bfad96741a8$var$Hk.bind(null, a) : null;
}
function $189c8bfad96741a8$var$Ok(a, b) {
    var c = $189c8bfad96741a8$var$tk;
    a.current.memoizedState.isDehydrated && ($189c8bfad96741a8$var$Lk(a, b).flags |= 256);
    a = $189c8bfad96741a8$var$Jk(a, b);
    2 !== a && (b = $189c8bfad96741a8$var$uk, $189c8bfad96741a8$var$uk = c, null !== b && $189c8bfad96741a8$var$Gj(b));
    return a;
}
function $189c8bfad96741a8$var$Gj(a) {
    null === $189c8bfad96741a8$var$uk ? $189c8bfad96741a8$var$uk = a : $189c8bfad96741a8$var$uk.push.apply($189c8bfad96741a8$var$uk, a);
}
function $189c8bfad96741a8$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$189c8bfad96741a8$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $189c8bfad96741a8$var$Dk(a, b) {
    b &= ~$189c8bfad96741a8$var$sk;
    b &= ~$189c8bfad96741a8$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $189c8bfad96741a8$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $189c8bfad96741a8$var$Fk(a) {
    if (0 !== ($189c8bfad96741a8$var$K & 6)) throw Error($189c8bfad96741a8$var$p(327));
    $189c8bfad96741a8$var$Ik();
    var b = $189c8bfad96741a8$var$uc(a, 0);
    if (0 === (b & 1)) return $189c8bfad96741a8$var$Ek(a, $189c8bfad96741a8$var$B()), null;
    var c = $189c8bfad96741a8$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $189c8bfad96741a8$var$xc(a);
        0 !== d && (b = d, c = $189c8bfad96741a8$var$Ok(a, d));
    }
    if (1 === c) throw c = $189c8bfad96741a8$var$qk, $189c8bfad96741a8$var$Lk(a, 0), $189c8bfad96741a8$var$Dk(a, b), $189c8bfad96741a8$var$Ek(a, $189c8bfad96741a8$var$B()), c;
    if (6 === c) throw Error($189c8bfad96741a8$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $189c8bfad96741a8$var$Qk(a, $189c8bfad96741a8$var$uk, $189c8bfad96741a8$var$vk);
    $189c8bfad96741a8$var$Ek(a, $189c8bfad96741a8$var$B());
    return null;
}
function $189c8bfad96741a8$var$Rk(a, b) {
    var c = $189c8bfad96741a8$var$K;
    $189c8bfad96741a8$var$K |= 1;
    try {
        return a(b);
    } finally{
        $189c8bfad96741a8$var$K = c, 0 === $189c8bfad96741a8$var$K && ($189c8bfad96741a8$var$Hj = $189c8bfad96741a8$var$B() + 500, $189c8bfad96741a8$var$fg && $189c8bfad96741a8$var$jg());
    }
}
function $189c8bfad96741a8$var$Sk(a) {
    null !== $189c8bfad96741a8$var$xk && 0 === $189c8bfad96741a8$var$xk.tag && 0 === ($189c8bfad96741a8$var$K & 6) && $189c8bfad96741a8$var$Ik();
    var b = $189c8bfad96741a8$var$K;
    $189c8bfad96741a8$var$K |= 1;
    var c = $189c8bfad96741a8$var$pk.transition, d = $189c8bfad96741a8$var$C;
    try {
        if ($189c8bfad96741a8$var$pk.transition = null, $189c8bfad96741a8$var$C = 1, a) return a();
    } finally{
        $189c8bfad96741a8$var$C = d, $189c8bfad96741a8$var$pk.transition = c, $189c8bfad96741a8$var$K = b, 0 === ($189c8bfad96741a8$var$K & 6) && $189c8bfad96741a8$var$jg();
    }
}
function $189c8bfad96741a8$var$Ij() {
    $189c8bfad96741a8$var$gj = $189c8bfad96741a8$var$fj.current;
    $189c8bfad96741a8$var$E($189c8bfad96741a8$var$fj);
}
function $189c8bfad96741a8$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $189c8bfad96741a8$var$Gf(c));
    if (null !== $189c8bfad96741a8$var$Y) for(c = $189c8bfad96741a8$var$Y.return; null !== c;){
        var d = c;
        $189c8bfad96741a8$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $189c8bfad96741a8$var$$f();
                break;
            case 3:
                $189c8bfad96741a8$var$Jh();
                $189c8bfad96741a8$var$E($189c8bfad96741a8$var$Wf);
                $189c8bfad96741a8$var$E($189c8bfad96741a8$var$H);
                $189c8bfad96741a8$var$Oh();
                break;
            case 5:
                $189c8bfad96741a8$var$Lh(d);
                break;
            case 4:
                $189c8bfad96741a8$var$Jh();
                break;
            case 13:
                $189c8bfad96741a8$var$E($189c8bfad96741a8$var$M);
                break;
            case 19:
                $189c8bfad96741a8$var$E($189c8bfad96741a8$var$M);
                break;
            case 10:
                $189c8bfad96741a8$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $189c8bfad96741a8$var$Ij();
        }
        c = c.return;
    }
    $189c8bfad96741a8$var$R = a;
    $189c8bfad96741a8$var$Y = a = $189c8bfad96741a8$var$wh(a.current, null);
    $189c8bfad96741a8$var$Z = $189c8bfad96741a8$var$gj = b;
    $189c8bfad96741a8$var$T = 0;
    $189c8bfad96741a8$var$qk = null;
    $189c8bfad96741a8$var$sk = $189c8bfad96741a8$var$rk = $189c8bfad96741a8$var$hh = 0;
    $189c8bfad96741a8$var$uk = $189c8bfad96741a8$var$tk = null;
    if (null !== $189c8bfad96741a8$var$Wg) {
        for(b = 0; b < $189c8bfad96741a8$var$Wg.length; b++)if (c = $189c8bfad96741a8$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $189c8bfad96741a8$var$Wg = null;
    }
    return a;
}
function $189c8bfad96741a8$var$Nk(a, b) {
    do {
        var c = $189c8bfad96741a8$var$Y;
        try {
            $189c8bfad96741a8$var$Qg();
            $189c8bfad96741a8$var$Ph.current = $189c8bfad96741a8$var$ai;
            if ($189c8bfad96741a8$var$Sh) {
                for(var d = $189c8bfad96741a8$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $189c8bfad96741a8$var$Sh = !1;
            }
            $189c8bfad96741a8$var$Rh = 0;
            $189c8bfad96741a8$var$P = $189c8bfad96741a8$var$O = $189c8bfad96741a8$var$N = null;
            $189c8bfad96741a8$var$Th = !1;
            $189c8bfad96741a8$var$Uh = 0;
            $189c8bfad96741a8$var$ok.current = null;
            if (null === c || null === c.return) {
                $189c8bfad96741a8$var$T = 1;
                $189c8bfad96741a8$var$qk = b;
                $189c8bfad96741a8$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $189c8bfad96741a8$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $189c8bfad96741a8$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $189c8bfad96741a8$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $189c8bfad96741a8$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $189c8bfad96741a8$var$Ti(f, l, b);
                            $189c8bfad96741a8$var$uj();
                            break a;
                        }
                        k = Error($189c8bfad96741a8$var$p(426));
                    }
                } else if ($189c8bfad96741a8$var$I && h.mode & 1) {
                    var J = $189c8bfad96741a8$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $189c8bfad96741a8$var$Wi(J, g, h, f, b);
                        $189c8bfad96741a8$var$Jg($189c8bfad96741a8$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $189c8bfad96741a8$var$Ki(k, h);
                4 !== $189c8bfad96741a8$var$T && ($189c8bfad96741a8$var$T = 2);
                null === $189c8bfad96741a8$var$tk ? $189c8bfad96741a8$var$tk = [
                    f
                ] : $189c8bfad96741a8$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $189c8bfad96741a8$var$Oi(f, k, b);
                            $189c8bfad96741a8$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $189c8bfad96741a8$var$Si || !$189c8bfad96741a8$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $189c8bfad96741a8$var$Ri(f, h, b);
                                $189c8bfad96741a8$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $189c8bfad96741a8$var$Tk(c);
        } catch (na) {
            b = na;
            $189c8bfad96741a8$var$Y === c && null !== c && ($189c8bfad96741a8$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $189c8bfad96741a8$var$Kk() {
    var a = $189c8bfad96741a8$var$nk.current;
    $189c8bfad96741a8$var$nk.current = $189c8bfad96741a8$var$ai;
    return null === a ? $189c8bfad96741a8$var$ai : a;
}
function $189c8bfad96741a8$var$uj() {
    if (0 === $189c8bfad96741a8$var$T || 3 === $189c8bfad96741a8$var$T || 2 === $189c8bfad96741a8$var$T) $189c8bfad96741a8$var$T = 4;
    null === $189c8bfad96741a8$var$R || 0 === ($189c8bfad96741a8$var$hh & 268435455) && 0 === ($189c8bfad96741a8$var$rk & 268435455) || $189c8bfad96741a8$var$Dk($189c8bfad96741a8$var$R, $189c8bfad96741a8$var$Z);
}
function $189c8bfad96741a8$var$Jk(a, b) {
    var c = $189c8bfad96741a8$var$K;
    $189c8bfad96741a8$var$K |= 2;
    var d = $189c8bfad96741a8$var$Kk();
    if ($189c8bfad96741a8$var$R !== a || $189c8bfad96741a8$var$Z !== b) $189c8bfad96741a8$var$vk = null, $189c8bfad96741a8$var$Lk(a, b);
    for(;;)try {
        $189c8bfad96741a8$var$Uk();
        break;
    } catch (e) {
        $189c8bfad96741a8$var$Nk(a, e);
    }
    $189c8bfad96741a8$var$Qg();
    $189c8bfad96741a8$var$K = c;
    $189c8bfad96741a8$var$nk.current = d;
    if (null !== $189c8bfad96741a8$var$Y) throw Error($189c8bfad96741a8$var$p(261));
    $189c8bfad96741a8$var$R = null;
    $189c8bfad96741a8$var$Z = 0;
    return $189c8bfad96741a8$var$T;
}
function $189c8bfad96741a8$var$Uk() {
    for(; null !== $189c8bfad96741a8$var$Y;)$189c8bfad96741a8$var$Vk($189c8bfad96741a8$var$Y);
}
function $189c8bfad96741a8$var$Mk() {
    for(; null !== $189c8bfad96741a8$var$Y && !$189c8bfad96741a8$var$cc();)$189c8bfad96741a8$var$Vk($189c8bfad96741a8$var$Y);
}
function $189c8bfad96741a8$var$Vk(a) {
    var b = $189c8bfad96741a8$var$Wk(a.alternate, a, $189c8bfad96741a8$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $189c8bfad96741a8$var$Tk(a) : $189c8bfad96741a8$var$Y = b;
    $189c8bfad96741a8$var$ok.current = null;
}
function $189c8bfad96741a8$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $189c8bfad96741a8$var$Fj(c, b, $189c8bfad96741a8$var$gj), null !== c) {
                $189c8bfad96741a8$var$Y = c;
                return;
            }
        } else {
            c = $189c8bfad96741a8$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $189c8bfad96741a8$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $189c8bfad96741a8$var$T = 6;
                $189c8bfad96741a8$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $189c8bfad96741a8$var$Y = b;
            return;
        }
        $189c8bfad96741a8$var$Y = b = a;
    }while (null !== b);
    0 === $189c8bfad96741a8$var$T && ($189c8bfad96741a8$var$T = 5);
}
function $189c8bfad96741a8$var$Qk(a, b, c) {
    var d = $189c8bfad96741a8$var$C, e = $189c8bfad96741a8$var$pk.transition;
    try {
        $189c8bfad96741a8$var$pk.transition = null, $189c8bfad96741a8$var$C = 1, $189c8bfad96741a8$var$Xk(a, b, c, d);
    } finally{
        $189c8bfad96741a8$var$pk.transition = e, $189c8bfad96741a8$var$C = d;
    }
    return null;
}
function $189c8bfad96741a8$var$Xk(a, b, c, d) {
    do $189c8bfad96741a8$var$Ik();
    while (null !== $189c8bfad96741a8$var$xk);
    if (0 !== ($189c8bfad96741a8$var$K & 6)) throw Error($189c8bfad96741a8$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($189c8bfad96741a8$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $189c8bfad96741a8$var$Bc(a, f);
    a === $189c8bfad96741a8$var$R && ($189c8bfad96741a8$var$Y = $189c8bfad96741a8$var$R = null, $189c8bfad96741a8$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $189c8bfad96741a8$var$wk || ($189c8bfad96741a8$var$wk = !0, $189c8bfad96741a8$var$Gk($189c8bfad96741a8$var$hc, function() {
        $189c8bfad96741a8$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $189c8bfad96741a8$var$pk.transition;
        $189c8bfad96741a8$var$pk.transition = null;
        var g = $189c8bfad96741a8$var$C;
        $189c8bfad96741a8$var$C = 1;
        var h = $189c8bfad96741a8$var$K;
        $189c8bfad96741a8$var$K |= 4;
        $189c8bfad96741a8$var$ok.current = null;
        $189c8bfad96741a8$var$Pj(a, c);
        $189c8bfad96741a8$var$ek(c, a);
        $189c8bfad96741a8$var$Oe($189c8bfad96741a8$var$Df);
        $189c8bfad96741a8$var$dd = !!$189c8bfad96741a8$var$Cf;
        $189c8bfad96741a8$var$Df = $189c8bfad96741a8$var$Cf = null;
        a.current = c;
        $189c8bfad96741a8$var$ik(c, a, e);
        $189c8bfad96741a8$var$dc();
        $189c8bfad96741a8$var$K = h;
        $189c8bfad96741a8$var$C = g;
        $189c8bfad96741a8$var$pk.transition = f;
    } else a.current = c;
    $189c8bfad96741a8$var$wk && ($189c8bfad96741a8$var$wk = !1, $189c8bfad96741a8$var$xk = a, $189c8bfad96741a8$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($189c8bfad96741a8$var$Si = null);
    $189c8bfad96741a8$var$mc(c.stateNode, d);
    $189c8bfad96741a8$var$Ek(a, $189c8bfad96741a8$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($189c8bfad96741a8$var$Pi) throw $189c8bfad96741a8$var$Pi = !1, a = $189c8bfad96741a8$var$Qi, $189c8bfad96741a8$var$Qi = null, a;
    0 !== ($189c8bfad96741a8$var$yk & 1) && 0 !== a.tag && $189c8bfad96741a8$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $189c8bfad96741a8$var$Ak ? $189c8bfad96741a8$var$zk++ : ($189c8bfad96741a8$var$zk = 0, $189c8bfad96741a8$var$Ak = a) : $189c8bfad96741a8$var$zk = 0;
    $189c8bfad96741a8$var$jg();
    return null;
}
function $189c8bfad96741a8$var$Ik() {
    if (null !== $189c8bfad96741a8$var$xk) {
        var a = $189c8bfad96741a8$var$Dc($189c8bfad96741a8$var$yk), b = $189c8bfad96741a8$var$pk.transition, c = $189c8bfad96741a8$var$C;
        try {
            $189c8bfad96741a8$var$pk.transition = null;
            $189c8bfad96741a8$var$C = 16 > a ? 16 : a;
            if (null === $189c8bfad96741a8$var$xk) var d = !1;
            else {
                a = $189c8bfad96741a8$var$xk;
                $189c8bfad96741a8$var$xk = null;
                $189c8bfad96741a8$var$yk = 0;
                if (0 !== ($189c8bfad96741a8$var$K & 6)) throw Error($189c8bfad96741a8$var$p(331));
                var e = $189c8bfad96741a8$var$K;
                $189c8bfad96741a8$var$K |= 4;
                for($189c8bfad96741a8$var$V = a.current; null !== $189c8bfad96741a8$var$V;){
                    var f = $189c8bfad96741a8$var$V, g = f.child;
                    if (0 !== ($189c8bfad96741a8$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($189c8bfad96741a8$var$V = l; null !== $189c8bfad96741a8$var$V;){
                                    var m = $189c8bfad96741a8$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $189c8bfad96741a8$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $189c8bfad96741a8$var$V = q;
                                    else for(; null !== $189c8bfad96741a8$var$V;){
                                        m = $189c8bfad96741a8$var$V;
                                        var r = m.sibling, y = m.return;
                                        $189c8bfad96741a8$var$Tj(m);
                                        if (m === l) {
                                            $189c8bfad96741a8$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $189c8bfad96741a8$var$V = r;
                                            break;
                                        }
                                        $189c8bfad96741a8$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $189c8bfad96741a8$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $189c8bfad96741a8$var$V = g;
                    else b: for(; null !== $189c8bfad96741a8$var$V;){
                        f = $189c8bfad96741a8$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $189c8bfad96741a8$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $189c8bfad96741a8$var$V = x;
                            break b;
                        }
                        $189c8bfad96741a8$var$V = f.return;
                    }
                }
                var w = a.current;
                for($189c8bfad96741a8$var$V = w; null !== $189c8bfad96741a8$var$V;){
                    g = $189c8bfad96741a8$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $189c8bfad96741a8$var$V = u;
                    else b: for(g = w; null !== $189c8bfad96741a8$var$V;){
                        h = $189c8bfad96741a8$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $189c8bfad96741a8$var$Rj(9, h);
                            }
                        } catch (na) {
                            $189c8bfad96741a8$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $189c8bfad96741a8$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $189c8bfad96741a8$var$V = F;
                            break b;
                        }
                        $189c8bfad96741a8$var$V = h.return;
                    }
                }
                $189c8bfad96741a8$var$K = e;
                $189c8bfad96741a8$var$jg();
                if ($189c8bfad96741a8$var$lc && "function" === typeof $189c8bfad96741a8$var$lc.onPostCommitFiberRoot) try {
                    $189c8bfad96741a8$var$lc.onPostCommitFiberRoot($189c8bfad96741a8$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $189c8bfad96741a8$var$C = c, $189c8bfad96741a8$var$pk.transition = b;
        }
    }
    return !1;
}
function $189c8bfad96741a8$var$Yk(a, b, c) {
    b = $189c8bfad96741a8$var$Ki(c, b);
    b = $189c8bfad96741a8$var$Oi(a, b, 1);
    a = $189c8bfad96741a8$var$dh(a, b, 1);
    b = $189c8bfad96741a8$var$L();
    null !== a && ($189c8bfad96741a8$var$Ac(a, 1, b), $189c8bfad96741a8$var$Ek(a, b));
}
function $189c8bfad96741a8$var$W(a, b, c) {
    if (3 === a.tag) $189c8bfad96741a8$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $189c8bfad96741a8$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $189c8bfad96741a8$var$Si || !$189c8bfad96741a8$var$Si.has(d))) {
                a = $189c8bfad96741a8$var$Ki(c, a);
                a = $189c8bfad96741a8$var$Ri(b, a, 1);
                b = $189c8bfad96741a8$var$dh(b, a, 1);
                a = $189c8bfad96741a8$var$L();
                null !== b && ($189c8bfad96741a8$var$Ac(b, 1, a), $189c8bfad96741a8$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $189c8bfad96741a8$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $189c8bfad96741a8$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $189c8bfad96741a8$var$R === a && ($189c8bfad96741a8$var$Z & c) === c && (4 === $189c8bfad96741a8$var$T || 3 === $189c8bfad96741a8$var$T && ($189c8bfad96741a8$var$Z & 130023424) === $189c8bfad96741a8$var$Z && 500 > $189c8bfad96741a8$var$B() - $189c8bfad96741a8$var$gk ? $189c8bfad96741a8$var$Lk(a, 0) : $189c8bfad96741a8$var$sk |= c);
    $189c8bfad96741a8$var$Ek(a, b);
}
function $189c8bfad96741a8$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $189c8bfad96741a8$var$sc, $189c8bfad96741a8$var$sc <<= 1, 0 === ($189c8bfad96741a8$var$sc & 130023424) && ($189c8bfad96741a8$var$sc = 4194304)));
    var c = $189c8bfad96741a8$var$L();
    a = $189c8bfad96741a8$var$Zg(a, b);
    null !== a && ($189c8bfad96741a8$var$Ac(a, b, c), $189c8bfad96741a8$var$Ek(a, c));
}
function $189c8bfad96741a8$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $189c8bfad96741a8$var$Zk(a, c);
}
function $189c8bfad96741a8$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($189c8bfad96741a8$var$p(314));
    }
    null !== d && d.delete(b);
    $189c8bfad96741a8$var$Zk(a, c);
}
var $189c8bfad96741a8$var$Wk;
$189c8bfad96741a8$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $189c8bfad96741a8$var$Wf.current) $189c8bfad96741a8$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $189c8bfad96741a8$var$Ug = !1, $189c8bfad96741a8$var$zj(a, b, c);
            $189c8bfad96741a8$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $189c8bfad96741a8$var$Ug = !1, $189c8bfad96741a8$var$I && 0 !== (b.flags & 1048576) && $189c8bfad96741a8$var$ug(b, $189c8bfad96741a8$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $189c8bfad96741a8$var$jj(a, b);
            a = b.pendingProps;
            var e = $189c8bfad96741a8$var$Yf(b, $189c8bfad96741a8$var$H.current);
            $189c8bfad96741a8$var$Tg(b, c);
            e = $189c8bfad96741a8$var$Xh(null, b, d, a, e, c);
            var f = $189c8bfad96741a8$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $189c8bfad96741a8$var$Zf(d) ? (f = !0, $189c8bfad96741a8$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $189c8bfad96741a8$var$ah(b), e.updater = $189c8bfad96741a8$var$nh, b.stateNode = e, e._reactInternals = b, $189c8bfad96741a8$var$rh(b, d, a, c), b = $189c8bfad96741a8$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $189c8bfad96741a8$var$I && f && $189c8bfad96741a8$var$vg(b), $189c8bfad96741a8$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $189c8bfad96741a8$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $189c8bfad96741a8$var$$k(d);
                a = $189c8bfad96741a8$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $189c8bfad96741a8$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $189c8bfad96741a8$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $189c8bfad96741a8$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $189c8bfad96741a8$var$aj(null, b, d, $189c8bfad96741a8$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($189c8bfad96741a8$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $189c8bfad96741a8$var$Lg(d, e), $189c8bfad96741a8$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $189c8bfad96741a8$var$Lg(d, e), $189c8bfad96741a8$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $189c8bfad96741a8$var$lj(b);
                if (null === a) throw Error($189c8bfad96741a8$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $189c8bfad96741a8$var$bh(a, b);
                $189c8bfad96741a8$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $189c8bfad96741a8$var$Ki(Error($189c8bfad96741a8$var$p(423)), b);
                        b = $189c8bfad96741a8$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $189c8bfad96741a8$var$Ki(Error($189c8bfad96741a8$var$p(424)), b);
                        b = $189c8bfad96741a8$var$mj(a, b, d, c, e);
                        break a;
                    } else for($189c8bfad96741a8$var$yg = $189c8bfad96741a8$var$Lf(b.stateNode.containerInfo.firstChild), $189c8bfad96741a8$var$xg = b, $189c8bfad96741a8$var$I = !0, $189c8bfad96741a8$var$zg = null, c = $189c8bfad96741a8$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $189c8bfad96741a8$var$Ig();
                    if (d === e) {
                        b = $189c8bfad96741a8$var$$i(a, b, c);
                        break a;
                    }
                    $189c8bfad96741a8$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $189c8bfad96741a8$var$Kh(b), null === a && $189c8bfad96741a8$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $189c8bfad96741a8$var$Ef(d, e) ? g = null : null !== f && $189c8bfad96741a8$var$Ef(d, f) && (b.flags |= 32), $189c8bfad96741a8$var$hj(a, b), $189c8bfad96741a8$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $189c8bfad96741a8$var$Eg(b), null;
        case 13:
            return $189c8bfad96741a8$var$pj(a, b, c);
        case 4:
            return $189c8bfad96741a8$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $189c8bfad96741a8$var$Bh(b, null, d, c) : $189c8bfad96741a8$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $189c8bfad96741a8$var$Lg(d, e), $189c8bfad96741a8$var$Zi(a, b, d, e, c);
        case 7:
            return $189c8bfad96741a8$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $189c8bfad96741a8$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $189c8bfad96741a8$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $189c8bfad96741a8$var$G($189c8bfad96741a8$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($189c8bfad96741a8$var$He(f.value, g)) {
                        if (f.children === e.children && !$189c8bfad96741a8$var$Wf.current) {
                            b = $189c8bfad96741a8$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $189c8bfad96741a8$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $189c8bfad96741a8$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($189c8bfad96741a8$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $189c8bfad96741a8$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $189c8bfad96741a8$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $189c8bfad96741a8$var$Tg(b, c), e = $189c8bfad96741a8$var$Vg(e), d = d(e), b.flags |= 1, $189c8bfad96741a8$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $189c8bfad96741a8$var$Lg(d, b.pendingProps), e = $189c8bfad96741a8$var$Lg(d.type, e), $189c8bfad96741a8$var$aj(a, b, d, e, c);
        case 15:
            return $189c8bfad96741a8$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $189c8bfad96741a8$var$Lg(d, e), $189c8bfad96741a8$var$jj(a, b), b.tag = 1, $189c8bfad96741a8$var$Zf(d) ? (a = !0, $189c8bfad96741a8$var$cg(b)) : a = !1, $189c8bfad96741a8$var$Tg(b, c), $189c8bfad96741a8$var$ph(b, d, e), $189c8bfad96741a8$var$rh(b, d, e, c), $189c8bfad96741a8$var$kj(null, b, d, !0, a, c);
        case 19:
            return $189c8bfad96741a8$var$yj(a, b, c);
        case 22:
            return $189c8bfad96741a8$var$ej(a, b, c);
    }
    throw Error($189c8bfad96741a8$var$p(156, b.tag));
};
function $189c8bfad96741a8$var$Gk(a, b) {
    return $189c8bfad96741a8$var$ac(a, b);
}
function $189c8bfad96741a8$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $189c8bfad96741a8$var$Bg(a, b, c, d) {
    return new $189c8bfad96741a8$var$al(a, b, c, d);
}
function $189c8bfad96741a8$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $189c8bfad96741a8$var$$k(a) {
    if ("function" === typeof a) return $189c8bfad96741a8$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $189c8bfad96741a8$var$Da) return 11;
        if (a === $189c8bfad96741a8$var$Ga) return 14;
    }
    return 2;
}
function $189c8bfad96741a8$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $189c8bfad96741a8$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $189c8bfad96741a8$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $189c8bfad96741a8$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $189c8bfad96741a8$var$ya:
            return $189c8bfad96741a8$var$Ah(c.children, e, f, b);
        case $189c8bfad96741a8$var$za:
            g = 8;
            e |= 8;
            break;
        case $189c8bfad96741a8$var$Aa:
            return a = $189c8bfad96741a8$var$Bg(12, c, b, e | 2), a.elementType = $189c8bfad96741a8$var$Aa, a.lanes = f, a;
        case $189c8bfad96741a8$var$Ea:
            return a = $189c8bfad96741a8$var$Bg(13, c, b, e), a.elementType = $189c8bfad96741a8$var$Ea, a.lanes = f, a;
        case $189c8bfad96741a8$var$Fa:
            return a = $189c8bfad96741a8$var$Bg(19, c, b, e), a.elementType = $189c8bfad96741a8$var$Fa, a.lanes = f, a;
        case $189c8bfad96741a8$var$Ia:
            return $189c8bfad96741a8$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $189c8bfad96741a8$var$Ba:
                    g = 10;
                    break a;
                case $189c8bfad96741a8$var$Ca:
                    g = 9;
                    break a;
                case $189c8bfad96741a8$var$Da:
                    g = 11;
                    break a;
                case $189c8bfad96741a8$var$Ga:
                    g = 14;
                    break a;
                case $189c8bfad96741a8$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($189c8bfad96741a8$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $189c8bfad96741a8$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $189c8bfad96741a8$var$Ah(a, b, c, d) {
    a = $189c8bfad96741a8$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $189c8bfad96741a8$var$qj(a, b, c, d) {
    a = $189c8bfad96741a8$var$Bg(22, a, d, b);
    a.elementType = $189c8bfad96741a8$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $189c8bfad96741a8$var$xh(a, b, c) {
    a = $189c8bfad96741a8$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $189c8bfad96741a8$var$zh(a, b, c) {
    b = $189c8bfad96741a8$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $189c8bfad96741a8$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $189c8bfad96741a8$var$zc(0);
    this.expirationTimes = $189c8bfad96741a8$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $189c8bfad96741a8$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $189c8bfad96741a8$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $189c8bfad96741a8$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $189c8bfad96741a8$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $189c8bfad96741a8$var$ah(f);
    return a;
}
function $189c8bfad96741a8$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $189c8bfad96741a8$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $189c8bfad96741a8$var$el(a) {
    if (!a) return $189c8bfad96741a8$var$Vf;
    a = a._reactInternals;
    a: {
        if ($189c8bfad96741a8$var$Vb(a) !== a || 1 !== a.tag) throw Error($189c8bfad96741a8$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($189c8bfad96741a8$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($189c8bfad96741a8$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($189c8bfad96741a8$var$Zf(c)) return $189c8bfad96741a8$var$bg(a, c, b);
    }
    return b;
}
function $189c8bfad96741a8$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $189c8bfad96741a8$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $189c8bfad96741a8$var$el(null);
    c = a.current;
    d = $189c8bfad96741a8$var$L();
    e = $189c8bfad96741a8$var$lh(c);
    f = $189c8bfad96741a8$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $189c8bfad96741a8$var$dh(c, f, e);
    a.current.lanes = e;
    $189c8bfad96741a8$var$Ac(a, e, d);
    $189c8bfad96741a8$var$Ek(a, d);
    return a;
}
function $189c8bfad96741a8$var$gl(a, b, c, d) {
    var e = b.current, f = $189c8bfad96741a8$var$L(), g = $189c8bfad96741a8$var$lh(e);
    c = $189c8bfad96741a8$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $189c8bfad96741a8$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $189c8bfad96741a8$var$dh(e, b, g);
    null !== a && ($189c8bfad96741a8$var$mh(a, e, g, f), $189c8bfad96741a8$var$eh(a, e, g));
    return g;
}
function $189c8bfad96741a8$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $189c8bfad96741a8$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $189c8bfad96741a8$var$jl(a, b) {
    $189c8bfad96741a8$var$il(a, b);
    (a = a.alternate) && $189c8bfad96741a8$var$il(a, b);
}
function $189c8bfad96741a8$var$kl() {
    return null;
}
var $189c8bfad96741a8$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $189c8bfad96741a8$var$ml(a) {
    this._internalRoot = a;
}
$189c8bfad96741a8$var$nl.prototype.render = $189c8bfad96741a8$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($189c8bfad96741a8$var$p(409));
    $189c8bfad96741a8$var$gl(a, b, null, null);
};
$189c8bfad96741a8$var$nl.prototype.unmount = $189c8bfad96741a8$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $189c8bfad96741a8$var$Sk(function() {
            $189c8bfad96741a8$var$gl(null, a, null, null);
        });
        b[$189c8bfad96741a8$var$uf] = null;
    }
};
function $189c8bfad96741a8$var$nl(a) {
    this._internalRoot = a;
}
$189c8bfad96741a8$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $189c8bfad96741a8$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $189c8bfad96741a8$var$Qc.length && 0 !== b && b < $189c8bfad96741a8$var$Qc[c].priority; c++);
        $189c8bfad96741a8$var$Qc.splice(c, 0, a);
        0 === c && $189c8bfad96741a8$var$Vc(a);
    }
};
function $189c8bfad96741a8$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $189c8bfad96741a8$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $189c8bfad96741a8$var$ql() {}
function $189c8bfad96741a8$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $189c8bfad96741a8$var$hl(g);
                f.call(a);
            };
        }
        var g = $189c8bfad96741a8$var$fl(b, d, a, 0, null, !1, !1, "", $189c8bfad96741a8$var$ql);
        a._reactRootContainer = g;
        a[$189c8bfad96741a8$var$uf] = g.current;
        $189c8bfad96741a8$var$sf(8 === a.nodeType ? a.parentNode : a);
        $189c8bfad96741a8$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $189c8bfad96741a8$var$hl(k);
            h.call(a);
        };
    }
    var k = $189c8bfad96741a8$var$cl(a, 0, !1, null, null, !1, !1, "", $189c8bfad96741a8$var$ql);
    a._reactRootContainer = k;
    a[$189c8bfad96741a8$var$uf] = k.current;
    $189c8bfad96741a8$var$sf(8 === a.nodeType ? a.parentNode : a);
    $189c8bfad96741a8$var$Sk(function() {
        $189c8bfad96741a8$var$gl(b, k, c, d);
    });
    return k;
}
function $189c8bfad96741a8$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $189c8bfad96741a8$var$hl(g);
                h.call(a);
            };
        }
        $189c8bfad96741a8$var$gl(b, g, a, e);
    } else g = $189c8bfad96741a8$var$rl(c, b, a, e, d);
    return $189c8bfad96741a8$var$hl(g);
}
$189c8bfad96741a8$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $189c8bfad96741a8$var$tc(b.pendingLanes);
                0 !== c && ($189c8bfad96741a8$var$Cc(b, c | 1), $189c8bfad96741a8$var$Ek(b, $189c8bfad96741a8$var$B()), 0 === ($189c8bfad96741a8$var$K & 6) && ($189c8bfad96741a8$var$Hj = $189c8bfad96741a8$var$B() + 500, $189c8bfad96741a8$var$jg()));
            }
            break;
        case 13:
            $189c8bfad96741a8$var$Sk(function() {
                var b = $189c8bfad96741a8$var$Zg(a, 1);
                if (null !== b) {
                    var c = $189c8bfad96741a8$var$L();
                    $189c8bfad96741a8$var$mh(b, a, 1, c);
                }
            }), $189c8bfad96741a8$var$jl(a, 1);
    }
};
$189c8bfad96741a8$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $189c8bfad96741a8$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $189c8bfad96741a8$var$L();
            $189c8bfad96741a8$var$mh(b, a, 134217728, c);
        }
        $189c8bfad96741a8$var$jl(a, 134217728);
    }
};
$189c8bfad96741a8$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $189c8bfad96741a8$var$lh(a), c = $189c8bfad96741a8$var$Zg(a, b);
        if (null !== c) {
            var d = $189c8bfad96741a8$var$L();
            $189c8bfad96741a8$var$mh(c, a, b, d);
        }
        $189c8bfad96741a8$var$jl(a, b);
    }
};
$189c8bfad96741a8$var$Hc = function() {
    return $189c8bfad96741a8$var$C;
};
$189c8bfad96741a8$var$Ic = function(a, b) {
    var c = $189c8bfad96741a8$var$C;
    try {
        return $189c8bfad96741a8$var$C = a, b();
    } finally{
        $189c8bfad96741a8$var$C = c;
    }
};
$189c8bfad96741a8$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $189c8bfad96741a8$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $189c8bfad96741a8$var$Db(d);
                        if (!e) throw Error($189c8bfad96741a8$var$p(90));
                        $189c8bfad96741a8$var$Wa(d);
                        $189c8bfad96741a8$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $189c8bfad96741a8$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $189c8bfad96741a8$var$fb(a, !!c.multiple, b, !1);
    }
};
$189c8bfad96741a8$var$Gb = $189c8bfad96741a8$var$Rk;
$189c8bfad96741a8$var$Hb = $189c8bfad96741a8$var$Sk;
var $189c8bfad96741a8$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $189c8bfad96741a8$var$Cb,
        $189c8bfad96741a8$var$ue,
        $189c8bfad96741a8$var$Db,
        $189c8bfad96741a8$var$Eb,
        $189c8bfad96741a8$var$Fb,
        $189c8bfad96741a8$var$Rk
    ]
}, $189c8bfad96741a8$var$ul = {
    findFiberByHostInstance: $189c8bfad96741a8$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $189c8bfad96741a8$var$vl = {
    bundleType: $189c8bfad96741a8$var$ul.bundleType,
    version: $189c8bfad96741a8$var$ul.version,
    rendererPackageName: $189c8bfad96741a8$var$ul.rendererPackageName,
    rendererConfig: $189c8bfad96741a8$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $189c8bfad96741a8$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $189c8bfad96741a8$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $189c8bfad96741a8$var$ul.findFiberByHostInstance || $189c8bfad96741a8$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $189c8bfad96741a8$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$189c8bfad96741a8$var$wl.isDisabled && $189c8bfad96741a8$var$wl.supportsFiber) try {
        $189c8bfad96741a8$var$kc = $189c8bfad96741a8$var$wl.inject($189c8bfad96741a8$var$vl), $189c8bfad96741a8$var$lc = $189c8bfad96741a8$var$wl;
    } catch (a) {}
}
$189c8bfad96741a8$export$ae55be85d98224ed = $189c8bfad96741a8$var$tl;
$189c8bfad96741a8$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$189c8bfad96741a8$var$ol(b)) throw Error($189c8bfad96741a8$var$p(200));
    return $189c8bfad96741a8$var$dl(a, b, null, c);
};
$189c8bfad96741a8$export$882461b6382ed46c = function(a, b) {
    if (!$189c8bfad96741a8$var$ol(a)) throw Error($189c8bfad96741a8$var$p(299));
    var c = !1, d = "", e = $189c8bfad96741a8$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $189c8bfad96741a8$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$189c8bfad96741a8$var$uf] = b.current;
    $189c8bfad96741a8$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $189c8bfad96741a8$var$ml(b);
};
$189c8bfad96741a8$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($189c8bfad96741a8$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($189c8bfad96741a8$var$p(268, a));
    }
    a = $189c8bfad96741a8$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$189c8bfad96741a8$export$cd75ccfd720a3cd4 = function(a) {
    return $189c8bfad96741a8$var$Sk(a);
};
$189c8bfad96741a8$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$189c8bfad96741a8$var$pl(b)) throw Error($189c8bfad96741a8$var$p(200));
    return $189c8bfad96741a8$var$sl(null, a, b, !0, c);
};
$189c8bfad96741a8$export$757ceba2d55c277e = function(a, b, c) {
    if (!$189c8bfad96741a8$var$ol(a)) throw Error($189c8bfad96741a8$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $189c8bfad96741a8$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $189c8bfad96741a8$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$189c8bfad96741a8$var$uf] = b.current;
    $189c8bfad96741a8$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $189c8bfad96741a8$var$nl(b);
};
$189c8bfad96741a8$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$189c8bfad96741a8$var$pl(b)) throw Error($189c8bfad96741a8$var$p(200));
    return $189c8bfad96741a8$var$sl(null, a, b, !1, c);
};
$189c8bfad96741a8$export$502457920280e6be = function(a) {
    if (!$189c8bfad96741a8$var$pl(a)) throw Error($189c8bfad96741a8$var$p(40));
    return a._reactRootContainer ? ($189c8bfad96741a8$var$Sk(function() {
        $189c8bfad96741a8$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$189c8bfad96741a8$var$uf] = null;
        });
    }), !0) : !1;
};
$189c8bfad96741a8$export$c78a37762a8d58e1 = $189c8bfad96741a8$var$Rk;
$189c8bfad96741a8$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$189c8bfad96741a8$var$pl(c)) throw Error($189c8bfad96741a8$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($189c8bfad96741a8$var$p(38));
    return $189c8bfad96741a8$var$sl(a, b, c, !1, d);
};
$189c8bfad96741a8$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("9LeLq", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lg6fM"));

});
parcelRegister("lg6fM", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $f79ff16c954ece87$export$c4744153514ff05d, (v) => $f79ff16c954ece87$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $f79ff16c954ece87$export$3e506c1ccc9cc1a7, (v) => $f79ff16c954ece87$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $f79ff16c954ece87$export$e26fe2ed2fa76875, (v) => $f79ff16c954ece87$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $f79ff16c954ece87$export$502329bbf4b505b1, (v) => $f79ff16c954ece87$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $f79ff16c954ece87$export$6e3807111c4874c4, (v) => $f79ff16c954ece87$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $f79ff16c954ece87$export$c27134553091fb3a, (v) => $f79ff16c954ece87$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $f79ff16c954ece87$export$33ee1acdc04fd2a2, (v) => $f79ff16c954ece87$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $f79ff16c954ece87$export$b00a404bbd5edef2, (v) => $f79ff16c954ece87$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $f79ff16c954ece87$export$8352ce38b91d0c62, (v) => $f79ff16c954ece87$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $f79ff16c954ece87$export$d66a1c1c77bd778b, (v) => $f79ff16c954ece87$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $f79ff16c954ece87$export$d3dfb8e4810cb555, (v) => $f79ff16c954ece87$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $f79ff16c954ece87$export$839f9183b0465a69, (v) => $f79ff16c954ece87$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $f79ff16c954ece87$export$72fdf0e06517287b, (v) => $f79ff16c954ece87$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $f79ff16c954ece87$export$4b844e58a3e414b4, (v) => $f79ff16c954ece87$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $f79ff16c954ece87$export$816d2913ae6b83b1, (v) => $f79ff16c954ece87$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $f79ff16c954ece87$export$61bcfe829111a1d0, (v) => $f79ff16c954ece87$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $f79ff16c954ece87$export$7ee8c9beb337bc3f, (v) => $f79ff16c954ece87$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $f79ff16c954ece87$export$b5836b71941fa3ed, (v) => $f79ff16c954ece87$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $f79ff16c954ece87$export$cf845f2c119da08a, (v) => $f79ff16c954ece87$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f79ff16c954ece87$export$c4744153514ff05d;
var $f79ff16c954ece87$export$3e506c1ccc9cc1a7;
var $f79ff16c954ece87$export$e26fe2ed2fa76875;
var $f79ff16c954ece87$export$502329bbf4b505b1;
var $f79ff16c954ece87$export$6e3807111c4874c4;
var $f79ff16c954ece87$export$c27134553091fb3a;
var $f79ff16c954ece87$export$33ee1acdc04fd2a2;
var $f79ff16c954ece87$export$b00a404bbd5edef2;
var $f79ff16c954ece87$export$8352ce38b91d0c62;
var $f79ff16c954ece87$export$d66a1c1c77bd778b;
var $f79ff16c954ece87$export$d3dfb8e4810cb555;
var $f79ff16c954ece87$export$839f9183b0465a69;
var $f79ff16c954ece87$export$72fdf0e06517287b;
var $f79ff16c954ece87$export$4b844e58a3e414b4;
var $f79ff16c954ece87$export$816d2913ae6b83b1;
var $f79ff16c954ece87$export$61bcfe829111a1d0;
var $f79ff16c954ece87$export$7ee8c9beb337bc3f;
var $f79ff16c954ece87$export$b5836b71941fa3ed;
var $f79ff16c954ece87$export$cf845f2c119da08a;
"use strict";
function $f79ff16c954ece87$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $f79ff16c954ece87$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $f79ff16c954ece87$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $f79ff16c954ece87$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $f79ff16c954ece87$var$g(C, c)) n < e && 0 > $f79ff16c954ece87$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $f79ff16c954ece87$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $f79ff16c954ece87$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $f79ff16c954ece87$var$l = performance;
    $f79ff16c954ece87$export$c4744153514ff05d = function() {
        return $f79ff16c954ece87$var$l.now();
    };
} else {
    var $f79ff16c954ece87$var$p = Date, $f79ff16c954ece87$var$q = $f79ff16c954ece87$var$p.now();
    $f79ff16c954ece87$export$c4744153514ff05d = function() {
        return $f79ff16c954ece87$var$p.now() - $f79ff16c954ece87$var$q;
    };
}
var $f79ff16c954ece87$var$r = [], $f79ff16c954ece87$var$t = [], $f79ff16c954ece87$var$u = 1, $f79ff16c954ece87$var$v = null, $f79ff16c954ece87$var$y = 3, $f79ff16c954ece87$var$z = !1, $f79ff16c954ece87$var$A = !1, $f79ff16c954ece87$var$B = !1, $f79ff16c954ece87$var$D = "function" === typeof setTimeout ? setTimeout : null, $f79ff16c954ece87$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $f79ff16c954ece87$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $f79ff16c954ece87$var$G(a) {
    for(var b = $f79ff16c954ece87$var$h($f79ff16c954ece87$var$t); null !== b;){
        if (null === b.callback) $f79ff16c954ece87$var$k($f79ff16c954ece87$var$t);
        else if (b.startTime <= a) $f79ff16c954ece87$var$k($f79ff16c954ece87$var$t), b.sortIndex = b.expirationTime, $f79ff16c954ece87$var$f($f79ff16c954ece87$var$r, b);
        else break;
        b = $f79ff16c954ece87$var$h($f79ff16c954ece87$var$t);
    }
}
function $f79ff16c954ece87$var$H(a) {
    $f79ff16c954ece87$var$B = !1;
    $f79ff16c954ece87$var$G(a);
    if (!$f79ff16c954ece87$var$A) {
        if (null !== $f79ff16c954ece87$var$h($f79ff16c954ece87$var$r)) $f79ff16c954ece87$var$A = !0, $f79ff16c954ece87$var$I($f79ff16c954ece87$var$J);
        else {
            var b = $f79ff16c954ece87$var$h($f79ff16c954ece87$var$t);
            null !== b && $f79ff16c954ece87$var$K($f79ff16c954ece87$var$H, b.startTime - a);
        }
    }
}
function $f79ff16c954ece87$var$J(a, b) {
    $f79ff16c954ece87$var$A = !1;
    $f79ff16c954ece87$var$B && ($f79ff16c954ece87$var$B = !1, $f79ff16c954ece87$var$E($f79ff16c954ece87$var$L), $f79ff16c954ece87$var$L = -1);
    $f79ff16c954ece87$var$z = !0;
    var c = $f79ff16c954ece87$var$y;
    try {
        $f79ff16c954ece87$var$G(b);
        for($f79ff16c954ece87$var$v = $f79ff16c954ece87$var$h($f79ff16c954ece87$var$r); null !== $f79ff16c954ece87$var$v && (!($f79ff16c954ece87$var$v.expirationTime > b) || a && !$f79ff16c954ece87$var$M());){
            var d = $f79ff16c954ece87$var$v.callback;
            if ("function" === typeof d) {
                $f79ff16c954ece87$var$v.callback = null;
                $f79ff16c954ece87$var$y = $f79ff16c954ece87$var$v.priorityLevel;
                var e = d($f79ff16c954ece87$var$v.expirationTime <= b);
                b = $f79ff16c954ece87$export$c4744153514ff05d();
                "function" === typeof e ? $f79ff16c954ece87$var$v.callback = e : $f79ff16c954ece87$var$v === $f79ff16c954ece87$var$h($f79ff16c954ece87$var$r) && $f79ff16c954ece87$var$k($f79ff16c954ece87$var$r);
                $f79ff16c954ece87$var$G(b);
            } else $f79ff16c954ece87$var$k($f79ff16c954ece87$var$r);
            $f79ff16c954ece87$var$v = $f79ff16c954ece87$var$h($f79ff16c954ece87$var$r);
        }
        if (null !== $f79ff16c954ece87$var$v) var w = !0;
        else {
            var m = $f79ff16c954ece87$var$h($f79ff16c954ece87$var$t);
            null !== m && $f79ff16c954ece87$var$K($f79ff16c954ece87$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $f79ff16c954ece87$var$v = null, $f79ff16c954ece87$var$y = c, $f79ff16c954ece87$var$z = !1;
    }
}
var $f79ff16c954ece87$var$N = !1, $f79ff16c954ece87$var$O = null, $f79ff16c954ece87$var$L = -1, $f79ff16c954ece87$var$P = 5, $f79ff16c954ece87$var$Q = -1;
function $f79ff16c954ece87$var$M() {
    return $f79ff16c954ece87$export$c4744153514ff05d() - $f79ff16c954ece87$var$Q < $f79ff16c954ece87$var$P ? !1 : !0;
}
function $f79ff16c954ece87$var$R() {
    if (null !== $f79ff16c954ece87$var$O) {
        var a = $f79ff16c954ece87$export$c4744153514ff05d();
        $f79ff16c954ece87$var$Q = a;
        var b = !0;
        try {
            b = $f79ff16c954ece87$var$O(!0, a);
        } finally{
            b ? $f79ff16c954ece87$var$S() : ($f79ff16c954ece87$var$N = !1, $f79ff16c954ece87$var$O = null);
        }
    } else $f79ff16c954ece87$var$N = !1;
}
var $f79ff16c954ece87$var$S;
if ("function" === typeof $f79ff16c954ece87$var$F) $f79ff16c954ece87$var$S = function() {
    $f79ff16c954ece87$var$F($f79ff16c954ece87$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $f79ff16c954ece87$var$T = new MessageChannel, $f79ff16c954ece87$var$U = $f79ff16c954ece87$var$T.port2;
    $f79ff16c954ece87$var$T.port1.onmessage = $f79ff16c954ece87$var$R;
    $f79ff16c954ece87$var$S = function() {
        $f79ff16c954ece87$var$U.postMessage(null);
    };
} else $f79ff16c954ece87$var$S = function() {
    $f79ff16c954ece87$var$D($f79ff16c954ece87$var$R, 0);
};
function $f79ff16c954ece87$var$I(a) {
    $f79ff16c954ece87$var$O = a;
    $f79ff16c954ece87$var$N || ($f79ff16c954ece87$var$N = !0, $f79ff16c954ece87$var$S());
}
function $f79ff16c954ece87$var$K(a, b) {
    $f79ff16c954ece87$var$L = $f79ff16c954ece87$var$D(function() {
        a($f79ff16c954ece87$export$c4744153514ff05d());
    }, b);
}
$f79ff16c954ece87$export$3e506c1ccc9cc1a7 = 5;
$f79ff16c954ece87$export$e26fe2ed2fa76875 = 1;
$f79ff16c954ece87$export$502329bbf4b505b1 = 4;
$f79ff16c954ece87$export$6e3807111c4874c4 = 3;
$f79ff16c954ece87$export$c27134553091fb3a = null;
$f79ff16c954ece87$export$33ee1acdc04fd2a2 = 2;
$f79ff16c954ece87$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$f79ff16c954ece87$export$8352ce38b91d0c62 = function() {
    $f79ff16c954ece87$var$A || $f79ff16c954ece87$var$z || ($f79ff16c954ece87$var$A = !0, $f79ff16c954ece87$var$I($f79ff16c954ece87$var$J));
};
$f79ff16c954ece87$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $f79ff16c954ece87$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$f79ff16c954ece87$export$d3dfb8e4810cb555 = function() {
    return $f79ff16c954ece87$var$y;
};
$f79ff16c954ece87$export$839f9183b0465a69 = function() {
    return $f79ff16c954ece87$var$h($f79ff16c954ece87$var$r);
};
$f79ff16c954ece87$export$72fdf0e06517287b = function(a) {
    switch($f79ff16c954ece87$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $f79ff16c954ece87$var$y;
    }
    var c = $f79ff16c954ece87$var$y;
    $f79ff16c954ece87$var$y = b;
    try {
        return a();
    } finally{
        $f79ff16c954ece87$var$y = c;
    }
};
$f79ff16c954ece87$export$4b844e58a3e414b4 = function() {};
$f79ff16c954ece87$export$816d2913ae6b83b1 = function() {};
$f79ff16c954ece87$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $f79ff16c954ece87$var$y;
    $f79ff16c954ece87$var$y = a;
    try {
        return b();
    } finally{
        $f79ff16c954ece87$var$y = c;
    }
};
$f79ff16c954ece87$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $f79ff16c954ece87$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $f79ff16c954ece87$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $f79ff16c954ece87$var$f($f79ff16c954ece87$var$t, a), null === $f79ff16c954ece87$var$h($f79ff16c954ece87$var$r) && a === $f79ff16c954ece87$var$h($f79ff16c954ece87$var$t) && ($f79ff16c954ece87$var$B ? ($f79ff16c954ece87$var$E($f79ff16c954ece87$var$L), $f79ff16c954ece87$var$L = -1) : $f79ff16c954ece87$var$B = !0, $f79ff16c954ece87$var$K($f79ff16c954ece87$var$H, c - d))) : (a.sortIndex = e, $f79ff16c954ece87$var$f($f79ff16c954ece87$var$r, a), $f79ff16c954ece87$var$A || $f79ff16c954ece87$var$z || ($f79ff16c954ece87$var$A = !0, $f79ff16c954ece87$var$I($f79ff16c954ece87$var$J)));
    return a;
};
$f79ff16c954ece87$export$b5836b71941fa3ed = $f79ff16c954ece87$var$M;
$f79ff16c954ece87$export$cf845f2c119da08a = function(a) {
    var b = $f79ff16c954ece87$var$y;
    return function() {
        var c = $f79ff16c954ece87$var$y;
        $f79ff16c954ece87$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $f79ff16c954ece87$var$y = c;
        }
    };
};

});



parcelRegister("1dxgA", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $0e30cf5e5b21caf1$export$2b8d127b894957b9, (v) => $0e30cf5e5b21caf1$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $0e30cf5e5b21caf1$export$cea3a54a6425200c, (v) => $0e30cf5e5b21caf1$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $0e30cf5e5b21caf1$export$a7c73072b1a182ae, (v) => $0e30cf5e5b21caf1$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $0e30cf5e5b21caf1$export$9f27bc3417b4524d, (v) => $0e30cf5e5b21caf1$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $0e30cf5e5b21caf1$export$db77ccec0bb4ccac, (v) => $0e30cf5e5b21caf1$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $0e30cf5e5b21caf1$export$8392c0c9d3dcbd35, (v) => $0e30cf5e5b21caf1$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $0e30cf5e5b21caf1$export$ffb0004e005737fa, (v) => $0e30cf5e5b21caf1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $0e30cf5e5b21caf1$export$b624eff549462981, (v) => $0e30cf5e5b21caf1$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $0e30cf5e5b21caf1$export$7897aa7841a5380c, (v) => $0e30cf5e5b21caf1$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $0e30cf5e5b21caf1$export$602eac185826482c, (v) => $0e30cf5e5b21caf1$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $0e30cf5e5b21caf1$export$e2c29f18771995cb, (v) => $0e30cf5e5b21caf1$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $0e30cf5e5b21caf1$export$5f8d39834fd61797, (v) => $0e30cf5e5b21caf1$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $0e30cf5e5b21caf1$export$74bf444e3cd11ea5, (v) => $0e30cf5e5b21caf1$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $0e30cf5e5b21caf1$export$92387174baf9b227, (v) => $0e30cf5e5b21caf1$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $0e30cf5e5b21caf1$export$ec112efeb987d9c6, (v) => $0e30cf5e5b21caf1$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $0e30cf5e5b21caf1$export$b706b080d889d2c9, (v) => $0e30cf5e5b21caf1$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $0e30cf5e5b21caf1$export$5be5a87408f70ddc, (v) => $0e30cf5e5b21caf1$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $0e30cf5e5b21caf1$export$45a5e7f76e0caa8d, (v) => $0e30cf5e5b21caf1$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $0e30cf5e5b21caf1$export$455c2e768291efa6, (v) => $0e30cf5e5b21caf1$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $0e30cf5e5b21caf1$export$9522e17588c12572, (v) => $0e30cf5e5b21caf1$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $0e30cf5e5b21caf1$export$2110ac352bb060b9, (v) => $0e30cf5e5b21caf1$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $0e30cf5e5b21caf1$export$56885ab8b9c456ab, (v) => $0e30cf5e5b21caf1$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $0e30cf5e5b21caf1$export$d927fcb6adf8f9de, (v) => $0e30cf5e5b21caf1$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $0e30cf5e5b21caf1$export$b82d16f27459e05a, (v) => $0e30cf5e5b21caf1$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $0e30cf5e5b21caf1$export$522c17b4f5e123e8, (v) => $0e30cf5e5b21caf1$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $0e30cf5e5b21caf1$export$1aabd8a0274ecfd6, (v) => $0e30cf5e5b21caf1$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $0e30cf5e5b21caf1$export$9b621391a187a31a, (v) => $0e30cf5e5b21caf1$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $0e30cf5e5b21caf1$export$f5bbd400c2f4426f, (v) => $0e30cf5e5b21caf1$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0e30cf5e5b21caf1$export$2b8d127b894957b9;
var $0e30cf5e5b21caf1$export$cea3a54a6425200c;
var $0e30cf5e5b21caf1$export$a7c73072b1a182ae;
var $0e30cf5e5b21caf1$export$9f27bc3417b4524d;
var $0e30cf5e5b21caf1$export$db77ccec0bb4ccac;
var $0e30cf5e5b21caf1$export$8392c0c9d3dcbd35;
var $0e30cf5e5b21caf1$export$ffb0004e005737fa;
var $0e30cf5e5b21caf1$export$b624eff549462981;
var $0e30cf5e5b21caf1$export$7897aa7841a5380c;
var $0e30cf5e5b21caf1$export$602eac185826482c;
var $0e30cf5e5b21caf1$export$e2c29f18771995cb;
var $0e30cf5e5b21caf1$export$5f8d39834fd61797;
var $0e30cf5e5b21caf1$export$74bf444e3cd11ea5;
var $0e30cf5e5b21caf1$export$92387174baf9b227;
var $0e30cf5e5b21caf1$export$ec112efeb987d9c6;
var $0e30cf5e5b21caf1$export$b706b080d889d2c9;
var $0e30cf5e5b21caf1$export$5be5a87408f70ddc;
var $0e30cf5e5b21caf1$export$45a5e7f76e0caa8d;
var $0e30cf5e5b21caf1$export$455c2e768291efa6;
var $0e30cf5e5b21caf1$export$9522e17588c12572;
var $0e30cf5e5b21caf1$export$2110ac352bb060b9;
var $0e30cf5e5b21caf1$export$56885ab8b9c456ab;
var $0e30cf5e5b21caf1$export$d927fcb6adf8f9de;
var $0e30cf5e5b21caf1$export$b82d16f27459e05a;
var $0e30cf5e5b21caf1$export$522c17b4f5e123e8;
var $0e30cf5e5b21caf1$export$1aabd8a0274ecfd6;
var $0e30cf5e5b21caf1$export$9b621391a187a31a;
var $0e30cf5e5b21caf1$export$f5bbd400c2f4426f;
"use strict";
var $0e30cf5e5b21caf1$var$b = "function" === typeof Symbol && Symbol.for, $0e30cf5e5b21caf1$var$c = $0e30cf5e5b21caf1$var$b ? Symbol.for("react.element") : 60103, $0e30cf5e5b21caf1$var$d = $0e30cf5e5b21caf1$var$b ? Symbol.for("react.portal") : 60106, $0e30cf5e5b21caf1$var$e = $0e30cf5e5b21caf1$var$b ? Symbol.for("react.fragment") : 60107, $0e30cf5e5b21caf1$var$f = $0e30cf5e5b21caf1$var$b ? Symbol.for("react.strict_mode") : 60108, $0e30cf5e5b21caf1$var$g = $0e30cf5e5b21caf1$var$b ? Symbol.for("react.profiler") : 60114, $0e30cf5e5b21caf1$var$h = $0e30cf5e5b21caf1$var$b ? Symbol.for("react.provider") : 60109, $0e30cf5e5b21caf1$var$k = $0e30cf5e5b21caf1$var$b ? Symbol.for("react.context") : 60110, $0e30cf5e5b21caf1$var$l = $0e30cf5e5b21caf1$var$b ? Symbol.for("react.async_mode") : 60111, $0e30cf5e5b21caf1$var$m = $0e30cf5e5b21caf1$var$b ? Symbol.for("react.concurrent_mode") : 60111, $0e30cf5e5b21caf1$var$n = $0e30cf5e5b21caf1$var$b ? Symbol.for("react.forward_ref") : 60112, $0e30cf5e5b21caf1$var$p = $0e30cf5e5b21caf1$var$b ? Symbol.for("react.suspense") : 60113, $0e30cf5e5b21caf1$var$q = $0e30cf5e5b21caf1$var$b ? Symbol.for("react.suspense_list") : 60120, $0e30cf5e5b21caf1$var$r = $0e30cf5e5b21caf1$var$b ? Symbol.for("react.memo") : 60115, $0e30cf5e5b21caf1$var$t = $0e30cf5e5b21caf1$var$b ? Symbol.for("react.lazy") : 60116, $0e30cf5e5b21caf1$var$v = $0e30cf5e5b21caf1$var$b ? Symbol.for("react.block") : 60121, $0e30cf5e5b21caf1$var$w = $0e30cf5e5b21caf1$var$b ? Symbol.for("react.fundamental") : 60117, $0e30cf5e5b21caf1$var$x = $0e30cf5e5b21caf1$var$b ? Symbol.for("react.responder") : 60118, $0e30cf5e5b21caf1$var$y = $0e30cf5e5b21caf1$var$b ? Symbol.for("react.scope") : 60119;
function $0e30cf5e5b21caf1$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $0e30cf5e5b21caf1$var$c:
                switch(a = a.type, a){
                    case $0e30cf5e5b21caf1$var$l:
                    case $0e30cf5e5b21caf1$var$m:
                    case $0e30cf5e5b21caf1$var$e:
                    case $0e30cf5e5b21caf1$var$g:
                    case $0e30cf5e5b21caf1$var$f:
                    case $0e30cf5e5b21caf1$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $0e30cf5e5b21caf1$var$k:
                            case $0e30cf5e5b21caf1$var$n:
                            case $0e30cf5e5b21caf1$var$t:
                            case $0e30cf5e5b21caf1$var$r:
                            case $0e30cf5e5b21caf1$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $0e30cf5e5b21caf1$var$d:
                return u;
        }
    }
}
function $0e30cf5e5b21caf1$var$A(a) {
    return $0e30cf5e5b21caf1$var$z(a) === $0e30cf5e5b21caf1$var$m;
}
$0e30cf5e5b21caf1$export$2b8d127b894957b9 = $0e30cf5e5b21caf1$var$l;
$0e30cf5e5b21caf1$export$cea3a54a6425200c = $0e30cf5e5b21caf1$var$m;
$0e30cf5e5b21caf1$export$a7c73072b1a182ae = $0e30cf5e5b21caf1$var$k;
$0e30cf5e5b21caf1$export$9f27bc3417b4524d = $0e30cf5e5b21caf1$var$h;
$0e30cf5e5b21caf1$export$db77ccec0bb4ccac = $0e30cf5e5b21caf1$var$c;
$0e30cf5e5b21caf1$export$8392c0c9d3dcbd35 = $0e30cf5e5b21caf1$var$n;
$0e30cf5e5b21caf1$export$ffb0004e005737fa = $0e30cf5e5b21caf1$var$e;
$0e30cf5e5b21caf1$export$b624eff549462981 = $0e30cf5e5b21caf1$var$t;
$0e30cf5e5b21caf1$export$7897aa7841a5380c = $0e30cf5e5b21caf1$var$r;
$0e30cf5e5b21caf1$export$602eac185826482c = $0e30cf5e5b21caf1$var$d;
$0e30cf5e5b21caf1$export$e2c29f18771995cb = $0e30cf5e5b21caf1$var$g;
$0e30cf5e5b21caf1$export$5f8d39834fd61797 = $0e30cf5e5b21caf1$var$f;
$0e30cf5e5b21caf1$export$74bf444e3cd11ea5 = $0e30cf5e5b21caf1$var$p;
$0e30cf5e5b21caf1$export$92387174baf9b227 = function(a) {
    return $0e30cf5e5b21caf1$var$A(a) || $0e30cf5e5b21caf1$var$z(a) === $0e30cf5e5b21caf1$var$l;
};
$0e30cf5e5b21caf1$export$ec112efeb987d9c6 = $0e30cf5e5b21caf1$var$A;
$0e30cf5e5b21caf1$export$b706b080d889d2c9 = function(a) {
    return $0e30cf5e5b21caf1$var$z(a) === $0e30cf5e5b21caf1$var$k;
};
$0e30cf5e5b21caf1$export$5be5a87408f70ddc = function(a) {
    return $0e30cf5e5b21caf1$var$z(a) === $0e30cf5e5b21caf1$var$h;
};
$0e30cf5e5b21caf1$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $0e30cf5e5b21caf1$var$c;
};
$0e30cf5e5b21caf1$export$455c2e768291efa6 = function(a) {
    return $0e30cf5e5b21caf1$var$z(a) === $0e30cf5e5b21caf1$var$n;
};
$0e30cf5e5b21caf1$export$9522e17588c12572 = function(a) {
    return $0e30cf5e5b21caf1$var$z(a) === $0e30cf5e5b21caf1$var$e;
};
$0e30cf5e5b21caf1$export$2110ac352bb060b9 = function(a) {
    return $0e30cf5e5b21caf1$var$z(a) === $0e30cf5e5b21caf1$var$t;
};
$0e30cf5e5b21caf1$export$56885ab8b9c456ab = function(a) {
    return $0e30cf5e5b21caf1$var$z(a) === $0e30cf5e5b21caf1$var$r;
};
$0e30cf5e5b21caf1$export$d927fcb6adf8f9de = function(a) {
    return $0e30cf5e5b21caf1$var$z(a) === $0e30cf5e5b21caf1$var$d;
};
$0e30cf5e5b21caf1$export$b82d16f27459e05a = function(a) {
    return $0e30cf5e5b21caf1$var$z(a) === $0e30cf5e5b21caf1$var$g;
};
$0e30cf5e5b21caf1$export$522c17b4f5e123e8 = function(a) {
    return $0e30cf5e5b21caf1$var$z(a) === $0e30cf5e5b21caf1$var$f;
};
$0e30cf5e5b21caf1$export$1aabd8a0274ecfd6 = function(a) {
    return $0e30cf5e5b21caf1$var$z(a) === $0e30cf5e5b21caf1$var$p;
};
$0e30cf5e5b21caf1$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $0e30cf5e5b21caf1$var$e || a === $0e30cf5e5b21caf1$var$m || a === $0e30cf5e5b21caf1$var$g || a === $0e30cf5e5b21caf1$var$f || a === $0e30cf5e5b21caf1$var$p || a === $0e30cf5e5b21caf1$var$q || "object" === typeof a && null !== a && (a.$$typeof === $0e30cf5e5b21caf1$var$t || a.$$typeof === $0e30cf5e5b21caf1$var$r || a.$$typeof === $0e30cf5e5b21caf1$var$h || a.$$typeof === $0e30cf5e5b21caf1$var$k || a.$$typeof === $0e30cf5e5b21caf1$var$n || a.$$typeof === $0e30cf5e5b21caf1$var$w || a.$$typeof === $0e30cf5e5b21caf1$var$x || a.$$typeof === $0e30cf5e5b21caf1$var$y || a.$$typeof === $0e30cf5e5b21caf1$var$v);
};
$0e30cf5e5b21caf1$export$f5bbd400c2f4426f = $0e30cf5e5b21caf1$var$z;

});

parcelRegister("iyhjB", function(module, exports) {

$parcel$export(module.exports, "cx", () => $ce2a5775c1b62f0e$export$a274e22fb40f762e);
$parcel$export(module.exports, "isObject", () => $ce2a5775c1b62f0e$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "runIfFn", () => $ce2a5775c1b62f0e$export$624e501d81f5ffce);
// src/index.ts
var $ce2a5775c1b62f0e$export$a274e22fb40f762e = (...classNames)=>classNames.filter(Boolean).join(" ");
function $ce2a5775c1b62f0e$var$isDev() {
    return false;
}
function $ce2a5775c1b62f0e$export$a6cdc56e425d0d0a(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}
var $ce2a5775c1b62f0e$export$c106dd0671a0fc2d = (options)=>{
    const { condition: condition, message: message } = options;
    if (condition && $ce2a5775c1b62f0e$var$isDev()) console.warn(message);
};
function $ce2a5775c1b62f0e$export$624e501d81f5ffce(valueOrFn, ...args) {
    return $ce2a5775c1b62f0e$var$isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
var $ce2a5775c1b62f0e$var$isFunction = (value)=>typeof value === "function";
var $ce2a5775c1b62f0e$export$5cc3b7b83e34ade7 = (condition)=>condition ? "" : void 0;
var $ce2a5775c1b62f0e$export$91a6105db3d4be7b = (condition)=>condition ? true : void 0;
function $ce2a5775c1b62f0e$export$5bdd3f730ec2c47e(...fns) {
    return function func(event) {
        fns.some((fn)=>{
            fn == null || fn(event);
            return event == null ? void 0 : event.defaultPrevented;
        });
    };
}
function $ce2a5775c1b62f0e$export$9dd9a52f2dd5b9ce(...fns) {
    return function mergedFn(arg) {
        fns.forEach((fn)=>{
            fn == null || fn(arg);
        });
    };
}

});

parcelRegister("eltz3", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeMax = Math.max, nativeNow = Date.now;
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map"), nativeCreate = getNative(Object, "create");
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
    baseMerge(object, source, srcIndex, customizer);
});
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = mergeWith;

});

parcelRegister("ddByY", function(module, exports) {

$parcel$export(module.exports, "useEnvironment", () => $9c3af75ce97970ff$export$ea7ed2425832167d);
$parcel$export(module.exports, "EnvironmentProvider", () => $9c3af75ce97970ff$export$29a4c0b32fc9db42);

var $jGf8z = parcelRequire("jGf8z");

var $3qjKr = parcelRequire("3qjKr");

var $4mwsf = parcelRequire("4mwsf");
"use client";
var $9c3af75ce97970ff$var$EnvironmentContext = (0, $3qjKr.createContext)({
    getDocument () {
        return document;
    },
    getWindow () {
        return window;
    }
});
$9c3af75ce97970ff$var$EnvironmentContext.displayName = "EnvironmentContext";
function $9c3af75ce97970ff$export$ea7ed2425832167d({ defer: defer } = {}) {
    const [, forceUpdate] = (0, $3qjKr.useReducer)((c)=>c + 1, 0);
    (0, $jGf8z.useSafeLayoutEffect)(()=>{
        if (!defer) return;
        forceUpdate();
    }, [
        defer
    ]);
    return (0, $3qjKr.useContext)($9c3af75ce97970ff$var$EnvironmentContext);
}
function $9c3af75ce97970ff$export$29a4c0b32fc9db42(props) {
    const { children: children, environment: environmentProp, disabled: disabled } = props;
    const ref = (0, $3qjKr.useRef)(null);
    const context = (0, $3qjKr.useMemo)(()=>{
        if (environmentProp) return environmentProp;
        return {
            getDocument: ()=>{
                var _a, _b;
                return (_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument) != null ? _b : document;
            },
            getWindow: ()=>{
                var _a, _b;
                return (_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument.defaultView) != null ? _b : window;
            }
        };
    }, [
        environmentProp
    ]);
    const showSpan = !disabled || !environmentProp;
    return /* @__PURE__ */ (0, $4mwsf.jsxs)($9c3af75ce97970ff$var$EnvironmentContext.Provider, {
        value: context,
        children: [
            children,
            showSpan && /* @__PURE__ */ (0, $4mwsf.jsx)("span", {
                id: "__chakra_env",
                hidden: true,
                ref: ref
            })
        ]
    });
}
$9c3af75ce97970ff$export$29a4c0b32fc9db42.displayName = "EnvironmentProvider";

});
parcelRegister("jGf8z", function(module, exports) {

$parcel$export(module.exports, "useSafeLayoutEffect", () => $6573b45e2573fdb8$export$deebe11a338de063);

var $3qjKr = parcelRequire("3qjKr");
"use client";
var $6573b45e2573fdb8$export$deebe11a338de063 = Boolean(globalThis == null ? void 0 : globalThis.document) ? (0, $3qjKr.useLayoutEffect) : (0, $3qjKr.useEffect);

});


parcelRegister("dRSS2", function(module, exports) {

$parcel$export(module.exports, "motion", () => $d7fa1f82583d5fa0$export$e25e478948902b8b);

var $kb8Tn = parcelRequire("kb8Tn");

var $2Mg9e = parcelRequire("2Mg9e");

var $eOfPe = parcelRequire("eOfPe");

var $kjEY4 = parcelRequire("kjEY4");

var $75gkt = parcelRequire("75gkt");

var $dtsrn = parcelRequire("dtsrn");

var $3iDhu = parcelRequire("3iDhu");

var $k6rxW = parcelRequire("k6rxW");
const $d7fa1f82583d5fa0$var$preloadedFeatures = {
    ...(0, $75gkt.animations),
    ...(0, $kjEY4.gestureAnimations),
    ...(0, $dtsrn.drag),
    ...(0, $k6rxW.layout)
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ const $d7fa1f82583d5fa0$export$e25e478948902b8b = /*@__PURE__*/ (0, $2Mg9e.createMotionProxy)((Component, config)=>(0, $eOfPe.createDomMotionConfig)(Component, config, $d7fa1f82583d5fa0$var$preloadedFeatures, (0, $3iDhu.createDomVisualElement)));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $d7fa1f82583d5fa0$export$546614c4a05701f9(key) {
    return (0, $kb8Tn.createMotionComponent)((0, $eOfPe.createDomMotionConfig)(key, {
        forwardMotionProps: false
    }, $d7fa1f82583d5fa0$var$preloadedFeatures, (0, $3iDhu.createDomVisualElement)));
}

});
parcelRegister("kb8Tn", function(module, exports) {

$parcel$export(module.exports, "createMotionComponent", () => $358ae0d70310d751$export$46b7e4b9dc6110c3);

var $3qjKr = parcelRequire("3qjKr");

var $geN69 = parcelRequire("geN69");

var $hv8m4 = parcelRequire("hv8m4");

var $acEoo = parcelRequire("acEoo");

var $dbva9 = parcelRequire("dbva9");

var $e26Oi = parcelRequire("e26Oi");

var $kKJsG = parcelRequire("kKJsG");

var $aDRop = parcelRequire("aDRop");

var $dhRBH = parcelRequire("dhRBH");

var $gQ7hU = parcelRequire("gQ7hU");

var $dW1Dq = parcelRequire("dW1Dq");

var $7SKdC = parcelRequire("7SKdC");
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $358ae0d70310d751$export$46b7e4b9dc6110c3({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $kKJsG.loadFeatures)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $3qjKr.useContext)((0, $geN69.MotionConfigContext)),
            ...props,
            layoutId: $358ae0d70310d751$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $e26Oi.useCreateMotionContext)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $aDRop.isBrowser)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $acEoo.useVisualElement)(Component, visualState, configAndProps, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */ const initialLayoutGroupConfig = (0, $3qjKr.useContext)((0, $dW1Dq.SwitchLayoutGroupContext));
            const isStrict = (0, $3qjKr.useContext)((0, $gQ7hU.LazyContext)).strict;
            if (context.visualElement) MeasureLayout = context.visualElement.loadFeatures(// Note: Pass the full new combined props to correctly re-render dynamic feature components.
            configAndProps, isStrict, preloadedFeatures, initialLayoutGroupConfig);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return $3qjKr.createElement((0, $hv8m4.MotionContext).Provider, {
            value: context
        }, MeasureLayout && context.visualElement ? $3qjKr.createElement(MeasureLayout, {
            visualElement: context.visualElement,
            ...configAndProps
        }) : null, useRender(Component, props, (0, $dbva9.useMotionRef)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement));
    }
    const ForwardRefComponent = (0, $3qjKr.forwardRef)(MotionComponent);
    ForwardRefComponent[0, $7SKdC.motionComponentSymbol] = Component;
    return ForwardRefComponent;
}
function $358ae0d70310d751$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $3qjKr.useContext)((0, $dhRBH.LayoutGroupContext)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}

});
parcelRegister("geN69", function(module, exports) {

$parcel$export(module.exports, "MotionConfigContext", () => $6f606955f54ece7d$export$22a697fb29aac98d);

var $3qjKr = parcelRequire("3qjKr");
/**
 * @public
 */ const $6f606955f54ece7d$export$22a697fb29aac98d = (0, $3qjKr.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});

});

parcelRegister("hv8m4", function(module, exports) {

$parcel$export(module.exports, "MotionContext", () => $214a5d2fefb7aec2$export$2285bbca2c666415);

var $3qjKr = parcelRequire("3qjKr");
const $214a5d2fefb7aec2$export$2285bbca2c666415 = (0, $3qjKr.createContext)({});

});

parcelRegister("acEoo", function(module, exports) {

$parcel$export(module.exports, "useVisualElement", () => $4761eb413497a924$export$dc0335d73ab0b115);

var $3qjKr = parcelRequire("3qjKr");

var $dMYJ7 = parcelRequire("dMYJ7");

var $hv8m4 = parcelRequire("hv8m4");

var $hTRhw = parcelRequire("hTRhw");

var $gQ7hU = parcelRequire("gQ7hU");

var $geN69 = parcelRequire("geN69");

var $9KlOx = parcelRequire("9KlOx");
function $4761eb413497a924$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    const { visualElement: parent } = (0, $3qjKr.useContext)((0, $hv8m4.MotionContext));
    const lazyContext = (0, $3qjKr.useContext)((0, $gQ7hU.LazyContext));
    const presenceContext = (0, $3qjKr.useContext)((0, $dMYJ7.PresenceContext));
    const reducedMotionConfig = (0, $3qjKr.useContext)((0, $geN69.MotionConfigContext)).reducedMotion;
    const visualElementRef = (0, $3qjKr.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    (0, $3qjKr.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const wantsHandoff = (0, $3qjKr.useRef)(Boolean(props[0, $9KlOx.optimizedAppearDataAttribute] && !window.HandoffComplete));
    (0, $hTRhw.useIsomorphicLayoutEffect)(()=>{
        if (!visualElement) return;
        visualElement.render();
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $3qjKr.useEffect)(()=>{
        if (!visualElement) return;
        visualElement.updateFeatures();
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            wantsHandoff.current = false;
            // This ensures all future calls to animateChanges() will run in useEffect
            window.HandoffComplete = true;
        }
    });
    return visualElement;
}

});
parcelRegister("dMYJ7", function(module, exports) {

$parcel$export(module.exports, "PresenceContext", () => $351ac348000eb502$export$f224e4635b6f8ce2);

var $3qjKr = parcelRequire("3qjKr");
/**
 * @public
 */ const $351ac348000eb502$export$f224e4635b6f8ce2 = (0, $3qjKr.createContext)(null);

});

parcelRegister("hTRhw", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $edbd04c5266f4f1c$export$700979bc83e7db82);

var $3qjKr = parcelRequire("3qjKr");

var $aDRop = parcelRequire("aDRop");
const $edbd04c5266f4f1c$export$700979bc83e7db82 = (0, $aDRop.isBrowser) ? (0, $3qjKr.useLayoutEffect) : (0, $3qjKr.useEffect);

});
parcelRegister("aDRop", function(module, exports) {

$parcel$export(module.exports, "isBrowser", () => $196c3b9f50c0311b$export$4e09c449d6c407f7);
const $196c3b9f50c0311b$export$4e09c449d6c407f7 = typeof document !== "undefined";

});


parcelRegister("gQ7hU", function(module, exports) {

$parcel$export(module.exports, "LazyContext", () => $b93360f37589daf9$export$40f10139ecf1f171);

var $3qjKr = parcelRequire("3qjKr");
const $b93360f37589daf9$export$40f10139ecf1f171 = (0, $3qjKr.createContext)({
    strict: false
});

});

parcelRegister("9KlOx", function(module, exports) {

$parcel$export(module.exports, "optimizedAppearDataAttribute", () => $e013138af419ceea$export$8592e1c077c890a6);

var $8cO1j = parcelRequire("8cO1j");
const $e013138af419ceea$export$ed7b8fa9dbf0105d = "framerAppearId";
const $e013138af419ceea$export$8592e1c077c890a6 = "data-" + (0, $8cO1j.camelToDash)($e013138af419ceea$export$ed7b8fa9dbf0105d);

});
parcelRegister("8cO1j", function(module, exports) {

$parcel$export(module.exports, "camelToDash", () => $cfea68b0c6033a0c$export$9fd24a634729c672);
/**
 * Convert camelCase to dash-case properties.
 */ const $cfea68b0c6033a0c$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();

});



parcelRegister("dbva9", function(module, exports) {

$parcel$export(module.exports, "useMotionRef", () => $7067ff6a66451207$export$c684914703d321fd);

var $3qjKr = parcelRequire("3qjKr");

var $h29D1 = parcelRequire("h29D1");
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $7067ff6a66451207$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $3qjKr.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $h29D1.isRefObject)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}

});
parcelRegister("h29D1", function(module, exports) {

$parcel$export(module.exports, "isRefObject", () => $35799e6e07e10aa8$export$dedd81df7bc1307);
function $35799e6e07e10aa8$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

});


parcelRegister("e26Oi", function(module, exports) {

$parcel$export(module.exports, "useCreateMotionContext", () => $8734f3d0b8c593b0$export$c5638d843b37a176);

var $3qjKr = parcelRequire("3qjKr");

var $hv8m4 = parcelRequire("hv8m4");

var $kDbvR = parcelRequire("kDbvR");
function $8734f3d0b8c593b0$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $kDbvR.getCurrentTreeVariants)(props, (0, $3qjKr.useContext)((0, $hv8m4.MotionContext)));
    return (0, $3qjKr.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $8734f3d0b8c593b0$var$variantLabelsAsDependency(initial),
        $8734f3d0b8c593b0$var$variantLabelsAsDependency(animate)
    ]);
}
function $8734f3d0b8c593b0$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

});
parcelRegister("kDbvR", function(module, exports) {

$parcel$export(module.exports, "getCurrentTreeVariants", () => $120ee964e4f2699f$export$12fc32fc096a04a3);

var $jG6Uh = parcelRequire("jG6Uh");

var $7qjRv = parcelRequire("7qjRv");
function $120ee964e4f2699f$export$12fc32fc096a04a3(props, context) {
    if ((0, $7qjRv.isControllingVariants)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $jG6Uh.isVariantLabel)(initial) ? initial : undefined,
            animate: (0, $jG6Uh.isVariantLabel)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}

});
parcelRegister("jG6Uh", function(module, exports) {

$parcel$export(module.exports, "isVariantLabel", () => $51b63f3e9f1edf7a$export$720b90e312cea233);
/**
 * Decides if the supplied variable is variant label
 */ function $51b63f3e9f1edf7a$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}

});

parcelRegister("7qjRv", function(module, exports) {

$parcel$export(module.exports, "isControllingVariants", () => $b8b8ae1bdb5f6806$export$4b3c3bd8d910d78d);
$parcel$export(module.exports, "isVariantNode", () => $b8b8ae1bdb5f6806$export$ce46fa4165cdec40);

var $76EU5 = parcelRequire("76EU5");

var $jG6Uh = parcelRequire("jG6Uh");

var $9y3RP = parcelRequire("9y3RP");
function $b8b8ae1bdb5f6806$export$4b3c3bd8d910d78d(props) {
    return (0, $76EU5.isAnimationControls)(props.animate) || (0, $9y3RP.variantProps).some((name)=>(0, $jG6Uh.isVariantLabel)(props[name]));
}
function $b8b8ae1bdb5f6806$export$ce46fa4165cdec40(props) {
    return Boolean($b8b8ae1bdb5f6806$export$4b3c3bd8d910d78d(props) || props.variants);
}

});
parcelRegister("76EU5", function(module, exports) {

$parcel$export(module.exports, "isAnimationControls", () => $9ccdf7dd73dd935d$export$aa71198ceeaf53ce);
function $9ccdf7dd73dd935d$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}

});

parcelRegister("9y3RP", function(module, exports) {

$parcel$export(module.exports, "variantPriorityOrder", () => $fcaff635563050bd$export$16e45afcc206d3a8);
$parcel$export(module.exports, "variantProps", () => $fcaff635563050bd$export$1405a65085f40b9);
const $fcaff635563050bd$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $fcaff635563050bd$export$1405a65085f40b9 = [
    "initial",
    ...$fcaff635563050bd$export$16e45afcc206d3a8
];

});




parcelRegister("kKJsG", function(module, exports) {

$parcel$export(module.exports, "loadFeatures", () => $eeb8a5b7afa26d43$export$449561ec5703cdc8);

var $0KLeb = parcelRequire("0KLeb");
function $eeb8a5b7afa26d43$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $0KLeb.featureDefinitions)[key] = {
        ...(0, $0KLeb.featureDefinitions)[key],
        ...features[key]
    };
}

});
parcelRegister("0KLeb", function(module, exports) {

$parcel$export(module.exports, "featureDefinitions", () => $b16f15ea4f711456$export$65570e08d843624d);
const $b16f15ea4f711456$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $b16f15ea4f711456$export$65570e08d843624d = {};
for(const key in $b16f15ea4f711456$var$featureProps)$b16f15ea4f711456$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$b16f15ea4f711456$var$featureProps[key].some((name)=>!!props[name])
};

});


parcelRegister("dhRBH", function(module, exports) {

$parcel$export(module.exports, "LayoutGroupContext", () => $3ff0cfaebec47ed3$export$a3579ca508007a95);

var $3qjKr = parcelRequire("3qjKr");
const $3ff0cfaebec47ed3$export$a3579ca508007a95 = (0, $3qjKr.createContext)({});

});

parcelRegister("dW1Dq", function(module, exports) {

$parcel$export(module.exports, "SwitchLayoutGroupContext", () => $36e98caad151ba40$export$da5f7b802957459a);

var $3qjKr = parcelRequire("3qjKr");
/**
 * Internal, exported only for usage in Framer
 */ const $36e98caad151ba40$export$da5f7b802957459a = (0, $3qjKr.createContext)({});

});

parcelRegister("7SKdC", function(module, exports) {

$parcel$export(module.exports, "motionComponentSymbol", () => $a28aefe9f61631d1$export$28e2e4cce424ae23);
const $a28aefe9f61631d1$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");

});


parcelRegister("2Mg9e", function(module, exports) {

$parcel$export(module.exports, "createMotionProxy", () => $fc37437c81a307f8$export$a28d6df673050e18);

var $kb8Tn = parcelRequire("kb8Tn");
/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $fc37437c81a307f8$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return (0, $kb8Tn.createMotionComponent)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}

});

parcelRegister("eOfPe", function(module, exports) {

$parcel$export(module.exports, "createDomMotionConfig", () => $113888a2d2da7b25$export$732916c0e88175fb);

var $d3WXv = parcelRequire("d3WXv");

var $8kQwg = parcelRequire("8kQwg");

var $lMc7o = parcelRequire("lMc7o");

var $1q9wz = parcelRequire("1q9wz");
function $113888a2d2da7b25$export$732916c0e88175fb(Component, { forwardMotionProps: forwardMotionProps = false }, preloadedFeatures, createVisualElement) {
    const baseConfig = (0, $d3WXv.isSVGComponent)(Component) ? (0, $lMc7o.svgMotionConfig) : (0, $1q9wz.htmlMotionConfig);
    return {
        ...baseConfig,
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $8kQwg.createUseRender)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    };
}

});
parcelRegister("d3WXv", function(module, exports) {

$parcel$export(module.exports, "isSVGComponent", () => $5e6719a6e633f668$export$88f3fc2fd3766989);

var $9WQc5 = parcelRequire("9WQc5");
function $5e6719a6e633f668$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $9WQc5.lowercaseSVGElements).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}

});
parcelRegister("9WQc5", function(module, exports) {

$parcel$export(module.exports, "lowercaseSVGElements", () => $a8229439b25602e3$export$40209c4c512158e6);
/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $a8229439b25602e3$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];

});


parcelRegister("8kQwg", function(module, exports) {

$parcel$export(module.exports, "createUseRender", () => $8eb050b56e8a43ef$export$5d29104eefd89cc8);

var $3qjKr = parcelRequire("3qjKr");

var $1LOGn = parcelRequire("1LOGn");

var $iOXzM = parcelRequire("iOXzM");

var $d3WXv = parcelRequire("d3WXv");

var $9kiID = parcelRequire("9kiID");

var $cV7py = parcelRequire("cV7py");
function $8eb050b56e8a43ef$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $d3WXv.isSVGComponent)(Component) ? (0, $9kiID.useSVGProps) : (0, $1LOGn.useHTMLProps);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $iOXzM.filterProps)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = {
            ...filteredProps,
            ...visualProps,
            ref: ref
        };
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $3qjKr.useMemo)(()=>(0, $cV7py.isMotionValue)(children) ? children.get() : children, [
            children
        ]);
        return (0, $3qjKr.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}

});
parcelRegister("1LOGn", function(module, exports) {

$parcel$export(module.exports, "copyRawValuesOnly", () => $2c600b400b8cd206$export$40dafdb8630c956b);
$parcel$export(module.exports, "useHTMLProps", () => $2c600b400b8cd206$export$57be0a314572d87d);

var $3qjKr = parcelRequire("3qjKr");

var $lcVU0 = parcelRequire("lcVU0");

var $cV7py = parcelRequire("cV7py");

var $9bx9Q = parcelRequire("9bx9Q");

var $1Vryx = parcelRequire("1Vryx");
function $2c600b400b8cd206$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $cV7py.isMotionValue)(source[key]) && !(0, $lcVU0.isForcedMotionValue)(key, props)) target[key] = source[key];
}
function $2c600b400b8cd206$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState, isStatic) {
    return (0, $3qjKr.useMemo)(()=>{
        const state = (0, $1Vryx.createHtmlRenderState)();
        (0, $9bx9Q.buildHTMLStyles)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $2c600b400b8cd206$var$useStyle(props, visualState, isStatic) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $2c600b400b8cd206$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $2c600b400b8cd206$var$useInitialMotionValues(props, visualState, isStatic));
    return props.transformValues ? props.transformValues(style) : style;
}
function $2c600b400b8cd206$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $2c600b400b8cd206$var$useStyle(props, visualState, isStatic);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}

});
parcelRegister("lcVU0", function(module, exports) {

$parcel$export(module.exports, "isForcedMotionValue", () => $7540b5c35f3a6585$export$6d27ce8e3de1c3cf);

var $01mqa = parcelRequire("01mqa");

var $1ewxR = parcelRequire("1ewxR");
function $7540b5c35f3a6585$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $1ewxR.transformProps).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $01mqa.scaleCorrectors)[key] || key === "opacity");
}

});
parcelRegister("01mqa", function(module, exports) {

$parcel$export(module.exports, "scaleCorrectors", () => $69b954a17e7d055d$export$91ddd985b97788d1);
$parcel$export(module.exports, "addScaleCorrector", () => $69b954a17e7d055d$export$de9e7791c71225fd);
const $69b954a17e7d055d$export$91ddd985b97788d1 = {};
function $69b954a17e7d055d$export$de9e7791c71225fd(correctors) {
    Object.assign($69b954a17e7d055d$export$91ddd985b97788d1, correctors);
}

});

parcelRegister("1ewxR", function(module, exports) {

$parcel$export(module.exports, "transformPropOrder", () => $14909b1ca57018bc$export$280dc01950909d86);
$parcel$export(module.exports, "transformProps", () => $14909b1ca57018bc$export$7b42a0094fb00b6e);
/**
 * Generate a list of every possible transform key.
 */ const $14909b1ca57018bc$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $14909b1ca57018bc$export$7b42a0094fb00b6e = new Set($14909b1ca57018bc$export$280dc01950909d86);

});


parcelRegister("cV7py", function(module, exports) {

$parcel$export(module.exports, "isMotionValue", () => $cc53bd6700258d03$export$605d60a2578142d3);
const $cc53bd6700258d03$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);

});

parcelRegister("9bx9Q", function(module, exports) {

$parcel$export(module.exports, "buildHTMLStyles", () => $8558eb9efa10b469$export$bb517f8b40f8e99d);

var $4xXx8 = parcelRequire("4xXx8");

var $4RRaL = parcelRequire("4RRaL");

var $1ewxR = parcelRequire("1ewxR");

var $49RvZ = parcelRequire("49RvZ");

var $4UnGW = parcelRequire("4UnGW");
function $8558eb9efa10b469$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    const { style: style, vars: vars, transform: transform, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $4RRaL.isCSSVariableName)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = (0, $4UnGW.numberValueTypes)[key];
        const valueAsType = (0, $49RvZ.getValueAsType)(value, valueType);
        if ((0, $1ewxR.transformProps).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0)) transformIsNone = false;
        } else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        } else style[key] = valueAsType;
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $4xXx8.buildTransform)(state.transform, options, transformIsNone, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}

});
parcelRegister("4xXx8", function(module, exports) {

$parcel$export(module.exports, "buildTransform", () => $24844537c06c7ac0$export$bdc96e0d5c8f914);

var $1ewxR = parcelRequire("1ewxR");
const $24844537c06c7ac0$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $24844537c06c7ac0$var$numTransforms = (0, $1ewxR.transformPropOrder).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $24844537c06c7ac0$export$bdc96e0d5c8f914(transform, { enableHardwareAcceleration: enableHardwareAcceleration = true, allowTransformNone: allowTransformNone = true }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $24844537c06c7ac0$var$numTransforms; i++){
        const key = (0, $1ewxR.transformPropOrder)[i];
        if (transform[key] !== undefined) {
            const transformName = $24844537c06c7ac0$var$translateAlias[key] || key;
            transformString += `${transformName}(${transform[key]}) `;
        }
    }
    if (enableHardwareAcceleration && !transform.z) transformString += "translateZ(0)";
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}

});

parcelRegister("4RRaL", function(module, exports) {

$parcel$export(module.exports, "isCSSVariableName", () => $9b170de4c48626a8$export$9de1236619d9e756);
$parcel$export(module.exports, "isCSSVariableToken", () => $9b170de4c48626a8$export$31f9caa2600b5723);
$parcel$export(module.exports, "cssVariableRegex", () => $9b170de4c48626a8$export$f7c0a352d8ef6313);
const $9b170de4c48626a8$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $9b170de4c48626a8$export$9de1236619d9e756 = $9b170de4c48626a8$var$checkStringStartsWith("--");
const $9b170de4c48626a8$export$31f9caa2600b5723 = $9b170de4c48626a8$var$checkStringStartsWith("var(--");
const $9b170de4c48626a8$export$f7c0a352d8ef6313 = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g;

});

parcelRegister("49RvZ", function(module, exports) {

$parcel$export(module.exports, "getValueAsType", () => $897241026453b0b4$export$453ef540a9a1bd6b);
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $897241026453b0b4$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};

});

parcelRegister("4UnGW", function(module, exports) {

$parcel$export(module.exports, "numberValueTypes", () => $ffe29922c37db369$export$eec14432cd1cb67b);

var $kRios = parcelRequire("kRios");

var $9PDxZ = parcelRequire("9PDxZ");

var $kZ9pY = parcelRequire("kZ9pY");
const $ffe29922c37db369$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $9PDxZ.px),
    borderTopWidth: (0, $9PDxZ.px),
    borderRightWidth: (0, $9PDxZ.px),
    borderBottomWidth: (0, $9PDxZ.px),
    borderLeftWidth: (0, $9PDxZ.px),
    borderRadius: (0, $9PDxZ.px),
    radius: (0, $9PDxZ.px),
    borderTopLeftRadius: (0, $9PDxZ.px),
    borderTopRightRadius: (0, $9PDxZ.px),
    borderBottomRightRadius: (0, $9PDxZ.px),
    borderBottomLeftRadius: (0, $9PDxZ.px),
    // Positioning props
    width: (0, $9PDxZ.px),
    maxWidth: (0, $9PDxZ.px),
    height: (0, $9PDxZ.px),
    maxHeight: (0, $9PDxZ.px),
    size: (0, $9PDxZ.px),
    top: (0, $9PDxZ.px),
    right: (0, $9PDxZ.px),
    bottom: (0, $9PDxZ.px),
    left: (0, $9PDxZ.px),
    // Spacing props
    padding: (0, $9PDxZ.px),
    paddingTop: (0, $9PDxZ.px),
    paddingRight: (0, $9PDxZ.px),
    paddingBottom: (0, $9PDxZ.px),
    paddingLeft: (0, $9PDxZ.px),
    margin: (0, $9PDxZ.px),
    marginTop: (0, $9PDxZ.px),
    marginRight: (0, $9PDxZ.px),
    marginBottom: (0, $9PDxZ.px),
    marginLeft: (0, $9PDxZ.px),
    // Transform props
    rotate: (0, $9PDxZ.degrees),
    rotateX: (0, $9PDxZ.degrees),
    rotateY: (0, $9PDxZ.degrees),
    rotateZ: (0, $9PDxZ.degrees),
    scale: $kRios.scale,
    scaleX: (0, $kRios.scale),
    scaleY: (0, $kRios.scale),
    scaleZ: (0, $kRios.scale),
    skew: (0, $9PDxZ.degrees),
    skewX: (0, $9PDxZ.degrees),
    skewY: (0, $9PDxZ.degrees),
    distance: (0, $9PDxZ.px),
    translateX: (0, $9PDxZ.px),
    translateY: (0, $9PDxZ.px),
    translateZ: (0, $9PDxZ.px),
    x: (0, $9PDxZ.px),
    y: (0, $9PDxZ.px),
    z: (0, $9PDxZ.px),
    perspective: (0, $9PDxZ.px),
    transformPerspective: (0, $9PDxZ.px),
    opacity: (0, $kRios.alpha),
    originX: (0, $9PDxZ.progressPercentage),
    originY: (0, $9PDxZ.progressPercentage),
    originZ: (0, $9PDxZ.px),
    // Misc
    zIndex: (0, $kZ9pY.int),
    // SVG
    fillOpacity: (0, $kRios.alpha),
    strokeOpacity: (0, $kRios.alpha),
    numOctaves: (0, $kZ9pY.int)
};

});
parcelRegister("kRios", function(module, exports) {

$parcel$export(module.exports, "number", () => $c18610f1b5207a08$export$98e628dec113755e);
$parcel$export(module.exports, "alpha", () => $c18610f1b5207a08$export$58f0f39f63f3cf42);
$parcel$export(module.exports, "scale", () => $c18610f1b5207a08$export$dcdf75081b88279d);

var $8WJMW = parcelRequire("8WJMW");
const $c18610f1b5207a08$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $c18610f1b5207a08$export$58f0f39f63f3cf42 = {
    ...$c18610f1b5207a08$export$98e628dec113755e,
    transform: (v)=>(0, $8WJMW.clamp)(0, 1, v)
};
const $c18610f1b5207a08$export$dcdf75081b88279d = {
    ...$c18610f1b5207a08$export$98e628dec113755e,
    default: 1
};

});
parcelRegister("8WJMW", function(module, exports) {

$parcel$export(module.exports, "clamp", () => $d3184d4d5db0f207$export$7d15b64cf5a3a4c4);
const $d3184d4d5db0f207$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);

});


parcelRegister("9PDxZ", function(module, exports) {

$parcel$export(module.exports, "degrees", () => $6b4161d3b4993fcd$export$41fc368e1a942b97);
$parcel$export(module.exports, "percent", () => $6b4161d3b4993fcd$export$626336c2cd4b14de);
$parcel$export(module.exports, "px", () => $6b4161d3b4993fcd$export$91c0eda1d06bf008);
$parcel$export(module.exports, "vh", () => $6b4161d3b4993fcd$export$f91e8c45a95a32f2);
$parcel$export(module.exports, "vw", () => $6b4161d3b4993fcd$export$aed3d7b7d206c196);
$parcel$export(module.exports, "progressPercentage", () => $6b4161d3b4993fcd$export$44e2e1705876d7ed);

var $j5Bkz = parcelRequire("j5Bkz");
const $6b4161d3b4993fcd$var$createUnitType = (unit)=>({
        test: (v)=>(0, $j5Bkz.isString)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $6b4161d3b4993fcd$export$41fc368e1a942b97 = $6b4161d3b4993fcd$var$createUnitType("deg");
const $6b4161d3b4993fcd$export$626336c2cd4b14de = $6b4161d3b4993fcd$var$createUnitType("%");
const $6b4161d3b4993fcd$export$91c0eda1d06bf008 = $6b4161d3b4993fcd$var$createUnitType("px");
const $6b4161d3b4993fcd$export$f91e8c45a95a32f2 = $6b4161d3b4993fcd$var$createUnitType("vh");
const $6b4161d3b4993fcd$export$aed3d7b7d206c196 = $6b4161d3b4993fcd$var$createUnitType("vw");
const $6b4161d3b4993fcd$export$44e2e1705876d7ed = {
    ...$6b4161d3b4993fcd$export$626336c2cd4b14de,
    parse: (v)=>$6b4161d3b4993fcd$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$6b4161d3b4993fcd$export$626336c2cd4b14de.transform(v * 100)
};

});
parcelRegister("j5Bkz", function(module, exports) {

$parcel$export(module.exports, "sanitize", () => $0979630d80f45a6f$export$83d2e9e3e4ee39ed);
$parcel$export(module.exports, "floatRegex", () => $0979630d80f45a6f$export$2444ca58c08448e4);
$parcel$export(module.exports, "colorRegex", () => $0979630d80f45a6f$export$740b69c5fad25dba);
$parcel$export(module.exports, "singleColorRegex", () => $0979630d80f45a6f$export$ed808ff6ecd39e8d);
$parcel$export(module.exports, "isString", () => $0979630d80f45a6f$export$844ec244b1367d54);
/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $0979630d80f45a6f$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $0979630d80f45a6f$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
const $0979630d80f45a6f$export$740b69c5fad25dba = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
const $0979630d80f45a6f$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function $0979630d80f45a6f$export$844ec244b1367d54(v) {
    return typeof v === "string";
}

});


parcelRegister("kZ9pY", function(module, exports) {

$parcel$export(module.exports, "int", () => $3bcf2a56dd28757c$export$7d260a2a5f8bc19e);

var $kRios = parcelRequire("kRios");
const $3bcf2a56dd28757c$export$7d260a2a5f8bc19e = {
    ...(0, $kRios.number),
    transform: Math.round
};

});



parcelRegister("1Vryx", function(module, exports) {

$parcel$export(module.exports, "createHtmlRenderState", () => $f234bbca1317acb0$export$8940b483cf52eeda);
const $f234bbca1317acb0$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });

});


parcelRegister("iOXzM", function(module, exports) {

$parcel$export(module.exports, "filterProps", () => $ba8add19b7299582$export$d697c39a2985a4c);

var $kuMeW = parcelRequire("kuMeW");
let $ba8add19b7299582$var$shouldForward = (key)=>!(0, $kuMeW.isValidMotionProp)(key);
function $ba8add19b7299582$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $ba8add19b7299582$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $kuMeW.isValidMotionProp)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $ba8add19b7299582$export$59d6962c470509a5((parcelRequire("lWNW4")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $ba8add19b7299582$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($ba8add19b7299582$var$shouldForward(key) || forwardMotionProps === true && (0, $kuMeW.isValidMotionProp)(key) || !isDom && !(0, $kuMeW.isValidMotionProp)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}

});
parcelRegister("kuMeW", function(module, exports) {

$parcel$export(module.exports, "isValidMotionProp", () => $3683a2652d91fb81$export$2f9c46555243bf04);
/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $3683a2652d91fb81$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $3683a2652d91fb81$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $3683a2652d91fb81$var$validMotionProps.has(key);
}

});

parcelRegister("lWNW4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffa5bfefc2f55111$export$2e2bcd8739ae039);

var $bsgJ9 = parcelRequire("bsgJ9");
var $ffa5bfefc2f55111$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $ffa5bfefc2f55111$var$index = (0, $bsgJ9.default)(function(prop) {
    return $ffa5bfefc2f55111$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $ffa5bfefc2f55111$export$2e2bcd8739ae039 = $ffa5bfefc2f55111$var$index;

});
parcelRegister("bsgJ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $856f48ea97dcf065$export$2e2bcd8739ae039);
function $856f48ea97dcf065$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $856f48ea97dcf065$export$2e2bcd8739ae039 = $856f48ea97dcf065$var$memoize;

});



parcelRegister("9kiID", function(module, exports) {

$parcel$export(module.exports, "useSVGProps", () => $0278b4b4e1d6ea64$export$84309c4f53cb1bd5);

var $3qjKr = parcelRequire("3qjKr");

var $1LOGn = parcelRequire("1LOGn");

var $dCQSo = parcelRequire("dCQSo");

var $b4D0J = parcelRequire("b4D0J");

var $hn5IJ = parcelRequire("hn5IJ");
function $0278b4b4e1d6ea64$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $3qjKr.useMemo)(()=>{
        const state = (0, $b4D0J.createSvgRenderState)();
        (0, $dCQSo.buildSVGAttrs)(state, visualState, {
            enableHardwareAcceleration: false
        }, (0, $hn5IJ.isSVGTag)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $1LOGn.copyRawValuesOnly)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}

});
parcelRegister("dCQSo", function(module, exports) {

$parcel$export(module.exports, "buildSVGAttrs", () => $ce1e33329f722125$export$5475d24f125d7053);

var $9bx9Q = parcelRequire("9bx9Q");

var $f0NP5 = parcelRequire("f0NP5");

var $qb0He = parcelRequire("qb0He");
/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $ce1e33329f722125$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, options, isSVGTag, transformTemplate) {
    (0, $9bx9Q.buildHTMLStyles)(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $f0NP5.calcSVGTransformOrigin)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $qb0He.buildSVGPath)(attrs, pathLength, pathSpacing, pathOffset, false);
}

});
parcelRegister("f0NP5", function(module, exports) {

$parcel$export(module.exports, "calcSVGTransformOrigin", () => $57052e6978c57ef5$export$d4fbcfc8e5472155);

var $9PDxZ = parcelRequire("9PDxZ");
function $57052e6978c57ef5$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $9PDxZ.px).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $57052e6978c57ef5$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $57052e6978c57ef5$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $57052e6978c57ef5$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}

});

parcelRegister("qb0He", function(module, exports) {

$parcel$export(module.exports, "buildSVGPath", () => $54818c5bf6c12eeb$export$311b43f666da1d82);

var $9PDxZ = parcelRequire("9PDxZ");
const $54818c5bf6c12eeb$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $54818c5bf6c12eeb$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $54818c5bf6c12eeb$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $54818c5bf6c12eeb$var$dashKeys : $54818c5bf6c12eeb$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $9PDxZ.px).transform(-offset);
    // Build the dash array
    const pathLength = (0, $9PDxZ.px).transform(length);
    const pathSpacing = (0, $9PDxZ.px).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}

});


parcelRegister("b4D0J", function(module, exports) {

$parcel$export(module.exports, "createSvgRenderState", () => $59ad0ca90cbd6ace$export$41be8b43e1c4d4f9);

var $1Vryx = parcelRequire("1Vryx");
const $59ad0ca90cbd6ace$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $1Vryx.createHtmlRenderState)(),
        attrs: {}
    });

});

parcelRegister("hn5IJ", function(module, exports) {

$parcel$export(module.exports, "isSVGTag", () => $ec6821bef1e31dec$export$6328ce7565ea1049);
const $ec6821bef1e31dec$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";

});



parcelRegister("lMc7o", function(module, exports) {

$parcel$export(module.exports, "svgMotionConfig", () => $97231ab41f89ecdb$export$44dabd3fae512e85);

var $9hjkH = parcelRequire("9hjkH");

var $1mlXz = parcelRequire("1mlXz");

var $8HTNf = parcelRequire("8HTNf");

var $b4D0J = parcelRequire("b4D0J");

var $dCQSo = parcelRequire("dCQSo");

var $hn5IJ = parcelRequire("hn5IJ");

var $lJeQK = parcelRequire("lJeQK");
const $97231ab41f89ecdb$export$44dabd3fae512e85 = {
    useVisualState: (0, $8HTNf.makeUseVisualState)({
        scrapeMotionValuesFromProps: (0, $1mlXz.scrapeMotionValuesFromProps),
        createRenderState: (0, $b4D0J.createSvgRenderState),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            (0, $lJeQK.frame).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $lJeQK.frame).render(()=>{
                (0, $dCQSo.buildSVGAttrs)(renderState, latestValues, {
                    enableHardwareAcceleration: false
                }, (0, $hn5IJ.isSVGTag)(instance.tagName), props.transformTemplate);
                (0, $9hjkH.renderSVG)(instance, renderState);
            });
        }
    })
};

});
parcelRegister("9hjkH", function(module, exports) {

$parcel$export(module.exports, "renderSVG", () => $8ac9c86953fb4893$export$c5f8399d19a7394b);

var $8cO1j = parcelRequire("8cO1j");

var $0LmxL = parcelRequire("0LmxL");

var $lARPw = parcelRequire("lARPw");
function $8ac9c86953fb4893$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $0LmxL.renderHTML)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $lARPw.camelCaseAttributes).has(key) ? (0, $8cO1j.camelToDash)(key) : key, renderState.attrs[key]);
}

});
parcelRegister("0LmxL", function(module, exports) {

$parcel$export(module.exports, "renderHTML", () => $66cc073b09c5aa70$export$1a32bf6229c258c0);
function $66cc073b09c5aa70$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}

});

parcelRegister("lARPw", function(module, exports) {

$parcel$export(module.exports, "camelCaseAttributes", () => $8ded2c61a7bceb22$export$28931db5d57958e5);
/**
 * A set of attribute names that are always read/written as camel case.
 */ const $8ded2c61a7bceb22$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);

});


parcelRegister("1mlXz", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", () => $14722cc0c00366e8$export$16da615486abaa45);

var $cV7py = parcelRequire("cV7py");

var $qNfEF = parcelRequire("qNfEF");

var $1ewxR = parcelRequire("1ewxR");
function $14722cc0c00366e8$export$16da615486abaa45(props, prevProps) {
    const newValues = (0, $qNfEF.scrapeMotionValuesFromProps)(props, prevProps);
    for(const key in props)if ((0, $cV7py.isMotionValue)(props[key]) || (0, $cV7py.isMotionValue)(prevProps[key])) {
        const targetKey = (0, $1ewxR.transformPropOrder).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}

});
parcelRegister("qNfEF", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", () => $07947ed0431c1016$export$16da615486abaa45);

var $lcVU0 = parcelRequire("lcVU0");

var $cV7py = parcelRequire("cV7py");
function $07947ed0431c1016$export$16da615486abaa45(props, prevProps) {
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $cV7py.isMotionValue)(style[key]) || prevProps.style && (0, $cV7py.isMotionValue)(prevProps.style[key]) || (0, $lcVU0.isForcedMotionValue)(key, props)) newValues[key] = style[key];
    return newValues;
}

});


parcelRegister("8HTNf", function(module, exports) {

$parcel$export(module.exports, "makeUseVisualState", () => $b760153d3919db5a$export$e91e107bc6d03a8e);

var $3qjKr = parcelRequire("3qjKr");

var $76EU5 = parcelRequire("76EU5");

var $dMYJ7 = parcelRequire("dMYJ7");

var $jEvFY = parcelRequire("jEvFY");

var $cStpt = parcelRequire("cStpt");

var $7BLmV = parcelRequire("7BLmV");

var $hv8m4 = parcelRequire("hv8m4");

var $7qjRv = parcelRequire("7qjRv");
function $b760153d3919db5a$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext) {
    const state = {
        latestValues: $b760153d3919db5a$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $b760153d3919db5a$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $3qjKr.useContext)((0, $hv8m4.MotionContext));
        const presenceContext = (0, $3qjKr.useContext)((0, $dMYJ7.PresenceContext));
        const make = ()=>$b760153d3919db5a$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $cStpt.useConstant)(make);
    };
function $b760153d3919db5a$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $7BLmV.resolveMotionValue)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $7qjRv.isControllingVariants)(props);
    const isVariantNode$1 = (0, $7qjRv.isVariantNode)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $76EU5.isAnimationControls)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach((definition)=>{
            const resolved = (0, $jEvFY.resolveVariantFromProps)(props, definition);
            if (!resolved) return;
            const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
            for(const key in target){
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(const key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}

});
parcelRegister("jEvFY", function(module, exports) {

$parcel$export(module.exports, "resolveVariantFromProps", () => $36c00a4ae1c389d0$export$d68f140c4d9b48bc);
function $36c00a4ae1c389d0$export$d68f140c4d9b48bc(props, definition, custom, currentValues = {}, currentVelocity = {}) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    return definition;
}

});

parcelRegister("cStpt", function(module, exports) {

$parcel$export(module.exports, "useConstant", () => $247789f08a9e07bc$export$fe4300aa8eebea86);

var $3qjKr = parcelRequire("3qjKr");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $247789f08a9e07bc$export$fe4300aa8eebea86(init) {
    const ref = (0, $3qjKr.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}

});

parcelRegister("7BLmV", function(module, exports) {

$parcel$export(module.exports, "resolveMotionValue", () => $384eb75cd1196e7e$export$fcc2206ecb6d74b);

var $7JSeb = parcelRequire("7JSeb");

var $cV7py = parcelRequire("cV7py");
/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $384eb75cd1196e7e$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $cV7py.isMotionValue)(value) ? value.get() : value;
    return (0, $7JSeb.isCustomValue)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}

});
parcelRegister("7JSeb", function(module, exports) {

$parcel$export(module.exports, "isCustomValue", () => $9c52fdfd24cb7340$export$2f308ad9864b3ac9);
$parcel$export(module.exports, "resolveFinalValueInKeyframes", () => $9c52fdfd24cb7340$export$5485128c47bd48bb);

var $l2nMT = parcelRequire("l2nMT");
const $9c52fdfd24cb7340$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $9c52fdfd24cb7340$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $l2nMT.isKeyframesTarget)(v) ? v[v.length - 1] || 0 : v;
};

});
parcelRegister("l2nMT", function(module, exports) {

$parcel$export(module.exports, "isKeyframesTarget", () => $c70a985d102bba45$export$9153ad4c4999f4a0);
const $c70a985d102bba45$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};

});




parcelRegister("lJeQK", function(module, exports) {

$parcel$export(module.exports, "frame", () => $db0fd6c5b11cc719$export$2cef06c20297c17d);
$parcel$export(module.exports, "cancelFrame", () => $db0fd6c5b11cc719$export$ec99c0ef4978dccb);
$parcel$export(module.exports, "frameData", () => $db0fd6c5b11cc719$export$fff89137e9e818ce);
$parcel$export(module.exports, "steps", () => $db0fd6c5b11cc719$export$be3f796aed065412);

var $hsNz5 = parcelRequire("hsNz5");

var $gu1Pz = parcelRequire("gu1Pz");
const { schedule: $db0fd6c5b11cc719$export$2cef06c20297c17d, cancel: $db0fd6c5b11cc719$export$ec99c0ef4978dccb, state: $db0fd6c5b11cc719$export$fff89137e9e818ce, steps: $db0fd6c5b11cc719$export$be3f796aed065412 } = (0, $gu1Pz.createRenderBatcher)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $hsNz5.noop), true);

});
parcelRegister("hsNz5", function(module, exports) {

$parcel$export(module.exports, "noop", () => $aa3d7297e0e91720$export$8793edee2d425525);
const $aa3d7297e0e91720$export$8793edee2d425525 = (any)=>any;

});

parcelRegister("gu1Pz", function(module, exports) {

$parcel$export(module.exports, "createRenderBatcher", () => $9e11ffc06d220c16$export$510b0596a933801a);

var $2zOzc = parcelRequire("2zOzc");
const $9e11ffc06d220c16$export$71ecace0a033b35a = [
    "prepare",
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $9e11ffc06d220c16$var$maxElapsed = 40;
function $9e11ffc06d220c16$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0,
        timestamp: 0,
        isProcessing: false
    };
    const steps = $9e11ffc06d220c16$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $2zOzc.createRenderStep)(()=>runNextFrame = true);
        return acc;
    }, {});
    const processStep = (stepId)=>steps[stepId].process(state);
    const processBatch = ()=>{
        const timestamp = performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $9e11ffc06d220c16$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        $9e11ffc06d220c16$export$71ecace0a033b35a.forEach(processStep);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $9e11ffc06d220c16$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>$9e11ffc06d220c16$export$71ecace0a033b35a.forEach((key)=>steps[key].cancel(process));
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}

});
parcelRegister("2zOzc", function(module, exports) {

$parcel$export(module.exports, "createRenderStep", () => $3e4a7aa479bcdc05$export$b995e5e85f5c8289);
class $3e4a7aa479bcdc05$var$Queue {
    constructor(){
        this.order = [];
        this.scheduled = new Set();
    }
    add(process) {
        if (!this.scheduled.has(process)) {
            this.scheduled.add(process);
            this.order.push(process);
            return true;
        }
    }
    remove(process) {
        const index = this.order.indexOf(process);
        if (index !== -1) {
            this.order.splice(index, 1);
            this.scheduled.delete(process);
        }
    }
    clear() {
        this.order.length = 0;
        this.scheduled.clear();
    }
}
function $3e4a7aa479bcdc05$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new $3e4a7aa479bcdc05$var$Queue();
    let nextFrame = new $3e4a7aa479bcdc05$var$Queue();
    let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (queue.add(callback) && addToCurrentFrame && isProcessing) // If we're adding it to the currently running queue, update its measured size
            numToRun = thisFrame.order.length;
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.remove(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            numToRun = thisFrame.order.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = thisFrame.order[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}

});




parcelRegister("1q9wz", function(module, exports) {

$parcel$export(module.exports, "htmlMotionConfig", () => $1595af4bc5a7c8a0$export$e13ea21d87ea57c8);

var $8HTNf = parcelRequire("8HTNf");

var $qNfEF = parcelRequire("qNfEF");

var $1Vryx = parcelRequire("1Vryx");
const $1595af4bc5a7c8a0$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $8HTNf.makeUseVisualState)({
        scrapeMotionValuesFromProps: $qNfEF.scrapeMotionValuesFromProps,
        createRenderState: (0, $1Vryx.createHtmlRenderState)
    })
};

});


parcelRegister("kjEY4", function(module, exports) {

$parcel$export(module.exports, "gestureAnimations", () => $389dbdec6be4439d$export$e5b72898e5a201f1);

var $EikAC = parcelRequire("EikAC");

var $2jASI = parcelRequire("2jASI");

var $7AX2I = parcelRequire("7AX2I");

var $6MhVe = parcelRequire("6MhVe");
const $389dbdec6be4439d$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $6MhVe.InViewFeature)
    },
    tap: {
        Feature: (0, $7AX2I.PressGesture)
    },
    focus: {
        Feature: (0, $2jASI.FocusGesture)
    },
    hover: {
        Feature: (0, $EikAC.HoverGesture)
    }
};

});
parcelRegister("EikAC", function(module, exports) {

$parcel$export(module.exports, "HoverGesture", () => $2566e7f9d06a9458$export$93a81ea037eac456);

var $Z8cIX = parcelRequire("Z8cIX");

var $jnmzn = parcelRequire("jnmzn");

var $iDnTQ = parcelRequire("iDnTQ");

var $jRBPW = parcelRequire("jRBPW");

var $lJeQK = parcelRequire("lJeQK");
function $2566e7f9d06a9458$var$addHoverEvent(node, isActive) {
    const eventName = "pointer" + (isActive ? "enter" : "leave");
    const callbackName = "onHover" + (isActive ? "Start" : "End");
    const handleEvent = (event, info)=>{
        if (event.pointerType === "touch" || (0, $iDnTQ.isDragActive)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        if (props[callbackName]) (0, $lJeQK.frame).update(()=>props[callbackName](event, info));
    };
    return (0, $Z8cIX.addPointerEvent)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $2566e7f9d06a9458$export$93a81ea037eac456 extends (0, $jRBPW.Feature) {
    mount() {
        this.unmount = (0, $jnmzn.pipe)($2566e7f9d06a9458$var$addHoverEvent(this.node, true), $2566e7f9d06a9458$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}

});
parcelRegister("Z8cIX", function(module, exports) {

$parcel$export(module.exports, "addPointerEvent", () => $db9db84b14459c8f$export$fcff2e64e6676b81);

var $hvbUJ = parcelRequire("hvbUJ");

var $dT4Fd = parcelRequire("dT4Fd");
function $db9db84b14459c8f$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $hvbUJ.addDomEvent)(target, eventName, (0, $dT4Fd.addPointerInfo)(handler), options);
}

});
parcelRegister("hvbUJ", function(module, exports) {

$parcel$export(module.exports, "addDomEvent", () => $f758b206e9fd31c2$export$b1d829ddf82884aa);
function $f758b206e9fd31c2$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}

});

parcelRegister("dT4Fd", function(module, exports) {

$parcel$export(module.exports, "extractEventInfo", () => $9e6fbbfef3cc5ac7$export$12f84bb882d06e1a);
$parcel$export(module.exports, "addPointerInfo", () => $9e6fbbfef3cc5ac7$export$c404e80f92c98d29);

var $KnY8t = parcelRequire("KnY8t");
function $9e6fbbfef3cc5ac7$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[pointType + "X"],
            y: event[pointType + "Y"]
        }
    };
}
const $9e6fbbfef3cc5ac7$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $KnY8t.isPrimaryPointer)(event) && handler(event, $9e6fbbfef3cc5ac7$export$12f84bb882d06e1a(event));
};

});
parcelRegister("KnY8t", function(module, exports) {

$parcel$export(module.exports, "isPrimaryPointer", () => $521195b9dac2a29b$export$a4cf9c8a4b063a6e);
const $521195b9dac2a29b$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};

});



parcelRegister("jnmzn", function(module, exports) {

$parcel$export(module.exports, "pipe", () => $8f18140dca7c1b07$export$a4627e546088548d);
/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $8f18140dca7c1b07$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $8f18140dca7c1b07$export$a4627e546088548d = (...transformers)=>transformers.reduce($8f18140dca7c1b07$var$combineFunctions);

});

parcelRegister("iDnTQ", function(module, exports) {

$parcel$export(module.exports, "getGlobalLock", () => $f6f5a0bffbd78430$export$2b7959ed03c1a3fe);
$parcel$export(module.exports, "isDragActive", () => $f6f5a0bffbd78430$export$1b3dd616664938e4);
function $f6f5a0bffbd78430$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $f6f5a0bffbd78430$var$globalHorizontalLock = $f6f5a0bffbd78430$export$518c5fc2dcb7974b("dragHorizontal");
const $f6f5a0bffbd78430$var$globalVerticalLock = $f6f5a0bffbd78430$export$518c5fc2dcb7974b("dragVertical");
function $f6f5a0bffbd78430$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $f6f5a0bffbd78430$var$globalVerticalLock();
    else if (drag === "x") lock = $f6f5a0bffbd78430$var$globalHorizontalLock();
    else {
        const openHorizontal = $f6f5a0bffbd78430$var$globalHorizontalLock();
        const openVertical = $f6f5a0bffbd78430$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $f6f5a0bffbd78430$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $f6f5a0bffbd78430$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}

});

parcelRegister("jRBPW", function(module, exports) {

$parcel$export(module.exports, "Feature", () => $283d45f297c3ee39$export$6e91cf7616333d5);
class $283d45f297c3ee39$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}

});


parcelRegister("2jASI", function(module, exports) {

$parcel$export(module.exports, "FocusGesture", () => $cf46c86028784dd6$export$d4826db40d47595b);

var $hvbUJ = parcelRequire("hvbUJ");

var $jRBPW = parcelRequire("jRBPW");

var $jnmzn = parcelRequire("jnmzn");
class $cf46c86028784dd6$export$d4826db40d47595b extends (0, $jRBPW.Feature) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $jnmzn.pipe)((0, $hvbUJ.addDomEvent)(this.node.current, "focus", ()=>this.onFocus()), (0, $hvbUJ.addDomEvent)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}

});

parcelRegister("7AX2I", function(module, exports) {

$parcel$export(module.exports, "PressGesture", () => $ba02d1abcfaecc9c$export$f026abdbba7f0c9e);

var $dT4Fd = parcelRequire("dT4Fd");

var $hvbUJ = parcelRequire("hvbUJ");

var $Z8cIX = parcelRequire("Z8cIX");

var $jRBPW = parcelRequire("jRBPW");

var $jnmzn = parcelRequire("jnmzn");

var $iDnTQ = parcelRequire("iDnTQ");

var $aTt6S = parcelRequire("aTt6S");

var $hsNz5 = parcelRequire("hsNz5");

var $lJeQK = parcelRequire("lJeQK");
function $ba02d1abcfaecc9c$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $dT4Fd.extractEventInfo)(syntheticPointerEvent));
}
class $ba02d1abcfaecc9c$export$f026abdbba7f0c9e extends (0, $jRBPW.Feature) {
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $hsNz5.noop);
        this.removeEndListeners = (0, $hsNz5.noop);
        this.removeAccessibleListeners = (0, $hsNz5.noop);
        this.startPointerPress = (startEvent, startInfo)=>{
            if (this.isPressing) return;
            this.removeEndListeners();
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel, globalTapTarget: globalTapTarget } = this.node.getProps();
                (0, $lJeQK.frame).update(()=>{
                    /**
                     * We only count this as a tap gesture if the event.target is the same
                     * as, or a child of, this component's element
                     */ !globalTapTarget && !(0, $aTt6S.isNodeOrChild)(this.node.current, endEvent.target) ? onTapCancel && onTapCancel(endEvent, endInfo) : onTap && onTap(endEvent, endInfo);
                });
            };
            const removePointerUpListener = (0, $Z8cIX.addPointerEvent)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $Z8cIX.addPointerEvent)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $jnmzn.pipe)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $ba02d1abcfaecc9c$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) (0, $lJeQK.frame).update(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $hvbUJ.addDomEvent)(this.node.current, "keyup", handleKeyup);
                $ba02d1abcfaecc9c$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $hvbUJ.addDomEvent)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $ba02d1abcfaecc9c$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $hvbUJ.addDomEvent)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $jnmzn.pipe)(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, $lJeQK.frame).update(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $iDnTQ.isDragActive)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, $lJeQK.frame).update(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $Z8cIX.addPointerEvent)(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $hvbUJ.addDomEvent)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $jnmzn.pipe)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}

});
parcelRegister("aTt6S", function(module, exports) {

$parcel$export(module.exports, "isNodeOrChild", () => $a15d0be7949b6b4d$export$e841ada32ff745b);
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $a15d0be7949b6b4d$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $a15d0be7949b6b4d$export$e841ada32ff745b(parent, child.parentElement);
};

});


parcelRegister("6MhVe", function(module, exports) {

$parcel$export(module.exports, "InViewFeature", () => $c6c4a16d274df951$export$150851c8cc2f0c72);

var $jRBPW = parcelRequire("jRBPW");

var $cmCVQ = parcelRequire("cmCVQ");
const $c6c4a16d274df951$var$thresholdNames = {
    some: 0,
    all: 1
};
class $c6c4a16d274df951$export$150851c8cc2f0c72 extends (0, $jRBPW.Feature) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $c6c4a16d274df951$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $cmCVQ.observeIntersection)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($c6c4a16d274df951$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $c6c4a16d274df951$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}

});
parcelRegister("cmCVQ", function(module, exports) {

$parcel$export(module.exports, "observeIntersection", () => $55a30a335b01c87d$export$b2bcd62fb7925aa5);
/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $55a30a335b01c87d$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $55a30a335b01c87d$var$observers = new WeakMap();
const $55a30a335b01c87d$var$fireObserverCallback = (entry)=>{
    const callback = $55a30a335b01c87d$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $55a30a335b01c87d$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($55a30a335b01c87d$var$fireObserverCallback);
};
function $55a30a335b01c87d$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$55a30a335b01c87d$var$observers.has(lookupRoot)) $55a30a335b01c87d$var$observers.set(lookupRoot, {});
    const rootObservers = $55a30a335b01c87d$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($55a30a335b01c87d$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $55a30a335b01c87d$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $55a30a335b01c87d$var$initIntersectionObserver(options);
    $55a30a335b01c87d$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $55a30a335b01c87d$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}

});



parcelRegister("75gkt", function(module, exports) {

$parcel$export(module.exports, "animations", () => $84ae02c001e2c44d$export$7f9953c70dacfd7f);

var $bG1QJ = parcelRequire("bG1QJ");

var $e0395 = parcelRequire("e0395");
const $84ae02c001e2c44d$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $bG1QJ.AnimationFeature)
    },
    exit: {
        Feature: (0, $e0395.ExitAnimationFeature)
    }
};

});
parcelRegister("bG1QJ", function(module, exports) {

$parcel$export(module.exports, "AnimationFeature", () => $caa5b8501011829b$export$b45b3fe5caabdca);

var $76EU5 = parcelRequire("76EU5");

var $9Zzrw = parcelRequire("9Zzrw");

var $jRBPW = parcelRequire("jRBPW");
class $caa5b8501011829b$export$b45b3fe5caabdca extends (0, $jRBPW.Feature) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $9Zzrw.createAnimationState)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        this.unmount();
        if ((0, $76EU5.isAnimationControls)(animate)) this.unmount = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {}
}

});
parcelRegister("9Zzrw", function(module, exports) {

$parcel$export(module.exports, "createAnimationState", () => $1c095008bb4308a8$export$bb53502b7a672aa8);

var $76EU5 = parcelRequire("76EU5");

var $l2nMT = parcelRequire("l2nMT");

var $20xdK = parcelRequire("20xdK");

var $jG6Uh = parcelRequire("jG6Uh");

var $3COsz = parcelRequire("3COsz");

var $9y3RP = parcelRequire("9y3RP");

var $hhg7M = parcelRequire("hhg7M");
const $1c095008bb4308a8$var$reversePriorityOrder = [
    ...(0, $9y3RP.variantPriorityOrder)
].reverse();
const $1c095008bb4308a8$var$numAnimationTypes = (0, $9y3RP.variantPriorityOrder).length;
function $1c095008bb4308a8$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $hhg7M.animateVisualElement)(visualElement, animation, options)));
}
function $1c095008bb4308a8$export$bb53502b7a672aa8(visualElement) {
    let animate = $1c095008bb4308a8$var$animateList(visualElement);
    const state = $1c095008bb4308a8$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (acc, definition)=>{
        const resolved = (0, $3COsz.resolveVariant)(visualElement, definition);
        if (resolved) {
            const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
            acc = {
                ...acc,
                ...target,
                ...transitionEnd
            };
        }
        return acc;
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $1c095008bb4308a8$var$numAnimationTypes; i++){
            const type = $1c095008bb4308a8$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $jG6Uh.isVariantLabel)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $76EU5.isAnimationControls)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $1c095008bb4308a8$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $l2nMT.isKeyframesTarget)(next) && (0, $l2nMT.isKeyframesTarget)(prev)) valueHasChanged = !(0, $20xdK.shallowCompare)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             */ if (shouldAnimateType && (!isInherited || handledRemovedValues)) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type,
                        ...options
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(options, type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state
    };
}
function $1c095008bb4308a8$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $20xdK.shallowCompare)(next, prev);
    return false;
}
function $1c095008bb4308a8$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $1c095008bb4308a8$var$createState() {
    return {
        animate: $1c095008bb4308a8$var$createTypeState(true),
        whileInView: $1c095008bb4308a8$var$createTypeState(),
        whileHover: $1c095008bb4308a8$var$createTypeState(),
        whileTap: $1c095008bb4308a8$var$createTypeState(),
        whileDrag: $1c095008bb4308a8$var$createTypeState(),
        whileFocus: $1c095008bb4308a8$var$createTypeState(),
        exit: $1c095008bb4308a8$var$createTypeState()
    };
}

});
parcelRegister("20xdK", function(module, exports) {

$parcel$export(module.exports, "shallowCompare", () => $58017378b1b7535e$export$90e866afbd6b9f1a);
function $58017378b1b7535e$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}

});

parcelRegister("3COsz", function(module, exports) {

$parcel$export(module.exports, "resolveVariant", () => $7108cf6188c02953$export$7b1b1c981f4f0558);

var $jEvFY = parcelRequire("jEvFY");
/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $7108cf6188c02953$var$getCurrent(visualElement) {
    const current = {};
    visualElement.values.forEach((value, key)=>current[key] = value.get());
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $7108cf6188c02953$var$getVelocity(visualElement) {
    const velocity = {};
    visualElement.values.forEach((value, key)=>velocity[key] = value.getVelocity());
    return velocity;
}
function $7108cf6188c02953$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $jEvFY.resolveVariantFromProps)(props, definition, custom !== undefined ? custom : props.custom, $7108cf6188c02953$var$getCurrent(visualElement), $7108cf6188c02953$var$getVelocity(visualElement));
}

});

parcelRegister("hhg7M", function(module, exports) {

$parcel$export(module.exports, "animateVisualElement", () => $0f5eefba84ac6696$export$ff62cf473653f109);

var $3COsz = parcelRequire("3COsz");

var $29hVF = parcelRequire("29hVF");

var $5Dswx = parcelRequire("5Dswx");
function $0f5eefba84ac6696$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $5Dswx.animateVariant)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $5Dswx.animateVariant)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $3COsz.resolveVariant)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $29hVF.animateTarget)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>visualElement.notify("AnimationComplete", definition));
}

});
parcelRegister("29hVF", function(module, exports) {

$parcel$export(module.exports, "animateTarget", () => $58ea4d5f207516a0$export$68cacfeee78d98d2);

var $1ewxR = parcelRequire("1ewxR");

var $9KlOx = parcelRequire("9KlOx");

var $cHMmF = parcelRequire("cHMmF");

var $8DT3X = parcelRequire("8DT3X");

var $g5LEV = parcelRequire("g5LEV");

var $8jA9i = parcelRequire("8jA9i");

var $lJeQK = parcelRequire("lJeQK");
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $58ea4d5f207516a0$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $58ea4d5f207516a0$var$hasKeyframesChanged(value, target) {
    const current = value.get();
    if (Array.isArray(target)) for(let i = 0; i < target.length; i++){
        if (target[i] !== current) return true;
    }
    else return current !== target;
}
function $58ea4d5f207516a0$export$68cacfeee78d98d2(visualElement, definition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = visualElement.makeTargetAnimatable(definition);
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key);
        const valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && $58ea4d5f207516a0$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            elapsed: 0,
            ...(0, $8jA9i.getValueTransition)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ if (window.HandoffAppearAnimations) {
            const appearId = visualElement.getProps()[0, $9KlOx.optimizedAppearDataAttribute];
            if (appearId) {
                const elapsed = window.HandoffAppearAnimations(appearId, key, value, (0, $lJeQK.frame));
                if (elapsed !== null) {
                    valueTransition.elapsed = elapsed;
                    valueTransition.isHandoff = true;
                }
            }
        }
        let canSkip = !valueTransition.isHandoff && !$58ea4d5f207516a0$var$hasKeyframesChanged(value, valueTarget);
        if (valueTransition.type === "spring" && (value.getVelocity() || valueTransition.velocity)) canSkip = false;
        /**
         * Temporarily disable skipping animations if there's an animation in
         * progress. Better would be to track the current target of a value
         * and compare that against valueTarget.
         */ if (value.animation) canSkip = false;
        if (canSkip) continue;
        value.start((0, $cHMmF.animateMotionValue)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $1ewxR.transformProps).has(key) ? {
            type: false
        } : valueTransition));
        const animation = value.animation;
        if ((0, $8DT3X.isWillChangeMotionValue)(willChange)) {
            willChange.add(key);
            animation.then(()=>willChange.remove(key));
        }
        animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        transitionEnd && (0, $g5LEV.setTarget)(visualElement, transitionEnd);
    });
    return animations;
}

});
parcelRegister("cHMmF", function(module, exports) {

$parcel$export(module.exports, "animateMotionValue", () => $c7f4ed43e937d6d6$export$90b3dfc33ff3548);

var $kpJ0L = parcelRequire("kpJ0L");

var $48XSc = parcelRequire("48XSc");

var $hozwj = parcelRequire("hozwj");

var $iqPTs = parcelRequire("iqPTs");

var $gNYQn = parcelRequire("gNYQn");

var $5Te0i = parcelRequire("5Te0i");

var $hPjQl = parcelRequire("hPjQl");

var $dsuVe = parcelRequire("dsuVe");

var $8jA9i = parcelRequire("8jA9i");

var $9sEW6 = parcelRequire("9sEW6");

var $nolfW = parcelRequire("nolfW");
const $c7f4ed43e937d6d6$export$90b3dfc33ff3548 = (valueName, value, target, transition = {})=>{
    return (onComplete)=>{
        const valueTransition = (0, $8jA9i.getValueTransition)(transition, valueName) || {};
        /**
         * Most transition values are currently completely overwritten by value-specific
         * transitions. In the future it'd be nicer to blend these transitions. But for now
         * delay actually does inherit from the root transition if not value-specific.
         */ const delay = valueTransition.delay || transition.delay || 0;
        /**
         * Elapsed isn't a public transition option but can be passed through from
         * optimized appear effects in milliseconds.
         */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $48XSc.secondsToMilliseconds)(delay);
        const keyframes = (0, $dsuVe.getKeyframes)(value, valueName, target, valueTransition);
        /**
         * Check if we're able to animate between the start and end keyframes,
         * and throw a warning if we're attempting to animate between one that's
         * animatable and another that isn't.
         */ const originKeyframe = keyframes[0];
        const targetKeyframe = keyframes[keyframes.length - 1];
        const isOriginAnimatable = (0, $hPjQl.isAnimatable)(valueName, originKeyframe);
        const isTargetAnimatable = (0, $hPjQl.isAnimatable)(valueName, targetKeyframe);
        (0, $kpJ0L.warning)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${valueName} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
        let options = {
            keyframes: keyframes,
            velocity: value.getVelocity(),
            ease: "easeOut",
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            }
        };
        /**
         * If there's no transition defined for this value, we can generate
         * unqiue transition settings for this value.
         */ if (!(0, $8jA9i.isTransitionDefined)(valueTransition)) options = {
            ...options,
            ...(0, $5Te0i.getDefaultTransition)(valueName, options)
        };
        /**
         * Both WAAPI and our internal animation functions use durations
         * as defined by milliseconds, while our external API defines them
         * as seconds.
         */ if (options.duration) options.duration = (0, $48XSc.secondsToMilliseconds)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $48XSc.secondsToMilliseconds)(options.repeatDelay);
        if (!isOriginAnimatable || !isTargetAnimatable || (0, $hozwj.instantAnimationState).current || valueTransition.type === false || (0, $nolfW.MotionGlobalConfig).skipAnimations) /**
             * If we can't animate this value, or the global instant animation flag is set,
             * or this is simply defined as an instant transition, return an instant transition.
             */ return (0, $gNYQn.createInstantAnimation)((0, $hozwj.instantAnimationState).current ? {
            ...options,
            delay: 0
        } : options);
        /**
         * Animate via WAAPI if possible.
         */ if (/**
         * If this is a handoff animation, the optimised animation will be running via
         * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
         * optimised animation.
         */ !transition.isHandoff && value.owner && value.owner.current instanceof HTMLElement && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !value.owner.getProps().onUpdate) {
            const acceleratedAnimation = (0, $iqPTs.createAcceleratedAnimation)(value, valueName, options);
            if (acceleratedAnimation) return acceleratedAnimation;
        }
        /**
         * If we didn't create an accelerated animation, create a JS animation
         */ return (0, $9sEW6.animateValue)(options);
    };
};

});
parcelRegister("kpJ0L", function(module, exports) {

$parcel$export(module.exports, "warning", () => $035e6e1d9195366d$export$491112666e282270);
$parcel$export(module.exports, "invariant", () => $035e6e1d9195366d$export$f5708dca728d7177);

var $hsNz5 = parcelRequire("hsNz5");
let $035e6e1d9195366d$export$491112666e282270 = (0, $hsNz5.noop);
let $035e6e1d9195366d$export$f5708dca728d7177 = (0, $hsNz5.noop);
var $035e6e1d9195366d$var$check, $035e6e1d9195366d$var$message, $035e6e1d9195366d$var$check1, $035e6e1d9195366d$var$message1;

});

parcelRegister("48XSc", function(module, exports) {

$parcel$export(module.exports, "secondsToMilliseconds", () => $71049ae9d3385eee$export$fc3e7e8557f8c8c7);
$parcel$export(module.exports, "millisecondsToSeconds", () => $71049ae9d3385eee$export$f64c3bfbc58eec0f);
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $71049ae9d3385eee$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $71049ae9d3385eee$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;

});

parcelRegister("hozwj", function(module, exports) {

$parcel$export(module.exports, "instantAnimationState", () => $ac24705a256d9c3d$export$888a3d84909f9e3d);
const $ac24705a256d9c3d$export$888a3d84909f9e3d = {
    current: false
};

});

parcelRegister("iqPTs", function(module, exports) {

$parcel$export(module.exports, "createAcceleratedAnimation", () => $8567d30f4f69106e$export$4d5d9557ab897126);

var $2RKsD = parcelRequire("2RKsD");

var $kBpfx = parcelRequire("kBpfx");

var $9yOKF = parcelRequire("9yOKF");

var $9sEW6 = parcelRequire("9sEW6");

var $48XSc = parcelRequire("48XSc");

var $izj8W = parcelRequire("izj8W");

var $hsNz5 = parcelRequire("hsNz5");

var $lJeQK = parcelRequire("lJeQK");
const $8567d30f4f69106e$var$supportsWaapi = (0, $izj8W.memo)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
/**
 * A list of values that can be hardware-accelerated.
 */ const $8567d30f4f69106e$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform",
    "backgroundColor"
]);
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $8567d30f4f69106e$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $8567d30f4f69106e$var$maxDuration = 20000;
const $8567d30f4f69106e$var$requiresPregeneratedKeyframes = (valueName, options)=>options.type === "spring" || valueName === "backgroundColor" || !(0, $kBpfx.isWaapiSupportedEasing)(options.ease);
function $8567d30f4f69106e$export$4d5d9557ab897126(value, valueName, { onUpdate: onUpdate, onComplete: onComplete, ...options }) {
    const canAccelerateAnimation = $8567d30f4f69106e$var$supportsWaapi() && $8567d30f4f69106e$var$acceleratedValues.has(valueName) && !options.repeatDelay && options.repeatType !== "mirror" && options.damping !== 0 && options.type !== "inertia";
    if (!canAccelerateAnimation) return false;
    /**
     * TODO: Unify with js/index
     */ let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Cancelling an animation will write to the DOM. For safety we want to defer
     * this until the next `update` frame lifecycle. This flag tracks whether we
     * have a pending cancel, if so we shouldn't allow animations to finish.
     */ let pendingCancel = false;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let { keyframes: keyframes, duration: duration = 300, ease: ease, times: times } = options;
    /**
     * If this animation needs pre-generated keyframes then generate.
     */ if ($8567d30f4f69106e$var$requiresPregeneratedKeyframes(valueName, options)) {
        const sampleAnimation = (0, $9sEW6.animateValue)({
            ...options,
            repeat: 0,
            delay: 0
        });
        let state = {
            done: false,
            value: keyframes[0]
        };
        const pregeneratedKeyframes = [];
        /**
         * Bail after 20 seconds of pre-generated keyframes as it's likely
         * we're heading for an infinite loop.
         */ let t = 0;
        while(!state.done && t < $8567d30f4f69106e$var$maxDuration){
            state = sampleAnimation.sample(t);
            pregeneratedKeyframes.push(state.value);
            t += $8567d30f4f69106e$var$sampleDelta;
        }
        times = undefined;
        keyframes = pregeneratedKeyframes;
        duration = t - $8567d30f4f69106e$var$sampleDelta;
        ease = "linear";
    }
    const animation = (0, $2RKsD.animateStyle)(value.owner.current, valueName, keyframes, {
        ...options,
        duration: duration,
        /**
         * This function is currently not called if ease is provided
         * as a function so the cast is safe.
         *
         * However it would be possible for a future refinement to port
         * in easing pregeneration from Motion One for browsers that
         * support the upcoming `linear()` easing function.
         */ ease: ease,
        times: times
    });
    const cancelAnimation = ()=>{
        pendingCancel = false;
        animation.cancel();
    };
    const safeCancel = ()=>{
        pendingCancel = true;
        (0, $lJeQK.frame).update(cancelAnimation);
        resolveFinishedPromise();
        updateFinishedPromise();
    };
    /**
     * Prefer the `onfinish` prop as it's more widely supported than
     * the `finished` promise.
     *
     * Here, we synchronously set the provided MotionValue to the end
     * keyframe. If we didn't, when the WAAPI animation is finished it would
     * be removed from the element which would then revert to its old styles.
     */ animation.onfinish = ()=>{
        if (pendingCancel) return;
        value.set((0, $9yOKF.getFinalKeyframe)(keyframes, options));
        onComplete && onComplete();
        safeCancel();
    };
    /**
     * Animation interrupt callback.
     */ const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        attachTimeline (timeline) {
            animation.timeline = timeline;
            animation.onfinish = null;
            return 0, $hsNz5.noop;
        },
        get time () {
            return (0, $48XSc.millisecondsToSeconds)(animation.currentTime || 0);
        },
        set time (newTime){
            animation.currentTime = (0, $48XSc.secondsToMilliseconds)(newTime);
        },
        get speed () {
            return animation.playbackRate;
        },
        set speed (newSpeed){
            animation.playbackRate = newSpeed;
        },
        get duration () {
            return (0, $48XSc.millisecondsToSeconds)(duration);
        },
        play: ()=>{
            if (hasStopped) return;
            animation.play();
            /**
             * Cancel any pending cancel tasks
             */ (0, $lJeQK.cancelFrame)(cancelAnimation);
        },
        pause: ()=>animation.pause(),
        stop: ()=>{
            hasStopped = true;
            if (animation.playState === "idle") return;
            /**
             * WAAPI doesn't natively have any interruption capabilities.
             *
             * Rather than read commited styles back out of the DOM, we can
             * create a renderless JS animation and sample it twice to calculate
             * its current value, "previous" value, and therefore allow
             * Motion to calculate velocity for any subsequent animation.
             */ const { currentTime: currentTime } = animation;
            if (currentTime) {
                const sampleAnimation = (0, $9sEW6.animateValue)({
                    ...options,
                    autoplay: false
                });
                value.setWithVelocity(sampleAnimation.sample(currentTime - $8567d30f4f69106e$var$sampleDelta).value, sampleAnimation.sample(currentTime).value, $8567d30f4f69106e$var$sampleDelta);
            }
            safeCancel();
        },
        complete: ()=>{
            if (pendingCancel) return;
            animation.finish();
        },
        cancel: safeCancel
    };
    return controls;
}

});
parcelRegister("2RKsD", function(module, exports) {

$parcel$export(module.exports, "animateStyle", () => $6e0f67eff48c393e$export$c76cd972d26986f9);

var $kBpfx = parcelRequire("kBpfx");
function $6e0f67eff48c393e$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $kBpfx.mapEasingToNativeEasing)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}

});
parcelRegister("kBpfx", function(module, exports) {

$parcel$export(module.exports, "isWaapiSupportedEasing", () => $1d10aa321c0fd00f$export$fcdd8f3f2160beda);
$parcel$export(module.exports, "mapEasingToNativeEasing", () => $1d10aa321c0fd00f$export$916ea73bcd3a6030);

var $28MMK = parcelRequire("28MMK");
function $1d10aa321c0fd00f$export$fcdd8f3f2160beda(easing) {
    return Boolean(!easing || typeof easing === "string" && $1d10aa321c0fd00f$export$2cf569f5e2221176[easing] || (0, $28MMK.isBezierDefinition)(easing) || Array.isArray(easing) && easing.every($1d10aa321c0fd00f$export$fcdd8f3f2160beda));
}
const $1d10aa321c0fd00f$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $1d10aa321c0fd00f$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: $1d10aa321c0fd00f$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: $1d10aa321c0fd00f$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: $1d10aa321c0fd00f$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: $1d10aa321c0fd00f$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $1d10aa321c0fd00f$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    return (0, $28MMK.isBezierDefinition)(easing) ? $1d10aa321c0fd00f$export$2523b8f0bd8f44cb(easing) : Array.isArray(easing) ? easing.map($1d10aa321c0fd00f$export$916ea73bcd3a6030) : $1d10aa321c0fd00f$export$2cf569f5e2221176[easing];
}

});
parcelRegister("28MMK", function(module, exports) {

$parcel$export(module.exports, "isBezierDefinition", () => $e7eec3fad82561bb$export$ff43f99925d7366b);
const $e7eec3fad82561bb$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";

});



parcelRegister("9yOKF", function(module, exports) {

$parcel$export(module.exports, "getFinalKeyframe", () => $d90e213f9a0aed4f$export$14de59408fad90b);
function $d90e213f9a0aed4f$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }) {
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : keyframes.length - 1;
    return keyframes[index];
}

});

parcelRegister("9sEW6", function(module, exports) {

$parcel$export(module.exports, "animateValue", () => $c10cee822095f19c$export$ee9b76de7353d815);

var $heiPU = parcelRequire("heiPU");

var $5lvMn = parcelRequire("5lvMn");

var $7vp35 = parcelRequire("7vp35");

var $h38RI = parcelRequire("h38RI");

var $amI2v = parcelRequire("amI2v");

var $8WJMW = parcelRequire("8WJMW");

var $48XSc = parcelRequire("48XSc");

var $2167W = parcelRequire("2167W");

const $c10cee822095f19c$var$types = {
    decay: (0, $7vp35.inertia),
    inertia: $7vp35.inertia,
    tween: (0, $heiPU.keyframes),
    keyframes: (0, $heiPU.keyframes),
    spring: $5lvMn.spring
};
/**
 * Animate a single value on the main thread.
 *
 * This function is written, where functionality overlaps,
 * to be largely spec-compliant with WAAPI to allow fungibility
 * between the two.
 */ function $c10cee822095f19c$export$ee9b76de7353d815({ autoplay: autoplay = true, delay: delay = 0, driver: driver = (0, $h38RI.frameloopDriver), keyframes: keyframes$1, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", onPlay: onPlay, onStop: onStop, onComplete: onComplete, onUpdate: onUpdate, ...options }) {
    let speed = 1;
    let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let animationDriver;
    const generatorFactory = $c10cee822095f19c$var$types[type] || (0, $heiPU.keyframes);
    /**
     * If this isn't the keyframes generator and we've been provided
     * strings as keyframes, we need to interpolate these.
     */ let mapNumbersToKeyframes;
    if (generatorFactory !== (0, $heiPU.keyframes) && typeof keyframes$1[0] !== "number") {
        mapNumbersToKeyframes = (0, $amI2v.interpolate)([
            0,
            100
        ], keyframes$1, {
            clamp: false
        });
        keyframes$1 = [
            0,
            100
        ];
    }
    const generator = generatorFactory({
        ...options,
        keyframes: keyframes$1
    });
    let mirroredGenerator;
    if (repeatType === "mirror") mirroredGenerator = generatorFactory({
        ...options,
        keyframes: [
            ...keyframes$1
        ].reverse(),
        velocity: -(options.velocity || 0)
    });
    let playState = "idle";
    let holdTime = null;
    let startTime = null;
    let cancelTime = null;
    /**
     * If duration is undefined and we have repeat options,
     * we need to calculate a duration from the generator.
     *
     * We set it to the generator itself to cache the duration.
     * Any timeline resolver will need to have already precalculated
     * the duration by this step.
     */ if (generator.calculatedDuration === null && repeat) generator.calculatedDuration = (0, $2167W.calcGeneratorDuration)(generator);
    const { calculatedDuration: calculatedDuration } = generator;
    let resolvedDuration = Infinity;
    let totalDuration = Infinity;
    if (calculatedDuration !== null) {
        resolvedDuration = calculatedDuration + repeatDelay;
        totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
    }
    let currentTime = 0;
    const tick = (timestamp)=>{
        if (startTime === null) return;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (speed > 0) startTime = Math.min(startTime, timestamp);
        if (speed < 0) startTime = Math.min(timestamp - totalDuration / speed, startTime);
        if (holdTime !== null) currentTime = holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        currentTime = Math.round(timestamp - startTime) * speed;
        // Rebase on delay
        const timeWithoutDelay = currentTime - delay * (speed >= 0 ? 1 : -1);
        const isInDelayPhase = speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        currentTime = Math.max(timeWithoutDelay, 0);
        /**
         * If this animation has finished, set the current time
         * to the total duration.
         */ if (playState === "finished" && holdTime === null) currentTime = totalDuration;
        let elapsed = currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $8WJMW.clamp)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes$1[0]
        } : frameGenerator.next(elapsed);
        if (mapNumbersToKeyframes) state.value = mapNumbersToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = speed >= 0 ? currentTime >= totalDuration : currentTime <= 0;
        const isAnimationFinished = holdTime === null && (playState === "finished" || playState === "running" && done);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) finish();
        return state;
    };
    const stopAnimationDriver = ()=>{
        animationDriver && animationDriver.stop();
        animationDriver = undefined;
    };
    const cancel = ()=>{
        playState = "idle";
        stopAnimationDriver();
        resolveFinishedPromise();
        updateFinishedPromise();
        startTime = cancelTime = null;
    };
    const finish = ()=>{
        playState = "finished";
        onComplete && onComplete();
        stopAnimationDriver();
        resolveFinishedPromise();
    };
    const play = ()=>{
        if (hasStopped) return;
        if (!animationDriver) animationDriver = driver(tick);
        const now = animationDriver.now();
        onPlay && onPlay();
        if (holdTime !== null) startTime = now - holdTime;
        else if (!startTime || playState === "finished") startTime = now;
        if (playState === "finished") updateFinishedPromise();
        cancelTime = startTime;
        holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ playState = "running";
        animationDriver.start();
    };
    if (autoplay) play();
    const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        get time () {
            return (0, $48XSc.millisecondsToSeconds)(currentTime);
        },
        set time (newTime){
            newTime = (0, $48XSc.secondsToMilliseconds)(newTime);
            currentTime = newTime;
            if (holdTime !== null || !animationDriver || speed === 0) holdTime = newTime;
            else startTime = animationDriver.now() - newTime / speed;
        },
        get duration () {
            const duration = generator.calculatedDuration === null ? (0, $2167W.calcGeneratorDuration)(generator) : generator.calculatedDuration;
            return (0, $48XSc.millisecondsToSeconds)(duration);
        },
        get speed () {
            return speed;
        },
        set speed (newSpeed){
            if (newSpeed === speed || !animationDriver) return;
            speed = newSpeed;
            controls.time = (0, $48XSc.millisecondsToSeconds)(currentTime);
        },
        get state () {
            return playState;
        },
        play: play,
        pause: ()=>{
            playState = "paused";
            holdTime = currentTime;
        },
        stop: ()=>{
            hasStopped = true;
            if (playState === "idle") return;
            playState = "idle";
            onStop && onStop();
            cancel();
        },
        cancel: ()=>{
            if (cancelTime !== null) tick(cancelTime);
            cancel();
        },
        complete: ()=>{
            playState = "finished";
        },
        sample: (elapsed)=>{
            startTime = 0;
            return tick(elapsed);
        }
    };
    return controls;
}

});
parcelRegister("heiPU", function(module, exports) {

$parcel$export(module.exports, "keyframes", () => $186efe6c9ccfa4f4$export$d25ddfdf17c3ad3e);

var $dEkp4 = parcelRequire("dEkp4");

var $f7iHm = parcelRequire("f7iHm");

var $bx41f = parcelRequire("bx41f");

var $amI2v = parcelRequire("amI2v");

var $5D3CS = parcelRequire("5D3CS");

var $kk5mf = parcelRequire("kk5mf");
function $186efe6c9ccfa4f4$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $dEkp4.easeInOut)).splice(0, values.length - 1);
}
function $186efe6c9ccfa4f4$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $f7iHm.isEasingArray)(ease) ? ease.map((0, $bx41f.easingDefinitionToFunction)) : (0, $bx41f.easingDefinitionToFunction)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $kk5mf.convertOffsetToTimes)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $5D3CS.defaultOffset)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $amI2v.interpolate)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $186efe6c9ccfa4f4$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}

});
parcelRegister("dEkp4", function(module, exports) {

$parcel$export(module.exports, "easeIn", () => $75211692a6d9eb36$export$929e5a82286172a6);
$parcel$export(module.exports, "easeOut", () => $75211692a6d9eb36$export$57636bb43b1ccbb0);
$parcel$export(module.exports, "easeInOut", () => $75211692a6d9eb36$export$c07234257a03d5e9);

var $dP5rG = parcelRequire("dP5rG");
const $75211692a6d9eb36$export$929e5a82286172a6 = (0, $dP5rG.cubicBezier)(0.42, 0, 1, 1);
const $75211692a6d9eb36$export$57636bb43b1ccbb0 = (0, $dP5rG.cubicBezier)(0, 0, 0.58, 1);
const $75211692a6d9eb36$export$c07234257a03d5e9 = (0, $dP5rG.cubicBezier)(0.42, 0, 0.58, 1);

});
parcelRegister("dP5rG", function(module, exports) {

$parcel$export(module.exports, "cubicBezier", () => $11293072df24cb60$export$2c575fa1d20488bd);

var $hsNz5 = parcelRequire("hsNz5");
/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $11293072df24cb60$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $11293072df24cb60$var$subdivisionPrecision = 0.0000001;
const $11293072df24cb60$var$subdivisionMaxIterations = 12;
function $11293072df24cb60$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $11293072df24cb60$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $11293072df24cb60$var$subdivisionPrecision && ++i < $11293072df24cb60$var$subdivisionMaxIterations);
    return currentT;
}
function $11293072df24cb60$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $hsNz5.noop;
    const getTForX = (aX)=>$11293072df24cb60$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $11293072df24cb60$var$calcBezier(getTForX(t), mY1, mY2);
}

});


parcelRegister("f7iHm", function(module, exports) {

$parcel$export(module.exports, "isEasingArray", () => $d5c2e536b3441133$export$216948827bbdc797);
const $d5c2e536b3441133$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

});

parcelRegister("bx41f", function(module, exports) {

$parcel$export(module.exports, "easingDefinitionToFunction", () => $00ce46861d43621f$export$ef97fe084f156ca4);

var $kpJ0L = parcelRequire("kpJ0L");

var $dP5rG = parcelRequire("dP5rG");

var $hsNz5 = parcelRequire("hsNz5");

var $dEkp4 = parcelRequire("dEkp4");

var $2xkaC = parcelRequire("2xkaC");

var $4NtGV = parcelRequire("4NtGV");

var $9NGj9 = parcelRequire("9NGj9");
const $00ce46861d43621f$var$easingLookup = {
    linear: (0, $hsNz5.noop),
    easeIn: $dEkp4.easeIn,
    easeInOut: $dEkp4.easeInOut,
    easeOut: $dEkp4.easeOut,
    circIn: $2xkaC.circIn,
    circInOut: $2xkaC.circInOut,
    circOut: $2xkaC.circOut,
    backIn: $4NtGV.backIn,
    backInOut: $4NtGV.backInOut,
    backOut: $4NtGV.backOut,
    anticipate: $9NGj9.anticipate
};
const $00ce46861d43621f$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $kpJ0L.invariant)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $dP5rG.cubicBezier)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $kpJ0L.invariant)($00ce46861d43621f$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $00ce46861d43621f$var$easingLookup[definition];
    }
    return definition;
};

});
parcelRegister("2xkaC", function(module, exports) {

$parcel$export(module.exports, "circIn", () => $c2c57d535a485c77$export$e444123e42d03385);
$parcel$export(module.exports, "circOut", () => $c2c57d535a485c77$export$c8d67a19199d1a50);
$parcel$export(module.exports, "circInOut", () => $c2c57d535a485c77$export$30d3455eee55bed5);

var $dSy24 = parcelRequire("dSy24");

var $44B7m = parcelRequire("44B7m");
const $c2c57d535a485c77$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $c2c57d535a485c77$export$c8d67a19199d1a50 = (0, $44B7m.reverseEasing)($c2c57d535a485c77$export$e444123e42d03385);
const $c2c57d535a485c77$export$30d3455eee55bed5 = (0, $dSy24.mirrorEasing)($c2c57d535a485c77$export$e444123e42d03385);

});
parcelRegister("dSy24", function(module, exports) {

$parcel$export(module.exports, "mirrorEasing", () => $5cc81d86c0c27f69$export$f946554fb8aeaf0d);
// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $5cc81d86c0c27f69$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;

});

parcelRegister("44B7m", function(module, exports) {

$parcel$export(module.exports, "reverseEasing", () => $3d75b0729eda0719$export$2c07eeff45156d4d);
// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $3d75b0729eda0719$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);

});


parcelRegister("4NtGV", function(module, exports) {

$parcel$export(module.exports, "backOut", () => $4587182493605278$export$77edfce482316a60);
$parcel$export(module.exports, "backIn", () => $4587182493605278$export$b01116c84cdfe1a2);
$parcel$export(module.exports, "backInOut", () => $4587182493605278$export$ddc5fd596f6c71b2);

var $dP5rG = parcelRequire("dP5rG");

var $dSy24 = parcelRequire("dSy24");

var $44B7m = parcelRequire("44B7m");
const $4587182493605278$export$77edfce482316a60 = (0, $dP5rG.cubicBezier)(0.33, 1.53, 0.69, 0.99);
const $4587182493605278$export$b01116c84cdfe1a2 = (0, $44B7m.reverseEasing)($4587182493605278$export$77edfce482316a60);
const $4587182493605278$export$ddc5fd596f6c71b2 = (0, $dSy24.mirrorEasing)($4587182493605278$export$b01116c84cdfe1a2);

});

parcelRegister("9NGj9", function(module, exports) {

$parcel$export(module.exports, "anticipate", () => $ddc9b949af016c94$export$6b0af63b873d419e);

var $4NtGV = parcelRequire("4NtGV");
const $ddc9b949af016c94$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $4NtGV.backIn)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));

});


parcelRegister("amI2v", function(module, exports) {

$parcel$export(module.exports, "interpolate", () => $8bea4cbd28e5c177$export$89e29e4ab65e70a9);

var $kpJ0L = parcelRequire("kpJ0L");

var $4MLAr = parcelRequire("4MLAr");

var $8WJMW = parcelRequire("8WJMW");

var $bVhPN = parcelRequire("bVhPN");

var $7HYnb = parcelRequire("7HYnb");

var $1SLVz = parcelRequire("1SLVz");

var $jnmzn = parcelRequire("jnmzn");

var $aqB8F = parcelRequire("aqB8F");

var $hsNz5 = parcelRequire("hsNz5");
const $8bea4cbd28e5c177$var$mixNumber = (from, to)=>(p)=>(0, $bVhPN.mix)(from, to, p);
function $8bea4cbd28e5c177$var$detectMixerFactory(v) {
    if (typeof v === "number") return $8bea4cbd28e5c177$var$mixNumber;
    else if (typeof v === "string") return (0, $4MLAr.color).test(v) ? (0, $7HYnb.mixColor) : (0, $1SLVz.mixComplex);
    else if (Array.isArray(v)) return 0, $1SLVz.mixArray;
    else if (typeof v === "object") return 0, $1SLVz.mixObject;
    return $8bea4cbd28e5c177$var$mixNumber;
}
function $8bea4cbd28e5c177$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || $8bea4cbd28e5c177$var$detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $hsNz5.noop) : ease;
            mixer = (0, $jnmzn.pipe)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $8bea4cbd28e5c177$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $kpJ0L.invariant)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $8bea4cbd28e5c177$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $aqB8F.progress)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $8WJMW.clamp)(input[0], input[inputLength - 1], v)) : interpolator;
}

});
parcelRegister("4MLAr", function(module, exports) {

$parcel$export(module.exports, "color", () => $74df552527fc0804$export$35e9368ef982300f);

var $j5Bkz = parcelRequire("j5Bkz");

var $gMowX = parcelRequire("gMowX");

var $aTZuY = parcelRequire("aTZuY");

var $1T4fR = parcelRequire("1T4fR");
const $74df552527fc0804$export$35e9368ef982300f = {
    test: (v)=>(0, $1T4fR.rgba).test(v) || (0, $gMowX.hex).test(v) || (0, $aTZuY.hsla).test(v),
    parse: (v)=>{
        if ((0, $1T4fR.rgba).test(v)) return (0, $1T4fR.rgba).parse(v);
        else if ((0, $aTZuY.hsla).test(v)) return (0, $aTZuY.hsla).parse(v);
        else return (0, $gMowX.hex).parse(v);
    },
    transform: (v)=>{
        return (0, $j5Bkz.isString)(v) ? v : v.hasOwnProperty("red") ? (0, $1T4fR.rgba).transform(v) : (0, $aTZuY.hsla).transform(v);
    }
};

});
parcelRegister("gMowX", function(module, exports) {

$parcel$export(module.exports, "hex", () => $cfc024756421104d$export$834dfc94dde4b3d8);

var $1T4fR = parcelRequire("1T4fR");

var $idQxT = parcelRequire("idQxT");
function $cfc024756421104d$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $cfc024756421104d$export$834dfc94dde4b3d8 = {
    test: (0, $idQxT.isColorString)("#"),
    parse: $cfc024756421104d$var$parseHex,
    transform: (0, $1T4fR.rgba).transform
};

});
parcelRegister("1T4fR", function(module, exports) {

$parcel$export(module.exports, "rgba", () => $3a18fae99c87085f$export$4e46ac54fc82cf3b);

var $8WJMW = parcelRequire("8WJMW");

var $kRios = parcelRequire("kRios");

var $j5Bkz = parcelRequire("j5Bkz");

var $idQxT = parcelRequire("idQxT");
const $3a18fae99c87085f$var$clampRgbUnit = (v)=>(0, $8WJMW.clamp)(0, 255, v);
const $3a18fae99c87085f$export$7a99c86b5b1f4c9e = {
    ...(0, $kRios.number),
    transform: (v)=>Math.round($3a18fae99c87085f$var$clampRgbUnit(v))
};
const $3a18fae99c87085f$export$4e46ac54fc82cf3b = {
    test: (0, $idQxT.isColorString)("rgb", "red"),
    parse: (0, $idQxT.splitColor)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $3a18fae99c87085f$export$7a99c86b5b1f4c9e.transform(red) + ", " + $3a18fae99c87085f$export$7a99c86b5b1f4c9e.transform(green) + ", " + $3a18fae99c87085f$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $j5Bkz.sanitize)((0, $kRios.alpha).transform(alpha$1)) + ")"
};

});
parcelRegister("idQxT", function(module, exports) {

$parcel$export(module.exports, "isColorString", () => $13d4594773c1ffd2$export$2c8400d58aca05e);
$parcel$export(module.exports, "splitColor", () => $13d4594773c1ffd2$export$73d6f35be992df24);

var $j5Bkz = parcelRequire("j5Bkz");
/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $13d4594773c1ffd2$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $j5Bkz.isString)(v) && (0, $j5Bkz.singleColorRegex).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $13d4594773c1ffd2$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $j5Bkz.isString)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $j5Bkz.floatRegex));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };

});



parcelRegister("aTZuY", function(module, exports) {

$parcel$export(module.exports, "hsla", () => $a0aedb1795162487$export$810b04175080204c);

var $kRios = parcelRequire("kRios");

var $9PDxZ = parcelRequire("9PDxZ");

var $j5Bkz = parcelRequire("j5Bkz");

var $idQxT = parcelRequire("idQxT");
const $a0aedb1795162487$export$810b04175080204c = {
    test: (0, $idQxT.isColorString)("hsl", "hue"),
    parse: (0, $idQxT.splitColor)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $9PDxZ.percent).transform((0, $j5Bkz.sanitize)(saturation)) + ", " + (0, $9PDxZ.percent).transform((0, $j5Bkz.sanitize)(lightness)) + ", " + (0, $j5Bkz.sanitize)((0, $kRios.alpha).transform(alpha$1)) + ")";
    }
};

});


parcelRegister("bVhPN", function(module, exports) {

$parcel$export(module.exports, "mix", () => $ad221416a4841bfa$export$2c9e8a9632a706b2);
/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $ad221416a4841bfa$export$2c9e8a9632a706b2 = (from, to, progress)=>-progress * from + progress * to + from;

});

parcelRegister("7HYnb", function(module, exports) {

$parcel$export(module.exports, "mixColor", () => $314c1c0a1bc9a446$export$51e568cf5c039bac);

var $bVhPN = parcelRequire("bVhPN");

var $kpJ0L = parcelRequire("kpJ0L");

var $7FhkM = parcelRequire("7FhkM");

var $gMowX = parcelRequire("gMowX");

var $1T4fR = parcelRequire("1T4fR");

var $aTZuY = parcelRequire("aTZuY");
// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $314c1c0a1bc9a446$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
};
const $314c1c0a1bc9a446$var$colorTypes = [
    (0, $gMowX.hex),
    (0, $1T4fR.rgba),
    (0, $aTZuY.hsla)
];
const $314c1c0a1bc9a446$var$getColorType = (v)=>$314c1c0a1bc9a446$var$colorTypes.find((type)=>type.test(v));
function $314c1c0a1bc9a446$var$asRGBA(color) {
    const type = $314c1c0a1bc9a446$var$getColorType(color);
    (0, $kpJ0L.invariant)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    let model = type.parse(color);
    if (type === (0, $aTZuY.hsla)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $7FhkM.hslaToRgba)(model);
    return model;
}
const $314c1c0a1bc9a446$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $314c1c0a1bc9a446$var$asRGBA(from);
    const toRGBA = $314c1c0a1bc9a446$var$asRGBA(to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $314c1c0a1bc9a446$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $314c1c0a1bc9a446$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $314c1c0a1bc9a446$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $bVhPN.mix)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $1T4fR.rgba).transform(blended);
    };
};

});
parcelRegister("7FhkM", function(module, exports) {

$parcel$export(module.exports, "hslaToRgba", () => $9d550dc5c11035ab$export$6ae64dbcd6bfc33e);
// Adapted from https://gist.github.com/mjackson/5311256
function $9d550dc5c11035ab$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $9d550dc5c11035ab$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $9d550dc5c11035ab$var$hueToRgb(p, q, hue + 1 / 3);
        green = $9d550dc5c11035ab$var$hueToRgb(p, q, hue);
        blue = $9d550dc5c11035ab$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}

});


parcelRegister("1SLVz", function(module, exports) {

$parcel$export(module.exports, "mixComplex", () => $ab104b7c0bc3b78a$export$65516310a87d8205);
$parcel$export(module.exports, "mixArray", () => $ab104b7c0bc3b78a$export$3bbefa2f402845c4);
$parcel$export(module.exports, "mixObject", () => $ab104b7c0bc3b78a$export$ebc23b6840c51ba1);

var $bVhPN = parcelRequire("bVhPN");

var $7HYnb = parcelRequire("7HYnb");

var $jnmzn = parcelRequire("jnmzn");

var $kpJ0L = parcelRequire("kpJ0L");

var $4MLAr = parcelRequire("4MLAr");

var $c7p3O = parcelRequire("c7p3O");
const $ab104b7c0bc3b78a$var$mixImmediate = (origin, target)=>(p)=>`${p > 0 ? target : origin}`;
function $ab104b7c0bc3b78a$var$getMixer(origin, target) {
    if (typeof origin === "number") return (v)=>(0, $bVhPN.mix)(origin, target, v);
    else if ((0, $4MLAr.color).test(origin)) return (0, $7HYnb.mixColor)(origin, target);
    else return origin.startsWith("var(") ? $ab104b7c0bc3b78a$var$mixImmediate(origin, target) : $ab104b7c0bc3b78a$export$65516310a87d8205(origin, target);
}
const $ab104b7c0bc3b78a$export$3bbefa2f402845c4 = (from, to)=>{
    const output = [
        ...from
    ];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i)=>$ab104b7c0bc3b78a$var$getMixer(fromThis, to[i]));
    return (v)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
const $ab104b7c0bc3b78a$export$ebc23b6840c51ba1 = (origin, target)=>{
    const output = {
        ...origin,
        ...target
    };
    const blendValue = {};
    for(const key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $ab104b7c0bc3b78a$var$getMixer(origin[key], target[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
const $ab104b7c0bc3b78a$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $c7p3O.complex).createTransformer(target);
    const originStats = (0, $c7p3O.analyseComplexValue)(origin);
    const targetStats = (0, $c7p3O.analyseComplexValue)(target);
    const canInterpolate = originStats.numVars === targetStats.numVars && originStats.numColors === targetStats.numColors && originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) return (0, $jnmzn.pipe)($ab104b7c0bc3b78a$export$3bbefa2f402845c4(originStats.values, targetStats.values), template);
    else {
        (0, $kpJ0L.warning)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return $ab104b7c0bc3b78a$var$mixImmediate(origin, target);
    }
};

});
parcelRegister("c7p3O", function(module, exports) {

$parcel$export(module.exports, "analyseComplexValue", () => $2270194b74f77550$export$b61fc7c44bf646d5);
$parcel$export(module.exports, "complex", () => $2270194b74f77550$export$83a0e34f1302825b);

var $4RRaL = parcelRequire("4RRaL");

var $hsNz5 = parcelRequire("hsNz5");

var $4MLAr = parcelRequire("4MLAr");

var $kRios = parcelRequire("kRios");

var $j5Bkz = parcelRequire("j5Bkz");
function $2270194b74f77550$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $j5Bkz.isString)(v) && (((_a = v.match((0, $j5Bkz.floatRegex))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $j5Bkz.colorRegex))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $2270194b74f77550$var$cssVarTokeniser = {
    regex: (0, $4RRaL.cssVariableRegex),
    countKey: "Vars",
    token: "${v}",
    parse: (0, $hsNz5.noop)
};
const $2270194b74f77550$var$colorTokeniser = {
    regex: (0, $j5Bkz.colorRegex),
    countKey: "Colors",
    token: "${c}",
    parse: (0, $4MLAr.color).parse
};
const $2270194b74f77550$var$numberTokeniser = {
    regex: (0, $j5Bkz.floatRegex),
    countKey: "Numbers",
    token: "${n}",
    parse: (0, $kRios.number).parse
};
function $2270194b74f77550$var$tokenise(info, { regex: regex, countKey: countKey, token: token, parse: parse }) {
    const matches = info.tokenised.match(regex);
    if (!matches) return;
    info["num" + countKey] = matches.length;
    info.tokenised = info.tokenised.replace(regex, token);
    info.values.push(...matches.map(parse));
}
function $2270194b74f77550$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const info = {
        value: originalValue,
        tokenised: originalValue,
        values: [],
        numVars: 0,
        numColors: 0,
        numNumbers: 0
    };
    if (info.value.includes("var(--")) $2270194b74f77550$var$tokenise(info, $2270194b74f77550$var$cssVarTokeniser);
    $2270194b74f77550$var$tokenise(info, $2270194b74f77550$var$colorTokeniser);
    $2270194b74f77550$var$tokenise(info, $2270194b74f77550$var$numberTokeniser);
    return info;
}
function $2270194b74f77550$var$parseComplexValue(v) {
    return $2270194b74f77550$export$b61fc7c44bf646d5(v).values;
}
function $2270194b74f77550$var$createTransformer(source) {
    const { values: values, numColors: numColors, numVars: numVars, tokenised: tokenised } = $2270194b74f77550$export$b61fc7c44bf646d5(source);
    const numValues = values.length;
    return (v)=>{
        let output = tokenised;
        for(let i = 0; i < numValues; i++){
            if (i < numVars) output = output.replace($2270194b74f77550$var$cssVarTokeniser.token, v[i]);
            else if (i < numVars + numColors) output = output.replace($2270194b74f77550$var$colorTokeniser.token, (0, $4MLAr.color).transform(v[i]));
            else output = output.replace($2270194b74f77550$var$numberTokeniser.token, (0, $j5Bkz.sanitize)(v[i]));
        }
        return output;
    };
}
const $2270194b74f77550$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $2270194b74f77550$var$getAnimatableNone(v) {
    const parsed = $2270194b74f77550$var$parseComplexValue(v);
    const transformer = $2270194b74f77550$var$createTransformer(v);
    return transformer(parsed.map($2270194b74f77550$var$convertNumbersToZero));
}
const $2270194b74f77550$export$83a0e34f1302825b = {
    test: $2270194b74f77550$var$test,
    parse: $2270194b74f77550$var$parseComplexValue,
    createTransformer: $2270194b74f77550$var$createTransformer,
    getAnimatableNone: $2270194b74f77550$var$getAnimatableNone
};

});


parcelRegister("aqB8F", function(module, exports) {

$parcel$export(module.exports, "progress", () => $0895b14e50ae4bf7$export$504d7abb21fa8c9);
/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $0895b14e50ae4bf7$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

});


parcelRegister("5D3CS", function(module, exports) {

$parcel$export(module.exports, "defaultOffset", () => $1530ee972371a802$export$24dbcec0b26e6d9d);

var $2a4ba = parcelRequire("2a4ba");
function $1530ee972371a802$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $2a4ba.fillOffset)(offset, arr.length - 1);
    return offset;
}

});
parcelRegister("2a4ba", function(module, exports) {

$parcel$export(module.exports, "fillOffset", () => $5905c42cd9e7dd1e$export$dafee61230cf05c6);

var $bVhPN = parcelRequire("bVhPN");

var $aqB8F = parcelRequire("aqB8F");
function $5905c42cd9e7dd1e$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $aqB8F.progress)(0, remaining, i);
        offset.push((0, $bVhPN.mix)(min, 1, offsetProgress));
    }
}

});


parcelRegister("kk5mf", function(module, exports) {

$parcel$export(module.exports, "convertOffsetToTimes", () => $87e58ea248696712$export$2a91b4e3a4539316);
function $87e58ea248696712$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}

});


parcelRegister("5lvMn", function(module, exports) {

$parcel$export(module.exports, "spring", () => $311de6786f97e3cf$export$b36281d89752ae66);

var $48XSc = parcelRequire("48XSc");

var $lGT4F = parcelRequire("lGT4F");

var $6FC93 = parcelRequire("6FC93");
const $311de6786f97e3cf$var$durationKeys = [
    "duration",
    "bounce"
];
const $311de6786f97e3cf$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $311de6786f97e3cf$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $311de6786f97e3cf$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$311de6786f97e3cf$var$isSpringType(options, $311de6786f97e3cf$var$physicsKeys) && $311de6786f97e3cf$var$isSpringType(options, $311de6786f97e3cf$var$durationKeys)) {
        const derived = (0, $6FC93.findSpring)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $311de6786f97e3cf$export$b36281d89752ae66({ keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $311de6786f97e3cf$var$getSpringOptions({
        ...options,
        velocity: -(0, $48XSc.millisecondsToSeconds)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $48XSc.millisecondsToSeconds)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $6FC93.calcAngularFreq)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */ if (dampingRatio < 1) currentVelocity = (0, $lGT4F.calcGeneratorVelocity)(resolveSpring, t, current);
                    else currentVelocity = 0;
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}

});
parcelRegister("lGT4F", function(module, exports) {

$parcel$export(module.exports, "calcGeneratorVelocity", () => $6c864a8100178660$export$854187271d233eb5);

var $36DSG = parcelRequire("36DSG");
const $6c864a8100178660$var$velocitySampleDuration = 5; // ms
function $6c864a8100178660$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $6c864a8100178660$var$velocitySampleDuration, 0);
    return (0, $36DSG.velocityPerSecond)(current - resolveValue(prevT), t - prevT);
}

});
parcelRegister("36DSG", function(module, exports) {

$parcel$export(module.exports, "velocityPerSecond", () => $5138beb499deffc7$export$eab0632f7ad4f9d7);
/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $5138beb499deffc7$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

});


parcelRegister("6FC93", function(module, exports) {

$parcel$export(module.exports, "findSpring", () => $58d013265cb01d8b$export$b15f158dc6d6f458);
$parcel$export(module.exports, "calcAngularFreq", () => $58d013265cb01d8b$export$5f679887c3a78b15);

var $kpJ0L = parcelRequire("kpJ0L");

var $8WJMW = parcelRequire("8WJMW");

var $48XSc = parcelRequire("48XSc");
const $58d013265cb01d8b$var$safeMin = 0.001;
const $58d013265cb01d8b$export$a3cdb76e84ee608e = 0.01;
const $58d013265cb01d8b$export$1824b851fad8862b = 10.0;
const $58d013265cb01d8b$export$ff08f2d53484465 = 0.05;
const $58d013265cb01d8b$export$201ca48e54038115 = 1;
function $58d013265cb01d8b$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $kpJ0L.warning)(duration <= (0, $48XSc.secondsToMilliseconds)($58d013265cb01d8b$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $8WJMW.clamp)($58d013265cb01d8b$export$ff08f2d53484465, $58d013265cb01d8b$export$201ca48e54038115, dampingRatio);
    duration = (0, $8WJMW.clamp)($58d013265cb01d8b$export$a3cdb76e84ee608e, $58d013265cb01d8b$export$1824b851fad8862b, (0, $48XSc.millisecondsToSeconds)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $58d013265cb01d8b$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $58d013265cb01d8b$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $58d013265cb01d8b$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $58d013265cb01d8b$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$58d013265cb01d8b$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $58d013265cb01d8b$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $48XSc.secondsToMilliseconds)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $58d013265cb01d8b$var$rootIterations = 12;
function $58d013265cb01d8b$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $58d013265cb01d8b$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $58d013265cb01d8b$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

});


parcelRegister("7vp35", function(module, exports) {

$parcel$export(module.exports, "inertia", () => $e1c93ba144f22cdf$export$ee3ff3a17106998);

var $5lvMn = parcelRequire("5lvMn");

var $lGT4F = parcelRequire("lGT4F");
function $e1c93ba144f22cdf$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $5lvMn.spring)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $lGT4F.calcGeneratorVelocity)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t > timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}

});

parcelRegister("h38RI", function(module, exports) {

$parcel$export(module.exports, "frameloopDriver", () => $3da7ce0ee2622882$export$c1033964b5ad7fef);

var $lJeQK = parcelRequire("lJeQK");
const $3da7ce0ee2622882$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $lJeQK.frame).update(passTimestamp, true),
        stop: ()=>(0, $lJeQK.cancelFrame)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $lJeQK.frameData).isProcessing ? (0, $lJeQK.frameData).timestamp : performance.now()
    };
};

});

parcelRegister("2167W", function(module, exports) {

$parcel$export(module.exports, "calcGeneratorDuration", () => $b133e3d14805dc83$export$cbdd6b3d40ea54e2);
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $b133e3d14805dc83$export$f4ff70a5b4808fd8 = 20000;
function $b133e3d14805dc83$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $b133e3d14805dc83$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $b133e3d14805dc83$export$f4ff70a5b4808fd8 ? Infinity : duration;
}

});


parcelRegister("izj8W", function(module, exports) {

$parcel$export(module.exports, "memo", () => $042d3d704f166b97$export$7c73462e0d25e514);
function $042d3d704f166b97$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}

});


parcelRegister("gNYQn", function(module, exports) {

$parcel$export(module.exports, "createInstantAnimation", () => $e305a79904b60537$export$6f34fc8ef6c42b70);

var $9sEW6 = parcelRequire("9sEW6");

var $hsNz5 = parcelRequire("hsNz5");
function $e305a79904b60537$export$6f34fc8ef6c42b70({ keyframes: keyframes, delay: delay, onUpdate: onUpdate, onComplete: onComplete }) {
    const setValue = ()=>{
        onUpdate && onUpdate(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
        /**
         * TODO: As this API grows it could make sense to always return
         * animateValue. This will be a bigger project as animateValue
         * is frame-locked whereas this function resolves instantly.
         * This is a behavioural change and also has ramifications regarding
         * assumptions within tests.
         */ return {
            time: 0,
            speed: 1,
            duration: 0,
            play: (0, $hsNz5.noop),
            pause: (0, $hsNz5.noop),
            stop: (0, $hsNz5.noop),
            then: (resolve)=>{
                resolve();
                return Promise.resolve();
            },
            cancel: (0, $hsNz5.noop),
            complete: (0, $hsNz5.noop)
        };
    };
    return delay ? (0, $9sEW6.animateValue)({
        keyframes: [
            0,
            1
        ],
        duration: 0,
        delay: delay,
        onComplete: setValue
    }) : setValue();
}

});

parcelRegister("5Te0i", function(module, exports) {

$parcel$export(module.exports, "getDefaultTransition", () => $fca48f31d5e8f003$export$262124b154b9f1c0);

var $1ewxR = parcelRequire("1ewxR");
const $fca48f31d5e8f003$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $fca48f31d5e8f003$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $fca48f31d5e8f003$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $fca48f31d5e8f003$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $fca48f31d5e8f003$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $fca48f31d5e8f003$var$keyframesTransition;
    else if ((0, $1ewxR.transformProps).has(valueKey)) return valueKey.startsWith("scale") ? $fca48f31d5e8f003$var$criticallyDampedSpring(keyframes[1]) : $fca48f31d5e8f003$var$underDampedSpring;
    return $fca48f31d5e8f003$var$ease;
};

});

parcelRegister("hPjQl", function(module, exports) {

$parcel$export(module.exports, "isAnimatable", () => $070967be225b7207$export$65676b58b122bc38);

var $c7p3O = parcelRequire("c7p3O");
/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $070967be225b7207$export$65676b58b122bc38 = (key, value)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $c7p3O.complex).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};

});

parcelRegister("dsuVe", function(module, exports) {

$parcel$export(module.exports, "getKeyframes", () => $8a091dcc6fa561bc$export$b2b5e866b2fbf2ec);

var $cKVug = parcelRequire("cKVug");

var $hPjQl = parcelRequire("hPjQl");

var $hcHOK = parcelRequire("hcHOK");
function $8a091dcc6fa561bc$export$b2b5e866b2fbf2ec(value, valueName, target, transition) {
    const isTargetAnimatable = (0, $hPjQl.isAnimatable)(valueName, target);
    let keyframes;
    if (Array.isArray(target)) keyframes = [
        ...target
    ];
    else keyframes = [
        null,
        target
    ];
    const defaultOrigin = transition.from !== undefined ? transition.from : value.get();
    let animatableTemplateValue = undefined;
    const noneKeyframeIndexes = [];
    for(let i = 0; i < keyframes.length; i++){
        /**
         * Fill null/wildcard keyframes
         */ if (keyframes[i] === null) keyframes[i] = i === 0 ? defaultOrigin : keyframes[i - 1];
        if ((0, $hcHOK.isNone)(keyframes[i])) noneKeyframeIndexes.push(i);
        // TODO: Clean this conditional, it works for now
        if (typeof keyframes[i] === "string" && keyframes[i] !== "none" && keyframes[i] !== "0") animatableTemplateValue = keyframes[i];
    }
    if (isTargetAnimatable && noneKeyframeIndexes.length && animatableTemplateValue) for(let i = 0; i < noneKeyframeIndexes.length; i++){
        const index = noneKeyframeIndexes[i];
        keyframes[index] = (0, $cKVug.getAnimatableNone)(valueName, animatableTemplateValue);
    }
    return keyframes;
}

});
parcelRegister("cKVug", function(module, exports) {

$parcel$export(module.exports, "getAnimatableNone", () => $1fee80fe94aa2484$export$cea0cedcb94873b5);

var $c7p3O = parcelRequire("c7p3O");

var $276v4 = parcelRequire("276v4");

var $k5dje = parcelRequire("k5dje");
function $1fee80fe94aa2484$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $k5dje.getDefaultValueType)(key);
    if (defaultValueType !== (0, $276v4.filter)) defaultValueType = (0, $c7p3O.complex);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}

});
parcelRegister("276v4", function(module, exports) {

$parcel$export(module.exports, "filter", () => $e19335e2ec0b8b23$export$3dea766d36a8935f);

var $c7p3O = parcelRequire("c7p3O");

var $j5Bkz = parcelRequire("j5Bkz");
/**
 * Properties that should default to 1 or 100%
 */ const $e19335e2ec0b8b23$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $e19335e2ec0b8b23$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $j5Bkz.floatRegex)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $e19335e2ec0b8b23$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $e19335e2ec0b8b23$var$functionRegex = /([a-z-]*)\(.*?\)/g;
const $e19335e2ec0b8b23$export$3dea766d36a8935f = {
    ...(0, $c7p3O.complex),
    getAnimatableNone: (v)=>{
        const functions = v.match($e19335e2ec0b8b23$var$functionRegex);
        return functions ? functions.map($e19335e2ec0b8b23$var$applyDefaultFilter).join(" ") : v;
    }
};

});

parcelRegister("k5dje", function(module, exports) {

$parcel$export(module.exports, "getDefaultValueType", () => $4ff005b07671c1bc$export$67d1babe0338d23b);

var $4MLAr = parcelRequire("4MLAr");

var $276v4 = parcelRequire("276v4");

var $4UnGW = parcelRequire("4UnGW");
/**
 * A map of default value types for common values
 */ const $4ff005b07671c1bc$export$98cd7c72c5a731fb = {
    ...(0, $4UnGW.numberValueTypes),
    color: // Color props
    $4MLAr.color,
    backgroundColor: (0, $4MLAr.color),
    outlineColor: (0, $4MLAr.color),
    fill: (0, $4MLAr.color),
    stroke: (0, $4MLAr.color),
    // Border props
    borderColor: (0, $4MLAr.color),
    borderTopColor: (0, $4MLAr.color),
    borderRightColor: (0, $4MLAr.color),
    borderBottomColor: (0, $4MLAr.color),
    borderLeftColor: (0, $4MLAr.color),
    filter: $276v4.filter,
    WebkitFilter: (0, $276v4.filter)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $4ff005b07671c1bc$export$67d1babe0338d23b = (key)=>$4ff005b07671c1bc$export$98cd7c72c5a731fb[key];

});


parcelRegister("hcHOK", function(module, exports) {

$parcel$export(module.exports, "isNone", () => $cf52ac042204f7a0$export$e56af863d5645d5f);

var $3VpHs = parcelRequire("3VpHs");
function $cf52ac042204f7a0$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $3VpHs.isZeroValueString)(value);
}

});
parcelRegister("3VpHs", function(module, exports) {

$parcel$export(module.exports, "isZeroValueString", () => $fa390152bf620c86$export$ade84c85e44a6cb1);
/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $fa390152bf620c86$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/.test(v);

});



parcelRegister("8jA9i", function(module, exports) {

$parcel$export(module.exports, "isTransitionDefined", () => $97c593d3e622b254$export$ca8e47dc8ed5a9d7);
$parcel$export(module.exports, "getValueTransition", () => $97c593d3e622b254$export$7c1391340308742e);
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $97c593d3e622b254$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function $97c593d3e622b254$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}

});

parcelRegister("nolfW", function(module, exports) {

$parcel$export(module.exports, "MotionGlobalConfig", () => $df98f03a93e1bb6e$export$dd826089e3c5e502);
const $df98f03a93e1bb6e$export$dd826089e3c5e502 = {
    skipAnimations: false
};

});


parcelRegister("8DT3X", function(module, exports) {

$parcel$export(module.exports, "isWillChangeMotionValue", () => $b1b434dd42619598$export$98397f3adbf6259f);

var $cV7py = parcelRequire("cV7py");
function $b1b434dd42619598$export$98397f3adbf6259f(value) {
    return Boolean((0, $cV7py.isMotionValue)(value) && value.add);
}

});

parcelRegister("g5LEV", function(module, exports) {

$parcel$export(module.exports, "setTarget", () => $fd8757c225bcc16a$export$1f61c53461aff4a5);
$parcel$export(module.exports, "setValues", () => $fd8757c225bcc16a$export$b7771d60d308862f);
$parcel$export(module.exports, "checkTargetForNewValues", () => $fd8757c225bcc16a$export$6afbed164019a54c);
$parcel$export(module.exports, "getOrigin", () => $fd8757c225bcc16a$export$5a759dc7a1cfb72a);

var $c6hlF = parcelRequire("c6hlF");

var $3VpHs = parcelRequire("3VpHs");

var $7JSeb = parcelRequire("7JSeb");

var $8fYq9 = parcelRequire("8fYq9");

var $c7p3O = parcelRequire("c7p3O");

var $cKVug = parcelRequire("cKVug");

var $5TkWU = parcelRequire("5TkWU");

var $3COsz = parcelRequire("3COsz");
/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $fd8757c225bcc16a$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $8fYq9.motionValue)(value));
}
function $fd8757c225bcc16a$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $3COsz.resolveVariant)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $7JSeb.resolveFinalValueInKeyframes)(target[key]);
        $fd8757c225bcc16a$var$setMotionValue(visualElement, key, value);
    }
}
function $fd8757c225bcc16a$var$setVariants(visualElement, variantLabels) {
    const reversedLabels = [
        ...variantLabels
    ].reverse();
    reversedLabels.forEach((key)=>{
        const variant = visualElement.getVariant(key);
        variant && $fd8757c225bcc16a$export$1f61c53461aff4a5(visualElement, variant);
        if (visualElement.variantChildren) visualElement.variantChildren.forEach((child)=>{
            $fd8757c225bcc16a$var$setVariants(child, variantLabels);
        });
    });
}
function $fd8757c225bcc16a$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $fd8757c225bcc16a$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $fd8757c225bcc16a$var$setVariants(visualElement, [
        definition
    ]);
    else $fd8757c225bcc16a$export$1f61c53461aff4a5(visualElement, definition);
}
function $fd8757c225bcc16a$export$6afbed164019a54c(visualElement, target, origin) {
    var _a, _b;
    const newValueKeys = Object.keys(target).filter((key)=>!visualElement.hasValue(key));
    const numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(let i = 0; i < numNewValues; i++){
        const key = newValueKeys[i];
        const targetValue = target[key];
        let value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && ((0, $c6hlF.isNumericalString)(value) || (0, $3VpHs.isZeroValueString)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, $5TkWU.findValueType)(value) && (0, $c7p3O.complex).test(targetValue)) value = (0, $cKVug.getAnimatableNone)(key, targetValue);
        visualElement.addValue(key, (0, $8fYq9.motionValue)(value, {
            owner: visualElement
        }));
        if (origin[key] === undefined) origin[key] = value;
        if (value !== null) visualElement.setBaseTarget(key, value);
    }
}
function $fd8757c225bcc16a$export$c3befe8e18686628(key, transition) {
    if (!transition) return;
    const valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function $fd8757c225bcc16a$export$5a759dc7a1cfb72a(target, transition, visualElement) {
    const origin = {};
    for(const key in target){
        const transitionOrigin = $fd8757c225bcc16a$export$c3befe8e18686628(key, transition);
        if (transitionOrigin !== undefined) origin[key] = transitionOrigin;
        else {
            const value = visualElement.getValue(key);
            if (value) origin[key] = value.get();
        }
    }
    return origin;
}

});
parcelRegister("c6hlF", function(module, exports) {

$parcel$export(module.exports, "isNumericalString", () => $b4cdf160a39b30fd$export$65583ed5a868f2d9);
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $b4cdf160a39b30fd$export$65583ed5a868f2d9 = (v)=>/^\-?\d*\.?\d+$/.test(v);

});

parcelRegister("8fYq9", function(module, exports) {

$parcel$export(module.exports, "collectMotionValues", () => $556c7c9e427bb619$export$67fcd818a264039d);
$parcel$export(module.exports, "motionValue", () => $556c7c9e427bb619$export$ce8bdc721e76545f);

var $36ejV = parcelRequire("36ejV");

var $36DSG = parcelRequire("36DSG");


var $lJeQK = parcelRequire("lJeQK");
const $556c7c9e427bb619$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $556c7c9e427bb619$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $556c7c9e427bb619$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "10.18.0";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            this.prev = this.current;
            this.current = v;
            // Update timestamp
            const { delta: delta, timestamp: timestamp } = (0, $lJeQK.frameData);
            if (this.lastUpdated !== timestamp) {
                this.timeDelta = delta;
                this.lastUpdated = timestamp;
                (0, $lJeQK.frame).postRender(this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (this.prev !== this.current && this.events.change) this.events.change.notify(this.current);
            // Update velocity subscribers
            if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = ()=>(0, $lJeQK.frame).postRender(this.velocityCheck);
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = ({ timestamp: timestamp })=>{
            if (timestamp !== this.lastUpdated) {
                this.prev = this.current;
                if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = $556c7c9e427bb619$var$isFloat(this.current);
        this.owner = options.owner;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $36ejV.SubscriptionManager)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $lJeQK.frame).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = prev;
        this.timeDelta = delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v) {
        this.updateAndNotify(v);
        this.prev = v;
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($556c7c9e427bb619$export$67fcd818a264039d.current) $556c7c9e427bb619$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, $36DSG.velocityPerSecond)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $556c7c9e427bb619$export$ce8bdc721e76545f(init, options) {
    return new $556c7c9e427bb619$export$8cea36d14ee64562(init, options);
}

});
parcelRegister("36ejV", function(module, exports) {

$parcel$export(module.exports, "SubscriptionManager", () => $13f58d9be48aa3db$export$e7dff9482a5fd23c);

var $6Oyuy = parcelRequire("6Oyuy");
class $13f58d9be48aa3db$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $6Oyuy.addUniqueItem)(this.subscriptions, handler);
        return ()=>(0, $6Oyuy.removeItem)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}

});
parcelRegister("6Oyuy", function(module, exports) {

$parcel$export(module.exports, "addUniqueItem", () => $a388d1a861d8a258$export$20e507e47fae79fd);
$parcel$export(module.exports, "removeItem", () => $a388d1a861d8a258$export$fe2d9b4e03920b4c);
$parcel$export(module.exports, "moveItem", () => $a388d1a861d8a258$export$ec937e64de6c1257);
function $a388d1a861d8a258$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $a388d1a861d8a258$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $a388d1a861d8a258$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}

});



parcelRegister("5TkWU", function(module, exports) {

$parcel$export(module.exports, "findValueType", () => $fa2371910af2567d$export$950e7e59ea1ffed7);

var $4MLAr = parcelRequire("4MLAr");

var $c7p3O = parcelRequire("c7p3O");

var $92Rhp = parcelRequire("92Rhp");

var $9XEdL = parcelRequire("9XEdL");
/**
 * A list of all ValueTypes
 */ const $fa2371910af2567d$var$valueTypes = [
    ...(0, $92Rhp.dimensionValueTypes),
    (0, $4MLAr.color),
    (0, $c7p3O.complex)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $fa2371910af2567d$export$950e7e59ea1ffed7 = (v)=>$fa2371910af2567d$var$valueTypes.find((0, $9XEdL.testValueType)(v));

});
parcelRegister("92Rhp", function(module, exports) {

$parcel$export(module.exports, "dimensionValueTypes", () => $9b259a19053bbcce$export$d176691c1998a1f5);
$parcel$export(module.exports, "findDimensionValueType", () => $9b259a19053bbcce$export$eefdd52e3ccae428);

var $kRios = parcelRequire("kRios");

var $9PDxZ = parcelRequire("9PDxZ");

var $9XEdL = parcelRequire("9XEdL");

var $70CBH = parcelRequire("70CBH");
/**
 * A list of value types commonly used for dimensions
 */ const $9b259a19053bbcce$export$d176691c1998a1f5 = [
    (0, $kRios.number),
    (0, $9PDxZ.px),
    (0, $9PDxZ.percent),
    (0, $9PDxZ.degrees),
    (0, $9PDxZ.vw),
    (0, $9PDxZ.vh),
    (0, $70CBH.auto)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $9b259a19053bbcce$export$eefdd52e3ccae428 = (v)=>$9b259a19053bbcce$export$d176691c1998a1f5.find((0, $9XEdL.testValueType)(v));

});
parcelRegister("9XEdL", function(module, exports) {

$parcel$export(module.exports, "testValueType", () => $5f9786a55c621b57$export$6eae4d0a6a7ca7cd);
/**
 * Tests a provided value against a ValueType
 */ const $5f9786a55c621b57$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);

});

parcelRegister("70CBH", function(module, exports) {

$parcel$export(module.exports, "auto", () => $c7cb9a3bd3055925$export$dfb5619354ba860);
/**
 * ValueType for "auto"
 */ const $c7cb9a3bd3055925$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};

});





parcelRegister("5Dswx", function(module, exports) {

$parcel$export(module.exports, "animateVariant", () => $31c78694b87ca7a1$export$4709dc300705b2af);

var $3COsz = parcelRequire("3COsz");

var $29hVF = parcelRequire("29hVF");
function $31c78694b87ca7a1$export$4709dc300705b2af(visualElement, variant, options = {}) {
    const resolved = (0, $3COsz.resolveVariant)(visualElement, variant, options.custom);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $29hVF.animateTarget)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $31c78694b87ca7a1$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $31c78694b87ca7a1$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($31c78694b87ca7a1$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($31c78694b87ca7a1$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $31c78694b87ca7a1$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}

});




parcelRegister("e0395", function(module, exports) {

$parcel$export(module.exports, "ExitAnimationFeature", () => $2aee006d06e2e5e8$export$4989d1eb6104cc6c);

var $jRBPW = parcelRequire("jRBPW");
let $2aee006d06e2e5e8$var$id = 0;
class $2aee006d06e2e5e8$export$4989d1eb6104cc6c extends (0, $jRBPW.Feature) {
    constructor(){
        super(...arguments);
        this.id = $2aee006d06e2e5e8$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete, custom: custom } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent, {
            custom: custom !== null && custom !== void 0 ? custom : this.node.getProps().custom
        });
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}

});


parcelRegister("dtsrn", function(module, exports) {

$parcel$export(module.exports, "drag", () => $5cc8e3d399c8b23c$export$d7d5d435647ed5a0);

var $8zTiw = parcelRequire("8zTiw");

var $i9KJB = parcelRequire("i9KJB");

var $7OUlY = parcelRequire("7OUlY");

var $luVWK = parcelRequire("luVWK");
const $5cc8e3d399c8b23c$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $i9KJB.PanGesture)
    },
    drag: {
        Feature: (0, $8zTiw.DragGesture),
        ProjectionNode: (0, $luVWK.HTMLProjectionNode),
        MeasureLayout: $7OUlY.MeasureLayout
    }
};

});
parcelRegister("8zTiw", function(module, exports) {

$parcel$export(module.exports, "DragGesture", () => $b363c7118fc7b1f9$export$5d97dc2872682820);

var $jRBPW = parcelRequire("jRBPW");

var $hsNz5 = parcelRequire("hsNz5");

var $dygUv = parcelRequire("dygUv");
class $b363c7118fc7b1f9$export$5d97dc2872682820 extends (0, $jRBPW.Feature) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $hsNz5.noop);
        this.removeListeners = (0, $hsNz5.noop);
        this.controls = new (0, $dygUv.VisualElementDragControls)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $hsNz5.noop);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}

});
parcelRegister("dygUv", function(module, exports) {

$parcel$export(module.exports, "VisualElementDragControls", () => $71c5334ffa006142$export$86bff71f18910307);

var $kpJ0L = parcelRequire("kpJ0L");

var $axvnx = parcelRequire("axvnx");

var $iDnTQ = parcelRequire("iDnTQ");

var $h29D1 = parcelRequire("h29D1");

var $Z8cIX = parcelRequire("Z8cIX");

var $4N2iN = parcelRequire("4N2iN");

var $kjXzb = parcelRequire("kjXzb");

var $2MHzA = parcelRequire("2MHzA");

var $WoUBD = parcelRequire("WoUBD");

var $dT4Fd = parcelRequire("dT4Fd");

var $kH9QY = parcelRequire("kH9QY");

var $hvbUJ = parcelRequire("hvbUJ");

var $jllPU = parcelRequire("jllPU");

var $bVhPN = parcelRequire("bVhPN");

var $9PDxZ = parcelRequire("9PDxZ");

var $cHMmF = parcelRequire("cHMmF");

var $01gYC = parcelRequire("01gYC");

var $lJeQK = parcelRequire("lJeQK");
const $71c5334ffa006142$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $71c5334ffa006142$export$86bff71f18910307 {
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $kjXzb.createBox)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $dT4Fd.extractEventInfo)(event, "page").point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $iDnTQ.getGlobalLock)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $2MHzA.eachAxis)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $9PDxZ.percent).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $jllPU.calcLength)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $lJeQK.frame).update(()=>onDragStart(event, info), false, true);
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $71c5334ffa006142$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $2MHzA.eachAxis)((axis)=>{
                var _a;
                return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
            });
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $axvnx.PanSession)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $01gYC.getContextWindow)(this.visualElement)
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $lJeQK.frame).update(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$71c5334ffa006142$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $4N2iN.applyConstraints)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $h29D1.isRefObject)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $4N2iN.calcRelativeConstraints)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $4N2iN.resolveDragElastic)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $2MHzA.eachAxis)((axis)=>{
            if (this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $4N2iN.rebaseAxisConstraints)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $h29D1.isRefObject)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $kpJ0L.invariant)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $WoUBD.measurePageBox)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $4N2iN.calcViewportConstraints)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $kH9QY.convertBoxToBoundingBox)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $kH9QY.convertBoundingBoxToBox)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $2MHzA.eachAxis)((axis)=>{
            if (!$71c5334ffa006142$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start((0, $cHMmF.animateMotionValue)(axis, axisValue, 0, transition));
    }
    stopAnimation() {
        (0, $2MHzA.eachAxis)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $2MHzA.eachAxis)((axis)=>{
            var _a;
            return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = "_drag" + axis.toUpperCase();
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $2MHzA.eachAxis)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$71c5334ffa006142$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $bVhPN.mix)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $h29D1.isRefObject)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $2MHzA.eachAxis)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $4N2iN.calcOrigin)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $2MHzA.eachAxis)((axis)=>{
            if (!$71c5334ffa006142$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $bVhPN.mix)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $71c5334ffa006142$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $Z8cIX.addPointerEvent)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $h29D1.isRefObject)(dragConstraints)) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $hvbUJ.addDomEvent)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $2MHzA.eachAxis)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $4N2iN.defaultElastic), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $71c5334ffa006142$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $71c5334ffa006142$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}

});
parcelRegister("axvnx", function(module, exports) {

$parcel$export(module.exports, "PanSession", () => $1a590c9e0c5c1b65$export$d9c66232c9c4689c);

var $dT4Fd = parcelRequire("dT4Fd");

var $48XSc = parcelRequire("48XSc");

var $Z8cIX = parcelRequire("Z8cIX");

var $jnmzn = parcelRequire("jnmzn");

var $dI47U = parcelRequire("dI47U");

var $KnY8t = parcelRequire("KnY8t");

var $lJeQK = parcelRequire("lJeQK");
/**
 * @internal
 */ class $1a590c9e0c5c1b65$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow, dragSnapToOrigin: dragSnapToOrigin = false } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $1a590c9e0c5c1b65$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $dI47U.distance2D)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $lJeQK.frameData);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $1a590c9e0c5c1b65$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $lJeQK.frame).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $1a590c9e0c5c1b65$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $1a590c9e0c5c1b65$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $KnY8t.isPrimaryPointer)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $dT4Fd.extractEventInfo)(event);
        const initialInfo = $1a590c9e0c5c1b65$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $lJeQK.frameData);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $1a590c9e0c5c1b65$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $jnmzn.pipe)((0, $Z8cIX.addPointerEvent)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $Z8cIX.addPointerEvent)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $Z8cIX.addPointerEvent)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $lJeQK.cancelFrame)(this.updatePoint);
    }
}
function $1a590c9e0c5c1b65$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $1a590c9e0c5c1b65$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $1a590c9e0c5c1b65$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $1a590c9e0c5c1b65$var$subtractPoint(point, $1a590c9e0c5c1b65$var$lastDevicePoint(history)),
        offset: $1a590c9e0c5c1b65$var$subtractPoint(point, $1a590c9e0c5c1b65$var$startDevicePoint(history)),
        velocity: $1a590c9e0c5c1b65$var$getVelocity(history, 0.1)
    };
}
function $1a590c9e0c5c1b65$var$startDevicePoint(history) {
    return history[0];
}
function $1a590c9e0c5c1b65$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $1a590c9e0c5c1b65$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $1a590c9e0c5c1b65$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $48XSc.secondsToMilliseconds)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $48XSc.millisecondsToSeconds)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}

});
parcelRegister("dI47U", function(module, exports) {

$parcel$export(module.exports, "distance2D", () => $a85087c0b7b865ff$export$503a1d513f12e38b);
const $a85087c0b7b865ff$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $a85087c0b7b865ff$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $a85087c0b7b865ff$export$9f17032d917177de(a.x, b.x);
    const yDelta = $a85087c0b7b865ff$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}

});


parcelRegister("4N2iN", function(module, exports) {

$parcel$export(module.exports, "applyConstraints", () => $a8ab40dfbc0c75b8$export$b3c764d3fca3ffe3);
$parcel$export(module.exports, "calcRelativeConstraints", () => $a8ab40dfbc0c75b8$export$4e9195bf7793bc78);
$parcel$export(module.exports, "calcViewportConstraints", () => $a8ab40dfbc0c75b8$export$4228500f19d4cdf7);
$parcel$export(module.exports, "calcOrigin", () => $a8ab40dfbc0c75b8$export$13abbfca044ca46d);
$parcel$export(module.exports, "rebaseAxisConstraints", () => $a8ab40dfbc0c75b8$export$e9672cc4c36a8b87);
$parcel$export(module.exports, "defaultElastic", () => $a8ab40dfbc0c75b8$export$a3366d3bac43a742);
$parcel$export(module.exports, "resolveDragElastic", () => $a8ab40dfbc0c75b8$export$7c5eaef8f4723d22);

var $aqB8F = parcelRequire("aqB8F");

var $jllPU = parcelRequire("jllPU");

var $8WJMW = parcelRequire("8WJMW");

var $bVhPN = parcelRequire("bVhPN");
/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $a8ab40dfbc0c75b8$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $bVhPN.mix)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $bVhPN.mix)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $a8ab40dfbc0c75b8$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $a8ab40dfbc0c75b8$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $a8ab40dfbc0c75b8$export$690c180aa5775042(layoutBox.x, left, right),
        y: $a8ab40dfbc0c75b8$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $a8ab40dfbc0c75b8$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $a8ab40dfbc0c75b8$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $a8ab40dfbc0c75b8$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $a8ab40dfbc0c75b8$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $a8ab40dfbc0c75b8$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $jllPU.calcLength)(source);
    const targetLength = (0, $jllPU.calcLength)(target);
    if (targetLength > sourceLength) origin = (0, $aqB8F.progress)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $aqB8F.progress)(source.min, source.max - targetLength, target.min);
    return (0, $8WJMW.clamp)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $a8ab40dfbc0c75b8$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $a8ab40dfbc0c75b8$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $a8ab40dfbc0c75b8$export$7c5eaef8f4723d22(dragElastic = $a8ab40dfbc0c75b8$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $a8ab40dfbc0c75b8$export$a3366d3bac43a742;
    return {
        x: $a8ab40dfbc0c75b8$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $a8ab40dfbc0c75b8$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $a8ab40dfbc0c75b8$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $a8ab40dfbc0c75b8$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $a8ab40dfbc0c75b8$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $a8ab40dfbc0c75b8$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}

});
parcelRegister("jllPU", function(module, exports) {

$parcel$export(module.exports, "calcLength", () => $2cdcf6041853015c$export$c1c127004b72a37);
$parcel$export(module.exports, "isNear", () => $2cdcf6041853015c$export$28d0384c4b79bde2);
$parcel$export(module.exports, "calcBoxDelta", () => $2cdcf6041853015c$export$c0d25e96fc67d310);
$parcel$export(module.exports, "calcRelativeBox", () => $2cdcf6041853015c$export$426154f9d100f99);
$parcel$export(module.exports, "calcRelativePosition", () => $2cdcf6041853015c$export$2785bfcc929c5650);

var $bVhPN = parcelRequire("bVhPN");
function $2cdcf6041853015c$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $2cdcf6041853015c$export$28d0384c4b79bde2(value, target = 0, maxDistance = 0.01) {
    return Math.abs(value - target) <= maxDistance;
}
function $2cdcf6041853015c$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $bVhPN.mix)(source.min, source.max, delta.origin);
    delta.scale = $2cdcf6041853015c$export$c1c127004b72a37(target) / $2cdcf6041853015c$export$c1c127004b72a37(source);
    if ($2cdcf6041853015c$export$28d0384c4b79bde2(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = (0, $bVhPN.mix)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($2cdcf6041853015c$export$28d0384c4b79bde2(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function $2cdcf6041853015c$export$c0d25e96fc67d310(delta, source, target, origin) {
    $2cdcf6041853015c$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $2cdcf6041853015c$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $2cdcf6041853015c$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $2cdcf6041853015c$export$c1c127004b72a37(relative);
}
function $2cdcf6041853015c$export$426154f9d100f99(target, relative, parent) {
    $2cdcf6041853015c$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $2cdcf6041853015c$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $2cdcf6041853015c$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $2cdcf6041853015c$export$c1c127004b72a37(layout);
}
function $2cdcf6041853015c$export$2785bfcc929c5650(target, layout, parent) {
    $2cdcf6041853015c$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $2cdcf6041853015c$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}

});


parcelRegister("kjXzb", function(module, exports) {

$parcel$export(module.exports, "createDelta", () => $1a4fe3ac6f750acf$export$3d227df54007d73a);
$parcel$export(module.exports, "createBox", () => $1a4fe3ac6f750acf$export$6459fc9e86be362e);
const $1a4fe3ac6f750acf$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $1a4fe3ac6f750acf$export$3d227df54007d73a = ()=>({
        x: $1a4fe3ac6f750acf$export$ff25708b37f72782(),
        y: $1a4fe3ac6f750acf$export$ff25708b37f72782()
    });
const $1a4fe3ac6f750acf$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $1a4fe3ac6f750acf$export$6459fc9e86be362e = ()=>({
        x: $1a4fe3ac6f750acf$export$6db76765312617ac(),
        y: $1a4fe3ac6f750acf$export$6db76765312617ac()
    });

});

parcelRegister("2MHzA", function(module, exports) {

$parcel$export(module.exports, "eachAxis", () => $ae65936e4f16ad07$export$b789de563eb43b1);
function $ae65936e4f16ad07$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}

});

parcelRegister("WoUBD", function(module, exports) {

$parcel$export(module.exports, "measureViewportBox", () => $82d6cf626c13cf63$export$d8718b6a7e5c624e);
$parcel$export(module.exports, "measurePageBox", () => $82d6cf626c13cf63$export$6a597be7a7940a96);

var $kH9QY = parcelRequire("kH9QY");

var $iWFmw = parcelRequire("iWFmw");
function $82d6cf626c13cf63$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $kH9QY.convertBoundingBoxToBox)((0, $kH9QY.transformBoxPoints)(instance.getBoundingClientRect(), transformPoint));
}
function $82d6cf626c13cf63$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $82d6cf626c13cf63$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $iWFmw.translateAxis)(viewportBox.x, scroll.offset.x);
        (0, $iWFmw.translateAxis)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}

});
parcelRegister("kH9QY", function(module, exports) {

$parcel$export(module.exports, "convertBoundingBoxToBox", () => $60fcf38e847d6426$export$d3955c6a8f65a36b);
$parcel$export(module.exports, "convertBoxToBoundingBox", () => $60fcf38e847d6426$export$b6b9cd4198191a47);
$parcel$export(module.exports, "transformBoxPoints", () => $60fcf38e847d6426$export$21543fb75483a50);
/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $60fcf38e847d6426$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $60fcf38e847d6426$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $60fcf38e847d6426$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}

});

parcelRegister("iWFmw", function(module, exports) {

$parcel$export(module.exports, "scalePoint", () => $1e819ae3b5d62121$export$2290ec7febe36dd6);
$parcel$export(module.exports, "applyBoxDelta", () => $1e819ae3b5d62121$export$d80074982803af5c);
$parcel$export(module.exports, "applyTreeDeltas", () => $1e819ae3b5d62121$export$e2a980535c55eabb);
$parcel$export(module.exports, "transformBox", () => $1e819ae3b5d62121$export$58b16271041fbfb);
$parcel$export(module.exports, "translateAxis", () => $1e819ae3b5d62121$export$a807a5ce5ebb3895);

var $bVhPN = parcelRequire("bVhPN");

var $dhuRS = parcelRequire("dhuRS");
/**
 * Scales a point based on a factor and an originPoint
 */ function $1e819ae3b5d62121$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $1e819ae3b5d62121$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $1e819ae3b5d62121$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $1e819ae3b5d62121$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $1e819ae3b5d62121$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $1e819ae3b5d62121$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $1e819ae3b5d62121$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $1e819ae3b5d62121$export$d80074982803af5c(box, { x: x, y: y }) {
    $1e819ae3b5d62121$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $1e819ae3b5d62121$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $1e819ae3b5d62121$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const instance = node.instance;
        if (instance && instance.style && instance.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $1e819ae3b5d62121$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $1e819ae3b5d62121$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $dhuRS.hasTransform)(node.latestValues)) $1e819ae3b5d62121$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ treeScale.x = $1e819ae3b5d62121$var$snapToDefault(treeScale.x);
    treeScale.y = $1e819ae3b5d62121$var$snapToDefault(treeScale.y);
}
function $1e819ae3b5d62121$var$snapToDefault(scale) {
    if (Number.isInteger(scale)) return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function $1e819ae3b5d62121$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $1e819ae3b5d62121$export$625f1dd140a2f5e7(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = (0, $bVhPN.mix)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $1e819ae3b5d62121$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $1e819ae3b5d62121$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $1e819ae3b5d62121$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $1e819ae3b5d62121$export$58b16271041fbfb(box, transform) {
    $1e819ae3b5d62121$export$625f1dd140a2f5e7(box.x, transform, $1e819ae3b5d62121$var$xKeys);
    $1e819ae3b5d62121$export$625f1dd140a2f5e7(box.y, transform, $1e819ae3b5d62121$var$yKeys);
}

});
parcelRegister("dhuRS", function(module, exports) {

$parcel$export(module.exports, "hasScale", () => $38a3ef45168f2bd4$export$bdf30dca883ea463);
$parcel$export(module.exports, "hasTransform", () => $38a3ef45168f2bd4$export$a545127cf1fbb600);
$parcel$export(module.exports, "has2DTranslate", () => $38a3ef45168f2bd4$export$bf80f5f8f4dc327f);
function $38a3ef45168f2bd4$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $38a3ef45168f2bd4$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$38a3ef45168f2bd4$var$isIdentityScale(scale) || !$38a3ef45168f2bd4$var$isIdentityScale(scaleX) || !$38a3ef45168f2bd4$var$isIdentityScale(scaleY);
}
function $38a3ef45168f2bd4$export$a545127cf1fbb600(values) {
    return $38a3ef45168f2bd4$export$bdf30dca883ea463(values) || $38a3ef45168f2bd4$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function $38a3ef45168f2bd4$export$bf80f5f8f4dc327f(values) {
    return $38a3ef45168f2bd4$var$is2DTranslate(values.x) || $38a3ef45168f2bd4$var$is2DTranslate(values.y);
}
function $38a3ef45168f2bd4$var$is2DTranslate(value) {
    return value && value !== "0%";
}

});



parcelRegister("01gYC", function(module, exports) {

$parcel$export(module.exports, "getContextWindow", () => $2263cb0552277d58$export$d533d84f9871c879);
// Fixes https://github.com/framer/motion/issues/2270
const $2263cb0552277d58$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};

});



parcelRegister("i9KJB", function(module, exports) {

$parcel$export(module.exports, "PanGesture", () => $53420294c01cf6be$export$b4f8f1ee75ce5859);

var $axvnx = parcelRequire("axvnx");

var $Z8cIX = parcelRequire("Z8cIX");

var $jRBPW = parcelRequire("jRBPW");

var $hsNz5 = parcelRequire("hsNz5");

var $01gYC = parcelRequire("01gYC");

var $lJeQK = parcelRequire("lJeQK");
const $53420294c01cf6be$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $lJeQK.frame).update(()=>handler(event, info));
    };
class $53420294c01cf6be$export$b4f8f1ee75ce5859 extends (0, $jRBPW.Feature) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $hsNz5.noop);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $axvnx.PanSession)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $01gYC.getContextWindow)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $53420294c01cf6be$var$asyncHandler(onPanSessionStart),
            onStart: $53420294c01cf6be$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $lJeQK.frame).update(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $Z8cIX.addPointerEvent)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}

});

parcelRegister("7OUlY", function(module, exports) {

$parcel$export(module.exports, "MeasureLayout", () => $412f86d803304f84$export$779f5fb01ad751cd);

var $3qjKr = parcelRequire("3qjKr");

var $ecotb = parcelRequire("ecotb");

var $dhRBH = parcelRequire("dhRBH");

var $dW1Dq = parcelRequire("dW1Dq");

var $9h9QH = parcelRequire("9h9QH");

var $eFAh2 = parcelRequire("eFAh2");

var $jSOD1 = parcelRequire("jSOD1");

var $01mqa = parcelRequire("01mqa");

var $lJeQK = parcelRequire("lJeQK");
class $412f86d803304f84$var$MeasureLayoutWithContext extends (0, (/*@__PURE__*/$parcel$interopDefault($3qjKr))).Component {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $01mqa.addScaleCorrector)($412f86d803304f84$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $9h9QH.globalProjectionState).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $lJeQK.frame).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            queueMicrotask(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $412f86d803304f84$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $ecotb.usePresence)();
    const layoutGroup = (0, $3qjKr.useContext)((0, $dhRBH.LayoutGroupContext));
    return (0, (/*@__PURE__*/$parcel$interopDefault($3qjKr))).createElement($412f86d803304f84$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $3qjKr.useContext)((0, $dW1Dq.SwitchLayoutGroupContext)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $412f86d803304f84$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $eFAh2.correctBorderRadius),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $eFAh2.correctBorderRadius),
    borderTopRightRadius: (0, $eFAh2.correctBorderRadius),
    borderBottomLeftRadius: (0, $eFAh2.correctBorderRadius),
    borderBottomRightRadius: (0, $eFAh2.correctBorderRadius),
    boxShadow: (0, $jSOD1.correctBoxShadow)
};

});
parcelRegister("ecotb", function(module, exports) {

$parcel$export(module.exports, "usePresence", () => $1dad77bd9cb5e0c6$export$2a8c16d82a0a0e26);
$parcel$export(module.exports, "useIsPresent", () => $1dad77bd9cb5e0c6$export$8249053f690ea39a);

var $3qjKr = parcelRequire("3qjKr");

var $dMYJ7 = parcelRequire("dMYJ7");
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $1dad77bd9cb5e0c6$export$2a8c16d82a0a0e26() {
    const context = (0, $3qjKr.useContext)((0, $dMYJ7.PresenceContext));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $3qjKr.useId)();
    (0, $3qjKr.useEffect)(()=>register(id), []);
    const safeToRemove = ()=>onExitComplete && onExitComplete(id);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $1dad77bd9cb5e0c6$export$8249053f690ea39a() {
    return $1dad77bd9cb5e0c6$export$ee27c052bca048fb((0, $3qjKr.useContext)((0, $dMYJ7.PresenceContext)));
}
function $1dad77bd9cb5e0c6$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}

});

parcelRegister("9h9QH", function(module, exports) {

$parcel$export(module.exports, "globalProjectionState", () => $2792f44172204f99$export$97db156a3ed1593b);
/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $2792f44172204f99$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};

});

parcelRegister("eFAh2", function(module, exports) {

$parcel$export(module.exports, "correctBorderRadius", () => $0acda2bb9dea1d23$export$5eafb6257a5844c);

var $9PDxZ = parcelRequire("9PDxZ");
function $0acda2bb9dea1d23$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $0acda2bb9dea1d23$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $9PDxZ.px).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $0acda2bb9dea1d23$export$fafff692be55225d(latest, node.target.x);
        const y = $0acda2bb9dea1d23$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};

});

parcelRegister("jSOD1", function(module, exports) {

$parcel$export(module.exports, "correctBoxShadow", () => $2eba4767d9746c11$export$eb0bc629e74dcf8);

var $bVhPN = parcelRequire("bVhPN");

var $c7p3O = parcelRequire("c7p3O");
const $2eba4767d9746c11$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $c7p3O.complex).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $c7p3O.complex).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $bVhPN.mix)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};

});


parcelRegister("luVWK", function(module, exports) {

$parcel$export(module.exports, "HTMLProjectionNode", () => $0ad16bce2b55bb50$export$b61a9eb3dbde8858);

var $3UgiJ = parcelRequire("3UgiJ");

var $gLmaM = parcelRequire("gLmaM");
const $0ad16bce2b55bb50$export$b91509fcf893b648 = {
    current: undefined
};
const $0ad16bce2b55bb50$export$b61a9eb3dbde8858 = (0, $3UgiJ.createProjectionNode)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$0ad16bce2b55bb50$export$b91509fcf893b648.current) {
            const documentNode = new (0, $gLmaM.DocumentProjectionNode)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $0ad16bce2b55bb50$export$b91509fcf893b648.current = documentNode;
        }
        return $0ad16bce2b55bb50$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});

});
parcelRegister("3UgiJ", function(module, exports) {

$parcel$export(module.exports, "createProjectionNode", () => $c763064da9a08930$export$a84b61f69daa9da0);

var $36ejV = parcelRequire("36ejV");

var $aMXav = parcelRequire("aMXav");

var $bEkEP = parcelRequire("bEkEP");

var $iWFmw = parcelRequire("iWFmw");

var $jllPU = parcelRequire("jllPU");

var $5py78 = parcelRequire("5py78");

var $kjXzb = parcelRequire("kjXzb");

var $8jA9i = parcelRequire("8jA9i");

var $RyhFU = parcelRequire("RyhFU");

var $iVo0D = parcelRequire("iVo0D");

var $01mqa = parcelRequire("01mqa");

var $rhFEe = parcelRequire("rhFEe");

var $2MHzA = parcelRequire("2MHzA");

var $dhuRS = parcelRequire("dhuRS");

var $56wZe = parcelRequire("56wZe");

var $7BLmV = parcelRequire("7BLmV");

var $9h9QH = parcelRequire("9h9QH");

var $5vrEU = parcelRequire("5vrEU");

var $bVhPN = parcelRequire("bVhPN");

var $4tvqn = parcelRequire("4tvqn");

var $kzVWy = parcelRequire("kzVWy");

var $karw4 = parcelRequire("karw4");

var $8WJMW = parcelRequire("8WJMW");

var $lJeQK = parcelRequire("lJeQK");

var $hsNz5 = parcelRequire("hsNz5");
const $c763064da9a08930$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $c763064da9a08930$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $c763064da9a08930$var$animationTarget = 1000;
let $c763064da9a08930$var$id = 0;
/**
 * Use a mutable data object for debug data so as to not create a new
 * object every frame.
 */ const $c763064da9a08930$var$projectionFrameData = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
function $c763064da9a08930$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $c763064da9a08930$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ $c763064da9a08930$var$projectionFrameData.totalNodes = $c763064da9a08930$var$projectionFrameData.resolvedTargetDeltas = $c763064da9a08930$var$projectionFrameData.recalculatedProjection = 0;
                this.nodes.forEach($c763064da9a08930$export$131f2f0cc5fe9609);
                this.nodes.forEach($c763064da9a08930$var$resolveTargetDelta);
                this.nodes.forEach($c763064da9a08930$var$calcProjection);
                this.nodes.forEach($c763064da9a08930$export$c2664f37bc951031);
                (0, $4tvqn.record)($c763064da9a08930$var$projectionFrameData);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $56wZe.FlatTree)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $36ejV.SubscriptionManager)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $kzVWy.isSVGElement)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $5vrEU.delay)(resizeUnblockUpdate, 250);
                    if ((0, $9h9QH.globalProjectionState).hasAnimatedSinceResize) {
                        (0, $9h9QH.globalProjectionState).hasAnimatedSinceResize = false;
                        this.nodes.forEach($c763064da9a08930$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $c763064da9a08930$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $RyhFU.boxEqualsRounded)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $8jA9i.getValueTransition)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $c763064da9a08930$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $lJeQK.cancelFrame)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($c763064da9a08930$var$resetRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($c763064da9a08930$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($c763064da9a08930$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($c763064da9a08930$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($c763064da9a08930$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($c763064da9a08930$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = performance.now();
            (0, $lJeQK.frameData).delta = (0, $8WJMW.clamp)(0, 1000 / 60, now - (0, $lJeQK.frameData).timestamp);
            (0, $lJeQK.frameData).timestamp = now;
            (0, $lJeQK.frameData).isProcessing = true;
            (0, $lJeQK.steps).update.process((0, $lJeQK.frameData));
            (0, $lJeQK.steps).preRender.process((0, $lJeQK.frameData));
            (0, $lJeQK.steps).render.process((0, $lJeQK.frameData));
            (0, $lJeQK.frameData).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                queueMicrotask(()=>this.update());
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($c763064da9a08930$var$clearSnapshot);
            this.sharedNodes.forEach($c763064da9a08930$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $lJeQK.frame).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $lJeQK.frame).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $kjXzb.createBox)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) this.scroll = {
                animationId: this.root.animationId,
                phase: phase,
                isRoot: checkIsScrollRoot(this.instance),
                offset: measureScroll(this.instance)
            };
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            const hasProjection = this.projectionDelta && !(0, $RyhFU.isDeltaZero)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $dhuRS.hasTransform)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $c763064da9a08930$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $kjXzb.createBox)();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll: scroll } = this.root;
            if (scroll) {
                (0, $iWFmw.translateAxis)(box.x, scroll.offset.x);
                (0, $iWFmw.translateAxis)(box.y, scroll.offset.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $kjXzb.createBox)();
            (0, $bEkEP.copyBoxInto)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.isRoot) {
                        (0, $bEkEP.copyBoxInto)(boxWithoutScroll, box);
                        const { scroll: rootScroll } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            (0, $iWFmw.translateAxis)(boxWithoutScroll.x, -rootScroll.offset.x);
                            (0, $iWFmw.translateAxis)(boxWithoutScroll.y, -rootScroll.offset.y);
                        }
                    }
                    (0, $iWFmw.translateAxis)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $iWFmw.translateAxis)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $kjXzb.createBox)();
            (0, $bEkEP.copyBoxInto)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $iWFmw.transformBox)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $dhuRS.hasTransform)(node.latestValues)) continue;
                (0, $iWFmw.transformBox)(withTransforms, node.latestValues);
            }
            if ((0, $dhuRS.hasTransform)(this.latestValues)) (0, $iWFmw.transformBox)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $kjXzb.createBox)();
            (0, $bEkEP.copyBoxInto)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $dhuRS.hasTransform)(node.latestValues)) continue;
                (0, $dhuRS.hasScale)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $kjXzb.createBox)();
                const nodeBox = node.measurePageBox();
                (0, $bEkEP.copyBoxInto)(sourceBox, nodeBox);
                (0, $5py78.removeBoxTransforms)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $dhuRS.hasTransform)(this.latestValues)) (0, $5py78.removeBoxTransforms)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $lJeQK.frameData).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $lJeQK.frameData).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $kjXzb.createBox)();
                    this.relativeTargetOrigin = (0, $kjXzb.createBox)();
                    (0, $jllPU.calcRelativePosition)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $bEkEP.copyBoxInto)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $kjXzb.createBox)();
                this.targetWithTransforms = (0, $kjXzb.createBox)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $jllPU.calcRelativeBox)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $bEkEP.copyBoxInto)(this.target, this.layout.layoutBox);
                (0, $iWFmw.applyBoxDelta)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $bEkEP.copyBoxInto)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $kjXzb.createBox)();
                    this.relativeTargetOrigin = (0, $kjXzb.createBox)();
                    (0, $jllPU.calcRelativePosition)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $bEkEP.copyBoxInto)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ $c763064da9a08930$var$projectionFrameData.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $dhuRS.hasScale)(this.parent.latestValues) || (0, $dhuRS.has2DTranslate)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $lJeQK.frameData).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $bEkEP.copyBoxInto)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $iWFmw.applyTreeDeltas)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) lead.target = lead.layout.layoutBox;
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.projectionTransform) {
                    this.projectionDelta = (0, $kjXzb.createDelta)();
                    this.projectionTransform = "none";
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta) {
                this.projectionDelta = (0, $kjXzb.createDelta)();
                this.projectionDeltaWithTransform = (0, $kjXzb.createDelta)();
            }
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $jllPU.calcBoxDelta)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, $rhFEe.buildProjectionTransform)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ $c763064da9a08930$var$projectionFrameData.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.scheduleRender && this.options.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $kjXzb.createDelta)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $kjXzb.createBox)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($c763064da9a08930$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $c763064da9a08930$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $c763064da9a08930$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $jllPU.calcRelativePosition)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $c763064da9a08930$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $RyhFU.boxEquals)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $kjXzb.createBox)();
                    (0, $bEkEP.copyBoxInto)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $aMXav.mixValues)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $lJeQK.cancelFrame)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $lJeQK.frame).update(()=>{
                (0, $9h9QH.globalProjectionState).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $karw4.animateSingleValue)(0, $c763064da9a08930$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($c763064da9a08930$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $c763064da9a08930$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $kjXzb.createBox)();
                const xLength = (0, $jllPU.calcLength)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $jllPU.calcLength)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $bEkEP.copyBoxInto)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $iWFmw.transformBox)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $jllPU.calcBoxDelta)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $iVo0D.NodeStack)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected rotation values, we can early return without a forced render.
            let hasRotate = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ) hasRotate = true;
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate) return;
            const resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for(let i = 0; i < $c763064da9a08930$var$transformAxes.length; i++){
                const key = "rotate" + $c763064da9a08930$var$transformAxes[i];
                // Record the rotation and then temporarily set it to 0
                if (latestValues[key]) {
                    resetValues[key] = latestValues[key];
                    visualElement.setStaticValue(key, 0);
                }
            }
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues)visualElement.setStaticValue(key, resetValues[key]);
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $c763064da9a08930$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $7BLmV.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $7BLmV.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $dhuRS.hasTransform)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $rhFEe.buildProjectionTransform)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $01mqa.scaleCorrectors){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $01mqa.scaleCorrectors)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $7BLmV.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($c763064da9a08930$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $c763064da9a08930$var$updateLayout(node) {
    node.updateLayout();
}
function $c763064da9a08930$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $2MHzA.eachAxis)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $jllPU.calcLength)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($c763064da9a08930$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $2MHzA.eachAxis)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $jllPU.calcLength)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $kjXzb.createDelta)();
        (0, $jllPU.calcBoxDelta)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $kjXzb.createDelta)();
        if (isShared) (0, $jllPU.calcBoxDelta)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $jllPU.calcBoxDelta)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $RyhFU.isDeltaZero)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $kjXzb.createBox)();
                    (0, $jllPU.calcRelativePosition)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $kjXzb.createBox)();
                    (0, $jllPU.calcRelativePosition)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $RyhFU.boxEqualsRounded)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $c763064da9a08930$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ $c763064da9a08930$var$projectionFrameData.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $c763064da9a08930$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $c763064da9a08930$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $c763064da9a08930$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $c763064da9a08930$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $c763064da9a08930$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $c763064da9a08930$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $c763064da9a08930$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $c763064da9a08930$var$calcProjection(node) {
    node.calcProjection();
}
function $c763064da9a08930$var$resetRotation(node) {
    node.resetRotation();
}
function $c763064da9a08930$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $c763064da9a08930$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $bVhPN.mix)(delta.translate, 0, p);
    output.scale = (0, $bVhPN.mix)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $c763064da9a08930$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $bVhPN.mix)(from.min, to.min, p);
    output.max = (0, $bVhPN.mix)(from.max, to.max, p);
}
function $c763064da9a08930$export$6ffd3e6ae339a132(output, from, to, p) {
    $c763064da9a08930$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $c763064da9a08930$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $c763064da9a08930$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $c763064da9a08930$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $c763064da9a08930$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $c763064da9a08930$var$roundPoint = $c763064da9a08930$var$userAgentContains("applewebkit/") && !$c763064da9a08930$var$userAgentContains("chrome/") ? Math.round : (0, $hsNz5.noop);
function $c763064da9a08930$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $c763064da9a08930$var$roundPoint(axis.min);
    axis.max = $c763064da9a08930$var$roundPoint(axis.max);
}
function $c763064da9a08930$var$roundBox(box) {
    $c763064da9a08930$var$roundAxis(box.x);
    $c763064da9a08930$var$roundAxis(box.y);
}
function $c763064da9a08930$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $jllPU.isNear)((0, $RyhFU.aspectRatio)(snapshot), (0, $RyhFU.aspectRatio)(layout), 0.2);
}

});
parcelRegister("aMXav", function(module, exports) {

$parcel$export(module.exports, "mixValues", () => $763088c1e553cec0$export$739e279c17d51c3d);

var $2xkaC = parcelRequire("2xkaC");

var $aqB8F = parcelRequire("aqB8F");

var $bVhPN = parcelRequire("bVhPN");

var $hsNz5 = parcelRequire("hsNz5");

var $9PDxZ = parcelRequire("9PDxZ");
const $763088c1e553cec0$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $763088c1e553cec0$var$numBorders = $763088c1e553cec0$var$borders.length;
const $763088c1e553cec0$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $763088c1e553cec0$var$isPx = (value)=>typeof value === "number" || (0, $9PDxZ.px).test(value);
function $763088c1e553cec0$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $bVhPN.mix)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $763088c1e553cec0$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $bVhPN.mix)(follow.opacity !== undefined ? follow.opacity : 1, 0, $763088c1e553cec0$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $bVhPN.mix)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $763088c1e553cec0$var$numBorders; i++){
        const borderLabel = `border${$763088c1e553cec0$var$borders[i]}Radius`;
        let followRadius = $763088c1e553cec0$var$getRadius(follow, borderLabel);
        let leadRadius = $763088c1e553cec0$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $763088c1e553cec0$var$isPx(followRadius) === $763088c1e553cec0$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $bVhPN.mix)($763088c1e553cec0$var$asNumber(followRadius), $763088c1e553cec0$var$asNumber(leadRadius), progress), 0);
            if ((0, $9PDxZ.percent).test(leadRadius) || (0, $9PDxZ.percent).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $bVhPN.mix)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $763088c1e553cec0$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $763088c1e553cec0$var$easeCrossfadeIn = $763088c1e553cec0$var$compress(0, 0.5, (0, $2xkaC.circOut));
const $763088c1e553cec0$var$easeCrossfadeOut = $763088c1e553cec0$var$compress(0.5, 0.95, (0, $hsNz5.noop));
function $763088c1e553cec0$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $aqB8F.progress)(min, max, p));
    };
}

});

parcelRegister("bEkEP", function(module, exports) {

$parcel$export(module.exports, "copyBoxInto", () => $a77b712becdf881d$export$c53fd88f45d77e4b);
/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $a77b712becdf881d$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $a77b712becdf881d$export$c53fd88f45d77e4b(box, originBox) {
    $a77b712becdf881d$export$a0230ae482601ae8(box.x, originBox.x);
    $a77b712becdf881d$export$a0230ae482601ae8(box.y, originBox.y);
}

});

parcelRegister("5py78", function(module, exports) {

$parcel$export(module.exports, "removeBoxTransforms", () => $f192ac968f3182dd$export$73e1ad0a9694e25c);

var $bVhPN = parcelRequire("bVhPN");

var $9PDxZ = parcelRequire("9PDxZ");

var $iWFmw = parcelRequire("iWFmw");
/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $f192ac968f3182dd$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $iWFmw.scalePoint)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $iWFmw.scalePoint)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $f192ac968f3182dd$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $9PDxZ.percent).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $bVhPN.mix)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $bVhPN.mix)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $f192ac968f3182dd$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $f192ac968f3182dd$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $f192ac968f3182dd$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $f192ac968f3182dd$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $f192ac968f3182dd$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $f192ac968f3182dd$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $f192ac968f3182dd$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $f192ac968f3182dd$export$42b76f1d0d16d5b(box.x, transforms, $f192ac968f3182dd$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $f192ac968f3182dd$export$42b76f1d0d16d5b(box.y, transforms, $f192ac968f3182dd$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}

});

parcelRegister("RyhFU", function(module, exports) {

$parcel$export(module.exports, "isDeltaZero", () => $0b65448e0b5449e5$export$a7ec7642fe550fb6);
$parcel$export(module.exports, "boxEquals", () => $0b65448e0b5449e5$export$8d5cf76bb7daff09);
$parcel$export(module.exports, "boxEqualsRounded", () => $0b65448e0b5449e5$export$ef641b782d85522);
$parcel$export(module.exports, "aspectRatio", () => $0b65448e0b5449e5$export$c5706146bc63213);

var $jllPU = parcelRequire("jllPU");
function $0b65448e0b5449e5$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $0b65448e0b5449e5$export$a7ec7642fe550fb6(delta) {
    return $0b65448e0b5449e5$var$isAxisDeltaZero(delta.x) && $0b65448e0b5449e5$var$isAxisDeltaZero(delta.y);
}
function $0b65448e0b5449e5$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}
function $0b65448e0b5449e5$export$ef641b782d85522(a, b) {
    return Math.round(a.x.min) === Math.round(b.x.min) && Math.round(a.x.max) === Math.round(b.x.max) && Math.round(a.y.min) === Math.round(b.y.min) && Math.round(a.y.max) === Math.round(b.y.max);
}
function $0b65448e0b5449e5$export$c5706146bc63213(box) {
    return (0, $jllPU.calcLength)(box.x) / (0, $jllPU.calcLength)(box.y);
}

});

parcelRegister("iVo0D", function(module, exports) {

$parcel$export(module.exports, "NodeStack", () => $d5c5992340999b14$export$39be5b2d82fc9dc7);

var $6Oyuy = parcelRequire("6Oyuy");
class $d5c5992340999b14$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $6Oyuy.addUniqueItem)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $6Oyuy.removeItem)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}

});

parcelRegister("rhFEe", function(module, exports) {

$parcel$export(module.exports, "buildProjectionTransform", () => $ed2af9378d22123c$export$d33653b270fe725c);
function $ed2af9378d22123c$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    if (xTranslate || yTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { rotate: rotate, rotateX: rotateX, rotateY: rotateY } = latestTransform;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}

});

parcelRegister("56wZe", function(module, exports) {

$parcel$export(module.exports, "FlatTree", () => $d46b7ecb6606f28f$export$1465d17e3de78a96);

var $6Oyuy = parcelRequire("6Oyuy");

var $lwlFr = parcelRequire("lwlFr");
class $d46b7ecb6606f28f$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $6Oyuy.addUniqueItem)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $6Oyuy.removeItem)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $lwlFr.compareByDepth));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}

});
parcelRegister("lwlFr", function(module, exports) {

$parcel$export(module.exports, "compareByDepth", () => $90d567e7abd84cea$export$d689d9dec5ad338);
const $90d567e7abd84cea$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;

});


parcelRegister("5vrEU", function(module, exports) {

$parcel$export(module.exports, "delay", () => $8dabf0e3351bc52d$export$1391212d75b2ee65);

var $lJeQK = parcelRequire("lJeQK");
/**
 * Timeout defined in ms
 */ function $8dabf0e3351bc52d$export$1391212d75b2ee65(callback, timeout) {
    const start = performance.now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $lJeQK.cancelFrame)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $lJeQK.frame).read(checkElapsed, true);
    return ()=>(0, $lJeQK.cancelFrame)(checkElapsed);
}

});

parcelRegister("4tvqn", function(module, exports) {

$parcel$export(module.exports, "record", () => $0080848a5d07308b$export$e5185e241753e543);
function $0080848a5d07308b$export$e5185e241753e543(data) {
    if (window.MotionDebug) window.MotionDebug.record(data);
}

});

parcelRegister("kzVWy", function(module, exports) {

$parcel$export(module.exports, "isSVGElement", () => $bcf5283c60c0aa61$export$17eda790a720ec57);
function $bcf5283c60c0aa61$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}

});

parcelRegister("karw4", function(module, exports) {

$parcel$export(module.exports, "animateSingleValue", () => $76eae65ef3e09fa8$export$335a17c977067b99);

var $cHMmF = parcelRequire("cHMmF");

var $8fYq9 = parcelRequire("8fYq9");

var $cV7py = parcelRequire("cV7py");
function $76eae65ef3e09fa8$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $cV7py.isMotionValue)(value) ? value : (0, $8fYq9.motionValue)(value);
    motionValue$1.start((0, $cHMmF.animateMotionValue)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}

});


parcelRegister("gLmaM", function(module, exports) {

$parcel$export(module.exports, "DocumentProjectionNode", () => $59bc0922b8120577$export$2d029a49a09b6177);

var $3UgiJ = parcelRequire("3UgiJ");

var $hvbUJ = parcelRequire("hvbUJ");
const $59bc0922b8120577$export$2d029a49a09b6177 = (0, $3UgiJ.createProjectionNode)({
    attachResizeListener: (ref, notify)=>(0, $hvbUJ.addDomEvent)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});

});



parcelRegister("3iDhu", function(module, exports) {

$parcel$export(module.exports, "createDomVisualElement", () => $7443a886d2f94f6b$export$56ba0183203348f5);

var $5Ghw7 = parcelRequire("5Ghw7");

var $dRlYj = parcelRequire("dRlYj");

var $d3WXv = parcelRequire("d3WXv");
const $7443a886d2f94f6b$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $d3WXv.isSVGComponent)(Component) ? new (0, $dRlYj.SVGVisualElement)(options, {
        enableHardwareAcceleration: false
    }) : new (0, $5Ghw7.HTMLVisualElement)(options, {
        enableHardwareAcceleration: true
    });
};

});
parcelRegister("5Ghw7", function(module, exports) {

$parcel$export(module.exports, "HTMLVisualElement", () => $dc1cafacdf355eaa$export$23fea75b03ac16b3);

var $9bx9Q = parcelRequire("9bx9Q");

var $4RRaL = parcelRequire("4RRaL");

var $1ewxR = parcelRequire("1ewxR");

var $qNfEF = parcelRequire("qNfEF");

var $0LmxL = parcelRequire("0LmxL");

var $k5dje = parcelRequire("k5dje");

var $WoUBD = parcelRequire("WoUBD");

var $35TmA = parcelRequire("35TmA");

var $cV7py = parcelRequire("cV7py");
function $dc1cafacdf355eaa$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $dc1cafacdf355eaa$export$23fea75b03ac16b3 extends (0, $35TmA.DOMVisualElement) {
    constructor(){
        super(...arguments);
        this.type = "html";
    }
    readValueFromInstance(instance, key) {
        if ((0, $1ewxR.transformProps).has(key)) {
            const defaultType = (0, $k5dje.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $dc1cafacdf355eaa$export$3735103072e4a80(instance);
            const value = ((0, $4RRaL.isCSSVariableName)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $WoUBD.measureViewportBox)(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        (0, $9bx9Q.buildHTMLStyles)(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $qNfEF.scrapeMotionValuesFromProps)(props, prevProps);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $cV7py.isMotionValue)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $0LmxL.renderHTML)(instance, renderState, styleProp, projection);
    }
}

});
parcelRegister("35TmA", function(module, exports) {

$parcel$export(module.exports, "DOMVisualElement", () => $89cda77852006951$export$e49735c2a366bdc7);

var $g5LEV = parcelRequire("g5LEV");

var $3vm6z = parcelRequire("3vm6z");

var $cWbnp = parcelRequire("cWbnp");
class $89cda77852006951$export$e49735c2a366bdc7 extends (0, $cWbnp.VisualElement) {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    makeTargetAnimatableFromInstance({ transition: transition, transitionEnd: transitionEnd, ...target }, { transformValues: transformValues }, isMounted) {
        let origin = (0, $g5LEV.getOrigin)(target, transition || {}, this);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, $g5LEV.checkTargetForNewValues)(this, target, origin);
            const parsed = (0, $3vm6z.parseDomVariant)(this, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return {
            transition: transition,
            transitionEnd: transitionEnd,
            ...target
        };
    }
}

});
parcelRegister("3vm6z", function(module, exports) {

$parcel$export(module.exports, "parseDomVariant", () => $8e23cb5049410d1f$export$5849e743e29831d6);

var $4axax = parcelRequire("4axax");

var $arxF6 = parcelRequire("arxF6");
/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ const $8e23cb5049410d1f$export$5849e743e29831d6 = (visualElement, target, origin, transitionEnd)=>{
    const resolved = (0, $4axax.resolveCSSVariables)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, $arxF6.unitConversion)(visualElement, target, origin, transitionEnd);
};

});
parcelRegister("4axax", function(module, exports) {

$parcel$export(module.exports, "resolveCSSVariables", () => $b877e7f72571bce0$export$669319b042b57350);

var $kpJ0L = parcelRequire("kpJ0L");

var $c6hlF = parcelRequire("c6hlF");

var $4RRaL = parcelRequire("4RRaL");
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $b877e7f72571bce0$var$splitCSSVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $b877e7f72571bce0$export$b9f0c1f373aee2b0(current) {
    const match = $b877e7f72571bce0$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
}
const $b877e7f72571bce0$var$maxDepth = 4;
function $b877e7f72571bce0$var$getVariableValue(current, element, depth = 1) {
    (0, $kpJ0L.invariant)(depth <= $b877e7f72571bce0$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $b877e7f72571bce0$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $c6hlF.isNumericalString)(trimmed) ? parseFloat(trimmed) : trimmed;
    } else if ((0, $4RRaL.isCSSVariableToken)(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return $b877e7f72571bce0$var$getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function $b877e7f72571bce0$export$669319b042b57350(visualElement, { ...target }, transitionEnd) {
    const element = visualElement.current;
    if (!(element instanceof Element)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = {
        ...transitionEnd
    };
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.values.forEach((value)=>{
        const current = value.get();
        if (!(0, $4RRaL.isCSSVariableToken)(current)) return;
        const resolved = $b877e7f72571bce0$var$getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(const key in target){
        const current = target[key];
        if (!(0, $4RRaL.isCSSVariableToken)(current)) continue;
        const resolved = $b877e7f72571bce0$var$getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        if (!transitionEnd) transitionEnd = {};
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd[key] === undefined) transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}

});

parcelRegister("arxF6", function(module, exports) {

$parcel$export(module.exports, "unitConversion", () => $5f1087091542e730$export$9e04b0cab841a28);

var $l2nMT = parcelRequire("l2nMT");

var $kpJ0L = parcelRequire("kpJ0L");

var $1ewxR = parcelRequire("1ewxR");

var $92Rhp = parcelRequire("92Rhp");

var $aDRop = parcelRequire("aDRop");

var $kRios = parcelRequire("kRios");

var $9PDxZ = parcelRequire("9PDxZ");
const $5f1087091542e730$var$positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $5f1087091542e730$var$isPositionalKey = (key)=>$5f1087091542e730$var$positionalKeys.has(key);
const $5f1087091542e730$var$hasPositionalKey = (target)=>{
    return Object.keys(target).some($5f1087091542e730$var$isPositionalKey);
};
const $5f1087091542e730$var$isNumOrPxType = (v)=>v === (0, $kRios.number) || v === (0, $9PDxZ.px);
const $5f1087091542e730$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $5f1087091542e730$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return $5f1087091542e730$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return $5f1087091542e730$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $5f1087091542e730$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $5f1087091542e730$var$nonTranslationalTransformKeys = (0, $1ewxR.transformPropOrder).filter((key)=>!$5f1087091542e730$var$transformKeys.has(key));
function $5f1087091542e730$var$removeNonTranslationalTransform(visualElement) {
    const removedTransforms = [];
    $5f1087091542e730$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.render();
    return removedTransforms;
}
const $5f1087091542e730$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $5f1087091542e730$var$getTranslateFromMatrix(4, 13),
    y: $5f1087091542e730$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$5f1087091542e730$export$781d46a8aa670d52.translateX = $5f1087091542e730$export$781d46a8aa670d52.x;
$5f1087091542e730$export$781d46a8aa670d52.translateY = $5f1087091542e730$export$781d46a8aa670d52.y;
const $5f1087091542e730$var$convertChangedValueTypes = (target, visualElement, changedKeys)=>{
    const originBbox = visualElement.measureViewportBox();
    const element = visualElement.current;
    const elementComputedStyle = getComputedStyle(element);
    const { display: display } = elementComputedStyle;
    const origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    /**
     * Record origins before we render and update styles
     */ changedKeys.forEach((key)=>{
        origin[key] = $5f1087091542e730$export$781d46a8aa670d52[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.render();
    const targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach((key)=>{
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        const value = visualElement.getValue(key);
        value && value.jump(origin[key]);
        target[key] = $5f1087091542e730$export$781d46a8aa670d52[key](targetBbox, elementComputedStyle);
    });
    return target;
};
const $5f1087091542e730$var$checkAndConvertChangedValueTypes = (visualElement, target, origin = {}, transitionEnd = {})=>{
    target = {
        ...target
    };
    transitionEnd = {
        ...transitionEnd
    };
    const targetPositionalKeys = Object.keys(target).filter($5f1087091542e730$var$isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    let removedTransformValues = [];
    let hasAttemptedToRemoveTransformValues = false;
    const changedValueTypeKeys = [];
    targetPositionalKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        let from = origin[key];
        let fromType = (0, $92Rhp.findDimensionValueType)(from);
        const to = target[key];
        let toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, $l2nMT.isKeyframesTarget)(to)) {
            const numKeyframes = to.length;
            const fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = (0, $92Rhp.findDimensionValueType)(from);
            for(let i = fromIndex; i < numKeyframes; i++){
                /**
                 * Don't allow wildcard keyframes to be used to detect
                 * a difference in value types.
                 */ if (to[i] === null) break;
                if (!toType) {
                    toType = (0, $92Rhp.findDimensionValueType)(to[i]);
                    (0, $kpJ0L.invariant)(toType === fromType || $5f1087091542e730$var$isNumOrPxType(fromType) && $5f1087091542e730$var$isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
                } else (0, $kpJ0L.invariant)((0, $92Rhp.findDimensionValueType)(to[i]) === toType, "All keyframes must be of the same type");
            }
        } else toType = (0, $92Rhp.findDimensionValueType)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if ($5f1087091542e730$var$isNumOrPxType(fromType) && $5f1087091542e730$var$isNumOrPxType(toType)) {
                const current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, $9PDxZ.px)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = $5f1087091542e730$var$removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                value.jump(to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        const scrollY = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
        const convertedTarget = $5f1087091542e730$var$convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(([key, value])=>{
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.render();
        // Restore scroll position
        if ((0, $aDRop.isBrowser) && scrollY !== null) window.scrollTo({
            top: scrollY
        });
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function $5f1087091542e730$export$9e04b0cab841a28(visualElement, target, origin, transitionEnd) {
    return $5f1087091542e730$var$hasPositionalKey(target) ? $5f1087091542e730$var$checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}

});


parcelRegister("cWbnp", function(module, exports) {

$parcel$export(module.exports, "VisualElement", () => $686a158fb677da95$export$fa8b653c0f3714e5);


var $kjXzb = parcelRequire("kjXzb");

var $h29D1 = parcelRequire("h29D1");

var $humPT = parcelRequire("humPT");

var $4fjtp = parcelRequire("4fjtp");

var $36ejV = parcelRequire("36ejV");

var $8fYq9 = parcelRequire("8fYq9");

var $8DT3X = parcelRequire("8DT3X");

var $cV7py = parcelRequire("cV7py");

var $1ewxR = parcelRequire("1ewxR");

var $7qjRv = parcelRequire("7qjRv");

var $jG6Uh = parcelRequire("jG6Uh");

var $dQe3M = parcelRequire("dQe3M");

var $jEvFY = parcelRequire("jEvFY");


var $0KLeb = parcelRequire("0KLeb");

var $9y3RP = parcelRequire("9y3RP");

var $1KgZC = parcelRequire("1KgZC");

var $lJeQK = parcelRequire("lJeQK");
const $686a158fb677da95$var$featureNames = Object.keys((0, $0KLeb.featureDefinitions));
const $686a158fb677da95$var$numFeatures = $686a158fb677da95$var$featureNames.length;
const $686a158fb677da95$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const $686a158fb677da95$var$numVariantProps = (0, $9y3RP.variantProps).length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $686a158fb677da95$export$fa8b653c0f3714e5 {
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = ()=>(0, $lJeQK.frame).render(this.render, false, true);
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.isControllingVariants = (0, $7qjRv.isControllingVariants)(props);
        this.isVariantNode = (0, $7qjRv.isVariantNode)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {});
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $cV7py.isMotionValue)(value)) {
                value.set(latestValues[key], false);
                if ((0, $8DT3X.isWillChangeMotionValue)(willChange)) willChange.add(key);
            }
        }
    }
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps) {
        return {};
    }
    mount(instance) {
        this.current = instance;
        (0, $1KgZC.visualElementStore).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $4fjtp.hasReducedMotionListener).current) (0, $humPT.initPrefersReducedMotion)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $4fjtp.prefersReducedMotion).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $1KgZC.visualElementStore).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $lJeQK.cancelFrame)(this.notifyUpdate);
        (0, $lJeQK.cancelFrame)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features)this.features[key].unmount();
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = (0, $1ewxR.transformProps).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $lJeQK.frame).update(this.notifyUpdate, false, true);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    loadFeatures({ children: children, ...renderedProps }, isStrict, preloadedFeatures, initialLayoutGroupConfig) {
        let ProjectionNodeConstructor;
        let MeasureLayout;
        for(let i = 0; i < $686a158fb677da95$var$numFeatures; i++){
            const name = $686a158fb677da95$var$featureNames[i];
            const { isEnabled: isEnabled, Feature: FeatureConstructor, ProjectionNode: ProjectionNode, MeasureLayout: MeasureLayoutComponent } = (0, $0KLeb.featureDefinitions)[name];
            if (ProjectionNode) ProjectionNodeConstructor = ProjectionNode;
            if (isEnabled(renderedProps)) {
                if (!this.features[name] && FeatureConstructor) this.features[name] = new FeatureConstructor(this);
                if (MeasureLayoutComponent) MeasureLayout = MeasureLayoutComponent;
            }
        }
        if ((this.type === "html" || this.type === "svg") && !this.projection && ProjectionNodeConstructor) {
            this.projection = new ProjectionNodeConstructor(this.latestValues, this.parent && this.parent.projection);
            const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = renderedProps;
            this.projection.setOptions({
                layoutId: layoutId,
                layout: layout,
                alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $h29D1.isRefObject)(dragConstraints),
                visualElement: this,
                scheduleRender: ()=>this.scheduleRender(),
                /**
                 * TODO: Update options in an effect. This could be tricky as it'll be too late
                 * to update by the time layout animations run.
                 * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                 * ensuring it gets called if there's no potential layout animations.
                 *
                 */ animationType: typeof layout === "string" ? layout : "both",
                initialPromotionConfig: initialLayoutGroupConfig,
                layoutScroll: layoutScroll,
                layoutRoot: layoutRoot
            });
        }
        return MeasureLayout;
    }
    updateFeatures() {
        for(const key in this.features){
            const feature = this.features[key];
            if (feature.isMounted) feature.update();
            else {
                feature.mount();
                feature.isMounted = true;
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $kjXzb.createBox)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Make a target animatable by Popmotion. For instance, if we're
     * trying to animate width from 100px to 100vw we need to measure 100vw
     * in pixels to determine what we really need to animate to. This is also
     * pluggable to support Framer's custom value types like Color,
     * and CSS variables.
     */ makeTargetAnimatable(target, canMutate = true) {
        return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $686a158fb677da95$var$propEventHandlers.length; i++){
            const key = $686a158fb677da95$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listener = props["on" + key];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $dQe3M.updateMotionValuesFromProps)(this, this.scrapeMotionValuesFromProps(props, this.prevProps), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $686a158fb677da95$var$numVariantProps; i++){
            const name = (0, $9y3RP.variantProps)[i];
            const prop = this.props[name];
            if ((0, $jG6Uh.isVariantLabel)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        if (value !== this.values.get(key)) {
            this.removeValue(key);
            this.bindToMotionValue(key, value);
        }
        this.values.set(key, value);
        this.latestValues[key] = value.get();
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $8fYq9.motionValue)(defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key) {
        var _a;
        return this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        const valueFromInitial = typeof initial === "string" || typeof initial === "object" ? (_a = (0, $jEvFY.resolveVariantFromProps)(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key] : undefined;
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $cV7py.isMotionValue)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $36ejV.SubscriptionManager)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}

});
parcelRegister("humPT", function(module, exports) {

$parcel$export(module.exports, "initPrefersReducedMotion", () => $119570d70e59af61$export$ca9f41fb23dded3d);

var $aDRop = parcelRequire("aDRop");

var $4fjtp = parcelRequire("4fjtp");
function $119570d70e59af61$export$ca9f41fb23dded3d() {
    (0, $4fjtp.hasReducedMotionListener).current = true;
    if (!(0, $aDRop.isBrowser)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $4fjtp.prefersReducedMotion).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $4fjtp.prefersReducedMotion).current = false;
}

});
parcelRegister("4fjtp", function(module, exports) {

$parcel$export(module.exports, "prefersReducedMotion", () => $8a3cf6c9535ab294$export$ff7706047246b98b);
$parcel$export(module.exports, "hasReducedMotionListener", () => $8a3cf6c9535ab294$export$6476d16e2fd2d0db);
// Does this device prefer reduced motion? Returns `null` server-side.
const $8a3cf6c9535ab294$export$ff7706047246b98b = {
    current: null
};
const $8a3cf6c9535ab294$export$6476d16e2fd2d0db = {
    current: false
};

});


parcelRegister("dQe3M", function(module, exports) {

$parcel$export(module.exports, "updateMotionValuesFromProps", () => $d531bf8f13b483cf$export$9a552858d5197f6e);

var $8DT3X = parcelRequire("8DT3X");


var $8fYq9 = parcelRequire("8fYq9");

var $cV7py = parcelRequire("cV7py");
function $d531bf8f13b483cf$export$9a552858d5197f6e(element, next, prev) {
    const { willChange: willChange } = next;
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $cV7py.isMotionValue)(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
            if ((0, $8DT3X.isWillChangeMotionValue)(willChange)) willChange.add(key);
        } else if ((0, $cV7py.isMotionValue)(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $8fYq9.motionValue)(nextValue, {
                owner: element
            }));
            if ((0, $8DT3X.isWillChangeMotionValue)(willChange)) willChange.remove(key);
        } else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $8fYq9.motionValue)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}

});

parcelRegister("1KgZC", function(module, exports) {

$parcel$export(module.exports, "visualElementStore", () => $a0da600ecb380056$export$bc2a978a17abfdde);
const $a0da600ecb380056$export$bc2a978a17abfdde = new WeakMap();

});




parcelRegister("dRlYj", function(module, exports) {

$parcel$export(module.exports, "SVGVisualElement", () => $a9e3616f7af38be7$export$86bcdffbaf733d84);

var $1mlXz = parcelRequire("1mlXz");

var $35TmA = parcelRequire("35TmA");

var $dCQSo = parcelRequire("dCQSo");

var $8cO1j = parcelRequire("8cO1j");

var $lARPw = parcelRequire("lARPw");

var $1ewxR = parcelRequire("1ewxR");

var $9hjkH = parcelRequire("9hjkH");

var $k5dje = parcelRequire("k5dje");

var $kjXzb = parcelRequire("kjXzb");

var $hn5IJ = parcelRequire("hn5IJ");
class $a9e3616f7af38be7$export$86bcdffbaf733d84 extends (0, $35TmA.DOMVisualElement) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $1ewxR.transformProps).has(key)) {
            const defaultType = (0, $k5dje.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $lARPw.camelCaseAttributes).has(key) ? (0, $8cO1j.camelToDash)(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return (0, $kjXzb.createBox)();
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $1mlXz.scrapeMotionValuesFromProps)(props, prevProps);
    }
    build(renderState, latestValues, options, props) {
        (0, $dCQSo.buildSVGAttrs)(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $9hjkH.renderSVG)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $hn5IJ.isSVGTag)(instance.tagName);
        super.mount(instance);
    }
}

});


parcelRegister("k6rxW", function(module, exports) {

$parcel$export(module.exports, "layout", () => $ffd975dbcfda3ae3$export$b3219800bda33a1f);

var $luVWK = parcelRequire("luVWK");

var $7OUlY = parcelRequire("7OUlY");
const $ffd975dbcfda3ae3$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $luVWK.HTMLProjectionNode),
        MeasureLayout: $7OUlY.MeasureLayout
    }
};

});


parcelRegister("1kFN0", function(module, exports) {

$parcel$export(module.exports, "chakra", () => $4e9d2c9f13da510e$export$7cd122d781af9fa4);

var $hCeol = parcelRequire("hCeol");
"use client";
// src/factory.ts
function $4e9d2c9f13da510e$var$factory() {
    const cache = /* @__PURE__ */ new Map();
    return new Proxy((0, $hCeol.styled), {
        /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */ apply (target, thisArg, argArray) {
            return (0, $hCeol.styled)(...argArray);
        },
        /**
     * @example
     * <chakra.div />
     */ get (_, element) {
            if (!cache.has(element)) cache.set(element, (0, $hCeol.styled)(element));
            return cache.get(element);
        }
    });
}
var $4e9d2c9f13da510e$export$7cd122d781af9fa4 = $4e9d2c9f13da510e$var$factory();

});
parcelRegister("hCeol", function(module, exports) {

$parcel$export(module.exports, "styled", () => $62a69a2cf4a3339c$export$3817b7a54a07cec7);

var $iFCd9 = parcelRequire("iFCd9");

var $ioRKz = parcelRequire("ioRKz");

var $cDoMf = parcelRequire("cDoMf");

var $6SrEO = parcelRequire("6SrEO");
var $747z2 = parcelRequire("747z2");

var $4duK8 = parcelRequire("4duK8");

var $5A90g = parcelRequire("5A90g");

var $3qjKr = parcelRequire("3qjKr");
"use client";
var $62a69a2cf4a3339c$var$_a;
var $62a69a2cf4a3339c$var$emotion_styled = ($62a69a2cf4a3339c$var$_a = (0, $5A90g.default).default) != null ? $62a69a2cf4a3339c$var$_a : (0, $5A90g.default);
var $62a69a2cf4a3339c$export$9dba07f3d84163bb = ({ baseStyle: baseStyle })=>(props)=>{
        const { theme: theme, css: cssProp, __css: __css, sx: sx, ...rest } = props;
        const styleProps = (0, $6SrEO.objectFilter)(rest, (_, prop)=>(0, $cDoMf.isStyleProp)(prop));
        const finalBaseStyle = (0, $747z2.runIfFn)(baseStyle, props);
        const finalStyles = (0, $4duK8.assignAfter)({}, __css, finalBaseStyle, (0, $6SrEO.filterUndefined)(styleProps), sx);
        const computedCSS = (0, $cDoMf.css)(finalStyles)(props.theme);
        return cssProp ? [
            computedCSS,
            cssProp
        ] : computedCSS;
    };
function $62a69a2cf4a3339c$export$3817b7a54a07cec7(component, options) {
    const { baseStyle: baseStyle, ...styledOptions } = options != null ? options : {};
    if (!styledOptions.shouldForwardProp) styledOptions.shouldForwardProp = (0, $iFCd9.shouldForwardProp);
    const styleObject = $62a69a2cf4a3339c$export$9dba07f3d84163bb({
        baseStyle: baseStyle
    });
    const Component = $62a69a2cf4a3339c$var$emotion_styled(component, styledOptions)(styleObject);
    const chakraComponent = (0, (/*@__PURE__*/$parcel$interopDefault($3qjKr))).forwardRef(function ChakraComponent(props, ref) {
        const { colorMode: colorMode, forced: forced } = (0, $ioRKz.useColorMode)();
        return (0, (/*@__PURE__*/$parcel$interopDefault($3qjKr))).createElement(Component, {
            ref: ref,
            "data-theme": forced ? colorMode : void 0,
            ...props
        });
    });
    return chakraComponent;
}

});
parcelRegister("iFCd9", function(module, exports) {

$parcel$export(module.exports, "shouldForwardProp", () => $fbdb67cac9ab19c9$export$3ba67b570e26eea0);

var $cDoMf = parcelRequire("cDoMf");
"use client";
var $fbdb67cac9ab19c9$var$allPropNames = /* @__PURE__ */ new Set([
    ...(0, $cDoMf.propNames),
    "textStyle",
    "layerStyle",
    "apply",
    "noOfLines",
    "focusBorderColor",
    "errorBorderColor",
    "as",
    "__css",
    "css",
    "sx"
]);
var $fbdb67cac9ab19c9$var$validHTMLProps = /* @__PURE__ */ new Set([
    "htmlWidth",
    "htmlHeight",
    "htmlSize",
    "htmlTranslate"
]);
function $fbdb67cac9ab19c9$export$3ba67b570e26eea0(prop) {
    return $fbdb67cac9ab19c9$var$validHTMLProps.has(prop) || !$fbdb67cac9ab19c9$var$allPropNames.has(prop);
}

});
parcelRegister("cDoMf", function(module, exports) {

$parcel$export(module.exports, "cssVar", () => $39e2d87d62de0beb$export$8b4981022bd80a4e);
$parcel$export(module.exports, "defineCssVars", () => $39e2d87d62de0beb$export$bd40561c6c056841);
$parcel$export(module.exports, "toCSSVar", () => $39e2d87d62de0beb$export$d4e5dc2a444c0164);
$parcel$export(module.exports, "propNames", () => $39e2d87d62de0beb$export$332cc7004bcbb8b4);
$parcel$export(module.exports, "isStyleProp", () => $39e2d87d62de0beb$export$95b76554d0cd12d6);
$parcel$export(module.exports, "css", () => $39e2d87d62de0beb$export$dbf350e5966cf602);
$parcel$export(module.exports, "defineStyle", () => $39e2d87d62de0beb$export$9a6b93c1c4f92839);
$parcel$export(module.exports, "defineStyleConfig", () => $39e2d87d62de0beb$export$5c9a64458a4ed8a4);
$parcel$export(module.exports, "createMultiStyleConfigHelpers", () => $39e2d87d62de0beb$export$d5f717dc145477b8);
$parcel$export(module.exports, "resolveStyleConfig", () => $39e2d87d62de0beb$export$f94106bbb00e81eb);
$parcel$export(module.exports, "getCSSVar", () => $39e2d87d62de0beb$export$93c8e06b7014dc33);
$parcel$export(module.exports, "omitThemingProps", () => $39e2d87d62de0beb$export$adfcf5a5e4d17785);
// src/utils/create-transform.ts

var $iyhjB = parcelRequire("iyhjB");

var $eltz3 = parcelRequire("eltz3");
var $39e2d87d62de0beb$var$isImportant = (value)=>/!(important)?$/.test(value);
var $39e2d87d62de0beb$var$withoutImportant = (value)=>typeof value === "string" ? value.replace(/!(important)?$/, "").trim() : value;
var $39e2d87d62de0beb$export$92f5bb613cffac78 = (scale, value)=>(theme)=>{
        const valueStr = String(value);
        const important = $39e2d87d62de0beb$var$isImportant(valueStr);
        const valueWithoutImportant = $39e2d87d62de0beb$var$withoutImportant(valueStr);
        const key = scale ? `${scale}.${valueWithoutImportant}` : valueWithoutImportant;
        let transformed = (0, $iyhjB.isObject)(theme.__cssMap) && key in theme.__cssMap ? theme.__cssMap[key].varRef : value;
        transformed = $39e2d87d62de0beb$var$withoutImportant(transformed);
        return important ? `${transformed} !important` : transformed;
    };
function $39e2d87d62de0beb$var$createTransform(options) {
    const { scale: scale, transform: transform2, compose: compose } = options;
    const fn = (value, theme)=>{
        var _a;
        const _value = $39e2d87d62de0beb$export$92f5bb613cffac78(scale, value)(theme);
        let result = (_a = transform2 == null ? void 0 : transform2(_value, theme)) != null ? _a : _value;
        if (compose) result = compose(result, theme);
        return result;
    };
    return fn;
}
// src/utils/pipe.ts
var $39e2d87d62de0beb$var$pipe = (...fns)=>(v)=>fns.reduce((a, b)=>b(a), v);
// src/utils/prop-config.ts
function $39e2d87d62de0beb$var$toConfig(scale, transform2) {
    return (property)=>{
        const result = {
            property: property,
            scale: scale
        };
        result.transform = $39e2d87d62de0beb$var$createTransform({
            scale: scale,
            transform: transform2
        });
        return result;
    };
}
var $39e2d87d62de0beb$var$getRtl = ({ rtl: rtl, ltr: ltr })=>(theme)=>theme.direction === "rtl" ? rtl : ltr;
function $39e2d87d62de0beb$var$logical(options) {
    const { property: property, scale: scale, transform: transform2 } = options;
    return {
        scale: scale,
        property: $39e2d87d62de0beb$var$getRtl(property),
        transform: scale ? $39e2d87d62de0beb$var$createTransform({
            scale: scale,
            compose: transform2
        }) : transform2
    };
}
// src/utils/templates.ts
var $39e2d87d62de0beb$var$transformTemplate = [
    "rotate(var(--chakra-rotate, 0))",
    "scaleX(var(--chakra-scale-x, 1))",
    "scaleY(var(--chakra-scale-y, 1))",
    "skewX(var(--chakra-skew-x, 0))",
    "skewY(var(--chakra-skew-y, 0))"
];
function $39e2d87d62de0beb$var$getTransformTemplate() {
    return [
        "translateX(var(--chakra-translate-x, 0))",
        "translateY(var(--chakra-translate-y, 0))",
        ...$39e2d87d62de0beb$var$transformTemplate
    ].join(" ");
}
function $39e2d87d62de0beb$var$getTransformGpuTemplate() {
    return [
        "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",
        ...$39e2d87d62de0beb$var$transformTemplate
    ].join(" ");
}
var $39e2d87d62de0beb$var$filterTemplate = {
    "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
    filter: [
        "var(--chakra-blur)",
        "var(--chakra-brightness)",
        "var(--chakra-contrast)",
        "var(--chakra-grayscale)",
        "var(--chakra-hue-rotate)",
        "var(--chakra-invert)",
        "var(--chakra-saturate)",
        "var(--chakra-sepia)",
        "var(--chakra-drop-shadow)"
    ].join(" ")
};
var $39e2d87d62de0beb$var$backdropFilterTemplate = {
    backdropFilter: [
        "var(--chakra-backdrop-blur)",
        "var(--chakra-backdrop-brightness)",
        "var(--chakra-backdrop-contrast)",
        "var(--chakra-backdrop-grayscale)",
        "var(--chakra-backdrop-hue-rotate)",
        "var(--chakra-backdrop-invert)",
        "var(--chakra-backdrop-opacity)",
        "var(--chakra-backdrop-saturate)",
        "var(--chakra-backdrop-sepia)"
    ].join(" "),
    "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function $39e2d87d62de0beb$var$getRingTemplate(value) {
    return {
        "--chakra-ring-offset-shadow": `var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)`,
        "--chakra-ring-shadow": `var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)`,
        "--chakra-ring-width": value,
        boxShadow: [
            `var(--chakra-ring-offset-shadow)`,
            `var(--chakra-ring-shadow)`,
            `var(--chakra-shadow, 0 0 #0000)`
        ].join(", ")
    };
}
var $39e2d87d62de0beb$var$flexDirectionTemplate = {
    "row-reverse": {
        space: "--chakra-space-x-reverse",
        divide: "--chakra-divide-x-reverse"
    },
    "column-reverse": {
        space: "--chakra-space-y-reverse",
        divide: "--chakra-divide-y-reverse"
    }
};
// src/utils/parse-gradient.ts
var $39e2d87d62de0beb$var$directionMap = {
    "to-t": "to top",
    "to-tr": "to top right",
    "to-r": "to right",
    "to-br": "to bottom right",
    "to-b": "to bottom",
    "to-bl": "to bottom left",
    "to-l": "to left",
    "to-tl": "to top left"
};
var $39e2d87d62de0beb$var$valueSet = new Set(Object.values($39e2d87d62de0beb$var$directionMap));
var $39e2d87d62de0beb$var$globalSet = /* @__PURE__ */ new Set([
    "none",
    "-moz-initial",
    "inherit",
    "initial",
    "revert",
    "unset"
]);
var $39e2d87d62de0beb$var$trimSpace = (str)=>str.trim();
function $39e2d87d62de0beb$var$parseGradient(value, theme) {
    if (value == null || $39e2d87d62de0beb$var$globalSet.has(value)) return value;
    const prevent = $39e2d87d62de0beb$var$isCSSFunction(value) || $39e2d87d62de0beb$var$globalSet.has(value);
    if (!prevent) return `url('${value}')`;
    const regex = /(^[a-z-A-Z]+)\((.*)\)/g;
    const results = regex.exec(value);
    const type = results == null ? void 0 : results[1];
    const values = results == null ? void 0 : results[2];
    if (!type || !values) return value;
    const _type = type.includes("-gradient") ? type : `${type}-gradient`;
    const [maybeDirection, ...stops] = values.split(",").map($39e2d87d62de0beb$var$trimSpace).filter(Boolean);
    if ((stops == null ? void 0 : stops.length) === 0) return value;
    const direction = maybeDirection in $39e2d87d62de0beb$var$directionMap ? $39e2d87d62de0beb$var$directionMap[maybeDirection] : maybeDirection;
    stops.unshift(direction);
    const _values = stops.map((stop)=>{
        if ($39e2d87d62de0beb$var$valueSet.has(stop)) return stop;
        const firstStop = stop.indexOf(" ");
        const [_color, _stop] = firstStop !== -1 ? [
            stop.substr(0, firstStop),
            stop.substr(firstStop + 1)
        ] : [
            stop
        ];
        const _stopOrFunc = $39e2d87d62de0beb$var$isCSSFunction(_stop) ? _stop : _stop && _stop.split(" ");
        const key = `colors.${_color}`;
        const color2 = key in theme.__cssMap ? theme.__cssMap[key].varRef : _color;
        return _stopOrFunc ? [
            color2,
            ...Array.isArray(_stopOrFunc) ? _stopOrFunc : [
                _stopOrFunc
            ]
        ].join(" ") : color2;
    });
    return `${_type}(${_values.join(", ")})`;
}
var $39e2d87d62de0beb$var$isCSSFunction = (value)=>{
    return typeof value === "string" && value.includes("(") && value.includes(")");
};
var $39e2d87d62de0beb$var$gradientTransform = (value, theme)=>$39e2d87d62de0beb$var$parseGradient(value, theme != null ? theme : {});
// src/utils/transform-functions.ts
function $39e2d87d62de0beb$var$isCssVar(value) {
    return /^var\(--.+\)$/.test(value);
}
var $39e2d87d62de0beb$var$analyzeCSSValue = (value)=>{
    const num = parseFloat(value.toString());
    const unit = value.toString().replace(String(num), "");
    return {
        unitless: !unit,
        value: num,
        unit: unit
    };
};
var $39e2d87d62de0beb$var$wrap = (str)=>(value)=>`${str}(${value})`;
var $39e2d87d62de0beb$var$transformFunctions = {
    filter (value) {
        return value !== "auto" ? value : $39e2d87d62de0beb$var$filterTemplate;
    },
    backdropFilter (value) {
        return value !== "auto" ? value : $39e2d87d62de0beb$var$backdropFilterTemplate;
    },
    ring (value) {
        return $39e2d87d62de0beb$var$getRingTemplate($39e2d87d62de0beb$var$transformFunctions.px(value));
    },
    bgClip (value) {
        return value === "text" ? {
            color: "transparent",
            backgroundClip: "text"
        } : {
            backgroundClip: value
        };
    },
    transform (value) {
        if (value === "auto") return $39e2d87d62de0beb$var$getTransformTemplate();
        if (value === "auto-gpu") return $39e2d87d62de0beb$var$getTransformGpuTemplate();
        return value;
    },
    vh (value) {
        return value === "$100vh" ? "var(--chakra-vh)" : value;
    },
    px (value) {
        if (value == null) return value;
        const { unitless: unitless } = $39e2d87d62de0beb$var$analyzeCSSValue(value);
        return unitless || typeof value === "number" ? `${value}px` : value;
    },
    fraction (value) {
        return !(typeof value === "number") || value > 1 ? value : `${value * 100}%`;
    },
    float (value, theme) {
        const map = {
            left: "right",
            right: "left"
        };
        return theme.direction === "rtl" ? map[value] : value;
    },
    degree (value) {
        if ($39e2d87d62de0beb$var$isCssVar(value) || value == null) return value;
        const unitless = typeof value === "string" && !value.endsWith("deg");
        return typeof value === "number" || unitless ? `${value}deg` : value;
    },
    gradient: $39e2d87d62de0beb$var$gradientTransform,
    blur: $39e2d87d62de0beb$var$wrap("blur"),
    opacity: $39e2d87d62de0beb$var$wrap("opacity"),
    brightness: $39e2d87d62de0beb$var$wrap("brightness"),
    contrast: $39e2d87d62de0beb$var$wrap("contrast"),
    dropShadow: $39e2d87d62de0beb$var$wrap("drop-shadow"),
    grayscale: $39e2d87d62de0beb$var$wrap("grayscale"),
    hueRotate: (value)=>$39e2d87d62de0beb$var$wrap("hue-rotate")($39e2d87d62de0beb$var$transformFunctions.degree(value)),
    invert: $39e2d87d62de0beb$var$wrap("invert"),
    saturate: $39e2d87d62de0beb$var$wrap("saturate"),
    sepia: $39e2d87d62de0beb$var$wrap("sepia"),
    bgImage (value) {
        if (value == null) return value;
        const prevent = $39e2d87d62de0beb$var$isCSSFunction(value) || $39e2d87d62de0beb$var$globalSet.has(value);
        return !prevent ? `url(${value})` : value;
    },
    outline (value) {
        const isNoneOrZero = String(value) === "0" || String(value) === "none";
        return value !== null && isNoneOrZero ? {
            outline: "2px solid transparent",
            outlineOffset: "2px"
        } : {
            outline: value
        };
    },
    flexDirection (value) {
        var _a;
        const { space: space2, divide: divide2 } = (_a = $39e2d87d62de0beb$var$flexDirectionTemplate[value]) != null ? _a : {};
        const result = {
            flexDirection: value
        };
        if (space2) result[space2] = 1;
        if (divide2) result[divide2] = 1;
        return result;
    }
};
// src/utils/index.ts
var $39e2d87d62de0beb$var$t = {
    borderWidths: $39e2d87d62de0beb$var$toConfig("borderWidths"),
    borderStyles: $39e2d87d62de0beb$var$toConfig("borderStyles"),
    colors: $39e2d87d62de0beb$var$toConfig("colors"),
    borders: $39e2d87d62de0beb$var$toConfig("borders"),
    gradients: $39e2d87d62de0beb$var$toConfig("gradients", $39e2d87d62de0beb$var$transformFunctions.gradient),
    radii: $39e2d87d62de0beb$var$toConfig("radii", $39e2d87d62de0beb$var$transformFunctions.px),
    space: $39e2d87d62de0beb$var$toConfig("space", $39e2d87d62de0beb$var$pipe($39e2d87d62de0beb$var$transformFunctions.vh, $39e2d87d62de0beb$var$transformFunctions.px)),
    spaceT: $39e2d87d62de0beb$var$toConfig("space", $39e2d87d62de0beb$var$pipe($39e2d87d62de0beb$var$transformFunctions.vh, $39e2d87d62de0beb$var$transformFunctions.px)),
    degreeT (property) {
        return {
            property: property,
            transform: $39e2d87d62de0beb$var$transformFunctions.degree
        };
    },
    prop (property, scale, transform2) {
        return {
            property: property,
            scale: scale,
            ...scale && {
                transform: $39e2d87d62de0beb$var$createTransform({
                    scale: scale,
                    transform: transform2
                })
            }
        };
    },
    propT (property, transform2) {
        return {
            property: property,
            transform: transform2
        };
    },
    sizes: $39e2d87d62de0beb$var$toConfig("sizes", $39e2d87d62de0beb$var$pipe($39e2d87d62de0beb$var$transformFunctions.vh, $39e2d87d62de0beb$var$transformFunctions.px)),
    sizesT: $39e2d87d62de0beb$var$toConfig("sizes", $39e2d87d62de0beb$var$pipe($39e2d87d62de0beb$var$transformFunctions.vh, $39e2d87d62de0beb$var$transformFunctions.fraction)),
    shadows: $39e2d87d62de0beb$var$toConfig("shadows"),
    logical: $39e2d87d62de0beb$var$logical,
    blur: $39e2d87d62de0beb$var$toConfig("blur", $39e2d87d62de0beb$var$transformFunctions.blur)
};
// src/config/background.ts
var $39e2d87d62de0beb$export$8ce1fd94bee2f412 = {
    background: $39e2d87d62de0beb$var$t.colors("background"),
    backgroundColor: $39e2d87d62de0beb$var$t.colors("backgroundColor"),
    backgroundImage: $39e2d87d62de0beb$var$t.gradients("backgroundImage"),
    backgroundSize: true,
    backgroundPosition: true,
    backgroundRepeat: true,
    backgroundAttachment: true,
    backgroundClip: {
        transform: $39e2d87d62de0beb$var$transformFunctions.bgClip
    },
    bgSize: $39e2d87d62de0beb$var$t.prop("backgroundSize"),
    bgPosition: $39e2d87d62de0beb$var$t.prop("backgroundPosition"),
    bg: $39e2d87d62de0beb$var$t.colors("background"),
    bgColor: $39e2d87d62de0beb$var$t.colors("backgroundColor"),
    bgPos: $39e2d87d62de0beb$var$t.prop("backgroundPosition"),
    bgRepeat: $39e2d87d62de0beb$var$t.prop("backgroundRepeat"),
    bgAttachment: $39e2d87d62de0beb$var$t.prop("backgroundAttachment"),
    bgGradient: $39e2d87d62de0beb$var$t.gradients("backgroundImage"),
    bgClip: {
        transform: $39e2d87d62de0beb$var$transformFunctions.bgClip
    }
};
Object.assign($39e2d87d62de0beb$export$8ce1fd94bee2f412, {
    bgImage: $39e2d87d62de0beb$export$8ce1fd94bee2f412.backgroundImage,
    bgImg: $39e2d87d62de0beb$export$8ce1fd94bee2f412.backgroundImage
});
// src/config/border.ts
var $39e2d87d62de0beb$export$1edee58a52776cd9 = {
    border: $39e2d87d62de0beb$var$t.borders("border"),
    borderWidth: $39e2d87d62de0beb$var$t.borderWidths("borderWidth"),
    borderStyle: $39e2d87d62de0beb$var$t.borderStyles("borderStyle"),
    borderColor: $39e2d87d62de0beb$var$t.colors("borderColor"),
    borderRadius: $39e2d87d62de0beb$var$t.radii("borderRadius"),
    borderTop: $39e2d87d62de0beb$var$t.borders("borderTop"),
    borderBlockStart: $39e2d87d62de0beb$var$t.borders("borderBlockStart"),
    borderTopLeftRadius: $39e2d87d62de0beb$var$t.radii("borderTopLeftRadius"),
    borderStartStartRadius: $39e2d87d62de0beb$var$t.logical({
        scale: "radii",
        property: {
            ltr: "borderTopLeftRadius",
            rtl: "borderTopRightRadius"
        }
    }),
    borderEndStartRadius: $39e2d87d62de0beb$var$t.logical({
        scale: "radii",
        property: {
            ltr: "borderBottomLeftRadius",
            rtl: "borderBottomRightRadius"
        }
    }),
    borderTopRightRadius: $39e2d87d62de0beb$var$t.radii("borderTopRightRadius"),
    borderStartEndRadius: $39e2d87d62de0beb$var$t.logical({
        scale: "radii",
        property: {
            ltr: "borderTopRightRadius",
            rtl: "borderTopLeftRadius"
        }
    }),
    borderEndEndRadius: $39e2d87d62de0beb$var$t.logical({
        scale: "radii",
        property: {
            ltr: "borderBottomRightRadius",
            rtl: "borderBottomLeftRadius"
        }
    }),
    borderRight: $39e2d87d62de0beb$var$t.borders("borderRight"),
    borderInlineEnd: $39e2d87d62de0beb$var$t.borders("borderInlineEnd"),
    borderBottom: $39e2d87d62de0beb$var$t.borders("borderBottom"),
    borderBlockEnd: $39e2d87d62de0beb$var$t.borders("borderBlockEnd"),
    borderBottomLeftRadius: $39e2d87d62de0beb$var$t.radii("borderBottomLeftRadius"),
    borderBottomRightRadius: $39e2d87d62de0beb$var$t.radii("borderBottomRightRadius"),
    borderLeft: $39e2d87d62de0beb$var$t.borders("borderLeft"),
    borderInlineStart: {
        property: "borderInlineStart",
        scale: "borders"
    },
    borderInlineStartRadius: $39e2d87d62de0beb$var$t.logical({
        scale: "radii",
        property: {
            ltr: [
                "borderTopLeftRadius",
                "borderBottomLeftRadius"
            ],
            rtl: [
                "borderTopRightRadius",
                "borderBottomRightRadius"
            ]
        }
    }),
    borderInlineEndRadius: $39e2d87d62de0beb$var$t.logical({
        scale: "radii",
        property: {
            ltr: [
                "borderTopRightRadius",
                "borderBottomRightRadius"
            ],
            rtl: [
                "borderTopLeftRadius",
                "borderBottomLeftRadius"
            ]
        }
    }),
    borderX: $39e2d87d62de0beb$var$t.borders([
        "borderLeft",
        "borderRight"
    ]),
    borderInline: $39e2d87d62de0beb$var$t.borders("borderInline"),
    borderY: $39e2d87d62de0beb$var$t.borders([
        "borderTop",
        "borderBottom"
    ]),
    borderBlock: $39e2d87d62de0beb$var$t.borders("borderBlock"),
    borderTopWidth: $39e2d87d62de0beb$var$t.borderWidths("borderTopWidth"),
    borderBlockStartWidth: $39e2d87d62de0beb$var$t.borderWidths("borderBlockStartWidth"),
    borderTopColor: $39e2d87d62de0beb$var$t.colors("borderTopColor"),
    borderBlockStartColor: $39e2d87d62de0beb$var$t.colors("borderBlockStartColor"),
    borderTopStyle: $39e2d87d62de0beb$var$t.borderStyles("borderTopStyle"),
    borderBlockStartStyle: $39e2d87d62de0beb$var$t.borderStyles("borderBlockStartStyle"),
    borderBottomWidth: $39e2d87d62de0beb$var$t.borderWidths("borderBottomWidth"),
    borderBlockEndWidth: $39e2d87d62de0beb$var$t.borderWidths("borderBlockEndWidth"),
    borderBottomColor: $39e2d87d62de0beb$var$t.colors("borderBottomColor"),
    borderBlockEndColor: $39e2d87d62de0beb$var$t.colors("borderBlockEndColor"),
    borderBottomStyle: $39e2d87d62de0beb$var$t.borderStyles("borderBottomStyle"),
    borderBlockEndStyle: $39e2d87d62de0beb$var$t.borderStyles("borderBlockEndStyle"),
    borderLeftWidth: $39e2d87d62de0beb$var$t.borderWidths("borderLeftWidth"),
    borderInlineStartWidth: $39e2d87d62de0beb$var$t.borderWidths("borderInlineStartWidth"),
    borderLeftColor: $39e2d87d62de0beb$var$t.colors("borderLeftColor"),
    borderInlineStartColor: $39e2d87d62de0beb$var$t.colors("borderInlineStartColor"),
    borderLeftStyle: $39e2d87d62de0beb$var$t.borderStyles("borderLeftStyle"),
    borderInlineStartStyle: $39e2d87d62de0beb$var$t.borderStyles("borderInlineStartStyle"),
    borderRightWidth: $39e2d87d62de0beb$var$t.borderWidths("borderRightWidth"),
    borderInlineEndWidth: $39e2d87d62de0beb$var$t.borderWidths("borderInlineEndWidth"),
    borderRightColor: $39e2d87d62de0beb$var$t.colors("borderRightColor"),
    borderInlineEndColor: $39e2d87d62de0beb$var$t.colors("borderInlineEndColor"),
    borderRightStyle: $39e2d87d62de0beb$var$t.borderStyles("borderRightStyle"),
    borderInlineEndStyle: $39e2d87d62de0beb$var$t.borderStyles("borderInlineEndStyle"),
    borderTopRadius: $39e2d87d62de0beb$var$t.radii([
        "borderTopLeftRadius",
        "borderTopRightRadius"
    ]),
    borderBottomRadius: $39e2d87d62de0beb$var$t.radii([
        "borderBottomLeftRadius",
        "borderBottomRightRadius"
    ]),
    borderLeftRadius: $39e2d87d62de0beb$var$t.radii([
        "borderTopLeftRadius",
        "borderBottomLeftRadius"
    ]),
    borderRightRadius: $39e2d87d62de0beb$var$t.radii([
        "borderTopRightRadius",
        "borderBottomRightRadius"
    ])
};
Object.assign($39e2d87d62de0beb$export$1edee58a52776cd9, {
    rounded: $39e2d87d62de0beb$export$1edee58a52776cd9.borderRadius,
    roundedTop: $39e2d87d62de0beb$export$1edee58a52776cd9.borderTopRadius,
    roundedTopLeft: $39e2d87d62de0beb$export$1edee58a52776cd9.borderTopLeftRadius,
    roundedTopRight: $39e2d87d62de0beb$export$1edee58a52776cd9.borderTopRightRadius,
    roundedTopStart: $39e2d87d62de0beb$export$1edee58a52776cd9.borderStartStartRadius,
    roundedTopEnd: $39e2d87d62de0beb$export$1edee58a52776cd9.borderStartEndRadius,
    roundedBottom: $39e2d87d62de0beb$export$1edee58a52776cd9.borderBottomRadius,
    roundedBottomLeft: $39e2d87d62de0beb$export$1edee58a52776cd9.borderBottomLeftRadius,
    roundedBottomRight: $39e2d87d62de0beb$export$1edee58a52776cd9.borderBottomRightRadius,
    roundedBottomStart: $39e2d87d62de0beb$export$1edee58a52776cd9.borderEndStartRadius,
    roundedBottomEnd: $39e2d87d62de0beb$export$1edee58a52776cd9.borderEndEndRadius,
    roundedLeft: $39e2d87d62de0beb$export$1edee58a52776cd9.borderLeftRadius,
    roundedRight: $39e2d87d62de0beb$export$1edee58a52776cd9.borderRightRadius,
    roundedStart: $39e2d87d62de0beb$export$1edee58a52776cd9.borderInlineStartRadius,
    roundedEnd: $39e2d87d62de0beb$export$1edee58a52776cd9.borderInlineEndRadius,
    borderStart: $39e2d87d62de0beb$export$1edee58a52776cd9.borderInlineStart,
    borderEnd: $39e2d87d62de0beb$export$1edee58a52776cd9.borderInlineEnd,
    borderTopStartRadius: $39e2d87d62de0beb$export$1edee58a52776cd9.borderStartStartRadius,
    borderTopEndRadius: $39e2d87d62de0beb$export$1edee58a52776cd9.borderStartEndRadius,
    borderBottomStartRadius: $39e2d87d62de0beb$export$1edee58a52776cd9.borderEndStartRadius,
    borderBottomEndRadius: $39e2d87d62de0beb$export$1edee58a52776cd9.borderEndEndRadius,
    borderStartRadius: $39e2d87d62de0beb$export$1edee58a52776cd9.borderInlineStartRadius,
    borderEndRadius: $39e2d87d62de0beb$export$1edee58a52776cd9.borderInlineEndRadius,
    borderStartWidth: $39e2d87d62de0beb$export$1edee58a52776cd9.borderInlineStartWidth,
    borderEndWidth: $39e2d87d62de0beb$export$1edee58a52776cd9.borderInlineEndWidth,
    borderStartColor: $39e2d87d62de0beb$export$1edee58a52776cd9.borderInlineStartColor,
    borderEndColor: $39e2d87d62de0beb$export$1edee58a52776cd9.borderInlineEndColor,
    borderStartStyle: $39e2d87d62de0beb$export$1edee58a52776cd9.borderInlineStartStyle,
    borderEndStyle: $39e2d87d62de0beb$export$1edee58a52776cd9.borderInlineEndStyle
});
// src/config/color.ts
var $39e2d87d62de0beb$export$35e9368ef982300f = {
    color: $39e2d87d62de0beb$var$t.colors("color"),
    textColor: $39e2d87d62de0beb$var$t.colors("color"),
    fill: $39e2d87d62de0beb$var$t.colors("fill"),
    stroke: $39e2d87d62de0beb$var$t.colors("stroke")
};
// src/config/effect.ts
var $39e2d87d62de0beb$export$dc573d8a6576cdb3 = {
    boxShadow: $39e2d87d62de0beb$var$t.shadows("boxShadow"),
    mixBlendMode: true,
    blendMode: $39e2d87d62de0beb$var$t.prop("mixBlendMode"),
    backgroundBlendMode: true,
    bgBlendMode: $39e2d87d62de0beb$var$t.prop("backgroundBlendMode"),
    opacity: true
};
Object.assign($39e2d87d62de0beb$export$dc573d8a6576cdb3, {
    shadow: $39e2d87d62de0beb$export$dc573d8a6576cdb3.boxShadow
});
// src/config/filter.ts
var $39e2d87d62de0beb$export$3dea766d36a8935f = {
    filter: {
        transform: $39e2d87d62de0beb$var$transformFunctions.filter
    },
    blur: $39e2d87d62de0beb$var$t.blur("--chakra-blur"),
    brightness: $39e2d87d62de0beb$var$t.propT("--chakra-brightness", $39e2d87d62de0beb$var$transformFunctions.brightness),
    contrast: $39e2d87d62de0beb$var$t.propT("--chakra-contrast", $39e2d87d62de0beb$var$transformFunctions.contrast),
    hueRotate: $39e2d87d62de0beb$var$t.propT("--chakra-hue-rotate", $39e2d87d62de0beb$var$transformFunctions.hueRotate),
    invert: $39e2d87d62de0beb$var$t.propT("--chakra-invert", $39e2d87d62de0beb$var$transformFunctions.invert),
    saturate: $39e2d87d62de0beb$var$t.propT("--chakra-saturate", $39e2d87d62de0beb$var$transformFunctions.saturate),
    dropShadow: $39e2d87d62de0beb$var$t.propT("--chakra-drop-shadow", $39e2d87d62de0beb$var$transformFunctions.dropShadow),
    backdropFilter: {
        transform: $39e2d87d62de0beb$var$transformFunctions.backdropFilter
    },
    backdropBlur: $39e2d87d62de0beb$var$t.blur("--chakra-backdrop-blur"),
    backdropBrightness: $39e2d87d62de0beb$var$t.propT("--chakra-backdrop-brightness", $39e2d87d62de0beb$var$transformFunctions.brightness),
    backdropContrast: $39e2d87d62de0beb$var$t.propT("--chakra-backdrop-contrast", $39e2d87d62de0beb$var$transformFunctions.contrast),
    backdropHueRotate: $39e2d87d62de0beb$var$t.propT("--chakra-backdrop-hue-rotate", $39e2d87d62de0beb$var$transformFunctions.hueRotate),
    backdropInvert: $39e2d87d62de0beb$var$t.propT("--chakra-backdrop-invert", $39e2d87d62de0beb$var$transformFunctions.invert),
    backdropSaturate: $39e2d87d62de0beb$var$t.propT("--chakra-backdrop-saturate", $39e2d87d62de0beb$var$transformFunctions.saturate)
};
// src/config/flexbox.ts
var $39e2d87d62de0beb$export$feec61708a55c80e = {
    alignItems: true,
    alignContent: true,
    justifyItems: true,
    justifyContent: true,
    flexWrap: true,
    flexDirection: {
        transform: $39e2d87d62de0beb$var$transformFunctions.flexDirection
    },
    flex: true,
    flexFlow: true,
    flexGrow: true,
    flexShrink: true,
    flexBasis: $39e2d87d62de0beb$var$t.sizes("flexBasis"),
    justifySelf: true,
    alignSelf: true,
    order: true,
    placeItems: true,
    placeContent: true,
    placeSelf: true,
    gap: $39e2d87d62de0beb$var$t.space("gap"),
    rowGap: $39e2d87d62de0beb$var$t.space("rowGap"),
    columnGap: $39e2d87d62de0beb$var$t.space("columnGap")
};
Object.assign($39e2d87d62de0beb$export$feec61708a55c80e, {
    flexDir: $39e2d87d62de0beb$export$feec61708a55c80e.flexDirection
});
// src/config/grid.ts
var $39e2d87d62de0beb$export$85fc379452d91af0 = {
    gridGap: $39e2d87d62de0beb$var$t.space("gridGap"),
    gridColumnGap: $39e2d87d62de0beb$var$t.space("gridColumnGap"),
    gridRowGap: $39e2d87d62de0beb$var$t.space("gridRowGap"),
    gridColumn: true,
    gridRow: true,
    gridAutoFlow: true,
    gridAutoColumns: true,
    gridColumnStart: true,
    gridColumnEnd: true,
    gridRowStart: true,
    gridRowEnd: true,
    gridAutoRows: true,
    gridTemplate: true,
    gridTemplateColumns: true,
    gridTemplateRows: true,
    gridTemplateAreas: true,
    gridArea: true
};
// src/config/interactivity.ts
var $39e2d87d62de0beb$export$2499a341a8256d68 = {
    appearance: true,
    cursor: true,
    resize: true,
    userSelect: true,
    pointerEvents: true,
    outline: {
        transform: $39e2d87d62de0beb$var$transformFunctions.outline
    },
    outlineOffset: true,
    outlineColor: $39e2d87d62de0beb$var$t.colors("outlineColor")
};
// src/config/layout.ts
var $39e2d87d62de0beb$export$b3219800bda33a1f = {
    width: $39e2d87d62de0beb$var$t.sizesT("width"),
    inlineSize: $39e2d87d62de0beb$var$t.sizesT("inlineSize"),
    height: $39e2d87d62de0beb$var$t.sizes("height"),
    blockSize: $39e2d87d62de0beb$var$t.sizes("blockSize"),
    boxSize: $39e2d87d62de0beb$var$t.sizes([
        "width",
        "height"
    ]),
    minWidth: $39e2d87d62de0beb$var$t.sizes("minWidth"),
    minInlineSize: $39e2d87d62de0beb$var$t.sizes("minInlineSize"),
    minHeight: $39e2d87d62de0beb$var$t.sizes("minHeight"),
    minBlockSize: $39e2d87d62de0beb$var$t.sizes("minBlockSize"),
    maxWidth: $39e2d87d62de0beb$var$t.sizes("maxWidth"),
    maxInlineSize: $39e2d87d62de0beb$var$t.sizes("maxInlineSize"),
    maxHeight: $39e2d87d62de0beb$var$t.sizes("maxHeight"),
    maxBlockSize: $39e2d87d62de0beb$var$t.sizes("maxBlockSize"),
    overflow: true,
    overflowX: true,
    overflowY: true,
    overscrollBehavior: true,
    overscrollBehaviorX: true,
    overscrollBehaviorY: true,
    display: true,
    aspectRatio: true,
    hideFrom: {
        scale: "breakpoints",
        transform: (value, theme)=>{
            var _a, _b, _c;
            const breakpoint = (_c = (_b = (_a = theme.__breakpoints) == null ? void 0 : _a.get(value)) == null ? void 0 : _b.minW) != null ? _c : value;
            const mq = `@media screen and (min-width: ${breakpoint})`;
            return {
                [mq]: {
                    display: "none"
                }
            };
        }
    },
    hideBelow: {
        scale: "breakpoints",
        transform: (value, theme)=>{
            var _a, _b, _c;
            const breakpoint = (_c = (_b = (_a = theme.__breakpoints) == null ? void 0 : _a.get(value)) == null ? void 0 : _b._minW) != null ? _c : value;
            const mq = `@media screen and (max-width: ${breakpoint})`;
            return {
                [mq]: {
                    display: "none"
                }
            };
        }
    },
    verticalAlign: true,
    boxSizing: true,
    boxDecorationBreak: true,
    float: $39e2d87d62de0beb$var$t.propT("float", $39e2d87d62de0beb$var$transformFunctions.float),
    objectFit: true,
    objectPosition: true,
    visibility: true,
    isolation: true
};
Object.assign($39e2d87d62de0beb$export$b3219800bda33a1f, {
    w: $39e2d87d62de0beb$export$b3219800bda33a1f.width,
    h: $39e2d87d62de0beb$export$b3219800bda33a1f.height,
    minW: $39e2d87d62de0beb$export$b3219800bda33a1f.minWidth,
    maxW: $39e2d87d62de0beb$export$b3219800bda33a1f.maxWidth,
    minH: $39e2d87d62de0beb$export$b3219800bda33a1f.minHeight,
    maxH: $39e2d87d62de0beb$export$b3219800bda33a1f.maxHeight,
    overscroll: $39e2d87d62de0beb$export$b3219800bda33a1f.overscrollBehavior,
    overscrollX: $39e2d87d62de0beb$export$b3219800bda33a1f.overscrollBehaviorX,
    overscrollY: $39e2d87d62de0beb$export$b3219800bda33a1f.overscrollBehaviorY
});
// src/config/list.ts
var $39e2d87d62de0beb$export$8837f4fc672e936d = {
    listStyleType: true,
    listStylePosition: true,
    listStylePos: $39e2d87d62de0beb$var$t.prop("listStylePosition"),
    listStyleImage: true,
    listStyleImg: $39e2d87d62de0beb$var$t.prop("listStyleImage")
};
// src/get.ts
function $39e2d87d62de0beb$var$get(obj, path, fallback, index) {
    const key = typeof path === "string" ? path.split(".") : [
        path
    ];
    for(index = 0; index < key.length; index += 1){
        if (!obj) break;
        obj = obj[key[index]];
    }
    return obj === void 0 ? fallback : obj;
}
var $39e2d87d62de0beb$var$memoize = (fn)=>{
    const cache = /* @__PURE__ */ new WeakMap();
    const memoizedFn = (obj, path, fallback, index)=>{
        if (typeof obj === "undefined") return fn(obj, path, fallback);
        if (!cache.has(obj)) cache.set(obj, /* @__PURE__ */ new Map());
        const map = cache.get(obj);
        if (map.has(path)) return map.get(path);
        const value = fn(obj, path, fallback, index);
        map.set(path, value);
        return value;
    };
    return memoizedFn;
};
var $39e2d87d62de0beb$var$memoizedGet = $39e2d87d62de0beb$var$memoize($39e2d87d62de0beb$var$get);
// src/config/others.ts
var $39e2d87d62de0beb$var$srOnly = {
    border: "0px",
    clip: "rect(0, 0, 0, 0)",
    width: "1px",
    height: "1px",
    margin: "-1px",
    padding: "0px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    position: "absolute"
};
var $39e2d87d62de0beb$var$srFocusable = {
    position: "static",
    width: "auto",
    height: "auto",
    clip: "auto",
    padding: "0",
    margin: "0",
    overflow: "visible",
    whiteSpace: "normal"
};
var $39e2d87d62de0beb$var$getWithPriority = (theme, key, styles)=>{
    const result = {};
    const obj = $39e2d87d62de0beb$var$memoizedGet(theme, key, {});
    for(const prop in obj){
        const isInStyles = prop in styles && styles[prop] != null;
        if (!isInStyles) result[prop] = obj[prop];
    }
    return result;
};
var $39e2d87d62de0beb$export$36263e8f8d7ce3b1 = {
    srOnly: {
        transform (value) {
            if (value === true) return $39e2d87d62de0beb$var$srOnly;
            if (value === "focusable") return $39e2d87d62de0beb$var$srFocusable;
            return {};
        }
    },
    layerStyle: {
        processResult: true,
        transform: (value, theme, styles)=>$39e2d87d62de0beb$var$getWithPriority(theme, `layerStyles.${value}`, styles)
    },
    textStyle: {
        processResult: true,
        transform: (value, theme, styles)=>$39e2d87d62de0beb$var$getWithPriority(theme, `textStyles.${value}`, styles)
    },
    apply: {
        processResult: true,
        transform: (value, theme, styles)=>$39e2d87d62de0beb$var$getWithPriority(theme, value, styles)
    }
};
// src/config/position.ts
var $39e2d87d62de0beb$export$5880b8b5730aff45 = {
    position: true,
    pos: $39e2d87d62de0beb$var$t.prop("position"),
    zIndex: $39e2d87d62de0beb$var$t.prop("zIndex", "zIndices"),
    inset: $39e2d87d62de0beb$var$t.spaceT("inset"),
    insetX: $39e2d87d62de0beb$var$t.spaceT([
        "left",
        "right"
    ]),
    insetInline: $39e2d87d62de0beb$var$t.spaceT("insetInline"),
    insetY: $39e2d87d62de0beb$var$t.spaceT([
        "top",
        "bottom"
    ]),
    insetBlock: $39e2d87d62de0beb$var$t.spaceT("insetBlock"),
    top: $39e2d87d62de0beb$var$t.spaceT("top"),
    insetBlockStart: $39e2d87d62de0beb$var$t.spaceT("insetBlockStart"),
    bottom: $39e2d87d62de0beb$var$t.spaceT("bottom"),
    insetBlockEnd: $39e2d87d62de0beb$var$t.spaceT("insetBlockEnd"),
    left: $39e2d87d62de0beb$var$t.spaceT("left"),
    insetInlineStart: $39e2d87d62de0beb$var$t.logical({
        scale: "space",
        property: {
            ltr: "left",
            rtl: "right"
        }
    }),
    right: $39e2d87d62de0beb$var$t.spaceT("right"),
    insetInlineEnd: $39e2d87d62de0beb$var$t.logical({
        scale: "space",
        property: {
            ltr: "right",
            rtl: "left"
        }
    })
};
Object.assign($39e2d87d62de0beb$export$5880b8b5730aff45, {
    insetStart: $39e2d87d62de0beb$export$5880b8b5730aff45.insetInlineStart,
    insetEnd: $39e2d87d62de0beb$export$5880b8b5730aff45.insetInlineEnd
});
// src/config/ring.ts
var $39e2d87d62de0beb$export$e7d0da6968da5dd = {
    ring: {
        transform: $39e2d87d62de0beb$var$transformFunctions.ring
    },
    ringColor: $39e2d87d62de0beb$var$t.colors("--chakra-ring-color"),
    ringOffset: $39e2d87d62de0beb$var$t.prop("--chakra-ring-offset-width"),
    ringOffsetColor: $39e2d87d62de0beb$var$t.colors("--chakra-ring-offset-color"),
    ringInset: $39e2d87d62de0beb$var$t.prop("--chakra-ring-inset")
};
// src/config/space.ts
var $39e2d87d62de0beb$export$a941ed4b947d12f8 = {
    margin: $39e2d87d62de0beb$var$t.spaceT("margin"),
    marginTop: $39e2d87d62de0beb$var$t.spaceT("marginTop"),
    marginBlockStart: $39e2d87d62de0beb$var$t.spaceT("marginBlockStart"),
    marginRight: $39e2d87d62de0beb$var$t.spaceT("marginRight"),
    marginInlineEnd: $39e2d87d62de0beb$var$t.spaceT("marginInlineEnd"),
    marginBottom: $39e2d87d62de0beb$var$t.spaceT("marginBottom"),
    marginBlockEnd: $39e2d87d62de0beb$var$t.spaceT("marginBlockEnd"),
    marginLeft: $39e2d87d62de0beb$var$t.spaceT("marginLeft"),
    marginInlineStart: $39e2d87d62de0beb$var$t.spaceT("marginInlineStart"),
    marginX: $39e2d87d62de0beb$var$t.spaceT([
        "marginInlineStart",
        "marginInlineEnd"
    ]),
    marginInline: $39e2d87d62de0beb$var$t.spaceT("marginInline"),
    marginY: $39e2d87d62de0beb$var$t.spaceT([
        "marginTop",
        "marginBottom"
    ]),
    marginBlock: $39e2d87d62de0beb$var$t.spaceT("marginBlock"),
    padding: $39e2d87d62de0beb$var$t.space("padding"),
    paddingTop: $39e2d87d62de0beb$var$t.space("paddingTop"),
    paddingBlockStart: $39e2d87d62de0beb$var$t.space("paddingBlockStart"),
    paddingRight: $39e2d87d62de0beb$var$t.space("paddingRight"),
    paddingBottom: $39e2d87d62de0beb$var$t.space("paddingBottom"),
    paddingBlockEnd: $39e2d87d62de0beb$var$t.space("paddingBlockEnd"),
    paddingLeft: $39e2d87d62de0beb$var$t.space("paddingLeft"),
    paddingInlineStart: $39e2d87d62de0beb$var$t.space("paddingInlineStart"),
    paddingInlineEnd: $39e2d87d62de0beb$var$t.space("paddingInlineEnd"),
    paddingX: $39e2d87d62de0beb$var$t.space([
        "paddingInlineStart",
        "paddingInlineEnd"
    ]),
    paddingInline: $39e2d87d62de0beb$var$t.space("paddingInline"),
    paddingY: $39e2d87d62de0beb$var$t.space([
        "paddingTop",
        "paddingBottom"
    ]),
    paddingBlock: $39e2d87d62de0beb$var$t.space("paddingBlock")
};
Object.assign($39e2d87d62de0beb$export$a941ed4b947d12f8, {
    m: $39e2d87d62de0beb$export$a941ed4b947d12f8.margin,
    mt: $39e2d87d62de0beb$export$a941ed4b947d12f8.marginTop,
    mr: $39e2d87d62de0beb$export$a941ed4b947d12f8.marginRight,
    me: $39e2d87d62de0beb$export$a941ed4b947d12f8.marginInlineEnd,
    marginEnd: $39e2d87d62de0beb$export$a941ed4b947d12f8.marginInlineEnd,
    mb: $39e2d87d62de0beb$export$a941ed4b947d12f8.marginBottom,
    ml: $39e2d87d62de0beb$export$a941ed4b947d12f8.marginLeft,
    ms: $39e2d87d62de0beb$export$a941ed4b947d12f8.marginInlineStart,
    marginStart: $39e2d87d62de0beb$export$a941ed4b947d12f8.marginInlineStart,
    mx: $39e2d87d62de0beb$export$a941ed4b947d12f8.marginX,
    my: $39e2d87d62de0beb$export$a941ed4b947d12f8.marginY,
    p: $39e2d87d62de0beb$export$a941ed4b947d12f8.padding,
    pt: $39e2d87d62de0beb$export$a941ed4b947d12f8.paddingTop,
    py: $39e2d87d62de0beb$export$a941ed4b947d12f8.paddingY,
    px: $39e2d87d62de0beb$export$a941ed4b947d12f8.paddingX,
    pb: $39e2d87d62de0beb$export$a941ed4b947d12f8.paddingBottom,
    pl: $39e2d87d62de0beb$export$a941ed4b947d12f8.paddingLeft,
    ps: $39e2d87d62de0beb$export$a941ed4b947d12f8.paddingInlineStart,
    paddingStart: $39e2d87d62de0beb$export$a941ed4b947d12f8.paddingInlineStart,
    pr: $39e2d87d62de0beb$export$a941ed4b947d12f8.paddingRight,
    pe: $39e2d87d62de0beb$export$a941ed4b947d12f8.paddingInlineEnd,
    paddingEnd: $39e2d87d62de0beb$export$a941ed4b947d12f8.paddingInlineEnd
});
// src/config/text-decoration.ts
var $39e2d87d62de0beb$export$6b7f9af9aa033040 = {
    textDecorationColor: $39e2d87d62de0beb$var$t.colors("textDecorationColor"),
    textDecoration: true,
    textDecor: {
        property: "textDecoration"
    },
    textDecorationLine: true,
    textDecorationStyle: true,
    textDecorationThickness: true,
    textUnderlineOffset: true,
    textShadow: $39e2d87d62de0beb$var$t.shadows("textShadow")
};
// src/config/transform.ts
var $39e2d87d62de0beb$export$51186ad6e864892a = {
    clipPath: true,
    transform: $39e2d87d62de0beb$var$t.propT("transform", $39e2d87d62de0beb$var$transformFunctions.transform),
    transformOrigin: true,
    translateX: $39e2d87d62de0beb$var$t.spaceT("--chakra-translate-x"),
    translateY: $39e2d87d62de0beb$var$t.spaceT("--chakra-translate-y"),
    skewX: $39e2d87d62de0beb$var$t.degreeT("--chakra-skew-x"),
    skewY: $39e2d87d62de0beb$var$t.degreeT("--chakra-skew-y"),
    scaleX: $39e2d87d62de0beb$var$t.prop("--chakra-scale-x"),
    scaleY: $39e2d87d62de0beb$var$t.prop("--chakra-scale-y"),
    scale: $39e2d87d62de0beb$var$t.prop([
        "--chakra-scale-x",
        "--chakra-scale-y"
    ]),
    rotate: $39e2d87d62de0beb$var$t.degreeT("--chakra-rotate")
};
// src/config/transition.ts
var $39e2d87d62de0beb$export$66bb15e2994e6a26 = {
    transition: true,
    transitionDelay: true,
    animation: true,
    willChange: true,
    transitionDuration: $39e2d87d62de0beb$var$t.prop("transitionDuration", "transition.duration"),
    transitionProperty: $39e2d87d62de0beb$var$t.prop("transitionProperty", "transition.property"),
    transitionTimingFunction: $39e2d87d62de0beb$var$t.prop("transitionTimingFunction", "transition.easing")
};
// src/config/typography.ts
var $39e2d87d62de0beb$export$d846a084e680d8e = {
    fontFamily: $39e2d87d62de0beb$var$t.prop("fontFamily", "fonts"),
    fontSize: $39e2d87d62de0beb$var$t.prop("fontSize", "fontSizes", $39e2d87d62de0beb$var$transformFunctions.px),
    fontWeight: $39e2d87d62de0beb$var$t.prop("fontWeight", "fontWeights"),
    lineHeight: $39e2d87d62de0beb$var$t.prop("lineHeight", "lineHeights"),
    letterSpacing: $39e2d87d62de0beb$var$t.prop("letterSpacing", "letterSpacings"),
    textAlign: true,
    fontStyle: true,
    textIndent: true,
    wordBreak: true,
    overflowWrap: true,
    textOverflow: true,
    textTransform: true,
    whiteSpace: true,
    isTruncated: {
        transform (value) {
            if (value === true) return {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
            };
        }
    },
    noOfLines: {
        static: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            //@ts-ignore
            WebkitLineClamp: "var(--chakra-line-clamp)"
        },
        property: "--chakra-line-clamp"
    }
};
// src/config/scroll.ts
var $39e2d87d62de0beb$export$209876d7b1ac8f3 = {
    scrollBehavior: true,
    scrollSnapAlign: true,
    scrollSnapStop: true,
    scrollSnapType: true,
    // scroll margin
    scrollMargin: $39e2d87d62de0beb$var$t.spaceT("scrollMargin"),
    scrollMarginTop: $39e2d87d62de0beb$var$t.spaceT("scrollMarginTop"),
    scrollMarginBottom: $39e2d87d62de0beb$var$t.spaceT("scrollMarginBottom"),
    scrollMarginLeft: $39e2d87d62de0beb$var$t.spaceT("scrollMarginLeft"),
    scrollMarginRight: $39e2d87d62de0beb$var$t.spaceT("scrollMarginRight"),
    scrollMarginX: $39e2d87d62de0beb$var$t.spaceT([
        "scrollMarginLeft",
        "scrollMarginRight"
    ]),
    scrollMarginY: $39e2d87d62de0beb$var$t.spaceT([
        "scrollMarginTop",
        "scrollMarginBottom"
    ]),
    // scroll padding
    scrollPadding: $39e2d87d62de0beb$var$t.spaceT("scrollPadding"),
    scrollPaddingTop: $39e2d87d62de0beb$var$t.spaceT("scrollPaddingTop"),
    scrollPaddingBottom: $39e2d87d62de0beb$var$t.spaceT("scrollPaddingBottom"),
    scrollPaddingLeft: $39e2d87d62de0beb$var$t.spaceT("scrollPaddingLeft"),
    scrollPaddingRight: $39e2d87d62de0beb$var$t.spaceT("scrollPaddingRight"),
    scrollPaddingX: $39e2d87d62de0beb$var$t.spaceT([
        "scrollPaddingLeft",
        "scrollPaddingRight"
    ]),
    scrollPaddingY: $39e2d87d62de0beb$var$t.spaceT([
        "scrollPaddingTop",
        "scrollPaddingBottom"
    ])
};
function $39e2d87d62de0beb$var$resolveReference(operand) {
    if ((0, $iyhjB.isObject)(operand) && operand.reference) return operand.reference;
    return String(operand);
}
var $39e2d87d62de0beb$var$toExpression = (operator, ...operands)=>operands.map($39e2d87d62de0beb$var$resolveReference).join(` ${operator} `).replace(/calc/g, "");
var $39e2d87d62de0beb$var$add = (...operands)=>`calc(${$39e2d87d62de0beb$var$toExpression("+", ...operands)})`;
var $39e2d87d62de0beb$var$subtract = (...operands)=>`calc(${$39e2d87d62de0beb$var$toExpression("-", ...operands)})`;
var $39e2d87d62de0beb$var$multiply = (...operands)=>`calc(${$39e2d87d62de0beb$var$toExpression("*", ...operands)})`;
var $39e2d87d62de0beb$var$divide = (...operands)=>`calc(${$39e2d87d62de0beb$var$toExpression("/", ...operands)})`;
var $39e2d87d62de0beb$var$negate = (x)=>{
    const value = $39e2d87d62de0beb$var$resolveReference(x);
    if (value != null && !Number.isNaN(parseFloat(value))) return String(value).startsWith("-") ? String(value).slice(1) : `-${value}`;
    return $39e2d87d62de0beb$var$multiply(value, -1);
};
var $39e2d87d62de0beb$export$42bfa9b2d4dad91a = Object.assign((x)=>({
        add: (...operands)=>$39e2d87d62de0beb$export$42bfa9b2d4dad91a($39e2d87d62de0beb$var$add(x, ...operands)),
        subtract: (...operands)=>$39e2d87d62de0beb$export$42bfa9b2d4dad91a($39e2d87d62de0beb$var$subtract(x, ...operands)),
        multiply: (...operands)=>$39e2d87d62de0beb$export$42bfa9b2d4dad91a($39e2d87d62de0beb$var$multiply(x, ...operands)),
        divide: (...operands)=>$39e2d87d62de0beb$export$42bfa9b2d4dad91a($39e2d87d62de0beb$var$divide(x, ...operands)),
        negate: ()=>$39e2d87d62de0beb$export$42bfa9b2d4dad91a($39e2d87d62de0beb$var$negate(x)),
        toString: ()=>x.toString()
    }), {
    add: $39e2d87d62de0beb$var$add,
    subtract: $39e2d87d62de0beb$var$subtract,
    multiply: $39e2d87d62de0beb$var$multiply,
    divide: $39e2d87d62de0beb$var$divide,
    negate: $39e2d87d62de0beb$var$negate
});
// src/create-theme-vars/css-var.ts
function $39e2d87d62de0beb$var$replaceWhiteSpace(value, replaceValue = "-") {
    return value.replace(/\s+/g, replaceValue);
}
function $39e2d87d62de0beb$var$escape(value) {
    const valueStr = $39e2d87d62de0beb$var$replaceWhiteSpace(value.toString());
    return $39e2d87d62de0beb$var$escapeSymbol($39e2d87d62de0beb$var$escapeDot(valueStr));
}
function $39e2d87d62de0beb$var$escapeDot(value) {
    if (value.includes("\\.")) return value;
    const isDecimal = !Number.isInteger(parseFloat(value.toString()));
    return isDecimal ? value.replace(".", `\\.`) : value;
}
function $39e2d87d62de0beb$var$escapeSymbol(value) {
    return value.replace(/[!-,/:-@[-^`{-~]/g, "\\$&");
}
function $39e2d87d62de0beb$export$9748efee331ec573(value, prefix = "") {
    return [
        prefix,
        value
    ].filter(Boolean).join("-");
}
function $39e2d87d62de0beb$export$bb435e137b4b8e38(name, fallback) {
    return `var(${name}${fallback ? `, ${fallback}` : ""})`;
}
function $39e2d87d62de0beb$export$3695bd65cc73dae9(value, prefix = "") {
    return $39e2d87d62de0beb$var$escape(`--${$39e2d87d62de0beb$export$9748efee331ec573(value, prefix)}`);
}
function $39e2d87d62de0beb$export$8b4981022bd80a4e(name, fallback, cssVarPrefix) {
    const cssVariable = $39e2d87d62de0beb$export$3695bd65cc73dae9(name, cssVarPrefix);
    return {
        variable: cssVariable,
        reference: $39e2d87d62de0beb$export$bb435e137b4b8e38(cssVariable, fallback)
    };
}
function $39e2d87d62de0beb$export$bd40561c6c056841(scope, keys2) {
    const vars = {};
    for (const key of keys2){
        if (Array.isArray(key)) {
            const [name, fallback] = key;
            vars[name] = $39e2d87d62de0beb$export$8b4981022bd80a4e(`${scope}-${name}`, fallback);
            continue;
        }
        vars[key] = $39e2d87d62de0beb$export$8b4981022bd80a4e(`${scope}-${key}`);
    }
    return vars;
}
function $39e2d87d62de0beb$var$getLastItem(array) {
    const length = array == null ? 0 : array.length;
    return length ? array[length - 1] : void 0;
}
function $39e2d87d62de0beb$var$analyzeCSSValue2(value) {
    const num = parseFloat(value.toString());
    const unit = value.toString().replace(String(num), "");
    return {
        unitless: !unit,
        value: num,
        unit: unit
    };
}
function $39e2d87d62de0beb$var$px(value) {
    if (value == null) return value;
    const { unitless: unitless } = $39e2d87d62de0beb$var$analyzeCSSValue2(value);
    return unitless || typeof value === "number" ? `${value}px` : value;
}
var $39e2d87d62de0beb$var$sortByBreakpointValue = (a, b)=>parseInt(a[1], 10) > parseInt(b[1], 10) ? 1 : -1;
var $39e2d87d62de0beb$var$sortBps = (breakpoints)=>Object.fromEntries(Object.entries(breakpoints).sort($39e2d87d62de0beb$var$sortByBreakpointValue));
function $39e2d87d62de0beb$var$normalize(breakpoints) {
    const sorted = $39e2d87d62de0beb$var$sortBps(breakpoints);
    return Object.assign(Object.values(sorted), sorted);
}
function $39e2d87d62de0beb$var$keys(breakpoints) {
    const value = Object.keys($39e2d87d62de0beb$var$sortBps(breakpoints));
    return new Set(value);
}
function $39e2d87d62de0beb$var$subtract2(value) {
    var _a;
    if (!value) return value;
    value = (_a = $39e2d87d62de0beb$var$px(value)) != null ? _a : value;
    const OFFSET = -0.02;
    return typeof value === "number" ? `${value + OFFSET}` : value.replace(/(\d+\.?\d*)/u, (m)=>`${parseFloat(m) + OFFSET}`);
}
function $39e2d87d62de0beb$var$toMediaQueryString(min, max) {
    const query = [
        "@media screen"
    ];
    if (min) query.push("and", `(min-width: ${$39e2d87d62de0beb$var$px(min)})`);
    if (max) query.push("and", `(max-width: ${$39e2d87d62de0beb$var$px(max)})`);
    return query.join(" ");
}
function $39e2d87d62de0beb$var$analyzeBreakpoints(breakpoints) {
    var _a;
    if (!breakpoints) return null;
    breakpoints.base = (_a = breakpoints.base) != null ? _a : "0px";
    const normalized = $39e2d87d62de0beb$var$normalize(breakpoints);
    const queries = Object.entries(breakpoints).sort($39e2d87d62de0beb$var$sortByBreakpointValue).map(([breakpoint, minW], index, entry)=>{
        var _a2;
        let [, maxW] = (_a2 = entry[index + 1]) != null ? _a2 : [];
        maxW = parseFloat(maxW) > 0 ? $39e2d87d62de0beb$var$subtract2(maxW) : void 0;
        return {
            _minW: $39e2d87d62de0beb$var$subtract2(minW),
            breakpoint: breakpoint,
            minW: minW,
            maxW: maxW,
            maxWQuery: $39e2d87d62de0beb$var$toMediaQueryString(null, maxW),
            minWQuery: $39e2d87d62de0beb$var$toMediaQueryString(minW),
            minMaxQuery: $39e2d87d62de0beb$var$toMediaQueryString(minW, maxW)
        };
    });
    const _keys = $39e2d87d62de0beb$var$keys(breakpoints);
    const _keysArr = Array.from(_keys.values());
    return {
        keys: _keys,
        normalized: normalized,
        isResponsive (test) {
            const keys2 = Object.keys(test);
            return keys2.length > 0 && keys2.every((key)=>_keys.has(key));
        },
        asObject: $39e2d87d62de0beb$var$sortBps(breakpoints),
        asArray: $39e2d87d62de0beb$var$normalize(breakpoints),
        details: queries,
        get (key) {
            return queries.find((q)=>q.breakpoint === key);
        },
        media: [
            null,
            ...normalized.map((minW)=>$39e2d87d62de0beb$var$toMediaQueryString(minW)).slice(1)
        ],
        /**
     * Converts the object responsive syntax to array syntax
     *
     * @example
     * toArrayValue({ base: 1, sm: 2, md: 3 }) // => [1, 2, 3]
     */ toArrayValue (test) {
            if (!(0, $iyhjB.isObject)(test)) throw new Error("toArrayValue: value must be an object");
            const result = _keysArr.map((bp)=>{
                var _a2;
                return (_a2 = test[bp]) != null ? _a2 : null;
            });
            while($39e2d87d62de0beb$var$getLastItem(result) === null)result.pop();
            return result;
        },
        /**
     * Converts the array responsive syntax to object syntax
     *
     * @example
     * toObjectValue([1, 2, 3]) // => { base: 1, sm: 2, md: 3 }
     */ toObjectValue (test) {
            if (!Array.isArray(test)) throw new Error("toObjectValue: value must be an array");
            return test.reduce((acc, value, index)=>{
                const key = _keysArr[index];
                if (key != null && value != null) acc[key] = value;
                return acc;
            }, {});
        }
    };
}
// src/pseudos.ts
var $39e2d87d62de0beb$var$state = {
    hover: (str, post)=>`${str}:hover ${post}, ${str}[data-hover] ${post}`,
    focus: (str, post)=>`${str}:focus ${post}, ${str}[data-focus] ${post}`,
    focusVisible: (str, post)=>`${str}:focus-visible ${post}`,
    focusWithin: (str, post)=>`${str}:focus-within ${post}`,
    active: (str, post)=>`${str}:active ${post}, ${str}[data-active] ${post}`,
    disabled: (str, post)=>`${str}:disabled ${post}, ${str}[data-disabled] ${post}`,
    invalid: (str, post)=>`${str}:invalid ${post}, ${str}[data-invalid] ${post}`,
    checked: (str, post)=>`${str}:checked ${post}, ${str}[data-checked] ${post}`,
    indeterminate: (str, post)=>`${str}:indeterminate ${post}, ${str}[aria-checked=mixed] ${post}, ${str}[data-indeterminate] ${post}`,
    readOnly: (str, post)=>`${str}:read-only ${post}, ${str}[readonly] ${post}, ${str}[data-read-only] ${post}`,
    expanded: (str, post)=>`${str}:read-only ${post}, ${str}[aria-expanded=true] ${post}, ${str}[data-expanded] ${post}`,
    placeholderShown: (str, post)=>`${str}:placeholder-shown ${post}`
};
var $39e2d87d62de0beb$var$toGroup = (fn)=>$39e2d87d62de0beb$var$merge((v)=>fn(v, "&"), "[role=group]", "[data-group]", ".group");
var $39e2d87d62de0beb$var$toPeer = (fn)=>$39e2d87d62de0beb$var$merge((v)=>fn(v, "~ &"), "[data-peer]", ".peer");
var $39e2d87d62de0beb$var$merge = (fn, ...selectors)=>selectors.map(fn).join(", ");
var $39e2d87d62de0beb$export$a36cf593fde2a546 = {
    /**
   * Styles for CSS selector `&:hover`
   */ _hover: "&:hover, &[data-hover]",
    /**
   * Styles for CSS Selector `&:active`
   */ _active: "&:active, &[data-active]",
    /**
   * Styles for CSS selector `&:focus`
   *
   */ _focus: "&:focus, &[data-focus]",
    /**
   * Styles for the highlighted state.
   */ _highlighted: "&[data-highlighted]",
    /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */ _focusWithin: "&:focus-within",
    /**
   * Styles to apply when this element has received focus via tabbing
   * - CSS Selector `&:focus-visible`
   */ _focusVisible: "&:focus-visible, &[data-focus-visible]",
    /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   * - `&[disabled]`
   */ _disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
    /**
   * Styles for CSS Selector `&:readonly`
   */ _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
    /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */ _before: "&::before",
    /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */ _after: "&::after",
    /**
   * Styles for CSS selector `&:empty`
   */ _empty: "&:empty",
    /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */ _expanded: "&[aria-expanded=true], &[data-expanded]",
    /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */ _checked: "&[aria-checked=true], &[data-checked]",
    /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */ _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
    /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */ _pressed: "&[aria-pressed=true], &[data-pressed]",
    /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */ _invalid: "&[aria-invalid=true], &[data-invalid]",
    /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */ _valid: "&[data-valid], &[data-state=valid]",
    /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */ _loading: "&[data-loading], &[aria-busy=true]",
    /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */ _selected: "&[aria-selected=true], &[data-selected]",
    /**
   * Styles for CSS Selector `[hidden=true]`
   */ _hidden: "&[hidden], &[data-hidden]",
    /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */ _autofill: "&:-webkit-autofill",
    /**
   * Styles for CSS Selector `&:nth-child(even)`
   */ _even: "&:nth-of-type(even)",
    /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */ _odd: "&:nth-of-type(odd)",
    /**
   * Styles for CSS Selector `&:first-of-type`
   */ _first: "&:first-of-type",
    /**
   * Styles for CSS selector `&::first-letter`
   *
   * NOTE: This selector is only applied for block-level elements and not preceded by an image or table.
   * @example
   * ```jsx
   * <Text _firstLetter={{ textDecoration: 'underline' }}>Once upon a time</Text>
   * ```
   */ _firstLetter: "&::first-letter",
    /**
   * Styles for CSS Selector `&:last-of-type`
   */ _last: "&:last-of-type",
    /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */ _notFirst: "&:not(:first-of-type)",
    /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */ _notLast: "&:not(:last-of-type)",
    /**
   * Styles for CSS Selector `&:visited`
   */ _visited: "&:visited",
    /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */ _activeLink: "&[aria-current=page]",
    /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */ _activeStep: "&[aria-current=step]",
    /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */ _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
   */ _groupHover: $39e2d87d62de0beb$var$toGroup($39e2d87d62de0beb$var$state.hover),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
   */ _peerHover: $39e2d87d62de0beb$var$toPeer($39e2d87d62de0beb$var$state.hover),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
   */ _groupFocus: $39e2d87d62de0beb$var$toGroup($39e2d87d62de0beb$var$state.focus),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
   */ _peerFocus: $39e2d87d62de0beb$var$toPeer($39e2d87d62de0beb$var$state.focus),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
   */ _groupFocusVisible: $39e2d87d62de0beb$var$toGroup($39e2d87d62de0beb$var$state.focusVisible),
    /**
   * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
   */ _peerFocusVisible: $39e2d87d62de0beb$var$toPeer($39e2d87d62de0beb$var$state.focusVisible),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
   */ _groupActive: $39e2d87d62de0beb$var$toGroup($39e2d87d62de0beb$var$state.active),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is active
   */ _peerActive: $39e2d87d62de0beb$var$toPeer($39e2d87d62de0beb$var$state.active),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
   */ _groupDisabled: $39e2d87d62de0beb$var$toGroup($39e2d87d62de0beb$var$state.disabled),
    /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
   */ _peerDisabled: $39e2d87d62de0beb$var$toPeer($39e2d87d62de0beb$var$state.disabled),
    /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
   */ _groupInvalid: $39e2d87d62de0beb$var$toGroup($39e2d87d62de0beb$var$state.invalid),
    /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
   */ _peerInvalid: $39e2d87d62de0beb$var$toPeer($39e2d87d62de0beb$var$state.invalid),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
   */ _groupChecked: $39e2d87d62de0beb$var$toGroup($39e2d87d62de0beb$var$state.checked),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
   */ _peerChecked: $39e2d87d62de0beb$var$toPeer($39e2d87d62de0beb$var$state.checked),
    /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
   */ _groupFocusWithin: $39e2d87d62de0beb$var$toGroup($39e2d87d62de0beb$var$state.focusWithin),
    /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
   */ _peerFocusWithin: $39e2d87d62de0beb$var$toPeer($39e2d87d62de0beb$var$state.focusWithin),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
   */ _peerPlaceholderShown: $39e2d87d62de0beb$var$toPeer($39e2d87d62de0beb$var$state.placeholderShown),
    /**
   * Styles for CSS Selector `&::placeholder`.
   */ _placeholder: "&::placeholder",
    /**
   * Styles for CSS Selector `&:placeholder-shown`.
   */ _placeholderShown: "&:placeholder-shown",
    /**
   * Styles for CSS Selector `&:fullscreen`.
   */ _fullScreen: "&:fullscreen",
    /**
   * Styles for CSS Selector `&::selection`
   */ _selection: "&::selection",
    /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when a parent element or this element has `dir="rtl"`
   */ _rtl: "[dir=rtl] &, &[dir=rtl]",
    /**
   * Styles for CSS Selector `[dir=ltr] &`
   * It is applied when a parent element or this element has `dir="ltr"`
   */ _ltr: "[dir=ltr] &, &[dir=ltr]",
    /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * It is used when the user has requested the system use a light or dark color theme.
   */ _mediaDark: "@media (prefers-color-scheme: dark)",
    /**
   * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
   * It is used when the user has requested the system to reduce the amount of animations.
   */ _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
    /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */ _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
    /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */ _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",
    /**
   * Styles for the CSS Selector `&[data-orientation=horizontal]`
   */ _horizontal: "&[data-orientation=horizontal]",
    /**
   * Styles for the CSS Selector `&[data-orientation=vertical]`
   */ _vertical: "&[data-orientation=vertical]"
};
var $39e2d87d62de0beb$export$4ec9644154df43c2 = Object.keys($39e2d87d62de0beb$export$a36cf593fde2a546);
function $39e2d87d62de0beb$var$tokenToCssVar(token, prefix) {
    return $39e2d87d62de0beb$export$8b4981022bd80a4e(String(token).replace(/\./g, "-"), void 0, prefix);
}
function $39e2d87d62de0beb$var$createThemeVars(flatTokens, options) {
    let cssVars = {};
    const cssMap = {};
    for (const [token, tokenValue] of Object.entries(flatTokens)){
        const { isSemantic: isSemantic, value: value } = tokenValue;
        const { variable: variable, reference: reference } = $39e2d87d62de0beb$var$tokenToCssVar(token, options == null ? void 0 : options.cssVarPrefix);
        if (!isSemantic) {
            if (token.startsWith("space")) {
                const keys2 = token.split(".");
                const [firstKey, ...referenceKeys] = keys2;
                const negativeLookupKey = `${firstKey}.-${referenceKeys.join(".")}`;
                const negativeValue = $39e2d87d62de0beb$export$42bfa9b2d4dad91a.negate(value);
                const negatedReference = $39e2d87d62de0beb$export$42bfa9b2d4dad91a.negate(reference);
                cssMap[negativeLookupKey] = {
                    value: negativeValue,
                    var: variable,
                    varRef: negatedReference
                };
            }
            cssVars[variable] = value;
            cssMap[token] = {
                value: value,
                var: variable,
                varRef: reference
            };
            continue;
        }
        const lookupToken = (maybeToken)=>{
            const scale = String(token).split(".")[0];
            const withScale = [
                scale,
                maybeToken
            ].join(".");
            const resolvedTokenValue = flatTokens[withScale];
            if (!resolvedTokenValue) return maybeToken;
            const { reference: reference2 } = $39e2d87d62de0beb$var$tokenToCssVar(withScale, options == null ? void 0 : options.cssVarPrefix);
            return reference2;
        };
        const normalizedValue = (0, $iyhjB.isObject)(value) ? value : {
            default: value
        };
        cssVars = (0, (/*@__PURE__*/$parcel$interopDefault($eltz3)))(cssVars, Object.entries(normalizedValue).reduce((acc, [conditionAlias, conditionValue])=>{
            var _a, _b;
            if (!conditionValue) return acc;
            const tokenReference = lookupToken(`${conditionValue}`);
            if (conditionAlias === "default") {
                acc[variable] = tokenReference;
                return acc;
            }
            const conditionSelector = (_b = (_a = $39e2d87d62de0beb$export$a36cf593fde2a546) == null ? void 0 : _a[conditionAlias]) != null ? _b : conditionAlias;
            acc[conditionSelector] = {
                [variable]: tokenReference
            };
            return acc;
        }, {}));
        cssMap[token] = {
            value: reference,
            var: variable,
            varRef: reference
        };
    }
    return {
        cssVars: cssVars,
        cssMap: cssMap
    };
}
// ../../utilities/object-utils/src/omit.ts
function $39e2d87d62de0beb$var$omit(object, keysToOmit = []) {
    const clone = Object.assign({}, object);
    for (const key of keysToOmit)if (key in clone) delete clone[key];
    return clone;
}
// ../../utilities/object-utils/src/pick.ts
function $39e2d87d62de0beb$var$pick(object, keysToPick) {
    const result = {};
    for (const key of keysToPick)if (key in object) result[key] = object[key];
    return result;
}
// ../../utilities/object-utils/src/walk-object.ts
function $39e2d87d62de0beb$var$isObject5(value) {
    return typeof value === "object" && value != null && !Array.isArray(value);
}
function $39e2d87d62de0beb$var$walkObject(target, predicate, options = {}) {
    const { stop: stop, getKey: getKey } = options;
    function inner(value, path = []) {
        var _a;
        if ($39e2d87d62de0beb$var$isObject5(value) || Array.isArray(value)) {
            const result = {};
            for (const [prop, child] of Object.entries(value)){
                const key = (_a = getKey == null ? void 0 : getKey(prop)) != null ? _a : prop;
                const childPath = [
                    ...path,
                    key
                ];
                if (stop == null ? void 0 : stop(value, childPath)) return predicate(value, path);
                result[key] = inner(child, childPath);
            }
            return result;
        }
        return predicate(value, path);
    }
    return inner(target);
}
// src/create-theme-vars/theme-tokens.ts
var $39e2d87d62de0beb$var$tokens = [
    "colors",
    "borders",
    "borderWidths",
    "borderStyles",
    "fonts",
    "fontSizes",
    "fontWeights",
    "gradients",
    "letterSpacings",
    "lineHeights",
    "radii",
    "space",
    "shadows",
    "sizes",
    "zIndices",
    "transition",
    "blur",
    "breakpoints"
];
function $39e2d87d62de0beb$var$extractTokens(theme) {
    const _tokens = $39e2d87d62de0beb$var$tokens;
    return $39e2d87d62de0beb$var$pick(theme, _tokens);
}
function $39e2d87d62de0beb$var$extractSemanticTokens(theme) {
    return theme.semanticTokens;
}
function $39e2d87d62de0beb$var$omitVars(rawTheme) {
    const { __cssMap: __cssMap, __cssVars: __cssVars, __breakpoints: __breakpoints, ...cleanTheme } = rawTheme;
    return cleanTheme;
}
// src/create-theme-vars/flatten-tokens.ts
var $39e2d87d62de0beb$var$isSemanticCondition = (key)=>$39e2d87d62de0beb$export$4ec9644154df43c2.includes(key) || "default" === key;
function $39e2d87d62de0beb$export$8f520cff3dbc4769({ tokens: tokens2, semanticTokens: semanticTokens }) {
    const result = {};
    $39e2d87d62de0beb$var$walkObject(tokens2, (value, path)=>{
        if (value == null) return;
        result[path.join(".")] = {
            isSemantic: false,
            value: value
        };
    });
    $39e2d87d62de0beb$var$walkObject(semanticTokens, (value, path)=>{
        if (value == null) return;
        result[path.join(".")] = {
            isSemantic: true,
            value: value
        };
    }, {
        stop: (value)=>Object.keys(value).every($39e2d87d62de0beb$var$isSemanticCondition)
    });
    return result;
}
// src/create-theme-vars/to-css-var.ts
function $39e2d87d62de0beb$export$d4e5dc2a444c0164(rawTheme) {
    var _a;
    const theme = $39e2d87d62de0beb$var$omitVars(rawTheme);
    const tokens2 = $39e2d87d62de0beb$var$extractTokens(theme);
    const semanticTokens = $39e2d87d62de0beb$var$extractSemanticTokens(theme);
    const flatTokens = $39e2d87d62de0beb$export$8f520cff3dbc4769({
        tokens: tokens2,
        semanticTokens: semanticTokens
    });
    const cssVarPrefix = (_a = theme.config) == null ? void 0 : _a.cssVarPrefix;
    const { cssMap: /**
     * This is more like a dictionary of tokens users will type `green.500`,
     * and their equivalent css variable.
     */ cssMap, cssVars: /**
     * The extracted css variables will be stored here, and used in
     * the emotion's <Global/> component to attach variables to `:root`
     */ cssVars } = $39e2d87d62de0beb$var$createThemeVars(flatTokens, {
        cssVarPrefix: cssVarPrefix
    });
    const defaultCssVars = {
        "--chakra-ring-inset": "var(--chakra-empty,/*!*/ /*!*/)",
        "--chakra-ring-offset-width": "0px",
        "--chakra-ring-offset-color": "#fff",
        "--chakra-ring-color": "rgba(66, 153, 225, 0.6)",
        "--chakra-ring-offset-shadow": "0 0 #0000",
        "--chakra-ring-shadow": "0 0 #0000",
        "--chakra-space-x-reverse": "0",
        "--chakra-space-y-reverse": "0"
    };
    Object.assign(theme, {
        __cssVars: {
            ...defaultCssVars,
            ...cssVars
        },
        __cssMap: cssMap,
        __breakpoints: $39e2d87d62de0beb$var$analyzeBreakpoints(theme.breakpoints)
    });
    return theme;
}
var $39e2d87d62de0beb$export$30cfa87a708babfc = (0, (/*@__PURE__*/$parcel$interopDefault($eltz3)))({}, $39e2d87d62de0beb$export$8ce1fd94bee2f412, $39e2d87d62de0beb$export$1edee58a52776cd9, $39e2d87d62de0beb$export$35e9368ef982300f, $39e2d87d62de0beb$export$feec61708a55c80e, $39e2d87d62de0beb$export$b3219800bda33a1f, $39e2d87d62de0beb$export$3dea766d36a8935f, $39e2d87d62de0beb$export$e7d0da6968da5dd, $39e2d87d62de0beb$export$2499a341a8256d68, $39e2d87d62de0beb$export$85fc379452d91af0, $39e2d87d62de0beb$export$36263e8f8d7ce3b1, $39e2d87d62de0beb$export$5880b8b5730aff45, $39e2d87d62de0beb$export$dc573d8a6576cdb3, $39e2d87d62de0beb$export$a941ed4b947d12f8, $39e2d87d62de0beb$export$209876d7b1ac8f3, $39e2d87d62de0beb$export$d846a084e680d8e, $39e2d87d62de0beb$export$6b7f9af9aa033040, $39e2d87d62de0beb$export$51186ad6e864892a, $39e2d87d62de0beb$export$8837f4fc672e936d, $39e2d87d62de0beb$export$66bb15e2994e6a26);
var $39e2d87d62de0beb$var$layoutSystem = Object.assign({}, $39e2d87d62de0beb$export$a941ed4b947d12f8, $39e2d87d62de0beb$export$b3219800bda33a1f, $39e2d87d62de0beb$export$feec61708a55c80e, $39e2d87d62de0beb$export$85fc379452d91af0, $39e2d87d62de0beb$export$5880b8b5730aff45);
var $39e2d87d62de0beb$export$bccb7c6ca2f4f912 = Object.keys($39e2d87d62de0beb$var$layoutSystem);
var $39e2d87d62de0beb$export$332cc7004bcbb8b4 = [
    ...Object.keys($39e2d87d62de0beb$export$30cfa87a708babfc),
    ...$39e2d87d62de0beb$export$4ec9644154df43c2
];
var $39e2d87d62de0beb$var$styleProps = {
    ...$39e2d87d62de0beb$export$30cfa87a708babfc,
    ...$39e2d87d62de0beb$export$a36cf593fde2a546
};
var $39e2d87d62de0beb$export$95b76554d0cd12d6 = (prop)=>prop in $39e2d87d62de0beb$var$styleProps;
var $39e2d87d62de0beb$var$expandResponsive = (styles)=>(theme)=>{
        if (!theme.__breakpoints) return styles;
        const { isResponsive: isResponsive, toArrayValue: toArrayValue, media: medias } = theme.__breakpoints;
        const computedStyles = {};
        for(const key in styles){
            let value = (0, $iyhjB.runIfFn)(styles[key], theme);
            if (value == null) continue;
            value = (0, $iyhjB.isObject)(value) && isResponsive(value) ? toArrayValue(value) : value;
            if (!Array.isArray(value)) {
                computedStyles[key] = value;
                continue;
            }
            const queries = value.slice(0, medias.length).length;
            for(let index = 0; index < queries; index += 1){
                const media = medias == null ? void 0 : medias[index];
                if (!media) {
                    computedStyles[key] = value[index];
                    continue;
                }
                computedStyles[media] = computedStyles[media] || {};
                if (value[index] == null) continue;
                computedStyles[media][key] = value[index];
            }
        }
        return computedStyles;
    };
// src/utils/split-by-comma.ts
function $39e2d87d62de0beb$var$splitByComma(value) {
    const chunks = [];
    let chunk = "";
    let inParens = false;
    for(let i = 0; i < value.length; i++){
        const char = value[i];
        if (char === "(") {
            inParens = true;
            chunk += char;
        } else if (char === ")") {
            inParens = false;
            chunk += char;
        } else if (char === "," && !inParens) {
            chunks.push(chunk);
            chunk = "";
        } else chunk += char;
    }
    chunk = chunk.trim();
    if (chunk) chunks.push(chunk);
    return chunks;
}
// src/css.ts
function $39e2d87d62de0beb$var$isCssVar2(value) {
    return /^var\(--.+\)$/.test(value);
}
var $39e2d87d62de0beb$var$isCSSVariableTokenValue = (key, value)=>key.startsWith("--") && typeof value === "string" && !$39e2d87d62de0beb$var$isCssVar2(value);
var $39e2d87d62de0beb$var$resolveTokenValue = (theme, value)=>{
    var _a, _b;
    if (value == null) return value;
    const getVar = (val)=>{
        var _a2, _b2;
        return (_b2 = (_a2 = theme.__cssMap) == null ? void 0 : _a2[val]) == null ? void 0 : _b2.varRef;
    };
    const getValue = (val)=>{
        var _a2;
        return (_a2 = getVar(val)) != null ? _a2 : val;
    };
    const [tokenValue, fallbackValue] = $39e2d87d62de0beb$var$splitByComma(value);
    value = (_b = (_a = getVar(tokenValue)) != null ? _a : getValue(fallbackValue)) != null ? _b : getValue(value);
    return value;
};
function $39e2d87d62de0beb$export$955358618f994a11(options) {
    const { configs: configs = {}, pseudos: pseudos = {}, theme: theme } = options;
    const css2 = (stylesOrFn, nested = false)=>{
        var _a, _b, _c;
        const _styles = (0, $iyhjB.runIfFn)(stylesOrFn, theme);
        const styles = $39e2d87d62de0beb$var$expandResponsive(_styles)(theme);
        let computedStyles = {};
        for(let key in styles){
            const valueOrFn = styles[key];
            let value = (0, $iyhjB.runIfFn)(valueOrFn, theme);
            if (key in pseudos) key = pseudos[key];
            if ($39e2d87d62de0beb$var$isCSSVariableTokenValue(key, value)) value = $39e2d87d62de0beb$var$resolveTokenValue(theme, value);
            let config = configs[key];
            if (config === true) config = {
                property: key
            };
            if ((0, $iyhjB.isObject)(value)) {
                computedStyles[key] = (_a = computedStyles[key]) != null ? _a : {};
                computedStyles[key] = (0, (/*@__PURE__*/$parcel$interopDefault($eltz3)))({}, computedStyles[key], css2(value, true));
                continue;
            }
            let rawValue = (_c = (_b = config == null ? void 0 : config.transform) == null ? void 0 : _b.call(config, value, theme, _styles)) != null ? _c : value;
            rawValue = (config == null ? void 0 : config.processResult) ? css2(rawValue, true) : rawValue;
            const configProperty = (0, $iyhjB.runIfFn)(config == null ? void 0 : config.property, theme);
            if (!nested && (config == null ? void 0 : config.static)) {
                const staticStyles = (0, $iyhjB.runIfFn)(config.static, theme);
                computedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($eltz3)))({}, computedStyles, staticStyles);
            }
            if (configProperty && Array.isArray(configProperty)) {
                for (const property of configProperty)computedStyles[property] = rawValue;
                continue;
            }
            if (configProperty) {
                if (configProperty === "&" && (0, $iyhjB.isObject)(rawValue)) computedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($eltz3)))({}, computedStyles, rawValue);
                else computedStyles[configProperty] = rawValue;
                continue;
            }
            if ((0, $iyhjB.isObject)(rawValue)) {
                computedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($eltz3)))({}, computedStyles, rawValue);
                continue;
            }
            computedStyles[key] = rawValue;
        }
        return computedStyles;
    };
    return css2;
}
var $39e2d87d62de0beb$export$dbf350e5966cf602 = (styles)=>(theme)=>{
        const cssFn = $39e2d87d62de0beb$export$955358618f994a11({
            theme: theme,
            pseudos: $39e2d87d62de0beb$export$a36cf593fde2a546,
            configs: $39e2d87d62de0beb$export$30cfa87a708babfc
        });
        return cssFn(styles);
    };
// src/define-styles.ts
function $39e2d87d62de0beb$export$9a6b93c1c4f92839(styles) {
    return styles;
}
function $39e2d87d62de0beb$export$5c9a64458a4ed8a4(config) {
    return config;
}
function $39e2d87d62de0beb$export$d5f717dc145477b8(parts) {
    return {
        definePartsStyle (config) {
            return config;
        },
        defineMultiStyleConfig (config) {
            return {
                parts: parts,
                ...config
            };
        }
    };
}
function $39e2d87d62de0beb$var$normalize2(value, toArray) {
    if (Array.isArray(value)) return value;
    if ((0, $iyhjB.isObject)(value)) return toArray(value);
    if (value != null) return [
        value
    ];
}
function $39e2d87d62de0beb$var$getNextIndex(values, i) {
    for(let j = i + 1; j < values.length; j++){
        if (values[j] != null) return j;
    }
    return -1;
}
function $39e2d87d62de0beb$var$createResolver(theme) {
    const breakpointUtil = theme.__breakpoints;
    return function resolver(config, prop, value, props) {
        var _a, _b;
        if (!breakpointUtil) return;
        const result = {};
        const normalized = $39e2d87d62de0beb$var$normalize2(value, breakpointUtil.toArrayValue);
        if (!normalized) return result;
        const len = normalized.length;
        const isSingle = len === 1;
        const isMultipart = !!config.parts;
        for(let i = 0; i < len; i++){
            const key = breakpointUtil.details[i];
            const nextKey = breakpointUtil.details[$39e2d87d62de0beb$var$getNextIndex(normalized, i)];
            const query = $39e2d87d62de0beb$var$toMediaQueryString(key.minW, nextKey == null ? void 0 : nextKey._minW);
            const styles = (0, $iyhjB.runIfFn)((_a = config[prop]) == null ? void 0 : _a[normalized[i]], props);
            if (!styles) continue;
            if (isMultipart) {
                (_b = config.parts) == null || _b.forEach((part)=>{
                    (0, (/*@__PURE__*/$parcel$interopDefault($eltz3)))(result, {
                        [part]: isSingle ? styles[part] : {
                            [query]: styles[part]
                        }
                    });
                });
                continue;
            }
            if (!isMultipart) {
                if (isSingle) (0, (/*@__PURE__*/$parcel$interopDefault($eltz3)))(result, styles);
                else result[query] = styles;
                continue;
            }
            result[query] = styles;
        }
        return result;
    };
}
function $39e2d87d62de0beb$export$f94106bbb00e81eb(config) {
    return (props)=>{
        var _a;
        const { variant: variant, size: size, theme: theme } = props;
        const recipe = $39e2d87d62de0beb$var$createResolver(theme);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eltz3)))({}, (0, $iyhjB.runIfFn)((_a = config.baseStyle) != null ? _a : {}, props), recipe(config, "sizes", size, props), recipe(config, "variants", variant, props));
    };
}
// src/get-css-var.ts
function $39e2d87d62de0beb$export$93c8e06b7014dc33(theme, scale, value) {
    var _a, _b, _c;
    return (_c = (_b = (_a = theme.__cssMap) == null ? void 0 : _a[`${scale}.${value}`]) == null ? void 0 : _b.varRef) != null ? _c : value;
}
// src/theming-props.ts
function $39e2d87d62de0beb$export$adfcf5a5e4d17785(props) {
    return $39e2d87d62de0beb$var$omit(props, [
        "styleConfig",
        "size",
        "variant",
        "colorScheme"
    ]);
}

});


parcelRegister("ioRKz", function(module, exports) {

$parcel$export(module.exports, "ColorModeContext", () => $3a3070410c1afae6$export$49ddd74a6729fdb0);
$parcel$export(module.exports, "useColorMode", () => $3a3070410c1afae6$export$20f3076712c8dfa);

var $3qjKr = parcelRequire("3qjKr");
"use client";
var $3a3070410c1afae6$export$49ddd74a6729fdb0 = (0, $3qjKr.createContext)({});
$3a3070410c1afae6$export$49ddd74a6729fdb0.displayName = "ColorModeContext";
function $3a3070410c1afae6$export$20f3076712c8dfa() {
    const context = (0, $3qjKr.useContext)($3a3070410c1afae6$export$49ddd74a6729fdb0);
    if (context === void 0) throw new Error("useColorMode must be used within a ColorModeProvider");
    return context;
}
function $3a3070410c1afae6$export$d18f2ef57b0d7644(light, dark) {
    const { colorMode: colorMode } = $3a3070410c1afae6$export$20f3076712c8dfa();
    return colorMode === "dark" ? dark : light;
}

});

parcelRegister("6SrEO", function(module, exports) {

$parcel$export(module.exports, "omit", () => $f250795597b0eee1$export$30a06c8d3562193f);
$parcel$export(module.exports, "memoizedGet", () => $f250795597b0eee1$export$1bb32d0c65da6059);
$parcel$export(module.exports, "objectFilter", () => $f250795597b0eee1$export$3417cf6417437960);
$parcel$export(module.exports, "filterUndefined", () => $f250795597b0eee1$export$2458ce75c8ef9806);
// src/object.ts

var $eltz3 = parcelRequire("eltz3");
function $f250795597b0eee1$export$30a06c8d3562193f(object, keys) {
    const result = {};
    Object.keys(object).forEach((key)=>{
        if (keys.includes(key)) return;
        result[key] = object[key];
    });
    return result;
}
function $f250795597b0eee1$export$357523c63a2253b9(object, keys) {
    const result = {};
    keys.forEach((key)=>{
        if (key in object) result[key] = object[key];
    });
    return result;
}
function $f250795597b0eee1$export$65980d18b75784e2(object, keys) {
    const picked = {};
    const omitted = {};
    Object.keys(object).forEach((key)=>{
        if (keys.includes(key)) picked[key] = object[key];
        else omitted[key] = object[key];
    });
    return [
        picked,
        omitted
    ];
}
function $f250795597b0eee1$export$3988ae62b71be9a3(obj, path, fallback, index) {
    const key = typeof path === "string" ? path.split(".") : [
        path
    ];
    for(index = 0; index < key.length; index += 1){
        if (!obj) break;
        obj = obj[key[index]];
    }
    return obj === void 0 ? fallback : obj;
}
var $f250795597b0eee1$export$fc10aeed3a532e2a = (fn)=>{
    const cache = /* @__PURE__ */ new WeakMap();
    const memoizedFn = (obj, path, fallback, index)=>{
        if (typeof obj === "undefined") return fn(obj, path, fallback);
        if (!cache.has(obj)) cache.set(obj, /* @__PURE__ */ new Map());
        const map = cache.get(obj);
        if (map.has(path)) return map.get(path);
        const value = fn(obj, path, fallback, index);
        map.set(path, value);
        return value;
    };
    return memoizedFn;
};
var $f250795597b0eee1$export$1bb32d0c65da6059 = $f250795597b0eee1$export$fc10aeed3a532e2a($f250795597b0eee1$export$3988ae62b71be9a3);
function $f250795597b0eee1$export$73b8ef55a37133c7(path, scale) {
    return $f250795597b0eee1$export$1bb32d0c65da6059(scale, path, path);
}
function $f250795597b0eee1$export$3417cf6417437960(object, fn) {
    const result = {};
    Object.keys(object).forEach((key)=>{
        const value = object[key];
        const shouldPass = fn(value, key, object);
        if (shouldPass) result[key] = value;
    });
    return result;
}
var $f250795597b0eee1$export$2458ce75c8ef9806 = (object)=>$f250795597b0eee1$export$3417cf6417437960(object, (val)=>val !== null && val !== void 0);
var $f250795597b0eee1$export$259b4dd69e654a7a = (obj)=>Object.keys(obj);
var $f250795597b0eee1$export$5150077fc2e7c662 = (entries)=>entries.reduce((carry, [key, value])=>{
        carry[key] = value;
        return carry;
    }, {});
var $f250795597b0eee1$export$93c8e06b7014dc33 = (theme, scale, value)=>{
    var _a, _b, _c;
    return (_c = (_b = (_a = theme.__cssMap) == null ? void 0 : _a[`${scale}.${value}`]) == null ? void 0 : _b.varRef) != null ? _c : value;
};

});

parcelRegister("747z2", function(module, exports) {

$parcel$export(module.exports, "runIfFn", () => $eaa31dde8c6f9e76$export$624e501d81f5ffce);

var $huisO = parcelRequire("huisO");
// src/function.ts
function $eaa31dde8c6f9e76$export$624e501d81f5ffce(valueOrFn, ...args) {
    return (0, $huisO.isFunction)(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
function $eaa31dde8c6f9e76$export$5bdd3f730ec2c47e(...fns) {
    return function func(event) {
        fns.some((fn)=>{
            fn == null || fn(event);
            return event == null ? void 0 : event.defaultPrevented;
        });
    };
}
function $eaa31dde8c6f9e76$export$9dd9a52f2dd5b9ce(...fns) {
    return function mergedFn(arg) {
        fns.forEach((fn)=>{
            fn == null || fn(arg);
        });
    };
}
var $eaa31dde8c6f9e76$export$f672e0b6f7222cd7 = (fn1, ...fns)=>fns.reduce((f1, f2)=>(...args)=>f1(f2(...args)), fn1);
function $eaa31dde8c6f9e76$export$d2de3aaeafa91619(fn) {
    let result;
    return function func(...args) {
        if (fn) {
            result = fn.apply(this, args);
            fn = null;
        }
        return result;
    };
}
var $eaa31dde8c6f9e76$export$8793edee2d425525 = ()=>{};
var $eaa31dde8c6f9e76$export$c106dd0671a0fc2d = /* @__PURE__ */ $eaa31dde8c6f9e76$export$d2de3aaeafa91619((options)=>()=>{
        const { condition: condition, message: message } = options;
        if (condition && (0, $huisO.__DEV__)) console.warn(message);
    });
var $eaa31dde8c6f9e76$export$a3bc9b8ed74fc = /* @__PURE__ */ $eaa31dde8c6f9e76$export$d2de3aaeafa91619((options)=>()=>{
        const { condition: condition, message: message } = options;
        if (condition && (0, $huisO.__DEV__)) console.error(message);
    });
var $eaa31dde8c6f9e76$export$a4627e546088548d = (...fns)=>(v)=>fns.reduce((a, b)=>b(a), v);
var $eaa31dde8c6f9e76$var$distance1D = (a, b)=>Math.abs(a - b);
var $eaa31dde8c6f9e76$var$isPoint = (point)=>"x" in point && "y" in point;
function $eaa31dde8c6f9e76$export$9f17032d917177de(a, b) {
    if ((0, $huisO.isNumber)(a) && (0, $huisO.isNumber)(b)) return $eaa31dde8c6f9e76$var$distance1D(a, b);
    if ($eaa31dde8c6f9e76$var$isPoint(a) && $eaa31dde8c6f9e76$var$isPoint(b)) {
        const xDelta = $eaa31dde8c6f9e76$var$distance1D(a.x, b.x);
        const yDelta = $eaa31dde8c6f9e76$var$distance1D(a.y, b.y);
        return Math.sqrt(xDelta ** 2 + yDelta ** 2);
    }
    return 0;
}

});
parcelRegister("huisO", function(module, exports) {

$parcel$export(module.exports, "isNumber", () => $c7205418d50bb471$export$7e4aa119212bc614);
$parcel$export(module.exports, "isFunction", () => $c7205418d50bb471$export$f6e2535fb5126e54);
$parcel$export(module.exports, "__DEV__", () => $c7205418d50bb471$export$a866f231438cc228);
// src/assertion.ts
function $c7205418d50bb471$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}
function $c7205418d50bb471$export$3f283ac14831e759(value) {
    return typeof value !== "number" || Number.isNaN(value) || !Number.isFinite(value);
}
function $c7205418d50bb471$export$e90fb89750dba83f(value) {
    return value != null && value - parseFloat(value) + 1 >= 0;
}
function $c7205418d50bb471$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $c7205418d50bb471$export$4c0262a4f954db45(value) {
    return $c7205418d50bb471$export$43bee75e5e14138e(value) && value.length === 0;
}
function $c7205418d50bb471$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
function $c7205418d50bb471$export$4e62c701997796c1(value) {
    return typeof value !== "undefined" && value !== void 0;
}
function $c7205418d50bb471$export$fce6876652108ab(value) {
    return typeof value === "undefined" || value === void 0;
}
function $c7205418d50bb471$export$a6cdc56e425d0d0a(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function") && !$c7205418d50bb471$export$43bee75e5e14138e(value);
}
function $c7205418d50bb471$export$83b788b1a3698c03(value) {
    return $c7205418d50bb471$export$a6cdc56e425d0d0a(value) && Object.keys(value).length === 0;
}
function $c7205418d50bb471$export$e0287cc73292b477(value) {
    return value && !$c7205418d50bb471$export$83b788b1a3698c03(value);
}
function $c7205418d50bb471$export$630801d484da15df(value) {
    return value == null;
}
function $c7205418d50bb471$export$844ec244b1367d54(value) {
    return Object.prototype.toString.call(value) === "[object String]";
}
function $c7205418d50bb471$export$30a9abfd5fb9f5f6(value) {
    return /^var\(--.+\)$/.test(value);
}
function $c7205418d50bb471$export$dd1bc94b04021eeb(value) {
    if ($c7205418d50bb471$export$43bee75e5e14138e(value)) return $c7205418d50bb471$export$4c0262a4f954db45(value);
    if ($c7205418d50bb471$export$a6cdc56e425d0d0a(value)) return $c7205418d50bb471$export$83b788b1a3698c03(value);
    if (value == null || value === "") return true;
    return false;
}
var $c7205418d50bb471$export$a866f231438cc228 = false;
var $c7205418d50bb471$export$61cb32cff9a99948 = false;
function $c7205418d50bb471$export$dedd81df7bc1307(val) {
    return "current" in val;
}
function $c7205418d50bb471$export$4215e022093e324e(value) {
    return value && $c7205418d50bb471$export$a6cdc56e425d0d0a(value) && $c7205418d50bb471$export$a6cdc56e425d0d0a(value.target);
}

});


parcelRegister("4duK8", function(module, exports) {

$parcel$export(module.exports, "assignAfter", () => $f9ea955ac62c4c7f$export$1ab078c80230a125);
// src/assign-after.ts
function $f9ea955ac62c4c7f$export$1ab078c80230a125(target, ...sources) {
    if (target == null) throw new TypeError("Cannot convert undefined or null to object");
    const result = {
        ...target
    };
    for (const nextSource of sources){
        if (nextSource == null) continue;
        for(const nextKey in nextSource){
            if (!Object.prototype.hasOwnProperty.call(nextSource, nextKey)) continue;
            if (nextKey in result) delete result[nextKey];
            result[nextKey] = nextSource[nextKey];
        }
    }
    return result;
}

});

parcelRegister("5A90g", function(module, exports) {

$parcel$export(module.exports, "default", () => $41074c6bbe579b70$export$2e2bcd8739ae039);

var $dZuME = parcelRequire("dZuME");
parcelRequire("lG10Y");
parcelRequire("3qjKr");
parcelRequire("b4s3s");

parcelRequire("9RMP2");
parcelRequire("4yPgu");
parcelRequire("iTMjm");
var $41074c6bbe579b70$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $41074c6bbe579b70$export$2e2bcd8739ae039 = (0, $dZuME.default).bind();
$41074c6bbe579b70$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $41074c6bbe579b70$export$2e2bcd8739ae039[tagName] = $41074c6bbe579b70$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("dZuME", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2f8d9dbaae11dc0$export$2e2bcd8739ae039);

var $50wIY = parcelRequire("50wIY");

var $3qjKr = parcelRequire("3qjKr");

var $b4s3s = parcelRequire("b4s3s");
parcelRequire("8ka9R");
var $36iMe = parcelRequire("36iMe");

var $9RMP2 = parcelRequire("9RMP2");

var $4yPgu = parcelRequire("4yPgu");

var $iTMjm = parcelRequire("iTMjm");
var $a2f8d9dbaae11dc0$var$testOmitPropsOnStringTag = (0, $b4s3s.default);
var $a2f8d9dbaae11dc0$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $a2f8d9dbaae11dc0$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $a2f8d9dbaae11dc0$var$testOmitPropsOnStringTag : $a2f8d9dbaae11dc0$var$testOmitPropsOnComponent;
};
var $a2f8d9dbaae11dc0$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $a2f8d9dbaae11dc0$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $a2f8d9dbaae11dc0$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $9RMP2.registerStyles)(cache, serialized, isStringTag);
    (0, $iTMjm.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $9RMP2.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $a2f8d9dbaae11dc0$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $a2f8d9dbaae11dc0$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $a2f8d9dbaae11dc0$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $36iMe.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $3qjKr.useContext((0, $36iMe.T));
            }
            if (typeof props.className === "string") className = (0, $9RMP2.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $4yPgu.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $a2f8d9dbaae11dc0$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $3qjKr.createElement($3qjKr.Fragment, null, /*#__PURE__*/ $3qjKr.createElement($a2f8d9dbaae11dc0$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $3qjKr.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $50wIY.default)({}, options, nextOptions, {
                shouldForwardProp: $a2f8d9dbaae11dc0$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("50wIY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a565638dc604118$export$2e2bcd8739ae039);
function $3a565638dc604118$export$2e2bcd8739ae039() {
    $3a565638dc604118$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3a565638dc604118$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("b4s3s", function(module, exports) {

$parcel$export(module.exports, "default", () => $80f5d4822adfd7d8$export$2e2bcd8739ae039);

var $kT3TQ = parcelRequire("kT3TQ");
var $80f5d4822adfd7d8$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $80f5d4822adfd7d8$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $kT3TQ.default)(function(prop) {
    return $80f5d4822adfd7d8$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("kT3TQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f34bf81ef08a3ea4$export$2e2bcd8739ae039);
function $f34bf81ef08a3ea4$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("8ka9R", function(module, exports) {

$parcel$export(module.exports, "Global", () => $60f8122b8055edc3$export$98f03c5d19621d70);
$parcel$export(module.exports, "keyframes", () => $60f8122b8055edc3$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("36iMe")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("36iMe")).w);

var $36iMe = parcelRequire("36iMe");

var $3qjKr = parcelRequire("3qjKr");

var $9RMP2 = parcelRequire("9RMP2");

var $iTMjm = parcelRequire("iTMjm");

var $4yPgu = parcelRequire("4yPgu");
parcelRequire("3Elrg");
parcelRequire("lG10Y");
parcelRequire("5Fefb");

parcelRequire("i7wrp");
var $60f8122b8055edc3$var$pkg = {
    name: "@emotion/react",
    version: "11.11.3",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $60f8122b8055edc3$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $36iMe.h).call(props, "css")) // $FlowFixMe
    return $3qjKr.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $36iMe.E);
    createElementArgArray[1] = (0, $36iMe.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $3qjKr.createElement.apply(null, createElementArgArray);
};
var $60f8122b8055edc3$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $60f8122b8055edc3$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $36iMe.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $4yPgu.serializeStyles)([
        styles
    ], undefined, $3qjKr.useContext((0, $36iMe.T)));
    if (!(0, $36iMe.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $3qjKr.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $3qjKr.useRef();
    (0, $iTMjm.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $iTMjm.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $9RMP2.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $60f8122b8055edc3$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $4yPgu.serializeStyles)(args);
}
var $60f8122b8055edc3$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $60f8122b8055edc3$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $60f8122b8055edc3$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $60f8122b8055edc3$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $9RMP2.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $60f8122b8055edc3$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $iTMjm.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $9RMP2.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $60f8122b8055edc3$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $36iMe.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $4yPgu.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $9RMP2.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $60f8122b8055edc3$var$merge(cache.registered, css, $60f8122b8055edc3$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $3qjKr.useContext((0, $36iMe.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $3qjKr.createElement($3qjKr.Fragment, null, /*#__PURE__*/ $3qjKr.createElement($60f8122b8055edc3$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $60f8122b8055edc3$var$isBrowser, $60f8122b8055edc3$var$isTestEnv, $60f8122b8055edc3$var$globalContext, $60f8122b8055edc3$var$globalKey;

});
parcelRegister("36iMe", function(module, exports) {

$parcel$export(module.exports, "i", () => $24207f56613a46c9$export$23f2a1d2818174ef);
$parcel$export(module.exports, "h", () => $24207f56613a46c9$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "w", () => $24207f56613a46c9$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $24207f56613a46c9$export$971d5caa766a69d7);
$parcel$export(module.exports, "a", () => $24207f56613a46c9$export$407448d2b89b1813);
$parcel$export(module.exports, "c", () => $24207f56613a46c9$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $24207f56613a46c9$export$a9c23c6ac3fc3eca);

var $3qjKr = parcelRequire("3qjKr");

var $3Elrg = parcelRequire("3Elrg");

var $50wIY = parcelRequire("50wIY");

var $5Fefb = parcelRequire("5Fefb");

var $6p6Dg = parcelRequire("6p6Dg");

var $9RMP2 = parcelRequire("9RMP2");

var $4yPgu = parcelRequire("4yPgu");

var $iTMjm = parcelRequire("iTMjm");
var $24207f56613a46c9$export$23f2a1d2818174ef = true;
var $24207f56613a46c9$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $24207f56613a46c9$var$EmotionCacheContext = /* #__PURE__ */ $3qjKr.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $3Elrg.default)({
    key: "css"
}) : null);
var $24207f56613a46c9$export$e7094788287c5e9b = $24207f56613a46c9$var$EmotionCacheContext.Provider;
var $24207f56613a46c9$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $3qjKr.useContext)($24207f56613a46c9$var$EmotionCacheContext);
};
var $24207f56613a46c9$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $3qjKr.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $3qjKr.useContext)($24207f56613a46c9$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$24207f56613a46c9$export$23f2a1d2818174ef) $24207f56613a46c9$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $3qjKr.useContext)($24207f56613a46c9$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $3Elrg.default)({
                key: "css"
            });
            return /*#__PURE__*/ $3qjKr.createElement($24207f56613a46c9$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $24207f56613a46c9$export$971d5caa766a69d7 = /* #__PURE__ */ $3qjKr.createContext({});
var $24207f56613a46c9$export$3b14a55fb2447963 = function useTheme() {
    return $3qjKr.useContext($24207f56613a46c9$export$971d5caa766a69d7);
};
var $24207f56613a46c9$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $50wIY.default)({}, outerTheme, theme);
};
var $24207f56613a46c9$var$createCacheWithTheme = /* #__PURE__ */ (0, $5Fefb.default)(function(outerTheme) {
    return (0, $5Fefb.default)(function(theme) {
        return $24207f56613a46c9$var$getTheme(outerTheme, theme);
    });
});
var $24207f56613a46c9$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $3qjKr.useContext($24207f56613a46c9$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $24207f56613a46c9$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $3qjKr.createElement($24207f56613a46c9$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $24207f56613a46c9$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $3qjKr.useContext($24207f56613a46c9$export$971d5caa766a69d7);
        return /*#__PURE__*/ $3qjKr.createElement(Component, (0, $50wIY.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $3qjKr.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $6p6Dg.default)(WithTheme, Component);
}
var $24207f56613a46c9$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $24207f56613a46c9$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $24207f56613a46c9$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $24207f56613a46c9$var$getLastPart(match[1]);
    return undefined;
};
var $24207f56613a46c9$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $24207f56613a46c9$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $24207f56613a46c9$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $24207f56613a46c9$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($24207f56613a46c9$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $24207f56613a46c9$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $24207f56613a46c9$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $24207f56613a46c9$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $24207f56613a46c9$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($24207f56613a46c9$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$24207f56613a46c9$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $24207f56613a46c9$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $9RMP2.registerStyles)(cache, serialized, isStringTag);
    (0, $iTMjm.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $9RMP2.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $24207f56613a46c9$var$Emotion = /* #__PURE__ */ $24207f56613a46c9$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$24207f56613a46c9$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $9RMP2.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $4yPgu.serializeStyles)(registeredStyles, undefined, $3qjKr.useContext($24207f56613a46c9$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($24207f56613a46c9$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $24207f56613a46c9$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $3qjKr.createElement($3qjKr.Fragment, null, /*#__PURE__*/ $3qjKr.createElement($24207f56613a46c9$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $3qjKr.createElement(WrappedComponent, newProps));
});
var $24207f56613a46c9$export$a9c23c6ac3fc3eca = $24207f56613a46c9$var$Emotion;

});
parcelRegister("3Elrg", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a85bccb6c876aa2$export$2e2bcd8739ae039);

var $b1pBr = parcelRequire("b1pBr");

var $fBdRT = parcelRequire("fBdRT");
parcelRequire("5Fefb");
parcelRequire("kT3TQ");
var $2a85bccb6c876aa2$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $fBdRT.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $fBdRT.token)(character)) break;
        (0, $fBdRT.next)();
    }
    return (0, $fBdRT.slice)(begin, (0, $fBdRT.position));
};
var $2a85bccb6c876aa2$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $fBdRT.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $fBdRT.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $2a85bccb6c876aa2$var$identifierWithPointTracking((0, $fBdRT.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $fBdRT.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $fBdRT.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fBdRT.from)(character);
    }
    while (character = (0, $fBdRT.next)());
    return parsed;
};
var $2a85bccb6c876aa2$var$getRules = function getRules(value, points) {
    return (0, $fBdRT.dealloc)($2a85bccb6c876aa2$var$toRules((0, $fBdRT.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $2a85bccb6c876aa2$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $2a85bccb6c876aa2$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$2a85bccb6c876aa2$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $2a85bccb6c876aa2$var$fixedElements.set(element, true);
    var points = [];
    var rules = $2a85bccb6c876aa2$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $2a85bccb6c876aa2$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $2a85bccb6c876aa2$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $2a85bccb6c876aa2$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($2a85bccb6c876aa2$var$ignoreFlag) > -1;
};
var $2a85bccb6c876aa2$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($2a85bccb6c876aa2$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $2a85bccb6c876aa2$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $2a85bccb6c876aa2$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$2a85bccb6c876aa2$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $2a85bccb6c876aa2$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $2a85bccb6c876aa2$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$2a85bccb6c876aa2$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $2a85bccb6c876aa2$var$nullifyElement(element);
    } else if ($2a85bccb6c876aa2$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $2a85bccb6c876aa2$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $2a85bccb6c876aa2$var$prefix(value, length) {
    switch((0, $fBdRT.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fBdRT.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fBdRT.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fBdRT.WEBKIT) + value + (0, $fBdRT.MOZ) + value + (0, $fBdRT.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fBdRT.WEBKIT) + value + (0, $fBdRT.MS) + value + value;
        // order
        case 6165:
            return (0, $fBdRT.WEBKIT) + value + (0, $fBdRT.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $fBdRT.WEBKIT) + value + (0, $fBdRT.replace)(value, /(\w+).+(:[^]+)/, (0, $fBdRT.WEBKIT) + "box-$1$2" + (0, $fBdRT.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $fBdRT.WEBKIT) + value + (0, $fBdRT.MS) + "flex-item-" + (0, $fBdRT.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $fBdRT.WEBKIT) + value + (0, $fBdRT.MS) + "flex-line-pack" + (0, $fBdRT.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $fBdRT.WEBKIT) + value + (0, $fBdRT.MS) + (0, $fBdRT.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $fBdRT.WEBKIT) + value + (0, $fBdRT.MS) + (0, $fBdRT.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $fBdRT.WEBKIT) + "box-" + (0, $fBdRT.replace)(value, "-grow", "") + (0, $fBdRT.WEBKIT) + value + (0, $fBdRT.MS) + (0, $fBdRT.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $fBdRT.WEBKIT) + (0, $fBdRT.replace)(value, /([^-])(transform)/g, "$1" + (0, $fBdRT.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $fBdRT.replace)((0, $fBdRT.replace)((0, $fBdRT.replace)(value, /(zoom-|grab)/, (0, $fBdRT.WEBKIT) + "$1"), /(image-set)/, (0, $fBdRT.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fBdRT.replace)(value, /(image-set\([^]*)/, (0, $fBdRT.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $fBdRT.replace)((0, $fBdRT.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fBdRT.WEBKIT) + "box-pack:$3" + (0, $fBdRT.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $fBdRT.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fBdRT.replace)(value, /(.+)-inline(.+)/, (0, $fBdRT.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fBdRT.strlen)(value) - 1 - length > 6) switch((0, $fBdRT.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fBdRT.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fBdRT.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $fBdRT.WEBKIT) + "$2-$3" + "$1" + (0, $fBdRT.MOZ) + ((0, $fBdRT.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fBdRT.indexof)(value, "stretch") ? $2a85bccb6c876aa2$var$prefix((0, $fBdRT.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fBdRT.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fBdRT.charat)(value, (0, $fBdRT.strlen)(value) - 3 - (~(0, $fBdRT.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $fBdRT.replace)(value, ":", ":" + (0, $fBdRT.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fBdRT.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $fBdRT.WEBKIT) + ((0, $fBdRT.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $fBdRT.WEBKIT) + "$2$3" + "$1" + (0, $fBdRT.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fBdRT.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fBdRT.WEBKIT) + value + (0, $fBdRT.MS) + (0, $fBdRT.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $fBdRT.WEBKIT) + value + (0, $fBdRT.MS) + (0, $fBdRT.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fBdRT.WEBKIT) + value + (0, $fBdRT.MS) + (0, $fBdRT.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $fBdRT.WEBKIT) + value + (0, $fBdRT.MS) + value + value;
    }
    return value;
}
var $2a85bccb6c876aa2$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fBdRT.DECLARATION:
                element["return"] = $2a85bccb6c876aa2$var$prefix(element.value, element.length);
                break;
            case 0, $fBdRT.KEYFRAMES:
                return (0, $fBdRT.serialize)([
                    (0, $fBdRT.copy)(element, {
                        value: (0, $fBdRT.replace)(element.value, "@", "@" + (0, $fBdRT.WEBKIT))
                    })
                ], callback);
            case 0, $fBdRT.RULESET:
                if (element.length) return (0, $fBdRT.combine)(element.props, function(value) {
                    switch((0, $fBdRT.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $fBdRT.serialize)([
                                (0, $fBdRT.copy)(element, {
                                    props: [
                                        (0, $fBdRT.replace)(value, /:(read-\w+)/, ":" + (0, $fBdRT.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $fBdRT.serialize)([
                                (0, $fBdRT.copy)(element, {
                                    props: [
                                        (0, $fBdRT.replace)(value, /:(plac\w+)/, ":" + (0, $fBdRT.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $fBdRT.copy)(element, {
                                    props: [
                                        (0, $fBdRT.replace)(value, /:(plac\w+)/, ":" + (0, $fBdRT.MOZ) + "$1")
                                    ]
                                }),
                                (0, $fBdRT.copy)(element, {
                                    props: [
                                        (0, $fBdRT.replace)(value, /:(plac\w+)/, (0, $fBdRT.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $2a85bccb6c876aa2$var$defaultStylisPlugins = [
    $2a85bccb6c876aa2$var$prefixer
];
var $2a85bccb6c876aa2$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $2a85bccb6c876aa2$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $2a85bccb6c876aa2$var$compat,
        $2a85bccb6c876aa2$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $fBdRT.stringify),
        (0, $fBdRT.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $fBdRT.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $fBdRT.serialize)((0, $fBdRT.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $b1pBr.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("b1pBr", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $8063a5e16aeecdb2$export$9d753cd7ae895cce);
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $8063a5e16aeecdb2$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $8063a5e16aeecdb2$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $8063a5e16aeecdb2$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($8063a5e16aeecdb2$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $8063a5e16aeecdb2$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("fBdRT", function(module, exports) {

$parcel$export(module.exports, "MS", () => $e1949b2ada677a18$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $e1949b2ada677a18$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $e1949b2ada677a18$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $e1949b2ada677a18$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $e1949b2ada677a18$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $e1949b2ada677a18$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $e1949b2ada677a18$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $e1949b2ada677a18$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $e1949b2ada677a18$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $e1949b2ada677a18$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $e1949b2ada677a18$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $e1949b2ada677a18$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $e1949b2ada677a18$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $e1949b2ada677a18$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $e1949b2ada677a18$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $e1949b2ada677a18$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $e1949b2ada677a18$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $e1949b2ada677a18$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $e1949b2ada677a18$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $e1949b2ada677a18$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $e1949b2ada677a18$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $e1949b2ada677a18$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $e1949b2ada677a18$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $e1949b2ada677a18$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $e1949b2ada677a18$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $e1949b2ada677a18$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $e1949b2ada677a18$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $e1949b2ada677a18$export$38bcb760f1d4871c);
var $e1949b2ada677a18$export$71ad59f2e432cfe8 = "-ms-";
var $e1949b2ada677a18$export$2c0f367103c8d01c = "-moz-";
var $e1949b2ada677a18$export$39dfd62a25e0fe93 = "-webkit-";
var $e1949b2ada677a18$export$a29989082612d0d9 = "comm";
var $e1949b2ada677a18$export$aa3a2e812ca8570d = "rule";
var $e1949b2ada677a18$export$527d108ccf083c2b = "decl";
var $e1949b2ada677a18$export$d3d35020fa5b54f0 = "@page";
var $e1949b2ada677a18$export$500415a86c544f73 = "@media";
var $e1949b2ada677a18$export$a763edbf796b780a = "@import";
var $e1949b2ada677a18$export$2790aeb8b4e5c826 = "@charset";
var $e1949b2ada677a18$export$1cc683e23b84b133 = "@viewport";
var $e1949b2ada677a18$export$9447a5efea57e862 = "@supports";
var $e1949b2ada677a18$export$ef011b4e114b1fba = "@document";
var $e1949b2ada677a18$export$6aad947bda0f3f46 = "@namespace";
var $e1949b2ada677a18$export$b44a8529a35fcb60 = "@keyframes";
var $e1949b2ada677a18$export$2c16de31893252e6 = "@font-face";
var $e1949b2ada677a18$export$3d846dd52e150c6f = "@counter-style";
var $e1949b2ada677a18$export$22314bfbb57653fe = "@font-feature-values";
var $e1949b2ada677a18$export$d773506282b3cfe6 = "@layer";
var $e1949b2ada677a18$export$2335f513bbd82c6d = Math.abs;
var $e1949b2ada677a18$export$6788812c4e6611e6 = String.fromCharCode;
var $e1949b2ada677a18$export$e6e34fd1f2686227 = Object.assign;
function $e1949b2ada677a18$export$d6af199866bfb566(e, r) {
    return $e1949b2ada677a18$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $e1949b2ada677a18$export$a9db5e087081082d(e, 0)) << 2 ^ $e1949b2ada677a18$export$a9db5e087081082d(e, 1)) << 2 ^ $e1949b2ada677a18$export$a9db5e087081082d(e, 2)) << 2 ^ $e1949b2ada677a18$export$a9db5e087081082d(e, 3) : 0;
}
function $e1949b2ada677a18$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $e1949b2ada677a18$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $e1949b2ada677a18$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $e1949b2ada677a18$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $e1949b2ada677a18$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $e1949b2ada677a18$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $e1949b2ada677a18$export$36776f635604f274(e) {
    return e.length;
}
function $e1949b2ada677a18$export$f9084667e487ed46(e) {
    return e.length;
}
function $e1949b2ada677a18$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $e1949b2ada677a18$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $e1949b2ada677a18$export$53f1d5ea8de3d7c = 1;
var $e1949b2ada677a18$export$4e0c71f277ca26b3 = 1;
var $e1949b2ada677a18$export$f24224f1c91d8156 = 0;
var $e1949b2ada677a18$export$5880b8b5730aff45 = 0;
var $e1949b2ada677a18$export$c0306caf338ac095 = 0;
var $e1949b2ada677a18$export$30a86d91af8ff6e6 = "";
function $e1949b2ada677a18$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $e1949b2ada677a18$export$53f1d5ea8de3d7c,
        column: $e1949b2ada677a18$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $e1949b2ada677a18$export$784d13d8ee351f07(e, r) {
    return $e1949b2ada677a18$export$e6e34fd1f2686227($e1949b2ada677a18$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $e1949b2ada677a18$export$eba6f6f03b0a92e7() {
    return $e1949b2ada677a18$export$c0306caf338ac095;
}
function $e1949b2ada677a18$export$232faf9add678146() {
    $e1949b2ada677a18$export$c0306caf338ac095 = $e1949b2ada677a18$export$5880b8b5730aff45 > 0 ? $e1949b2ada677a18$export$a9db5e087081082d($e1949b2ada677a18$export$30a86d91af8ff6e6, --$e1949b2ada677a18$export$5880b8b5730aff45) : 0;
    if ($e1949b2ada677a18$export$4e0c71f277ca26b3--, $e1949b2ada677a18$export$c0306caf338ac095 === 10) $e1949b2ada677a18$export$4e0c71f277ca26b3 = 1, $e1949b2ada677a18$export$53f1d5ea8de3d7c--;
    return $e1949b2ada677a18$export$c0306caf338ac095;
}
function $e1949b2ada677a18$export$48cfd1e771a65c4f() {
    $e1949b2ada677a18$export$c0306caf338ac095 = $e1949b2ada677a18$export$5880b8b5730aff45 < $e1949b2ada677a18$export$f24224f1c91d8156 ? $e1949b2ada677a18$export$a9db5e087081082d($e1949b2ada677a18$export$30a86d91af8ff6e6, $e1949b2ada677a18$export$5880b8b5730aff45++) : 0;
    if ($e1949b2ada677a18$export$4e0c71f277ca26b3++, $e1949b2ada677a18$export$c0306caf338ac095 === 10) $e1949b2ada677a18$export$4e0c71f277ca26b3 = 1, $e1949b2ada677a18$export$53f1d5ea8de3d7c++;
    return $e1949b2ada677a18$export$c0306caf338ac095;
}
function $e1949b2ada677a18$export$4d3fb11e950abb9e() {
    return $e1949b2ada677a18$export$a9db5e087081082d($e1949b2ada677a18$export$30a86d91af8ff6e6, $e1949b2ada677a18$export$5880b8b5730aff45);
}
function $e1949b2ada677a18$export$e88cb2efb12ae807() {
    return $e1949b2ada677a18$export$5880b8b5730aff45;
}
function $e1949b2ada677a18$export$58adb3bec8346d0f(e, r) {
    return $e1949b2ada677a18$export$2f35ab04d2335697($e1949b2ada677a18$export$30a86d91af8ff6e6, e, r);
}
function $e1949b2ada677a18$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $e1949b2ada677a18$export$2de70f21292aac9e(e) {
    return $e1949b2ada677a18$export$53f1d5ea8de3d7c = $e1949b2ada677a18$export$4e0c71f277ca26b3 = 1, $e1949b2ada677a18$export$f24224f1c91d8156 = $e1949b2ada677a18$export$36776f635604f274($e1949b2ada677a18$export$30a86d91af8ff6e6 = e), $e1949b2ada677a18$export$5880b8b5730aff45 = 0, [];
}
function $e1949b2ada677a18$export$45918ac1574455b1(e) {
    return $e1949b2ada677a18$export$30a86d91af8ff6e6 = "", e;
}
function $e1949b2ada677a18$export$410ac95b9ec204b8(e) {
    return $e1949b2ada677a18$export$87c2784dc9fc4ab($e1949b2ada677a18$export$58adb3bec8346d0f($e1949b2ada677a18$export$5880b8b5730aff45 - 1, $e1949b2ada677a18$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $e1949b2ada677a18$export$660b2ee2d4fb4eff(e) {
    return $e1949b2ada677a18$export$45918ac1574455b1($e1949b2ada677a18$export$5f8c09e3ae6f64e1($e1949b2ada677a18$export$2de70f21292aac9e(e)));
}
function $e1949b2ada677a18$export$7af1228ff777d175(e) {
    while($e1949b2ada677a18$export$c0306caf338ac095 = $e1949b2ada677a18$export$4d3fb11e950abb9e())if ($e1949b2ada677a18$export$c0306caf338ac095 < 33) $e1949b2ada677a18$export$48cfd1e771a65c4f();
    else break;
    return $e1949b2ada677a18$export$9e1725a4cfeada27(e) > 2 || $e1949b2ada677a18$export$9e1725a4cfeada27($e1949b2ada677a18$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $e1949b2ada677a18$export$5f8c09e3ae6f64e1(e) {
    while($e1949b2ada677a18$export$48cfd1e771a65c4f())switch($e1949b2ada677a18$export$9e1725a4cfeada27($e1949b2ada677a18$export$c0306caf338ac095)){
        case 0:
            $e1949b2ada677a18$export$10d8903dec122b9d($e1949b2ada677a18$export$c2ab62c7bf24634($e1949b2ada677a18$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $e1949b2ada677a18$export$10d8903dec122b9d($e1949b2ada677a18$export$410ac95b9ec204b8($e1949b2ada677a18$export$c0306caf338ac095), e);
            break;
        default:
            $e1949b2ada677a18$export$10d8903dec122b9d($e1949b2ada677a18$export$6788812c4e6611e6($e1949b2ada677a18$export$c0306caf338ac095), e);
    }
    return e;
}
function $e1949b2ada677a18$export$955ba06d119e085e(e, r) {
    while(--r && $e1949b2ada677a18$export$48cfd1e771a65c4f())if ($e1949b2ada677a18$export$c0306caf338ac095 < 48 || $e1949b2ada677a18$export$c0306caf338ac095 > 102 || $e1949b2ada677a18$export$c0306caf338ac095 > 57 && $e1949b2ada677a18$export$c0306caf338ac095 < 65 || $e1949b2ada677a18$export$c0306caf338ac095 > 70 && $e1949b2ada677a18$export$c0306caf338ac095 < 97) break;
    return $e1949b2ada677a18$export$58adb3bec8346d0f(e, $e1949b2ada677a18$export$e88cb2efb12ae807() + (r < 6 && $e1949b2ada677a18$export$4d3fb11e950abb9e() == 32 && $e1949b2ada677a18$export$48cfd1e771a65c4f() == 32));
}
function $e1949b2ada677a18$export$c889f2fcc19dbf12(e) {
    while($e1949b2ada677a18$export$48cfd1e771a65c4f())switch($e1949b2ada677a18$export$c0306caf338ac095){
        case e:
            return $e1949b2ada677a18$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $e1949b2ada677a18$export$c889f2fcc19dbf12($e1949b2ada677a18$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $e1949b2ada677a18$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $e1949b2ada677a18$export$48cfd1e771a65c4f();
            break;
    }
    return $e1949b2ada677a18$export$5880b8b5730aff45;
}
function $e1949b2ada677a18$export$4254d4e2b3745c4c(e, r) {
    while($e1949b2ada677a18$export$48cfd1e771a65c4f())if (e + $e1949b2ada677a18$export$c0306caf338ac095 === 57) break;
    else if (e + $e1949b2ada677a18$export$c0306caf338ac095 === 84 && $e1949b2ada677a18$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $e1949b2ada677a18$export$58adb3bec8346d0f(r, $e1949b2ada677a18$export$5880b8b5730aff45 - 1) + "*" + $e1949b2ada677a18$export$6788812c4e6611e6(e === 47 ? e : $e1949b2ada677a18$export$48cfd1e771a65c4f());
}
function $e1949b2ada677a18$export$c2ab62c7bf24634(e) {
    while(!$e1949b2ada677a18$export$9e1725a4cfeada27($e1949b2ada677a18$export$4d3fb11e950abb9e()))$e1949b2ada677a18$export$48cfd1e771a65c4f();
    return $e1949b2ada677a18$export$58adb3bec8346d0f(e, $e1949b2ada677a18$export$5880b8b5730aff45);
}
function $e1949b2ada677a18$export$ef7acd7185315e22(e) {
    return $e1949b2ada677a18$export$45918ac1574455b1($e1949b2ada677a18$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $e1949b2ada677a18$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $e1949b2ada677a18$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $e1949b2ada677a18$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $e1949b2ada677a18$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($e1949b2ada677a18$export$f8e21b1e77979a08(j += $e1949b2ada677a18$export$77ad94ebf1c2b9ed($e1949b2ada677a18$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $e1949b2ada677a18$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $e1949b2ada677a18$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $e1949b2ada677a18$export$955ba06d119e085e($e1949b2ada677a18$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($e1949b2ada677a18$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $e1949b2ada677a18$export$10d8903dec122b9d($e1949b2ada677a18$export$4a34f930e789283c($e1949b2ada677a18$export$4254d4e2b3745c4c($e1949b2ada677a18$export$48cfd1e771a65c4f(), $e1949b2ada677a18$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $e1949b2ada677a18$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $e1949b2ada677a18$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $e1949b2ada677a18$export$36776f635604f274(j) - l) $e1949b2ada677a18$export$10d8903dec122b9d(p > 32 ? $e1949b2ada677a18$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $e1949b2ada677a18$export$f8483753829ec8f3($e1949b2ada677a18$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $e1949b2ada677a18$export$10d8903dec122b9d(y = $e1949b2ada677a18$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $e1949b2ada677a18$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $e1949b2ada677a18$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $e1949b2ada677a18$export$98e6a39c04603d36(e, y, y, n && $e1949b2ada677a18$export$10d8903dec122b9d($e1949b2ada677a18$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $e1949b2ada677a18$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $e1949b2ada677a18$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $e1949b2ada677a18$export$232faf9add678146() == 125) continue;
            }
            switch(j += $e1949b2ada677a18$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($e1949b2ada677a18$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($e1949b2ada677a18$export$4d3fb11e950abb9e() === 45) j += $e1949b2ada677a18$export$410ac95b9ec204b8($e1949b2ada677a18$export$48cfd1e771a65c4f());
                    v = $e1949b2ada677a18$export$4d3fb11e950abb9e(), o = l = $e1949b2ada677a18$export$36776f635604f274(g = j += $e1949b2ada677a18$export$c2ab62c7bf24634($e1949b2ada677a18$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $e1949b2ada677a18$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $e1949b2ada677a18$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $e1949b2ada677a18$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $e1949b2ada677a18$export$2f35ab04d2335697(e, v + 1, v = $e1949b2ada677a18$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $e1949b2ada677a18$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $e1949b2ada677a18$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $e1949b2ada677a18$export$35059013cd4a06db(e, r, a, s === 0 ? $e1949b2ada677a18$export$aa3a2e812ca8570d : i, f, o, l);
}
function $e1949b2ada677a18$export$4a34f930e789283c(e, r, a) {
    return $e1949b2ada677a18$export$35059013cd4a06db(e, r, a, $e1949b2ada677a18$export$a29989082612d0d9, $e1949b2ada677a18$export$6788812c4e6611e6($e1949b2ada677a18$export$eba6f6f03b0a92e7()), $e1949b2ada677a18$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $e1949b2ada677a18$export$f8483753829ec8f3(e, r, a, n) {
    return $e1949b2ada677a18$export$35059013cd4a06db(e, r, a, $e1949b2ada677a18$export$527d108ccf083c2b, $e1949b2ada677a18$export$2f35ab04d2335697(e, 0, n), $e1949b2ada677a18$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $e1949b2ada677a18$export$82e9f45cca5ba907(n, c, s) {
    switch($e1949b2ada677a18$export$d6af199866bfb566(n, c)){
        case 5103:
            return $e1949b2ada677a18$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $e1949b2ada677a18$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $e1949b2ada677a18$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $e1949b2ada677a18$export$39dfd62a25e0fe93 + n + $e1949b2ada677a18$export$2c0f367103c8d01c + n + $e1949b2ada677a18$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($e1949b2ada677a18$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $e1949b2ada677a18$export$39dfd62a25e0fe93 + n + $e1949b2ada677a18$export$71ad59f2e432cfe8 + $e1949b2ada677a18$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $e1949b2ada677a18$export$39dfd62a25e0fe93 + n + $e1949b2ada677a18$export$71ad59f2e432cfe8 + $e1949b2ada677a18$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $e1949b2ada677a18$export$39dfd62a25e0fe93 + n + $e1949b2ada677a18$export$71ad59f2e432cfe8 + $e1949b2ada677a18$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $e1949b2ada677a18$export$39dfd62a25e0fe93 + n + $e1949b2ada677a18$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $e1949b2ada677a18$export$39dfd62a25e0fe93 + n + $e1949b2ada677a18$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $e1949b2ada677a18$export$39dfd62a25e0fe93 + n + $e1949b2ada677a18$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $e1949b2ada677a18$export$39dfd62a25e0fe93 + "box-$1$2" + $e1949b2ada677a18$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $e1949b2ada677a18$export$39dfd62a25e0fe93 + n + $e1949b2ada677a18$export$71ad59f2e432cfe8 + "flex-item-" + $e1949b2ada677a18$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$e1949b2ada677a18$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $e1949b2ada677a18$export$71ad59f2e432cfe8 + "grid-row-" + $e1949b2ada677a18$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $e1949b2ada677a18$export$39dfd62a25e0fe93 + n + $e1949b2ada677a18$export$71ad59f2e432cfe8 + "flex-line-pack" + $e1949b2ada677a18$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $e1949b2ada677a18$export$39dfd62a25e0fe93 + n + $e1949b2ada677a18$export$71ad59f2e432cfe8 + $e1949b2ada677a18$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $e1949b2ada677a18$export$39dfd62a25e0fe93 + n + $e1949b2ada677a18$export$71ad59f2e432cfe8 + $e1949b2ada677a18$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $e1949b2ada677a18$export$39dfd62a25e0fe93 + "box-" + $e1949b2ada677a18$export$77ad94ebf1c2b9ed(n, "-grow", "") + $e1949b2ada677a18$export$39dfd62a25e0fe93 + n + $e1949b2ada677a18$export$71ad59f2e432cfe8 + $e1949b2ada677a18$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $e1949b2ada677a18$export$39dfd62a25e0fe93 + $e1949b2ada677a18$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $e1949b2ada677a18$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $e1949b2ada677a18$export$77ad94ebf1c2b9ed($e1949b2ada677a18$export$77ad94ebf1c2b9ed($e1949b2ada677a18$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $e1949b2ada677a18$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $e1949b2ada677a18$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $e1949b2ada677a18$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $e1949b2ada677a18$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $e1949b2ada677a18$export$77ad94ebf1c2b9ed($e1949b2ada677a18$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $e1949b2ada677a18$export$39dfd62a25e0fe93 + "box-pack:$3" + $e1949b2ada677a18$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $e1949b2ada677a18$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$e1949b2ada677a18$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $e1949b2ada677a18$export$71ad59f2e432cfe8 + "grid-column-align" + $e1949b2ada677a18$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $e1949b2ada677a18$export$71ad59f2e432cfe8 + $e1949b2ada677a18$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $e1949b2ada677a18$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$e1949b2ada677a18$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $e1949b2ada677a18$export$71ad59f2e432cfe8 + $e1949b2ada677a18$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $e1949b2ada677a18$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$e1949b2ada677a18$export$f8e21b1e77979a08(s, "span") ? $e1949b2ada677a18$export$4659b591c19bdf3d(s, /\d+/) : +$e1949b2ada677a18$export$4659b591c19bdf3d(s, /\d+/) - +$e1949b2ada677a18$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $e1949b2ada677a18$export$71ad59f2e432cfe8 + $e1949b2ada677a18$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $e1949b2ada677a18$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $e1949b2ada677a18$export$71ad59f2e432cfe8 + $e1949b2ada677a18$export$77ad94ebf1c2b9ed($e1949b2ada677a18$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $e1949b2ada677a18$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $e1949b2ada677a18$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($e1949b2ada677a18$export$36776f635604f274(n) - 1 - c > 6) switch($e1949b2ada677a18$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($e1949b2ada677a18$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $e1949b2ada677a18$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $e1949b2ada677a18$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $e1949b2ada677a18$export$2c0f367103c8d01c + ($e1949b2ada677a18$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$e1949b2ada677a18$export$f8e21b1e77979a08(n, "stretch") ? $e1949b2ada677a18$export$82e9f45cca5ba907($e1949b2ada677a18$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $e1949b2ada677a18$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $e1949b2ada677a18$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $e1949b2ada677a18$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($e1949b2ada677a18$export$a9db5e087081082d(n, c + 6) === 121) return $e1949b2ada677a18$export$77ad94ebf1c2b9ed(n, ":", ":" + $e1949b2ada677a18$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($e1949b2ada677a18$export$a9db5e087081082d(n, $e1949b2ada677a18$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $e1949b2ada677a18$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $e1949b2ada677a18$export$39dfd62a25e0fe93 + ($e1949b2ada677a18$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $e1949b2ada677a18$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $e1949b2ada677a18$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $e1949b2ada677a18$export$77ad94ebf1c2b9ed(n, ":", ":" + $e1949b2ada677a18$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $e1949b2ada677a18$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $e1949b2ada677a18$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $e1949b2ada677a18$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $e1949b2ada677a18$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $e1949b2ada677a18$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $e1949b2ada677a18$export$a763edbf796b780a:
        case $e1949b2ada677a18$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $e1949b2ada677a18$export$a29989082612d0d9:
            return "";
        case $e1949b2ada677a18$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $e1949b2ada677a18$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $e1949b2ada677a18$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $e1949b2ada677a18$export$36776f635604f274(a = $e1949b2ada677a18$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $e1949b2ada677a18$export$5a7767152ae0305f(e) {
    var r = $e1949b2ada677a18$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $e1949b2ada677a18$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $e1949b2ada677a18$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $e1949b2ada677a18$export$527d108ccf083c2b:
                n.return = $e1949b2ada677a18$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $e1949b2ada677a18$export$b44a8529a35fcb60:
                return $e1949b2ada677a18$export$dfdc1655ccc5b9cb([
                    $e1949b2ada677a18$export$784d13d8ee351f07(n, {
                        value: $e1949b2ada677a18$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $e1949b2ada677a18$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $e1949b2ada677a18$export$aa3a2e812ca8570d:
                if (n.length) return $e1949b2ada677a18$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($e1949b2ada677a18$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $e1949b2ada677a18$export$dfdc1655ccc5b9cb([
                                $e1949b2ada677a18$export$784d13d8ee351f07(n, {
                                    props: [
                                        $e1949b2ada677a18$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $e1949b2ada677a18$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $e1949b2ada677a18$export$dfdc1655ccc5b9cb([
                                $e1949b2ada677a18$export$784d13d8ee351f07(n, {
                                    props: [
                                        $e1949b2ada677a18$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $e1949b2ada677a18$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $e1949b2ada677a18$export$784d13d8ee351f07(n, {
                                    props: [
                                        $e1949b2ada677a18$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $e1949b2ada677a18$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $e1949b2ada677a18$export$784d13d8ee351f07(n, {
                                    props: [
                                        $e1949b2ada677a18$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $e1949b2ada677a18$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $e1949b2ada677a18$export$76a88f7de6507443(e) {
    switch(e.type){
        case $e1949b2ada677a18$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $e1949b2ada677a18$export$1be1fc439b849fdf($e1949b2ada677a18$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($e1949b2ada677a18$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $e1949b2ada677a18$export$2f35ab04d2335697(r, 1, $e1949b2ada677a18$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $e1949b2ada677a18$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $e1949b2ada677a18$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $e1949b2ada677a18$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("5Fefb", function(module, exports) {

$parcel$export(module.exports, "default", () => $41fbd4a4e19f557e$export$2e2bcd8739ae039);
var $41fbd4a4e19f557e$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});


parcelRegister("6p6Dg", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a9a38e868d4aaa4$export$2e2bcd8739ae039);

var $i7wrp = parcelRequire("i7wrp");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $4a9a38e868d4aaa4$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7wrp)))(targetComponent, sourceComponent);
};

});
parcelRegister("i7wrp", function(module, exports) {
"use strict";

var $6IURx = parcelRequire("6IURx");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $d3120b9260f06473$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $d3120b9260f06473$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $d3120b9260f06473$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $d3120b9260f06473$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $d3120b9260f06473$var$TYPE_STATICS = {};
$d3120b9260f06473$var$TYPE_STATICS[$6IURx.ForwardRef] = $d3120b9260f06473$var$FORWARD_REF_STATICS;
$d3120b9260f06473$var$TYPE_STATICS[$6IURx.Memo] = $d3120b9260f06473$var$MEMO_STATICS;
function $d3120b9260f06473$var$getStatics(component) {
    // React v16.11 and below
    if ($6IURx.isMemo(component)) return $d3120b9260f06473$var$MEMO_STATICS;
     // React v16.12 and above
    return $d3120b9260f06473$var$TYPE_STATICS[component["$$typeof"]] || $d3120b9260f06473$var$REACT_STATICS;
}
var $d3120b9260f06473$var$defineProperty = Object.defineProperty;
var $d3120b9260f06473$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $d3120b9260f06473$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $d3120b9260f06473$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $d3120b9260f06473$var$getPrototypeOf = Object.getPrototypeOf;
var $d3120b9260f06473$var$objectPrototype = Object.prototype;
function $d3120b9260f06473$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($d3120b9260f06473$var$objectPrototype) {
            var inheritedComponent = $d3120b9260f06473$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $d3120b9260f06473$var$objectPrototype) $d3120b9260f06473$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $d3120b9260f06473$var$getOwnPropertyNames(sourceComponent);
        if ($d3120b9260f06473$var$getOwnPropertySymbols) keys = keys.concat($d3120b9260f06473$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $d3120b9260f06473$var$getStatics(targetComponent);
        var sourceStatics = $d3120b9260f06473$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$d3120b9260f06473$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $d3120b9260f06473$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $d3120b9260f06473$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $d3120b9260f06473$var$hoistNonReactStatics;

});
parcelRegister("6IURx", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1dxgA"));

});



parcelRegister("9RMP2", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $72eeef5cfa7b898d$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $72eeef5cfa7b898d$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $72eeef5cfa7b898d$export$6f077d94b33a01aa);
var $72eeef5cfa7b898d$var$isBrowser = true;
function $72eeef5cfa7b898d$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $72eeef5cfa7b898d$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $72eeef5cfa7b898d$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $72eeef5cfa7b898d$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $72eeef5cfa7b898d$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("4yPgu", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $35221a87d6449556$export$6321afa313b251b5);

var $9Ykt8 = parcelRequire("9Ykt8");

var $2Jk2v = parcelRequire("2Jk2v");

var $kT3TQ = parcelRequire("kT3TQ");
var $35221a87d6449556$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $35221a87d6449556$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $35221a87d6449556$var$hyphenateRegex = /[A-Z]|^ms/g;
var $35221a87d6449556$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $35221a87d6449556$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $35221a87d6449556$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $35221a87d6449556$var$processStyleName = /* #__PURE__ */ (0, $kT3TQ.default)(function(styleName) {
    return $35221a87d6449556$var$isCustomProperty(styleName) ? styleName : styleName.replace($35221a87d6449556$var$hyphenateRegex, "-$&").toLowerCase();
});
var $35221a87d6449556$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($35221a87d6449556$var$animationRegex, function(match, p1, p2) {
                $35221a87d6449556$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $35221a87d6449556$var$cursor
                };
                return p1;
            });
    }
    if ((0, $2Jk2v.default)[key] !== 1 && !$35221a87d6449556$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $35221a87d6449556$var$contentValuePattern, $35221a87d6449556$var$contentValues, $35221a87d6449556$var$oldProcessStyleValue, $35221a87d6449556$var$msPattern, $35221a87d6449556$var$hyphenPattern, $35221a87d6449556$var$hyphenatedCache;
var $35221a87d6449556$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $35221a87d6449556$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $35221a87d6449556$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $35221a87d6449556$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $35221a87d6449556$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $35221a87d6449556$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $35221a87d6449556$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $35221a87d6449556$var$cursor;
                var result = interpolation(mergedProps);
                $35221a87d6449556$var$cursor = previousCursor;
                return $35221a87d6449556$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $35221a87d6449556$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $35221a87d6449556$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($35221a87d6449556$var$isProcessableValue(value)) string += $35221a87d6449556$var$processStyleName(_key) + ":" + $35221a87d6449556$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($35221a87d6449556$var$isProcessableValue(value[_i])) string += $35221a87d6449556$var$processStyleName(_key) + ":" + $35221a87d6449556$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $35221a87d6449556$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $35221a87d6449556$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $35221a87d6449556$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $35221a87d6449556$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $35221a87d6449556$var$cursor;
var $35221a87d6449556$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $35221a87d6449556$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $35221a87d6449556$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $35221a87d6449556$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $35221a87d6449556$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $35221a87d6449556$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $9Ykt8.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $35221a87d6449556$var$cursor
    };
};

});
parcelRegister("9Ykt8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7429985c6fc37e72$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $7429985c6fc37e72$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("2Jk2v", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fcf5423109f891b$export$2e2bcd8739ae039);
var $1fcf5423109f891b$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("iTMjm", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $dc22d6a7e94d9d08$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $dc22d6a7e94d9d08$export$811a713a7276cb9d);

var $3qjKr = parcelRequire("3qjKr");
var $dc22d6a7e94d9d08$var$syncFallback = function syncFallback(create) {
    return create();
};
var $dc22d6a7e94d9d08$var$useInsertionEffect = $3qjKr.useInsertionEffect ? $3qjKr.useInsertionEffect : false;
var $dc22d6a7e94d9d08$export$db21c7ffa21794e7 = $dc22d6a7e94d9d08$var$useInsertionEffect || $dc22d6a7e94d9d08$var$syncFallback;
var $dc22d6a7e94d9d08$export$811a713a7276cb9d = $dc22d6a7e94d9d08$var$useInsertionEffect || $3qjKr.useLayoutEffect;

});


parcelRegister("lG10Y", function(module, exports) {
function $04128da8100704cd$var$_extends() {
    module.exports = $04128da8100704cd$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $04128da8100704cd$var$_extends.apply(this, arguments);
}
module.exports = $04128da8100704cd$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});






parcelRegister("1CyaF", function(module, exports) {

$parcel$export(module.exports, "forwardRef", () => $677eee099f332347$export$257a8862b851cb5b);

var $3qjKr = parcelRequire("3qjKr");
"use client";
function $677eee099f332347$export$257a8862b851cb5b(component) {
    return (0, $3qjKr.forwardRef)(component);
}

});

parcelRegister("hXwtK", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $b503b682494ce9b5$export$93d4e7f90805808f);
parcelRequire("8ka9R");
var $36iMe = parcelRequire("36iMe");

var $3qjKr = parcelRequire("3qjKr");
"use client";
function $b503b682494ce9b5$export$93d4e7f90805808f() {
    const theme = (0, $3qjKr.useContext)((0, $36iMe.T));
    if (!theme) throw Error("useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`");
    return theme;
}

});

parcelRegister("dufMO", function(module, exports) {

$parcel$export(module.exports, "Spinner", () => $f1bb0226a70e2fa3$export$7f7cbe89f1eacd2);

var $1kFN0 = parcelRequire("1kFN0");
var $1CyaF = parcelRequire("1CyaF");
var $8ka9R = parcelRequire("8ka9R");
var $cDoMf = parcelRequire("cDoMf");
var $9a7LB = parcelRequire("9a7LB");

var $iyhjB = parcelRequire("iyhjB");

var $4mwsf = parcelRequire("4mwsf");
"use client";
var $f1bb0226a70e2fa3$var$spin = (0, $8ka9R.keyframes)({
    "0%": {
        transform: "rotate(0deg)"
    },
    "100%": {
        transform: "rotate(360deg)"
    }
});
var $f1bb0226a70e2fa3$export$7f7cbe89f1eacd2 = (0, $1CyaF.forwardRef)((props, ref)=>{
    const styles = (0, $9a7LB.useStyleConfig)("Spinner", props);
    const { label: label = "Loading...", thickness: thickness = "2px", speed: speed = "0.45s", emptyColor: emptyColor = "transparent", className: className, ...rest } = (0, $cDoMf.omitThemingProps)(props);
    const _className = (0, $iyhjB.cx)("chakra-spinner", className);
    const spinnerStyles = {
        display: "inline-block",
        borderColor: "currentColor",
        borderStyle: "solid",
        borderRadius: "99999px",
        borderWidth: thickness,
        borderBottomColor: emptyColor,
        borderLeftColor: emptyColor,
        animation: `${$f1bb0226a70e2fa3$var$spin} ${speed} linear infinite`,
        ...styles
    };
    return /* @__PURE__ */ (0, $4mwsf.jsx)((0, $1kFN0.chakra).div, {
        ref: ref,
        __css: spinnerStyles,
        className: _className,
        ...rest,
        children: label && /* @__PURE__ */ (0, $4mwsf.jsx)((0, $1kFN0.chakra).span, {
            srOnly: true,
            children: label
        })
    });
});
$f1bb0226a70e2fa3$export$7f7cbe89f1eacd2.displayName = "Spinner";

});
parcelRegister("9a7LB", function(module, exports) {

$parcel$export(module.exports, "useStyleConfig", () => $6ba0c2a44fe837fe$export$b863f77547fbcb03);
$parcel$export(module.exports, "useMultiStyleConfig", () => $6ba0c2a44fe837fe$export$31cdfe60c085d76f);

var $fNpZk = parcelRequire("fNpZk");

var $cDoMf = parcelRequire("cDoMf");

var $9dHn5 = parcelRequire("9dHn5");

var $6SrEO = parcelRequire("6SrEO");
var $eltz3 = parcelRequire("eltz3");

var $3qjKr = parcelRequire("3qjKr");

var $a8z0n = parcelRequire("a8z0n");
"use client";
function $6ba0c2a44fe837fe$var$useStyleConfigImpl(themeKey, props = {}) {
    var _a;
    const { styleConfig: styleConfigProp, ...rest } = props;
    const { theme: theme, colorMode: colorMode } = (0, $fNpZk.useChakra)();
    const themeStyleConfig = themeKey ? (0, $6SrEO.memoizedGet)(theme, `components.${themeKey}`) : void 0;
    const styleConfig = styleConfigProp || themeStyleConfig;
    const mergedProps = (0, (/*@__PURE__*/$parcel$interopDefault($eltz3)))({
        theme: theme,
        colorMode: colorMode
    }, (_a = styleConfig == null ? void 0 : styleConfig.defaultProps) != null ? _a : {}, (0, $6SrEO.filterUndefined)((0, $6SrEO.omit)(rest, [
        "children"
    ])));
    const stylesRef = (0, $3qjKr.useRef)({});
    if (styleConfig) {
        const getStyles = (0, $cDoMf.resolveStyleConfig)(styleConfig);
        const styles = getStyles(mergedProps);
        const isStyleEqual = (0, (/*@__PURE__*/$parcel$interopDefault($a8z0n)))(stylesRef.current, styles);
        if (!isStyleEqual) stylesRef.current = styles;
    }
    return stylesRef.current;
}
function $6ba0c2a44fe837fe$export$b863f77547fbcb03(themeKey, props = {}) {
    return $6ba0c2a44fe837fe$var$useStyleConfigImpl(themeKey, props);
}
function $6ba0c2a44fe837fe$export$31cdfe60c085d76f(themeKey, props = {}) {
    return $6ba0c2a44fe837fe$var$useStyleConfigImpl(themeKey, props);
}
function $6ba0c2a44fe837fe$export$d47b3683b351a542(themeKey, props) {
    var _a;
    const { baseConfig: baseConfig, ...restProps } = props;
    const { theme: theme } = (0, $fNpZk.useChakra)();
    const overrides = (_a = theme.components) == null ? void 0 : _a[themeKey];
    const styleConfig = overrides ? (0, $9dHn5.mergeThemeOverride)(overrides, baseConfig) : baseConfig;
    return $6ba0c2a44fe837fe$var$useStyleConfigImpl(null, {
        ...restProps,
        styleConfig: styleConfig
    });
}

});
parcelRegister("fNpZk", function(module, exports) {

$parcel$export(module.exports, "useChakra", () => $da2325c4f37bbbd2$export$a513a93efd9ab8a7);
$parcel$export(module.exports, "useToken", () => $da2325c4f37bbbd2$export$31dcd79391e423fe);

var $hXwtK = parcelRequire("hXwtK");

var $ioRKz = parcelRequire("ioRKz");
"use client";
function $da2325c4f37bbbd2$export$a513a93efd9ab8a7() {
    const colorModeResult = (0, $ioRKz.useColorMode)();
    const theme = (0, $hXwtK.useTheme)();
    return {
        ...colorModeResult,
        theme: theme
    };
}
function $da2325c4f37bbbd2$var$getBreakpointValue(theme, value, fallback) {
    var _a, _b;
    if (value == null) return value;
    const getValue = (val)=>{
        var _a2, _b2;
        return (_b2 = (_a2 = theme.__breakpoints) == null ? void 0 : _a2.asArray) == null ? void 0 : _b2[val];
    };
    return (_b = (_a = getValue(value)) != null ? _a : getValue(fallback)) != null ? _b : fallback;
}
function $da2325c4f37bbbd2$var$getTokenValue(theme, value, fallback) {
    var _a, _b;
    if (value == null) return value;
    const getValue = (val)=>{
        var _a2, _b2;
        return (_b2 = (_a2 = theme.__cssMap) == null ? void 0 : _a2[val]) == null ? void 0 : _b2.value;
    };
    return (_b = (_a = getValue(value)) != null ? _a : getValue(fallback)) != null ? _b : fallback;
}
function $da2325c4f37bbbd2$export$31dcd79391e423fe(scale, token, fallback) {
    const theme = (0, $hXwtK.useTheme)();
    return $da2325c4f37bbbd2$export$257b2d10b709d8ef(scale, token, fallback)(theme);
}
function $da2325c4f37bbbd2$export$257b2d10b709d8ef(scale, token, fallback) {
    const _token = Array.isArray(token) ? token : [
        token
    ];
    const _fallback = Array.isArray(fallback) ? fallback : [
        fallback
    ];
    return (theme)=>{
        const fallbackArr = _fallback.filter(Boolean);
        const result = _token.map((token2, index)=>{
            var _a, _b;
            if (scale === "breakpoints") return $da2325c4f37bbbd2$var$getBreakpointValue(theme, token2, (_a = fallbackArr[index]) != null ? _a : token2);
            const path = `${scale}.${token2}`;
            return $da2325c4f37bbbd2$var$getTokenValue(theme, path, (_b = fallbackArr[index]) != null ? _b : token2);
        });
        return Array.isArray(token) ? result : result[0];
    };
}

});

parcelRegister("9dHn5", function(module, exports) {

$parcel$export(module.exports, "mergeThemeOverride", () => $2c27ed3cc18d439d$export$c42236daa9a25fdd);
$parcel$export(module.exports, "extendTheme", () => $2c27ed3cc18d439d$export$33a2b855d5b8731e);
// src/extend-theme.ts

var $lenGy = parcelRequire("lenGy");
var $bFJbW = parcelRequire("bFJbW");

var $eltz3 = parcelRequire("eltz3");
function $2c27ed3cc18d439d$var$isFunction(value) {
    return typeof value === "function";
}
function $2c27ed3cc18d439d$var$pipe(...fns) {
    return (v)=>fns.reduce((a, b)=>b(a), v);
}
var $2c27ed3cc18d439d$var$createExtendTheme = (theme2)=>{
    return function extendTheme2(...extensions) {
        let overrides = [
            ...extensions
        ];
        let activeTheme = extensions[extensions.length - 1];
        if ((0, $bFJbW.isChakraTheme)(activeTheme) && // this ensures backward compatibility
        // previously only `extendTheme(override, activeTheme?)` was allowed
        overrides.length > 1) overrides = overrides.slice(0, overrides.length - 1);
        else activeTheme = theme2;
        return $2c27ed3cc18d439d$var$pipe(...overrides.map((extension)=>(prevTheme)=>$2c27ed3cc18d439d$var$isFunction(extension) ? extension(prevTheme) : $2c27ed3cc18d439d$export$c42236daa9a25fdd(prevTheme, extension)))(activeTheme);
    };
};
var $2c27ed3cc18d439d$export$33a2b855d5b8731e = $2c27ed3cc18d439d$var$createExtendTheme((0, $lenGy.theme));
var $2c27ed3cc18d439d$export$4c7add5200c9692a = $2c27ed3cc18d439d$var$createExtendTheme((0, $lenGy.baseTheme));
function $2c27ed3cc18d439d$export$c42236daa9a25fdd(...overrides) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eltz3)))({}, ...overrides, $2c27ed3cc18d439d$var$mergeThemeCustomizer);
}
function $2c27ed3cc18d439d$var$mergeThemeCustomizer(source, override, key, object) {
    if (($2c27ed3cc18d439d$var$isFunction(source) || $2c27ed3cc18d439d$var$isFunction(override)) && Object.prototype.hasOwnProperty.call(object, key)) return (...args)=>{
        const sourceValue = $2c27ed3cc18d439d$var$isFunction(source) ? source(...args) : source;
        const overrideValue = $2c27ed3cc18d439d$var$isFunction(override) ? override(...args) : override;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eltz3)))({}, sourceValue, overrideValue, $2c27ed3cc18d439d$var$mergeThemeCustomizer);
    };
    return void 0;
}

});
parcelRegister("lenGy", function(module, exports) {

$parcel$export(module.exports, "theme", () => $c9a3a3fa96655550$export$bca14c5b3b88a9c9);
$parcel$export(module.exports, "baseTheme", () => $c9a3a3fa96655550$export$9e955aef208055a6);

var $bFJbW = parcelRequire("bFJbW");

var $20xBB = parcelRequire("20xBB");









var $fYVi8 = parcelRequire("fYVi8");








































var $qj2FQ = parcelRequire("qj2FQ");

var $aeIKe = parcelRequire("aeIKe");








// src/index.ts
var $c9a3a3fa96655550$var$direction = "ltr";
var $c9a3a3fa96655550$var$config = {
    useSystemColorMode: false,
    initialColorMode: "light",
    cssVarPrefix: "chakra"
};
var $c9a3a3fa96655550$export$bca14c5b3b88a9c9 = {
    semanticTokens: $qj2FQ.semanticTokens,
    direction: $c9a3a3fa96655550$var$direction,
    ...(0, $20xBB.foundations),
    components: $fYVi8.components,
    styles: $aeIKe.styles,
    config: $c9a3a3fa96655550$var$config
};
var $c9a3a3fa96655550$export$9e955aef208055a6 = {
    semanticTokens: $qj2FQ.semanticTokens,
    direction: $c9a3a3fa96655550$var$direction,
    components: {},
    ...(0, $20xBB.foundations),
    styles: $aeIKe.styles,
    config: $c9a3a3fa96655550$var$config
};

});
parcelRegister("bFJbW", function(module, exports) {

$parcel$export(module.exports, "isChakraTheme", () => $c28f94b07adffaba$export$73a6ae01926a4f0e);
// src/utils/is-chakra-theme.ts

var $iyhjB = parcelRequire("iyhjB");
var $c28f94b07adffaba$export$1fad0bb5bac74e8f = [
    "borders",
    "breakpoints",
    "colors",
    "components",
    "config",
    "direction",
    "fonts",
    "fontSizes",
    "fontWeights",
    "letterSpacings",
    "lineHeights",
    "radii",
    "shadows",
    "sizes",
    "space",
    "styles",
    "transition",
    "zIndices"
];
function $c28f94b07adffaba$export$73a6ae01926a4f0e(unit) {
    if (!(0, $iyhjB.isObject)(unit)) return false;
    return $c28f94b07adffaba$export$1fad0bb5bac74e8f.every((propertyName)=>Object.prototype.hasOwnProperty.call(unit, propertyName));
}

});

parcelRegister("20xBB", function(module, exports) {

$parcel$export(module.exports, "foundations", () => $6c60dd8d3765426a$export$651a0b7b10dae380);

var $agtgV = parcelRequire("agtgV");

var $ifs3K = parcelRequire("ifs3K");

var $j0dzf = parcelRequire("j0dzf");

var $ghCgZ = parcelRequire("ghCgZ");

var $ddIpD = parcelRequire("ddIpD");

var $iJr7n = parcelRequire("iJr7n");

var $p65bk = parcelRequire("p65bk");

var $jFI2h = parcelRequire("jFI2h");

var $9Ga7i = parcelRequire("9Ga7i");

var $gaCnF = parcelRequire("gaCnF");

var $7kUBF = parcelRequire("7kUBF");
// src/foundations/index.ts
var $6c60dd8d3765426a$export$651a0b7b10dae380 = {
    breakpoints: (0, $ghCgZ.breakpoints_default),
    zIndices: (0, $ifs3K.z_index_default),
    radii: (0, $iJr7n.radius_default),
    blur: (0, $jFI2h.blur_default),
    colors: (0, $ddIpD.colors_default),
    ...(0, $9Ga7i.typography_default),
    sizes: (0, $gaCnF.sizes_default),
    shadows: (0, $p65bk.shadows_default),
    space: (0, $7kUBF.spacing),
    borders: (0, $j0dzf.borders_default),
    transition: (0, $agtgV.transition_default)
};

});
parcelRegister("agtgV", function(module, exports) {

$parcel$export(module.exports, "transition_default", () => $7e888c5750f9dbc3$export$6b266f9cfc4b7bb8);
// src/foundations/transition.ts
var $7e888c5750f9dbc3$var$transitionProperty = {
    common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
    colors: "background-color, border-color, color, fill, stroke",
    dimensions: "width, height",
    position: "left, right, top, bottom",
    background: "background-color, background-image, background-position"
};
var $7e888c5750f9dbc3$var$transitionTimingFunction = {
    "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
    "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
    "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
};
var $7e888c5750f9dbc3$var$transitionDuration = {
    "ultra-fast": "50ms",
    faster: "100ms",
    fast: "150ms",
    normal: "200ms",
    slow: "300ms",
    slower: "400ms",
    "ultra-slow": "500ms"
};
var $7e888c5750f9dbc3$var$transition = {
    property: $7e888c5750f9dbc3$var$transitionProperty,
    easing: $7e888c5750f9dbc3$var$transitionTimingFunction,
    duration: $7e888c5750f9dbc3$var$transitionDuration
};
var $7e888c5750f9dbc3$export$6b266f9cfc4b7bb8 = $7e888c5750f9dbc3$var$transition;

});

parcelRegister("ifs3K", function(module, exports) {

$parcel$export(module.exports, "z_index_default", () => $124e6aca238d1dcc$export$d9d5ef55fed42171);
// src/foundations/z-index.ts
var $124e6aca238d1dcc$var$zIndices = {
    hide: -1,
    auto: "auto",
    base: 0,
    docked: 10,
    dropdown: 1e3,
    sticky: 1100,
    banner: 1200,
    overlay: 1300,
    modal: 1400,
    popover: 1500,
    skipLink: 1600,
    toast: 1700,
    tooltip: 1800
};
var $124e6aca238d1dcc$export$d9d5ef55fed42171 = $124e6aca238d1dcc$var$zIndices;

});

parcelRegister("j0dzf", function(module, exports) {

$parcel$export(module.exports, "borders_default", () => $7b4ef9b095ae7a98$export$196bfcf31ca4deb7);
// src/foundations/borders.ts
var $7b4ef9b095ae7a98$var$borders = {
    none: 0,
    "1px": "1px solid",
    "2px": "2px solid",
    "4px": "4px solid",
    "8px": "8px solid"
};
var $7b4ef9b095ae7a98$export$196bfcf31ca4deb7 = $7b4ef9b095ae7a98$var$borders;

});

parcelRegister("ghCgZ", function(module, exports) {

$parcel$export(module.exports, "breakpoints_default", () => $c7b419cb4e425684$export$d0717e75346b884a);
// src/foundations/breakpoints.ts
var $c7b419cb4e425684$var$breakpoints = {
    base: "0em",
    sm: "30em",
    md: "48em",
    lg: "62em",
    xl: "80em",
    "2xl": "96em"
};
var $c7b419cb4e425684$export$d0717e75346b884a = $c7b419cb4e425684$var$breakpoints;

});

parcelRegister("ddIpD", function(module, exports) {

$parcel$export(module.exports, "colors_default", () => $54da5336d471546d$export$59d2d4241383b416);
// src/foundations/colors.ts
var $54da5336d471546d$var$colors = {
    transparent: "transparent",
    current: "currentColor",
    black: "#000000",
    white: "#FFFFFF",
    whiteAlpha: {
        50: "rgba(255, 255, 255, 0.04)",
        100: "rgba(255, 255, 255, 0.06)",
        200: "rgba(255, 255, 255, 0.08)",
        300: "rgba(255, 255, 255, 0.16)",
        400: "rgba(255, 255, 255, 0.24)",
        500: "rgba(255, 255, 255, 0.36)",
        600: "rgba(255, 255, 255, 0.48)",
        700: "rgba(255, 255, 255, 0.64)",
        800: "rgba(255, 255, 255, 0.80)",
        900: "rgba(255, 255, 255, 0.92)"
    },
    blackAlpha: {
        50: "rgba(0, 0, 0, 0.04)",
        100: "rgba(0, 0, 0, 0.06)",
        200: "rgba(0, 0, 0, 0.08)",
        300: "rgba(0, 0, 0, 0.16)",
        400: "rgba(0, 0, 0, 0.24)",
        500: "rgba(0, 0, 0, 0.36)",
        600: "rgba(0, 0, 0, 0.48)",
        700: "rgba(0, 0, 0, 0.64)",
        800: "rgba(0, 0, 0, 0.80)",
        900: "rgba(0, 0, 0, 0.92)"
    },
    gray: {
        50: "#F7FAFC",
        100: "#EDF2F7",
        200: "#E2E8F0",
        300: "#CBD5E0",
        400: "#A0AEC0",
        500: "#718096",
        600: "#4A5568",
        700: "#2D3748",
        800: "#1A202C",
        900: "#171923"
    },
    red: {
        50: "#FFF5F5",
        100: "#FED7D7",
        200: "#FEB2B2",
        300: "#FC8181",
        400: "#F56565",
        500: "#E53E3E",
        600: "#C53030",
        700: "#9B2C2C",
        800: "#822727",
        900: "#63171B"
    },
    orange: {
        50: "#FFFAF0",
        100: "#FEEBC8",
        200: "#FBD38D",
        300: "#F6AD55",
        400: "#ED8936",
        500: "#DD6B20",
        600: "#C05621",
        700: "#9C4221",
        800: "#7B341E",
        900: "#652B19"
    },
    yellow: {
        50: "#FFFFF0",
        100: "#FEFCBF",
        200: "#FAF089",
        300: "#F6E05E",
        400: "#ECC94B",
        500: "#D69E2E",
        600: "#B7791F",
        700: "#975A16",
        800: "#744210",
        900: "#5F370E"
    },
    green: {
        50: "#F0FFF4",
        100: "#C6F6D5",
        200: "#9AE6B4",
        300: "#68D391",
        400: "#48BB78",
        500: "#38A169",
        600: "#2F855A",
        700: "#276749",
        800: "#22543D",
        900: "#1C4532"
    },
    teal: {
        50: "#E6FFFA",
        100: "#B2F5EA",
        200: "#81E6D9",
        300: "#4FD1C5",
        400: "#38B2AC",
        500: "#319795",
        600: "#2C7A7B",
        700: "#285E61",
        800: "#234E52",
        900: "#1D4044"
    },
    blue: {
        50: "#ebf8ff",
        100: "#bee3f8",
        200: "#90cdf4",
        300: "#63b3ed",
        400: "#4299e1",
        500: "#3182ce",
        600: "#2b6cb0",
        700: "#2c5282",
        800: "#2a4365",
        900: "#1A365D"
    },
    cyan: {
        50: "#EDFDFD",
        100: "#C4F1F9",
        200: "#9DECF9",
        300: "#76E4F7",
        400: "#0BC5EA",
        500: "#00B5D8",
        600: "#00A3C4",
        700: "#0987A0",
        800: "#086F83",
        900: "#065666"
    },
    purple: {
        50: "#FAF5FF",
        100: "#E9D8FD",
        200: "#D6BCFA",
        300: "#B794F4",
        400: "#9F7AEA",
        500: "#805AD5",
        600: "#6B46C1",
        700: "#553C9A",
        800: "#44337A",
        900: "#322659"
    },
    pink: {
        50: "#FFF5F7",
        100: "#FED7E2",
        200: "#FBB6CE",
        300: "#F687B3",
        400: "#ED64A6",
        500: "#D53F8C",
        600: "#B83280",
        700: "#97266D",
        800: "#702459",
        900: "#521B41"
    },
    linkedin: {
        50: "#E8F4F9",
        100: "#CFEDFB",
        200: "#9BDAF3",
        300: "#68C7EC",
        400: "#34B3E4",
        500: "#00A0DC",
        600: "#008CC9",
        700: "#0077B5",
        800: "#005E93",
        900: "#004471"
    },
    facebook: {
        50: "#E8F4F9",
        100: "#D9DEE9",
        200: "#B7C2DA",
        300: "#6482C0",
        400: "#4267B2",
        500: "#385898",
        600: "#314E89",
        700: "#29487D",
        800: "#223B67",
        900: "#1E355B"
    },
    messenger: {
        50: "#D0E6FF",
        100: "#B9DAFF",
        200: "#A2CDFF",
        300: "#7AB8FF",
        400: "#2E90FF",
        500: "#0078FF",
        600: "#0063D1",
        700: "#0052AC",
        800: "#003C7E",
        900: "#002C5C"
    },
    whatsapp: {
        50: "#dffeec",
        100: "#b9f5d0",
        200: "#90edb3",
        300: "#65e495",
        400: "#3cdd78",
        500: "#22c35e",
        600: "#179848",
        700: "#0c6c33",
        800: "#01421c",
        900: "#001803"
    },
    twitter: {
        50: "#E5F4FD",
        100: "#C8E9FB",
        200: "#A8DCFA",
        300: "#83CDF7",
        400: "#57BBF5",
        500: "#1DA1F2",
        600: "#1A94DA",
        700: "#1681BF",
        800: "#136B9E",
        900: "#0D4D71"
    },
    telegram: {
        50: "#E3F2F9",
        100: "#C5E4F3",
        200: "#A2D4EC",
        300: "#7AC1E4",
        400: "#47A9DA",
        500: "#0088CC",
        600: "#007AB8",
        700: "#006BA1",
        800: "#005885",
        900: "#003F5E"
    }
};
var $54da5336d471546d$export$59d2d4241383b416 = $54da5336d471546d$var$colors;

});

parcelRegister("iJr7n", function(module, exports) {

$parcel$export(module.exports, "radius_default", () => $bac1dd8906017cb4$export$9aaceac1356558f4);
// src/foundations/radius.ts
var $bac1dd8906017cb4$var$radii = {
    none: "0",
    sm: "0.125rem",
    base: "0.25rem",
    md: "0.375rem",
    lg: "0.5rem",
    xl: "0.75rem",
    "2xl": "1rem",
    "3xl": "1.5rem",
    full: "9999px"
};
var $bac1dd8906017cb4$export$9aaceac1356558f4 = $bac1dd8906017cb4$var$radii;

});

parcelRegister("p65bk", function(module, exports) {

$parcel$export(module.exports, "shadows_default", () => $e60e9033ad6fcda6$export$e70f92e6000288b2);
// src/foundations/shadows.ts
var $e60e9033ad6fcda6$var$shadows = {
    xs: "0 0 0 1px rgba(0, 0, 0, 0.05)",
    sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    outline: "0 0 0 3px rgba(66, 153, 225, 0.6)",
    inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
    none: "none",
    "dark-lg": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px"
};
var $e60e9033ad6fcda6$export$e70f92e6000288b2 = $e60e9033ad6fcda6$var$shadows;

});

parcelRegister("jFI2h", function(module, exports) {

$parcel$export(module.exports, "blur_default", () => $4ca04c84fe2edb48$export$6b4e890355bf1451);
// src/foundations/blur.ts
var $4ca04c84fe2edb48$var$blur = {
    none: 0,
    sm: "4px",
    base: "8px",
    md: "12px",
    lg: "16px",
    xl: "24px",
    "2xl": "40px",
    "3xl": "64px"
};
var $4ca04c84fe2edb48$export$6b4e890355bf1451 = $4ca04c84fe2edb48$var$blur;

});

parcelRegister("9Ga7i", function(module, exports) {

$parcel$export(module.exports, "typography_default", () => $701c55f00eb3e61f$export$d7c5d8884f83c8db);
// src/foundations/typography.ts
var $701c55f00eb3e61f$var$typography = {
    letterSpacings: {
        tighter: "-0.05em",
        tight: "-0.025em",
        normal: "0",
        wide: "0.025em",
        wider: "0.05em",
        widest: "0.1em"
    },
    lineHeights: {
        normal: "normal",
        none: 1,
        shorter: 1.25,
        short: 1.375,
        base: 1.5,
        tall: 1.625,
        taller: "2",
        "3": ".75rem",
        "4": "1rem",
        "5": "1.25rem",
        "6": "1.5rem",
        "7": "1.75rem",
        "8": "2rem",
        "9": "2.25rem",
        "10": "2.5rem"
    },
    fontWeights: {
        hairline: 100,
        thin: 200,
        light: 300,
        normal: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
        extrabold: 800,
        black: 900
    },
    fonts: {
        heading: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
        body: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
        mono: `SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace`
    },
    fontSizes: {
        "3xs": "0.45rem",
        "2xs": "0.625rem",
        xs: "0.75rem",
        sm: "0.875rem",
        md: "1rem",
        lg: "1.125rem",
        xl: "1.25rem",
        "2xl": "1.5rem",
        "3xl": "1.875rem",
        "4xl": "2.25rem",
        "5xl": "3rem",
        "6xl": "3.75rem",
        "7xl": "4.5rem",
        "8xl": "6rem",
        "9xl": "8rem"
    }
};
var $701c55f00eb3e61f$export$d7c5d8884f83c8db = $701c55f00eb3e61f$var$typography;

});

parcelRegister("gaCnF", function(module, exports) {

$parcel$export(module.exports, "sizes_default", () => $b8c791161442fb17$export$d7d4c689520cc141);

var $7kUBF = parcelRequire("7kUBF");
// src/foundations/sizes.ts
var $b8c791161442fb17$var$largeSizes = {
    max: "max-content",
    min: "min-content",
    full: "100%",
    "3xs": "14rem",
    "2xs": "16rem",
    xs: "20rem",
    sm: "24rem",
    md: "28rem",
    lg: "32rem",
    xl: "36rem",
    "2xl": "42rem",
    "3xl": "48rem",
    "4xl": "56rem",
    "5xl": "64rem",
    "6xl": "72rem",
    "7xl": "80rem",
    "8xl": "90rem",
    prose: "60ch"
};
var $b8c791161442fb17$var$container = {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px"
};
var $b8c791161442fb17$var$sizes = {
    ...(0, $7kUBF.spacing),
    ...$b8c791161442fb17$var$largeSizes,
    container: $b8c791161442fb17$var$container
};
var $b8c791161442fb17$export$d7d4c689520cc141 = $b8c791161442fb17$var$sizes;

});
parcelRegister("7kUBF", function(module, exports) {

$parcel$export(module.exports, "spacing", () => $f6186c99a870f6a9$export$5458b64234d1333c);
// src/foundations/spacing.ts
var $f6186c99a870f6a9$export$5458b64234d1333c = {
    px: "1px",
    0.5: "0.125rem",
    1: "0.25rem",
    1.5: "0.375rem",
    2: "0.5rem",
    2.5: "0.625rem",
    3: "0.75rem",
    3.5: "0.875rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem",
    12: "3rem",
    14: "3.5rem",
    16: "4rem",
    20: "5rem",
    24: "6rem",
    28: "7rem",
    32: "8rem",
    36: "9rem",
    40: "10rem",
    44: "11rem",
    48: "12rem",
    52: "13rem",
    56: "14rem",
    60: "15rem",
    64: "16rem",
    72: "18rem",
    80: "20rem",
    96: "24rem"
};

});



parcelRegister("fYVi8", function(module, exports) {

$parcel$export(module.exports, "components", () => $142131269f70d5cf$export$9b5ac10f59f76296);

var $5SU4f = parcelRequire("5SU4f");

var $cEzbc = parcelRequire("cEzbc");

var $jxvl5 = parcelRequire("jxvl5");

var $pZz4A = parcelRequire("pZz4A");

var $hwP0N = parcelRequire("hwP0N");

var $7wsB6 = parcelRequire("7wsB6");

var $i99Ar = parcelRequire("i99Ar");

var $aeJy0 = parcelRequire("aeJy0");

var $b8oZC = parcelRequire("b8oZC");

var $9jvtP = parcelRequire("9jvtP");

var $d4yAi = parcelRequire("d4yAi");

var $jlmfx = parcelRequire("jlmfx");

var $2g6Sl = parcelRequire("2g6Sl");

var $7X6L3 = parcelRequire("7X6L3");

var $eF9wh = parcelRequire("eF9wh");

var $h5VHX = parcelRequire("h5VHX");

var $1Dk22 = parcelRequire("1Dk22");

var $4bM5v = parcelRequire("4bM5v");

var $hEzBz = parcelRequire("hEzBz");

var $cKFPW = parcelRequire("cKFPW");

var $4C8RC = parcelRequire("4C8RC");

var $ggOLH = parcelRequire("ggOLH");

var $i9UZR = parcelRequire("i9UZR");

var $gMjvz = parcelRequire("gMjvz");

var $PGq40 = parcelRequire("PGq40");

var $6uUdM = parcelRequire("6uUdM");

var $iQWhh = parcelRequire("iQWhh");

var $efA8t = parcelRequire("efA8t");

var $1Rusw = parcelRequire("1Rusw");

var $emFSB = parcelRequire("emFSB");

var $kOTB2 = parcelRequire("kOTB2");

var $hmXYt = parcelRequire("hmXYt");

var $9jHpS = parcelRequire("9jHpS");

var $7mN8G = parcelRequire("7mN8G");

var $81GGp = parcelRequire("81GGp");

var $iM5Xt = parcelRequire("iM5Xt");

var $ljTCa = parcelRequire("ljTCa");

var $beR3a = parcelRequire("beR3a");

var $cSNX1 = parcelRequire("cSNX1");

var $3avqj = parcelRequire("3avqj");

var $btPEZ = parcelRequire("btPEZ");

var $aALPx = parcelRequire("aALPx");
// src/components/index.ts
var $142131269f70d5cf$export$9b5ac10f59f76296 = {
    Accordion: (0, $cSNX1.accordionTheme),
    Alert: (0, $3avqj.alertTheme),
    Avatar: (0, $btPEZ.avatarTheme),
    Badge: (0, $aALPx.badgeTheme),
    Breadcrumb: (0, $kOTB2.breadcrumbTheme),
    Button: (0, $hmXYt.buttonTheme),
    Checkbox: (0, $7mN8G.checkboxTheme),
    CloseButton: (0, $81GGp.closeButtonTheme),
    Code: (0, $iM5Xt.codeTheme),
    Container: (0, $ljTCa.containerTheme),
    Divider: (0, $beR3a.dividerTheme),
    Drawer: (0, $gMjvz.drawerTheme),
    Editable: (0, $PGq40.editableTheme),
    Form: (0, $6uUdM.formTheme),
    FormError: (0, $iQWhh.formErrorTheme),
    FormLabel: (0, $efA8t.formLabelTheme),
    Heading: (0, $1Rusw.headingTheme),
    Input: (0, $emFSB.inputTheme),
    Kbd: (0, $h5VHX.kbdTheme),
    Link: (0, $1Dk22.linkTheme),
    List: (0, $4bM5v.listTheme),
    Menu: (0, $hEzBz.menuTheme),
    Modal: (0, $cKFPW.modalTheme),
    NumberInput: (0, $4C8RC.numberInputTheme),
    PinInput: (0, $ggOLH.pinInputTheme),
    Popover: (0, $i9UZR.popoverTheme),
    Progress: (0, $aeJy0.progressTheme),
    Radio: (0, $b8oZC.radioTheme),
    Select: (0, $9jvtP.selectTheme),
    Skeleton: (0, $d4yAi.skeletonTheme),
    SkipLink: (0, $jlmfx.skipLinkTheme),
    Slider: (0, $2g6Sl.sliderTheme),
    Spinner: (0, $7X6L3.spinnerTheme),
    Stat: (0, $eF9wh.statTheme),
    Switch: (0, $cEzbc.switchTheme),
    Table: (0, $jxvl5.tableTheme),
    Tabs: (0, $pZz4A.tabsTheme),
    Tag: (0, $hwP0N.tagTheme),
    Textarea: (0, $7wsB6.textareaTheme),
    Tooltip: (0, $i99Ar.tooltipTheme),
    Card: (0, $9jHpS.cardTheme),
    Stepper: (0, $5SU4f.stepperTheme)
};

});
parcelRegister("5SU4f", function(module, exports) {

$parcel$export(module.exports, "stepperTheme", () => $d77f2b6c365e1950$export$54c84d54375c8d75);
// src/components/stepper.ts

var $cDoMf = parcelRequire("cDoMf");
var { defineMultiStyleConfig: $d77f2b6c365e1950$var$defineMultiStyleConfig, definePartsStyle: $d77f2b6c365e1950$var$definePartsStyle } = (0, $cDoMf.createMultiStyleConfigHelpers)([
    "stepper",
    "step",
    "title",
    "description",
    "indicator",
    "separator",
    "icon",
    "number"
]);
var $d77f2b6c365e1950$var$$size = (0, $cDoMf.cssVar)("stepper-indicator-size");
var $d77f2b6c365e1950$var$$iconSize = (0, $cDoMf.cssVar)("stepper-icon-size");
var $d77f2b6c365e1950$var$$titleFontSize = (0, $cDoMf.cssVar)("stepper-title-font-size");
var $d77f2b6c365e1950$var$$descFontSize = (0, $cDoMf.cssVar)("stepper-description-font-size");
var $d77f2b6c365e1950$var$$accentColor = (0, $cDoMf.cssVar)("stepper-accent-color");
var $d77f2b6c365e1950$var$baseStyle = $d77f2b6c365e1950$var$definePartsStyle(({ colorScheme: c })=>({
        stepper: {
            display: "flex",
            justifyContent: "space-between",
            gap: "4",
            "&[data-orientation=vertical]": {
                flexDirection: "column",
                alignItems: "flex-start"
            },
            "&[data-orientation=horizontal]": {
                flexDirection: "row",
                alignItems: "center"
            },
            [$d77f2b6c365e1950$var$$accentColor.variable]: `colors.${c}.500`,
            _dark: {
                [$d77f2b6c365e1950$var$$accentColor.variable]: `colors.${c}.200`
            }
        },
        title: {
            fontSize: $d77f2b6c365e1950$var$$titleFontSize.reference,
            fontWeight: "medium"
        },
        description: {
            fontSize: $d77f2b6c365e1950$var$$descFontSize.reference,
            color: "chakra-subtle-text"
        },
        number: {
            fontSize: $d77f2b6c365e1950$var$$titleFontSize.reference
        },
        step: {
            flexShrink: 0,
            position: "relative",
            display: "flex",
            gap: "2",
            "&[data-orientation=horizontal]": {
                alignItems: "center"
            },
            flex: "1",
            "&:last-of-type:not([data-stretch])": {
                flex: "initial"
            }
        },
        icon: {
            flexShrink: 0,
            width: $d77f2b6c365e1950$var$$iconSize.reference,
            height: $d77f2b6c365e1950$var$$iconSize.reference
        },
        indicator: {
            flexShrink: 0,
            borderRadius: "full",
            width: $d77f2b6c365e1950$var$$size.reference,
            height: $d77f2b6c365e1950$var$$size.reference,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "&[data-status=active]": {
                borderWidth: "2px",
                borderColor: $d77f2b6c365e1950$var$$accentColor.reference
            },
            "&[data-status=complete]": {
                bg: $d77f2b6c365e1950$var$$accentColor.reference,
                color: "chakra-inverse-text"
            },
            "&[data-status=incomplete]": {
                borderWidth: "2px"
            }
        },
        separator: {
            bg: "chakra-border-color",
            flex: "1",
            "&[data-status=complete]": {
                bg: $d77f2b6c365e1950$var$$accentColor.reference
            },
            "&[data-orientation=horizontal]": {
                width: "100%",
                height: "2px",
                marginStart: "2"
            },
            "&[data-orientation=vertical]": {
                width: "2px",
                position: "absolute",
                height: "100%",
                maxHeight: `calc(100% - ${$d77f2b6c365e1950$var$$size.reference} - 8px)`,
                top: `calc(${$d77f2b6c365e1950$var$$size.reference} + 4px)`,
                insetStart: `calc(${$d77f2b6c365e1950$var$$size.reference} / 2 - 1px)`
            }
        }
    }));
var $d77f2b6c365e1950$export$54c84d54375c8d75 = $d77f2b6c365e1950$var$defineMultiStyleConfig({
    baseStyle: $d77f2b6c365e1950$var$baseStyle,
    sizes: {
        xs: $d77f2b6c365e1950$var$definePartsStyle({
            stepper: {
                [$d77f2b6c365e1950$var$$size.variable]: "sizes.4",
                [$d77f2b6c365e1950$var$$iconSize.variable]: "sizes.3",
                [$d77f2b6c365e1950$var$$titleFontSize.variable]: "fontSizes.xs",
                [$d77f2b6c365e1950$var$$descFontSize.variable]: "fontSizes.xs"
            }
        }),
        sm: $d77f2b6c365e1950$var$definePartsStyle({
            stepper: {
                [$d77f2b6c365e1950$var$$size.variable]: "sizes.6",
                [$d77f2b6c365e1950$var$$iconSize.variable]: "sizes.4",
                [$d77f2b6c365e1950$var$$titleFontSize.variable]: "fontSizes.sm",
                [$d77f2b6c365e1950$var$$descFontSize.variable]: "fontSizes.xs"
            }
        }),
        md: $d77f2b6c365e1950$var$definePartsStyle({
            stepper: {
                [$d77f2b6c365e1950$var$$size.variable]: "sizes.8",
                [$d77f2b6c365e1950$var$$iconSize.variable]: "sizes.5",
                [$d77f2b6c365e1950$var$$titleFontSize.variable]: "fontSizes.md",
                [$d77f2b6c365e1950$var$$descFontSize.variable]: "fontSizes.sm"
            }
        }),
        lg: $d77f2b6c365e1950$var$definePartsStyle({
            stepper: {
                [$d77f2b6c365e1950$var$$size.variable]: "sizes.10",
                [$d77f2b6c365e1950$var$$iconSize.variable]: "sizes.6",
                [$d77f2b6c365e1950$var$$titleFontSize.variable]: "fontSizes.lg",
                [$d77f2b6c365e1950$var$$descFontSize.variable]: "fontSizes.md"
            }
        })
    },
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});

});

parcelRegister("cEzbc", function(module, exports) {

$parcel$export(module.exports, "switchTheme", () => $0cb4285ef90e8c51$export$6856b73e98185bff);
// src/components/switch.ts

var $jNq6g = parcelRequire("jNq6g");

var $cDoMf = parcelRequire("cDoMf");

var $8rLXU = parcelRequire("8rLXU");
var $9TrBA = parcelRequire("9TrBA");
var { defineMultiStyleConfig: $0cb4285ef90e8c51$var$defineMultiStyleConfig, definePartsStyle: $0cb4285ef90e8c51$var$definePartsStyle } = (0, $cDoMf.createMultiStyleConfigHelpers)((0, $jNq6g.switchAnatomy).keys);
var $0cb4285ef90e8c51$var$$width = (0, $9TrBA.cssVar)("switch-track-width");
var $0cb4285ef90e8c51$var$$height = (0, $9TrBA.cssVar)("switch-track-height");
var $0cb4285ef90e8c51$var$$diff = (0, $9TrBA.cssVar)("switch-track-diff");
var $0cb4285ef90e8c51$var$diffValue = (0, $8rLXU.calc).subtract($0cb4285ef90e8c51$var$$width, $0cb4285ef90e8c51$var$$height);
var $0cb4285ef90e8c51$var$$translateX = (0, $9TrBA.cssVar)("switch-thumb-x");
var $0cb4285ef90e8c51$var$$bg = (0, $9TrBA.cssVar)("switch-bg");
var $0cb4285ef90e8c51$var$baseStyleTrack = (0, $cDoMf.defineStyle)((props)=>{
    const { colorScheme: c } = props;
    return {
        borderRadius: "full",
        p: "0.5",
        width: [
            $0cb4285ef90e8c51$var$$width.reference
        ],
        height: [
            $0cb4285ef90e8c51$var$$height.reference
        ],
        transitionProperty: "common",
        transitionDuration: "fast",
        [$0cb4285ef90e8c51$var$$bg.variable]: "colors.gray.300",
        _dark: {
            [$0cb4285ef90e8c51$var$$bg.variable]: "colors.whiteAlpha.400"
        },
        _focusVisible: {
            boxShadow: "outline"
        },
        _disabled: {
            opacity: 0.4,
            cursor: "not-allowed"
        },
        _checked: {
            [$0cb4285ef90e8c51$var$$bg.variable]: `colors.${c}.500`,
            _dark: {
                [$0cb4285ef90e8c51$var$$bg.variable]: `colors.${c}.200`
            }
        },
        bg: $0cb4285ef90e8c51$var$$bg.reference
    };
});
var $0cb4285ef90e8c51$var$baseStyleThumb = (0, $cDoMf.defineStyle)({
    bg: "white",
    transitionProperty: "transform",
    transitionDuration: "normal",
    borderRadius: "inherit",
    width: [
        $0cb4285ef90e8c51$var$$height.reference
    ],
    height: [
        $0cb4285ef90e8c51$var$$height.reference
    ],
    _checked: {
        transform: `translateX(${$0cb4285ef90e8c51$var$$translateX.reference})`
    }
});
var $0cb4285ef90e8c51$var$baseStyle = $0cb4285ef90e8c51$var$definePartsStyle((props)=>({
        container: {
            [$0cb4285ef90e8c51$var$$diff.variable]: $0cb4285ef90e8c51$var$diffValue,
            [$0cb4285ef90e8c51$var$$translateX.variable]: $0cb4285ef90e8c51$var$$diff.reference,
            _rtl: {
                [$0cb4285ef90e8c51$var$$translateX.variable]: (0, $8rLXU.calc)($0cb4285ef90e8c51$var$$diff).negate().toString()
            }
        },
        track: $0cb4285ef90e8c51$var$baseStyleTrack(props),
        thumb: $0cb4285ef90e8c51$var$baseStyleThumb
    }));
var $0cb4285ef90e8c51$var$sizes = {
    sm: $0cb4285ef90e8c51$var$definePartsStyle({
        container: {
            [$0cb4285ef90e8c51$var$$width.variable]: "1.375rem",
            [$0cb4285ef90e8c51$var$$height.variable]: "sizes.3"
        }
    }),
    md: $0cb4285ef90e8c51$var$definePartsStyle({
        container: {
            [$0cb4285ef90e8c51$var$$width.variable]: "1.875rem",
            [$0cb4285ef90e8c51$var$$height.variable]: "sizes.4"
        }
    }),
    lg: $0cb4285ef90e8c51$var$definePartsStyle({
        container: {
            [$0cb4285ef90e8c51$var$$width.variable]: "2.875rem",
            [$0cb4285ef90e8c51$var$$height.variable]: "sizes.6"
        }
    })
};
var $0cb4285ef90e8c51$export$6856b73e98185bff = $0cb4285ef90e8c51$var$defineMultiStyleConfig({
    baseStyle: $0cb4285ef90e8c51$var$baseStyle,
    sizes: $0cb4285ef90e8c51$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});

});
parcelRegister("jNq6g", function(module, exports) {

$parcel$export(module.exports, "accordionAnatomy", () => $8be8bf2b8c9e74e2$export$377a77e99e7c73a5);
$parcel$export(module.exports, "alertAnatomy", () => $8be8bf2b8c9e74e2$export$fc51889fa4de265a);
$parcel$export(module.exports, "avatarAnatomy", () => $8be8bf2b8c9e74e2$export$60f8655d889e17c7);
$parcel$export(module.exports, "breadcrumbAnatomy", () => $8be8bf2b8c9e74e2$export$2fb03f744a6ecf93);
$parcel$export(module.exports, "checkboxAnatomy", () => $8be8bf2b8c9e74e2$export$21946b04497ed6ac);
$parcel$export(module.exports, "drawerAnatomy", () => $8be8bf2b8c9e74e2$export$d3f4aaa4b0f2907a);
$parcel$export(module.exports, "editableAnatomy", () => $8be8bf2b8c9e74e2$export$2813c9511eeab082);
$parcel$export(module.exports, "formAnatomy", () => $8be8bf2b8c9e74e2$export$4b243e3f209a7e5e);
$parcel$export(module.exports, "formErrorAnatomy", () => $8be8bf2b8c9e74e2$export$bb18c440c00e82d9);
$parcel$export(module.exports, "inputAnatomy", () => $8be8bf2b8c9e74e2$export$1ffeb100b532f46d);
$parcel$export(module.exports, "listAnatomy", () => $8be8bf2b8c9e74e2$export$12b3a655a94374ed);
$parcel$export(module.exports, "menuAnatomy", () => $8be8bf2b8c9e74e2$export$e251092a5dcb1329);
$parcel$export(module.exports, "modalAnatomy", () => $8be8bf2b8c9e74e2$export$34e33beb8d992ac2);
$parcel$export(module.exports, "numberInputAnatomy", () => $8be8bf2b8c9e74e2$export$859cc7ca3200df97);
$parcel$export(module.exports, "popoverAnatomy", () => $8be8bf2b8c9e74e2$export$afda07d12cd4337d);
$parcel$export(module.exports, "progressAnatomy", () => $8be8bf2b8c9e74e2$export$ba6328c242bd649c);
$parcel$export(module.exports, "radioAnatomy", () => $8be8bf2b8c9e74e2$export$d28d06d0e29ef022);
$parcel$export(module.exports, "selectAnatomy", () => $8be8bf2b8c9e74e2$export$17993f0be9538b5a);
$parcel$export(module.exports, "sliderAnatomy", () => $8be8bf2b8c9e74e2$export$c21b4b3f8b239f32);
$parcel$export(module.exports, "statAnatomy", () => $8be8bf2b8c9e74e2$export$2cfbad67ae6ee421);
$parcel$export(module.exports, "switchAnatomy", () => $8be8bf2b8c9e74e2$export$921c1a2d1ce1e86a);
$parcel$export(module.exports, "tableAnatomy", () => $8be8bf2b8c9e74e2$export$8b1b9cdd5db9f5fd);
$parcel$export(module.exports, "tabsAnatomy", () => $8be8bf2b8c9e74e2$export$97383552563be58d);
$parcel$export(module.exports, "tagAnatomy", () => $8be8bf2b8c9e74e2$export$4c2f5f7f2ea94a8e);
$parcel$export(module.exports, "cardAnatomy", () => $8be8bf2b8c9e74e2$export$487a447ffa5755b6);

var $dA0wf = parcelRequire("dA0wf");
// src/components.ts
var $8be8bf2b8c9e74e2$export$377a77e99e7c73a5 = (0, $dA0wf.anatomy)("accordion").parts("root", "container", "button", "panel").extend("icon");
var $8be8bf2b8c9e74e2$export$fc51889fa4de265a = (0, $dA0wf.anatomy)("alert").parts("title", "description", "container").extend("icon", "spinner");
var $8be8bf2b8c9e74e2$export$60f8655d889e17c7 = (0, $dA0wf.anatomy)("avatar").parts("label", "badge", "container").extend("excessLabel", "group");
var $8be8bf2b8c9e74e2$export$2fb03f744a6ecf93 = (0, $dA0wf.anatomy)("breadcrumb").parts("link", "item", "container").extend("separator");
var $8be8bf2b8c9e74e2$export$1699c5cb20c07888 = (0, $dA0wf.anatomy)("button").parts();
var $8be8bf2b8c9e74e2$export$21946b04497ed6ac = (0, $dA0wf.anatomy)("checkbox").parts("control", "icon", "container").extend("label");
var $8be8bf2b8c9e74e2$export$2c953111278f3272 = (0, $dA0wf.anatomy)("progress").parts("track", "filledTrack").extend("label");
var $8be8bf2b8c9e74e2$export$d3f4aaa4b0f2907a = (0, $dA0wf.anatomy)("drawer").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
var $8be8bf2b8c9e74e2$export$2813c9511eeab082 = (0, $dA0wf.anatomy)("editable").parts("preview", "input", "textarea");
var $8be8bf2b8c9e74e2$export$4b243e3f209a7e5e = (0, $dA0wf.anatomy)("form").parts("container", "requiredIndicator", "helperText");
var $8be8bf2b8c9e74e2$export$bb18c440c00e82d9 = (0, $dA0wf.anatomy)("formError").parts("text", "icon");
var $8be8bf2b8c9e74e2$export$1ffeb100b532f46d = (0, $dA0wf.anatomy)("input").parts("addon", "field", "element", "group");
var $8be8bf2b8c9e74e2$export$12b3a655a94374ed = (0, $dA0wf.anatomy)("list").parts("container", "item", "icon");
var $8be8bf2b8c9e74e2$export$e251092a5dcb1329 = (0, $dA0wf.anatomy)("menu").parts("button", "list", "item").extend("groupTitle", "icon", "command", "divider");
var $8be8bf2b8c9e74e2$export$34e33beb8d992ac2 = (0, $dA0wf.anatomy)("modal").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
var $8be8bf2b8c9e74e2$export$859cc7ca3200df97 = (0, $dA0wf.anatomy)("numberinput").parts("root", "field", "stepperGroup", "stepper");
var $8be8bf2b8c9e74e2$export$12bb869d7991ac50 = (0, $dA0wf.anatomy)("pininput").parts("field");
var $8be8bf2b8c9e74e2$export$afda07d12cd4337d = (0, $dA0wf.anatomy)("popover").parts("content", "header", "body", "footer").extend("popper", "arrow", "closeButton");
var $8be8bf2b8c9e74e2$export$ba6328c242bd649c = (0, $dA0wf.anatomy)("progress").parts("label", "filledTrack", "track");
var $8be8bf2b8c9e74e2$export$d28d06d0e29ef022 = (0, $dA0wf.anatomy)("radio").parts("container", "control", "label");
var $8be8bf2b8c9e74e2$export$17993f0be9538b5a = (0, $dA0wf.anatomy)("select").parts("field", "icon");
var $8be8bf2b8c9e74e2$export$c21b4b3f8b239f32 = (0, $dA0wf.anatomy)("slider").parts("container", "track", "thumb", "filledTrack", "mark");
var $8be8bf2b8c9e74e2$export$2cfbad67ae6ee421 = (0, $dA0wf.anatomy)("stat").parts("container", "label", "helpText", "number", "icon");
var $8be8bf2b8c9e74e2$export$921c1a2d1ce1e86a = (0, $dA0wf.anatomy)("switch").parts("container", "track", "thumb", "label");
var $8be8bf2b8c9e74e2$export$8b1b9cdd5db9f5fd = (0, $dA0wf.anatomy)("table").parts("table", "thead", "tbody", "tr", "th", "td", "tfoot", "caption");
var $8be8bf2b8c9e74e2$export$97383552563be58d = (0, $dA0wf.anatomy)("tabs").parts("root", "tab", "tablist", "tabpanel", "tabpanels", "indicator");
var $8be8bf2b8c9e74e2$export$4c2f5f7f2ea94a8e = (0, $dA0wf.anatomy)("tag").parts("container", "label", "closeButton");
var $8be8bf2b8c9e74e2$export$487a447ffa5755b6 = (0, $dA0wf.anatomy)("card").parts("container", "header", "body", "footer");
var $8be8bf2b8c9e74e2$export$76976ae72ac68c27 = (0, $dA0wf.anatomy)("stepper").parts("stepper", "step", "title", "description", "indicator", "separator", "icon", "number");

});
parcelRegister("dA0wf", function(module, exports) {

$parcel$export(module.exports, "anatomy", () => $d38ba53e07312e42$export$477202748c7242bf);
// src/anatomy.ts
function $d38ba53e07312e42$export$477202748c7242bf(name, map = {}) {
    let called = false;
    function assert() {
        if (!called) {
            called = true;
            return;
        }
        throw new Error("[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?");
    }
    function parts(...values) {
        assert();
        for (const part of values)map[part] = toPart(part);
        return $d38ba53e07312e42$export$477202748c7242bf(name, map);
    }
    function extend(...parts2) {
        for (const part of parts2){
            if (part in map) continue;
            map[part] = toPart(part);
        }
        return $d38ba53e07312e42$export$477202748c7242bf(name, map);
    }
    function selectors() {
        const value = Object.fromEntries(Object.entries(map).map(([key, part])=>[
                key,
                part.selector
            ]));
        return value;
    }
    function classnames() {
        const value = Object.fromEntries(Object.entries(map).map(([key, part])=>[
                key,
                part.className
            ]));
        return value;
    }
    function toPart(part) {
        const el = [
            "container",
            "root"
        ].includes(part != null ? part : "") ? [
            name
        ] : [
            name,
            part
        ];
        const attr = el.filter(Boolean).join("__");
        const className = `chakra-${attr}`;
        const partObj = {
            className: className,
            selector: `.${className}`,
            toString: ()=>part
        };
        return partObj;
    }
    const __type = {};
    return {
        parts: parts,
        toPart: toPart,
        extend: extend,
        selectors: selectors,
        classnames: classnames,
        get keys () {
            return Object.keys(map);
        },
        __type: __type
    };
}

});


parcelRegister("8rLXU", function(module, exports) {

$parcel$export(module.exports, "calc", () => $414116a01325954a$export$42bfa9b2d4dad91a);
// src/css-calc.ts

var $iyhjB = parcelRequire("iyhjB");
function $414116a01325954a$var$toRef(operand) {
    if ((0, $iyhjB.isObject)(operand) && operand.reference) return operand.reference;
    return String(operand);
}
var $414116a01325954a$var$toExpr = (operator, ...operands)=>operands.map($414116a01325954a$var$toRef).join(` ${operator} `).replace(/calc/g, "");
var $414116a01325954a$var$add = (...operands)=>`calc(${$414116a01325954a$var$toExpr("+", ...operands)})`;
var $414116a01325954a$var$subtract = (...operands)=>`calc(${$414116a01325954a$var$toExpr("-", ...operands)})`;
var $414116a01325954a$var$multiply = (...operands)=>`calc(${$414116a01325954a$var$toExpr("*", ...operands)})`;
var $414116a01325954a$var$divide = (...operands)=>`calc(${$414116a01325954a$var$toExpr("/", ...operands)})`;
var $414116a01325954a$var$negate = (x)=>{
    const value = $414116a01325954a$var$toRef(x);
    if (value != null && !Number.isNaN(parseFloat(value))) return String(value).startsWith("-") ? String(value).slice(1) : `-${value}`;
    return $414116a01325954a$var$multiply(value, -1);
};
var $414116a01325954a$export$42bfa9b2d4dad91a = Object.assign((x)=>({
        add: (...operands)=>$414116a01325954a$export$42bfa9b2d4dad91a($414116a01325954a$var$add(x, ...operands)),
        subtract: (...operands)=>$414116a01325954a$export$42bfa9b2d4dad91a($414116a01325954a$var$subtract(x, ...operands)),
        multiply: (...operands)=>$414116a01325954a$export$42bfa9b2d4dad91a($414116a01325954a$var$multiply(x, ...operands)),
        divide: (...operands)=>$414116a01325954a$export$42bfa9b2d4dad91a($414116a01325954a$var$divide(x, ...operands)),
        negate: ()=>$414116a01325954a$export$42bfa9b2d4dad91a($414116a01325954a$var$negate(x)),
        toString: ()=>x.toString()
    }), {
    add: $414116a01325954a$var$add,
    subtract: $414116a01325954a$var$subtract,
    multiply: $414116a01325954a$var$multiply,
    divide: $414116a01325954a$var$divide,
    negate: $414116a01325954a$var$negate
});

});

parcelRegister("9TrBA", function(module, exports) {

$parcel$export(module.exports, "cssVar", () => $0d0a7d1e12627b8b$export$8b4981022bd80a4e);
// src/css-var.ts
function $0d0a7d1e12627b8b$export$2ad0182371401ea4(value) {
    return !Number.isInteger(parseFloat(value.toString()));
}
function $0d0a7d1e12627b8b$var$replaceWhiteSpace(value, replaceValue = "-") {
    return value.replace(/\s+/g, replaceValue);
}
function $0d0a7d1e12627b8b$var$escape(value) {
    const valueStr = $0d0a7d1e12627b8b$var$replaceWhiteSpace(value.toString());
    if (valueStr.includes("\\.")) return value;
    return $0d0a7d1e12627b8b$export$2ad0182371401ea4(value) ? valueStr.replace(".", `\\.`) : value;
}
function $0d0a7d1e12627b8b$export$9748efee331ec573(value, prefix = "") {
    return [
        prefix,
        $0d0a7d1e12627b8b$var$escape(value)
    ].filter(Boolean).join("-");
}
function $0d0a7d1e12627b8b$export$44410db3a43190e8(name, fallback) {
    return `var(${$0d0a7d1e12627b8b$var$escape(name)}${fallback ? `, ${fallback}` : ""})`;
}
function $0d0a7d1e12627b8b$export$e2ffa342f278b3a3(value, prefix = "") {
    return `--${$0d0a7d1e12627b8b$export$9748efee331ec573(value, prefix)}`;
}
function $0d0a7d1e12627b8b$export$8b4981022bd80a4e(name, options) {
    const cssVariable = $0d0a7d1e12627b8b$export$e2ffa342f278b3a3(name, options == null ? void 0 : options.prefix);
    return {
        variable: cssVariable,
        reference: $0d0a7d1e12627b8b$export$44410db3a43190e8(cssVariable, $0d0a7d1e12627b8b$var$getFallback(options == null ? void 0 : options.fallback))
    };
}
function $0d0a7d1e12627b8b$var$getFallback(fallback) {
    if (typeof fallback === "string") return fallback;
    return fallback == null ? void 0 : fallback.reference;
}

});


parcelRegister("jxvl5", function(module, exports) {

$parcel$export(module.exports, "tableTheme", () => $7b96c6d2b0745baf$export$3339219781bb5161);
// src/components/table.ts

var $jNq6g = parcelRequire("jNq6g");

var $cDoMf = parcelRequire("cDoMf");

var $kYGZ9 = parcelRequire("kYGZ9");
var { defineMultiStyleConfig: $7b96c6d2b0745baf$var$defineMultiStyleConfig, definePartsStyle: $7b96c6d2b0745baf$var$definePartsStyle } = (0, $cDoMf.createMultiStyleConfigHelpers)((0, $jNq6g.tableAnatomy).keys);
var $7b96c6d2b0745baf$var$baseStyle = $7b96c6d2b0745baf$var$definePartsStyle({
    table: {
        fontVariantNumeric: "lining-nums tabular-nums",
        borderCollapse: "collapse",
        width: "full"
    },
    th: {
        fontFamily: "heading",
        fontWeight: "bold",
        textTransform: "uppercase",
        letterSpacing: "wider",
        textAlign: "start"
    },
    td: {
        textAlign: "start"
    },
    caption: {
        mt: 4,
        fontFamily: "heading",
        textAlign: "center",
        fontWeight: "medium"
    }
});
var $7b96c6d2b0745baf$var$numericStyles = (0, $cDoMf.defineStyle)({
    "&[data-is-numeric=true]": {
        textAlign: "end"
    }
});
var $7b96c6d2b0745baf$var$variantSimple = $7b96c6d2b0745baf$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        th: {
            color: (0, $kYGZ9.mode)("gray.600", "gray.400")(props),
            borderBottom: "1px",
            borderColor: (0, $kYGZ9.mode)(`${c}.100`, `${c}.700`)(props),
            ...$7b96c6d2b0745baf$var$numericStyles
        },
        td: {
            borderBottom: "1px",
            borderColor: (0, $kYGZ9.mode)(`${c}.100`, `${c}.700`)(props),
            ...$7b96c6d2b0745baf$var$numericStyles
        },
        caption: {
            color: (0, $kYGZ9.mode)("gray.600", "gray.100")(props)
        },
        tfoot: {
            tr: {
                "&:last-of-type": {
                    th: {
                        borderBottomWidth: 0
                    }
                }
            }
        }
    };
});
var $7b96c6d2b0745baf$var$variantStripe = $7b96c6d2b0745baf$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        th: {
            color: (0, $kYGZ9.mode)("gray.600", "gray.400")(props),
            borderBottom: "1px",
            borderColor: (0, $kYGZ9.mode)(`${c}.100`, `${c}.700`)(props),
            ...$7b96c6d2b0745baf$var$numericStyles
        },
        td: {
            borderBottom: "1px",
            borderColor: (0, $kYGZ9.mode)(`${c}.100`, `${c}.700`)(props),
            ...$7b96c6d2b0745baf$var$numericStyles
        },
        caption: {
            color: (0, $kYGZ9.mode)("gray.600", "gray.100")(props)
        },
        tbody: {
            tr: {
                "&:nth-of-type(odd)": {
                    "th, td": {
                        borderBottomWidth: "1px",
                        borderColor: (0, $kYGZ9.mode)(`${c}.100`, `${c}.700`)(props)
                    },
                    td: {
                        background: (0, $kYGZ9.mode)(`${c}.100`, `${c}.700`)(props)
                    }
                }
            }
        },
        tfoot: {
            tr: {
                "&:last-of-type": {
                    th: {
                        borderBottomWidth: 0
                    }
                }
            }
        }
    };
});
var $7b96c6d2b0745baf$var$variants = {
    simple: $7b96c6d2b0745baf$var$variantSimple,
    striped: $7b96c6d2b0745baf$var$variantStripe,
    unstyled: (0, $cDoMf.defineStyle)({})
};
var $7b96c6d2b0745baf$var$sizes = {
    sm: $7b96c6d2b0745baf$var$definePartsStyle({
        th: {
            px: "4",
            py: "1",
            lineHeight: "4",
            fontSize: "xs"
        },
        td: {
            px: "4",
            py: "2",
            fontSize: "sm",
            lineHeight: "4"
        },
        caption: {
            px: "4",
            py: "2",
            fontSize: "xs"
        }
    }),
    md: $7b96c6d2b0745baf$var$definePartsStyle({
        th: {
            px: "6",
            py: "3",
            lineHeight: "4",
            fontSize: "xs"
        },
        td: {
            px: "6",
            py: "4",
            lineHeight: "5"
        },
        caption: {
            px: "6",
            py: "2",
            fontSize: "sm"
        }
    }),
    lg: $7b96c6d2b0745baf$var$definePartsStyle({
        th: {
            px: "8",
            py: "4",
            lineHeight: "5",
            fontSize: "sm"
        },
        td: {
            px: "8",
            py: "5",
            lineHeight: "6"
        },
        caption: {
            px: "6",
            py: "2",
            fontSize: "md"
        }
    })
};
var $7b96c6d2b0745baf$export$3339219781bb5161 = $7b96c6d2b0745baf$var$defineMultiStyleConfig({
    baseStyle: $7b96c6d2b0745baf$var$baseStyle,
    variants: $7b96c6d2b0745baf$var$variants,
    sizes: $7b96c6d2b0745baf$var$sizes,
    defaultProps: {
        variant: "simple",
        size: "md",
        colorScheme: "gray"
    }
});

});
parcelRegister("kYGZ9", function(module, exports) {

$parcel$export(module.exports, "mode", () => $f67737b903a02b73$export$549ff81930776885);
$parcel$export(module.exports, "orient", () => $f67737b903a02b73$export$f3eec17ee6065eee);
// src/component.ts
function $f67737b903a02b73$export$549ff81930776885(light, dark) {
    return (props)=>props.colorMode === "dark" ? dark : light;
}
function $f67737b903a02b73$export$f3eec17ee6065eee(options) {
    const { orientation: orientation, vertical: vertical, horizontal: horizontal } = options;
    if (!orientation) return {};
    return orientation === "vertical" ? vertical : horizontal;
}

});


parcelRegister("pZz4A", function(module, exports) {

$parcel$export(module.exports, "tabsTheme", () => $167bb939f79e1f29$export$847a245e7ebce2a1);
// src/components/tabs.ts

var $jNq6g = parcelRequire("jNq6g");

var $cDoMf = parcelRequire("cDoMf");

var $a99Nd = parcelRequire("a99Nd");
var $167bb939f79e1f29$var$$fg = (0, $cDoMf.cssVar)("tabs-color");
var $167bb939f79e1f29$var$$bg = (0, $cDoMf.cssVar)("tabs-bg");
var $167bb939f79e1f29$var$$border = (0, $cDoMf.cssVar)("tabs-border-color");
var { defineMultiStyleConfig: $167bb939f79e1f29$var$defineMultiStyleConfig, definePartsStyle: $167bb939f79e1f29$var$definePartsStyle } = (0, $cDoMf.createMultiStyleConfigHelpers)((0, $jNq6g.tabsAnatomy).keys);
var $167bb939f79e1f29$var$baseStyleRoot = (0, $cDoMf.defineStyle)((props)=>{
    const { orientation: orientation } = props;
    return {
        display: orientation === "vertical" ? "flex" : "block"
    };
});
var $167bb939f79e1f29$var$baseStyleTab = (0, $cDoMf.defineStyle)((props)=>{
    const { isFitted: isFitted } = props;
    return {
        flex: isFitted ? 1 : void 0,
        transitionProperty: "common",
        transitionDuration: "normal",
        _focusVisible: {
            zIndex: 1,
            boxShadow: "outline"
        },
        _disabled: {
            cursor: "not-allowed",
            opacity: 0.4
        }
    };
});
var $167bb939f79e1f29$var$baseStyleTablist = (0, $cDoMf.defineStyle)((props)=>{
    const { align: align = "start", orientation: orientation } = props;
    const alignments = {
        end: "flex-end",
        center: "center",
        start: "flex-start"
    };
    return {
        justifyContent: alignments[align],
        flexDirection: orientation === "vertical" ? "column" : "row"
    };
});
var $167bb939f79e1f29$var$baseStyleTabpanel = (0, $cDoMf.defineStyle)({
    p: 4
});
var $167bb939f79e1f29$var$baseStyle = $167bb939f79e1f29$var$definePartsStyle((props)=>({
        root: $167bb939f79e1f29$var$baseStyleRoot(props),
        tab: $167bb939f79e1f29$var$baseStyleTab(props),
        tablist: $167bb939f79e1f29$var$baseStyleTablist(props),
        tabpanel: $167bb939f79e1f29$var$baseStyleTabpanel
    }));
var $167bb939f79e1f29$var$sizes = {
    sm: $167bb939f79e1f29$var$definePartsStyle({
        tab: {
            py: 1,
            px: 4,
            fontSize: "sm"
        }
    }),
    md: $167bb939f79e1f29$var$definePartsStyle({
        tab: {
            fontSize: "md",
            py: 2,
            px: 4
        }
    }),
    lg: $167bb939f79e1f29$var$definePartsStyle({
        tab: {
            fontSize: "lg",
            py: 3,
            px: 4
        }
    })
};
var $167bb939f79e1f29$var$variantLine = $167bb939f79e1f29$var$definePartsStyle((props)=>{
    const { colorScheme: c, orientation: orientation } = props;
    const isVertical = orientation === "vertical";
    const borderProp = isVertical ? "borderStart" : "borderBottom";
    const marginProp = isVertical ? "marginStart" : "marginBottom";
    return {
        tablist: {
            [borderProp]: "2px solid",
            borderColor: "inherit"
        },
        tab: {
            [borderProp]: "2px solid",
            borderColor: "transparent",
            [marginProp]: "-2px",
            _selected: {
                [$167bb939f79e1f29$var$$fg.variable]: `colors.${c}.600`,
                _dark: {
                    [$167bb939f79e1f29$var$$fg.variable]: `colors.${c}.300`
                },
                borderColor: "currentColor"
            },
            _active: {
                [$167bb939f79e1f29$var$$bg.variable]: "colors.gray.200",
                _dark: {
                    [$167bb939f79e1f29$var$$bg.variable]: "colors.whiteAlpha.300"
                }
            },
            _disabled: {
                _active: {
                    bg: "none"
                }
            },
            color: $167bb939f79e1f29$var$$fg.reference,
            bg: $167bb939f79e1f29$var$$bg.reference
        }
    };
});
var $167bb939f79e1f29$var$variantEnclosed = $167bb939f79e1f29$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        tab: {
            borderTopRadius: "md",
            border: "1px solid",
            borderColor: "transparent",
            mb: "-1px",
            [$167bb939f79e1f29$var$$border.variable]: "transparent",
            _selected: {
                [$167bb939f79e1f29$var$$fg.variable]: `colors.${c}.600`,
                [$167bb939f79e1f29$var$$border.variable]: `colors.white`,
                _dark: {
                    [$167bb939f79e1f29$var$$fg.variable]: `colors.${c}.300`,
                    [$167bb939f79e1f29$var$$border.variable]: `colors.gray.800`
                },
                borderColor: "inherit",
                borderBottomColor: $167bb939f79e1f29$var$$border.reference
            },
            color: $167bb939f79e1f29$var$$fg.reference
        },
        tablist: {
            mb: "-1px",
            borderBottom: "1px solid",
            borderColor: "inherit"
        }
    };
});
var $167bb939f79e1f29$var$variantEnclosedColored = $167bb939f79e1f29$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        tab: {
            border: "1px solid",
            borderColor: "inherit",
            [$167bb939f79e1f29$var$$bg.variable]: "colors.gray.50",
            _dark: {
                [$167bb939f79e1f29$var$$bg.variable]: "colors.whiteAlpha.50"
            },
            mb: "-1px",
            _notLast: {
                marginEnd: "-1px"
            },
            _selected: {
                [$167bb939f79e1f29$var$$bg.variable]: "colors.white",
                [$167bb939f79e1f29$var$$fg.variable]: `colors.${c}.600`,
                _dark: {
                    [$167bb939f79e1f29$var$$bg.variable]: "colors.gray.800",
                    [$167bb939f79e1f29$var$$fg.variable]: `colors.${c}.300`
                },
                borderColor: "inherit",
                borderTopColor: "currentColor",
                borderBottomColor: "transparent"
            },
            color: $167bb939f79e1f29$var$$fg.reference,
            bg: $167bb939f79e1f29$var$$bg.reference
        },
        tablist: {
            mb: "-1px",
            borderBottom: "1px solid",
            borderColor: "inherit"
        }
    };
});
var $167bb939f79e1f29$var$variantSoftRounded = $167bb939f79e1f29$var$definePartsStyle((props)=>{
    const { colorScheme: c, theme: theme } = props;
    return {
        tab: {
            borderRadius: "full",
            fontWeight: "semibold",
            color: "gray.600",
            _selected: {
                color: (0, $a99Nd.getColor)(theme, `${c}.700`),
                bg: (0, $a99Nd.getColor)(theme, `${c}.100`)
            }
        }
    };
});
var $167bb939f79e1f29$var$variantSolidRounded = $167bb939f79e1f29$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        tab: {
            borderRadius: "full",
            fontWeight: "semibold",
            [$167bb939f79e1f29$var$$fg.variable]: "colors.gray.600",
            _dark: {
                [$167bb939f79e1f29$var$$fg.variable]: "inherit"
            },
            _selected: {
                [$167bb939f79e1f29$var$$fg.variable]: "colors.white",
                [$167bb939f79e1f29$var$$bg.variable]: `colors.${c}.600`,
                _dark: {
                    [$167bb939f79e1f29$var$$fg.variable]: "colors.gray.800",
                    [$167bb939f79e1f29$var$$bg.variable]: `colors.${c}.300`
                }
            },
            color: $167bb939f79e1f29$var$$fg.reference,
            bg: $167bb939f79e1f29$var$$bg.reference
        }
    };
});
var $167bb939f79e1f29$var$variantUnstyled = $167bb939f79e1f29$var$definePartsStyle({});
var $167bb939f79e1f29$var$variants = {
    line: $167bb939f79e1f29$var$variantLine,
    enclosed: $167bb939f79e1f29$var$variantEnclosed,
    "enclosed-colored": $167bb939f79e1f29$var$variantEnclosedColored,
    "soft-rounded": $167bb939f79e1f29$var$variantSoftRounded,
    "solid-rounded": $167bb939f79e1f29$var$variantSolidRounded,
    unstyled: $167bb939f79e1f29$var$variantUnstyled
};
var $167bb939f79e1f29$export$847a245e7ebce2a1 = $167bb939f79e1f29$var$defineMultiStyleConfig({
    baseStyle: $167bb939f79e1f29$var$baseStyle,
    sizes: $167bb939f79e1f29$var$sizes,
    variants: $167bb939f79e1f29$var$variants,
    defaultProps: {
        size: "md",
        variant: "line",
        colorScheme: "blue"
    }
});

});
parcelRegister("a99Nd", function(module, exports) {

$parcel$export(module.exports, "getColor", () => $f3e994159e05b407$export$5551a2d24ff40153);
$parcel$export(module.exports, "isDark", () => $f3e994159e05b407$export$a79ad82046afa44e);
$parcel$export(module.exports, "transparentize", () => $f3e994159e05b407$export$d11da87e55cc498f);
$parcel$export(module.exports, "generateStripe", () => $f3e994159e05b407$export$db0ffb03ee9f3080);
$parcel$export(module.exports, "randomColor", () => $f3e994159e05b407$export$f3c6ed4330abfc18);
// src/color.ts

var $cDoMf = parcelRequire("cDoMf");

var $kChKM = parcelRequire("kChKM");
// ../../../node_modules/.pnpm/dlv@1.1.3/node_modules/dlv/dist/dlv.es.js
function $f3e994159e05b407$var$dlv_es_default(t, e, l, n, r) {
    for(e = e.split ? e.split(".") : e, n = 0; n < e.length; n++)t = t ? t[e[n]] : r;
    return t === r ? l : t;
}
// src/color.ts
var $f3e994159e05b407$var$isEmptyObject = (obj)=>Object.keys(obj).length === 0;
var $f3e994159e05b407$export$5551a2d24ff40153 = (theme, color, fallback)=>{
    const hex = $f3e994159e05b407$var$dlv_es_default(theme, `colors.${color}`, color);
    try {
        (0, $kChKM.toHex)(hex);
        return hex;
    } catch  {
        return fallback != null ? fallback : "#000000";
    }
};
var $f3e994159e05b407$export$fdaf813cf8a11246 = (theme, color, fallback)=>{
    var _a;
    return (_a = (0, $cDoMf.getCSSVar)(theme, "colors", color)) != null ? _a : fallback;
};
var $f3e994159e05b407$var$getBrightness = (color)=>{
    const [r, g, b] = (0, $kChKM.parseToRgba)(color);
    return (r * 299 + g * 587 + b * 114) / 1e3;
};
var $f3e994159e05b407$export$7297c25227171a1f = (color)=>(theme)=>{
        const hex = $f3e994159e05b407$export$5551a2d24ff40153(theme, color);
        const brightness = $f3e994159e05b407$var$getBrightness(hex);
        const isDark2 = brightness < 128;
        return isDark2 ? "dark" : "light";
    };
var $f3e994159e05b407$export$a79ad82046afa44e = (color)=>(theme)=>$f3e994159e05b407$export$7297c25227171a1f(color)(theme) === "dark";
var $f3e994159e05b407$export$44af652f4cca9039 = (color)=>(theme)=>$f3e994159e05b407$export$7297c25227171a1f(color)(theme) === "light";
var $f3e994159e05b407$export$d11da87e55cc498f = (color, opacity)=>(theme)=>{
        const raw = $f3e994159e05b407$export$5551a2d24ff40153(theme, color);
        return (0, $kChKM.transparentize)(raw, 1 - opacity);
    };
var $f3e994159e05b407$export$81525e9955aa80e8 = (color, amount)=>(theme)=>{
        const raw = $f3e994159e05b407$export$5551a2d24ff40153(theme, color);
        return (0, $kChKM.toHex)((0, $kChKM.mix)(raw, "#fff", amount));
    };
var $f3e994159e05b407$export$2b471577c483101c = (color, amount)=>(theme)=>{
        const raw = $f3e994159e05b407$export$5551a2d24ff40153(theme, color);
        return (0, $kChKM.toHex)((0, $kChKM.mix)(raw, "#000", amount / 100));
    };
var $f3e994159e05b407$export$4b073707ff63303 = (color, amount)=>(theme)=>{
        const raw = $f3e994159e05b407$export$5551a2d24ff40153(theme, color);
        return (0, $kChKM.toHex)((0, $kChKM.darken)(raw, amount / 100));
    };
var $f3e994159e05b407$export$c0816ed86df316af = (color, amount)=>(theme)=>{
        const raw = $f3e994159e05b407$export$5551a2d24ff40153(theme, color);
        (0, $kChKM.toHex)((0, $kChKM.lighten)(raw, amount / 100));
    };
var $f3e994159e05b407$export$1ec78ac20028ebd4 = (fg, bg)=>(theme)=>(0, $kChKM.getContrast)($f3e994159e05b407$export$5551a2d24ff40153(theme, bg), $f3e994159e05b407$export$5551a2d24ff40153(theme, fg));
var $f3e994159e05b407$export$cd41ae544cfc2a65 = (textColor, bgColor, options)=>(theme)=>$f3e994159e05b407$export$3fe5b5ca1e6a6a28($f3e994159e05b407$export$5551a2d24ff40153(theme, bgColor), $f3e994159e05b407$export$5551a2d24ff40153(theme, textColor), options);
function $f3e994159e05b407$export$3fe5b5ca1e6a6a28(color1, color2, wcag2 = {
    level: "AA",
    size: "small"
}) {
    var _a, _b;
    const readabilityLevel = $f3e994159e05b407$export$b7b705aaad1c5b6a(color1, color2);
    switch(((_a = wcag2.level) != null ? _a : "AA") + ((_b = wcag2.size) != null ? _b : "small")){
        case "AAsmall":
        case "AAAlarge":
            return readabilityLevel >= 4.5;
        case "AAlarge":
            return readabilityLevel >= 3;
        case "AAAsmall":
            return readabilityLevel >= 7;
        default:
            return false;
    }
}
function $f3e994159e05b407$export$b7b705aaad1c5b6a(color1, color2) {
    return (Math.max((0, $kChKM.getLuminance)(color1), (0, $kChKM.getLuminance)(color2)) + 0.05) / (Math.min((0, $kChKM.getLuminance)(color1), (0, $kChKM.getLuminance)(color2)) + 0.05);
}
var $f3e994159e05b407$export$504efcfbebdbcaf = (color)=>(theme)=>{
        const raw = $f3e994159e05b407$export$5551a2d24ff40153(theme, color);
        const hsl = (0, $kChKM.parseToHsla)(raw);
        const complementHsl = Object.assign(hsl, [
            (hsl[0] + 180) % 360
        ]);
        return (0, $kChKM.toHex)((0, $kChKM.hsla)(...complementHsl));
    };
function $f3e994159e05b407$export$db0ffb03ee9f3080(size = "1rem", color = "rgba(255, 255, 255, 0.15)") {
    return {
        backgroundImage: `linear-gradient(
    45deg,
    ${color} 25%,
    transparent 25%,
    transparent 50%,
    ${color} 50%,
    ${color} 75%,
    transparent 75%,
    transparent
  )`,
        backgroundSize: `${size} ${size}`
    };
}
var $f3e994159e05b407$var$randomHex = ()=>`#${Math.floor(Math.random() * 16777215).toString(16).padEnd(6, "0")}`;
function $f3e994159e05b407$export$f3c6ed4330abfc18(opts) {
    const fallback = $f3e994159e05b407$var$randomHex();
    if (!opts || $f3e994159e05b407$var$isEmptyObject(opts)) return fallback;
    if (opts.string && opts.colors) return $f3e994159e05b407$var$randomColorFromList(opts.string, opts.colors);
    if (opts.string && !opts.colors) return $f3e994159e05b407$var$randomColorFromString(opts.string);
    if (opts.colors && !opts.string) return $f3e994159e05b407$var$randomFromList(opts.colors);
    return fallback;
}
function $f3e994159e05b407$var$randomColorFromString(str) {
    let hash = 0;
    if (str.length === 0) return hash.toString();
    for(let i = 0; i < str.length; i += 1){
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
    }
    let color = "#";
    for(let j = 0; j < 3; j += 1){
        const value = hash >> j * 8 & 255;
        color += `00${value.toString(16)}`.substr(-2);
    }
    return color;
}
function $f3e994159e05b407$var$randomColorFromList(str, list) {
    let index = 0;
    if (str.length === 0) return list[0];
    for(let i = 0; i < str.length; i += 1){
        index = str.charCodeAt(i) + ((index << 5) - index);
        index = index & index;
    }
    index = (index % list.length + list.length) % list.length;
    return list[index];
}
function $f3e994159e05b407$var$randomFromList(list) {
    return list[Math.floor(Math.random() * list.length)];
}

});
parcelRegister("kChKM", function(module, exports) {

$parcel$export(module.exports, "parseToRgba", () => $f02520c2c40a9787$export$88c26fe48243d749);
$parcel$export(module.exports, "parseToHsla", () => $f02520c2c40a9787$export$c7d9b10ca8edee87);
$parcel$export(module.exports, "hsla", () => $f02520c2c40a9787$export$810b04175080204c);
$parcel$export(module.exports, "darken", () => $f02520c2c40a9787$export$4b073707ff63303);
$parcel$export(module.exports, "getLuminance", () => $f02520c2c40a9787$export$c852d90bf7403b62);
$parcel$export(module.exports, "getContrast", () => $f02520c2c40a9787$export$850ce485a60d103b);
$parcel$export(module.exports, "mix", () => $f02520c2c40a9787$export$2c9e8a9632a706b2);
$parcel$export(module.exports, "lighten", () => $f02520c2c40a9787$export$c0816ed86df316af);
$parcel$export(module.exports, "transparentize", () => $f02520c2c40a9787$export$d11da87e55cc498f);
$parcel$export(module.exports, "toHex", () => $f02520c2c40a9787$export$7ea66e3774a60b67);
/**
 * A simple guard function:
 *
 * ```js
 * Math.min(Math.max(low, value), high)
 * ```
 */ function $f02520c2c40a9787$export$864d727b48066337(low, high, value) {
    return Math.min(Math.max(low, value), high);
}
class $f02520c2c40a9787$var$ColorError extends Error {
    constructor(color){
        super(`Failed to parse color: "${color}"`);
    }
}
var $f02520c2c40a9787$export$21f8cadbc4af9bbf = $f02520c2c40a9787$var$ColorError;
/**
 * Parses a color into red, gree, blue, alpha parts
 *
 * @param color the input color. Can be a RGB, RBGA, HSL, HSLA, or named color
 */ function $f02520c2c40a9787$export$88c26fe48243d749(color) {
    if (typeof color !== "string") throw new $f02520c2c40a9787$export$21f8cadbc4af9bbf(color);
    if (color.trim().toLowerCase() === "transparent") return [
        0,
        0,
        0,
        0
    ];
    let normalizedColor = color.trim();
    normalizedColor = $f02520c2c40a9787$var$namedColorRegex.test(color) ? $f02520c2c40a9787$var$nameToHex(color) : color;
    const reducedHexMatch = $f02520c2c40a9787$var$reducedHexRegex.exec(normalizedColor);
    if (reducedHexMatch) {
        const arr = Array.from(reducedHexMatch).slice(1);
        return [
            ...arr.slice(0, 3).map((x)=>parseInt($f02520c2c40a9787$var$r(x, 2), 16)),
            parseInt($f02520c2c40a9787$var$r(arr[3] || "f", 2), 16) / 255
        ];
    }
    const hexMatch = $f02520c2c40a9787$var$hexRegex.exec(normalizedColor);
    if (hexMatch) {
        const arr = Array.from(hexMatch).slice(1);
        return [
            ...arr.slice(0, 3).map((x)=>parseInt(x, 16)),
            parseInt(arr[3] || "ff", 16) / 255
        ];
    }
    const rgbaMatch = $f02520c2c40a9787$var$rgbaRegex.exec(normalizedColor);
    if (rgbaMatch) {
        const arr = Array.from(rgbaMatch).slice(1);
        return [
            ...arr.slice(0, 3).map((x)=>parseInt(x, 10)),
            parseFloat(arr[3] || "1")
        ];
    }
    const hslaMatch = $f02520c2c40a9787$var$hslaRegex.exec(normalizedColor);
    if (hslaMatch) {
        const [h, s, l, a] = Array.from(hslaMatch).slice(1).map(parseFloat);
        if ($f02520c2c40a9787$export$864d727b48066337(0, 100, s) !== s) throw new $f02520c2c40a9787$export$21f8cadbc4af9bbf(color);
        if ($f02520c2c40a9787$export$864d727b48066337(0, 100, l) !== l) throw new $f02520c2c40a9787$export$21f8cadbc4af9bbf(color);
        return [
            ...$f02520c2c40a9787$var$hslToRgb(h, s, l),
            Number.isNaN(a) ? 1 : a
        ];
    }
    throw new $f02520c2c40a9787$export$21f8cadbc4af9bbf(color);
}
function $f02520c2c40a9787$var$hash(str) {
    let hash = 5381;
    let i = str.length;
    while(i)hash = hash * 33 ^ str.charCodeAt(--i);
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */ return (hash >>> 0) % 2341;
}
const $f02520c2c40a9787$var$colorToInt = (x)=>parseInt(x.replace(/_/g, ""), 36);
const $f02520c2c40a9787$var$compressedColorMap = "1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm".split(" ").reduce((acc, next)=>{
    const key = $f02520c2c40a9787$var$colorToInt(next.substring(0, 3));
    const hex = $f02520c2c40a9787$var$colorToInt(next.substring(3)).toString(16);
    // NOTE: padStart could be used here but it breaks Node 6 compat
    // https://github.com/ricokahler/color2k/issues/351
    let prefix = "";
    for(let i = 0; i < 6 - hex.length; i++)prefix += "0";
    acc[key] = `${prefix}${hex}`;
    return acc;
}, {});
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 */ function $f02520c2c40a9787$var$nameToHex(color) {
    const normalizedColorName = color.toLowerCase().trim();
    const result = $f02520c2c40a9787$var$compressedColorMap[$f02520c2c40a9787$var$hash(normalizedColorName)];
    if (!result) throw new $f02520c2c40a9787$export$21f8cadbc4af9bbf(color);
    return `#${result}`;
}
const $f02520c2c40a9787$var$r = (str, amount)=>Array.from(Array(amount)).map(()=>str).join("");
const $f02520c2c40a9787$var$reducedHexRegex = new RegExp(`^#${$f02520c2c40a9787$var$r("([a-f0-9])", 3)}([a-f0-9])?$`, "i");
const $f02520c2c40a9787$var$hexRegex = new RegExp(`^#${$f02520c2c40a9787$var$r("([a-f0-9]{2})", 3)}([a-f0-9]{2})?$`, "i");
const $f02520c2c40a9787$var$rgbaRegex = new RegExp(`^rgba?\\(\\s*(\\d+)\\s*${$f02520c2c40a9787$var$r(",\\s*(\\d+)\\s*", 2)}(?:,\\s*([\\d.]+))?\\s*\\)$`, "i");
const $f02520c2c40a9787$var$hslaRegex = /^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i;
const $f02520c2c40a9787$var$namedColorRegex = /^[a-z]+$/i;
const $f02520c2c40a9787$var$roundColor = (color)=>{
    return Math.round(color * 255);
};
const $f02520c2c40a9787$var$hslToRgb = (hue, saturation, lightness)=>{
    let l = lightness / 100;
    if (saturation === 0) // achromatic
    return [
        l,
        l,
        l
    ].map($f02520c2c40a9787$var$roundColor);
    // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
    const huePrime = (hue % 360 + 360) % 360 / 60;
    const chroma = (1 - Math.abs(2 * l - 1)) * (saturation / 100);
    const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    let red = 0;
    let green = 0;
    let blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    const lightnessModification = l - chroma / 2;
    const finalRed = red + lightnessModification;
    const finalGreen = green + lightnessModification;
    const finalBlue = blue + lightnessModification;
    return [
        finalRed,
        finalGreen,
        finalBlue
    ].map($f02520c2c40a9787$var$roundColor);
};
// taken from:
// https://github.com/styled-components/polished/blob/a23a6a2bb26802b3d922d9c3b67bac3f3a54a310/src/internalHelpers/_rgbToHsl.js
/**
 * Parses a color in hue, saturation, lightness, and the alpha channel.
 *
 * Hue is a number between 0 and 360, saturation, lightness, and alpha are
 * decimal percentages between 0 and 1
 */ function $f02520c2c40a9787$export$c7d9b10ca8edee87(color) {
    const [red, green, blue, alpha] = $f02520c2c40a9787$export$88c26fe48243d749(color).map((value, index)=>// 3rd index is alpha channel which is already normalized
        index === 3 ? value : value / 255);
    const max = Math.max(red, green, blue);
    const min = Math.min(red, green, blue);
    const lightness = (max + min) / 2;
    // achromatic
    if (max === min) return [
        0,
        0,
        lightness,
        alpha
    ];
    const delta = max - min;
    const saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
    const hue = 60 * (red === max ? (green - blue) / delta + (green < blue ? 6 : 0) : green === max ? (blue - red) / delta + 2 : (red - green) / delta + 4);
    return [
        hue,
        saturation,
        lightness,
        alpha
    ];
}
/**
 * Takes in hsla parts and constructs an hsla string
 *
 * @param hue The color circle (from 0 to 360) - 0 (or 360) is red, 120 is green, 240 is blue
 * @param saturation Percentage of saturation, given as a decimal between 0 and 1
 * @param lightness Percentage of lightness, given as a decimal between 0 and 1
 * @param alpha Percentage of opacity, given as a decimal between 0 and 1
 */ function $f02520c2c40a9787$export$810b04175080204c(hue, saturation, lightness, alpha) {
    return `hsla(${(hue % 360).toFixed()}, ${$f02520c2c40a9787$export$864d727b48066337(0, 100, saturation * 100).toFixed()}%, ${$f02520c2c40a9787$export$864d727b48066337(0, 100, lightness * 100).toFixed()}%, ${parseFloat($f02520c2c40a9787$export$864d727b48066337(0, 1, alpha).toFixed(3))})`;
}
/**
 * Adjusts the current hue of the color by the given degrees. Wraps around when
 * over 360.
 *
 * @param color input color
 * @param degrees degrees to adjust the input color, accepts degree integers
 * (0 - 360) and wraps around on overflow
 */ function $f02520c2c40a9787$export$2b372a09365374d6(color, degrees) {
    const [h, s, l, a] = $f02520c2c40a9787$export$c7d9b10ca8edee87(color);
    return $f02520c2c40a9787$export$810b04175080204c(h + degrees, s, l, a);
}
/**
 * Darkens using lightness. This is equivalent to subtracting the lightness
 * from the L in HSL.
 *
 * @param amount The amount to darken, given as a decimal between 0 and 1
 */ function $f02520c2c40a9787$export$4b073707ff63303(color, amount) {
    const [hue, saturation, lightness, alpha] = $f02520c2c40a9787$export$c7d9b10ca8edee87(color);
    return $f02520c2c40a9787$export$810b04175080204c(hue, saturation, lightness - amount, alpha);
}
/**
 * Desaturates the input color by the given amount via subtracting from the `s`
 * in `hsla`.
 *
 * @param amount The amount to desaturate, given as a decimal between 0 and 1
 */ function $f02520c2c40a9787$export$fb75607d98509d9(color, amount) {
    const [h, s, l, a] = $f02520c2c40a9787$export$c7d9b10ca8edee87(color);
    return $f02520c2c40a9787$export$810b04175080204c(h, s - amount, l, a);
}
// taken from:
// https://github.com/styled-components/polished/blob/0764c982551b487469043acb56281b0358b3107b/src/color/getLuminance.js
/**
 * Returns a number (float) representing the luminance of a color.
 */ function $f02520c2c40a9787$export$c852d90bf7403b62(color) {
    if (color === "transparent") return 0;
    function f(x) {
        const channel = x / 255;
        return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }
    const [r, g, b] = $f02520c2c40a9787$export$88c26fe48243d749(color);
    return 0.2126 * f(r) + 0.7152 * f(g) + 0.0722 * f(b);
}
// taken from:
// https://github.com/styled-components/polished/blob/0764c982551b487469043acb56281b0358b3107b/src/color/getContrast.js
/**
 * Returns the contrast ratio between two colors based on
 * [W3's recommended equation for calculating contrast](http://www.w3.org/TR/WCAG20/#contrast-ratiodef).
 */ function $f02520c2c40a9787$export$850ce485a60d103b(color1, color2) {
    const luminance1 = $f02520c2c40a9787$export$c852d90bf7403b62(color1);
    const luminance2 = $f02520c2c40a9787$export$c852d90bf7403b62(color2);
    return luminance1 > luminance2 ? (luminance1 + 0.05) / (luminance2 + 0.05) : (luminance2 + 0.05) / (luminance1 + 0.05);
}
/**
 * Takes in rgba parts and returns an rgba string
 *
 * @param red The amount of red in the red channel, given in a number between 0 and 255 inclusive
 * @param green The amount of green in the red channel, given in a number between 0 and 255 inclusive
 * @param blue The amount of blue in the red channel, given in a number between 0 and 255 inclusive
 * @param alpha Percentage of opacity, given as a decimal between 0 and 1
 */ function $f02520c2c40a9787$export$4e46ac54fc82cf3b(red, green, blue, alpha) {
    return `rgba(${$f02520c2c40a9787$export$864d727b48066337(0, 255, red).toFixed()}, ${$f02520c2c40a9787$export$864d727b48066337(0, 255, green).toFixed()}, ${$f02520c2c40a9787$export$864d727b48066337(0, 255, blue).toFixed()}, ${parseFloat($f02520c2c40a9787$export$864d727b48066337(0, 1, alpha).toFixed(3))})`;
}
/**
 * Mixes two colors together. Taken from sass's implementation.
 */ function $f02520c2c40a9787$export$2c9e8a9632a706b2(color1, color2, weight) {
    const normalize = (n, index)=>// 3rd index is alpha channel which is already normalized
        index === 3 ? n : n / 255;
    const [r1, g1, b1, a1] = $f02520c2c40a9787$export$88c26fe48243d749(color1).map(normalize);
    const [r2, g2, b2, a2] = $f02520c2c40a9787$export$88c26fe48243d749(color2).map(normalize);
    // The formula is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
    const alphaDelta = a2 - a1;
    const normalizedWeight = weight * 2 - 1;
    const combinedWeight = normalizedWeight * alphaDelta === -1 ? normalizedWeight : normalizedWeight + alphaDelta / (1 + normalizedWeight * alphaDelta);
    const weight2 = (combinedWeight + 1) / 2;
    const weight1 = 1 - weight2;
    const r = (r1 * weight1 + r2 * weight2) * 255;
    const g = (g1 * weight1 + g2 * weight2) * 255;
    const b = (b1 * weight1 + b2 * weight2) * 255;
    const a = a2 * weight + a1 * (1 - weight);
    return $f02520c2c40a9787$export$4e46ac54fc82cf3b(r, g, b, a);
}
/**
 * Given a series colors, this function will return a `scale(x)` function that
 * accepts a percentage as a decimal between 0 and 1 and returns the color at
 * that percentage in the scale.
 *
 * ```js
 * const scale = getScale('red', 'yellow', 'green');
 * console.log(scale(0)); // rgba(255, 0, 0, 1)
 * console.log(scale(0.5)); // rgba(255, 255, 0, 1)
 * console.log(scale(1)); // rgba(0, 128, 0, 1)
 * ```
 *
 * If you'd like to limit the domain and range like chroma-js, we recommend
 * wrapping scale again.
 *
 * ```js
 * const _scale = getScale('red', 'yellow', 'green');
 * const scale = x => _scale(x / 100);
 *
 * console.log(scale(0)); // rgba(255, 0, 0, 1)
 * console.log(scale(50)); // rgba(255, 255, 0, 1)
 * console.log(scale(100)); // rgba(0, 128, 0, 1)
 * ```
 */ function $f02520c2c40a9787$export$5cdac61cf538712e(...colors) {
    return (n)=>{
        const lastIndex = colors.length - 1;
        const lowIndex = $f02520c2c40a9787$export$864d727b48066337(0, lastIndex, Math.floor(n * lastIndex));
        const highIndex = $f02520c2c40a9787$export$864d727b48066337(0, lastIndex, Math.ceil(n * lastIndex));
        const color1 = colors[lowIndex];
        const color2 = colors[highIndex];
        const unit = 1 / lastIndex;
        const weight = (n - unit * lowIndex) / unit;
        return $f02520c2c40a9787$export$2c9e8a9632a706b2(color1, color2, weight);
    };
}
const $f02520c2c40a9787$var$guidelines = {
    decorative: 1.5,
    readable: 3,
    aa: 4.5,
    aaa: 7
};
/**
 * Returns whether or not a color has bad contrast against a background
 * according to a given standard.
 */ function $f02520c2c40a9787$export$f4ab80233a44f806(color, standard = "aa", background = "#fff") {
    return $f02520c2c40a9787$export$850ce485a60d103b(color, background) < $f02520c2c40a9787$var$guidelines[standard];
}
/**
 * Lightens a color by a given amount. This is equivalent to
 * `darken(color, -amount)`
 *
 * @param amount The amount to darken, given as a decimal between 0 and 1
 */ function $f02520c2c40a9787$export$c0816ed86df316af(color, amount) {
    return $f02520c2c40a9787$export$4b073707ff63303(color, -amount);
}
/**
 * Takes in a color and makes it more transparent by convert to `rgba` and
 * decreasing the amount in the alpha channel.
 *
 * @param amount The amount to increase the transparency by, given as a decimal between 0 and 1
 */ function $f02520c2c40a9787$export$d11da87e55cc498f(color, amount) {
    const [r, g, b, a] = $f02520c2c40a9787$export$88c26fe48243d749(color);
    return $f02520c2c40a9787$export$4e46ac54fc82cf3b(r, g, b, a - amount);
}
/**
 * Takes a color and un-transparentizes it. Equivalent to
 * `transparentize(color, -amount)`
 *
 * @param amount The amount to increase the opacity by, given as a decimal between 0 and 1
 */ function $f02520c2c40a9787$export$f4f50e3877dd0530(color, amount) {
    return $f02520c2c40a9787$export$d11da87e55cc498f(color, -amount);
}
/**
 * An alternative function to `readableColor`. Returns whether or not the 
 * readable color (i.e. the color to be place on top the input color) should be
 * black.
 */ function $f02520c2c40a9787$export$dcb2d24cf045d06(color) {
    return $f02520c2c40a9787$export$c852d90bf7403b62(color) > 0.179;
}
/**
 * Returns black or white for best contrast depending on the luminosity of the
 * given color.
 */ function $f02520c2c40a9787$export$61654c1796c44811(color) {
    return $f02520c2c40a9787$export$dcb2d24cf045d06(color) ? "#000" : "#fff";
}
/**
 * Saturates a color by converting it to `hsl` and increasing the saturation
 * amount. Equivalent to `desaturate(color, -amount)`
 * 
 * @param color Input color
 * @param amount The amount to darken, given as a decimal between 0 and 1
 */ function $f02520c2c40a9787$export$5fcac96f5a87e3db(color, amount) {
    return $f02520c2c40a9787$export$fb75607d98509d9(color, -amount);
}
/**
 * Takes in any color and returns it as a hex code.
 */ function $f02520c2c40a9787$export$7ea66e3774a60b67(color) {
    const [r, g, b, a] = $f02520c2c40a9787$export$88c26fe48243d749(color);
    let hex = (x)=>{
        const h = $f02520c2c40a9787$export$864d727b48066337(0, 255, x).toString(16);
        // NOTE: padStart could be used here but it breaks Node 6 compat
        // https://github.com/ricokahler/color2k/issues/351
        return h.length === 1 ? `0${h}` : h;
    };
    return `#${hex(r)}${hex(g)}${hex(b)}${a < 1 ? hex(Math.round(a * 255)) : ""}`;
}
/**
 * Takes in any color and returns it as an rgba string.
 */ function $f02520c2c40a9787$export$5db297beaffffbfc(color) {
    return $f02520c2c40a9787$export$4e46ac54fc82cf3b(...$f02520c2c40a9787$export$88c26fe48243d749(color));
}
/**
 * Takes in any color and returns it as an hsla string.
 */ function $f02520c2c40a9787$export$b9678a7d4ac803cc(color) {
    return $f02520c2c40a9787$export$810b04175080204c(...$f02520c2c40a9787$export$c7d9b10ca8edee87(color));
}

});



parcelRegister("hwP0N", function(module, exports) {

$parcel$export(module.exports, "tagTheme", () => $79cd1676c54a3b51$export$f8ab9ac2a319695b);

var $aALPx = parcelRequire("aALPx");

var $jNq6g = parcelRequire("jNq6g");

var $cDoMf = parcelRequire("cDoMf");
var { defineMultiStyleConfig: $79cd1676c54a3b51$var$defineMultiStyleConfig, definePartsStyle: $79cd1676c54a3b51$var$definePartsStyle } = (0, $cDoMf.createMultiStyleConfigHelpers)((0, $jNq6g.tagAnatomy).keys);
var $79cd1676c54a3b51$var$$bg = (0, $cDoMf.cssVar)("tag-bg");
var $79cd1676c54a3b51$var$$color = (0, $cDoMf.cssVar)("tag-color");
var $79cd1676c54a3b51$var$$shadow = (0, $cDoMf.cssVar)("tag-shadow");
var $79cd1676c54a3b51$var$$minH = (0, $cDoMf.cssVar)("tag-min-height");
var $79cd1676c54a3b51$var$$minW = (0, $cDoMf.cssVar)("tag-min-width");
var $79cd1676c54a3b51$var$$fontSize = (0, $cDoMf.cssVar)("tag-font-size");
var $79cd1676c54a3b51$var$$paddingX = (0, $cDoMf.cssVar)("tag-padding-inline");
var $79cd1676c54a3b51$var$baseStyleContainer = (0, $cDoMf.defineStyle)({
    fontWeight: "medium",
    lineHeight: 1.2,
    outline: 0,
    [$79cd1676c54a3b51$var$$color.variable]: (0, $aALPx.vars).color.reference,
    [$79cd1676c54a3b51$var$$bg.variable]: (0, $aALPx.vars).bg.reference,
    [$79cd1676c54a3b51$var$$shadow.variable]: (0, $aALPx.vars).shadow.reference,
    color: $79cd1676c54a3b51$var$$color.reference,
    bg: $79cd1676c54a3b51$var$$bg.reference,
    boxShadow: $79cd1676c54a3b51$var$$shadow.reference,
    borderRadius: "md",
    minH: $79cd1676c54a3b51$var$$minH.reference,
    minW: $79cd1676c54a3b51$var$$minW.reference,
    fontSize: $79cd1676c54a3b51$var$$fontSize.reference,
    px: $79cd1676c54a3b51$var$$paddingX.reference,
    _focusVisible: {
        [$79cd1676c54a3b51$var$$shadow.variable]: "shadows.outline"
    }
});
var $79cd1676c54a3b51$var$baseStyleLabel = (0, $cDoMf.defineStyle)({
    lineHeight: 1.2,
    overflow: "visible"
});
var $79cd1676c54a3b51$var$baseStyleCloseButton = (0, $cDoMf.defineStyle)({
    fontSize: "lg",
    w: "5",
    h: "5",
    transitionProperty: "common",
    transitionDuration: "normal",
    borderRadius: "full",
    marginStart: "1.5",
    marginEnd: "-1",
    opacity: 0.5,
    _disabled: {
        opacity: 0.4
    },
    _focusVisible: {
        boxShadow: "outline",
        bg: "rgba(0, 0, 0, 0.14)"
    },
    _hover: {
        opacity: 0.8
    },
    _active: {
        opacity: 1
    }
});
var $79cd1676c54a3b51$var$baseStyle = $79cd1676c54a3b51$var$definePartsStyle({
    container: $79cd1676c54a3b51$var$baseStyleContainer,
    label: $79cd1676c54a3b51$var$baseStyleLabel,
    closeButton: $79cd1676c54a3b51$var$baseStyleCloseButton
});
var $79cd1676c54a3b51$var$sizes = {
    sm: $79cd1676c54a3b51$var$definePartsStyle({
        container: {
            [$79cd1676c54a3b51$var$$minH.variable]: "sizes.5",
            [$79cd1676c54a3b51$var$$minW.variable]: "sizes.5",
            [$79cd1676c54a3b51$var$$fontSize.variable]: "fontSizes.xs",
            [$79cd1676c54a3b51$var$$paddingX.variable]: "space.2"
        },
        closeButton: {
            marginEnd: "-2px",
            marginStart: "0.35rem"
        }
    }),
    md: $79cd1676c54a3b51$var$definePartsStyle({
        container: {
            [$79cd1676c54a3b51$var$$minH.variable]: "sizes.6",
            [$79cd1676c54a3b51$var$$minW.variable]: "sizes.6",
            [$79cd1676c54a3b51$var$$fontSize.variable]: "fontSizes.sm",
            [$79cd1676c54a3b51$var$$paddingX.variable]: "space.2"
        }
    }),
    lg: $79cd1676c54a3b51$var$definePartsStyle({
        container: {
            [$79cd1676c54a3b51$var$$minH.variable]: "sizes.8",
            [$79cd1676c54a3b51$var$$minW.variable]: "sizes.8",
            [$79cd1676c54a3b51$var$$fontSize.variable]: "fontSizes.md",
            [$79cd1676c54a3b51$var$$paddingX.variable]: "space.3"
        }
    })
};
var $79cd1676c54a3b51$var$variants = {
    subtle: $79cd1676c54a3b51$var$definePartsStyle((props)=>{
        var _a;
        return {
            container: (_a = (0, $aALPx.badgeTheme).variants) == null ? void 0 : _a.subtle(props)
        };
    }),
    solid: $79cd1676c54a3b51$var$definePartsStyle((props)=>{
        var _a;
        return {
            container: (_a = (0, $aALPx.badgeTheme).variants) == null ? void 0 : _a.solid(props)
        };
    }),
    outline: $79cd1676c54a3b51$var$definePartsStyle((props)=>{
        var _a;
        return {
            container: (_a = (0, $aALPx.badgeTheme).variants) == null ? void 0 : _a.outline(props)
        };
    })
};
var $79cd1676c54a3b51$export$f8ab9ac2a319695b = $79cd1676c54a3b51$var$defineMultiStyleConfig({
    variants: $79cd1676c54a3b51$var$variants,
    baseStyle: $79cd1676c54a3b51$var$baseStyle,
    sizes: $79cd1676c54a3b51$var$sizes,
    defaultProps: {
        size: "md",
        variant: "subtle",
        colorScheme: "gray"
    }
});

});
parcelRegister("aALPx", function(module, exports) {

$parcel$export(module.exports, "vars", () => $0f65da44018baa38$export$3cb96c9f6c8d16a4);
$parcel$export(module.exports, "badgeTheme", () => $0f65da44018baa38$export$eb6e7cbc82d0f88b);
// src/components/badge.ts

var $cDoMf = parcelRequire("cDoMf");

var $a99Nd = parcelRequire("a99Nd");
var $0f65da44018baa38$export$3cb96c9f6c8d16a4 = (0, $cDoMf.defineCssVars)("badge", [
    "bg",
    "color",
    "shadow"
]);
var $0f65da44018baa38$var$baseStyle = (0, $cDoMf.defineStyle)({
    px: 1,
    textTransform: "uppercase",
    fontSize: "xs",
    borderRadius: "sm",
    fontWeight: "bold",
    bg: $0f65da44018baa38$export$3cb96c9f6c8d16a4.bg.reference,
    color: $0f65da44018baa38$export$3cb96c9f6c8d16a4.color.reference,
    boxShadow: $0f65da44018baa38$export$3cb96c9f6c8d16a4.shadow.reference
});
var $0f65da44018baa38$var$variantSolid = (0, $cDoMf.defineStyle)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    const dark = (0, $a99Nd.transparentize)(`${c}.500`, 0.6)(theme);
    return {
        [$0f65da44018baa38$export$3cb96c9f6c8d16a4.bg.variable]: `colors.${c}.500`,
        [$0f65da44018baa38$export$3cb96c9f6c8d16a4.color.variable]: `colors.white`,
        _dark: {
            [$0f65da44018baa38$export$3cb96c9f6c8d16a4.bg.variable]: dark,
            [$0f65da44018baa38$export$3cb96c9f6c8d16a4.color.variable]: `colors.whiteAlpha.800`
        }
    };
});
var $0f65da44018baa38$var$variantSubtle = (0, $cDoMf.defineStyle)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    const darkBg = (0, $a99Nd.transparentize)(`${c}.200`, 0.16)(theme);
    return {
        [$0f65da44018baa38$export$3cb96c9f6c8d16a4.bg.variable]: `colors.${c}.100`,
        [$0f65da44018baa38$export$3cb96c9f6c8d16a4.color.variable]: `colors.${c}.800`,
        _dark: {
            [$0f65da44018baa38$export$3cb96c9f6c8d16a4.bg.variable]: darkBg,
            [$0f65da44018baa38$export$3cb96c9f6c8d16a4.color.variable]: `colors.${c}.200`
        }
    };
});
var $0f65da44018baa38$var$variantOutline = (0, $cDoMf.defineStyle)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    const darkColor = (0, $a99Nd.transparentize)(`${c}.200`, 0.8)(theme);
    return {
        [$0f65da44018baa38$export$3cb96c9f6c8d16a4.color.variable]: `colors.${c}.500`,
        _dark: {
            [$0f65da44018baa38$export$3cb96c9f6c8d16a4.color.variable]: darkColor
        },
        [$0f65da44018baa38$export$3cb96c9f6c8d16a4.shadow.variable]: `inset 0 0 0px 1px ${$0f65da44018baa38$export$3cb96c9f6c8d16a4.color.reference}`
    };
});
var $0f65da44018baa38$var$variants = {
    solid: $0f65da44018baa38$var$variantSolid,
    subtle: $0f65da44018baa38$var$variantSubtle,
    outline: $0f65da44018baa38$var$variantOutline
};
var $0f65da44018baa38$export$eb6e7cbc82d0f88b = (0, $cDoMf.defineStyleConfig)({
    baseStyle: $0f65da44018baa38$var$baseStyle,
    variants: $0f65da44018baa38$var$variants,
    defaultProps: {
        variant: "subtle",
        colorScheme: "gray"
    }
});

});


parcelRegister("7wsB6", function(module, exports) {

$parcel$export(module.exports, "textareaTheme", () => $ee45a2a0a3dd8602$export$394b8322fab774c1);

var $emFSB = parcelRequire("emFSB");

var $cDoMf = parcelRequire("cDoMf");
var $ee45a2a0a3dd8602$var$_a;
var $ee45a2a0a3dd8602$var$baseStyle = (0, $cDoMf.defineStyle)({
    ...($ee45a2a0a3dd8602$var$_a = (0, $emFSB.inputTheme).baseStyle) == null ? void 0 : $ee45a2a0a3dd8602$var$_a.field,
    paddingY: "2",
    minHeight: "20",
    lineHeight: "short",
    verticalAlign: "top"
});
var $ee45a2a0a3dd8602$var$_a2, $ee45a2a0a3dd8602$var$_b;
var $ee45a2a0a3dd8602$var$variants = {
    outline: (0, $cDoMf.defineStyle)((props)=>{
        var _a4, _b3;
        return (_b3 = (_a4 = (0, $emFSB.inputTheme).variants) == null ? void 0 : _a4.outline(props).field) != null ? _b3 : {};
    }),
    flushed: (0, $cDoMf.defineStyle)((props)=>{
        var _a4, _b3;
        return (_b3 = (_a4 = (0, $emFSB.inputTheme).variants) == null ? void 0 : _a4.flushed(props).field) != null ? _b3 : {};
    }),
    filled: (0, $cDoMf.defineStyle)((props)=>{
        var _a4, _b3;
        return (_b3 = (_a4 = (0, $emFSB.inputTheme).variants) == null ? void 0 : _a4.filled(props).field) != null ? _b3 : {};
    }),
    unstyled: ($ee45a2a0a3dd8602$var$_b = ($ee45a2a0a3dd8602$var$_a2 = (0, $emFSB.inputTheme).variants) == null ? void 0 : $ee45a2a0a3dd8602$var$_a2.unstyled.field) != null ? $ee45a2a0a3dd8602$var$_b : {}
};
var $ee45a2a0a3dd8602$var$_a3, $ee45a2a0a3dd8602$var$_b2, $ee45a2a0a3dd8602$var$_c, $ee45a2a0a3dd8602$var$_d, $ee45a2a0a3dd8602$var$_e, $ee45a2a0a3dd8602$var$_f, $ee45a2a0a3dd8602$var$_g, $ee45a2a0a3dd8602$var$_h;
var $ee45a2a0a3dd8602$var$sizes = {
    xs: ($ee45a2a0a3dd8602$var$_b2 = ($ee45a2a0a3dd8602$var$_a3 = (0, $emFSB.inputTheme).sizes) == null ? void 0 : $ee45a2a0a3dd8602$var$_a3.xs.field) != null ? $ee45a2a0a3dd8602$var$_b2 : {},
    sm: ($ee45a2a0a3dd8602$var$_d = ($ee45a2a0a3dd8602$var$_c = (0, $emFSB.inputTheme).sizes) == null ? void 0 : $ee45a2a0a3dd8602$var$_c.sm.field) != null ? $ee45a2a0a3dd8602$var$_d : {},
    md: ($ee45a2a0a3dd8602$var$_f = ($ee45a2a0a3dd8602$var$_e = (0, $emFSB.inputTheme).sizes) == null ? void 0 : $ee45a2a0a3dd8602$var$_e.md.field) != null ? $ee45a2a0a3dd8602$var$_f : {},
    lg: ($ee45a2a0a3dd8602$var$_h = ($ee45a2a0a3dd8602$var$_g = (0, $emFSB.inputTheme).sizes) == null ? void 0 : $ee45a2a0a3dd8602$var$_g.lg.field) != null ? $ee45a2a0a3dd8602$var$_h : {}
};
var $ee45a2a0a3dd8602$export$394b8322fab774c1 = (0, $cDoMf.defineStyleConfig)({
    baseStyle: $ee45a2a0a3dd8602$var$baseStyle,
    sizes: $ee45a2a0a3dd8602$var$sizes,
    variants: $ee45a2a0a3dd8602$var$variants,
    defaultProps: {
        size: "md",
        variant: "outline"
    }
});

});
parcelRegister("emFSB", function(module, exports) {

$parcel$export(module.exports, "inputTheme", () => $610ccae16310baae$export$b1b9f3bced726e54);
// src/components/input.ts

var $jNq6g = parcelRequire("jNq6g");

var $cDoMf = parcelRequire("cDoMf");

var $a99Nd = parcelRequire("a99Nd");
var $kYGZ9 = parcelRequire("kYGZ9");
var { definePartsStyle: $610ccae16310baae$var$definePartsStyle, defineMultiStyleConfig: $610ccae16310baae$var$defineMultiStyleConfig } = (0, $cDoMf.createMultiStyleConfigHelpers)((0, $jNq6g.inputAnatomy).keys);
var $610ccae16310baae$var$$height = (0, $cDoMf.cssVar)("input-height");
var $610ccae16310baae$var$$fontSize = (0, $cDoMf.cssVar)("input-font-size");
var $610ccae16310baae$var$$padding = (0, $cDoMf.cssVar)("input-padding");
var $610ccae16310baae$var$$borderRadius = (0, $cDoMf.cssVar)("input-border-radius");
var $610ccae16310baae$var$baseStyle = $610ccae16310baae$var$definePartsStyle({
    addon: {
        height: $610ccae16310baae$var$$height.reference,
        fontSize: $610ccae16310baae$var$$fontSize.reference,
        px: $610ccae16310baae$var$$padding.reference,
        borderRadius: $610ccae16310baae$var$$borderRadius.reference
    },
    field: {
        width: "100%",
        height: $610ccae16310baae$var$$height.reference,
        fontSize: $610ccae16310baae$var$$fontSize.reference,
        px: $610ccae16310baae$var$$padding.reference,
        borderRadius: $610ccae16310baae$var$$borderRadius.reference,
        minWidth: 0,
        outline: 0,
        position: "relative",
        appearance: "none",
        transitionProperty: "common",
        transitionDuration: "normal",
        _disabled: {
            opacity: 0.4,
            cursor: "not-allowed"
        }
    }
});
var $610ccae16310baae$var$size = {
    lg: (0, $cDoMf.defineStyle)({
        [$610ccae16310baae$var$$fontSize.variable]: "fontSizes.lg",
        [$610ccae16310baae$var$$padding.variable]: "space.4",
        [$610ccae16310baae$var$$borderRadius.variable]: "radii.md",
        [$610ccae16310baae$var$$height.variable]: "sizes.12"
    }),
    md: (0, $cDoMf.defineStyle)({
        [$610ccae16310baae$var$$fontSize.variable]: "fontSizes.md",
        [$610ccae16310baae$var$$padding.variable]: "space.4",
        [$610ccae16310baae$var$$borderRadius.variable]: "radii.md",
        [$610ccae16310baae$var$$height.variable]: "sizes.10"
    }),
    sm: (0, $cDoMf.defineStyle)({
        [$610ccae16310baae$var$$fontSize.variable]: "fontSizes.sm",
        [$610ccae16310baae$var$$padding.variable]: "space.3",
        [$610ccae16310baae$var$$borderRadius.variable]: "radii.sm",
        [$610ccae16310baae$var$$height.variable]: "sizes.8"
    }),
    xs: (0, $cDoMf.defineStyle)({
        [$610ccae16310baae$var$$fontSize.variable]: "fontSizes.xs",
        [$610ccae16310baae$var$$padding.variable]: "space.2",
        [$610ccae16310baae$var$$borderRadius.variable]: "radii.sm",
        [$610ccae16310baae$var$$height.variable]: "sizes.6"
    })
};
var $610ccae16310baae$var$sizes = {
    lg: $610ccae16310baae$var$definePartsStyle({
        field: $610ccae16310baae$var$size.lg,
        group: $610ccae16310baae$var$size.lg
    }),
    md: $610ccae16310baae$var$definePartsStyle({
        field: $610ccae16310baae$var$size.md,
        group: $610ccae16310baae$var$size.md
    }),
    sm: $610ccae16310baae$var$definePartsStyle({
        field: $610ccae16310baae$var$size.sm,
        group: $610ccae16310baae$var$size.sm
    }),
    xs: $610ccae16310baae$var$definePartsStyle({
        field: $610ccae16310baae$var$size.xs,
        group: $610ccae16310baae$var$size.xs
    })
};
function $610ccae16310baae$var$getDefaults(props) {
    const { focusBorderColor: fc, errorBorderColor: ec } = props;
    return {
        focusBorderColor: fc || (0, $kYGZ9.mode)("blue.500", "blue.300")(props),
        errorBorderColor: ec || (0, $kYGZ9.mode)("red.500", "red.300")(props)
    };
}
var $610ccae16310baae$var$variantOutline = $610ccae16310baae$var$definePartsStyle((props)=>{
    const { theme: theme } = props;
    const { focusBorderColor: fc, errorBorderColor: ec } = $610ccae16310baae$var$getDefaults(props);
    return {
        field: {
            border: "1px solid",
            borderColor: "inherit",
            bg: "inherit",
            _hover: {
                borderColor: (0, $kYGZ9.mode)("gray.300", "whiteAlpha.400")(props)
            },
            _readOnly: {
                boxShadow: "none !important",
                userSelect: "all"
            },
            _invalid: {
                borderColor: (0, $a99Nd.getColor)(theme, ec),
                boxShadow: `0 0 0 1px ${(0, $a99Nd.getColor)(theme, ec)}`
            },
            _focusVisible: {
                zIndex: 1,
                borderColor: (0, $a99Nd.getColor)(theme, fc),
                boxShadow: `0 0 0 1px ${(0, $a99Nd.getColor)(theme, fc)}`
            }
        },
        addon: {
            border: "1px solid",
            borderColor: (0, $kYGZ9.mode)("inherit", "whiteAlpha.50")(props),
            bg: (0, $kYGZ9.mode)("gray.100", "whiteAlpha.300")(props)
        }
    };
});
var $610ccae16310baae$var$variantFilled = $610ccae16310baae$var$definePartsStyle((props)=>{
    const { theme: theme } = props;
    const { focusBorderColor: fc, errorBorderColor: ec } = $610ccae16310baae$var$getDefaults(props);
    return {
        field: {
            border: "2px solid",
            borderColor: "transparent",
            bg: (0, $kYGZ9.mode)("gray.100", "whiteAlpha.50")(props),
            _hover: {
                bg: (0, $kYGZ9.mode)("gray.200", "whiteAlpha.100")(props)
            },
            _readOnly: {
                boxShadow: "none !important",
                userSelect: "all"
            },
            _invalid: {
                borderColor: (0, $a99Nd.getColor)(theme, ec)
            },
            _focusVisible: {
                bg: "transparent",
                borderColor: (0, $a99Nd.getColor)(theme, fc)
            }
        },
        addon: {
            border: "2px solid",
            borderColor: "transparent",
            bg: (0, $kYGZ9.mode)("gray.100", "whiteAlpha.50")(props)
        }
    };
});
var $610ccae16310baae$var$variantFlushed = $610ccae16310baae$var$definePartsStyle((props)=>{
    const { theme: theme } = props;
    const { focusBorderColor: fc, errorBorderColor: ec } = $610ccae16310baae$var$getDefaults(props);
    return {
        field: {
            borderBottom: "1px solid",
            borderColor: "inherit",
            borderRadius: "0",
            px: "0",
            bg: "transparent",
            _readOnly: {
                boxShadow: "none !important",
                userSelect: "all"
            },
            _invalid: {
                borderColor: (0, $a99Nd.getColor)(theme, ec),
                boxShadow: `0px 1px 0px 0px ${(0, $a99Nd.getColor)(theme, ec)}`
            },
            _focusVisible: {
                borderColor: (0, $a99Nd.getColor)(theme, fc),
                boxShadow: `0px 1px 0px 0px ${(0, $a99Nd.getColor)(theme, fc)}`
            }
        },
        addon: {
            borderBottom: "2px solid",
            borderColor: "inherit",
            borderRadius: "0",
            px: "0",
            bg: "transparent"
        }
    };
});
var $610ccae16310baae$var$variantUnstyled = $610ccae16310baae$var$definePartsStyle({
    field: {
        bg: "transparent",
        px: "0",
        height: "auto"
    },
    addon: {
        bg: "transparent",
        px: "0",
        height: "auto"
    }
});
var $610ccae16310baae$var$variants = {
    outline: $610ccae16310baae$var$variantOutline,
    filled: $610ccae16310baae$var$variantFilled,
    flushed: $610ccae16310baae$var$variantFlushed,
    unstyled: $610ccae16310baae$var$variantUnstyled
};
var $610ccae16310baae$export$b1b9f3bced726e54 = $610ccae16310baae$var$defineMultiStyleConfig({
    baseStyle: $610ccae16310baae$var$baseStyle,
    sizes: $610ccae16310baae$var$sizes,
    variants: $610ccae16310baae$var$variants,
    defaultProps: {
        size: "md",
        variant: "outline"
    }
});

});


parcelRegister("i99Ar", function(module, exports) {

$parcel$export(module.exports, "tooltipTheme", () => $3ddf021f7accb221$export$7472a7883840b563);
// src/components/tooltip.ts

var $cDoMf = parcelRequire("cDoMf");

var $9TrBA = parcelRequire("9TrBA");
var $3ddf021f7accb221$var$$bg = (0, $9TrBA.cssVar)("tooltip-bg");
var $3ddf021f7accb221$var$$fg = (0, $9TrBA.cssVar)("tooltip-fg");
var $3ddf021f7accb221$var$$arrowBg = (0, $9TrBA.cssVar)("popper-arrow-bg");
var $3ddf021f7accb221$var$baseStyle = (0, $cDoMf.defineStyle)({
    bg: $3ddf021f7accb221$var$$bg.reference,
    color: $3ddf021f7accb221$var$$fg.reference,
    [$3ddf021f7accb221$var$$bg.variable]: "colors.gray.700",
    [$3ddf021f7accb221$var$$fg.variable]: "colors.whiteAlpha.900",
    _dark: {
        [$3ddf021f7accb221$var$$bg.variable]: "colors.gray.300",
        [$3ddf021f7accb221$var$$fg.variable]: "colors.gray.900"
    },
    [$3ddf021f7accb221$var$$arrowBg.variable]: $3ddf021f7accb221$var$$bg.reference,
    px: "2",
    py: "0.5",
    borderRadius: "sm",
    fontWeight: "medium",
    fontSize: "sm",
    boxShadow: "md",
    maxW: "xs",
    zIndex: "tooltip"
});
var $3ddf021f7accb221$export$7472a7883840b563 = (0, $cDoMf.defineStyleConfig)({
    baseStyle: $3ddf021f7accb221$var$baseStyle
});

});

parcelRegister("aeJy0", function(module, exports) {

$parcel$export(module.exports, "progressTheme", () => $629d485227c66822$export$dc04d8e6a17afea1);
// src/components/progress.ts

var $jNq6g = parcelRequire("jNq6g");

var $cDoMf = parcelRequire("cDoMf");

var $a99Nd = parcelRequire("a99Nd");
var $kYGZ9 = parcelRequire("kYGZ9");
var { defineMultiStyleConfig: $629d485227c66822$var$defineMultiStyleConfig, definePartsStyle: $629d485227c66822$var$definePartsStyle } = (0, $cDoMf.createMultiStyleConfigHelpers)((0, $jNq6g.progressAnatomy).keys);
var $629d485227c66822$var$filledStyle = (0, $cDoMf.defineStyle)((props)=>{
    const { colorScheme: c, theme: t, isIndeterminate: isIndeterminate, hasStripe: hasStripe } = props;
    const stripeStyle = (0, $kYGZ9.mode)((0, $a99Nd.generateStripe)(), (0, $a99Nd.generateStripe)("1rem", "rgba(0,0,0,0.1)"))(props);
    const bgColor = (0, $kYGZ9.mode)(`${c}.500`, `${c}.200`)(props);
    const gradient = `linear-gradient(
    to right,
    transparent 0%,
    ${(0, $a99Nd.getColor)(t, bgColor)} 50%,
    transparent 100%
  )`;
    const addStripe = !isIndeterminate && hasStripe;
    return {
        ...addStripe && stripeStyle,
        ...isIndeterminate ? {
            bgImage: gradient
        } : {
            bgColor: bgColor
        }
    };
});
var $629d485227c66822$var$baseStyleLabel = (0, $cDoMf.defineStyle)({
    lineHeight: "1",
    fontSize: "0.25em",
    fontWeight: "bold",
    color: "white"
});
var $629d485227c66822$var$baseStyleTrack = (0, $cDoMf.defineStyle)((props)=>{
    return {
        bg: (0, $kYGZ9.mode)("gray.100", "whiteAlpha.300")(props)
    };
});
var $629d485227c66822$var$baseStyleFilledTrack = (0, $cDoMf.defineStyle)((props)=>{
    return {
        transitionProperty: "common",
        transitionDuration: "slow",
        ...$629d485227c66822$var$filledStyle(props)
    };
});
var $629d485227c66822$var$baseStyle = $629d485227c66822$var$definePartsStyle((props)=>({
        label: $629d485227c66822$var$baseStyleLabel,
        filledTrack: $629d485227c66822$var$baseStyleFilledTrack(props),
        track: $629d485227c66822$var$baseStyleTrack(props)
    }));
var $629d485227c66822$var$sizes = {
    xs: $629d485227c66822$var$definePartsStyle({
        track: {
            h: "1"
        }
    }),
    sm: $629d485227c66822$var$definePartsStyle({
        track: {
            h: "2"
        }
    }),
    md: $629d485227c66822$var$definePartsStyle({
        track: {
            h: "3"
        }
    }),
    lg: $629d485227c66822$var$definePartsStyle({
        track: {
            h: "4"
        }
    })
};
var $629d485227c66822$export$dc04d8e6a17afea1 = $629d485227c66822$var$defineMultiStyleConfig({
    sizes: $629d485227c66822$var$sizes,
    baseStyle: $629d485227c66822$var$baseStyle,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});

});

parcelRegister("b8oZC", function(module, exports) {

$parcel$export(module.exports, "radioTheme", () => $6af94a775fcbe737$export$f0b387b940941887);

var $7mN8G = parcelRequire("7mN8G");

var $1VjjY = parcelRequire("1VjjY");

var $jNq6g = parcelRequire("jNq6g");

var $cDoMf = parcelRequire("cDoMf");
var { defineMultiStyleConfig: $6af94a775fcbe737$var$defineMultiStyleConfig, definePartsStyle: $6af94a775fcbe737$var$definePartsStyle } = (0, $cDoMf.createMultiStyleConfigHelpers)((0, $jNq6g.radioAnatomy).keys);
var $6af94a775fcbe737$var$baseStyleControl = (0, $cDoMf.defineStyle)((props)=>{
    var _a;
    const controlStyle = (_a = (0, $1VjjY.runIfFn)((0, $7mN8G.checkboxTheme).baseStyle, props)) == null ? void 0 : _a.control;
    return {
        ...controlStyle,
        borderRadius: "full",
        _checked: {
            ...controlStyle == null ? void 0 : controlStyle["_checked"],
            _before: {
                content: `""`,
                display: "inline-block",
                pos: "relative",
                w: "50%",
                h: "50%",
                borderRadius: "50%",
                bg: "currentColor"
            }
        }
    };
});
var $6af94a775fcbe737$var$baseStyle = $6af94a775fcbe737$var$definePartsStyle((props)=>{
    var _a, _b, _c, _d;
    return {
        label: (_b = (_a = (0, $7mN8G.checkboxTheme)).baseStyle) == null ? void 0 : _b.call(_a, props).label,
        container: (_d = (_c = (0, $7mN8G.checkboxTheme)).baseStyle) == null ? void 0 : _d.call(_c, props).container,
        control: $6af94a775fcbe737$var$baseStyleControl(props)
    };
});
var $6af94a775fcbe737$var$sizes = {
    md: $6af94a775fcbe737$var$definePartsStyle({
        control: {
            w: "4",
            h: "4"
        },
        label: {
            fontSize: "md"
        }
    }),
    lg: $6af94a775fcbe737$var$definePartsStyle({
        control: {
            w: "5",
            h: "5"
        },
        label: {
            fontSize: "lg"
        }
    }),
    sm: $6af94a775fcbe737$var$definePartsStyle({
        control: {
            width: "3",
            height: "3"
        },
        label: {
            fontSize: "sm"
        }
    })
};
var $6af94a775fcbe737$export$f0b387b940941887 = $6af94a775fcbe737$var$defineMultiStyleConfig({
    baseStyle: $6af94a775fcbe737$var$baseStyle,
    sizes: $6af94a775fcbe737$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});

});
parcelRegister("7mN8G", function(module, exports) {

$parcel$export(module.exports, "checkboxTheme", () => $bfcbca331b465288$export$86286d8c37984115);

var $1VjjY = parcelRequire("1VjjY");

var $jNq6g = parcelRequire("jNq6g");

var $cDoMf = parcelRequire("cDoMf");

var $kYGZ9 = parcelRequire("kYGZ9");
var { definePartsStyle: $bfcbca331b465288$var$definePartsStyle, defineMultiStyleConfig: $bfcbca331b465288$var$defineMultiStyleConfig } = (0, $cDoMf.createMultiStyleConfigHelpers)((0, $jNq6g.checkboxAnatomy).keys);
var $bfcbca331b465288$var$$size = (0, $cDoMf.cssVar)("checkbox-size");
var $bfcbca331b465288$var$baseStyleControl = (0, $cDoMf.defineStyle)((props)=>{
    const { colorScheme: c } = props;
    return {
        w: $bfcbca331b465288$var$$size.reference,
        h: $bfcbca331b465288$var$$size.reference,
        transitionProperty: "box-shadow",
        transitionDuration: "normal",
        border: "2px solid",
        borderRadius: "sm",
        borderColor: "inherit",
        color: "white",
        _checked: {
            bg: (0, $kYGZ9.mode)(`${c}.500`, `${c}.200`)(props),
            borderColor: (0, $kYGZ9.mode)(`${c}.500`, `${c}.200`)(props),
            color: (0, $kYGZ9.mode)("white", "gray.900")(props),
            _hover: {
                bg: (0, $kYGZ9.mode)(`${c}.600`, `${c}.300`)(props),
                borderColor: (0, $kYGZ9.mode)(`${c}.600`, `${c}.300`)(props)
            },
            _disabled: {
                borderColor: (0, $kYGZ9.mode)("gray.200", "transparent")(props),
                bg: (0, $kYGZ9.mode)("gray.200", "whiteAlpha.300")(props),
                color: (0, $kYGZ9.mode)("gray.500", "whiteAlpha.500")(props)
            }
        },
        _indeterminate: {
            bg: (0, $kYGZ9.mode)(`${c}.500`, `${c}.200`)(props),
            borderColor: (0, $kYGZ9.mode)(`${c}.500`, `${c}.200`)(props),
            color: (0, $kYGZ9.mode)("white", "gray.900")(props)
        },
        _disabled: {
            bg: (0, $kYGZ9.mode)("gray.100", "whiteAlpha.100")(props),
            borderColor: (0, $kYGZ9.mode)("gray.100", "transparent")(props)
        },
        _focusVisible: {
            boxShadow: "outline"
        },
        _invalid: {
            borderColor: (0, $kYGZ9.mode)("red.500", "red.300")(props)
        }
    };
});
var $bfcbca331b465288$var$baseStyleContainer = (0, $cDoMf.defineStyle)({
    _disabled: {
        cursor: "not-allowed"
    }
});
var $bfcbca331b465288$var$baseStyleLabel = (0, $cDoMf.defineStyle)({
    userSelect: "none",
    _disabled: {
        opacity: 0.4
    }
});
var $bfcbca331b465288$var$baseStyleIcon = (0, $cDoMf.defineStyle)({
    transitionProperty: "transform",
    transitionDuration: "normal"
});
var $bfcbca331b465288$var$baseStyle = $bfcbca331b465288$var$definePartsStyle((props)=>({
        icon: $bfcbca331b465288$var$baseStyleIcon,
        container: $bfcbca331b465288$var$baseStyleContainer,
        control: (0, $1VjjY.runIfFn)($bfcbca331b465288$var$baseStyleControl, props),
        label: $bfcbca331b465288$var$baseStyleLabel
    }));
var $bfcbca331b465288$var$sizes = {
    sm: $bfcbca331b465288$var$definePartsStyle({
        control: {
            [$bfcbca331b465288$var$$size.variable]: "sizes.3"
        },
        label: {
            fontSize: "sm"
        },
        icon: {
            fontSize: "3xs"
        }
    }),
    md: $bfcbca331b465288$var$definePartsStyle({
        control: {
            [$bfcbca331b465288$var$$size.variable]: "sizes.4"
        },
        label: {
            fontSize: "md"
        },
        icon: {
            fontSize: "2xs"
        }
    }),
    lg: $bfcbca331b465288$var$definePartsStyle({
        control: {
            [$bfcbca331b465288$var$$size.variable]: "sizes.5"
        },
        label: {
            fontSize: "lg"
        },
        icon: {
            fontSize: "2xs"
        }
    })
};
var $bfcbca331b465288$export$86286d8c37984115 = $bfcbca331b465288$var$defineMultiStyleConfig({
    baseStyle: $bfcbca331b465288$var$baseStyle,
    sizes: $bfcbca331b465288$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});

});
parcelRegister("1VjjY", function(module, exports) {

$parcel$export(module.exports, "runIfFn", () => $6c859ac803750e7f$export$624e501d81f5ffce);
// src/utils/run-if-fn.ts
var $6c859ac803750e7f$var$isFunction = (value)=>typeof value === "function";
function $6c859ac803750e7f$export$624e501d81f5ffce(valueOrFn, ...args) {
    return $6c859ac803750e7f$var$isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}

});



parcelRegister("9jvtP", function(module, exports) {

$parcel$export(module.exports, "selectTheme", () => $21b24ee79b52aaa6$export$21af0fc3c16183e1);

var $emFSB = parcelRequire("emFSB");

var $jNq6g = parcelRequire("jNq6g");

var $cDoMf = parcelRequire("cDoMf");
var { defineMultiStyleConfig: $21b24ee79b52aaa6$var$defineMultiStyleConfig, definePartsStyle: $21b24ee79b52aaa6$var$definePartsStyle } = (0, $cDoMf.createMultiStyleConfigHelpers)((0, $jNq6g.selectAnatomy).keys);
var $21b24ee79b52aaa6$var$$bg = (0, $cDoMf.cssVar)("select-bg");
var $21b24ee79b52aaa6$var$_a;
var $21b24ee79b52aaa6$var$baseStyleField = (0, $cDoMf.defineStyle)({
    ...($21b24ee79b52aaa6$var$_a = (0, $emFSB.inputTheme).baseStyle) == null ? void 0 : $21b24ee79b52aaa6$var$_a.field,
    appearance: "none",
    paddingBottom: "1px",
    lineHeight: "normal",
    bg: $21b24ee79b52aaa6$var$$bg.reference,
    [$21b24ee79b52aaa6$var$$bg.variable]: "colors.white",
    _dark: {
        [$21b24ee79b52aaa6$var$$bg.variable]: "colors.gray.700"
    },
    "> option, > optgroup": {
        bg: $21b24ee79b52aaa6$var$$bg.reference
    }
});
var $21b24ee79b52aaa6$var$baseStyleIcon = (0, $cDoMf.defineStyle)({
    width: "6",
    height: "100%",
    insetEnd: "2",
    position: "relative",
    color: "currentColor",
    fontSize: "xl",
    _disabled: {
        opacity: 0.5
    }
});
var $21b24ee79b52aaa6$var$baseStyle = $21b24ee79b52aaa6$var$definePartsStyle({
    field: $21b24ee79b52aaa6$var$baseStyleField,
    icon: $21b24ee79b52aaa6$var$baseStyleIcon
});
var $21b24ee79b52aaa6$var$iconSpacing = (0, $cDoMf.defineStyle)({
    paddingInlineEnd: "8"
});
var $21b24ee79b52aaa6$var$_a2, $21b24ee79b52aaa6$var$_b, $21b24ee79b52aaa6$var$_c, $21b24ee79b52aaa6$var$_d, $21b24ee79b52aaa6$var$_e, $21b24ee79b52aaa6$var$_f, $21b24ee79b52aaa6$var$_g, $21b24ee79b52aaa6$var$_h;
var $21b24ee79b52aaa6$var$sizes = {
    lg: {
        ...($21b24ee79b52aaa6$var$_a2 = (0, $emFSB.inputTheme).sizes) == null ? void 0 : $21b24ee79b52aaa6$var$_a2.lg,
        field: {
            ...($21b24ee79b52aaa6$var$_b = (0, $emFSB.inputTheme).sizes) == null ? void 0 : $21b24ee79b52aaa6$var$_b.lg.field,
            ...$21b24ee79b52aaa6$var$iconSpacing
        }
    },
    md: {
        ...($21b24ee79b52aaa6$var$_c = (0, $emFSB.inputTheme).sizes) == null ? void 0 : $21b24ee79b52aaa6$var$_c.md,
        field: {
            ...($21b24ee79b52aaa6$var$_d = (0, $emFSB.inputTheme).sizes) == null ? void 0 : $21b24ee79b52aaa6$var$_d.md.field,
            ...$21b24ee79b52aaa6$var$iconSpacing
        }
    },
    sm: {
        ...($21b24ee79b52aaa6$var$_e = (0, $emFSB.inputTheme).sizes) == null ? void 0 : $21b24ee79b52aaa6$var$_e.sm,
        field: {
            ...($21b24ee79b52aaa6$var$_f = (0, $emFSB.inputTheme).sizes) == null ? void 0 : $21b24ee79b52aaa6$var$_f.sm.field,
            ...$21b24ee79b52aaa6$var$iconSpacing
        }
    },
    xs: {
        ...($21b24ee79b52aaa6$var$_g = (0, $emFSB.inputTheme).sizes) == null ? void 0 : $21b24ee79b52aaa6$var$_g.xs,
        field: {
            ...($21b24ee79b52aaa6$var$_h = (0, $emFSB.inputTheme).sizes) == null ? void 0 : $21b24ee79b52aaa6$var$_h.xs.field,
            ...$21b24ee79b52aaa6$var$iconSpacing
        },
        icon: {
            insetEnd: "1"
        }
    }
};
var $21b24ee79b52aaa6$export$21af0fc3c16183e1 = $21b24ee79b52aaa6$var$defineMultiStyleConfig({
    baseStyle: $21b24ee79b52aaa6$var$baseStyle,
    sizes: $21b24ee79b52aaa6$var$sizes,
    variants: (0, $emFSB.inputTheme).variants,
    defaultProps: (0, $emFSB.inputTheme).defaultProps
});

});

parcelRegister("d4yAi", function(module, exports) {

$parcel$export(module.exports, "skeletonTheme", () => $1f3c88013442264d$export$7680371ad2d79142);
// src/components/skeleton.ts

var $cDoMf = parcelRequire("cDoMf");
var $1f3c88013442264d$var$$startColor = (0, $cDoMf.cssVar)("skeleton-start-color");
var $1f3c88013442264d$var$$endColor = (0, $cDoMf.cssVar)("skeleton-end-color");
var $1f3c88013442264d$var$baseStyle = (0, $cDoMf.defineStyle)({
    [$1f3c88013442264d$var$$startColor.variable]: "colors.gray.100",
    [$1f3c88013442264d$var$$endColor.variable]: "colors.gray.400",
    _dark: {
        [$1f3c88013442264d$var$$startColor.variable]: "colors.gray.800",
        [$1f3c88013442264d$var$$endColor.variable]: "colors.gray.600"
    },
    background: $1f3c88013442264d$var$$startColor.reference,
    borderColor: $1f3c88013442264d$var$$endColor.reference,
    opacity: 0.7,
    borderRadius: "sm"
});
var $1f3c88013442264d$export$7680371ad2d79142 = (0, $cDoMf.defineStyleConfig)({
    baseStyle: $1f3c88013442264d$var$baseStyle
});

});

parcelRegister("jlmfx", function(module, exports) {

$parcel$export(module.exports, "skipLinkTheme", () => $cd7442d77f4a26e1$export$a8cf3228ef52959);
// src/components/skip-link.ts

var $cDoMf = parcelRequire("cDoMf");
var $cd7442d77f4a26e1$var$$bg = (0, $cDoMf.cssVar)("skip-link-bg");
var $cd7442d77f4a26e1$var$baseStyle = (0, $cDoMf.defineStyle)({
    borderRadius: "md",
    fontWeight: "semibold",
    _focusVisible: {
        boxShadow: "outline",
        padding: "4",
        position: "fixed",
        top: "6",
        insetStart: "6",
        [$cd7442d77f4a26e1$var$$bg.variable]: "colors.white",
        _dark: {
            [$cd7442d77f4a26e1$var$$bg.variable]: "colors.gray.700"
        },
        bg: $cd7442d77f4a26e1$var$$bg.reference
    }
});
var $cd7442d77f4a26e1$export$a8cf3228ef52959 = (0, $cDoMf.defineStyleConfig)({
    baseStyle: $cd7442d77f4a26e1$var$baseStyle
});

});

parcelRegister("2g6Sl", function(module, exports) {

$parcel$export(module.exports, "sliderTheme", () => $371a611021c06446$export$fff8df8fd8e1ed6f);
// src/components/slider.ts

var $jNq6g = parcelRequire("jNq6g");

var $cDoMf = parcelRequire("cDoMf");

var $kYGZ9 = parcelRequire("kYGZ9");
var { defineMultiStyleConfig: $371a611021c06446$var$defineMultiStyleConfig, definePartsStyle: $371a611021c06446$var$definePartsStyle } = (0, $cDoMf.createMultiStyleConfigHelpers)((0, $jNq6g.sliderAnatomy).keys);
var $371a611021c06446$var$$thumbSize = (0, $cDoMf.cssVar)("slider-thumb-size");
var $371a611021c06446$var$$trackSize = (0, $cDoMf.cssVar)("slider-track-size");
var $371a611021c06446$var$$bg = (0, $cDoMf.cssVar)("slider-bg");
var $371a611021c06446$var$baseStyleContainer = (0, $cDoMf.defineStyle)((props)=>{
    const { orientation: orientation } = props;
    return {
        display: "inline-block",
        position: "relative",
        cursor: "pointer",
        _disabled: {
            opacity: 0.6,
            cursor: "default",
            pointerEvents: "none"
        },
        ...(0, $kYGZ9.orient)({
            orientation: orientation,
            vertical: {
                h: "100%"
            },
            horizontal: {
                w: "100%"
            }
        })
    };
});
var $371a611021c06446$var$baseStyleTrack = (0, $cDoMf.defineStyle)((props)=>{
    const orientationStyles = (0, $kYGZ9.orient)({
        orientation: props.orientation,
        horizontal: {
            h: $371a611021c06446$var$$trackSize.reference
        },
        vertical: {
            w: $371a611021c06446$var$$trackSize.reference
        }
    });
    return {
        ...orientationStyles,
        overflow: "hidden",
        borderRadius: "sm",
        [$371a611021c06446$var$$bg.variable]: "colors.gray.200",
        _dark: {
            [$371a611021c06446$var$$bg.variable]: "colors.whiteAlpha.200"
        },
        _disabled: {
            [$371a611021c06446$var$$bg.variable]: "colors.gray.300",
            _dark: {
                [$371a611021c06446$var$$bg.variable]: "colors.whiteAlpha.300"
            }
        },
        bg: $371a611021c06446$var$$bg.reference
    };
});
var $371a611021c06446$var$baseStyleThumb = (0, $cDoMf.defineStyle)((props)=>{
    const { orientation: orientation } = props;
    const orientationStyle = (0, $kYGZ9.orient)({
        orientation: orientation,
        vertical: {
            left: "50%",
            transform: `translateX(-50%)`,
            _active: {
                transform: `translateX(-50%) scale(1.15)`
            }
        },
        horizontal: {
            top: "50%",
            transform: `translateY(-50%)`,
            _active: {
                transform: `translateY(-50%) scale(1.15)`
            }
        }
    });
    return {
        ...orientationStyle,
        w: $371a611021c06446$var$$thumbSize.reference,
        h: $371a611021c06446$var$$thumbSize.reference,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        outline: 0,
        zIndex: 1,
        borderRadius: "full",
        bg: "white",
        boxShadow: "base",
        border: "1px solid",
        borderColor: "transparent",
        transitionProperty: "transform",
        transitionDuration: "normal",
        _focusVisible: {
            boxShadow: "outline"
        },
        _disabled: {
            bg: "gray.300"
        }
    };
});
var $371a611021c06446$var$baseStyleFilledTrack = (0, $cDoMf.defineStyle)((props)=>{
    const { colorScheme: c } = props;
    return {
        width: "inherit",
        height: "inherit",
        [$371a611021c06446$var$$bg.variable]: `colors.${c}.500`,
        _dark: {
            [$371a611021c06446$var$$bg.variable]: `colors.${c}.200`
        },
        bg: $371a611021c06446$var$$bg.reference
    };
});
var $371a611021c06446$var$baseStyle = $371a611021c06446$var$definePartsStyle((props)=>({
        container: $371a611021c06446$var$baseStyleContainer(props),
        track: $371a611021c06446$var$baseStyleTrack(props),
        thumb: $371a611021c06446$var$baseStyleThumb(props),
        filledTrack: $371a611021c06446$var$baseStyleFilledTrack(props)
    }));
var $371a611021c06446$var$sizeLg = $371a611021c06446$var$definePartsStyle({
    container: {
        [$371a611021c06446$var$$thumbSize.variable]: `sizes.4`,
        [$371a611021c06446$var$$trackSize.variable]: `sizes.1`
    }
});
var $371a611021c06446$var$sizeMd = $371a611021c06446$var$definePartsStyle({
    container: {
        [$371a611021c06446$var$$thumbSize.variable]: `sizes.3.5`,
        [$371a611021c06446$var$$trackSize.variable]: `sizes.1`
    }
});
var $371a611021c06446$var$sizeSm = $371a611021c06446$var$definePartsStyle({
    container: {
        [$371a611021c06446$var$$thumbSize.variable]: `sizes.2.5`,
        [$371a611021c06446$var$$trackSize.variable]: `sizes.0.5`
    }
});
var $371a611021c06446$var$sizes = {
    lg: $371a611021c06446$var$sizeLg,
    md: $371a611021c06446$var$sizeMd,
    sm: $371a611021c06446$var$sizeSm
};
var $371a611021c06446$export$fff8df8fd8e1ed6f = $371a611021c06446$var$defineMultiStyleConfig({
    baseStyle: $371a611021c06446$var$baseStyle,
    sizes: $371a611021c06446$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});

});

parcelRegister("7X6L3", function(module, exports) {

$parcel$export(module.exports, "spinnerTheme", () => $1fae57c7d4dd448a$export$d76156e68e556d3f);
// src/components/spinner.ts

var $cDoMf = parcelRequire("cDoMf");

var $9TrBA = parcelRequire("9TrBA");
var $1fae57c7d4dd448a$var$$size = (0, $9TrBA.cssVar)("spinner-size");
var $1fae57c7d4dd448a$var$baseStyle = (0, $cDoMf.defineStyle)({
    width: [
        $1fae57c7d4dd448a$var$$size.reference
    ],
    height: [
        $1fae57c7d4dd448a$var$$size.reference
    ]
});
var $1fae57c7d4dd448a$var$sizes = {
    xs: (0, $cDoMf.defineStyle)({
        [$1fae57c7d4dd448a$var$$size.variable]: "sizes.3"
    }),
    sm: (0, $cDoMf.defineStyle)({
        [$1fae57c7d4dd448a$var$$size.variable]: "sizes.4"
    }),
    md: (0, $cDoMf.defineStyle)({
        [$1fae57c7d4dd448a$var$$size.variable]: "sizes.6"
    }),
    lg: (0, $cDoMf.defineStyle)({
        [$1fae57c7d4dd448a$var$$size.variable]: "sizes.8"
    }),
    xl: (0, $cDoMf.defineStyle)({
        [$1fae57c7d4dd448a$var$$size.variable]: "sizes.12"
    })
};
var $1fae57c7d4dd448a$export$d76156e68e556d3f = (0, $cDoMf.defineStyleConfig)({
    baseStyle: $1fae57c7d4dd448a$var$baseStyle,
    sizes: $1fae57c7d4dd448a$var$sizes,
    defaultProps: {
        size: "md"
    }
});

});

parcelRegister("eF9wh", function(module, exports) {

$parcel$export(module.exports, "statTheme", () => $729b10f46bb8fcce$export$f3301eb37a20f09e);
// src/components/stat.ts

var $jNq6g = parcelRequire("jNq6g");

var $cDoMf = parcelRequire("cDoMf");
var { defineMultiStyleConfig: $729b10f46bb8fcce$var$defineMultiStyleConfig, definePartsStyle: $729b10f46bb8fcce$var$definePartsStyle } = (0, $cDoMf.createMultiStyleConfigHelpers)((0, $jNq6g.statAnatomy).keys);
var $729b10f46bb8fcce$var$baseStyleLabel = (0, $cDoMf.defineStyle)({
    fontWeight: "medium"
});
var $729b10f46bb8fcce$var$baseStyleHelpText = (0, $cDoMf.defineStyle)({
    opacity: 0.8,
    marginBottom: "2"
});
var $729b10f46bb8fcce$var$baseStyleNumber = (0, $cDoMf.defineStyle)({
    verticalAlign: "baseline",
    fontWeight: "semibold"
});
var $729b10f46bb8fcce$var$baseStyleIcon = (0, $cDoMf.defineStyle)({
    marginEnd: 1,
    w: "3.5",
    h: "3.5",
    verticalAlign: "middle"
});
var $729b10f46bb8fcce$var$baseStyle = $729b10f46bb8fcce$var$definePartsStyle({
    container: {},
    label: $729b10f46bb8fcce$var$baseStyleLabel,
    helpText: $729b10f46bb8fcce$var$baseStyleHelpText,
    number: $729b10f46bb8fcce$var$baseStyleNumber,
    icon: $729b10f46bb8fcce$var$baseStyleIcon
});
var $729b10f46bb8fcce$var$sizes = {
    md: $729b10f46bb8fcce$var$definePartsStyle({
        label: {
            fontSize: "sm"
        },
        helpText: {
            fontSize: "sm"
        },
        number: {
            fontSize: "2xl"
        }
    })
};
var $729b10f46bb8fcce$export$f3301eb37a20f09e = $729b10f46bb8fcce$var$defineMultiStyleConfig({
    baseStyle: $729b10f46bb8fcce$var$baseStyle,
    sizes: $729b10f46bb8fcce$var$sizes,
    defaultProps: {
        size: "md"
    }
});

});

parcelRegister("h5VHX", function(module, exports) {

$parcel$export(module.exports, "kbdTheme", () => $3cb2d6f35ae2434b$export$e193528a501e9a4a);
// src/components/kbd.ts

var $cDoMf = parcelRequire("cDoMf");
var $3cb2d6f35ae2434b$var$$bg = (0, $cDoMf.cssVar)("kbd-bg");
var $3cb2d6f35ae2434b$var$baseStyle = (0, $cDoMf.defineStyle)({
    [$3cb2d6f35ae2434b$var$$bg.variable]: "colors.gray.100",
    _dark: {
        [$3cb2d6f35ae2434b$var$$bg.variable]: "colors.whiteAlpha.100"
    },
    bg: $3cb2d6f35ae2434b$var$$bg.reference,
    borderRadius: "md",
    borderWidth: "1px",
    borderBottomWidth: "3px",
    fontSize: "0.8em",
    fontWeight: "bold",
    lineHeight: "normal",
    px: "0.4em",
    whiteSpace: "nowrap"
});
var $3cb2d6f35ae2434b$export$e193528a501e9a4a = (0, $cDoMf.defineStyleConfig)({
    baseStyle: $3cb2d6f35ae2434b$var$baseStyle
});

});

parcelRegister("1Dk22", function(module, exports) {

$parcel$export(module.exports, "linkTheme", () => $6ee73a2102c0ce93$export$af7f58b96695762e);
// src/components/link.ts

var $cDoMf = parcelRequire("cDoMf");
var $6ee73a2102c0ce93$var$baseStyle = (0, $cDoMf.defineStyle)({
    transitionProperty: "common",
    transitionDuration: "fast",
    transitionTimingFunction: "ease-out",
    cursor: "pointer",
    textDecoration: "none",
    outline: "none",
    color: "inherit",
    _hover: {
        textDecoration: "underline"
    },
    _focusVisible: {
        boxShadow: "outline"
    }
});
var $6ee73a2102c0ce93$export$af7f58b96695762e = (0, $cDoMf.defineStyleConfig)({
    baseStyle: $6ee73a2102c0ce93$var$baseStyle
});

});

parcelRegister("4bM5v", function(module, exports) {

$parcel$export(module.exports, "listTheme", () => $bcecc590cfeb91cf$export$ce840f8e8ef752d);
// src/components/list.ts

var $jNq6g = parcelRequire("jNq6g");

var $cDoMf = parcelRequire("cDoMf");
var { defineMultiStyleConfig: $bcecc590cfeb91cf$var$defineMultiStyleConfig, definePartsStyle: $bcecc590cfeb91cf$var$definePartsStyle } = (0, $cDoMf.createMultiStyleConfigHelpers)((0, $jNq6g.listAnatomy).keys);
var $bcecc590cfeb91cf$var$baseStyleIcon = (0, $cDoMf.defineStyle)({
    marginEnd: "2",
    display: "inline",
    verticalAlign: "text-bottom"
});
var $bcecc590cfeb91cf$var$baseStyle = $bcecc590cfeb91cf$var$definePartsStyle({
    icon: $bcecc590cfeb91cf$var$baseStyleIcon
});
var $bcecc590cfeb91cf$export$ce840f8e8ef752d = $bcecc590cfeb91cf$var$defineMultiStyleConfig({
    baseStyle: $bcecc590cfeb91cf$var$baseStyle
});

});

parcelRegister("hEzBz", function(module, exports) {

$parcel$export(module.exports, "menuTheme", () => $d4a13a24a07a6c3f$export$687ce088075ea42b);
// src/components/menu.ts

var $jNq6g = parcelRequire("jNq6g");

var $cDoMf = parcelRequire("cDoMf");
var { defineMultiStyleConfig: $d4a13a24a07a6c3f$var$defineMultiStyleConfig, definePartsStyle: $d4a13a24a07a6c3f$var$definePartsStyle } = (0, $cDoMf.createMultiStyleConfigHelpers)((0, $jNq6g.menuAnatomy).keys);
var $d4a13a24a07a6c3f$var$$bg = (0, $cDoMf.cssVar)("menu-bg");
var $d4a13a24a07a6c3f$var$$shadow = (0, $cDoMf.cssVar)("menu-shadow");
var $d4a13a24a07a6c3f$var$baseStyleList = (0, $cDoMf.defineStyle)({
    [$d4a13a24a07a6c3f$var$$bg.variable]: "#fff",
    [$d4a13a24a07a6c3f$var$$shadow.variable]: "shadows.sm",
    _dark: {
        [$d4a13a24a07a6c3f$var$$bg.variable]: "colors.gray.700",
        [$d4a13a24a07a6c3f$var$$shadow.variable]: "shadows.dark-lg"
    },
    color: "inherit",
    minW: "3xs",
    py: "2",
    zIndex: 1,
    borderRadius: "md",
    borderWidth: "1px",
    bg: $d4a13a24a07a6c3f$var$$bg.reference,
    boxShadow: $d4a13a24a07a6c3f$var$$shadow.reference
});
var $d4a13a24a07a6c3f$var$baseStyleItem = (0, $cDoMf.defineStyle)({
    py: "1.5",
    px: "3",
    transitionProperty: "background",
    transitionDuration: "ultra-fast",
    transitionTimingFunction: "ease-in",
    _focus: {
        [$d4a13a24a07a6c3f$var$$bg.variable]: "colors.gray.100",
        _dark: {
            [$d4a13a24a07a6c3f$var$$bg.variable]: "colors.whiteAlpha.100"
        }
    },
    _active: {
        [$d4a13a24a07a6c3f$var$$bg.variable]: "colors.gray.200",
        _dark: {
            [$d4a13a24a07a6c3f$var$$bg.variable]: "colors.whiteAlpha.200"
        }
    },
    _expanded: {
        [$d4a13a24a07a6c3f$var$$bg.variable]: "colors.gray.100",
        _dark: {
            [$d4a13a24a07a6c3f$var$$bg.variable]: "colors.whiteAlpha.100"
        }
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
    },
    bg: $d4a13a24a07a6c3f$var$$bg.reference
});
var $d4a13a24a07a6c3f$var$baseStyleGroupTitle = (0, $cDoMf.defineStyle)({
    mx: 4,
    my: 2,
    fontWeight: "semibold",
    fontSize: "sm"
});
var $d4a13a24a07a6c3f$var$baseStyleIcon = (0, $cDoMf.defineStyle)({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
});
var $d4a13a24a07a6c3f$var$baseStyleCommand = (0, $cDoMf.defineStyle)({
    opacity: 0.6
});
var $d4a13a24a07a6c3f$var$baseStyleDivider = (0, $cDoMf.defineStyle)({
    border: 0,
    borderBottom: "1px solid",
    borderColor: "inherit",
    my: "2",
    opacity: 0.6
});
var $d4a13a24a07a6c3f$var$baseStyleButton = (0, $cDoMf.defineStyle)({
    transitionProperty: "common",
    transitionDuration: "normal"
});
var $d4a13a24a07a6c3f$var$baseStyle = $d4a13a24a07a6c3f$var$definePartsStyle({
    button: $d4a13a24a07a6c3f$var$baseStyleButton,
    list: $d4a13a24a07a6c3f$var$baseStyleList,
    item: $d4a13a24a07a6c3f$var$baseStyleItem,
    groupTitle: $d4a13a24a07a6c3f$var$baseStyleGroupTitle,
    icon: $d4a13a24a07a6c3f$var$baseStyleIcon,
    command: $d4a13a24a07a6c3f$var$baseStyleCommand,
    divider: $d4a13a24a07a6c3f$var$baseStyleDivider
});
var $d4a13a24a07a6c3f$export$687ce088075ea42b = $d4a13a24a07a6c3f$var$defineMultiStyleConfig({
    baseStyle: $d4a13a24a07a6c3f$var$baseStyle
});

});

parcelRegister("cKFPW", function(module, exports) {

$parcel$export(module.exports, "modalTheme", () => $e48329fb3beef499$export$158ae9a07be41c05);

var $1VjjY = parcelRequire("1VjjY");

var $jNq6g = parcelRequire("jNq6g");

var $cDoMf = parcelRequire("cDoMf");
var { defineMultiStyleConfig: $e48329fb3beef499$var$defineMultiStyleConfig, definePartsStyle: $e48329fb3beef499$var$definePartsStyle } = (0, $cDoMf.createMultiStyleConfigHelpers)((0, $jNq6g.modalAnatomy).keys);
var $e48329fb3beef499$var$$bg = (0, $cDoMf.cssVar)("modal-bg");
var $e48329fb3beef499$var$$shadow = (0, $cDoMf.cssVar)("modal-shadow");
var $e48329fb3beef499$var$baseStyleOverlay = (0, $cDoMf.defineStyle)({
    bg: "blackAlpha.600",
    zIndex: "modal"
});
var $e48329fb3beef499$var$baseStyleDialogContainer = (0, $cDoMf.defineStyle)((props)=>{
    const { isCentered: isCentered, scrollBehavior: scrollBehavior } = props;
    return {
        display: "flex",
        zIndex: "modal",
        justifyContent: "center",
        alignItems: isCentered ? "center" : "flex-start",
        overflow: scrollBehavior === "inside" ? "hidden" : "auto",
        overscrollBehaviorY: "none"
    };
});
var $e48329fb3beef499$var$baseStyleDialog = (0, $cDoMf.defineStyle)((props)=>{
    const { isCentered: isCentered, scrollBehavior: scrollBehavior } = props;
    return {
        borderRadius: "md",
        color: "inherit",
        my: isCentered ? "auto" : "16",
        mx: isCentered ? "auto" : void 0,
        zIndex: "modal",
        maxH: scrollBehavior === "inside" ? "calc(100% - 7.5rem)" : void 0,
        [$e48329fb3beef499$var$$bg.variable]: "colors.white",
        [$e48329fb3beef499$var$$shadow.variable]: "shadows.lg",
        _dark: {
            [$e48329fb3beef499$var$$bg.variable]: "colors.gray.700",
            [$e48329fb3beef499$var$$shadow.variable]: "shadows.dark-lg"
        },
        bg: $e48329fb3beef499$var$$bg.reference,
        boxShadow: $e48329fb3beef499$var$$shadow.reference
    };
});
var $e48329fb3beef499$var$baseStyleHeader = (0, $cDoMf.defineStyle)({
    px: "6",
    py: "4",
    fontSize: "xl",
    fontWeight: "semibold"
});
var $e48329fb3beef499$var$baseStyleCloseButton = (0, $cDoMf.defineStyle)({
    position: "absolute",
    top: "2",
    insetEnd: "3"
});
var $e48329fb3beef499$var$baseStyleBody = (0, $cDoMf.defineStyle)((props)=>{
    const { scrollBehavior: scrollBehavior } = props;
    return {
        px: "6",
        py: "2",
        flex: "1",
        overflow: scrollBehavior === "inside" ? "auto" : void 0
    };
});
var $e48329fb3beef499$var$baseStyleFooter = (0, $cDoMf.defineStyle)({
    px: "6",
    py: "4"
});
var $e48329fb3beef499$var$baseStyle = $e48329fb3beef499$var$definePartsStyle((props)=>({
        overlay: $e48329fb3beef499$var$baseStyleOverlay,
        dialogContainer: (0, $1VjjY.runIfFn)($e48329fb3beef499$var$baseStyleDialogContainer, props),
        dialog: (0, $1VjjY.runIfFn)($e48329fb3beef499$var$baseStyleDialog, props),
        header: $e48329fb3beef499$var$baseStyleHeader,
        closeButton: $e48329fb3beef499$var$baseStyleCloseButton,
        body: (0, $1VjjY.runIfFn)($e48329fb3beef499$var$baseStyleBody, props),
        footer: $e48329fb3beef499$var$baseStyleFooter
    }));
function $e48329fb3beef499$var$getSize(value) {
    if (value === "full") return $e48329fb3beef499$var$definePartsStyle({
        dialog: {
            maxW: "100vw",
            minH: "$100vh",
            my: "0",
            borderRadius: "0"
        }
    });
    return $e48329fb3beef499$var$definePartsStyle({
        dialog: {
            maxW: value
        }
    });
}
var $e48329fb3beef499$var$sizes = {
    xs: $e48329fb3beef499$var$getSize("xs"),
    sm: $e48329fb3beef499$var$getSize("sm"),
    md: $e48329fb3beef499$var$getSize("md"),
    lg: $e48329fb3beef499$var$getSize("lg"),
    xl: $e48329fb3beef499$var$getSize("xl"),
    "2xl": $e48329fb3beef499$var$getSize("2xl"),
    "3xl": $e48329fb3beef499$var$getSize("3xl"),
    "4xl": $e48329fb3beef499$var$getSize("4xl"),
    "5xl": $e48329fb3beef499$var$getSize("5xl"),
    "6xl": $e48329fb3beef499$var$getSize("6xl"),
    full: $e48329fb3beef499$var$getSize("full")
};
var $e48329fb3beef499$export$158ae9a07be41c05 = $e48329fb3beef499$var$defineMultiStyleConfig({
    baseStyle: $e48329fb3beef499$var$baseStyle,
    sizes: $e48329fb3beef499$var$sizes,
    defaultProps: {
        size: "md"
    }
});

});

parcelRegister("4C8RC", function(module, exports) {

$parcel$export(module.exports, "numberInputTheme", () => $5d059c3825dc74e1$export$b9bc5fa6e7f960a1);

var $9Ga7i = parcelRequire("9Ga7i");

var $emFSB = parcelRequire("emFSB");

var $1VjjY = parcelRequire("1VjjY");

var $jNq6g = parcelRequire("jNq6g");

var $cDoMf = parcelRequire("cDoMf");

var $8rLXU = parcelRequire("8rLXU");
var $9TrBA = parcelRequire("9TrBA");
var { defineMultiStyleConfig: $5d059c3825dc74e1$var$defineMultiStyleConfig, definePartsStyle: $5d059c3825dc74e1$var$definePartsStyle } = (0, $cDoMf.createMultiStyleConfigHelpers)((0, $jNq6g.numberInputAnatomy).keys);
var $5d059c3825dc74e1$var$$stepperWidth = (0, $9TrBA.cssVar)("number-input-stepper-width");
var $5d059c3825dc74e1$var$$inputPadding = (0, $9TrBA.cssVar)("number-input-input-padding");
var $5d059c3825dc74e1$var$inputPaddingValue = (0, $8rLXU.calc)($5d059c3825dc74e1$var$$stepperWidth).add("0.5rem").toString();
var $5d059c3825dc74e1$var$$bg = (0, $9TrBA.cssVar)("number-input-bg");
var $5d059c3825dc74e1$var$$fg = (0, $9TrBA.cssVar)("number-input-color");
var $5d059c3825dc74e1$var$$border = (0, $9TrBA.cssVar)("number-input-border-color");
var $5d059c3825dc74e1$var$baseStyleRoot = (0, $cDoMf.defineStyle)({
    [$5d059c3825dc74e1$var$$stepperWidth.variable]: "sizes.6",
    [$5d059c3825dc74e1$var$$inputPadding.variable]: $5d059c3825dc74e1$var$inputPaddingValue
});
var $5d059c3825dc74e1$var$baseStyleField = (0, $cDoMf.defineStyle)((props)=>{
    var _a, _b;
    return (_b = (_a = (0, $1VjjY.runIfFn)((0, $emFSB.inputTheme).baseStyle, props)) == null ? void 0 : _a.field) != null ? _b : {};
});
var $5d059c3825dc74e1$var$baseStyleStepperGroup = (0, $cDoMf.defineStyle)({
    width: $5d059c3825dc74e1$var$$stepperWidth.reference
});
var $5d059c3825dc74e1$var$baseStyleStepper = (0, $cDoMf.defineStyle)({
    borderStart: "1px solid",
    borderStartColor: $5d059c3825dc74e1$var$$border.reference,
    color: $5d059c3825dc74e1$var$$fg.reference,
    bg: $5d059c3825dc74e1$var$$bg.reference,
    [$5d059c3825dc74e1$var$$fg.variable]: "colors.chakra-body-text",
    [$5d059c3825dc74e1$var$$border.variable]: "colors.chakra-border-color",
    _dark: {
        [$5d059c3825dc74e1$var$$fg.variable]: "colors.whiteAlpha.800",
        [$5d059c3825dc74e1$var$$border.variable]: "colors.whiteAlpha.300"
    },
    _active: {
        [$5d059c3825dc74e1$var$$bg.variable]: "colors.gray.200",
        _dark: {
            [$5d059c3825dc74e1$var$$bg.variable]: "colors.whiteAlpha.300"
        }
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
    }
});
var $5d059c3825dc74e1$var$baseStyle = $5d059c3825dc74e1$var$definePartsStyle((props)=>{
    var _a;
    return {
        root: $5d059c3825dc74e1$var$baseStyleRoot,
        field: (_a = (0, $1VjjY.runIfFn)($5d059c3825dc74e1$var$baseStyleField, props)) != null ? _a : {},
        stepperGroup: $5d059c3825dc74e1$var$baseStyleStepperGroup,
        stepper: $5d059c3825dc74e1$var$baseStyleStepper
    };
});
function $5d059c3825dc74e1$var$getSize(size) {
    var _a, _b, _c;
    const sizeStyle = (_a = (0, $emFSB.inputTheme).sizes) == null ? void 0 : _a[size];
    const radius = {
        lg: "md",
        md: "md",
        sm: "sm",
        xs: "sm"
    };
    const _fontSize = (_c = (_b = sizeStyle.field) == null ? void 0 : _b.fontSize) != null ? _c : "md";
    const fontSize = (0, $9Ga7i.typography_default).fontSizes[_fontSize];
    return $5d059c3825dc74e1$var$definePartsStyle({
        field: {
            ...sizeStyle.field,
            paddingInlineEnd: $5d059c3825dc74e1$var$$inputPadding.reference,
            verticalAlign: "top"
        },
        stepper: {
            fontSize: (0, $8rLXU.calc)(fontSize).multiply(0.75).toString(),
            _first: {
                borderTopEndRadius: radius[size]
            },
            _last: {
                borderBottomEndRadius: radius[size],
                mt: "-1px",
                borderTopWidth: 1
            }
        }
    });
}
var $5d059c3825dc74e1$var$sizes = {
    xs: $5d059c3825dc74e1$var$getSize("xs"),
    sm: $5d059c3825dc74e1$var$getSize("sm"),
    md: $5d059c3825dc74e1$var$getSize("md"),
    lg: $5d059c3825dc74e1$var$getSize("lg")
};
var $5d059c3825dc74e1$export$b9bc5fa6e7f960a1 = $5d059c3825dc74e1$var$defineMultiStyleConfig({
    baseStyle: $5d059c3825dc74e1$var$baseStyle,
    sizes: $5d059c3825dc74e1$var$sizes,
    variants: (0, $emFSB.inputTheme).variants,
    defaultProps: (0, $emFSB.inputTheme).defaultProps
});

});

parcelRegister("ggOLH", function(module, exports) {

$parcel$export(module.exports, "pinInputTheme", () => $128770732eb75b35$export$8504c22c55a552e0);

var $emFSB = parcelRequire("emFSB");

var $1VjjY = parcelRequire("1VjjY");

var $cDoMf = parcelRequire("cDoMf");
var $128770732eb75b35$var$_a;
var $128770732eb75b35$var$baseStyle = (0, $cDoMf.defineStyle)({
    ...($128770732eb75b35$var$_a = (0, $emFSB.inputTheme).baseStyle) == null ? void 0 : $128770732eb75b35$var$_a.field,
    textAlign: "center"
});
var $128770732eb75b35$var$sizes = {
    lg: (0, $cDoMf.defineStyle)({
        fontSize: "lg",
        w: 12,
        h: 12,
        borderRadius: "md"
    }),
    md: (0, $cDoMf.defineStyle)({
        fontSize: "md",
        w: 10,
        h: 10,
        borderRadius: "md"
    }),
    sm: (0, $cDoMf.defineStyle)({
        fontSize: "sm",
        w: 8,
        h: 8,
        borderRadius: "sm"
    }),
    xs: (0, $cDoMf.defineStyle)({
        fontSize: "xs",
        w: 6,
        h: 6,
        borderRadius: "sm"
    })
};
var $128770732eb75b35$var$_a2, $128770732eb75b35$var$_b;
var $128770732eb75b35$var$variants = {
    outline: (0, $cDoMf.defineStyle)((props)=>{
        var _a3, _b2, _c;
        return (_c = (_b2 = (0, $1VjjY.runIfFn)((_a3 = (0, $emFSB.inputTheme).variants) == null ? void 0 : _a3.outline, props)) == null ? void 0 : _b2.field) != null ? _c : {};
    }),
    flushed: (0, $cDoMf.defineStyle)((props)=>{
        var _a3, _b2, _c;
        return (_c = (_b2 = (0, $1VjjY.runIfFn)((_a3 = (0, $emFSB.inputTheme).variants) == null ? void 0 : _a3.flushed, props)) == null ? void 0 : _b2.field) != null ? _c : {};
    }),
    filled: (0, $cDoMf.defineStyle)((props)=>{
        var _a3, _b2, _c;
        return (_c = (_b2 = (0, $1VjjY.runIfFn)((_a3 = (0, $emFSB.inputTheme).variants) == null ? void 0 : _a3.filled, props)) == null ? void 0 : _b2.field) != null ? _c : {};
    }),
    unstyled: ($128770732eb75b35$var$_b = ($128770732eb75b35$var$_a2 = (0, $emFSB.inputTheme).variants) == null ? void 0 : $128770732eb75b35$var$_a2.unstyled.field) != null ? $128770732eb75b35$var$_b : {}
};
var $128770732eb75b35$export$8504c22c55a552e0 = (0, $cDoMf.defineStyleConfig)({
    baseStyle: $128770732eb75b35$var$baseStyle,
    sizes: $128770732eb75b35$var$sizes,
    variants: $128770732eb75b35$var$variants,
    defaultProps: (0, $emFSB.inputTheme).defaultProps
});

});

parcelRegister("i9UZR", function(module, exports) {

$parcel$export(module.exports, "popoverTheme", () => $ec9a16436d66d358$export$135f12f777be1ef7);
// src/components/popover.ts

var $jNq6g = parcelRequire("jNq6g");

var $cDoMf = parcelRequire("cDoMf");

var $9TrBA = parcelRequire("9TrBA");
var { defineMultiStyleConfig: $ec9a16436d66d358$var$defineMultiStyleConfig, definePartsStyle: $ec9a16436d66d358$var$definePartsStyle } = (0, $cDoMf.createMultiStyleConfigHelpers)((0, $jNq6g.popoverAnatomy).keys);
var $ec9a16436d66d358$var$$popperBg = (0, $9TrBA.cssVar)("popper-bg");
var $ec9a16436d66d358$var$$arrowBg = (0, $9TrBA.cssVar)("popper-arrow-bg");
var $ec9a16436d66d358$var$$arrowShadowColor = (0, $9TrBA.cssVar)("popper-arrow-shadow-color");
var $ec9a16436d66d358$var$baseStylePopper = (0, $cDoMf.defineStyle)({
    zIndex: 10
});
var $ec9a16436d66d358$var$baseStyleContent = (0, $cDoMf.defineStyle)({
    [$ec9a16436d66d358$var$$popperBg.variable]: `colors.white`,
    bg: $ec9a16436d66d358$var$$popperBg.reference,
    [$ec9a16436d66d358$var$$arrowBg.variable]: $ec9a16436d66d358$var$$popperBg.reference,
    [$ec9a16436d66d358$var$$arrowShadowColor.variable]: `colors.gray.200`,
    _dark: {
        [$ec9a16436d66d358$var$$popperBg.variable]: `colors.gray.700`,
        [$ec9a16436d66d358$var$$arrowShadowColor.variable]: `colors.whiteAlpha.300`
    },
    width: "xs",
    border: "1px solid",
    borderColor: "inherit",
    borderRadius: "md",
    boxShadow: "sm",
    zIndex: "inherit",
    _focusVisible: {
        outline: 0,
        boxShadow: "outline"
    }
});
var $ec9a16436d66d358$var$baseStyleHeader = (0, $cDoMf.defineStyle)({
    px: 3,
    py: 2,
    borderBottomWidth: "1px"
});
var $ec9a16436d66d358$var$baseStyleBody = (0, $cDoMf.defineStyle)({
    px: 3,
    py: 2
});
var $ec9a16436d66d358$var$baseStyleFooter = (0, $cDoMf.defineStyle)({
    px: 3,
    py: 2,
    borderTopWidth: "1px"
});
var $ec9a16436d66d358$var$baseStyleCloseButton = (0, $cDoMf.defineStyle)({
    position: "absolute",
    borderRadius: "md",
    top: 1,
    insetEnd: 2,
    padding: 2
});
var $ec9a16436d66d358$var$baseStyle = $ec9a16436d66d358$var$definePartsStyle({
    popper: $ec9a16436d66d358$var$baseStylePopper,
    content: $ec9a16436d66d358$var$baseStyleContent,
    header: $ec9a16436d66d358$var$baseStyleHeader,
    body: $ec9a16436d66d358$var$baseStyleBody,
    footer: $ec9a16436d66d358$var$baseStyleFooter,
    closeButton: $ec9a16436d66d358$var$baseStyleCloseButton
});
var $ec9a16436d66d358$export$135f12f777be1ef7 = $ec9a16436d66d358$var$defineMultiStyleConfig({
    baseStyle: $ec9a16436d66d358$var$baseStyle
});

});

parcelRegister("gMjvz", function(module, exports) {

$parcel$export(module.exports, "drawerTheme", () => $0ef5deadefc8c240$export$8057937c11129602);

var $1VjjY = parcelRequire("1VjjY");

var $jNq6g = parcelRequire("jNq6g");

var $cDoMf = parcelRequire("cDoMf");
var { definePartsStyle: $0ef5deadefc8c240$var$definePartsStyle, defineMultiStyleConfig: $0ef5deadefc8c240$var$defineMultiStyleConfig } = (0, $cDoMf.createMultiStyleConfigHelpers)((0, $jNq6g.drawerAnatomy).keys);
var $0ef5deadefc8c240$var$$bg = (0, $cDoMf.cssVar)("drawer-bg");
var $0ef5deadefc8c240$var$$bs = (0, $cDoMf.cssVar)("drawer-box-shadow");
function $0ef5deadefc8c240$var$getSize(value) {
    if (value === "full") return $0ef5deadefc8c240$var$definePartsStyle({
        dialog: {
            maxW: "100vw",
            h: "100vh"
        }
    });
    return $0ef5deadefc8c240$var$definePartsStyle({
        dialog: {
            maxW: value
        }
    });
}
var $0ef5deadefc8c240$var$baseStyleOverlay = (0, $cDoMf.defineStyle)({
    bg: "blackAlpha.600",
    zIndex: "modal"
});
var $0ef5deadefc8c240$var$baseStyleDialogContainer = (0, $cDoMf.defineStyle)({
    display: "flex",
    zIndex: "modal",
    justifyContent: "center"
});
var $0ef5deadefc8c240$var$baseStyleDialog = (0, $cDoMf.defineStyle)((props)=>{
    const { isFullHeight: isFullHeight } = props;
    return {
        ...isFullHeight && {
            height: "100vh"
        },
        zIndex: "modal",
        maxH: "100vh",
        color: "inherit",
        [$0ef5deadefc8c240$var$$bg.variable]: "colors.white",
        [$0ef5deadefc8c240$var$$bs.variable]: "shadows.lg",
        _dark: {
            [$0ef5deadefc8c240$var$$bg.variable]: "colors.gray.700",
            [$0ef5deadefc8c240$var$$bs.variable]: "shadows.dark-lg"
        },
        bg: $0ef5deadefc8c240$var$$bg.reference,
        boxShadow: $0ef5deadefc8c240$var$$bs.reference
    };
});
var $0ef5deadefc8c240$var$baseStyleHeader = (0, $cDoMf.defineStyle)({
    px: "6",
    py: "4",
    fontSize: "xl",
    fontWeight: "semibold"
});
var $0ef5deadefc8c240$var$baseStyleCloseButton = (0, $cDoMf.defineStyle)({
    position: "absolute",
    top: "2",
    insetEnd: "3"
});
var $0ef5deadefc8c240$var$baseStyleBody = (0, $cDoMf.defineStyle)({
    px: "6",
    py: "2",
    flex: "1",
    overflow: "auto"
});
var $0ef5deadefc8c240$var$baseStyleFooter = (0, $cDoMf.defineStyle)({
    px: "6",
    py: "4"
});
var $0ef5deadefc8c240$var$baseStyle = $0ef5deadefc8c240$var$definePartsStyle((props)=>({
        overlay: $0ef5deadefc8c240$var$baseStyleOverlay,
        dialogContainer: $0ef5deadefc8c240$var$baseStyleDialogContainer,
        dialog: (0, $1VjjY.runIfFn)($0ef5deadefc8c240$var$baseStyleDialog, props),
        header: $0ef5deadefc8c240$var$baseStyleHeader,
        closeButton: $0ef5deadefc8c240$var$baseStyleCloseButton,
        body: $0ef5deadefc8c240$var$baseStyleBody,
        footer: $0ef5deadefc8c240$var$baseStyleFooter
    }));
var $0ef5deadefc8c240$var$sizes = {
    xs: $0ef5deadefc8c240$var$getSize("xs"),
    sm: $0ef5deadefc8c240$var$getSize("md"),
    md: $0ef5deadefc8c240$var$getSize("lg"),
    lg: $0ef5deadefc8c240$var$getSize("2xl"),
    xl: $0ef5deadefc8c240$var$getSize("4xl"),
    full: $0ef5deadefc8c240$var$getSize("full")
};
var $0ef5deadefc8c240$export$8057937c11129602 = $0ef5deadefc8c240$var$defineMultiStyleConfig({
    baseStyle: $0ef5deadefc8c240$var$baseStyle,
    sizes: $0ef5deadefc8c240$var$sizes,
    defaultProps: {
        size: "xs"
    }
});

});

parcelRegister("PGq40", function(module, exports) {

$parcel$export(module.exports, "editableTheme", () => $b105653afd756ffe$export$a09813cbe72349b1);
// src/components/editable.ts

var $jNq6g = parcelRequire("jNq6g");

var $cDoMf = parcelRequire("cDoMf");
var { definePartsStyle: $b105653afd756ffe$var$definePartsStyle, defineMultiStyleConfig: $b105653afd756ffe$var$defineMultiStyleConfig } = (0, $cDoMf.createMultiStyleConfigHelpers)((0, $jNq6g.editableAnatomy).keys);
var $b105653afd756ffe$var$baseStylePreview = (0, $cDoMf.defineStyle)({
    borderRadius: "md",
    py: "1",
    transitionProperty: "common",
    transitionDuration: "normal"
});
var $b105653afd756ffe$var$baseStyleInput = (0, $cDoMf.defineStyle)({
    borderRadius: "md",
    py: "1",
    transitionProperty: "common",
    transitionDuration: "normal",
    width: "full",
    _focusVisible: {
        boxShadow: "outline"
    },
    _placeholder: {
        opacity: 0.6
    }
});
var $b105653afd756ffe$var$baseStyleTextarea = (0, $cDoMf.defineStyle)({
    borderRadius: "md",
    py: "1",
    transitionProperty: "common",
    transitionDuration: "normal",
    width: "full",
    _focusVisible: {
        boxShadow: "outline"
    },
    _placeholder: {
        opacity: 0.6
    }
});
var $b105653afd756ffe$var$baseStyle = $b105653afd756ffe$var$definePartsStyle({
    preview: $b105653afd756ffe$var$baseStylePreview,
    input: $b105653afd756ffe$var$baseStyleInput,
    textarea: $b105653afd756ffe$var$baseStyleTextarea
});
var $b105653afd756ffe$export$a09813cbe72349b1 = $b105653afd756ffe$var$defineMultiStyleConfig({
    baseStyle: $b105653afd756ffe$var$baseStyle
});

});

parcelRegister("6uUdM", function(module, exports) {

$parcel$export(module.exports, "formTheme", () => $b8ec94ec64b530fd$export$870bcc1d98fee0aa);
// src/components/form-control.ts

var $jNq6g = parcelRequire("jNq6g");

var $cDoMf = parcelRequire("cDoMf");
var { definePartsStyle: $b8ec94ec64b530fd$var$definePartsStyle, defineMultiStyleConfig: $b8ec94ec64b530fd$var$defineMultiStyleConfig } = (0, $cDoMf.createMultiStyleConfigHelpers)((0, $jNq6g.formAnatomy).keys);
var $b8ec94ec64b530fd$var$$fg = (0, $cDoMf.cssVar)("form-control-color");
var $b8ec94ec64b530fd$var$baseStyleRequiredIndicator = (0, $cDoMf.defineStyle)({
    marginStart: "1",
    [$b8ec94ec64b530fd$var$$fg.variable]: "colors.red.500",
    _dark: {
        [$b8ec94ec64b530fd$var$$fg.variable]: "colors.red.300"
    },
    color: $b8ec94ec64b530fd$var$$fg.reference
});
var $b8ec94ec64b530fd$var$baseStyleHelperText = (0, $cDoMf.defineStyle)({
    mt: "2",
    [$b8ec94ec64b530fd$var$$fg.variable]: "colors.gray.600",
    _dark: {
        [$b8ec94ec64b530fd$var$$fg.variable]: "colors.whiteAlpha.600"
    },
    color: $b8ec94ec64b530fd$var$$fg.reference,
    lineHeight: "normal",
    fontSize: "sm"
});
var $b8ec94ec64b530fd$var$baseStyle = $b8ec94ec64b530fd$var$definePartsStyle({
    container: {
        width: "100%",
        position: "relative"
    },
    requiredIndicator: $b8ec94ec64b530fd$var$baseStyleRequiredIndicator,
    helperText: $b8ec94ec64b530fd$var$baseStyleHelperText
});
var $b8ec94ec64b530fd$export$870bcc1d98fee0aa = $b8ec94ec64b530fd$var$defineMultiStyleConfig({
    baseStyle: $b8ec94ec64b530fd$var$baseStyle
});

});

parcelRegister("iQWhh", function(module, exports) {

$parcel$export(module.exports, "formErrorTheme", () => $2c8e34a8bdf01ad4$export$b8d6747e16cd5f4d);
// src/components/form-error.ts

var $jNq6g = parcelRequire("jNq6g");

var $cDoMf = parcelRequire("cDoMf");
var { definePartsStyle: $2c8e34a8bdf01ad4$var$definePartsStyle, defineMultiStyleConfig: $2c8e34a8bdf01ad4$var$defineMultiStyleConfig } = (0, $cDoMf.createMultiStyleConfigHelpers)((0, $jNq6g.formErrorAnatomy).keys);
var $2c8e34a8bdf01ad4$var$$fg = (0, $cDoMf.cssVar)("form-error-color");
var $2c8e34a8bdf01ad4$var$baseStyleText = (0, $cDoMf.defineStyle)({
    [$2c8e34a8bdf01ad4$var$$fg.variable]: `colors.red.500`,
    _dark: {
        [$2c8e34a8bdf01ad4$var$$fg.variable]: `colors.red.300`
    },
    color: $2c8e34a8bdf01ad4$var$$fg.reference,
    mt: "2",
    fontSize: "sm",
    lineHeight: "normal"
});
var $2c8e34a8bdf01ad4$var$baseStyleIcon = (0, $cDoMf.defineStyle)({
    marginEnd: "0.5em",
    [$2c8e34a8bdf01ad4$var$$fg.variable]: `colors.red.500`,
    _dark: {
        [$2c8e34a8bdf01ad4$var$$fg.variable]: `colors.red.300`
    },
    color: $2c8e34a8bdf01ad4$var$$fg.reference
});
var $2c8e34a8bdf01ad4$var$baseStyle = $2c8e34a8bdf01ad4$var$definePartsStyle({
    text: $2c8e34a8bdf01ad4$var$baseStyleText,
    icon: $2c8e34a8bdf01ad4$var$baseStyleIcon
});
var $2c8e34a8bdf01ad4$export$b8d6747e16cd5f4d = $2c8e34a8bdf01ad4$var$defineMultiStyleConfig({
    baseStyle: $2c8e34a8bdf01ad4$var$baseStyle
});

});

parcelRegister("efA8t", function(module, exports) {

$parcel$export(module.exports, "formLabelTheme", () => $0e65501dc675ab35$export$c49af69dbfc0c993);
// src/components/form-label.ts

var $cDoMf = parcelRequire("cDoMf");
var $0e65501dc675ab35$var$baseStyle = (0, $cDoMf.defineStyle)({
    fontSize: "md",
    marginEnd: "3",
    mb: "2",
    fontWeight: "medium",
    transitionProperty: "common",
    transitionDuration: "normal",
    opacity: 1,
    _disabled: {
        opacity: 0.4
    }
});
var $0e65501dc675ab35$export$c49af69dbfc0c993 = (0, $cDoMf.defineStyleConfig)({
    baseStyle: $0e65501dc675ab35$var$baseStyle
});

});

parcelRegister("1Rusw", function(module, exports) {

$parcel$export(module.exports, "headingTheme", () => $6f96773b625acf98$export$5f175074e0f09e7b);
// src/components/heading.ts

var $cDoMf = parcelRequire("cDoMf");
var $6f96773b625acf98$var$baseStyle = (0, $cDoMf.defineStyle)({
    fontFamily: "heading",
    fontWeight: "bold"
});
var $6f96773b625acf98$var$sizes = {
    "4xl": (0, $cDoMf.defineStyle)({
        fontSize: [
            "6xl",
            null,
            "7xl"
        ],
        lineHeight: 1
    }),
    "3xl": (0, $cDoMf.defineStyle)({
        fontSize: [
            "5xl",
            null,
            "6xl"
        ],
        lineHeight: 1
    }),
    "2xl": (0, $cDoMf.defineStyle)({
        fontSize: [
            "4xl",
            null,
            "5xl"
        ],
        lineHeight: [
            1.2,
            null,
            1
        ]
    }),
    xl: (0, $cDoMf.defineStyle)({
        fontSize: [
            "3xl",
            null,
            "4xl"
        ],
        lineHeight: [
            1.33,
            null,
            1.2
        ]
    }),
    lg: (0, $cDoMf.defineStyle)({
        fontSize: [
            "2xl",
            null,
            "3xl"
        ],
        lineHeight: [
            1.33,
            null,
            1.2
        ]
    }),
    md: (0, $cDoMf.defineStyle)({
        fontSize: "xl",
        lineHeight: 1.2
    }),
    sm: (0, $cDoMf.defineStyle)({
        fontSize: "md",
        lineHeight: 1.2
    }),
    xs: (0, $cDoMf.defineStyle)({
        fontSize: "sm",
        lineHeight: 1.2
    })
};
var $6f96773b625acf98$export$5f175074e0f09e7b = (0, $cDoMf.defineStyleConfig)({
    baseStyle: $6f96773b625acf98$var$baseStyle,
    sizes: $6f96773b625acf98$var$sizes,
    defaultProps: {
        size: "xl"
    }
});

});

parcelRegister("kOTB2", function(module, exports) {

$parcel$export(module.exports, "breadcrumbTheme", () => $2cecb3bc9b1ea0df$export$e2d8c6f6af55009);
// src/components/breadcrumb.ts

var $jNq6g = parcelRequire("jNq6g");

var $cDoMf = parcelRequire("cDoMf");
var { defineMultiStyleConfig: $2cecb3bc9b1ea0df$var$defineMultiStyleConfig, definePartsStyle: $2cecb3bc9b1ea0df$var$definePartsStyle } = (0, $cDoMf.createMultiStyleConfigHelpers)((0, $jNq6g.breadcrumbAnatomy).keys);
var $2cecb3bc9b1ea0df$var$$decor = (0, $cDoMf.cssVar)("breadcrumb-link-decor");
var $2cecb3bc9b1ea0df$var$baseStyleLink = (0, $cDoMf.defineStyle)({
    transitionProperty: "common",
    transitionDuration: "fast",
    transitionTimingFunction: "ease-out",
    outline: "none",
    color: "inherit",
    textDecoration: $2cecb3bc9b1ea0df$var$$decor.reference,
    [$2cecb3bc9b1ea0df$var$$decor.variable]: "none",
    "&:not([aria-current=page])": {
        cursor: "pointer",
        _hover: {
            [$2cecb3bc9b1ea0df$var$$decor.variable]: "underline"
        },
        _focusVisible: {
            boxShadow: "outline"
        }
    }
});
var $2cecb3bc9b1ea0df$var$baseStyle = $2cecb3bc9b1ea0df$var$definePartsStyle({
    link: $2cecb3bc9b1ea0df$var$baseStyleLink
});
var $2cecb3bc9b1ea0df$export$e2d8c6f6af55009 = $2cecb3bc9b1ea0df$var$defineMultiStyleConfig({
    baseStyle: $2cecb3bc9b1ea0df$var$baseStyle
});

});

parcelRegister("hmXYt", function(module, exports) {

$parcel$export(module.exports, "buttonTheme", () => $0e5cc62c4ce629d6$export$577deec5d331f6be);

var $1VjjY = parcelRequire("1VjjY");

var $cDoMf = parcelRequire("cDoMf");

var $kYGZ9 = parcelRequire("kYGZ9");
var $a99Nd = parcelRequire("a99Nd");
var $0e5cc62c4ce629d6$var$baseStyle = (0, $cDoMf.defineStyle)({
    lineHeight: "1.2",
    borderRadius: "md",
    fontWeight: "semibold",
    transitionProperty: "common",
    transitionDuration: "normal",
    _focusVisible: {
        boxShadow: "outline"
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed",
        boxShadow: "none"
    },
    _hover: {
        _disabled: {
            bg: "initial"
        }
    }
});
var $0e5cc62c4ce629d6$var$variantGhost = (0, $cDoMf.defineStyle)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    if (c === "gray") return {
        color: (0, $kYGZ9.mode)(`gray.800`, `whiteAlpha.900`)(props),
        _hover: {
            bg: (0, $kYGZ9.mode)(`gray.100`, `whiteAlpha.200`)(props)
        },
        _active: {
            bg: (0, $kYGZ9.mode)(`gray.200`, `whiteAlpha.300`)(props)
        }
    };
    const darkHoverBg = (0, $a99Nd.transparentize)(`${c}.200`, 0.12)(theme);
    const darkActiveBg = (0, $a99Nd.transparentize)(`${c}.200`, 0.24)(theme);
    return {
        color: (0, $kYGZ9.mode)(`${c}.600`, `${c}.200`)(props),
        bg: "transparent",
        _hover: {
            bg: (0, $kYGZ9.mode)(`${c}.50`, darkHoverBg)(props)
        },
        _active: {
            bg: (0, $kYGZ9.mode)(`${c}.100`, darkActiveBg)(props)
        }
    };
});
var $0e5cc62c4ce629d6$var$variantOutline = (0, $cDoMf.defineStyle)((props)=>{
    const { colorScheme: c } = props;
    const borderColor = (0, $kYGZ9.mode)(`gray.200`, `whiteAlpha.300`)(props);
    return {
        border: "1px solid",
        borderColor: c === "gray" ? borderColor : "currentColor",
        ".chakra-button__group[data-attached][data-orientation=horizontal] > &:not(:last-of-type)": {
            marginEnd: "-1px"
        },
        ".chakra-button__group[data-attached][data-orientation=vertical] > &:not(:last-of-type)": {
            marginBottom: "-1px"
        },
        ...(0, $1VjjY.runIfFn)($0e5cc62c4ce629d6$var$variantGhost, props)
    };
});
var $0e5cc62c4ce629d6$var$accessibleColorMap = {
    yellow: {
        bg: "yellow.400",
        color: "black",
        hoverBg: "yellow.500",
        activeBg: "yellow.600"
    },
    cyan: {
        bg: "cyan.400",
        color: "black",
        hoverBg: "cyan.500",
        activeBg: "cyan.600"
    }
};
var $0e5cc62c4ce629d6$var$variantSolid = (0, $cDoMf.defineStyle)((props)=>{
    var _a;
    const { colorScheme: c } = props;
    if (c === "gray") {
        const bg2 = (0, $kYGZ9.mode)(`gray.100`, `whiteAlpha.200`)(props);
        return {
            bg: bg2,
            color: (0, $kYGZ9.mode)(`gray.800`, `whiteAlpha.900`)(props),
            _hover: {
                bg: (0, $kYGZ9.mode)(`gray.200`, `whiteAlpha.300`)(props),
                _disabled: {
                    bg: bg2
                }
            },
            _active: {
                bg: (0, $kYGZ9.mode)(`gray.300`, `whiteAlpha.400`)(props)
            }
        };
    }
    const { bg: bg = `${c}.500`, color: color = "white", hoverBg: hoverBg = `${c}.600`, activeBg: activeBg = `${c}.700` } = (_a = $0e5cc62c4ce629d6$var$accessibleColorMap[c]) != null ? _a : {};
    const background = (0, $kYGZ9.mode)(bg, `${c}.200`)(props);
    return {
        bg: background,
        color: (0, $kYGZ9.mode)(color, `gray.800`)(props),
        _hover: {
            bg: (0, $kYGZ9.mode)(hoverBg, `${c}.300`)(props),
            _disabled: {
                bg: background
            }
        },
        _active: {
            bg: (0, $kYGZ9.mode)(activeBg, `${c}.400`)(props)
        }
    };
});
var $0e5cc62c4ce629d6$var$variantLink = (0, $cDoMf.defineStyle)((props)=>{
    const { colorScheme: c } = props;
    return {
        padding: 0,
        height: "auto",
        lineHeight: "normal",
        verticalAlign: "baseline",
        color: (0, $kYGZ9.mode)(`${c}.500`, `${c}.200`)(props),
        _hover: {
            textDecoration: "underline",
            _disabled: {
                textDecoration: "none"
            }
        },
        _active: {
            color: (0, $kYGZ9.mode)(`${c}.700`, `${c}.500`)(props)
        }
    };
});
var $0e5cc62c4ce629d6$var$variantUnstyled = (0, $cDoMf.defineStyle)({
    bg: "none",
    color: "inherit",
    display: "inline",
    lineHeight: "inherit",
    m: "0",
    p: "0"
});
var $0e5cc62c4ce629d6$var$variants = {
    ghost: $0e5cc62c4ce629d6$var$variantGhost,
    outline: $0e5cc62c4ce629d6$var$variantOutline,
    solid: $0e5cc62c4ce629d6$var$variantSolid,
    link: $0e5cc62c4ce629d6$var$variantLink,
    unstyled: $0e5cc62c4ce629d6$var$variantUnstyled
};
var $0e5cc62c4ce629d6$var$sizes = {
    lg: (0, $cDoMf.defineStyle)({
        h: "12",
        minW: "12",
        fontSize: "lg",
        px: "6"
    }),
    md: (0, $cDoMf.defineStyle)({
        h: "10",
        minW: "10",
        fontSize: "md",
        px: "4"
    }),
    sm: (0, $cDoMf.defineStyle)({
        h: "8",
        minW: "8",
        fontSize: "sm",
        px: "3"
    }),
    xs: (0, $cDoMf.defineStyle)({
        h: "6",
        minW: "6",
        fontSize: "xs",
        px: "2"
    })
};
var $0e5cc62c4ce629d6$export$577deec5d331f6be = (0, $cDoMf.defineStyleConfig)({
    baseStyle: $0e5cc62c4ce629d6$var$baseStyle,
    variants: $0e5cc62c4ce629d6$var$variants,
    sizes: $0e5cc62c4ce629d6$var$sizes,
    defaultProps: {
        variant: "solid",
        size: "md",
        colorScheme: "gray"
    }
});

});

parcelRegister("9jHpS", function(module, exports) {

$parcel$export(module.exports, "cardTheme", () => $995f8df102f1ca3c$export$880f7b1201440c23);
// src/components/card.ts

var $jNq6g = parcelRequire("jNq6g");

var $cDoMf = parcelRequire("cDoMf");
var { definePartsStyle: $995f8df102f1ca3c$var$definePartsStyle, defineMultiStyleConfig: $995f8df102f1ca3c$var$defineMultiStyleConfig } = (0, $cDoMf.createMultiStyleConfigHelpers)((0, $jNq6g.cardAnatomy).keys);
var $995f8df102f1ca3c$var$$bg = (0, $cDoMf.cssVar)("card-bg");
var $995f8df102f1ca3c$var$$padding = (0, $cDoMf.cssVar)("card-padding");
var $995f8df102f1ca3c$var$$shadow = (0, $cDoMf.cssVar)("card-shadow");
var $995f8df102f1ca3c$var$$radius = (0, $cDoMf.cssVar)("card-radius");
var $995f8df102f1ca3c$var$$border = (0, $cDoMf.cssVar)("card-border-width", "0");
var $995f8df102f1ca3c$var$$borderColor = (0, $cDoMf.cssVar)("card-border-color");
var $995f8df102f1ca3c$var$baseStyle = $995f8df102f1ca3c$var$definePartsStyle({
    container: {
        [$995f8df102f1ca3c$var$$bg.variable]: "colors.chakra-body-bg",
        backgroundColor: $995f8df102f1ca3c$var$$bg.reference,
        boxShadow: $995f8df102f1ca3c$var$$shadow.reference,
        borderRadius: $995f8df102f1ca3c$var$$radius.reference,
        color: "chakra-body-text",
        borderWidth: $995f8df102f1ca3c$var$$border.reference,
        borderColor: $995f8df102f1ca3c$var$$borderColor.reference
    },
    body: {
        padding: $995f8df102f1ca3c$var$$padding.reference,
        flex: "1 1 0%"
    },
    header: {
        padding: $995f8df102f1ca3c$var$$padding.reference
    },
    footer: {
        padding: $995f8df102f1ca3c$var$$padding.reference
    }
});
var $995f8df102f1ca3c$var$sizes = {
    sm: $995f8df102f1ca3c$var$definePartsStyle({
        container: {
            [$995f8df102f1ca3c$var$$radius.variable]: "radii.base",
            [$995f8df102f1ca3c$var$$padding.variable]: "space.3"
        }
    }),
    md: $995f8df102f1ca3c$var$definePartsStyle({
        container: {
            [$995f8df102f1ca3c$var$$radius.variable]: "radii.md",
            [$995f8df102f1ca3c$var$$padding.variable]: "space.5"
        }
    }),
    lg: $995f8df102f1ca3c$var$definePartsStyle({
        container: {
            [$995f8df102f1ca3c$var$$radius.variable]: "radii.xl",
            [$995f8df102f1ca3c$var$$padding.variable]: "space.7"
        }
    })
};
var $995f8df102f1ca3c$var$variants = {
    elevated: $995f8df102f1ca3c$var$definePartsStyle({
        container: {
            [$995f8df102f1ca3c$var$$shadow.variable]: "shadows.base",
            _dark: {
                [$995f8df102f1ca3c$var$$bg.variable]: "colors.gray.700"
            }
        }
    }),
    outline: $995f8df102f1ca3c$var$definePartsStyle({
        container: {
            [$995f8df102f1ca3c$var$$border.variable]: "1px",
            [$995f8df102f1ca3c$var$$borderColor.variable]: "colors.chakra-border-color"
        }
    }),
    filled: $995f8df102f1ca3c$var$definePartsStyle({
        container: {
            [$995f8df102f1ca3c$var$$bg.variable]: "colors.chakra-subtle-bg"
        }
    }),
    unstyled: {
        body: {
            [$995f8df102f1ca3c$var$$padding.variable]: 0
        },
        header: {
            [$995f8df102f1ca3c$var$$padding.variable]: 0
        },
        footer: {
            [$995f8df102f1ca3c$var$$padding.variable]: 0
        }
    }
};
var $995f8df102f1ca3c$export$880f7b1201440c23 = $995f8df102f1ca3c$var$defineMultiStyleConfig({
    baseStyle: $995f8df102f1ca3c$var$baseStyle,
    variants: $995f8df102f1ca3c$var$variants,
    sizes: $995f8df102f1ca3c$var$sizes,
    defaultProps: {
        variant: "elevated",
        size: "md"
    }
});

});

parcelRegister("81GGp", function(module, exports) {

$parcel$export(module.exports, "closeButtonTheme", () => $210f9b3b453d9a36$export$47615e5b7f7e315f);
// src/components/close-button.ts

var $cDoMf = parcelRequire("cDoMf");

var $9TrBA = parcelRequire("9TrBA");
var $210f9b3b453d9a36$var$$size = (0, $9TrBA.cssVar)("close-button-size");
var $210f9b3b453d9a36$var$$bg = (0, $9TrBA.cssVar)("close-button-bg");
var $210f9b3b453d9a36$var$baseStyle = (0, $cDoMf.defineStyle)({
    w: [
        $210f9b3b453d9a36$var$$size.reference
    ],
    h: [
        $210f9b3b453d9a36$var$$size.reference
    ],
    borderRadius: "md",
    transitionProperty: "common",
    transitionDuration: "normal",
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed",
        boxShadow: "none"
    },
    _hover: {
        [$210f9b3b453d9a36$var$$bg.variable]: "colors.blackAlpha.100",
        _dark: {
            [$210f9b3b453d9a36$var$$bg.variable]: "colors.whiteAlpha.100"
        }
    },
    _active: {
        [$210f9b3b453d9a36$var$$bg.variable]: "colors.blackAlpha.200",
        _dark: {
            [$210f9b3b453d9a36$var$$bg.variable]: "colors.whiteAlpha.200"
        }
    },
    _focusVisible: {
        boxShadow: "outline"
    },
    bg: $210f9b3b453d9a36$var$$bg.reference
});
var $210f9b3b453d9a36$var$sizes = {
    lg: (0, $cDoMf.defineStyle)({
        [$210f9b3b453d9a36$var$$size.variable]: "sizes.10",
        fontSize: "md"
    }),
    md: (0, $cDoMf.defineStyle)({
        [$210f9b3b453d9a36$var$$size.variable]: "sizes.8",
        fontSize: "xs"
    }),
    sm: (0, $cDoMf.defineStyle)({
        [$210f9b3b453d9a36$var$$size.variable]: "sizes.6",
        fontSize: "2xs"
    })
};
var $210f9b3b453d9a36$export$47615e5b7f7e315f = (0, $cDoMf.defineStyleConfig)({
    baseStyle: $210f9b3b453d9a36$var$baseStyle,
    sizes: $210f9b3b453d9a36$var$sizes,
    defaultProps: {
        size: "md"
    }
});

});

parcelRegister("iM5Xt", function(module, exports) {

$parcel$export(module.exports, "codeTheme", () => $e456939a14efc19b$export$f9b9a8633a36e3c7);

var $aALPx = parcelRequire("aALPx");

var $cDoMf = parcelRequire("cDoMf");
var { variants: $e456939a14efc19b$var$variants, defaultProps: $e456939a14efc19b$var$defaultProps } = (0, $aALPx.badgeTheme);
var $e456939a14efc19b$var$baseStyle = (0, $cDoMf.defineStyle)({
    fontFamily: "mono",
    fontSize: "sm",
    px: "0.2em",
    borderRadius: "sm",
    bg: (0, $aALPx.vars).bg.reference,
    color: (0, $aALPx.vars).color.reference,
    boxShadow: (0, $aALPx.vars).shadow.reference
});
var $e456939a14efc19b$export$f9b9a8633a36e3c7 = (0, $cDoMf.defineStyleConfig)({
    baseStyle: $e456939a14efc19b$var$baseStyle,
    variants: $e456939a14efc19b$var$variants,
    defaultProps: $e456939a14efc19b$var$defaultProps
});

});

parcelRegister("ljTCa", function(module, exports) {

$parcel$export(module.exports, "containerTheme", () => $e7421c814aeeb5e1$export$3ca0760d240fe5f4);
// src/components/container.ts

var $cDoMf = parcelRequire("cDoMf");
var $e7421c814aeeb5e1$var$baseStyle = (0, $cDoMf.defineStyle)({
    w: "100%",
    mx: "auto",
    maxW: "prose",
    px: "4"
});
var $e7421c814aeeb5e1$export$3ca0760d240fe5f4 = (0, $cDoMf.defineStyleConfig)({
    baseStyle: $e7421c814aeeb5e1$var$baseStyle
});

});

parcelRegister("beR3a", function(module, exports) {

$parcel$export(module.exports, "dividerTheme", () => $ebfd909ca384f9d8$export$f0e91f779c5bb416);
// src/components/divider.ts

var $cDoMf = parcelRequire("cDoMf");
var $ebfd909ca384f9d8$var$baseStyle = (0, $cDoMf.defineStyle)({
    opacity: 0.6,
    borderColor: "inherit"
});
var $ebfd909ca384f9d8$var$variantSolid = (0, $cDoMf.defineStyle)({
    borderStyle: "solid"
});
var $ebfd909ca384f9d8$var$variantDashed = (0, $cDoMf.defineStyle)({
    borderStyle: "dashed"
});
var $ebfd909ca384f9d8$var$variants = {
    solid: $ebfd909ca384f9d8$var$variantSolid,
    dashed: $ebfd909ca384f9d8$var$variantDashed
};
var $ebfd909ca384f9d8$export$f0e91f779c5bb416 = (0, $cDoMf.defineStyleConfig)({
    baseStyle: $ebfd909ca384f9d8$var$baseStyle,
    variants: $ebfd909ca384f9d8$var$variants,
    defaultProps: {
        variant: "solid"
    }
});

});

parcelRegister("cSNX1", function(module, exports) {

$parcel$export(module.exports, "accordionTheme", () => $cdc341bc65cc7ed7$export$20ec2254f76fa604);
// src/components/accordion.ts

var $jNq6g = parcelRequire("jNq6g");

var $cDoMf = parcelRequire("cDoMf");
var { definePartsStyle: $cdc341bc65cc7ed7$var$definePartsStyle, defineMultiStyleConfig: $cdc341bc65cc7ed7$var$defineMultiStyleConfig } = (0, $cDoMf.createMultiStyleConfigHelpers)((0, $jNq6g.accordionAnatomy).keys);
var $cdc341bc65cc7ed7$var$baseStyleContainer = (0, $cDoMf.defineStyle)({
    borderTopWidth: "1px",
    borderColor: "inherit",
    _last: {
        borderBottomWidth: "1px"
    }
});
var $cdc341bc65cc7ed7$var$baseStyleButton = (0, $cDoMf.defineStyle)({
    transitionProperty: "common",
    transitionDuration: "normal",
    fontSize: "md",
    _focusVisible: {
        boxShadow: "outline"
    },
    _hover: {
        bg: "blackAlpha.50"
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
    },
    px: "4",
    py: "2"
});
var $cdc341bc65cc7ed7$var$baseStylePanel = (0, $cDoMf.defineStyle)({
    pt: "2",
    px: "4",
    pb: "5"
});
var $cdc341bc65cc7ed7$var$baseStyleIcon = (0, $cDoMf.defineStyle)({
    fontSize: "1.25em"
});
var $cdc341bc65cc7ed7$var$baseStyle = $cdc341bc65cc7ed7$var$definePartsStyle({
    container: $cdc341bc65cc7ed7$var$baseStyleContainer,
    button: $cdc341bc65cc7ed7$var$baseStyleButton,
    panel: $cdc341bc65cc7ed7$var$baseStylePanel,
    icon: $cdc341bc65cc7ed7$var$baseStyleIcon
});
var $cdc341bc65cc7ed7$export$20ec2254f76fa604 = $cdc341bc65cc7ed7$var$defineMultiStyleConfig({
    baseStyle: $cdc341bc65cc7ed7$var$baseStyle
});

});

parcelRegister("3avqj", function(module, exports) {

$parcel$export(module.exports, "alertTheme", () => $85c06a1133591674$export$9d77d9665d829e89);
// src/components/alert.ts

var $jNq6g = parcelRequire("jNq6g");

var $cDoMf = parcelRequire("cDoMf");

var $a99Nd = parcelRequire("a99Nd");
var { definePartsStyle: $85c06a1133591674$var$definePartsStyle, defineMultiStyleConfig: $85c06a1133591674$var$defineMultiStyleConfig } = (0, $cDoMf.createMultiStyleConfigHelpers)((0, $jNq6g.alertAnatomy).keys);
var $85c06a1133591674$var$$fg = (0, $cDoMf.cssVar)("alert-fg");
var $85c06a1133591674$var$$bg = (0, $cDoMf.cssVar)("alert-bg");
var $85c06a1133591674$var$baseStyle = $85c06a1133591674$var$definePartsStyle({
    container: {
        bg: $85c06a1133591674$var$$bg.reference,
        px: "4",
        py: "3"
    },
    title: {
        fontWeight: "bold",
        lineHeight: "6",
        marginEnd: "2"
    },
    description: {
        lineHeight: "6"
    },
    icon: {
        color: $85c06a1133591674$var$$fg.reference,
        flexShrink: 0,
        marginEnd: "3",
        w: "5",
        h: "6"
    },
    spinner: {
        color: $85c06a1133591674$var$$fg.reference,
        flexShrink: 0,
        marginEnd: "3",
        w: "5",
        h: "5"
    }
});
function $85c06a1133591674$var$getBg(props) {
    const { theme: theme, colorScheme: c } = props;
    const darkBg = (0, $a99Nd.transparentize)(`${c}.200`, 0.16)(theme);
    return {
        light: `colors.${c}.100`,
        dark: darkBg
    };
}
var $85c06a1133591674$var$variantSubtle = $85c06a1133591674$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    const bg = $85c06a1133591674$var$getBg(props);
    return {
        container: {
            [$85c06a1133591674$var$$fg.variable]: `colors.${c}.600`,
            [$85c06a1133591674$var$$bg.variable]: bg.light,
            _dark: {
                [$85c06a1133591674$var$$fg.variable]: `colors.${c}.200`,
                [$85c06a1133591674$var$$bg.variable]: bg.dark
            }
        }
    };
});
var $85c06a1133591674$var$variantLeftAccent = $85c06a1133591674$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    const bg = $85c06a1133591674$var$getBg(props);
    return {
        container: {
            [$85c06a1133591674$var$$fg.variable]: `colors.${c}.600`,
            [$85c06a1133591674$var$$bg.variable]: bg.light,
            _dark: {
                [$85c06a1133591674$var$$fg.variable]: `colors.${c}.200`,
                [$85c06a1133591674$var$$bg.variable]: bg.dark
            },
            paddingStart: "3",
            borderStartWidth: "4px",
            borderStartColor: $85c06a1133591674$var$$fg.reference
        }
    };
});
var $85c06a1133591674$var$variantTopAccent = $85c06a1133591674$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    const bg = $85c06a1133591674$var$getBg(props);
    return {
        container: {
            [$85c06a1133591674$var$$fg.variable]: `colors.${c}.600`,
            [$85c06a1133591674$var$$bg.variable]: bg.light,
            _dark: {
                [$85c06a1133591674$var$$fg.variable]: `colors.${c}.200`,
                [$85c06a1133591674$var$$bg.variable]: bg.dark
            },
            pt: "2",
            borderTopWidth: "4px",
            borderTopColor: $85c06a1133591674$var$$fg.reference
        }
    };
});
var $85c06a1133591674$var$variantSolid = $85c06a1133591674$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        container: {
            [$85c06a1133591674$var$$fg.variable]: `colors.white`,
            [$85c06a1133591674$var$$bg.variable]: `colors.${c}.600`,
            _dark: {
                [$85c06a1133591674$var$$fg.variable]: `colors.gray.900`,
                [$85c06a1133591674$var$$bg.variable]: `colors.${c}.200`
            },
            color: $85c06a1133591674$var$$fg.reference
        }
    };
});
var $85c06a1133591674$var$variants = {
    subtle: $85c06a1133591674$var$variantSubtle,
    "left-accent": $85c06a1133591674$var$variantLeftAccent,
    "top-accent": $85c06a1133591674$var$variantTopAccent,
    solid: $85c06a1133591674$var$variantSolid
};
var $85c06a1133591674$export$9d77d9665d829e89 = $85c06a1133591674$var$defineMultiStyleConfig({
    baseStyle: $85c06a1133591674$var$baseStyle,
    variants: $85c06a1133591674$var$variants,
    defaultProps: {
        variant: "subtle",
        colorScheme: "blue"
    }
});

});

parcelRegister("btPEZ", function(module, exports) {

$parcel$export(module.exports, "avatarTheme", () => $a16244cfb2c7f604$export$9975d21893c10e66);

var $gaCnF = parcelRequire("gaCnF");

var $1VjjY = parcelRequire("1VjjY");

var $jNq6g = parcelRequire("jNq6g");

var $cDoMf = parcelRequire("cDoMf");

var $a99Nd = parcelRequire("a99Nd");
var { definePartsStyle: $a16244cfb2c7f604$var$definePartsStyle, defineMultiStyleConfig: $a16244cfb2c7f604$var$defineMultiStyleConfig } = (0, $cDoMf.createMultiStyleConfigHelpers)((0, $jNq6g.avatarAnatomy).keys);
var $a16244cfb2c7f604$var$$border = (0, $cDoMf.cssVar)("avatar-border-color");
var $a16244cfb2c7f604$var$$bg = (0, $cDoMf.cssVar)("avatar-bg");
var $a16244cfb2c7f604$var$$fs = (0, $cDoMf.cssVar)("avatar-font-size");
var $a16244cfb2c7f604$var$$size = (0, $cDoMf.cssVar)("avatar-size");
var $a16244cfb2c7f604$var$baseStyleBadge = (0, $cDoMf.defineStyle)({
    borderRadius: "full",
    border: "0.2em solid",
    borderColor: $a16244cfb2c7f604$var$$border.reference,
    [$a16244cfb2c7f604$var$$border.variable]: "white",
    _dark: {
        [$a16244cfb2c7f604$var$$border.variable]: "colors.gray.800"
    }
});
var $a16244cfb2c7f604$var$baseStyleExcessLabel = (0, $cDoMf.defineStyle)({
    bg: $a16244cfb2c7f604$var$$bg.reference,
    fontSize: $a16244cfb2c7f604$var$$fs.reference,
    width: $a16244cfb2c7f604$var$$size.reference,
    height: $a16244cfb2c7f604$var$$size.reference,
    lineHeight: "1",
    [$a16244cfb2c7f604$var$$bg.variable]: "colors.gray.200",
    _dark: {
        [$a16244cfb2c7f604$var$$bg.variable]: "colors.whiteAlpha.400"
    }
});
var $a16244cfb2c7f604$var$baseStyleContainer = (0, $cDoMf.defineStyle)((props)=>{
    const { name: name, theme: theme } = props;
    const bg = name ? (0, $a99Nd.randomColor)({
        string: name
    }) : "colors.gray.400";
    const isBgDark = (0, $a99Nd.isDark)(bg)(theme);
    let color = "white";
    if (!isBgDark) color = "gray.800";
    return {
        bg: $a16244cfb2c7f604$var$$bg.reference,
        fontSize: $a16244cfb2c7f604$var$$fs.reference,
        color: color,
        borderColor: $a16244cfb2c7f604$var$$border.reference,
        verticalAlign: "top",
        width: $a16244cfb2c7f604$var$$size.reference,
        height: $a16244cfb2c7f604$var$$size.reference,
        "&:not([data-loaded])": {
            [$a16244cfb2c7f604$var$$bg.variable]: bg
        },
        [$a16244cfb2c7f604$var$$border.variable]: "colors.white",
        _dark: {
            [$a16244cfb2c7f604$var$$border.variable]: "colors.gray.800"
        }
    };
});
var $a16244cfb2c7f604$var$baseStyleLabel = (0, $cDoMf.defineStyle)({
    fontSize: $a16244cfb2c7f604$var$$fs.reference,
    lineHeight: "1"
});
var $a16244cfb2c7f604$var$baseStyle = $a16244cfb2c7f604$var$definePartsStyle((props)=>({
        badge: (0, $1VjjY.runIfFn)($a16244cfb2c7f604$var$baseStyleBadge, props),
        excessLabel: (0, $1VjjY.runIfFn)($a16244cfb2c7f604$var$baseStyleExcessLabel, props),
        container: (0, $1VjjY.runIfFn)($a16244cfb2c7f604$var$baseStyleContainer, props),
        label: $a16244cfb2c7f604$var$baseStyleLabel
    }));
function $a16244cfb2c7f604$var$getSize(size) {
    const themeSize = size !== "100%" ? (0, $gaCnF.sizes_default)[size] : void 0;
    return $a16244cfb2c7f604$var$definePartsStyle({
        container: {
            [$a16244cfb2c7f604$var$$size.variable]: themeSize != null ? themeSize : size,
            [$a16244cfb2c7f604$var$$fs.variable]: `calc(${themeSize != null ? themeSize : size} / 2.5)`
        },
        excessLabel: {
            [$a16244cfb2c7f604$var$$size.variable]: themeSize != null ? themeSize : size,
            [$a16244cfb2c7f604$var$$fs.variable]: `calc(${themeSize != null ? themeSize : size} / 2.5)`
        }
    });
}
var $a16244cfb2c7f604$var$sizes = {
    "2xs": $a16244cfb2c7f604$var$getSize(4),
    xs: $a16244cfb2c7f604$var$getSize(6),
    sm: $a16244cfb2c7f604$var$getSize(8),
    md: $a16244cfb2c7f604$var$getSize(12),
    lg: $a16244cfb2c7f604$var$getSize(16),
    xl: $a16244cfb2c7f604$var$getSize(24),
    "2xl": $a16244cfb2c7f604$var$getSize(32),
    full: $a16244cfb2c7f604$var$getSize("100%")
};
var $a16244cfb2c7f604$export$9975d21893c10e66 = $a16244cfb2c7f604$var$defineMultiStyleConfig({
    baseStyle: $a16244cfb2c7f604$var$baseStyle,
    sizes: $a16244cfb2c7f604$var$sizes,
    defaultProps: {
        size: "md"
    }
});

});


parcelRegister("qj2FQ", function(module, exports) {

$parcel$export(module.exports, "semanticTokens", () => $8d92da3cc97655f7$export$c1b409c4e1d33fce);
// src/semantic-tokens.ts
var $8d92da3cc97655f7$export$c1b409c4e1d33fce = {
    colors: {
        "chakra-body-text": {
            _light: "gray.800",
            _dark: "whiteAlpha.900"
        },
        "chakra-body-bg": {
            _light: "white",
            _dark: "gray.800"
        },
        "chakra-border-color": {
            _light: "gray.200",
            _dark: "whiteAlpha.300"
        },
        "chakra-inverse-text": {
            _light: "white",
            _dark: "gray.800"
        },
        "chakra-subtle-bg": {
            _light: "gray.100",
            _dark: "gray.700"
        },
        "chakra-subtle-text": {
            _light: "gray.600",
            _dark: "gray.400"
        },
        "chakra-placeholder-color": {
            _light: "gray.500",
            _dark: "whiteAlpha.400"
        }
    }
};

});

parcelRegister("aeIKe", function(module, exports) {

$parcel$export(module.exports, "styles", () => $ecb688249c5a4a6f$export$9dd6ff9ea0189349);
// src/styles.ts
var $ecb688249c5a4a6f$export$9dd6ff9ea0189349 = {
    global: {
        body: {
            fontFamily: "body",
            color: "chakra-body-text",
            bg: "chakra-body-bg",
            transitionProperty: "background-color",
            transitionDuration: "normal",
            lineHeight: "base"
        },
        "*::placeholder": {
            color: "chakra-placeholder-color"
        },
        "*, *::before, &::after": {
            borderColor: "chakra-border-color"
        }
    }
};

});



parcelRegister("a8z0n", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $7615ce02cc8e96ec$var$hasElementType = typeof Element !== "undefined";
var $7615ce02cc8e96ec$var$hasMap = typeof Map === "function";
var $7615ce02cc8e96ec$var$hasSet = typeof Set === "function";
var $7615ce02cc8e96ec$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $7615ce02cc8e96ec$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$7615ce02cc8e96ec$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($7615ce02cc8e96ec$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$7615ce02cc8e96ec$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($7615ce02cc8e96ec$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($7615ce02cc8e96ec$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($7615ce02cc8e96ec$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$7615ce02cc8e96ec$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $7615ce02cc8e96ec$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});



parcelRegister("hglk4", function(module, exports) {

$parcel$export(module.exports, "AnimatePresence", () => $4b8b5e51ef15d909$export$3ae376d12526dd6f);

var $3qjKr = parcelRequire("3qjKr");

var $83YI6 = parcelRequire("83YI6");

var $hXtfF = parcelRequire("hXtfF");

var $7HsuL = parcelRequire("7HsuL");

var $dhRBH = parcelRequire("dhRBH");

var $hTRhw = parcelRequire("hTRhw");

var $dEn2O = parcelRequire("dEn2O");

var $kpJ0L = parcelRequire("kpJ0L");
const $4b8b5e51ef15d909$var$getChildKey = (child)=>child.key || "";
function $4b8b5e51ef15d909$var$updateChildLookup(children, allChildren) {
    children.forEach((child)=>{
        const key = $4b8b5e51ef15d909$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $4b8b5e51ef15d909$var$onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $3qjKr.Children).forEach(children, (child)=>{
        if ((0, $3qjKr.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $4b8b5e51ef15d909$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, exitBeforeEnter: exitBeforeEnter, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    (0, $kpJ0L.invariant)(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    const forceRender = (0, $3qjKr.useContext)((0, $dhRBH.LayoutGroupContext)).forceRender || (0, $83YI6.useForceUpdate)()[0];
    const isMounted = (0, $hXtfF.useIsMounted)();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    const filteredChildren = $4b8b5e51ef15d909$var$onlyElements(children);
    let childrenToRender = filteredChildren;
    const exitingChildren = (0, $3qjKr.useRef)(new Map()).current;
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    const presentChildren = (0, $3qjKr.useRef)(childrenToRender);
    // A lookup table to quickly reference components by key
    const allChildren = (0, $3qjKr.useRef)(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    const isInitialRender = (0, $3qjKr.useRef)(true);
    (0, $hTRhw.useIsomorphicLayoutEffect)(()=>{
        isInitialRender.current = false;
        $4b8b5e51ef15d909$var$updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    (0, $dEn2O.useUnmountEffect)(()=>{
        isInitialRender.current = true;
        allChildren.clear();
        exitingChildren.clear();
    });
    if (isInitialRender.current) return $3qjKr.createElement($3qjKr.Fragment, null, childrenToRender.map((child)=>$3qjKr.createElement((0, $7HsuL.PresenceChild), {
            key: $4b8b5e51ef15d909$var$getChildKey(child),
            isPresent: true,
            initial: initial ? undefined : false,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child)));
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = [
        ...childrenToRender
    ];
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    const presentKeys = presentChildren.current.map($4b8b5e51ef15d909$var$getChildKey);
    const targetKeys = filteredChildren.map($4b8b5e51ef15d909$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    const numPresent = presentKeys.length;
    for(let i = 0; i < numPresent; i++){
        const key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1 && !exitingChildren.has(key)) exitingChildren.set(key, undefined);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (mode === "wait" && exitingChildren.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exitingChildren.forEach((component, key)=>{
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        const child = allChildren.get(key);
        if (!child) return;
        const insertionIndex = presentKeys.indexOf(key);
        let exitingComponent = component;
        if (!exitingComponent) {
            const onExit = ()=>{
                // clean up the exiting children map
                exitingChildren.delete(key);
                // compute the keys of children that were rendered once but are no longer present
                // this could happen in case of too many fast consequent renderings
                // @link https://github.com/framer/motion/issues/2023
                const leftOverKeys = Array.from(allChildren.keys()).filter((childKey)=>!targetKeys.includes(childKey));
                // clean up the all children map
                leftOverKeys.forEach((leftOverKey)=>allChildren.delete(leftOverKey));
                // make sure to render only the children that are actually visible
                presentChildren.current = filteredChildren.filter((presentChild)=>{
                    const presentChildKey = $4b8b5e51ef15d909$var$getChildKey(presentChild);
                    return(// filter out the node exiting
                    presentChildKey === key || // filter out the leftover children
                    leftOverKeys.includes(presentChildKey));
                });
                // Defer re-rendering until all exiting children have indeed left
                if (!exitingChildren.size) {
                    if (isMounted.current === false) return;
                    forceRender();
                    onExitComplete && onExitComplete();
                }
            };
            exitingComponent = $3qjKr.createElement((0, $7HsuL.PresenceChild), {
                key: $4b8b5e51ef15d909$var$getChildKey(child),
                isPresent: false,
                onExitComplete: onExit,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode
            }, child);
            exitingChildren.set(key, exitingComponent);
        }
        childrenToRender.splice(insertionIndex, 0, exitingComponent);
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map((child)=>{
        const key = child.key;
        return exitingChildren.has(key) ? child : $3qjKr.createElement((0, $7HsuL.PresenceChild), {
            key: $4b8b5e51ef15d909$var$getChildKey(child),
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child);
    });
    return $3qjKr.createElement($3qjKr.Fragment, null, exitingChildren.size ? childrenToRender : childrenToRender.map((child)=>(0, $3qjKr.cloneElement)(child)));
};

});
parcelRegister("83YI6", function(module, exports) {

$parcel$export(module.exports, "useForceUpdate", () => $821965b149938b2b$export$91db9bc4f8ac944a);

var $3qjKr = parcelRequire("3qjKr");

var $hXtfF = parcelRequire("hXtfF");

var $lJeQK = parcelRequire("lJeQK");
function $821965b149938b2b$export$91db9bc4f8ac944a() {
    const isMounted = (0, $hXtfF.useIsMounted)();
    const [forcedRenderCount, setForcedRenderCount] = (0, $3qjKr.useState)(0);
    const forceRender = (0, $3qjKr.useCallback)(()=>{
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ const deferredForceRender = (0, $3qjKr.useCallback)(()=>(0, $lJeQK.frame).postRender(forceRender), [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}

});
parcelRegister("hXtfF", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", () => $5b017bf483144f42$export$80c2a3957bcb42ea);

var $3qjKr = parcelRequire("3qjKr");

var $hTRhw = parcelRequire("hTRhw");
function $5b017bf483144f42$export$80c2a3957bcb42ea() {
    const isMounted = (0, $3qjKr.useRef)(false);
    (0, $hTRhw.useIsomorphicLayoutEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}

});


parcelRegister("7HsuL", function(module, exports) {

$parcel$export(module.exports, "PresenceChild", () => $5d1d47e5e9385af8$export$979daf65881a382a);

var $3qjKr = parcelRequire("3qjKr");

var $dMYJ7 = parcelRequire("dMYJ7");

var $cStpt = parcelRequire("cStpt");

var $1h3Dp = parcelRequire("1h3Dp");
const $5d1d47e5e9385af8$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $cStpt.useConstant)($5d1d47e5e9385af8$var$newChildrenMap);
    const id = (0, $3qjKr.useId)();
    const context = (0, $3qjKr.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? undefined : [
        isPresent
    ]);
    (0, $3qjKr.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $3qjKr.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = $3qjKr.createElement((0, $1h3Dp.PopChild), {
        isPresent: isPresent
    }, children);
    return $3qjKr.createElement((0, $dMYJ7.PresenceContext).Provider, {
        value: context
    }, children);
};
function $5d1d47e5e9385af8$var$newChildrenMap() {
    return new Map();
}

});
parcelRegister("1h3Dp", function(module, exports) {

$parcel$export(module.exports, "PopChild", () => $76fcb57b4fdd24d2$export$1d6cdde0c6816c6d);

var $3qjKr = parcelRequire("3qjKr");
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $76fcb57b4fdd24d2$var$PopChildMeasure extends $3qjKr.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $76fcb57b4fdd24d2$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $3qjKr.useId)();
    const ref = (0, $3qjKr.useRef)(null);
    const size = (0, $3qjKr.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $3qjKr.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return $3qjKr.createElement($76fcb57b4fdd24d2$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size
    }, $3qjKr.cloneElement(children, {
        ref: ref
    }));
}

});


parcelRegister("dEn2O", function(module, exports) {

$parcel$export(module.exports, "useUnmountEffect", () => $191394ae91826eb5$export$f3a192d0cbd30b96);

var $3qjKr = parcelRequire("3qjKr");
function $191394ae91826eb5$export$f3a192d0cbd30b96(callback) {
    return (0, $3qjKr.useEffect)(()=>()=>callback(), []);
}

});


parcelRegister("hbnNg", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $c825eba30733ad73$export$306c0aa65ff9ec16, (v) => $c825eba30733ad73$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c825eba30733ad73$export$306c0aa65ff9ec16;
"use strict";

var $3qjKr = parcelRequire("3qjKr");
function $c825eba30733ad73$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c825eba30733ad73$var$k = "function" === typeof Object.is ? Object.is : $c825eba30733ad73$var$h, $c825eba30733ad73$var$l = $3qjKr.useState, $c825eba30733ad73$var$m = $3qjKr.useEffect, $c825eba30733ad73$var$n = $3qjKr.useLayoutEffect, $c825eba30733ad73$var$p = $3qjKr.useDebugValue;
function $c825eba30733ad73$var$q(a, b) {
    var d = b(), f = $c825eba30733ad73$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $c825eba30733ad73$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $c825eba30733ad73$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $c825eba30733ad73$var$m(function() {
        $c825eba30733ad73$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $c825eba30733ad73$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $c825eba30733ad73$var$p(d);
    return d;
}
function $c825eba30733ad73$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$c825eba30733ad73$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $c825eba30733ad73$var$t(a, b) {
    return b();
}
var $c825eba30733ad73$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c825eba30733ad73$var$t : $c825eba30733ad73$var$q;
$c825eba30733ad73$export$306c0aa65ff9ec16 = void 0 !== $3qjKr.useSyncExternalStore ? $3qjKr.useSyncExternalStore : $c825eba30733ad73$var$u;

});

parcelRegister("ebuv3", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $a539c064c7b97b30$export$bf730a2d8bf68b42, (v) => $a539c064c7b97b30$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a539c064c7b97b30$export$bf730a2d8bf68b42;
"use strict";

var $3qjKr = parcelRequire("3qjKr");

var $bKfyC = parcelRequire("bKfyC");
function $a539c064c7b97b30$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $a539c064c7b97b30$var$q = "function" === typeof Object.is ? Object.is : $a539c064c7b97b30$var$p, $a539c064c7b97b30$var$r = $bKfyC.useSyncExternalStore, $a539c064c7b97b30$var$t = $3qjKr.useRef, $a539c064c7b97b30$var$u = $3qjKr.useEffect, $a539c064c7b97b30$var$v = $3qjKr.useMemo, $a539c064c7b97b30$var$w = $3qjKr.useDebugValue;
$a539c064c7b97b30$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $a539c064c7b97b30$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $a539c064c7b97b30$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($a539c064c7b97b30$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $a539c064c7b97b30$var$r(a, c[0], c[1]);
    $a539c064c7b97b30$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $a539c064c7b97b30$var$w(d);
    return d;
};

});
parcelRegister("bKfyC", function(module, exports) {
"use strict";

module.exports = (parcelRequire("hbnNg"));

});


parcelRegister("dAglg", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $9e3b505ad00953d8$export$a7c73072b1a182ae, (v) => $9e3b505ad00953d8$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $9e3b505ad00953d8$export$9f27bc3417b4524d, (v) => $9e3b505ad00953d8$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $9e3b505ad00953d8$export$db77ccec0bb4ccac, (v) => $9e3b505ad00953d8$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $9e3b505ad00953d8$export$8392c0c9d3dcbd35, (v) => $9e3b505ad00953d8$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $9e3b505ad00953d8$export$ffb0004e005737fa, (v) => $9e3b505ad00953d8$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $9e3b505ad00953d8$export$b624eff549462981, (v) => $9e3b505ad00953d8$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $9e3b505ad00953d8$export$7897aa7841a5380c, (v) => $9e3b505ad00953d8$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $9e3b505ad00953d8$export$602eac185826482c, (v) => $9e3b505ad00953d8$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $9e3b505ad00953d8$export$e2c29f18771995cb, (v) => $9e3b505ad00953d8$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $9e3b505ad00953d8$export$5f8d39834fd61797, (v) => $9e3b505ad00953d8$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $9e3b505ad00953d8$export$74bf444e3cd11ea5, (v) => $9e3b505ad00953d8$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $9e3b505ad00953d8$export$998bcd577473dd93, (v) => $9e3b505ad00953d8$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $9e3b505ad00953d8$export$92387174baf9b227, (v) => $9e3b505ad00953d8$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $9e3b505ad00953d8$export$ec112efeb987d9c6, (v) => $9e3b505ad00953d8$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $9e3b505ad00953d8$export$b706b080d889d2c9, (v) => $9e3b505ad00953d8$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $9e3b505ad00953d8$export$5be5a87408f70ddc, (v) => $9e3b505ad00953d8$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $9e3b505ad00953d8$export$45a5e7f76e0caa8d, (v) => $9e3b505ad00953d8$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $9e3b505ad00953d8$export$455c2e768291efa6, (v) => $9e3b505ad00953d8$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $9e3b505ad00953d8$export$9522e17588c12572, (v) => $9e3b505ad00953d8$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $9e3b505ad00953d8$export$2110ac352bb060b9, (v) => $9e3b505ad00953d8$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $9e3b505ad00953d8$export$56885ab8b9c456ab, (v) => $9e3b505ad00953d8$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $9e3b505ad00953d8$export$d927fcb6adf8f9de, (v) => $9e3b505ad00953d8$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $9e3b505ad00953d8$export$b82d16f27459e05a, (v) => $9e3b505ad00953d8$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $9e3b505ad00953d8$export$522c17b4f5e123e8, (v) => $9e3b505ad00953d8$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $9e3b505ad00953d8$export$1aabd8a0274ecfd6, (v) => $9e3b505ad00953d8$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $9e3b505ad00953d8$export$3d6c20d97e46b957, (v) => $9e3b505ad00953d8$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $9e3b505ad00953d8$export$9b621391a187a31a, (v) => $9e3b505ad00953d8$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $9e3b505ad00953d8$export$f5bbd400c2f4426f, (v) => $9e3b505ad00953d8$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9e3b505ad00953d8$export$a7c73072b1a182ae;
var $9e3b505ad00953d8$export$9f27bc3417b4524d;
var $9e3b505ad00953d8$export$db77ccec0bb4ccac;
var $9e3b505ad00953d8$export$8392c0c9d3dcbd35;
var $9e3b505ad00953d8$export$ffb0004e005737fa;
var $9e3b505ad00953d8$export$b624eff549462981;
var $9e3b505ad00953d8$export$7897aa7841a5380c;
var $9e3b505ad00953d8$export$602eac185826482c;
var $9e3b505ad00953d8$export$e2c29f18771995cb;
var $9e3b505ad00953d8$export$5f8d39834fd61797;
var $9e3b505ad00953d8$export$74bf444e3cd11ea5;
var $9e3b505ad00953d8$export$998bcd577473dd93;
var $9e3b505ad00953d8$export$92387174baf9b227;
var $9e3b505ad00953d8$export$ec112efeb987d9c6;
var $9e3b505ad00953d8$export$b706b080d889d2c9;
var $9e3b505ad00953d8$export$5be5a87408f70ddc;
var $9e3b505ad00953d8$export$45a5e7f76e0caa8d;
var $9e3b505ad00953d8$export$455c2e768291efa6;
var $9e3b505ad00953d8$export$9522e17588c12572;
var $9e3b505ad00953d8$export$2110ac352bb060b9;
var $9e3b505ad00953d8$export$56885ab8b9c456ab;
var $9e3b505ad00953d8$export$d927fcb6adf8f9de;
var $9e3b505ad00953d8$export$b82d16f27459e05a;
var $9e3b505ad00953d8$export$522c17b4f5e123e8;
var $9e3b505ad00953d8$export$1aabd8a0274ecfd6;
var $9e3b505ad00953d8$export$3d6c20d97e46b957;
var $9e3b505ad00953d8$export$9b621391a187a31a;
var $9e3b505ad00953d8$export$f5bbd400c2f4426f;
"use strict";
var $9e3b505ad00953d8$var$b = Symbol.for("react.element"), $9e3b505ad00953d8$var$c = Symbol.for("react.portal"), $9e3b505ad00953d8$var$d = Symbol.for("react.fragment"), $9e3b505ad00953d8$var$e = Symbol.for("react.strict_mode"), $9e3b505ad00953d8$var$f = Symbol.for("react.profiler"), $9e3b505ad00953d8$var$g = Symbol.for("react.provider"), $9e3b505ad00953d8$var$h = Symbol.for("react.context"), $9e3b505ad00953d8$var$k = Symbol.for("react.server_context"), $9e3b505ad00953d8$var$l = Symbol.for("react.forward_ref"), $9e3b505ad00953d8$var$m = Symbol.for("react.suspense"), $9e3b505ad00953d8$var$n = Symbol.for("react.suspense_list"), $9e3b505ad00953d8$var$p = Symbol.for("react.memo"), $9e3b505ad00953d8$var$q = Symbol.for("react.lazy"), $9e3b505ad00953d8$var$t = Symbol.for("react.offscreen"), $9e3b505ad00953d8$var$u;
$9e3b505ad00953d8$var$u = Symbol.for("react.module.reference");
function $9e3b505ad00953d8$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $9e3b505ad00953d8$var$b:
                switch(a = a.type, a){
                    case $9e3b505ad00953d8$var$d:
                    case $9e3b505ad00953d8$var$f:
                    case $9e3b505ad00953d8$var$e:
                    case $9e3b505ad00953d8$var$m:
                    case $9e3b505ad00953d8$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $9e3b505ad00953d8$var$k:
                            case $9e3b505ad00953d8$var$h:
                            case $9e3b505ad00953d8$var$l:
                            case $9e3b505ad00953d8$var$q:
                            case $9e3b505ad00953d8$var$p:
                            case $9e3b505ad00953d8$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $9e3b505ad00953d8$var$c:
                return r;
        }
    }
}
$9e3b505ad00953d8$export$a7c73072b1a182ae = $9e3b505ad00953d8$var$h;
$9e3b505ad00953d8$export$9f27bc3417b4524d = $9e3b505ad00953d8$var$g;
$9e3b505ad00953d8$export$db77ccec0bb4ccac = $9e3b505ad00953d8$var$b;
$9e3b505ad00953d8$export$8392c0c9d3dcbd35 = $9e3b505ad00953d8$var$l;
$9e3b505ad00953d8$export$ffb0004e005737fa = $9e3b505ad00953d8$var$d;
$9e3b505ad00953d8$export$b624eff549462981 = $9e3b505ad00953d8$var$q;
$9e3b505ad00953d8$export$7897aa7841a5380c = $9e3b505ad00953d8$var$p;
$9e3b505ad00953d8$export$602eac185826482c = $9e3b505ad00953d8$var$c;
$9e3b505ad00953d8$export$e2c29f18771995cb = $9e3b505ad00953d8$var$f;
$9e3b505ad00953d8$export$5f8d39834fd61797 = $9e3b505ad00953d8$var$e;
$9e3b505ad00953d8$export$74bf444e3cd11ea5 = $9e3b505ad00953d8$var$m;
$9e3b505ad00953d8$export$998bcd577473dd93 = $9e3b505ad00953d8$var$n;
$9e3b505ad00953d8$export$92387174baf9b227 = function() {
    return !1;
};
$9e3b505ad00953d8$export$ec112efeb987d9c6 = function() {
    return !1;
};
$9e3b505ad00953d8$export$b706b080d889d2c9 = function(a) {
    return $9e3b505ad00953d8$var$v(a) === $9e3b505ad00953d8$var$h;
};
$9e3b505ad00953d8$export$5be5a87408f70ddc = function(a) {
    return $9e3b505ad00953d8$var$v(a) === $9e3b505ad00953d8$var$g;
};
$9e3b505ad00953d8$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $9e3b505ad00953d8$var$b;
};
$9e3b505ad00953d8$export$455c2e768291efa6 = function(a) {
    return $9e3b505ad00953d8$var$v(a) === $9e3b505ad00953d8$var$l;
};
$9e3b505ad00953d8$export$9522e17588c12572 = function(a) {
    return $9e3b505ad00953d8$var$v(a) === $9e3b505ad00953d8$var$d;
};
$9e3b505ad00953d8$export$2110ac352bb060b9 = function(a) {
    return $9e3b505ad00953d8$var$v(a) === $9e3b505ad00953d8$var$q;
};
$9e3b505ad00953d8$export$56885ab8b9c456ab = function(a) {
    return $9e3b505ad00953d8$var$v(a) === $9e3b505ad00953d8$var$p;
};
$9e3b505ad00953d8$export$d927fcb6adf8f9de = function(a) {
    return $9e3b505ad00953d8$var$v(a) === $9e3b505ad00953d8$var$c;
};
$9e3b505ad00953d8$export$b82d16f27459e05a = function(a) {
    return $9e3b505ad00953d8$var$v(a) === $9e3b505ad00953d8$var$f;
};
$9e3b505ad00953d8$export$522c17b4f5e123e8 = function(a) {
    return $9e3b505ad00953d8$var$v(a) === $9e3b505ad00953d8$var$e;
};
$9e3b505ad00953d8$export$1aabd8a0274ecfd6 = function(a) {
    return $9e3b505ad00953d8$var$v(a) === $9e3b505ad00953d8$var$m;
};
$9e3b505ad00953d8$export$3d6c20d97e46b957 = function(a) {
    return $9e3b505ad00953d8$var$v(a) === $9e3b505ad00953d8$var$n;
};
$9e3b505ad00953d8$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $9e3b505ad00953d8$var$d || a === $9e3b505ad00953d8$var$f || a === $9e3b505ad00953d8$var$e || a === $9e3b505ad00953d8$var$m || a === $9e3b505ad00953d8$var$n || a === $9e3b505ad00953d8$var$t || "object" === typeof a && null !== a && (a.$$typeof === $9e3b505ad00953d8$var$q || a.$$typeof === $9e3b505ad00953d8$var$p || a.$$typeof === $9e3b505ad00953d8$var$g || a.$$typeof === $9e3b505ad00953d8$var$h || a.$$typeof === $9e3b505ad00953d8$var$l || a.$$typeof === $9e3b505ad00953d8$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$9e3b505ad00953d8$export$f5bbd400c2f4426f = $9e3b505ad00953d8$var$v;

});

parcelRegister("keQ1f", function(module, exports) {

$parcel$export(module.exports, "isDraft", () => r);
$parcel$export(module.exports, "isDraftable", () => t);
$parcel$export(module.exports, "immerable", () => L);
$parcel$export(module.exports, "original", () => e);
$parcel$export(module.exports, "freeze", () => d);
$parcel$export(module.exports, "nothing", () => H);
$parcel$export(module.exports, "current", () => R);
$parcel$export(module.exports, "enableES5", () => F);
$parcel$export(module.exports, "enablePatches", () => T);
$parcel$export(module.exports, "enableMapSet", () => C);
$parcel$export(module.exports, "enableAllPlugins", () => J);
$parcel$export(module.exports, "castDraft", () => K);
$parcel$export(module.exports, "castImmutable", () => $);
$parcel$export(module.exports, "Immer", () => un);
$parcel$export(module.exports, "produce", () => fn);
$parcel$export(module.exports, "produceWithPatches", () => cn);
$parcel$export(module.exports, "setAutoFreeze", () => sn);
$parcel$export(module.exports, "setUseProxies", () => vn);
$parcel$export(module.exports, "applyPatches", () => pn);
$parcel$export(module.exports, "createDraft", () => ln);
$parcel$export(module.exports, "finishDraft", () => dn);
$parcel$export(module.exports, "default", () => $ebbd7757e1300322$export$2e2bcd8739ae039);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $ebbd7757e1300322$export$2e2bcd8739ae039 = fn;

});

parcelRegister("jgLFK", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("eFcLf", function(module, exports) {

var $jdIcp = parcelRequire("jdIcp");
var $aacecb1e4abfac22$var$Global = $jdIcp.Global;
module.exports = {
    name: "localStorage",
    read: $aacecb1e4abfac22$var$read,
    write: $aacecb1e4abfac22$var$write,
    each: $aacecb1e4abfac22$var$each,
    remove: $aacecb1e4abfac22$var$remove,
    clearAll: $aacecb1e4abfac22$var$clearAll
};
function $aacecb1e4abfac22$var$localStorage() {
    return $aacecb1e4abfac22$var$Global.localStorage;
}
function $aacecb1e4abfac22$var$read(key) {
    return $aacecb1e4abfac22$var$localStorage().getItem(key);
}
function $aacecb1e4abfac22$var$write(key, data) {
    return $aacecb1e4abfac22$var$localStorage().setItem(key, data);
}
function $aacecb1e4abfac22$var$each(fn) {
    for(var i = $aacecb1e4abfac22$var$localStorage().length - 1; i >= 0; i--){
        var key = $aacecb1e4abfac22$var$localStorage().key(i);
        fn($aacecb1e4abfac22$var$read(key), key);
    }
}
function $aacecb1e4abfac22$var$remove(key) {
    return $aacecb1e4abfac22$var$localStorage().removeItem(key);
}
function $aacecb1e4abfac22$var$clearAll() {
    return $aacecb1e4abfac22$var$localStorage().clear();
}

});
parcelRegister("jdIcp", function(module, exports) {
var $dfe18441e0263c91$var$assign = $dfe18441e0263c91$var$make_assign();
var $dfe18441e0263c91$var$create = $dfe18441e0263c91$var$make_create();
var $dfe18441e0263c91$var$trim = $dfe18441e0263c91$var$make_trim();
var $dfe18441e0263c91$var$Global = typeof window !== "undefined" ? window : $parcel$global;
module.exports = {
    assign: $dfe18441e0263c91$var$assign,
    create: $dfe18441e0263c91$var$create,
    trim: $dfe18441e0263c91$var$trim,
    bind: $dfe18441e0263c91$var$bind,
    slice: $dfe18441e0263c91$var$slice,
    each: $dfe18441e0263c91$var$each,
    map: $dfe18441e0263c91$var$map,
    pluck: $dfe18441e0263c91$var$pluck,
    isList: $dfe18441e0263c91$var$isList,
    isFunction: $dfe18441e0263c91$var$isFunction,
    isObject: $dfe18441e0263c91$var$isObject,
    Global: $dfe18441e0263c91$var$Global
};
function $dfe18441e0263c91$var$make_assign() {
    if (Object.assign) return Object.assign;
    else return function shimAssign(obj, props1, props2, etc) {
        for(var i = 1; i < arguments.length; i++)$dfe18441e0263c91$var$each(Object(arguments[i]), function(val, key) {
            obj[key] = val;
        });
        return obj;
    };
}
function $dfe18441e0263c91$var$make_create() {
    if (Object.create) return function create(obj, assignProps1, assignProps2, etc) {
        var assignArgsList = $dfe18441e0263c91$var$slice(arguments, 1);
        return $dfe18441e0263c91$var$assign.apply(this, [
            Object.create(obj)
        ].concat(assignArgsList));
    };
    else {
        function F() {} // eslint-disable-line no-inner-declarations
        return function create(obj, assignProps1, assignProps2, etc) {
            var assignArgsList = $dfe18441e0263c91$var$slice(arguments, 1);
            F.prototype = obj;
            return $dfe18441e0263c91$var$assign.apply(this, [
                new F()
            ].concat(assignArgsList));
        };
    }
}
function $dfe18441e0263c91$var$make_trim() {
    if (String.prototype.trim) return function trim(str) {
        return String.prototype.trim.call(str);
    };
    else return function trim(str) {
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
    };
}
function $dfe18441e0263c91$var$bind(obj, fn) {
    return function() {
        return fn.apply(obj, Array.prototype.slice.call(arguments, 0));
    };
}
function $dfe18441e0263c91$var$slice(arr, index) {
    return Array.prototype.slice.call(arr, index || 0);
}
function $dfe18441e0263c91$var$each(obj, fn) {
    $dfe18441e0263c91$var$pluck(obj, function(val, key) {
        fn(val, key);
        return false;
    });
}
function $dfe18441e0263c91$var$map(obj, fn) {
    var res = $dfe18441e0263c91$var$isList(obj) ? [] : {};
    $dfe18441e0263c91$var$pluck(obj, function(v, k) {
        res[k] = fn(v, k);
        return false;
    });
    return res;
}
function $dfe18441e0263c91$var$pluck(obj, fn) {
    if ($dfe18441e0263c91$var$isList(obj)) for(var i = 0; i < obj.length; i++){
        if (fn(obj[i], i)) return obj[i];
    }
    else {
        for(var key in obj)if (obj.hasOwnProperty(key)) {
            if (fn(obj[key], key)) return obj[key];
        }
    }
}
function $dfe18441e0263c91$var$isList(val) {
    return val != null && typeof val != "function" && typeof val.length == "number";
}
function $dfe18441e0263c91$var$isFunction(val) {
    return val && ({}).toString.call(val) === "[object Function]";
}
function $dfe18441e0263c91$var$isObject(val) {
    return val && ({}).toString.call(val) === "[object Object]";
}

});


parcelRegister("8KDBm", function(module, exports) {
// oldFF-globalStorage provides storage for Firefox
// versions 6 and 7, where no localStorage, etc
// is available.

var $jdIcp = parcelRequire("jdIcp");
var $65f156a827440ad4$var$Global = $jdIcp.Global;
module.exports = {
    name: "oldFF-globalStorage",
    read: $65f156a827440ad4$var$read,
    write: $65f156a827440ad4$var$write,
    each: $65f156a827440ad4$var$each,
    remove: $65f156a827440ad4$var$remove,
    clearAll: $65f156a827440ad4$var$clearAll
};
var $65f156a827440ad4$var$globalStorage = $65f156a827440ad4$var$Global.globalStorage;
function $65f156a827440ad4$var$read(key) {
    return $65f156a827440ad4$var$globalStorage[key];
}
function $65f156a827440ad4$var$write(key, data) {
    $65f156a827440ad4$var$globalStorage[key] = data;
}
function $65f156a827440ad4$var$each(fn) {
    for(var i = $65f156a827440ad4$var$globalStorage.length - 1; i >= 0; i--){
        var key = $65f156a827440ad4$var$globalStorage.key(i);
        fn($65f156a827440ad4$var$globalStorage[key], key);
    }
}
function $65f156a827440ad4$var$remove(key) {
    return $65f156a827440ad4$var$globalStorage.removeItem(key);
}
function $65f156a827440ad4$var$clearAll() {
    $65f156a827440ad4$var$each(function(key, _) {
        delete $65f156a827440ad4$var$globalStorage[key];
    });
}

});

parcelRegister("axeA6", function(module, exports) {
// oldIE-userDataStorage provides storage for Internet Explorer
// versions 6 and 7, where no localStorage, sessionStorage, etc
// is available.

var $jdIcp = parcelRequire("jdIcp");
var $7ab84c01c5ae867c$var$Global = $jdIcp.Global;
module.exports = {
    name: "oldIE-userDataStorage",
    write: $7ab84c01c5ae867c$var$write,
    read: $7ab84c01c5ae867c$var$read,
    each: $7ab84c01c5ae867c$var$each,
    remove: $7ab84c01c5ae867c$var$remove,
    clearAll: $7ab84c01c5ae867c$var$clearAll
};
var $7ab84c01c5ae867c$var$storageName = "storejs";
var $7ab84c01c5ae867c$var$doc = $7ab84c01c5ae867c$var$Global.document;
var $7ab84c01c5ae867c$var$_withStorageEl = $7ab84c01c5ae867c$var$_makeIEStorageElFunction();
var $7ab84c01c5ae867c$var$disable = ($7ab84c01c5ae867c$var$Global.navigator ? $7ab84c01c5ae867c$var$Global.navigator.userAgent : "").match(/ (MSIE 8|MSIE 9|MSIE 10)\./) // MSIE 9.x, MSIE 10.x
;
function $7ab84c01c5ae867c$var$write(unfixedKey, data) {
    if ($7ab84c01c5ae867c$var$disable) return;
    var fixedKey = $7ab84c01c5ae867c$var$fixKey(unfixedKey);
    $7ab84c01c5ae867c$var$_withStorageEl(function(storageEl) {
        storageEl.setAttribute(fixedKey, data);
        storageEl.save($7ab84c01c5ae867c$var$storageName);
    });
}
function $7ab84c01c5ae867c$var$read(unfixedKey) {
    if ($7ab84c01c5ae867c$var$disable) return;
    var fixedKey = $7ab84c01c5ae867c$var$fixKey(unfixedKey);
    var res = null;
    $7ab84c01c5ae867c$var$_withStorageEl(function(storageEl) {
        res = storageEl.getAttribute(fixedKey);
    });
    return res;
}
function $7ab84c01c5ae867c$var$each(callback) {
    $7ab84c01c5ae867c$var$_withStorageEl(function(storageEl) {
        var attributes = storageEl.XMLDocument.documentElement.attributes;
        for(var i = attributes.length - 1; i >= 0; i--){
            var attr = attributes[i];
            callback(storageEl.getAttribute(attr.name), attr.name);
        }
    });
}
function $7ab84c01c5ae867c$var$remove(unfixedKey) {
    var fixedKey = $7ab84c01c5ae867c$var$fixKey(unfixedKey);
    $7ab84c01c5ae867c$var$_withStorageEl(function(storageEl) {
        storageEl.removeAttribute(fixedKey);
        storageEl.save($7ab84c01c5ae867c$var$storageName);
    });
}
function $7ab84c01c5ae867c$var$clearAll() {
    $7ab84c01c5ae867c$var$_withStorageEl(function(storageEl) {
        var attributes = storageEl.XMLDocument.documentElement.attributes;
        storageEl.load($7ab84c01c5ae867c$var$storageName);
        for(var i = attributes.length - 1; i >= 0; i--)storageEl.removeAttribute(attributes[i].name);
        storageEl.save($7ab84c01c5ae867c$var$storageName);
    });
}
// Helpers
//////////
// In IE7, keys cannot start with a digit or contain certain chars.
// See https://github.com/marcuswestin/store.js/issues/40
// See https://github.com/marcuswestin/store.js/issues/83
var $7ab84c01c5ae867c$var$forbiddenCharsRegex = new RegExp("[!\"#$%&'()*+,/\\\\:;<=>?@[\\]^`{|}~]", "g");
function $7ab84c01c5ae867c$var$fixKey(key) {
    return key.replace(/^\d/, "___$&").replace($7ab84c01c5ae867c$var$forbiddenCharsRegex, "___");
}
function $7ab84c01c5ae867c$var$_makeIEStorageElFunction() {
    if (!$7ab84c01c5ae867c$var$doc || !$7ab84c01c5ae867c$var$doc.documentElement || !$7ab84c01c5ae867c$var$doc.documentElement.addBehavior) return null;
    var scriptTag = "script", storageOwner, storageContainer, storageEl;
    // Since #userData storage applies only to specific paths, we need to
    // somehow link our data to a specific path.  We choose /favicon.ico
    // as a pretty safe option, since all browsers already make a request to
    // this URL anyway and being a 404 will not hurt us here.  We wrap an
    // iframe pointing to the favicon in an ActiveXObject(htmlfile) object
    // (see: http://msdn.microsoft.com/en-us/library/aa752574(v=VS.85).aspx)
    // since the iframe access rules appear to allow direct access and
    // manipulation of the document element, even for a 404 page.  This
    // document can be used instead of the current document (which would
    // have been limited to the current path) to perform #userData storage.
    try {
        /* global ActiveXObject */ storageContainer = new ActiveXObject("htmlfile");
        storageContainer.open();
        storageContainer.write("<" + scriptTag + ">document.w=window</" + scriptTag + '><iframe src="/favicon.ico"></iframe>');
        storageContainer.close();
        storageOwner = storageContainer.w.frames[0].document;
        storageEl = storageOwner.createElement("div");
    } catch (e) {
        // somehow ActiveXObject instantiation failed (perhaps some special
        // security settings or otherwse), fall back to per-path storage
        storageEl = $7ab84c01c5ae867c$var$doc.createElement("div");
        storageOwner = $7ab84c01c5ae867c$var$doc.body;
    }
    return function(storeFunction) {
        var args = [].slice.call(arguments, 0);
        args.unshift(storageEl);
        // See http://msdn.microsoft.com/en-us/library/ms531081(v=VS.85).aspx
        // and http://msdn.microsoft.com/en-us/library/ms531424(v=VS.85).aspx
        storageOwner.appendChild(storageEl);
        storageEl.addBehavior("#default#userData");
        storageEl.load($7ab84c01c5ae867c$var$storageName);
        storeFunction.apply(this, args);
        storageOwner.removeChild(storageEl);
        return;
    };
}

});

parcelRegister("43GGY", function(module, exports) {
// cookieStorage is useful Safari private browser mode, where localStorage
// doesn't work but cookies do. This implementation is adopted from
// https://developer.mozilla.org/en-US/docs/Web/API/Storage/LocalStorage

var $jdIcp = parcelRequire("jdIcp");
var $2f488efbbac38c6f$var$Global = $jdIcp.Global;
var $2f488efbbac38c6f$var$trim = $jdIcp.trim;
module.exports = {
    name: "cookieStorage",
    read: $2f488efbbac38c6f$var$read,
    write: $2f488efbbac38c6f$var$write,
    each: $2f488efbbac38c6f$var$each,
    remove: $2f488efbbac38c6f$var$remove,
    clearAll: $2f488efbbac38c6f$var$clearAll
};
var $2f488efbbac38c6f$var$doc = $2f488efbbac38c6f$var$Global.document;
function $2f488efbbac38c6f$var$read(key) {
    if (!key || !$2f488efbbac38c6f$var$_has(key)) return null;
    var regexpStr = "(?:^|.*;\\s*)" + escape(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*";
    return unescape($2f488efbbac38c6f$var$doc.cookie.replace(new RegExp(regexpStr), "$1"));
}
function $2f488efbbac38c6f$var$each(callback) {
    var cookies = $2f488efbbac38c6f$var$doc.cookie.split(/; ?/g);
    for(var i = cookies.length - 1; i >= 0; i--){
        if (!$2f488efbbac38c6f$var$trim(cookies[i])) continue;
        var kvp = cookies[i].split("=");
        var key = unescape(kvp[0]);
        var val = unescape(kvp[1]);
        callback(val, key);
    }
}
function $2f488efbbac38c6f$var$write(key, data) {
    if (!key) return;
    $2f488efbbac38c6f$var$doc.cookie = escape(key) + "=" + escape(data) + "; expires=Tue, 19 Jan 2038 03:14:07 GMT; path=/";
}
function $2f488efbbac38c6f$var$remove(key) {
    if (!key || !$2f488efbbac38c6f$var$_has(key)) return;
    $2f488efbbac38c6f$var$doc.cookie = escape(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
}
function $2f488efbbac38c6f$var$clearAll() {
    $2f488efbbac38c6f$var$each(function(_, key) {
        $2f488efbbac38c6f$var$remove(key);
    });
}
function $2f488efbbac38c6f$var$_has(key) {
    return new RegExp("(?:^|;\\s*)" + escape(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test($2f488efbbac38c6f$var$doc.cookie);
}

});

parcelRegister("hJeqb", function(module, exports) {

var $jdIcp = parcelRequire("jdIcp");
var $ce81d36df069b61d$var$Global = $jdIcp.Global;
module.exports = {
    name: "sessionStorage",
    read: $ce81d36df069b61d$var$read,
    write: $ce81d36df069b61d$var$write,
    each: $ce81d36df069b61d$var$each,
    remove: $ce81d36df069b61d$var$remove,
    clearAll: $ce81d36df069b61d$var$clearAll
};
function $ce81d36df069b61d$var$sessionStorage() {
    return $ce81d36df069b61d$var$Global.sessionStorage;
}
function $ce81d36df069b61d$var$read(key) {
    return $ce81d36df069b61d$var$sessionStorage().getItem(key);
}
function $ce81d36df069b61d$var$write(key, data) {
    return $ce81d36df069b61d$var$sessionStorage().setItem(key, data);
}
function $ce81d36df069b61d$var$each(fn) {
    for(var i = $ce81d36df069b61d$var$sessionStorage().length - 1; i >= 0; i--){
        var key = $ce81d36df069b61d$var$sessionStorage().key(i);
        fn($ce81d36df069b61d$var$read(key), key);
    }
}
function $ce81d36df069b61d$var$remove(key) {
    return $ce81d36df069b61d$var$sessionStorage().removeItem(key);
}
function $ce81d36df069b61d$var$clearAll() {
    return $ce81d36df069b61d$var$sessionStorage().clear();
}

});

parcelRegister("ewqms", function(module, exports) {
// memoryStorage is a useful last fallback to ensure that the store
// is functions (meaning store.get(), store.set(), etc will all function).
// However, stored values will not persist when the browser navigates to
// a new page or reloads the current page.
module.exports = {
    name: "memoryStorage",
    read: $a928809e8d826a79$var$read,
    write: $a928809e8d826a79$var$write,
    each: $a928809e8d826a79$var$each,
    remove: $a928809e8d826a79$var$remove,
    clearAll: $a928809e8d826a79$var$clearAll
};
var $a928809e8d826a79$var$memoryStorage = {};
function $a928809e8d826a79$var$read(key) {
    return $a928809e8d826a79$var$memoryStorage[key];
}
function $a928809e8d826a79$var$write(key, data) {
    $a928809e8d826a79$var$memoryStorage[key] = data;
}
function $a928809e8d826a79$var$each(callback) {
    for(var key in $a928809e8d826a79$var$memoryStorage)if ($a928809e8d826a79$var$memoryStorage.hasOwnProperty(key)) callback($a928809e8d826a79$var$memoryStorage[key], key);
}
function $a928809e8d826a79$var$remove(key) {
    delete $a928809e8d826a79$var$memoryStorage[key];
}
function $a928809e8d826a79$var$clearAll(key) {
    $a928809e8d826a79$var$memoryStorage = {};
}

});

parcelRegister("62rbo", function(module, exports) {
module.exports = $465803ef44dc9e1d$var$json2Plugin;

function $465803ef44dc9e1d$var$json2Plugin() {
    (parcelRequire("2HFkh"));
    return {};
}

});
parcelRegister("2HFkh", function(module, exports) {
/* eslint-disable */ //  json2.js
//  2016-10-28
//  Public Domain.
//  NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
//  See http://www.JSON.org/js.html
//  This code should be minified before deployment.
//  See http://javascript.crockford.com/jsmin.html
//  USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
//  NOT CONTROL.
//  This file creates a global JSON object containing two methods: stringify
//  and parse. This file provides the ES5 JSON capability to ES3 systems.
//  If a project might run on IE8 or earlier, then this file should be included.
//  This file does nothing on ES5 systems.
//      JSON.stringify(value, replacer, space)
//          value       any JavaScript value, usually an object or array.
//          replacer    an optional parameter that determines how object
//                      values are stringified for objects. It can be a
//                      function or an array of strings.
//          space       an optional parameter that specifies the indentation
//                      of nested structures. If it is omitted, the text will
//                      be packed without extra whitespace. If it is a number,
//                      it will specify the number of spaces to indent at each
//                      level. If it is a string (such as "\t" or "&nbsp;"),
//                      it contains the characters used to indent at each level.
//          This method produces a JSON text from a JavaScript value.
//          When an object value is found, if the object contains a toJSON
//          method, its toJSON method will be called and the result will be
//          stringified. A toJSON method does not serialize: it returns the
//          value represented by the name/value pair that should be serialized,
//          or undefined if nothing should be serialized. The toJSON method
//          will be passed the key associated with the value, and this will be
//          bound to the value.
//          For example, this would serialize Dates as ISO strings.
//              Date.prototype.toJSON = function (key) {
//                  function f(n) {
//                      // Format integers to have at least two digits.
//                      return (n < 10)
//                          ? "0" + n
//                          : n;
//                  }
//                  return this.getUTCFullYear()   + "-" +
//                       f(this.getUTCMonth() + 1) + "-" +
//                       f(this.getUTCDate())      + "T" +
//                       f(this.getUTCHours())     + ":" +
//                       f(this.getUTCMinutes())   + ":" +
//                       f(this.getUTCSeconds())   + "Z";
//              };
//          You can provide an optional replacer method. It will be passed the
//          key and value of each member, with this bound to the containing
//          object. The value that is returned from your method will be
//          serialized. If your method returns undefined, then the member will
//          be excluded from the serialization.
//          If the replacer parameter is an array of strings, then it will be
//          used to select the members to be serialized. It filters the results
//          such that only members with keys listed in the replacer array are
//          stringified.
//          Values that do not have JSON representations, such as undefined or
//          functions, will not be serialized. Such values in objects will be
//          dropped; in arrays they will be replaced with null. You can use
//          a replacer function to replace those with JSON values.
//          JSON.stringify(undefined) returns undefined.
//          The optional space parameter produces a stringification of the
//          value that is filled with line breaks and indentation to make it
//          easier to read.
//          If the space parameter is a non-empty string, then that string will
//          be used for indentation. If the space parameter is a number, then
//          the indentation will be that many spaces.
//          Example:
//          text = JSON.stringify(["e", {pluribus: "unum"}]);
//          // text is '["e",{"pluribus":"unum"}]'
//          text = JSON.stringify(["e", {pluribus: "unum"}], null, "\t");
//          // text is '[\n\t"e",\n\t{\n\t\t"pluribus": "unum"\n\t}\n]'
//          text = JSON.stringify([new Date()], function (key, value) {
//              return this[key] instanceof Date
//                  ? "Date(" + this[key] + ")"
//                  : value;
//          });
//          // text is '["Date(---current time---)"]'
//      JSON.parse(text, reviver)
//          This method parses a JSON text to produce an object or array.
//          It can throw a SyntaxError exception.
//          The optional reviver parameter is a function that can filter and
//          transform the results. It receives each of the keys and values,
//          and its return value is used instead of the original value.
//          If it returns what it received, then the structure is not modified.
//          If it returns undefined then the member is deleted.
//          Example:
//          // Parse the text. Values that look like ISO date strings will
//          // be converted to Date objects.
//          myData = JSON.parse(text, function (key, value) {
//              var a;
//              if (typeof value === "string") {
//                  a =
//   /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
//                  if (a) {
//                      return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
//                          +a[5], +a[6]));
//                  }
//              }
//              return value;
//          });
//          myData = JSON.parse('["Date(09/09/2001)"]', function (key, value) {
//              var d;
//              if (typeof value === "string" &&
//                      value.slice(0, 5) === "Date(" &&
//                      value.slice(-1) === ")") {
//                  d = new Date(value.slice(5, -1));
//                  if (d) {
//                      return d;
//                  }
//              }
//              return value;
//          });
//  This is a reference implementation. You are free to copy, modify, or
//  redistribute.
/*jslint
    eval, for, this
*/ /*property
    JSON, apply, call, charCodeAt, getUTCDate, getUTCFullYear, getUTCHours,
    getUTCMinutes, getUTCMonth, getUTCSeconds, hasOwnProperty, join,
    lastIndex, length, parse, prototype, push, replace, slice, stringify,
    test, toJSON, toString, valueOf
*/ // Create a JSON object only if one does not already exist. We create the
// methods in a closure to avoid creating global variables.
if (typeof JSON !== "object") JSON = {};
(function() {
    "use strict";
    var rx_one = /^[\],:{}\s]*$/;
    var rx_two = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
    var rx_three = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
    var rx_four = /(?:^|:|,)(?:\s*\[)+/g;
    var rx_escapable = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
    var rx_dangerous = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
    function f(n) {
        // Format integers to have at least two digits.
        return n < 10 ? "0" + n : n;
    }
    function this_value() {
        return this.valueOf();
    }
    if (typeof Date.prototype.toJSON !== "function") {
        Date.prototype.toJSON = function() {
            return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + f(this.getUTCMonth() + 1) + "-" + f(this.getUTCDate()) + "T" + f(this.getUTCHours()) + ":" + f(this.getUTCMinutes()) + ":" + f(this.getUTCSeconds()) + "Z" : null;
        };
        Boolean.prototype.toJSON = this_value;
        Number.prototype.toJSON = this_value;
        String.prototype.toJSON = this_value;
    }
    var gap;
    var indent;
    var meta;
    var rep;
    function quote(string) {
        // If the string contains no control characters, no quote characters, and no
        // backslash characters, then we can safely slap some quotes around it.
        // Otherwise we must also replace the offending characters with safe escape
        // sequences.
        rx_escapable.lastIndex = 0;
        return rx_escapable.test(string) ? '"' + string.replace(rx_escapable, function(a) {
            var c = meta[a];
            return typeof c === "string" ? c : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
        }) + '"' : '"' + string + '"';
    }
    function str(key, holder) {
        // Produce a string from holder[key].
        var i; // The loop counter.
        var k; // The member key.
        var v; // The member value.
        var length;
        var mind = gap;
        var partial;
        var value = holder[key];
        // If the value has a toJSON method, call it to obtain a replacement value.
        if (value && typeof value === "object" && typeof value.toJSON === "function") value = value.toJSON(key);
        // If we were called with a replacer function, then call the replacer to
        // obtain a replacement value.
        if (typeof rep === "function") value = rep.call(holder, key, value);
        // What happens next depends on the value's type.
        switch(typeof value){
            case "string":
                return quote(value);
            case "number":
                // JSON numbers must be finite. Encode non-finite numbers as null.
                return isFinite(value) ? String(value) : "null";
            case "boolean":
            case "null":
                // If the value is a boolean or null, convert it to a string. Note:
                // typeof null does not produce "null". The case is included here in
                // the remote chance that this gets fixed someday.
                return String(value);
            // If the type is "object", we might be dealing with an object or an array or
            // null.
            case "object":
                // Due to a specification blunder in ECMAScript, typeof null is "object",
                // so watch out for that case.
                if (!value) return "null";
                // Make an array to hold the partial results of stringifying this object value.
                gap += indent;
                partial = [];
                // Is the value an array?
                if (Object.prototype.toString.apply(value) === "[object Array]") {
                    // The value is an array. Stringify every element. Use null as a placeholder
                    // for non-JSON values.
                    length = value.length;
                    for(i = 0; i < length; i += 1)partial[i] = str(i, value) || "null";
                    // Join all of the elements together, separated with commas, and wrap them in
                    // brackets.
                    v = partial.length === 0 ? "[]" : gap ? "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]" : "[" + partial.join(",") + "]";
                    gap = mind;
                    return v;
                }
                // If the replacer is an array, use it to select the members to be stringified.
                if (rep && typeof rep === "object") {
                    length = rep.length;
                    for(i = 0; i < length; i += 1)if (typeof rep[i] === "string") {
                        k = rep[i];
                        v = str(k, value);
                        if (v) partial.push(quote(k) + (gap ? ": " : ":") + v);
                    }
                } else {
                    // Otherwise, iterate through all of the keys in the object.
                    for(k in value)if (Object.prototype.hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) partial.push(quote(k) + (gap ? ": " : ":") + v);
                    }
                }
                // Join all of the member texts together, separated with commas,
                // and wrap them in braces.
                v = partial.length === 0 ? "{}" : gap ? "{\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "}" : "{" + partial.join(",") + "}";
                gap = mind;
                return v;
        }
    }
    // If the JSON object does not yet have a stringify method, give it one.
    if (typeof JSON.stringify !== "function") {
        meta = {
            "\b": "\\b",
            "	": "\\t",
            "\n": "\\n",
            "\f": "\\f",
            "\r": "\\r",
            '"': '\\"',
            "\\": "\\\\"
        };
        JSON.stringify = function(value, replacer, space) {
            // The stringify method takes a value and an optional replacer, and an optional
            // space parameter, and returns a JSON text. The replacer can be a function
            // that can replace values, or an array of strings that will select the keys.
            // A default replacer method can be provided. Use of the space parameter can
            // produce text that is more easily readable.
            var i;
            gap = "";
            indent = "";
            // If the space parameter is a number, make an indent string containing that
            // many spaces.
            if (typeof space === "number") for(i = 0; i < space; i += 1)indent += " ";
            else if (typeof space === "string") indent = space;
            // If there is a replacer, it must be a function or an array.
            // Otherwise, throw an error.
            rep = replacer;
            if (replacer && typeof replacer !== "function" && (typeof replacer !== "object" || typeof replacer.length !== "number")) throw new Error("JSON.stringify");
            // Make a fake root object containing our value under the key of "".
            // Return the result of stringifying the value.
            return str("", {
                "": value
            });
        };
    }
    // If the JSON object does not yet have a parse method, give it one.
    if (typeof JSON.parse !== "function") JSON.parse = function(text, reviver) {
        // The parse method takes a text and an optional reviver function, and returns
        // a JavaScript value if the text is a valid JSON text.
        var j;
        function walk(holder, key) {
            // The walk method is used to recursively walk the resulting structure so
            // that modifications can be made.
            var k;
            var v;
            var value = holder[key];
            if (value && typeof value === "object") {
                for(k in value)if (Object.prototype.hasOwnProperty.call(value, k)) {
                    v = walk(value, k);
                    if (v !== undefined) value[k] = v;
                    else delete value[k];
                }
            }
            return reviver.call(holder, key, value);
        }
        // Parsing happens in four stages. In the first stage, we replace certain
        // Unicode characters with escape sequences. JavaScript handles many characters
        // incorrectly, either silently deleting them, or treating them as line endings.
        text = String(text);
        rx_dangerous.lastIndex = 0;
        if (rx_dangerous.test(text)) text = text.replace(rx_dangerous, function(a) {
            return "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
        });
        // In the second stage, we run the text against regular expressions that look
        // for non-JSON patterns. We are especially concerned with "()" and "new"
        // because they can cause invocation, and "=" because it can cause mutation.
        // But just to be safe, we want to reject all unexpected forms.
        // We split the second stage into 4 regexp operations in order to work around
        // crippling inefficiencies in IE's and Safari's regexp engines. First we
        // replace the JSON backslash pairs with "@" (a non-JSON character). Second, we
        // replace all simple value tokens with "]" characters. Third, we delete all
        // open brackets that follow a colon or comma or that begin the text. Finally,
        // we look to see that the remaining characters are only whitespace or "]" or
        // "," or ":" or "{" or "}". If that is so, then the text is safe for eval.
        if (rx_one.test(text.replace(rx_two, "@").replace(rx_three, "]").replace(rx_four, ""))) {
            // In the third stage we use the eval function to compile the text into a
            // JavaScript structure. The "{" operator is subject to a syntactic ambiguity
            // in JavaScript: it can begin a block or an object literal. We wrap the text
            // in parens to eliminate the ambiguity.
            j = eval("(" + text + ")");
            // In the optional fourth stage, we recursively walk the new structure, passing
            // each name/value pair to a reviver function for possible transformation.
            return typeof reviver === "function" ? walk({
                "": j
            }, "") : j;
        }
        // If the text is not JSON parseable, then a SyntaxError is thrown.
        throw new SyntaxError("JSON.parse");
    };
})();

});


parcelRegister("3XnHf", function(module, exports) {
"use strict";

var $dehRR = parcelRequire("dehRR");

var $eT175 = parcelRequire("eT175");

var $jf1g9 = parcelRequire("jf1g9");
module.exports = {
    formats: $jf1g9,
    parse: $eT175,
    stringify: $dehRR
};

});
parcelRegister("dehRR", function(module, exports) {
"use strict";

var $fjvaG = parcelRequire("fjvaG");

var $4BETh = parcelRequire("4BETh");

var $jf1g9 = parcelRequire("jf1g9");
var $9a1a71598fb3a848$var$has = Object.prototype.hasOwnProperty;
var $9a1a71598fb3a848$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $9a1a71598fb3a848$var$isArray = Array.isArray;
var $9a1a71598fb3a848$var$push = Array.prototype.push;
var $9a1a71598fb3a848$var$pushToArray = function(arr, valueOrArray) {
    $9a1a71598fb3a848$var$push.apply(arr, $9a1a71598fb3a848$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $9a1a71598fb3a848$var$toISO = Date.prototype.toISOString;
var $9a1a71598fb3a848$var$defaultFormat = $jf1g9.default;
var $9a1a71598fb3a848$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encoder: $4BETh.encode,
    encodeValuesOnly: false,
    format: $9a1a71598fb3a848$var$defaultFormat,
    formatter: $jf1g9.formatters[$9a1a71598fb3a848$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $9a1a71598fb3a848$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $9a1a71598fb3a848$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $9a1a71598fb3a848$var$sentinel = {};
var $9a1a71598fb3a848$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($9a1a71598fb3a848$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($9a1a71598fb3a848$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $9a1a71598fb3a848$var$isArray(obj)) obj = $4BETh.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $9a1a71598fb3a848$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($9a1a71598fb3a848$var$isNonNullishPrimitive(obj) || $4BETh.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $9a1a71598fb3a848$var$defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $9a1a71598fb3a848$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $9a1a71598fb3a848$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $4BETh.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if ($9a1a71598fb3a848$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var adjustedPrefix = commaRoundTrip && $9a1a71598fb3a848$var$isArray(obj) && obj.length === 1 ? prefix + "[]" : prefix;
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var keyPrefix = $9a1a71598fb3a848$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + key : "[" + key + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $fjvaG();
        valueSideChannel.set($9a1a71598fb3a848$var$sentinel, sideChannel);
        $9a1a71598fb3a848$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, generateArrayPrefix === "comma" && encodeValuesOnly && $9a1a71598fb3a848$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $9a1a71598fb3a848$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $9a1a71598fb3a848$var$defaults;
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $9a1a71598fb3a848$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $jf1g9.default;
    if (typeof opts.format !== "undefined") {
        if (!$9a1a71598fb3a848$var$has.call($jf1g9.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $jf1g9.formatters[format];
    var filter = $9a1a71598fb3a848$var$defaults.filter;
    if (typeof opts.filter === "function" || $9a1a71598fb3a848$var$isArray(opts.filter)) filter = opts.filter;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $9a1a71598fb3a848$var$defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === "undefined" ? $9a1a71598fb3a848$var$defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $9a1a71598fb3a848$var$defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === "undefined" ? $9a1a71598fb3a848$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $9a1a71598fb3a848$var$defaults.encode,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $9a1a71598fb3a848$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $9a1a71598fb3a848$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $9a1a71598fb3a848$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $9a1a71598fb3a848$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $9a1a71598fb3a848$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $9a1a71598fb3a848$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($9a1a71598fb3a848$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var arrayFormat;
    if (opts && opts.arrayFormat in $9a1a71598fb3a848$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if (opts && "indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = "indices";
    var generateArrayPrefix = $9a1a71598fb3a848$var$arrayPrefixGenerators[arrayFormat];
    if (opts && "commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var commaRoundTrip = generateArrayPrefix === "comma" && opts && opts.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $fjvaG();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $9a1a71598fb3a848$var$pushToArray(keys, $9a1a71598fb3a848$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

});
parcelRegister("fjvaG", function(module, exports) {
"use strict";

var $jUyTc = parcelRequire("jUyTc");

var $67AY3 = parcelRequire("67AY3");

var $cxXW3 = parcelRequire("cxXW3");
var $b260cf5c88aee487$var$$TypeError = $jUyTc("%TypeError%");
var $b260cf5c88aee487$var$$WeakMap = $jUyTc("%WeakMap%", true);
var $b260cf5c88aee487$var$$Map = $jUyTc("%Map%", true);
var $b260cf5c88aee487$var$$weakMapGet = $67AY3("WeakMap.prototype.get", true);
var $b260cf5c88aee487$var$$weakMapSet = $67AY3("WeakMap.prototype.set", true);
var $b260cf5c88aee487$var$$weakMapHas = $67AY3("WeakMap.prototype.has", true);
var $b260cf5c88aee487$var$$mapGet = $67AY3("Map.prototype.get", true);
var $b260cf5c88aee487$var$$mapSet = $67AY3("Map.prototype.set", true);
var $b260cf5c88aee487$var$$mapHas = $67AY3("Map.prototype.has", true);
/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */ var $b260cf5c88aee487$var$listGetNode = function(list, key) {
    for(var prev = list, curr; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        curr.next = list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
var $b260cf5c88aee487$var$listGet = function(objects, key) {
    var node = $b260cf5c88aee487$var$listGetNode(objects, key);
    return node && node.value;
};
var $b260cf5c88aee487$var$listSet = function(objects, key, value) {
    var node = $b260cf5c88aee487$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = {
        key: key,
        next: objects.next,
        value: value
    };
};
var $b260cf5c88aee487$var$listHas = function(objects, key) {
    return !!$b260cf5c88aee487$var$listGetNode(objects, key);
};
module.exports = function getSideChannel() {
    var $wm;
    var $m;
    var $o;
    var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $b260cf5c88aee487$var$$TypeError("Side channel does not contain " + $cxXW3(key));
        },
        get: function(key) {
            if ($b260cf5c88aee487$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $b260cf5c88aee487$var$$weakMapGet($wm, key);
            } else if ($b260cf5c88aee487$var$$Map) {
                if ($m) return $b260cf5c88aee487$var$$mapGet($m, key);
            } else {
                if ($o) return $b260cf5c88aee487$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($b260cf5c88aee487$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $b260cf5c88aee487$var$$weakMapHas($wm, key);
            } else if ($b260cf5c88aee487$var$$Map) {
                if ($m) return $b260cf5c88aee487$var$$mapHas($m, key);
            } else {
                if ($o) return $b260cf5c88aee487$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($b260cf5c88aee487$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $b260cf5c88aee487$var$$WeakMap();
                $b260cf5c88aee487$var$$weakMapSet($wm, key, value);
            } else if ($b260cf5c88aee487$var$$Map) {
                if (!$m) $m = new $b260cf5c88aee487$var$$Map();
                $b260cf5c88aee487$var$$mapSet($m, key, value);
            } else {
                if (!$o) /*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */ $o = {
                    key: {},
                    next: null
                };
                $b260cf5c88aee487$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};

});
parcelRegister("jUyTc", function(module, exports) {
"use strict";
var $e7ee4f8f9f051974$var$undefined1;
var $e7ee4f8f9f051974$var$$SyntaxError = SyntaxError;
var $e7ee4f8f9f051974$var$$Function = Function;
var $e7ee4f8f9f051974$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $e7ee4f8f9f051974$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $e7ee4f8f9f051974$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $e7ee4f8f9f051974$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($e7ee4f8f9f051974$var$$gOPD) try {
    $e7ee4f8f9f051974$var$$gOPD({}, "");
} catch (e) {
    $e7ee4f8f9f051974$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $e7ee4f8f9f051974$var$throwTypeError = function() {
    throw new $e7ee4f8f9f051974$var$$TypeError();
};
var $e7ee4f8f9f051974$var$ThrowTypeError = $e7ee4f8f9f051974$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $e7ee4f8f9f051974$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $e7ee4f8f9f051974$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $e7ee4f8f9f051974$var$throwTypeError;
        }
    }
}() : $e7ee4f8f9f051974$var$throwTypeError;

var $e7ee4f8f9f051974$var$hasSymbols = (parcelRequire("9aCfM"))();

var $e7ee4f8f9f051974$var$hasProto = (parcelRequire("ijo5Y"))();
var $e7ee4f8f9f051974$var$getProto = Object.getPrototypeOf || ($e7ee4f8f9f051974$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $e7ee4f8f9f051974$var$needsEval = {};
var $e7ee4f8f9f051974$var$TypedArray = typeof Uint8Array === "undefined" || !$e7ee4f8f9f051974$var$getProto ? undefined : $e7ee4f8f9f051974$var$getProto(Uint8Array);
var $e7ee4f8f9f051974$var$INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $e7ee4f8f9f051974$var$hasSymbols && $e7ee4f8f9f051974$var$getProto ? $e7ee4f8f9f051974$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $e7ee4f8f9f051974$var$needsEval,
    "%AsyncGenerator%": $e7ee4f8f9f051974$var$needsEval,
    "%AsyncGeneratorFunction%": $e7ee4f8f9f051974$var$needsEval,
    "%AsyncIteratorPrototype%": $e7ee4f8f9f051974$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $e7ee4f8f9f051974$var$$Function,
    "%GeneratorFunction%": $e7ee4f8f9f051974$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $e7ee4f8f9f051974$var$hasSymbols && $e7ee4f8f9f051974$var$getProto ? $e7ee4f8f9f051974$var$getProto($e7ee4f8f9f051974$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$e7ee4f8f9f051974$var$hasSymbols || !$e7ee4f8f9f051974$var$getProto ? undefined : $e7ee4f8f9f051974$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$e7ee4f8f9f051974$var$hasSymbols || !$e7ee4f8f9f051974$var$getProto ? undefined : $e7ee4f8f9f051974$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $e7ee4f8f9f051974$var$hasSymbols && $e7ee4f8f9f051974$var$getProto ? $e7ee4f8f9f051974$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $e7ee4f8f9f051974$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $e7ee4f8f9f051974$var$$SyntaxError,
    "%ThrowTypeError%": $e7ee4f8f9f051974$var$ThrowTypeError,
    "%TypedArray%": $e7ee4f8f9f051974$var$TypedArray,
    "%TypeError%": $e7ee4f8f9f051974$var$$TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($e7ee4f8f9f051974$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $e7ee4f8f9f051974$var$errorProto = $e7ee4f8f9f051974$var$getProto($e7ee4f8f9f051974$var$getProto(e));
    $e7ee4f8f9f051974$var$INTRINSICS["%Error.prototype%"] = $e7ee4f8f9f051974$var$errorProto;
}
var $e7ee4f8f9f051974$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $e7ee4f8f9f051974$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $e7ee4f8f9f051974$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $e7ee4f8f9f051974$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $e7ee4f8f9f051974$var$getProto) value = $e7ee4f8f9f051974$var$getProto(gen.prototype);
    }
    $e7ee4f8f9f051974$var$INTRINSICS[name] = value;
    return value;
};
var $e7ee4f8f9f051974$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $4LrPV = parcelRequire("4LrPV");

var $f1u4e = parcelRequire("f1u4e");
var $e7ee4f8f9f051974$var$$concat = $4LrPV.call(Function.call, Array.prototype.concat);
var $e7ee4f8f9f051974$var$$spliceApply = $4LrPV.call(Function.apply, Array.prototype.splice);
var $e7ee4f8f9f051974$var$$replace = $4LrPV.call(Function.call, String.prototype.replace);
var $e7ee4f8f9f051974$var$$strSlice = $4LrPV.call(Function.call, String.prototype.slice);
var $e7ee4f8f9f051974$var$$exec = $4LrPV.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $e7ee4f8f9f051974$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $e7ee4f8f9f051974$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $e7ee4f8f9f051974$var$stringToPath = function stringToPath(string) {
    var first = $e7ee4f8f9f051974$var$$strSlice(string, 0, 1);
    var last = $e7ee4f8f9f051974$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $e7ee4f8f9f051974$var$$SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $e7ee4f8f9f051974$var$$SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $e7ee4f8f9f051974$var$$replace(string, $e7ee4f8f9f051974$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $e7ee4f8f9f051974$var$$replace(subString, $e7ee4f8f9f051974$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $e7ee4f8f9f051974$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($f1u4e($e7ee4f8f9f051974$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $e7ee4f8f9f051974$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($f1u4e($e7ee4f8f9f051974$var$INTRINSICS, intrinsicName)) {
        var value = $e7ee4f8f9f051974$var$INTRINSICS[intrinsicName];
        if (value === $e7ee4f8f9f051974$var$needsEval) value = $e7ee4f8f9f051974$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $e7ee4f8f9f051974$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $e7ee4f8f9f051974$var$$SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $e7ee4f8f9f051974$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $e7ee4f8f9f051974$var$$TypeError('"allowMissing" argument must be a boolean');
    if ($e7ee4f8f9f051974$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $e7ee4f8f9f051974$var$$SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $e7ee4f8f9f051974$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $e7ee4f8f9f051974$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $e7ee4f8f9f051974$var$$spliceApply(parts, $e7ee4f8f9f051974$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $e7ee4f8f9f051974$var$$strSlice(part, 0, 1);
        var last = $e7ee4f8f9f051974$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $e7ee4f8f9f051974$var$$SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($f1u4e($e7ee4f8f9f051974$var$INTRINSICS, intrinsicRealName)) value = $e7ee4f8f9f051974$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $e7ee4f8f9f051974$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($e7ee4f8f9f051974$var$$gOPD && i + 1 >= parts.length) {
                var desc = $e7ee4f8f9f051974$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $f1u4e(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $e7ee4f8f9f051974$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("9aCfM", function(module, exports) {
"use strict";
var $6ad2b8929b284f4f$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $azEqB = parcelRequire("azEqB");
module.exports = function hasNativeSymbols() {
    if (typeof $6ad2b8929b284f4f$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $6ad2b8929b284f4f$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $azEqB();
};

});
parcelRegister("azEqB", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("ijo5Y", function(module, exports) {
"use strict";
var $d54cb133391df87d$var$test = {
    foo: {}
};
var $d54cb133391df87d$var$$Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: $d54cb133391df87d$var$test
    }).foo === $d54cb133391df87d$var$test.foo && !(({
        __proto__: null
    }) instanceof $d54cb133391df87d$var$$Object);
};

});

parcelRegister("4LrPV", function(module, exports) {
"use strict";

var $cuQmb = parcelRequire("cuQmb");
module.exports = Function.prototype.bind || $cuQmb;

});
parcelRegister("cuQmb", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $9190e65aa0c2c9a8$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $9190e65aa0c2c9a8$var$toStr = Object.prototype.toString;
var $9190e65aa0c2c9a8$var$max = Math.max;
var $9190e65aa0c2c9a8$var$funcType = "[object Function]";
var $9190e65aa0c2c9a8$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $9190e65aa0c2c9a8$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $9190e65aa0c2c9a8$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $9190e65aa0c2c9a8$var$toStr.apply(target) !== $9190e65aa0c2c9a8$var$funcType) throw new TypeError($9190e65aa0c2c9a8$var$ERROR_MESSAGE + target);
    var args = $9190e65aa0c2c9a8$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $9190e65aa0c2c9a8$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $9190e65aa0c2c9a8$var$concatty(args, arguments));
    };
    var boundLength = $9190e65aa0c2c9a8$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $9190e65aa0c2c9a8$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("f1u4e", function(module, exports) {
"use strict";
var $aefe45be6dd88375$var$call = Function.prototype.call;
var $aefe45be6dd88375$var$$hasOwn = Object.prototype.hasOwnProperty;

var $4LrPV = parcelRequire("4LrPV");
/** @type {(o: {}, p: PropertyKey) => p is keyof o} */ module.exports = $4LrPV.call($aefe45be6dd88375$var$call, $aefe45be6dd88375$var$$hasOwn);

});


parcelRegister("67AY3", function(module, exports) {
"use strict";

var $jUyTc = parcelRequire("jUyTc");

var $ahPdt = parcelRequire("ahPdt");
var $47501281c68df46e$var$$indexOf = $ahPdt($jUyTc("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $jUyTc(name, !!allowMissing);
    if (typeof intrinsic === "function" && $47501281c68df46e$var$$indexOf(name, ".prototype.") > -1) return $ahPdt(intrinsic);
    return intrinsic;
};

});
parcelRegister("ahPdt", function(module, exports) {
"use strict";

var $4LrPV = parcelRequire("4LrPV");

var $jUyTc = parcelRequire("jUyTc");

var $g2IRz = parcelRequire("g2IRz");
var $77d33867bb964291$var$$TypeError = $jUyTc("%TypeError%");
var $77d33867bb964291$var$$apply = $jUyTc("%Function.prototype.apply%");
var $77d33867bb964291$var$$call = $jUyTc("%Function.prototype.call%");
var $77d33867bb964291$var$$reflectApply = $jUyTc("%Reflect.apply%", true) || $4LrPV.call($77d33867bb964291$var$$call, $77d33867bb964291$var$$apply);
var $77d33867bb964291$var$$defineProperty = $jUyTc("%Object.defineProperty%", true);
var $77d33867bb964291$var$$max = $jUyTc("%Math.max%");
if ($77d33867bb964291$var$$defineProperty) try {
    $77d33867bb964291$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $77d33867bb964291$var$$defineProperty = null;
}
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $77d33867bb964291$var$$TypeError("a function is required");
    var func = $77d33867bb964291$var$$reflectApply($4LrPV, $77d33867bb964291$var$$call, arguments);
    return $g2IRz(func, 1 + $77d33867bb964291$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $77d33867bb964291$var$applyBind = function applyBind() {
    return $77d33867bb964291$var$$reflectApply($4LrPV, $77d33867bb964291$var$$apply, arguments);
};
if ($77d33867bb964291$var$$defineProperty) $77d33867bb964291$var$$defineProperty(module.exports, "apply", {
    value: $77d33867bb964291$var$applyBind
});
else module.exports.apply = $77d33867bb964291$var$applyBind;

});
parcelRegister("g2IRz", function(module, exports) {
"use strict";

var $jUyTc = parcelRequire("jUyTc");

var $1Btuj = parcelRequire("1Btuj");

var $badfa21f1dd1634c$var$hasDescriptors = (parcelRequire("5OiKv"))();

var $k6oWl = parcelRequire("k6oWl");
var $badfa21f1dd1634c$var$$TypeError = $jUyTc("%TypeError%");
var $badfa21f1dd1634c$var$$floor = $jUyTc("%Math.floor%");
module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $badfa21f1dd1634c$var$$TypeError("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $badfa21f1dd1634c$var$$floor(length) !== length) throw new $badfa21f1dd1634c$var$$TypeError("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $k6oWl) {
        var desc = $k6oWl(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($badfa21f1dd1634c$var$hasDescriptors) $1Btuj(fn, "length", length, true, true);
        else $1Btuj(fn, "length", length);
    }
    return fn;
};

});
parcelRegister("1Btuj", function(module, exports) {
"use strict";

var $12b01edad7c95745$var$hasPropertyDescriptors = (parcelRequire("5OiKv"))();

var $jUyTc = parcelRequire("jUyTc");
var $12b01edad7c95745$var$$defineProperty = $12b01edad7c95745$var$hasPropertyDescriptors && $jUyTc("%Object.defineProperty%", true);
if ($12b01edad7c95745$var$$defineProperty) try {
    $12b01edad7c95745$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $12b01edad7c95745$var$$defineProperty = false;
}
var $12b01edad7c95745$var$$SyntaxError = $jUyTc("%SyntaxError%");
var $12b01edad7c95745$var$$TypeError = $jUyTc("%TypeError%");

var $k6oWl = parcelRequire("k6oWl");
/** @type {(obj: Record<PropertyKey, unknown>, property: PropertyKey, value: unknown, nonEnumerable?: boolean | null, nonWritable?: boolean | null, nonConfigurable?: boolean | null, loose?: boolean) => void} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $12b01edad7c95745$var$$TypeError("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $12b01edad7c95745$var$$TypeError("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $12b01edad7c95745$var$$TypeError("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $12b01edad7c95745$var$$TypeError("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $12b01edad7c95745$var$$TypeError("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $12b01edad7c95745$var$$TypeError("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$k6oWl && $k6oWl(obj, property);
    if ($12b01edad7c95745$var$$defineProperty) $12b01edad7c95745$var$$defineProperty(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $12b01edad7c95745$var$$SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("5OiKv", function(module, exports) {
"use strict";

var $jUyTc = parcelRequire("jUyTc");
var $43b02a72e766450d$var$$defineProperty = $jUyTc("%Object.defineProperty%", true);
var $43b02a72e766450d$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    if ($43b02a72e766450d$var$$defineProperty) try {
        $43b02a72e766450d$var$$defineProperty({}, "a", {
            value: 1
        });
        return true;
    } catch (e) {
        // IE 8 has a broken defineProperty
        return false;
    }
    return false;
};
$43b02a72e766450d$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$43b02a72e766450d$var$hasPropertyDescriptors()) return null;
    try {
        return $43b02a72e766450d$var$$defineProperty([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $43b02a72e766450d$var$hasPropertyDescriptors;

});

parcelRegister("k6oWl", function(module, exports) {
"use strict";

var $jUyTc = parcelRequire("jUyTc");
var $ea27b6c0645eb09b$var$$gOPD = $jUyTc("%Object.getOwnPropertyDescriptor%", true);
if ($ea27b6c0645eb09b$var$$gOPD) try {
    $ea27b6c0645eb09b$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $ea27b6c0645eb09b$var$$gOPD = null;
}
module.exports = $ea27b6c0645eb09b$var$$gOPD;

});





parcelRegister("cxXW3", function(module, exports) {
var $92270f038c58001e$var$hasMap = typeof Map === "function" && Map.prototype;
var $92270f038c58001e$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $92270f038c58001e$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $92270f038c58001e$var$mapSize = $92270f038c58001e$var$hasMap && $92270f038c58001e$var$mapSizeDescriptor && typeof $92270f038c58001e$var$mapSizeDescriptor.get === "function" ? $92270f038c58001e$var$mapSizeDescriptor.get : null;
var $92270f038c58001e$var$mapForEach = $92270f038c58001e$var$hasMap && Map.prototype.forEach;
var $92270f038c58001e$var$hasSet = typeof Set === "function" && Set.prototype;
var $92270f038c58001e$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $92270f038c58001e$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $92270f038c58001e$var$setSize = $92270f038c58001e$var$hasSet && $92270f038c58001e$var$setSizeDescriptor && typeof $92270f038c58001e$var$setSizeDescriptor.get === "function" ? $92270f038c58001e$var$setSizeDescriptor.get : null;
var $92270f038c58001e$var$setForEach = $92270f038c58001e$var$hasSet && Set.prototype.forEach;
var $92270f038c58001e$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $92270f038c58001e$var$weakMapHas = $92270f038c58001e$var$hasWeakMap ? WeakMap.prototype.has : null;
var $92270f038c58001e$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $92270f038c58001e$var$weakSetHas = $92270f038c58001e$var$hasWeakSet ? WeakSet.prototype.has : null;
var $92270f038c58001e$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $92270f038c58001e$var$weakRefDeref = $92270f038c58001e$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $92270f038c58001e$var$booleanValueOf = Boolean.prototype.valueOf;
var $92270f038c58001e$var$objectToString = Object.prototype.toString;
var $92270f038c58001e$var$functionToString = Function.prototype.toString;
var $92270f038c58001e$var$$match = String.prototype.match;
var $92270f038c58001e$var$$slice = String.prototype.slice;
var $92270f038c58001e$var$$replace = String.prototype.replace;
var $92270f038c58001e$var$$toUpperCase = String.prototype.toUpperCase;
var $92270f038c58001e$var$$toLowerCase = String.prototype.toLowerCase;
var $92270f038c58001e$var$$test = RegExp.prototype.test;
var $92270f038c58001e$var$$concat = Array.prototype.concat;
var $92270f038c58001e$var$$join = Array.prototype.join;
var $92270f038c58001e$var$$arrSlice = Array.prototype.slice;
var $92270f038c58001e$var$$floor = Math.floor;
var $92270f038c58001e$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $92270f038c58001e$var$gOPS = Object.getOwnPropertySymbols;
var $92270f038c58001e$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $92270f038c58001e$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $92270f038c58001e$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $92270f038c58001e$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $92270f038c58001e$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $92270f038c58001e$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $92270f038c58001e$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $92270f038c58001e$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$92270f038c58001e$var$$floor(-num) : $92270f038c58001e$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $92270f038c58001e$var$$slice.call(str, intStr.length + 1);
            return $92270f038c58001e$var$$replace.call(intStr, sepRegex, "$&_") + "." + $92270f038c58001e$var$$replace.call($92270f038c58001e$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $92270f038c58001e$var$$replace.call(str, sepRegex, "$&_");
}

var $3Mxlj = parcelRequire("3Mxlj");
var $92270f038c58001e$var$inspectCustom = $3Mxlj.custom;
var $92270f038c58001e$var$inspectSymbol = $92270f038c58001e$var$isSymbol($92270f038c58001e$var$inspectCustom) ? $92270f038c58001e$var$inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($92270f038c58001e$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($92270f038c58001e$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $92270f038c58001e$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($92270f038c58001e$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($92270f038c58001e$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $92270f038c58001e$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $92270f038c58001e$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $92270f038c58001e$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $92270f038c58001e$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $92270f038c58001e$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($92270f038c58001e$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $92270f038c58001e$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($92270f038c58001e$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$92270f038c58001e$var$isRegExp(obj)) {
        var name = $92270f038c58001e$var$nameOf(obj);
        var keys = $92270f038c58001e$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $92270f038c58001e$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($92270f038c58001e$var$isSymbol(obj)) {
        var symString = $92270f038c58001e$var$hasShammedSymbols ? $92270f038c58001e$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $92270f038c58001e$var$symToString.call(obj);
        return typeof obj === "object" && !$92270f038c58001e$var$hasShammedSymbols ? $92270f038c58001e$var$markBoxed(symString) : symString;
    }
    if ($92270f038c58001e$var$isElement(obj)) {
        var s = "<" + $92270f038c58001e$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $92270f038c58001e$var$wrapQuotes($92270f038c58001e$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $92270f038c58001e$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($92270f038c58001e$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $92270f038c58001e$var$arrObjKeys(obj, inspect);
        if (indent && !$92270f038c58001e$var$singleLineValues(xs)) return "[" + $92270f038c58001e$var$indentedJoin(xs, indent) + "]";
        return "[ " + $92270f038c58001e$var$$join.call(xs, ", ") + " ]";
    }
    if ($92270f038c58001e$var$isError(obj)) {
        var parts = $92270f038c58001e$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$92270f038c58001e$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $92270f038c58001e$var$$join.call($92270f038c58001e$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $92270f038c58001e$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($92270f038c58001e$var$inspectSymbol && typeof obj[$92270f038c58001e$var$inspectSymbol] === "function" && $3Mxlj) return $3Mxlj(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($92270f038c58001e$var$isMap(obj)) {
        var mapParts = [];
        if ($92270f038c58001e$var$mapForEach) $92270f038c58001e$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $92270f038c58001e$var$collectionOf("Map", $92270f038c58001e$var$mapSize.call(obj), mapParts, indent);
    }
    if ($92270f038c58001e$var$isSet(obj)) {
        var setParts = [];
        if ($92270f038c58001e$var$setForEach) $92270f038c58001e$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $92270f038c58001e$var$collectionOf("Set", $92270f038c58001e$var$setSize.call(obj), setParts, indent);
    }
    if ($92270f038c58001e$var$isWeakMap(obj)) return $92270f038c58001e$var$weakCollectionOf("WeakMap");
    if ($92270f038c58001e$var$isWeakSet(obj)) return $92270f038c58001e$var$weakCollectionOf("WeakSet");
    if ($92270f038c58001e$var$isWeakRef(obj)) return $92270f038c58001e$var$weakCollectionOf("WeakRef");
    if ($92270f038c58001e$var$isNumber(obj)) return $92270f038c58001e$var$markBoxed(inspect(Number(obj)));
    if ($92270f038c58001e$var$isBigInt(obj)) return $92270f038c58001e$var$markBoxed(inspect($92270f038c58001e$var$bigIntValueOf.call(obj)));
    if ($92270f038c58001e$var$isBoolean(obj)) return $92270f038c58001e$var$markBoxed($92270f038c58001e$var$booleanValueOf.call(obj));
    if ($92270f038c58001e$var$isString(obj)) return $92270f038c58001e$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== "undefined" && obj === window) return "{ [object Window] }";
    if (obj === $parcel$global) return "{ [object globalThis] }";
    if (!$92270f038c58001e$var$isDate(obj) && !$92270f038c58001e$var$isRegExp(obj)) {
        var ys = $92270f038c58001e$var$arrObjKeys(obj, inspect);
        var isPlainObject = $92270f038c58001e$var$gPO ? $92270f038c58001e$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $92270f038c58001e$var$toStringTag && Object(obj) === obj && $92270f038c58001e$var$toStringTag in obj ? $92270f038c58001e$var$$slice.call($92270f038c58001e$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $92270f038c58001e$var$$join.call($92270f038c58001e$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $92270f038c58001e$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $92270f038c58001e$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $92270f038c58001e$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $92270f038c58001e$var$quote(s) {
    return $92270f038c58001e$var$$replace.call(String(s), /"/g, "&quot;");
}
function $92270f038c58001e$var$isArray(obj) {
    return $92270f038c58001e$var$toStr(obj) === "[object Array]" && (!$92270f038c58001e$var$toStringTag || !(typeof obj === "object" && $92270f038c58001e$var$toStringTag in obj));
}
function $92270f038c58001e$var$isDate(obj) {
    return $92270f038c58001e$var$toStr(obj) === "[object Date]" && (!$92270f038c58001e$var$toStringTag || !(typeof obj === "object" && $92270f038c58001e$var$toStringTag in obj));
}
function $92270f038c58001e$var$isRegExp(obj) {
    return $92270f038c58001e$var$toStr(obj) === "[object RegExp]" && (!$92270f038c58001e$var$toStringTag || !(typeof obj === "object" && $92270f038c58001e$var$toStringTag in obj));
}
function $92270f038c58001e$var$isError(obj) {
    return $92270f038c58001e$var$toStr(obj) === "[object Error]" && (!$92270f038c58001e$var$toStringTag || !(typeof obj === "object" && $92270f038c58001e$var$toStringTag in obj));
}
function $92270f038c58001e$var$isString(obj) {
    return $92270f038c58001e$var$toStr(obj) === "[object String]" && (!$92270f038c58001e$var$toStringTag || !(typeof obj === "object" && $92270f038c58001e$var$toStringTag in obj));
}
function $92270f038c58001e$var$isNumber(obj) {
    return $92270f038c58001e$var$toStr(obj) === "[object Number]" && (!$92270f038c58001e$var$toStringTag || !(typeof obj === "object" && $92270f038c58001e$var$toStringTag in obj));
}
function $92270f038c58001e$var$isBoolean(obj) {
    return $92270f038c58001e$var$toStr(obj) === "[object Boolean]" && (!$92270f038c58001e$var$toStringTag || !(typeof obj === "object" && $92270f038c58001e$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $92270f038c58001e$var$isSymbol(obj) {
    if ($92270f038c58001e$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$92270f038c58001e$var$symToString) return false;
    try {
        $92270f038c58001e$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $92270f038c58001e$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$92270f038c58001e$var$bigIntValueOf) return false;
    try {
        $92270f038c58001e$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $92270f038c58001e$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $92270f038c58001e$var$has(obj, key) {
    return $92270f038c58001e$var$hasOwn.call(obj, key);
}
function $92270f038c58001e$var$toStr(obj) {
    return $92270f038c58001e$var$objectToString.call(obj);
}
function $92270f038c58001e$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $92270f038c58001e$var$$match.call($92270f038c58001e$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $92270f038c58001e$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $92270f038c58001e$var$isMap(x) {
    if (!$92270f038c58001e$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $92270f038c58001e$var$mapSize.call(x);
        try {
            $92270f038c58001e$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $92270f038c58001e$var$isWeakMap(x) {
    if (!$92270f038c58001e$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $92270f038c58001e$var$weakMapHas.call(x, $92270f038c58001e$var$weakMapHas);
        try {
            $92270f038c58001e$var$weakSetHas.call(x, $92270f038c58001e$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $92270f038c58001e$var$isWeakRef(x) {
    if (!$92270f038c58001e$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $92270f038c58001e$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $92270f038c58001e$var$isSet(x) {
    if (!$92270f038c58001e$var$setSize || !x || typeof x !== "object") return false;
    try {
        $92270f038c58001e$var$setSize.call(x);
        try {
            $92270f038c58001e$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $92270f038c58001e$var$isWeakSet(x) {
    if (!$92270f038c58001e$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $92270f038c58001e$var$weakSetHas.call(x, $92270f038c58001e$var$weakSetHas);
        try {
            $92270f038c58001e$var$weakMapHas.call(x, $92270f038c58001e$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $92270f038c58001e$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $92270f038c58001e$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $92270f038c58001e$var$inspectString($92270f038c58001e$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $92270f038c58001e$var$$replace.call($92270f038c58001e$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $92270f038c58001e$var$lowbyte);
    return $92270f038c58001e$var$wrapQuotes(s, "single", opts);
}
function $92270f038c58001e$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $92270f038c58001e$var$$toUpperCase.call(n.toString(16));
}
function $92270f038c58001e$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $92270f038c58001e$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $92270f038c58001e$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $92270f038c58001e$var$indentedJoin(entries, indent) : $92270f038c58001e$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $92270f038c58001e$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($92270f038c58001e$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $92270f038c58001e$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $92270f038c58001e$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $92270f038c58001e$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $92270f038c58001e$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $92270f038c58001e$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $92270f038c58001e$var$arrObjKeys(obj, inspect) {
    var isArr = $92270f038c58001e$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $92270f038c58001e$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $92270f038c58001e$var$gOPS === "function" ? $92270f038c58001e$var$gOPS(obj) : [];
    var symMap;
    if ($92270f038c58001e$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$92270f038c58001e$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($92270f038c58001e$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($92270f038c58001e$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $92270f038c58001e$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($92270f038c58001e$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("3Mxlj", function(module, exports) {
"use strict";

});



parcelRegister("4BETh", function(module, exports) {
"use strict";

var $jf1g9 = parcelRequire("jf1g9");
var $35aa562c6781617a$var$has = Object.prototype.hasOwnProperty;
var $35aa562c6781617a$var$isArray = Array.isArray;
var $35aa562c6781617a$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $35aa562c6781617a$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($35aa562c6781617a$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $35aa562c6781617a$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $35aa562c6781617a$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($35aa562c6781617a$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$35aa562c6781617a$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($35aa562c6781617a$var$isArray(target) && !$35aa562c6781617a$var$isArray(source)) mergeTarget = $35aa562c6781617a$var$arrayToObject(target, options);
    if ($35aa562c6781617a$var$isArray(target) && $35aa562c6781617a$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($35aa562c6781617a$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($35aa562c6781617a$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $35aa562c6781617a$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $35aa562c6781617a$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $35aa562c6781617a$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
         || format === $jf1g9.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + $35aa562c6781617a$var$hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + ($35aa562c6781617a$var$hexTable[0xC0 | c >> 6] + $35aa562c6781617a$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + ($35aa562c6781617a$var$hexTable[0xE0 | c >> 12] + $35aa562c6781617a$var$hexTable[0x80 | c >> 6 & 0x3F] + $35aa562c6781617a$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */ out += $35aa562c6781617a$var$hexTable[0xF0 | c >> 18] + $35aa562c6781617a$var$hexTable[0x80 | c >> 12 & 0x3F] + $35aa562c6781617a$var$hexTable[0x80 | c >> 6 & 0x3F] + $35aa562c6781617a$var$hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var $35aa562c6781617a$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $35aa562c6781617a$var$compactQueue(queue);
    return value;
};
var $35aa562c6781617a$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $35aa562c6781617a$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $35aa562c6781617a$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $35aa562c6781617a$var$maybeMap = function maybeMap(val, fn) {
    if ($35aa562c6781617a$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $35aa562c6781617a$var$arrayToObject,
    assign: $35aa562c6781617a$var$assign,
    combine: $35aa562c6781617a$var$combine,
    compact: $35aa562c6781617a$var$compact,
    decode: $35aa562c6781617a$var$decode,
    encode: $35aa562c6781617a$var$encode,
    isBuffer: $35aa562c6781617a$var$isBuffer,
    isRegExp: $35aa562c6781617a$var$isRegExp,
    maybeMap: $35aa562c6781617a$var$maybeMap,
    merge: $35aa562c6781617a$var$merge
};

});
parcelRegister("jf1g9", function(module, exports) {
"use strict";
var $e0206524c95dd0c5$var$replace = String.prototype.replace;
var $e0206524c95dd0c5$var$percentTwenties = /%20/g;
var $e0206524c95dd0c5$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
module.exports = {
    "default": $e0206524c95dd0c5$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $e0206524c95dd0c5$var$replace.call(value, $e0206524c95dd0c5$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $e0206524c95dd0c5$var$Format.RFC1738,
    RFC3986: $e0206524c95dd0c5$var$Format.RFC3986
};

});



parcelRegister("eT175", function(module, exports) {
"use strict";

var $4BETh = parcelRequire("4BETh");
var $ad6710d7a10772e5$var$has = Object.prototype.hasOwnProperty;
var $ad6710d7a10772e5$var$isArray = Array.isArray;
var $ad6710d7a10772e5$var$defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decoder: $4BETh.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $ad6710d7a10772e5$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $ad6710d7a10772e5$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $ad6710d7a10772e5$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $ad6710d7a10772e5$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $ad6710d7a10772e5$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $ad6710d7a10772e5$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $ad6710d7a10772e5$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $ad6710d7a10772e5$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $ad6710d7a10772e5$var$defaults.decoder, charset, "key");
            val = $4BETh.maybeMap($ad6710d7a10772e5$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $ad6710d7a10772e5$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $ad6710d7a10772e5$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $ad6710d7a10772e5$var$isArray(val) ? [
            val
        ] : val;
        if ($ad6710d7a10772e5$var$has.call(obj, key)) obj[key] = $4BETh.combine(obj[key], val);
        else obj[key] = val;
    }
    return obj;
};
var $ad6710d7a10772e5$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $ad6710d7a10772e5$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== "__proto__") obj[cleanRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $ad6710d7a10772e5$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $ad6710d7a10772e5$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $ad6710d7a10772e5$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return $ad6710d7a10772e5$var$parseObject(keys, val, options, valuesParsed);
};
var $ad6710d7a10772e5$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $ad6710d7a10772e5$var$defaults;
    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $ad6710d7a10772e5$var$defaults.charset : opts.charset;
    return {
        allowDots: typeof opts.allowDots === "undefined" ? $ad6710d7a10772e5$var$defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $ad6710d7a10772e5$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $ad6710d7a10772e5$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $ad6710d7a10772e5$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $ad6710d7a10772e5$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $ad6710d7a10772e5$var$defaults.comma,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $ad6710d7a10772e5$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $4BETh.isRegExp(opts.delimiter) ? opts.delimiter : $ad6710d7a10772e5$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $ad6710d7a10772e5$var$defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $ad6710d7a10772e5$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $ad6710d7a10772e5$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $ad6710d7a10772e5$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $ad6710d7a10772e5$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $ad6710d7a10772e5$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $ad6710d7a10772e5$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $ad6710d7a10772e5$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $4BETh.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $4BETh.compact(obj);
};

});


parcelRegister("7oLjV", function(module, exports) {

$parcel$export(module.exports, "BASE_API_URL", () => $0a7fa081a0408a45$export$37b96ba04a8c05d1);
$parcel$export(module.exports, "getListModel", () => $0a7fa081a0408a45$export$76791d55be4d4e28);
$parcel$export(module.exports, "default", () => $0a7fa081a0408a45$export$2e2bcd8739ae039);
/**
 * Copyright 2023 ALPHAGUARD CONSULTING, LLC.  All rights reserved.
 * Use of this source code is governed by a Commercial License Agreement
 * license can be found in the LICENSE file or contact legal@alphaguard.io
 */ 
var $laoDg = parcelRequire("laoDg");

var $1owJc = parcelRequire("1owJc");

var $jgLFK = parcelRequire("jgLFK");
parcelRequire("jDTTg");
const $0a7fa081a0408a45$export$37b96ba04a8c05d1 = "https://mywelcometv.com";
const $0a7fa081a0408a45$export$6a92ee59a864e7f2 = `${$0a7fa081a0408a45$export$37b96ba04a8c05d1}/api`;
const $0a7fa081a0408a45$export$83017b621178cf39 = [
    "Appointments",
    "Branches",
    "ContentLibraryMedia",
    "ContentLibraryText",
    "Displays",
    "DisplayTemplates",
    "Groups",
    "UserContext",
    "Users"
];
const $0a7fa081a0408a45$export$eb7d154cd3559ec7 = (item, iteratee)=>{
    const base = (0, $jgLFK.assign)({
        ...item
    }, (0, $jgLFK.pick)(item, "id"), (0, $jgLFK.get)(item, "attributes"));
    if (iteratee && (0, $jgLFK.isFunction)(iteratee)) iteratee(base);
    if (iteratee && (0, $jgLFK.isObjectLike)(iteratee)) (0, $jgLFK.assign)(base, Object.entries(iteratee).reduce((p, [k, v])=>{
        const id = (0, $jgLFK.get)(base, `${(0, $jgLFK.replace)(iteratee[k], /(.*)\.attributes/, "$1.id")}`);
        const value = (0, $jgLFK.isString)(iteratee[k]) ? (0, $jgLFK.get)(base, iteratee[k], iteratee[k]) : (0, $jgLFK.isFunction)(iteratee[k]) ? (0, $jgLFK.attempt)(iteratee[k], base, base[k]) : iteratee[k];
        if (id && (0, $jgLFK.isObjectLike)(value)) (0, $jgLFK.set)(value, "id", id);
        return {
            ...p,
            [k]: (0, $jgLFK.isError)(value) ? undefined : value
        };
    }, {}));
    return base;
};
const $0a7fa081a0408a45$export$76791d55be4d4e28 = (data, iteratee)=>(0, $jgLFK.get)(data, "length") ? data.map((v)=>$0a7fa081a0408a45$export$eb7d154cd3559ec7(v, iteratee)) : [];
const $0a7fa081a0408a45$export$d4d9575772f13e61 = (0, $laoDg.fetchBaseQuery)({
    baseUrl: $0a7fa081a0408a45$export$6a92ee59a864e7f2,
    prepareHeaders: (headers, api)=>{
        // By default, if we have a token in the store, let's use that for authenticated requests
        // TOOD: we need to change this to use service workers or something else. This is not secure.
        const token = (0, $jgLFK.result)(api, "getState.app.auth.jwt");
        if (token) headers.set("Authorization", `Bearer ${token}`);
        return headers;
    }
});
const $0a7fa081a0408a45$export$bcc8035e549759b4 = (0, $1owJc.createApi)({
    reducerPath: "api",
    tagTypes: $0a7fa081a0408a45$export$83017b621178cf39,
    baseQuery: $0a7fa081a0408a45$export$d4d9575772f13e61,
    endpoints: ()=>({})
});
var $0a7fa081a0408a45$export$2e2bcd8739ae039 = $0a7fa081a0408a45$export$bcc8035e549759b4;

});
parcelRegister("laoDg", function(module, exports) {

$parcel$export(module.exports, "QueryStatus", () => $f68da39ab4625b3c$export$f4258b89f6bad1d6);
$parcel$export(module.exports, "fetchBaseQuery", () => $f68da39ab4625b3c$export$adcf4c6133c49b4e);
$parcel$export(module.exports, "setupListeners", () => $f68da39ab4625b3c$export$120c0dbb0351414c);
$parcel$export(module.exports, "skipToken", () => $f68da39ab4625b3c$export$1aa5a89531b7670d);
$parcel$export(module.exports, "buildCreateApi", () => $f68da39ab4625b3c$export$f957748792d43646);
$parcel$export(module.exports, "coreModule", () => $f68da39ab4625b3c$export$eb718ff92afd6f9b);

var $23PJP = parcelRequire("23PJP");
var $bNLBQ = parcelRequire("bNLBQ");
var $keQ1f = parcelRequire("keQ1f");
var $36fSf = parcelRequire("36fSf");

var $keQ1f = parcelRequire("keQ1f");
parcelRequire("36fSf");
var $iQsan = parcelRequire("iQsan");

var $62jNV = parcelRequire("62jNV");
var $f68da39ab4625b3c$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $f68da39ab4625b3c$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $f68da39ab4625b3c$var$__defProp = Object.defineProperty;
var $f68da39ab4625b3c$var$__defProps = Object.defineProperties;
var $f68da39ab4625b3c$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $f68da39ab4625b3c$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $f68da39ab4625b3c$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $f68da39ab4625b3c$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $f68da39ab4625b3c$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $f68da39ab4625b3c$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $f68da39ab4625b3c$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($f68da39ab4625b3c$var$__hasOwnProp.call(b, prop)) $f68da39ab4625b3c$var$__defNormalProp(a, prop, b[prop]);
    if ($f68da39ab4625b3c$var$__getOwnPropSymbols) for(var _j = 0, _k = $f68da39ab4625b3c$var$__getOwnPropSymbols(b); _j < _k.length; _j++){
        var prop = _k[_j];
        if ($f68da39ab4625b3c$var$__propIsEnum.call(b, prop)) $f68da39ab4625b3c$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $f68da39ab4625b3c$var$__spreadProps = function(a, b) {
    return $f68da39ab4625b3c$var$__defProps(a, $f68da39ab4625b3c$var$__getOwnPropDescs(b));
};
var $f68da39ab4625b3c$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($f68da39ab4625b3c$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $f68da39ab4625b3c$var$__getOwnPropSymbols) for(var _j = 0, _k = $f68da39ab4625b3c$var$__getOwnPropSymbols(source); _j < _k.length; _j++){
        var prop = _k[_j];
        if (exclude.indexOf(prop) < 0 && $f68da39ab4625b3c$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $f68da39ab4625b3c$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
// src/query/core/apiState.ts
var $f68da39ab4625b3c$export$f4258b89f6bad1d6;
(function(QueryStatus2) {
    QueryStatus2["uninitialized"] = "uninitialized";
    QueryStatus2["pending"] = "pending";
    QueryStatus2["fulfilled"] = "fulfilled";
    QueryStatus2["rejected"] = "rejected";
})($f68da39ab4625b3c$export$f4258b89f6bad1d6 || ($f68da39ab4625b3c$export$f4258b89f6bad1d6 = {}));
function $f68da39ab4625b3c$var$getRequestStatusFlags(status) {
    return {
        status: status,
        isUninitialized: status === $f68da39ab4625b3c$export$f4258b89f6bad1d6.uninitialized,
        isLoading: status === $f68da39ab4625b3c$export$f4258b89f6bad1d6.pending,
        isSuccess: status === $f68da39ab4625b3c$export$f4258b89f6bad1d6.fulfilled,
        isError: status === $f68da39ab4625b3c$export$f4258b89f6bad1d6.rejected
    };
}
// src/query/utils/isAbsoluteUrl.ts
function $f68da39ab4625b3c$var$isAbsoluteUrl(url) {
    return new RegExp("(^|:)//").test(url);
}
// src/query/utils/joinUrls.ts
var $f68da39ab4625b3c$var$withoutTrailingSlash = function(url) {
    return url.replace(/\/$/, "");
};
var $f68da39ab4625b3c$var$withoutLeadingSlash = function(url) {
    return url.replace(/^\//, "");
};
function $f68da39ab4625b3c$var$joinUrls(base, url) {
    if (!base) return url;
    if (!url) return base;
    if ($f68da39ab4625b3c$var$isAbsoluteUrl(url)) return url;
    var delimiter = base.endsWith("/") || !url.startsWith("?") ? "/" : "";
    base = $f68da39ab4625b3c$var$withoutTrailingSlash(base);
    url = $f68da39ab4625b3c$var$withoutLeadingSlash(url);
    return "" + base + delimiter + url;
}
// src/query/utils/flatten.ts
var $f68da39ab4625b3c$var$flatten = function(arr) {
    return [].concat.apply([], arr);
};
// src/query/utils/isOnline.ts
function $f68da39ab4625b3c$var$isOnline() {
    return typeof navigator === "undefined" ? true : navigator.onLine === void 0 ? true : navigator.onLine;
}
// src/query/utils/isDocumentVisible.ts
function $f68da39ab4625b3c$var$isDocumentVisible() {
    if (typeof document === "undefined") return true;
    return document.visibilityState !== "hidden";
}
var $f68da39ab4625b3c$var$isPlainObject = (0, $bNLBQ.isPlainObject);
function $f68da39ab4625b3c$export$b64d4502a1c929bd(oldObj, newObj) {
    if (oldObj === newObj || !($f68da39ab4625b3c$var$isPlainObject(oldObj) && $f68da39ab4625b3c$var$isPlainObject(newObj) || Array.isArray(oldObj) && Array.isArray(newObj))) return newObj;
    var newKeys = Object.keys(newObj);
    var oldKeys = Object.keys(oldObj);
    var isSameObject = newKeys.length === oldKeys.length;
    var mergeObj = Array.isArray(newObj) ? [] : {};
    for(var _j = 0, newKeys_1 = newKeys; _j < newKeys_1.length; _j++){
        var key = newKeys_1[_j];
        mergeObj[key] = $f68da39ab4625b3c$export$b64d4502a1c929bd(oldObj[key], newObj[key]);
        if (isSameObject) isSameObject = oldObj[key] === mergeObj[key];
    }
    return isSameObject ? oldObj : mergeObj;
}
var $f68da39ab4625b3c$var$defaultFetchFn = function() {
    var args = [];
    for(var _j = 0; _j < arguments.length; _j++)args[_j] = arguments[_j];
    return fetch.apply(void 0, args);
};
var $f68da39ab4625b3c$var$defaultValidateStatus = function(response) {
    return response.status >= 200 && response.status <= 299;
};
var $f68da39ab4625b3c$var$defaultIsJsonContentType = function(headers) {
    return /ion\/(vnd\.api\+)?json/.test(headers.get("content-type") || "");
};
function $f68da39ab4625b3c$var$stripUndefined(obj) {
    if (!(0, $bNLBQ.isPlainObject)(obj)) return obj;
    var copy = $f68da39ab4625b3c$var$__spreadValues({}, obj);
    for(var _j = 0, _k = Object.entries(copy); _j < _k.length; _j++){
        var _l = _k[_j], k = _l[0], v = _l[1];
        if (v === void 0) delete copy[k];
    }
    return copy;
}
function $f68da39ab4625b3c$export$adcf4c6133c49b4e(_a) {
    var _this = this;
    if (_a === void 0) _a = {};
    var _b = _a, baseUrl = _b.baseUrl, _j = _b.prepareHeaders, prepareHeaders = _j === void 0 ? function(x) {
        return x;
    } : _j, _k = _b.fetchFn, fetchFn = _k === void 0 ? $f68da39ab4625b3c$var$defaultFetchFn : _k, paramsSerializer = _b.paramsSerializer, _l = _b.isJsonContentType, isJsonContentType = _l === void 0 ? $f68da39ab4625b3c$var$defaultIsJsonContentType : _l, _m = _b.jsonContentType, jsonContentType = _m === void 0 ? "application/json" : _m, jsonReplacer = _b.jsonReplacer, defaultTimeout = _b.timeout, globalResponseHandler = _b.responseHandler, globalValidateStatus = _b.validateStatus, baseFetchOptions = $f68da39ab4625b3c$var$__objRest(_b, [
        "baseUrl",
        "prepareHeaders",
        "fetchFn",
        "paramsSerializer",
        "isJsonContentType",
        "jsonContentType",
        "jsonReplacer",
        "timeout",
        "responseHandler",
        "validateStatus"
    ]);
    if (typeof fetch === "undefined" && fetchFn === $f68da39ab4625b3c$var$defaultFetchFn) console.warn("Warning: `fetch` is not available. Please supply a custom `fetchFn` property to use `fetchBaseQuery` on SSR environments.");
    return function(arg, api) {
        return $f68da39ab4625b3c$var$__async(_this, null, function() {
            var signal, getState, extra, endpoint, forced, type, meta, _a2, url, _j, headers, _k, params, _l, responseHandler, _m, validateStatus, _o, timeout, rest, config, _p, isJsonifiable, divider, query, request, requestClone, response, timedOut, timeoutId, e_1, responseClone, resultData, responseText, handleResponseError_1, e_2;
            return $f68da39ab4625b3c$var$__generator(this, function(_q) {
                switch(_q.label){
                    case 0:
                        signal = api.signal, getState = api.getState, extra = api.extra, endpoint = api.endpoint, forced = api.forced, type = api.type;
                        _a2 = typeof arg == "string" ? {
                            url: arg
                        } : arg, url = _a2.url, _j = _a2.headers, headers = _j === void 0 ? new Headers(baseFetchOptions.headers) : _j, _k = _a2.params, params = _k === void 0 ? void 0 : _k, _l = _a2.responseHandler, responseHandler = _l === void 0 ? globalResponseHandler != null ? globalResponseHandler : "json" : _l, _m = _a2.validateStatus, validateStatus = _m === void 0 ? globalValidateStatus != null ? globalValidateStatus : $f68da39ab4625b3c$var$defaultValidateStatus : _m, _o = _a2.timeout, timeout = _o === void 0 ? defaultTimeout : _o, rest = $f68da39ab4625b3c$var$__objRest(_a2, [
                            "url",
                            "headers",
                            "params",
                            "responseHandler",
                            "validateStatus",
                            "timeout"
                        ]);
                        config = $f68da39ab4625b3c$var$__spreadValues($f68da39ab4625b3c$var$__spreadProps($f68da39ab4625b3c$var$__spreadValues({}, baseFetchOptions), {
                            signal: signal
                        }), rest);
                        headers = new Headers($f68da39ab4625b3c$var$stripUndefined(headers));
                        _p = config;
                        return [
                            4 /*yield*/ ,
                            prepareHeaders(headers, {
                                getState: getState,
                                extra: extra,
                                endpoint: endpoint,
                                forced: forced,
                                type: type
                            })
                        ];
                    case 1:
                        _p.headers = _q.sent() || headers;
                        isJsonifiable = function(body) {
                            return typeof body === "object" && ((0, $bNLBQ.isPlainObject)(body) || Array.isArray(body) || typeof body.toJSON === "function");
                        };
                        if (!config.headers.has("content-type") && isJsonifiable(config.body)) config.headers.set("content-type", jsonContentType);
                        if (isJsonifiable(config.body) && isJsonContentType(config.headers)) config.body = JSON.stringify(config.body, jsonReplacer);
                        if (params) {
                            divider = ~url.indexOf("?") ? "&" : "?";
                            query = paramsSerializer ? paramsSerializer(params) : new URLSearchParams($f68da39ab4625b3c$var$stripUndefined(params));
                            url += divider + query;
                        }
                        url = $f68da39ab4625b3c$var$joinUrls(baseUrl, url);
                        request = new Request(url, config);
                        requestClone = new Request(url, config);
                        meta = {
                            request: requestClone
                        };
                        timedOut = false, timeoutId = timeout && setTimeout(function() {
                            timedOut = true;
                            api.abort();
                        }, timeout);
                        _q.label = 2;
                    case 2:
                        _q.trys.push([
                            2,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            fetchFn(request)
                        ];
                    case 3:
                        response = _q.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        e_1 = _q.sent();
                        return [
                            2 /*return*/ ,
                            {
                                error: {
                                    status: timedOut ? "TIMEOUT_ERROR" : "FETCH_ERROR",
                                    error: String(e_1)
                                },
                                meta: meta
                            }
                        ];
                    case 5:
                        if (timeoutId) clearTimeout(timeoutId);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        responseClone = response.clone();
                        meta.response = responseClone;
                        responseText = "";
                        _q.label = 7;
                    case 7:
                        _q.trys.push([
                            7,
                            9,
                            ,
                            10
                        ]);
                        return [
                            4 /*yield*/ ,
                            Promise.all([
                                handleResponse(response, responseHandler).then(function(r) {
                                    return resultData = r;
                                }, function(e) {
                                    return handleResponseError_1 = e;
                                }),
                                responseClone.text().then(function(r) {
                                    return responseText = r;
                                }, function() {})
                            ])
                        ];
                    case 8:
                        _q.sent();
                        if (handleResponseError_1) throw handleResponseError_1;
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        e_2 = _q.sent();
                        return [
                            2 /*return*/ ,
                            {
                                error: {
                                    status: "PARSING_ERROR",
                                    originalStatus: response.status,
                                    data: responseText,
                                    error: String(e_2)
                                },
                                meta: meta
                            }
                        ];
                    case 10:
                        return [
                            2 /*return*/ ,
                            validateStatus(response, resultData) ? {
                                data: resultData,
                                meta: meta
                            } : {
                                error: {
                                    status: response.status,
                                    data: resultData
                                },
                                meta: meta
                            }
                        ];
                }
            });
        });
    };
    function handleResponse(response, responseHandler) {
        return $f68da39ab4625b3c$var$__async(this, null, function() {
            var text;
            return $f68da39ab4625b3c$var$__generator(this, function(_j) {
                switch(_j.label){
                    case 0:
                        if (typeof responseHandler === "function") return [
                            2 /*return*/ ,
                            responseHandler(response)
                        ];
                        if (responseHandler === "content-type") responseHandler = isJsonContentType(response.headers) ? "json" : "text";
                        if (!(responseHandler === "json")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            response.text()
                        ];
                    case 1:
                        text = _j.sent();
                        return [
                            2 /*return*/ ,
                            text.length ? JSON.parse(text) : null
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            response.text()
                        ];
                }
            });
        });
    }
}
// src/query/HandledError.ts
var $f68da39ab4625b3c$var$HandledError = /** @class */ function() {
    function HandledError(value, meta) {
        if (meta === void 0) meta = void 0;
        this.value = value;
        this.meta = meta;
    }
    return HandledError;
}();
// src/query/retry.ts
function $f68da39ab4625b3c$var$defaultBackoff(attempt, maxRetries) {
    if (attempt === void 0) attempt = 0;
    if (maxRetries === void 0) maxRetries = 5;
    return $f68da39ab4625b3c$var$__async(this, null, function() {
        var attempts, timeout;
        return $f68da39ab4625b3c$var$__generator(this, function(_j) {
            switch(_j.label){
                case 0:
                    attempts = Math.min(attempt, maxRetries);
                    timeout = ~~((Math.random() + 0.4) * (300 << attempts));
                    return [
                        4 /*yield*/ ,
                        new Promise(function(resolve) {
                            return setTimeout(function(res) {
                                return resolve(res);
                            }, timeout);
                        })
                    ];
                case 1:
                    _j.sent();
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $f68da39ab4625b3c$var$fail(e) {
    throw Object.assign(new $f68da39ab4625b3c$var$HandledError({
        error: e
    }), {
        throwImmediately: true
    });
}
var $f68da39ab4625b3c$var$EMPTY_OPTIONS = {};
var $f68da39ab4625b3c$var$retryWithBackoff = function(baseQuery, defaultOptions) {
    return function(args, api, extraOptions) {
        return $f68da39ab4625b3c$var$__async(void 0, null, function() {
            var possibleMaxRetries, maxRetries, defaultRetryCondition, options, retry2, result, e_3;
            return $f68da39ab4625b3c$var$__generator(this, function(_j) {
                switch(_j.label){
                    case 0:
                        possibleMaxRetries = [
                            5,
                            (defaultOptions || $f68da39ab4625b3c$var$EMPTY_OPTIONS).maxRetries,
                            (extraOptions || $f68da39ab4625b3c$var$EMPTY_OPTIONS).maxRetries
                        ].filter(function(x) {
                            return x !== void 0;
                        });
                        maxRetries = possibleMaxRetries.slice(-1)[0];
                        defaultRetryCondition = function(_, __, _j) {
                            var attempt = _j.attempt;
                            return attempt <= maxRetries;
                        };
                        options = $f68da39ab4625b3c$var$__spreadValues($f68da39ab4625b3c$var$__spreadValues({
                            maxRetries: maxRetries,
                            backoff: $f68da39ab4625b3c$var$defaultBackoff,
                            retryCondition: defaultRetryCondition
                        }, defaultOptions), extraOptions);
                        retry2 = 0;
                        _j.label = 1;
                    case 1:
                        _j.label = 2;
                    case 2:
                        _j.trys.push([
                            2,
                            4,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            baseQuery(args, api, extraOptions)
                        ];
                    case 3:
                        result = _j.sent();
                        if (result.error) throw new $f68da39ab4625b3c$var$HandledError(result);
                        return [
                            2 /*return*/ ,
                            result
                        ];
                    case 4:
                        e_3 = _j.sent();
                        retry2++;
                        if (e_3.throwImmediately) {
                            if (e_3 instanceof $f68da39ab4625b3c$var$HandledError) return [
                                2 /*return*/ ,
                                e_3.value
                            ];
                            throw e_3;
                        }
                        if (e_3 instanceof $f68da39ab4625b3c$var$HandledError && !options.retryCondition(e_3.value.error, args, {
                            attempt: retry2,
                            baseQueryApi: api,
                            extraOptions: extraOptions
                        })) return [
                            2 /*return*/ ,
                            e_3.value
                        ];
                        return [
                            4 /*yield*/ ,
                            options.backoff(retry2, options.maxRetries)
                        ];
                    case 5:
                        _j.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
};
var $f68da39ab4625b3c$export$9369b12211e1fce4 = /* @__PURE__ */ Object.assign($f68da39ab4625b3c$var$retryWithBackoff, {
    fail: $f68da39ab4625b3c$var$fail
});
var $f68da39ab4625b3c$var$onFocus = /* @__PURE__ */ (0, $bNLBQ.createAction)("__rtkq/focused");
var $f68da39ab4625b3c$var$onFocusLost = /* @__PURE__ */ (0, $bNLBQ.createAction)("__rtkq/unfocused");
var $f68da39ab4625b3c$var$onOnline = /* @__PURE__ */ (0, $bNLBQ.createAction)("__rtkq/online");
var $f68da39ab4625b3c$var$onOffline = /* @__PURE__ */ (0, $bNLBQ.createAction)("__rtkq/offline");
var $f68da39ab4625b3c$var$initialized = false;
function $f68da39ab4625b3c$export$120c0dbb0351414c(dispatch, customHandler) {
    function defaultHandler() {
        var handleFocus = function() {
            return dispatch($f68da39ab4625b3c$var$onFocus());
        };
        var handleFocusLost = function() {
            return dispatch($f68da39ab4625b3c$var$onFocusLost());
        };
        var handleOnline = function() {
            return dispatch($f68da39ab4625b3c$var$onOnline());
        };
        var handleOffline = function() {
            return dispatch($f68da39ab4625b3c$var$onOffline());
        };
        var handleVisibilityChange = function() {
            if (window.document.visibilityState === "visible") handleFocus();
            else handleFocusLost();
        };
        if (!$f68da39ab4625b3c$var$initialized) {
            if (typeof window !== "undefined" && window.addEventListener) {
                window.addEventListener("visibilitychange", handleVisibilityChange, false);
                window.addEventListener("focus", handleFocus, false);
                window.addEventListener("online", handleOnline, false);
                window.addEventListener("offline", handleOffline, false);
                $f68da39ab4625b3c$var$initialized = true;
            }
        }
        var unsubscribe = function() {
            window.removeEventListener("focus", handleFocus);
            window.removeEventListener("visibilitychange", handleVisibilityChange);
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
            $f68da39ab4625b3c$var$initialized = false;
        };
        return unsubscribe;
    }
    return customHandler ? customHandler(dispatch, {
        onFocus: $f68da39ab4625b3c$var$onFocus,
        onFocusLost: $f68da39ab4625b3c$var$onFocusLost,
        onOffline: $f68da39ab4625b3c$var$onOffline,
        onOnline: $f68da39ab4625b3c$var$onOnline
    }) : defaultHandler();
}
// src/query/endpointDefinitions.ts
var $f68da39ab4625b3c$var$DefinitionType;
(function(DefinitionType2) {
    DefinitionType2["query"] = "query";
    DefinitionType2["mutation"] = "mutation";
})($f68da39ab4625b3c$var$DefinitionType || ($f68da39ab4625b3c$var$DefinitionType = {}));
function $f68da39ab4625b3c$var$isQueryDefinition(e) {
    return e.type === $f68da39ab4625b3c$var$DefinitionType.query;
}
function $f68da39ab4625b3c$var$isMutationDefinition(e) {
    return e.type === $f68da39ab4625b3c$var$DefinitionType.mutation;
}
function $f68da39ab4625b3c$var$calculateProvidedBy(description, result, error, queryArg, meta, assertTagTypes) {
    if ($f68da39ab4625b3c$var$isFunction(description)) return description(result, error, queryArg, meta).map($f68da39ab4625b3c$var$expandTagDescription).map(assertTagTypes);
    if (Array.isArray(description)) return description.map($f68da39ab4625b3c$var$expandTagDescription).map(assertTagTypes);
    return [];
}
function $f68da39ab4625b3c$var$isFunction(t) {
    return typeof t === "function";
}
function $f68da39ab4625b3c$var$expandTagDescription(description) {
    return typeof description === "string" ? {
        type: description
    } : description;
}
// src/query/utils/isNotNullish.ts
function $f68da39ab4625b3c$var$isNotNullish(v) {
    return v != null;
}
// src/query/core/buildInitiate.ts
var $f68da39ab4625b3c$var$forceQueryFnSymbol = Symbol("forceQueryFn");
var $f68da39ab4625b3c$var$isUpsertQuery = function(arg) {
    return typeof arg[$f68da39ab4625b3c$var$forceQueryFnSymbol] === "function";
};
function $f68da39ab4625b3c$var$buildInitiate(_j) {
    var serializeQueryArgs = _j.serializeQueryArgs, queryThunk = _j.queryThunk, mutationThunk = _j.mutationThunk, api = _j.api, context = _j.context;
    var runningQueries = new Map();
    var runningMutations = new Map();
    var _k = api.internalActions, unsubscribeQueryResult = _k.unsubscribeQueryResult, removeMutationResult = _k.removeMutationResult, updateSubscriptionOptions = _k.updateSubscriptionOptions;
    return {
        buildInitiateQuery: buildInitiateQuery,
        buildInitiateMutation: buildInitiateMutation,
        getRunningQueryThunk: getRunningQueryThunk,
        getRunningMutationThunk: getRunningMutationThunk,
        getRunningQueriesThunk: getRunningQueriesThunk,
        getRunningMutationsThunk: getRunningMutationsThunk,
        getRunningOperationPromises: getRunningOperationPromises,
        removalWarning: removalWarning
    };
    function removalWarning() {
        throw new Error("This method had to be removed due to a conceptual bug in RTK.\n       Please see https://github.com/reduxjs/redux-toolkit/pull/2481 for details.\n       See https://redux-toolkit.js.org/rtk-query/usage/server-side-rendering for new guidance on SSR.");
    }
    function getRunningOperationPromises() {
        typeof $62jNV;
        var extract = function(v) {
            return Array.from(v.values()).flatMap(function(queriesForStore) {
                return queriesForStore ? Object.values(queriesForStore) : [];
            });
        };
        return $f68da39ab4625b3c$var$__spreadArray($f68da39ab4625b3c$var$__spreadArray([], extract(runningQueries)), extract(runningMutations)).filter($f68da39ab4625b3c$var$isNotNullish);
    }
    function getRunningQueryThunk(endpointName, queryArgs) {
        return function(dispatch) {
            var _a;
            var endpointDefinition = context.endpointDefinitions[endpointName];
            var queryCacheKey = serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            });
            return (_a = runningQueries.get(dispatch)) == null ? void 0 : _a[queryCacheKey];
        };
    }
    function getRunningMutationThunk(_endpointName, fixedCacheKeyOrRequestId) {
        return function(dispatch) {
            var _a;
            return (_a = runningMutations.get(dispatch)) == null ? void 0 : _a[fixedCacheKeyOrRequestId];
        };
    }
    function getRunningQueriesThunk() {
        return function(dispatch) {
            return Object.values(runningQueries.get(dispatch) || {}).filter($f68da39ab4625b3c$var$isNotNullish);
        };
    }
    function getRunningMutationsThunk() {
        return function(dispatch) {
            return Object.values(runningMutations.get(dispatch) || {}).filter($f68da39ab4625b3c$var$isNotNullish);
        };
    }
    function middlewareWarning(dispatch) {
        var registered;
    }
    function buildInitiateQuery(endpointName, endpointDefinition) {
        var queryAction = function(arg, _j) {
            var _k = _j === void 0 ? {} : _j, _l = _k.subscribe, subscribe = _l === void 0 ? true : _l, forceRefetch = _k.forceRefetch, subscriptionOptions = _k.subscriptionOptions, _m = $f68da39ab4625b3c$var$forceQueryFnSymbol, forceQueryFn = _k[_m];
            return function(dispatch, getState) {
                var _j;
                var _a;
                var queryCacheKey = serializeQueryArgs({
                    queryArgs: arg,
                    endpointDefinition: endpointDefinition,
                    endpointName: endpointName
                });
                var thunk = queryThunk((_j = {
                    type: "query",
                    subscribe: subscribe,
                    forceRefetch: forceRefetch,
                    subscriptionOptions: subscriptionOptions,
                    endpointName: endpointName,
                    originalArgs: arg,
                    queryCacheKey: queryCacheKey
                }, _j[$f68da39ab4625b3c$var$forceQueryFnSymbol] = forceQueryFn, _j));
                var selector = api.endpoints[endpointName].select(arg);
                var thunkResult = dispatch(thunk);
                var stateAfter = selector(getState());
                middlewareWarning(dispatch);
                var requestId = thunkResult.requestId, abort = thunkResult.abort;
                var skippedSynchronously = stateAfter.requestId !== requestId;
                var runningQuery = (_a = runningQueries.get(dispatch)) == null ? void 0 : _a[queryCacheKey];
                var selectFromState = function() {
                    return selector(getState());
                };
                var statePromise = Object.assign(forceQueryFn ? thunkResult.then(selectFromState) : skippedSynchronously && !runningQuery ? Promise.resolve(stateAfter) : Promise.all([
                    runningQuery,
                    thunkResult
                ]).then(selectFromState), {
                    arg: arg,
                    requestId: requestId,
                    subscriptionOptions: subscriptionOptions,
                    queryCacheKey: queryCacheKey,
                    abort: abort,
                    unwrap: function() {
                        return $f68da39ab4625b3c$var$__async(this, null, function() {
                            var result;
                            return $f68da39ab4625b3c$var$__generator(this, function(_j) {
                                switch(_j.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            statePromise
                                        ];
                                    case 1:
                                        result = _j.sent();
                                        if (result.isError) throw result.error;
                                        return [
                                            2 /*return*/ ,
                                            result.data
                                        ];
                                }
                            });
                        });
                    },
                    refetch: function() {
                        return dispatch(queryAction(arg, {
                            subscribe: false,
                            forceRefetch: true
                        }));
                    },
                    unsubscribe: function() {
                        if (subscribe) dispatch(unsubscribeQueryResult({
                            queryCacheKey: queryCacheKey,
                            requestId: requestId
                        }));
                    },
                    updateSubscriptionOptions: function(options) {
                        statePromise.subscriptionOptions = options;
                        dispatch(updateSubscriptionOptions({
                            endpointName: endpointName,
                            requestId: requestId,
                            queryCacheKey: queryCacheKey,
                            options: options
                        }));
                    }
                });
                if (!runningQuery && !skippedSynchronously && !forceQueryFn) {
                    var running_1 = runningQueries.get(dispatch) || {};
                    running_1[queryCacheKey] = statePromise;
                    runningQueries.set(dispatch, running_1);
                    statePromise.then(function() {
                        delete running_1[queryCacheKey];
                        if (!Object.keys(running_1).length) runningQueries.delete(dispatch);
                    });
                }
                return statePromise;
            };
        };
        return queryAction;
    }
    function buildInitiateMutation(endpointName) {
        return function(arg, _j) {
            var _k = _j === void 0 ? {} : _j, _l = _k.track, track = _l === void 0 ? true : _l, fixedCacheKey = _k.fixedCacheKey;
            return function(dispatch, getState) {
                var thunk = mutationThunk({
                    type: "mutation",
                    endpointName: endpointName,
                    originalArgs: arg,
                    track: track,
                    fixedCacheKey: fixedCacheKey
                });
                var thunkResult = dispatch(thunk);
                middlewareWarning(dispatch);
                var requestId = thunkResult.requestId, abort = thunkResult.abort, unwrap = thunkResult.unwrap;
                var returnValuePromise = thunkResult.unwrap().then(function(data) {
                    return {
                        data: data
                    };
                }).catch(function(error) {
                    return {
                        error: error
                    };
                });
                var reset = function() {
                    dispatch(removeMutationResult({
                        requestId: requestId,
                        fixedCacheKey: fixedCacheKey
                    }));
                };
                var ret = Object.assign(returnValuePromise, {
                    arg: thunkResult.arg,
                    requestId: requestId,
                    abort: abort,
                    unwrap: unwrap,
                    unsubscribe: reset,
                    reset: reset
                });
                var running = runningMutations.get(dispatch) || {};
                runningMutations.set(dispatch, running);
                running[requestId] = ret;
                ret.then(function() {
                    delete running[requestId];
                    if (!Object.keys(running).length) runningMutations.delete(dispatch);
                });
                if (fixedCacheKey) {
                    running[fixedCacheKey] = ret;
                    ret.then(function() {
                        if (running[fixedCacheKey] === ret) {
                            delete running[fixedCacheKey];
                            if (!Object.keys(running).length) runningMutations.delete(dispatch);
                        }
                    });
                }
                return ret;
            };
        };
    }
}
function $f68da39ab4625b3c$var$defaultTransformResponse(baseQueryReturnValue) {
    return baseQueryReturnValue;
}
function $f68da39ab4625b3c$var$buildThunks(_j) {
    var _this = this;
    var reducerPath = _j.reducerPath, baseQuery = _j.baseQuery, endpointDefinitions = _j.context.endpointDefinitions, serializeQueryArgs = _j.serializeQueryArgs, api = _j.api, assertTagType = _j.assertTagType;
    var patchQueryData = function(endpointName, args, patches, updateProvided) {
        return function(dispatch, getState) {
            var endpointDefinition = endpointDefinitions[endpointName];
            var queryCacheKey = serializeQueryArgs({
                queryArgs: args,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            });
            dispatch(api.internalActions.queryResultPatched({
                queryCacheKey: queryCacheKey,
                patches: patches
            }));
            if (!updateProvided) return;
            var newValue = api.endpoints[endpointName].select(args)(getState());
            var providedTags = $f68da39ab4625b3c$var$calculateProvidedBy(endpointDefinition.providesTags, newValue.data, void 0, args, {}, assertTagType);
            dispatch(api.internalActions.updateProvidedBy({
                queryCacheKey: queryCacheKey,
                providedTags: providedTags
            }));
        };
    };
    var updateQueryData = function(endpointName, args, updateRecipe, updateProvided) {
        if (updateProvided === void 0) updateProvided = true;
        return function(dispatch, getState) {
            var _j, _k;
            var endpointDefinition = api.endpoints[endpointName];
            var currentState = endpointDefinition.select(args)(getState());
            var ret = {
                patches: [],
                inversePatches: [],
                undo: function() {
                    return dispatch(api.util.patchQueryData(endpointName, args, ret.inversePatches, updateProvided));
                }
            };
            if (currentState.status === $f68da39ab4625b3c$export$f4258b89f6bad1d6.uninitialized) return ret;
            var newValue;
            if ("data" in currentState) {
                if ((0, $keQ1f.isDraftable)(currentState.data)) {
                    var _l = (0, $keQ1f.produceWithPatches)(currentState.data, updateRecipe), value = _l[0], patches = _l[1], inversePatches = _l[2];
                    (_j = ret.patches).push.apply(_j, patches);
                    (_k = ret.inversePatches).push.apply(_k, inversePatches);
                    newValue = value;
                } else {
                    newValue = updateRecipe(currentState.data);
                    ret.patches.push({
                        op: "replace",
                        path: [],
                        value: newValue
                    });
                    ret.inversePatches.push({
                        op: "replace",
                        path: [],
                        value: currentState.data
                    });
                }
            }
            dispatch(api.util.patchQueryData(endpointName, args, ret.patches, updateProvided));
            return ret;
        };
    };
    var upsertQueryData = function(endpointName, args, value) {
        return function(dispatch) {
            var _j;
            return dispatch(api.endpoints[endpointName].initiate(args, (_j = {
                subscribe: false,
                forceRefetch: true
            }, _j[$f68da39ab4625b3c$var$forceQueryFnSymbol] = function() {
                return {
                    data: value
                };
            }, _j)));
        };
    };
    var executeEndpoint = function(_0, _1) {
        return $f68da39ab4625b3c$var$__async(_this, [
            _0,
            _1
        ], function(arg, _j) {
            var endpointDefinition, transformResponse, result, baseQueryApi_1, forceQueryFn, what, err, _k, _l, key, _m, error_1, catchedError, transformErrorResponse, _o, e_4;
            var _p, _q;
            var signal = _j.signal, abort = _j.abort, rejectWithValue = _j.rejectWithValue, fulfillWithValue = _j.fulfillWithValue, dispatch = _j.dispatch, getState = _j.getState, extra = _j.extra;
            return $f68da39ab4625b3c$var$__generator(this, function(_r) {
                switch(_r.label){
                    case 0:
                        endpointDefinition = endpointDefinitions[arg.endpointName];
                        _r.label = 1;
                    case 1:
                        _r.trys.push([
                            1,
                            8,
                            ,
                            13
                        ]);
                        transformResponse = $f68da39ab4625b3c$var$defaultTransformResponse;
                        result = void 0;
                        baseQueryApi_1 = {
                            signal: signal,
                            abort: abort,
                            dispatch: dispatch,
                            getState: getState,
                            extra: extra,
                            endpoint: arg.endpointName,
                            type: arg.type,
                            forced: arg.type === "query" ? isForcedQuery(arg, getState()) : void 0
                        };
                        forceQueryFn = arg.type === "query" ? arg[$f68da39ab4625b3c$var$forceQueryFnSymbol] : void 0;
                        if (!forceQueryFn) return [
                            3 /*break*/ ,
                            2
                        ];
                        result = forceQueryFn();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 2:
                        if (!endpointDefinition.query) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            baseQuery(endpointDefinition.query(arg.originalArgs), baseQueryApi_1, endpointDefinition.extraOptions)
                        ];
                    case 3:
                        result = _r.sent();
                        if (endpointDefinition.transformResponse) transformResponse = endpointDefinition.transformResponse;
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            endpointDefinition.queryFn(arg.originalArgs, baseQueryApi_1, endpointDefinition.extraOptions, function(arg2) {
                                return baseQuery(arg2, baseQueryApi_1, endpointDefinition.extraOptions);
                            })
                        ];
                    case 5:
                        result = _r.sent();
                        _r.label = 6;
                    case 6:
                        typeof $62jNV;
                        if (result.error) throw new $f68da39ab4625b3c$var$HandledError(result.error, result.meta);
                        _m = fulfillWithValue;
                        return [
                            4 /*yield*/ ,
                            transformResponse(result.data, result.meta, arg.originalArgs)
                        ];
                    case 7:
                        return [
                            2 /*return*/ ,
                            _m.apply(void 0, [
                                _r.sent(),
                                (_p = {
                                    fulfilledTimeStamp: Date.now(),
                                    baseQueryMeta: result.meta
                                }, _p[0, $bNLBQ.SHOULD_AUTOBATCH] = true, _p)
                            ])
                        ];
                    case 8:
                        error_1 = _r.sent();
                        catchedError = error_1;
                        if (!(catchedError instanceof $f68da39ab4625b3c$var$HandledError)) return [
                            3 /*break*/ ,
                            12
                        ];
                        transformErrorResponse = $f68da39ab4625b3c$var$defaultTransformResponse;
                        if (endpointDefinition.query && endpointDefinition.transformErrorResponse) transformErrorResponse = endpointDefinition.transformErrorResponse;
                        _r.label = 9;
                    case 9:
                        _r.trys.push([
                            9,
                            11,
                            ,
                            12
                        ]);
                        _o = rejectWithValue;
                        return [
                            4 /*yield*/ ,
                            transformErrorResponse(catchedError.value, catchedError.meta, arg.originalArgs)
                        ];
                    case 10:
                        return [
                            2 /*return*/ ,
                            _o.apply(void 0, [
                                _r.sent(),
                                (_q = {
                                    baseQueryMeta: catchedError.meta
                                }, _q[0, $bNLBQ.SHOULD_AUTOBATCH] = true, _q)
                            ])
                        ];
                    case 11:
                        e_4 = _r.sent();
                        catchedError = e_4;
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 12:
                        typeof $62jNV;
                        console.error(catchedError);
                        throw catchedError;
                    case 13:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    function isForcedQuery(arg, state) {
        var _a, _b, _c, _d;
        var requestState = (_b = (_a = state[reducerPath]) == null ? void 0 : _a.queries) == null ? void 0 : _b[arg.queryCacheKey];
        var baseFetchOnMountOrArgChange = (_c = state[reducerPath]) == null ? void 0 : _c.config.refetchOnMountOrArgChange;
        var fulfilledVal = requestState == null ? void 0 : requestState.fulfilledTimeStamp;
        var refetchVal = (_d = arg.forceRefetch) != null ? _d : arg.subscribe && baseFetchOnMountOrArgChange;
        if (refetchVal) return refetchVal === true || (Number(new Date()) - Number(fulfilledVal)) / 1e3 >= refetchVal;
        return false;
    }
    var queryThunk = (0, $bNLBQ.createAsyncThunk)(reducerPath + "/executeQuery", executeEndpoint, {
        getPendingMeta: function() {
            var _j;
            return _j = {
                startedTimeStamp: Date.now()
            }, _j[0, $bNLBQ.SHOULD_AUTOBATCH] = true, _j;
        },
        condition: function(queryThunkArgs, _j) {
            var getState = _j.getState;
            var _a, _b, _c;
            var state = getState();
            var requestState = (_b = (_a = state[reducerPath]) == null ? void 0 : _a.queries) == null ? void 0 : _b[queryThunkArgs.queryCacheKey];
            var fulfilledVal = requestState == null ? void 0 : requestState.fulfilledTimeStamp;
            var currentArg = queryThunkArgs.originalArgs;
            var previousArg = requestState == null ? void 0 : requestState.originalArgs;
            var endpointDefinition = endpointDefinitions[queryThunkArgs.endpointName];
            if ($f68da39ab4625b3c$var$isUpsertQuery(queryThunkArgs)) return true;
            if ((requestState == null ? void 0 : requestState.status) === "pending") return false;
            if (isForcedQuery(queryThunkArgs, state)) return true;
            if ($f68da39ab4625b3c$var$isQueryDefinition(endpointDefinition) && ((_c = endpointDefinition == null ? void 0 : endpointDefinition.forceRefetch) == null ? void 0 : _c.call(endpointDefinition, {
                currentArg: currentArg,
                previousArg: previousArg,
                endpointState: requestState,
                state: state
            }))) return true;
            if (fulfilledVal) return false;
            return true;
        },
        dispatchConditionRejection: true
    });
    var mutationThunk = (0, $bNLBQ.createAsyncThunk)(reducerPath + "/executeMutation", executeEndpoint, {
        getPendingMeta: function() {
            var _j;
            return _j = {
                startedTimeStamp: Date.now()
            }, _j[0, $bNLBQ.SHOULD_AUTOBATCH] = true, _j;
        }
    });
    var hasTheForce = function(options) {
        return "force" in options;
    };
    var hasMaxAge = function(options) {
        return "ifOlderThan" in options;
    };
    var prefetch = function(endpointName, arg, options) {
        return function(dispatch, getState) {
            var force = hasTheForce(options) && options.force;
            var maxAge = hasMaxAge(options) && options.ifOlderThan;
            var queryAction = function(force2) {
                if (force2 === void 0) force2 = true;
                return api.endpoints[endpointName].initiate(arg, {
                    forceRefetch: force2
                });
            };
            var latestStateValue = api.endpoints[endpointName].select(arg)(getState());
            if (force) dispatch(queryAction());
            else if (maxAge) {
                var lastFulfilledTs = latestStateValue == null ? void 0 : latestStateValue.fulfilledTimeStamp;
                if (!lastFulfilledTs) {
                    dispatch(queryAction());
                    return;
                }
                var shouldRetrigger = (Number(new Date()) - Number(new Date(lastFulfilledTs))) / 1e3 >= maxAge;
                if (shouldRetrigger) dispatch(queryAction());
            } else dispatch(queryAction(false));
        };
    };
    function matchesEndpoint(endpointName) {
        return function(action) {
            var _a, _b;
            return ((_b = (_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.arg) == null ? void 0 : _b.endpointName) === endpointName;
        };
    }
    function buildMatchThunkActions(thunk, endpointName) {
        return {
            matchPending: (0, $bNLBQ.isAllOf)((0, $bNLBQ.isPending)(thunk), matchesEndpoint(endpointName)),
            matchFulfilled: (0, $bNLBQ.isAllOf)((0, $bNLBQ.isFulfilled)(thunk), matchesEndpoint(endpointName)),
            matchRejected: (0, $bNLBQ.isAllOf)((0, $bNLBQ.isRejected)(thunk), matchesEndpoint(endpointName))
        };
    }
    return {
        queryThunk: queryThunk,
        mutationThunk: mutationThunk,
        prefetch: prefetch,
        updateQueryData: updateQueryData,
        upsertQueryData: upsertQueryData,
        patchQueryData: patchQueryData,
        buildMatchThunkActions: buildMatchThunkActions
    };
}
function $f68da39ab4625b3c$var$calculateProvidedByThunk(action, type, endpointDefinitions, assertTagType) {
    return $f68da39ab4625b3c$var$calculateProvidedBy(endpointDefinitions[action.meta.arg.endpointName][type], (0, $bNLBQ.isFulfilled)(action) ? action.payload : void 0, (0, $bNLBQ.isRejectedWithValue)(action) ? action.payload : void 0, action.meta.arg.originalArgs, "baseQueryMeta" in action.meta ? action.meta.baseQueryMeta : void 0, assertTagType);
}
function $f68da39ab4625b3c$var$updateQuerySubstateIfExists(state, queryCacheKey, update) {
    var substate = state[queryCacheKey];
    if (substate) update(substate);
}
function $f68da39ab4625b3c$var$getMutationCacheKey(id) {
    var _a;
    return (_a = "arg" in id ? id.arg.fixedCacheKey : id.fixedCacheKey) != null ? _a : id.requestId;
}
function $f68da39ab4625b3c$var$updateMutationSubstateIfExists(state, id, update) {
    var substate = state[$f68da39ab4625b3c$var$getMutationCacheKey(id)];
    if (substate) update(substate);
}
var $f68da39ab4625b3c$var$initialState = {};
function $f68da39ab4625b3c$var$buildSlice(_j) {
    var reducerPath = _j.reducerPath, queryThunk = _j.queryThunk, mutationThunk = _j.mutationThunk, _k = _j.context, definitions = _k.endpointDefinitions, apiUid = _k.apiUid, extractRehydrationInfo = _k.extractRehydrationInfo, hasRehydrationInfo = _k.hasRehydrationInfo, assertTagType = _j.assertTagType, config = _j.config;
    var resetApiState = (0, $bNLBQ.createAction)(reducerPath + "/resetApiState");
    var querySlice = (0, $bNLBQ.createSlice)({
        name: reducerPath + "/queries",
        initialState: $f68da39ab4625b3c$var$initialState,
        reducers: {
            removeQueryResult: {
                reducer: function(draft, _j) {
                    var queryCacheKey = _j.payload.queryCacheKey;
                    delete draft[queryCacheKey];
                },
                prepare: (0, $bNLBQ.prepareAutoBatched)()
            },
            queryResultPatched: {
                reducer: function(draft, _j) {
                    var _k = _j.payload, queryCacheKey = _k.queryCacheKey, patches = _k.patches;
                    $f68da39ab4625b3c$var$updateQuerySubstateIfExists(draft, queryCacheKey, function(substate) {
                        substate.data = (0, $keQ1f.applyPatches)(substate.data, patches.concat());
                    });
                },
                prepare: (0, $bNLBQ.prepareAutoBatched)()
            }
        },
        extraReducers: function(builder) {
            builder.addCase(queryThunk.pending, function(draft, _j) {
                var meta = _j.meta, arg = _j.meta.arg;
                var _a, _b;
                var upserting = $f68da39ab4625b3c$var$isUpsertQuery(arg);
                if (arg.subscribe || upserting) (_b = draft[_a = arg.queryCacheKey]) != null ? _b : draft[_a] = {
                    status: $f68da39ab4625b3c$export$f4258b89f6bad1d6.uninitialized,
                    endpointName: arg.endpointName
                };
                $f68da39ab4625b3c$var$updateQuerySubstateIfExists(draft, arg.queryCacheKey, function(substate) {
                    substate.status = $f68da39ab4625b3c$export$f4258b89f6bad1d6.pending;
                    substate.requestId = upserting && substate.requestId ? substate.requestId : meta.requestId;
                    if (arg.originalArgs !== void 0) substate.originalArgs = arg.originalArgs;
                    substate.startedTimeStamp = meta.startedTimeStamp;
                });
            }).addCase(queryThunk.fulfilled, function(draft, _j) {
                var meta = _j.meta, payload = _j.payload;
                $f68da39ab4625b3c$var$updateQuerySubstateIfExists(draft, meta.arg.queryCacheKey, function(substate) {
                    var _a;
                    if (substate.requestId !== meta.requestId && !$f68da39ab4625b3c$var$isUpsertQuery(meta.arg)) return;
                    var merge = definitions[meta.arg.endpointName].merge;
                    substate.status = $f68da39ab4625b3c$export$f4258b89f6bad1d6.fulfilled;
                    if (merge) {
                        if (substate.data !== void 0) {
                            var fulfilledTimeStamp_1 = meta.fulfilledTimeStamp, arg_1 = meta.arg, baseQueryMeta_1 = meta.baseQueryMeta, requestId_1 = meta.requestId;
                            var newData = (0, $keQ1f.default)(substate.data, function(draftSubstateData) {
                                return merge(draftSubstateData, payload, {
                                    arg: arg_1.originalArgs,
                                    baseQueryMeta: baseQueryMeta_1,
                                    fulfilledTimeStamp: fulfilledTimeStamp_1,
                                    requestId: requestId_1
                                });
                            });
                            substate.data = newData;
                        } else substate.data = payload;
                    } else substate.data = ((_a = definitions[meta.arg.endpointName].structuralSharing) != null ? _a : true) ? $f68da39ab4625b3c$export$b64d4502a1c929bd((0, $keQ1f.isDraft)(substate.data) ? (0, $keQ1f.original)(substate.data) : substate.data, payload) : payload;
                    delete substate.error;
                    substate.fulfilledTimeStamp = meta.fulfilledTimeStamp;
                });
            }).addCase(queryThunk.rejected, function(draft, _j) {
                var _k = _j.meta, condition = _k.condition, arg = _k.arg, requestId = _k.requestId, error = _j.error, payload = _j.payload;
                $f68da39ab4625b3c$var$updateQuerySubstateIfExists(draft, arg.queryCacheKey, function(substate) {
                    if (condition) ;
                    else {
                        if (substate.requestId !== requestId) return;
                        substate.status = $f68da39ab4625b3c$export$f4258b89f6bad1d6.rejected;
                        substate.error = payload != null ? payload : error;
                    }
                });
            }).addMatcher(hasRehydrationInfo, function(draft, action) {
                var queries = extractRehydrationInfo(action).queries;
                for(var _j = 0, _k = Object.entries(queries); _j < _k.length; _j++){
                    var _l = _k[_j], key = _l[0], entry = _l[1];
                    if ((entry == null ? void 0 : entry.status) === $f68da39ab4625b3c$export$f4258b89f6bad1d6.fulfilled || (entry == null ? void 0 : entry.status) === $f68da39ab4625b3c$export$f4258b89f6bad1d6.rejected) draft[key] = entry;
                }
            });
        }
    });
    var mutationSlice = (0, $bNLBQ.createSlice)({
        name: reducerPath + "/mutations",
        initialState: $f68da39ab4625b3c$var$initialState,
        reducers: {
            removeMutationResult: {
                reducer: function(draft, _j) {
                    var payload = _j.payload;
                    var cacheKey = $f68da39ab4625b3c$var$getMutationCacheKey(payload);
                    if (cacheKey in draft) delete draft[cacheKey];
                },
                prepare: (0, $bNLBQ.prepareAutoBatched)()
            }
        },
        extraReducers: function(builder) {
            builder.addCase(mutationThunk.pending, function(draft, _j) {
                var meta = _j.meta, _k = _j.meta, requestId = _k.requestId, arg = _k.arg, startedTimeStamp = _k.startedTimeStamp;
                if (!arg.track) return;
                draft[$f68da39ab4625b3c$var$getMutationCacheKey(meta)] = {
                    requestId: requestId,
                    status: $f68da39ab4625b3c$export$f4258b89f6bad1d6.pending,
                    endpointName: arg.endpointName,
                    startedTimeStamp: startedTimeStamp
                };
            }).addCase(mutationThunk.fulfilled, function(draft, _j) {
                var payload = _j.payload, meta = _j.meta;
                if (!meta.arg.track) return;
                $f68da39ab4625b3c$var$updateMutationSubstateIfExists(draft, meta, function(substate) {
                    if (substate.requestId !== meta.requestId) return;
                    substate.status = $f68da39ab4625b3c$export$f4258b89f6bad1d6.fulfilled;
                    substate.data = payload;
                    substate.fulfilledTimeStamp = meta.fulfilledTimeStamp;
                });
            }).addCase(mutationThunk.rejected, function(draft, _j) {
                var payload = _j.payload, error = _j.error, meta = _j.meta;
                if (!meta.arg.track) return;
                $f68da39ab4625b3c$var$updateMutationSubstateIfExists(draft, meta, function(substate) {
                    if (substate.requestId !== meta.requestId) return;
                    substate.status = $f68da39ab4625b3c$export$f4258b89f6bad1d6.rejected;
                    substate.error = payload != null ? payload : error;
                });
            }).addMatcher(hasRehydrationInfo, function(draft, action) {
                var mutations = extractRehydrationInfo(action).mutations;
                for(var _j = 0, _k = Object.entries(mutations); _j < _k.length; _j++){
                    var _l = _k[_j], key = _l[0], entry = _l[1];
                    if (((entry == null ? void 0 : entry.status) === $f68da39ab4625b3c$export$f4258b89f6bad1d6.fulfilled || (entry == null ? void 0 : entry.status) === $f68da39ab4625b3c$export$f4258b89f6bad1d6.rejected) && key !== (entry == null ? void 0 : entry.requestId)) draft[key] = entry;
                }
            });
        }
    });
    var invalidationSlice = (0, $bNLBQ.createSlice)({
        name: reducerPath + "/invalidation",
        initialState: $f68da39ab4625b3c$var$initialState,
        reducers: {
            updateProvidedBy: {
                reducer: function(draft, action) {
                    var _a, _b, _c, _d;
                    var _j = action.payload, queryCacheKey = _j.queryCacheKey, providedTags = _j.providedTags;
                    for(var _k = 0, _l = Object.values(draft); _k < _l.length; _k++){
                        var tagTypeSubscriptions = _l[_k];
                        for(var _m = 0, _o = Object.values(tagTypeSubscriptions); _m < _o.length; _m++){
                            var idSubscriptions = _o[_m];
                            var foundAt = idSubscriptions.indexOf(queryCacheKey);
                            if (foundAt !== -1) idSubscriptions.splice(foundAt, 1);
                        }
                    }
                    for(var _p = 0, providedTags_1 = providedTags; _p < providedTags_1.length; _p++){
                        var _q = providedTags_1[_p], type = _q.type, id = _q.id;
                        var subscribedQueries = (_d = (_b = (_a = draft[type]) != null ? _a : draft[type] = {})[_c = id || "__internal_without_id"]) != null ? _d : _b[_c] = [];
                        var alreadySubscribed = subscribedQueries.includes(queryCacheKey);
                        if (!alreadySubscribed) subscribedQueries.push(queryCacheKey);
                    }
                },
                prepare: (0, $bNLBQ.prepareAutoBatched)()
            }
        },
        extraReducers: function(builder) {
            builder.addCase(querySlice.actions.removeQueryResult, function(draft, _j) {
                var queryCacheKey = _j.payload.queryCacheKey;
                for(var _k = 0, _l = Object.values(draft); _k < _l.length; _k++){
                    var tagTypeSubscriptions = _l[_k];
                    for(var _m = 0, _o = Object.values(tagTypeSubscriptions); _m < _o.length; _m++){
                        var idSubscriptions = _o[_m];
                        var foundAt = idSubscriptions.indexOf(queryCacheKey);
                        if (foundAt !== -1) idSubscriptions.splice(foundAt, 1);
                    }
                }
            }).addMatcher(hasRehydrationInfo, function(draft, action) {
                var _a, _b, _c, _d;
                var provided = extractRehydrationInfo(action).provided;
                for(var _j = 0, _k = Object.entries(provided); _j < _k.length; _j++){
                    var _l = _k[_j], type = _l[0], incomingTags = _l[1];
                    for(var _m = 0, _o = Object.entries(incomingTags); _m < _o.length; _m++){
                        var _p = _o[_m], id = _p[0], cacheKeys = _p[1];
                        var subscribedQueries = (_d = (_b = (_a = draft[type]) != null ? _a : draft[type] = {})[_c = id || "__internal_without_id"]) != null ? _d : _b[_c] = [];
                        for(var _q = 0, cacheKeys_1 = cacheKeys; _q < cacheKeys_1.length; _q++){
                            var queryCacheKey = cacheKeys_1[_q];
                            var alreadySubscribed = subscribedQueries.includes(queryCacheKey);
                            if (!alreadySubscribed) subscribedQueries.push(queryCacheKey);
                        }
                    }
                }
            }).addMatcher((0, $bNLBQ.isAnyOf)((0, $bNLBQ.isFulfilled)(queryThunk), (0, $bNLBQ.isRejectedWithValue)(queryThunk)), function(draft, action) {
                var providedTags = $f68da39ab4625b3c$var$calculateProvidedByThunk(action, "providesTags", definitions, assertTagType);
                var queryCacheKey = action.meta.arg.queryCacheKey;
                invalidationSlice.caseReducers.updateProvidedBy(draft, invalidationSlice.actions.updateProvidedBy({
                    queryCacheKey: queryCacheKey,
                    providedTags: providedTags
                }));
            });
        }
    });
    var subscriptionSlice = (0, $bNLBQ.createSlice)({
        name: reducerPath + "/subscriptions",
        initialState: $f68da39ab4625b3c$var$initialState,
        reducers: {
            updateSubscriptionOptions: function(d, a) {},
            unsubscribeQueryResult: function(d, a) {},
            internal_probeSubscription: function(d, a) {}
        }
    });
    var internalSubscriptionsSlice = (0, $bNLBQ.createSlice)({
        name: reducerPath + "/internalSubscriptions",
        initialState: $f68da39ab4625b3c$var$initialState,
        reducers: {
            subscriptionsUpdated: {
                reducer: function(state, action) {
                    return (0, $keQ1f.applyPatches)(state, action.payload);
                },
                prepare: (0, $bNLBQ.prepareAutoBatched)()
            }
        }
    });
    var configSlice = (0, $bNLBQ.createSlice)({
        name: reducerPath + "/config",
        initialState: $f68da39ab4625b3c$var$__spreadValues({
            online: $f68da39ab4625b3c$var$isOnline(),
            focused: $f68da39ab4625b3c$var$isDocumentVisible(),
            middlewareRegistered: false
        }, config),
        reducers: {
            middlewareRegistered: function(state, _j) {
                var payload = _j.payload;
                state.middlewareRegistered = state.middlewareRegistered === "conflict" || apiUid !== payload ? "conflict" : true;
            }
        },
        extraReducers: function(builder) {
            builder.addCase($f68da39ab4625b3c$var$onOnline, function(state) {
                state.online = true;
            }).addCase($f68da39ab4625b3c$var$onOffline, function(state) {
                state.online = false;
            }).addCase($f68da39ab4625b3c$var$onFocus, function(state) {
                state.focused = true;
            }).addCase($f68da39ab4625b3c$var$onFocusLost, function(state) {
                state.focused = false;
            }).addMatcher(hasRehydrationInfo, function(draft) {
                return $f68da39ab4625b3c$var$__spreadValues({}, draft);
            });
        }
    });
    var combinedReducer = (0, $23PJP.combineReducers)({
        queries: querySlice.reducer,
        mutations: mutationSlice.reducer,
        provided: invalidationSlice.reducer,
        subscriptions: internalSubscriptionsSlice.reducer,
        config: configSlice.reducer
    });
    var reducer = function(state, action) {
        return combinedReducer(resetApiState.match(action) ? void 0 : state, action);
    };
    var actions = $f68da39ab4625b3c$var$__spreadProps($f68da39ab4625b3c$var$__spreadValues($f68da39ab4625b3c$var$__spreadValues($f68da39ab4625b3c$var$__spreadValues($f68da39ab4625b3c$var$__spreadValues($f68da39ab4625b3c$var$__spreadValues($f68da39ab4625b3c$var$__spreadValues({}, configSlice.actions), querySlice.actions), subscriptionSlice.actions), internalSubscriptionsSlice.actions), mutationSlice.actions), invalidationSlice.actions), {
        unsubscribeMutationResult: mutationSlice.actions.removeMutationResult,
        resetApiState: resetApiState
    });
    return {
        reducer: reducer,
        actions: actions
    };
}
// src/query/core/buildSelectors.ts
var $f68da39ab4625b3c$export$1aa5a89531b7670d = /* @__PURE__ */ Symbol.for("RTKQ/skipToken");
var $f68da39ab4625b3c$export$8b2f5cccb7eda71d = $f68da39ab4625b3c$export$1aa5a89531b7670d;
var $f68da39ab4625b3c$var$initialSubState = {
    status: $f68da39ab4625b3c$export$f4258b89f6bad1d6.uninitialized
};
var $f68da39ab4625b3c$var$defaultQuerySubState = /* @__PURE__ */ (0, $keQ1f.default)($f68da39ab4625b3c$var$initialSubState, function() {});
var $f68da39ab4625b3c$var$defaultMutationSubState = /* @__PURE__ */ (0, $keQ1f.default)($f68da39ab4625b3c$var$initialSubState, function() {});
function $f68da39ab4625b3c$var$buildSelectors(_j) {
    var serializeQueryArgs = _j.serializeQueryArgs, reducerPath = _j.reducerPath;
    var selectSkippedQuery = function(state) {
        return $f68da39ab4625b3c$var$defaultQuerySubState;
    };
    var selectSkippedMutation = function(state) {
        return $f68da39ab4625b3c$var$defaultMutationSubState;
    };
    return {
        buildQuerySelector: buildQuerySelector,
        buildMutationSelector: buildMutationSelector,
        selectInvalidatedBy: selectInvalidatedBy
    };
    function withRequestFlags(substate) {
        return $f68da39ab4625b3c$var$__spreadValues($f68da39ab4625b3c$var$__spreadValues({}, substate), $f68da39ab4625b3c$var$getRequestStatusFlags(substate.status));
    }
    function selectInternalState(rootState) {
        var state = rootState[reducerPath];
        return state;
    }
    function buildQuerySelector(endpointName, endpointDefinition) {
        return function(queryArgs) {
            var serializedArgs = serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            });
            var selectQuerySubstate = function(state) {
                var _a, _b, _c;
                return (_c = (_b = (_a = selectInternalState(state)) == null ? void 0 : _a.queries) == null ? void 0 : _b[serializedArgs]) != null ? _c : $f68da39ab4625b3c$var$defaultQuerySubState;
            };
            var finalSelectQuerySubState = queryArgs === $f68da39ab4625b3c$export$1aa5a89531b7670d ? selectSkippedQuery : selectQuerySubstate;
            return (0, $36fSf.createSelector)(finalSelectQuerySubState, withRequestFlags);
        };
    }
    function buildMutationSelector() {
        return function(id) {
            var _a;
            var mutationId;
            if (typeof id === "object") mutationId = (_a = $f68da39ab4625b3c$var$getMutationCacheKey(id)) != null ? _a : $f68da39ab4625b3c$export$1aa5a89531b7670d;
            else mutationId = id;
            var selectMutationSubstate = function(state) {
                var _a2, _b, _c;
                return (_c = (_b = (_a2 = selectInternalState(state)) == null ? void 0 : _a2.mutations) == null ? void 0 : _b[mutationId]) != null ? _c : $f68da39ab4625b3c$var$defaultMutationSubState;
            };
            var finalSelectMutationSubstate = mutationId === $f68da39ab4625b3c$export$1aa5a89531b7670d ? selectSkippedMutation : selectMutationSubstate;
            return (0, $36fSf.createSelector)(finalSelectMutationSubstate, withRequestFlags);
        };
    }
    function selectInvalidatedBy(state, tags) {
        var _a;
        var apiState = state[reducerPath];
        var toInvalidate = new Set();
        for(var _j = 0, _k = tags.map($f68da39ab4625b3c$var$expandTagDescription); _j < _k.length; _j++){
            var tag = _k[_j];
            var provided = apiState.provided[tag.type];
            if (!provided) continue;
            var invalidateSubscriptions = (_a = tag.id !== void 0 ? provided[tag.id] : $f68da39ab4625b3c$var$flatten(Object.values(provided))) != null ? _a : [];
            for(var _l = 0, invalidateSubscriptions_1 = invalidateSubscriptions; _l < invalidateSubscriptions_1.length; _l++){
                var invalidate = invalidateSubscriptions_1[_l];
                toInvalidate.add(invalidate);
            }
        }
        return $f68da39ab4625b3c$var$flatten(Array.from(toInvalidate.values()).map(function(queryCacheKey) {
            var querySubState = apiState.queries[queryCacheKey];
            return querySubState ? [
                {
                    queryCacheKey: queryCacheKey,
                    endpointName: querySubState.endpointName,
                    originalArgs: querySubState.originalArgs
                }
            ] : [];
        }));
    }
}
var $f68da39ab4625b3c$var$cache = WeakMap ? new WeakMap() : void 0;
var $f68da39ab4625b3c$export$db8e4edac9bbb67b = function(_j) {
    var endpointName = _j.endpointName, queryArgs = _j.queryArgs;
    var serialized = "";
    var cached = $f68da39ab4625b3c$var$cache == null ? void 0 : $f68da39ab4625b3c$var$cache.get(queryArgs);
    if (typeof cached === "string") serialized = cached;
    else {
        var stringified = JSON.stringify(queryArgs, function(key, value) {
            return (0, $bNLBQ.isPlainObject)(value) ? Object.keys(value).sort().reduce(function(acc, key2) {
                acc[key2] = value[key2];
                return acc;
            }, {}) : value;
        });
        if ((0, $bNLBQ.isPlainObject)(queryArgs)) $f68da39ab4625b3c$var$cache == null || $f68da39ab4625b3c$var$cache.set(queryArgs, stringified);
        serialized = stringified;
    }
    return endpointName + "(" + serialized + ")";
};
function $f68da39ab4625b3c$export$f957748792d43646() {
    var modules = [];
    for(var _j = 0; _j < arguments.length; _j++)modules[_j] = arguments[_j];
    return function baseCreateApi(options) {
        var extractRehydrationInfo = (0, $iQsan.defaultMemoize)(function(action) {
            var _a, _b;
            return (_b = options.extractRehydrationInfo) == null ? void 0 : _b.call(options, action, {
                reducerPath: (_a = options.reducerPath) != null ? _a : "api"
            });
        });
        var optionsWithDefaults = $f68da39ab4625b3c$var$__spreadProps($f68da39ab4625b3c$var$__spreadValues({
            reducerPath: "api",
            keepUnusedDataFor: 60,
            refetchOnMountOrArgChange: false,
            refetchOnFocus: false,
            refetchOnReconnect: false
        }, options), {
            extractRehydrationInfo: extractRehydrationInfo,
            serializeQueryArgs: function(queryArgsApi) {
                var finalSerializeQueryArgs = $f68da39ab4625b3c$export$db8e4edac9bbb67b;
                if ("serializeQueryArgs" in queryArgsApi.endpointDefinition) {
                    var endpointSQA_1 = queryArgsApi.endpointDefinition.serializeQueryArgs;
                    finalSerializeQueryArgs = function(queryArgsApi2) {
                        var initialResult = endpointSQA_1(queryArgsApi2);
                        if (typeof initialResult === "string") return initialResult;
                        else return $f68da39ab4625b3c$export$db8e4edac9bbb67b($f68da39ab4625b3c$var$__spreadProps($f68da39ab4625b3c$var$__spreadValues({}, queryArgsApi2), {
                            queryArgs: initialResult
                        }));
                    };
                } else if (options.serializeQueryArgs) finalSerializeQueryArgs = options.serializeQueryArgs;
                return finalSerializeQueryArgs(queryArgsApi);
            },
            tagTypes: $f68da39ab4625b3c$var$__spreadArray([], options.tagTypes || [])
        });
        var context = {
            endpointDefinitions: {},
            batch: function(fn) {
                fn();
            },
            apiUid: (0, $bNLBQ.nanoid)(),
            extractRehydrationInfo: extractRehydrationInfo,
            hasRehydrationInfo: (0, $iQsan.defaultMemoize)(function(action) {
                return extractRehydrationInfo(action) != null;
            })
        };
        var api = {
            injectEndpoints: injectEndpoints,
            enhanceEndpoints: function(_j) {
                var addTagTypes = _j.addTagTypes, endpoints = _j.endpoints;
                if (addTagTypes) for(var _k = 0, addTagTypes_1 = addTagTypes; _k < addTagTypes_1.length; _k++){
                    var eT = addTagTypes_1[_k];
                    if (!optionsWithDefaults.tagTypes.includes(eT)) optionsWithDefaults.tagTypes.push(eT);
                }
                if (endpoints) for(var _l = 0, _m = Object.entries(endpoints); _l < _m.length; _l++){
                    var _o = _m[_l], endpointName = _o[0], partialDefinition = _o[1];
                    if (typeof partialDefinition === "function") partialDefinition(context.endpointDefinitions[endpointName]);
                    else Object.assign(context.endpointDefinitions[endpointName] || {}, partialDefinition);
                }
                return api;
            }
        };
        var initializedModules = modules.map(function(m) {
            return m.init(api, optionsWithDefaults, context);
        });
        function injectEndpoints(inject) {
            var evaluatedEndpoints = inject.endpoints({
                query: function(x) {
                    return $f68da39ab4625b3c$var$__spreadProps($f68da39ab4625b3c$var$__spreadValues({}, x), {
                        type: $f68da39ab4625b3c$var$DefinitionType.query
                    });
                },
                mutation: function(x) {
                    return $f68da39ab4625b3c$var$__spreadProps($f68da39ab4625b3c$var$__spreadValues({}, x), {
                        type: $f68da39ab4625b3c$var$DefinitionType.mutation
                    });
                }
            });
            for(var _j = 0, _k = Object.entries(evaluatedEndpoints); _j < _k.length; _j++){
                var _l = _k[_j], endpointName = _l[0], definition = _l[1];
                if (!inject.overrideExisting && endpointName in context.endpointDefinitions) {
                    typeof $62jNV;
                    continue;
                }
                context.endpointDefinitions[endpointName] = definition;
                for(var _m = 0, initializedModules_1 = initializedModules; _m < initializedModules_1.length; _m++){
                    var m = initializedModules_1[_m];
                    m.injectEndpoint(endpointName, definition);
                }
            }
            return api;
        }
        return api.injectEndpoints({
            endpoints: options.endpoints
        });
    };
}
// src/query/fakeBaseQuery.ts
function $f68da39ab4625b3c$export$f72b22d3ac378bae() {
    return function() {
        throw new Error("When using `fakeBaseQuery`, all queries & mutations must use the `queryFn` definition syntax.");
    };
}
// src/query/core/buildMiddleware/cacheCollection.ts
function $f68da39ab4625b3c$var$isObjectEmpty(obj) {
    for(var k in obj)return false;
    return true;
}
var $f68da39ab4625b3c$var$THIRTY_TWO_BIT_MAX_TIMER_SECONDS = 2147482.647;
var $f68da39ab4625b3c$var$buildCacheCollectionHandler = function(_j) {
    var reducerPath = _j.reducerPath, api = _j.api, context = _j.context, internalState = _j.internalState;
    var _k = api.internalActions, removeQueryResult = _k.removeQueryResult, unsubscribeQueryResult = _k.unsubscribeQueryResult;
    function anySubscriptionsRemainingForKey(queryCacheKey) {
        var subscriptions = internalState.currentSubscriptions[queryCacheKey];
        return !!subscriptions && !$f68da39ab4625b3c$var$isObjectEmpty(subscriptions);
    }
    var currentRemovalTimeouts = {};
    var handler = function(action, mwApi, internalState2) {
        var _a;
        if (unsubscribeQueryResult.match(action)) {
            var state = mwApi.getState()[reducerPath];
            var queryCacheKey = action.payload.queryCacheKey;
            handleUnsubscribe(queryCacheKey, (_a = state.queries[queryCacheKey]) == null ? void 0 : _a.endpointName, mwApi, state.config);
        }
        if (api.util.resetApiState.match(action)) for(var _j = 0, _k = Object.entries(currentRemovalTimeouts); _j < _k.length; _j++){
            var _l = _k[_j], key = _l[0], timeout = _l[1];
            if (timeout) clearTimeout(timeout);
            delete currentRemovalTimeouts[key];
        }
        if (context.hasRehydrationInfo(action)) {
            var state = mwApi.getState()[reducerPath];
            var queries = context.extractRehydrationInfo(action).queries;
            for(var _m = 0, _o = Object.entries(queries); _m < _o.length; _m++){
                var _p = _o[_m], queryCacheKey = _p[0], queryState = _p[1];
                handleUnsubscribe(queryCacheKey, queryState == null ? void 0 : queryState.endpointName, mwApi, state.config);
            }
        }
    };
    function handleUnsubscribe(queryCacheKey, endpointName, api2, config) {
        var _a;
        var endpointDefinition = context.endpointDefinitions[endpointName];
        var keepUnusedDataFor = (_a = endpointDefinition == null ? void 0 : endpointDefinition.keepUnusedDataFor) != null ? _a : config.keepUnusedDataFor;
        if (keepUnusedDataFor === Infinity) return;
        var finalKeepUnusedDataFor = Math.max(0, Math.min(keepUnusedDataFor, $f68da39ab4625b3c$var$THIRTY_TWO_BIT_MAX_TIMER_SECONDS));
        if (!anySubscriptionsRemainingForKey(queryCacheKey)) {
            var currentTimeout = currentRemovalTimeouts[queryCacheKey];
            if (currentTimeout) clearTimeout(currentTimeout);
            currentRemovalTimeouts[queryCacheKey] = setTimeout(function() {
                if (!anySubscriptionsRemainingForKey(queryCacheKey)) api2.dispatch(removeQueryResult({
                    queryCacheKey: queryCacheKey
                }));
                delete currentRemovalTimeouts[queryCacheKey];
            }, finalKeepUnusedDataFor * 1e3);
        }
    }
    return handler;
};
var $f68da39ab4625b3c$var$buildInvalidationByTagsHandler = function(_j) {
    var reducerPath = _j.reducerPath, context = _j.context, endpointDefinitions = _j.context.endpointDefinitions, mutationThunk = _j.mutationThunk, api = _j.api, assertTagType = _j.assertTagType, refetchQuery = _j.refetchQuery;
    var removeQueryResult = api.internalActions.removeQueryResult;
    var isThunkActionWithTags = (0, $bNLBQ.isAnyOf)((0, $bNLBQ.isFulfilled)(mutationThunk), (0, $bNLBQ.isRejectedWithValue)(mutationThunk));
    var handler = function(action, mwApi) {
        if (isThunkActionWithTags(action)) invalidateTags($f68da39ab4625b3c$var$calculateProvidedByThunk(action, "invalidatesTags", endpointDefinitions, assertTagType), mwApi);
        if (api.util.invalidateTags.match(action)) invalidateTags($f68da39ab4625b3c$var$calculateProvidedBy(action.payload, void 0, void 0, void 0, void 0, assertTagType), mwApi);
    };
    function invalidateTags(tags, mwApi) {
        var rootState = mwApi.getState();
        var state = rootState[reducerPath];
        var toInvalidate = api.util.selectInvalidatedBy(rootState, tags);
        context.batch(function() {
            var _a;
            var valuesArray = Array.from(toInvalidate.values());
            for(var _j = 0, valuesArray_1 = valuesArray; _j < valuesArray_1.length; _j++){
                var queryCacheKey = valuesArray_1[_j].queryCacheKey;
                var querySubState = state.queries[queryCacheKey];
                var subscriptionSubState = (_a = state.subscriptions[queryCacheKey]) != null ? _a : {};
                if (querySubState) {
                    if (Object.keys(subscriptionSubState).length === 0) mwApi.dispatch(removeQueryResult({
                        queryCacheKey: queryCacheKey
                    }));
                    else if (querySubState.status !== $f68da39ab4625b3c$export$f4258b89f6bad1d6.uninitialized) mwApi.dispatch(refetchQuery(querySubState, queryCacheKey));
                }
            }
        });
    }
    return handler;
};
// src/query/core/buildMiddleware/polling.ts
var $f68da39ab4625b3c$var$buildPollingHandler = function(_j) {
    var reducerPath = _j.reducerPath, queryThunk = _j.queryThunk, api = _j.api, refetchQuery = _j.refetchQuery, internalState = _j.internalState;
    var currentPolls = {};
    var handler = function(action, mwApi) {
        if (api.internalActions.updateSubscriptionOptions.match(action) || api.internalActions.unsubscribeQueryResult.match(action)) updatePollingInterval(action.payload, mwApi);
        if (queryThunk.pending.match(action) || queryThunk.rejected.match(action) && action.meta.condition) updatePollingInterval(action.meta.arg, mwApi);
        if (queryThunk.fulfilled.match(action) || queryThunk.rejected.match(action) && !action.meta.condition) startNextPoll(action.meta.arg, mwApi);
        if (api.util.resetApiState.match(action)) clearPolls();
    };
    function startNextPoll(_j, api2) {
        var queryCacheKey = _j.queryCacheKey;
        var state = api2.getState()[reducerPath];
        var querySubState = state.queries[queryCacheKey];
        var subscriptions = internalState.currentSubscriptions[queryCacheKey];
        if (!querySubState || querySubState.status === $f68da39ab4625b3c$export$f4258b89f6bad1d6.uninitialized) return;
        var lowestPollingInterval = findLowestPollingInterval(subscriptions);
        if (!Number.isFinite(lowestPollingInterval)) return;
        var currentPoll = currentPolls[queryCacheKey];
        if (currentPoll == null ? void 0 : currentPoll.timeout) {
            clearTimeout(currentPoll.timeout);
            currentPoll.timeout = void 0;
        }
        var nextPollTimestamp = Date.now() + lowestPollingInterval;
        var currentInterval = currentPolls[queryCacheKey] = {
            nextPollTimestamp: nextPollTimestamp,
            pollingInterval: lowestPollingInterval,
            timeout: setTimeout(function() {
                currentInterval.timeout = void 0;
                api2.dispatch(refetchQuery(querySubState, queryCacheKey));
            }, lowestPollingInterval)
        };
    }
    function updatePollingInterval(_j, api2) {
        var queryCacheKey = _j.queryCacheKey;
        var state = api2.getState()[reducerPath];
        var querySubState = state.queries[queryCacheKey];
        var subscriptions = internalState.currentSubscriptions[queryCacheKey];
        if (!querySubState || querySubState.status === $f68da39ab4625b3c$export$f4258b89f6bad1d6.uninitialized) return;
        var lowestPollingInterval = findLowestPollingInterval(subscriptions);
        if (!Number.isFinite(lowestPollingInterval)) {
            cleanupPollForKey(queryCacheKey);
            return;
        }
        var currentPoll = currentPolls[queryCacheKey];
        var nextPollTimestamp = Date.now() + lowestPollingInterval;
        if (!currentPoll || nextPollTimestamp < currentPoll.nextPollTimestamp) startNextPoll({
            queryCacheKey: queryCacheKey
        }, api2);
    }
    function cleanupPollForKey(key) {
        var existingPoll = currentPolls[key];
        if (existingPoll == null ? void 0 : existingPoll.timeout) clearTimeout(existingPoll.timeout);
        delete currentPolls[key];
    }
    function clearPolls() {
        for(var _j = 0, _k = Object.keys(currentPolls); _j < _k.length; _j++){
            var key = _k[_j];
            cleanupPollForKey(key);
        }
    }
    function findLowestPollingInterval(subscribers) {
        if (subscribers === void 0) subscribers = {};
        var lowestPollingInterval = Number.POSITIVE_INFINITY;
        for(var key in subscribers)if (!!subscribers[key].pollingInterval) lowestPollingInterval = Math.min(subscribers[key].pollingInterval, lowestPollingInterval);
        return lowestPollingInterval;
    }
    return handler;
};
// src/query/core/buildMiddleware/windowEventHandling.ts
var $f68da39ab4625b3c$var$buildWindowEventHandler = function(_j) {
    var reducerPath = _j.reducerPath, context = _j.context, api = _j.api, refetchQuery = _j.refetchQuery, internalState = _j.internalState;
    var removeQueryResult = api.internalActions.removeQueryResult;
    var handler = function(action, mwApi) {
        if ($f68da39ab4625b3c$var$onFocus.match(action)) refetchValidQueries(mwApi, "refetchOnFocus");
        if ($f68da39ab4625b3c$var$onOnline.match(action)) refetchValidQueries(mwApi, "refetchOnReconnect");
    };
    function refetchValidQueries(api2, type) {
        var state = api2.getState()[reducerPath];
        var queries = state.queries;
        var subscriptions = internalState.currentSubscriptions;
        context.batch(function() {
            for(var _j = 0, _k = Object.keys(subscriptions); _j < _k.length; _j++){
                var queryCacheKey = _k[_j];
                var querySubState = queries[queryCacheKey];
                var subscriptionSubState = subscriptions[queryCacheKey];
                if (!subscriptionSubState || !querySubState) continue;
                var shouldRefetch = Object.values(subscriptionSubState).some(function(sub) {
                    return sub[type] === true;
                }) || Object.values(subscriptionSubState).every(function(sub) {
                    return sub[type] === void 0;
                }) && state.config[type];
                if (shouldRefetch) {
                    if (Object.keys(subscriptionSubState).length === 0) api2.dispatch(removeQueryResult({
                        queryCacheKey: queryCacheKey
                    }));
                    else if (querySubState.status !== $f68da39ab4625b3c$export$f4258b89f6bad1d6.uninitialized) api2.dispatch(refetchQuery(querySubState, queryCacheKey));
                }
            }
        });
    }
    return handler;
};
var $f68da39ab4625b3c$var$neverResolvedError = new Error("Promise never resolved before cacheEntryRemoved.");
var $f68da39ab4625b3c$var$buildCacheLifecycleHandler = function(_j) {
    var api = _j.api, reducerPath = _j.reducerPath, context = _j.context, queryThunk = _j.queryThunk, mutationThunk = _j.mutationThunk, internalState = _j.internalState;
    var isQueryThunk = (0, $bNLBQ.isAsyncThunkAction)(queryThunk);
    var isMutationThunk = (0, $bNLBQ.isAsyncThunkAction)(mutationThunk);
    var isFulfilledThunk = (0, $bNLBQ.isFulfilled)(queryThunk, mutationThunk);
    var lifecycleMap = {};
    var handler = function(action, mwApi, stateBefore) {
        var cacheKey = getCacheKey(action);
        if (queryThunk.pending.match(action)) {
            var oldState = stateBefore[reducerPath].queries[cacheKey];
            var state = mwApi.getState()[reducerPath].queries[cacheKey];
            if (!oldState && state) handleNewKey(action.meta.arg.endpointName, action.meta.arg.originalArgs, cacheKey, mwApi, action.meta.requestId);
        } else if (mutationThunk.pending.match(action)) {
            var state = mwApi.getState()[reducerPath].mutations[cacheKey];
            if (state) handleNewKey(action.meta.arg.endpointName, action.meta.arg.originalArgs, cacheKey, mwApi, action.meta.requestId);
        } else if (isFulfilledThunk(action)) {
            var lifecycle = lifecycleMap[cacheKey];
            if (lifecycle == null ? void 0 : lifecycle.valueResolved) {
                lifecycle.valueResolved({
                    data: action.payload,
                    meta: action.meta.baseQueryMeta
                });
                delete lifecycle.valueResolved;
            }
        } else if (api.internalActions.removeQueryResult.match(action) || api.internalActions.removeMutationResult.match(action)) {
            var lifecycle = lifecycleMap[cacheKey];
            if (lifecycle) {
                delete lifecycleMap[cacheKey];
                lifecycle.cacheEntryRemoved();
            }
        } else if (api.util.resetApiState.match(action)) for(var _j = 0, _k = Object.entries(lifecycleMap); _j < _k.length; _j++){
            var _l = _k[_j], cacheKey2 = _l[0], lifecycle = _l[1];
            delete lifecycleMap[cacheKey2];
            lifecycle.cacheEntryRemoved();
        }
    };
    function getCacheKey(action) {
        if (isQueryThunk(action)) return action.meta.arg.queryCacheKey;
        if (isMutationThunk(action)) return action.meta.requestId;
        if (api.internalActions.removeQueryResult.match(action)) return action.payload.queryCacheKey;
        if (api.internalActions.removeMutationResult.match(action)) return $f68da39ab4625b3c$var$getMutationCacheKey(action.payload);
        return "";
    }
    function handleNewKey(endpointName, originalArgs, queryCacheKey, mwApi, requestId) {
        var endpointDefinition = context.endpointDefinitions[endpointName];
        var onCacheEntryAdded = endpointDefinition == null ? void 0 : endpointDefinition.onCacheEntryAdded;
        if (!onCacheEntryAdded) return;
        var lifecycle = {};
        var cacheEntryRemoved = new Promise(function(resolve) {
            lifecycle.cacheEntryRemoved = resolve;
        });
        var cacheDataLoaded = Promise.race([
            new Promise(function(resolve) {
                lifecycle.valueResolved = resolve;
            }),
            cacheEntryRemoved.then(function() {
                throw $f68da39ab4625b3c$var$neverResolvedError;
            })
        ]);
        cacheDataLoaded.catch(function() {});
        lifecycleMap[queryCacheKey] = lifecycle;
        var selector = api.endpoints[endpointName].select(endpointDefinition.type === $f68da39ab4625b3c$var$DefinitionType.query ? originalArgs : queryCacheKey);
        var extra = mwApi.dispatch(function(_, __, extra2) {
            return extra2;
        });
        var lifecycleApi = $f68da39ab4625b3c$var$__spreadProps($f68da39ab4625b3c$var$__spreadValues({}, mwApi), {
            getCacheEntry: function() {
                return selector(mwApi.getState());
            },
            requestId: requestId,
            extra: extra,
            updateCachedData: endpointDefinition.type === $f68da39ab4625b3c$var$DefinitionType.query ? function(updateRecipe) {
                return mwApi.dispatch(api.util.updateQueryData(endpointName, originalArgs, updateRecipe));
            } : void 0,
            cacheDataLoaded: cacheDataLoaded,
            cacheEntryRemoved: cacheEntryRemoved
        });
        var runningHandler = onCacheEntryAdded(originalArgs, lifecycleApi);
        Promise.resolve(runningHandler).catch(function(e) {
            if (e === $f68da39ab4625b3c$var$neverResolvedError) return;
            throw e;
        });
    }
    return handler;
};
var $f68da39ab4625b3c$var$buildQueryLifecycleHandler = function(_j) {
    var api = _j.api, context = _j.context, queryThunk = _j.queryThunk, mutationThunk = _j.mutationThunk;
    var isPendingThunk = (0, $bNLBQ.isPending)(queryThunk, mutationThunk);
    var isRejectedThunk = (0, $bNLBQ.isRejected)(queryThunk, mutationThunk);
    var isFullfilledThunk = (0, $bNLBQ.isFulfilled)(queryThunk, mutationThunk);
    var lifecycleMap = {};
    var handler = function(action, mwApi) {
        var _a, _b, _c;
        if (isPendingThunk(action)) {
            var _j = action.meta, requestId = _j.requestId, _k = _j.arg, endpointName_1 = _k.endpointName, originalArgs_1 = _k.originalArgs;
            var endpointDefinition = context.endpointDefinitions[endpointName_1];
            var onQueryStarted = endpointDefinition == null ? void 0 : endpointDefinition.onQueryStarted;
            if (onQueryStarted) {
                var lifecycle_1 = {};
                var queryFulfilled = new Promise(function(resolve, reject) {
                    lifecycle_1.resolve = resolve;
                    lifecycle_1.reject = reject;
                });
                queryFulfilled.catch(function() {});
                lifecycleMap[requestId] = lifecycle_1;
                var selector_1 = api.endpoints[endpointName_1].select(endpointDefinition.type === $f68da39ab4625b3c$var$DefinitionType.query ? originalArgs_1 : requestId);
                var extra = mwApi.dispatch(function(_, __, extra2) {
                    return extra2;
                });
                var lifecycleApi = $f68da39ab4625b3c$var$__spreadProps($f68da39ab4625b3c$var$__spreadValues({}, mwApi), {
                    getCacheEntry: function() {
                        return selector_1(mwApi.getState());
                    },
                    requestId: requestId,
                    extra: extra,
                    updateCachedData: endpointDefinition.type === $f68da39ab4625b3c$var$DefinitionType.query ? function(updateRecipe) {
                        return mwApi.dispatch(api.util.updateQueryData(endpointName_1, originalArgs_1, updateRecipe));
                    } : void 0,
                    queryFulfilled: queryFulfilled
                });
                onQueryStarted(originalArgs_1, lifecycleApi);
            }
        } else if (isFullfilledThunk(action)) {
            var _l = action.meta, requestId = _l.requestId, baseQueryMeta = _l.baseQueryMeta;
            (_a = lifecycleMap[requestId]) == null || _a.resolve({
                data: action.payload,
                meta: baseQueryMeta
            });
            delete lifecycleMap[requestId];
        } else if (isRejectedThunk(action)) {
            var _m = action.meta, requestId = _m.requestId, rejectedWithValue = _m.rejectedWithValue, baseQueryMeta = _m.baseQueryMeta;
            (_c = lifecycleMap[requestId]) == null || _c.reject({
                error: (_b = action.payload) != null ? _b : action.error,
                isUnhandledError: !rejectedWithValue,
                meta: baseQueryMeta
            });
            delete lifecycleMap[requestId];
        }
    };
    return handler;
};
// src/query/core/buildMiddleware/devMiddleware.ts
var $f68da39ab4625b3c$var$buildDevCheckHandler = function(_j) {
    var api = _j.api, apiUid = _j.context.apiUid, reducerPath = _j.reducerPath;
    return function(action, mwApi) {
        var _a, _b;
        if (api.util.resetApiState.match(action)) mwApi.dispatch(api.internalActions.middlewareRegistered(apiUid));
        typeof $62jNV;
    };
};
var $f68da39ab4625b3c$var$promise;
var $f68da39ab4625b3c$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($f68da39ab4625b3c$var$promise || ($f68da39ab4625b3c$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $f68da39ab4625b3c$var$buildBatchedActionsHandler = function(_j) {
    var api = _j.api, queryThunk = _j.queryThunk, internalState = _j.internalState;
    var subscriptionsPrefix = api.reducerPath + "/subscriptions";
    var previousSubscriptions = null;
    var dispatchQueued = false;
    var _k = api.internalActions, updateSubscriptionOptions = _k.updateSubscriptionOptions, unsubscribeQueryResult = _k.unsubscribeQueryResult;
    var actuallyMutateSubscriptions = function(mutableState, action) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i;
        if (updateSubscriptionOptions.match(action)) {
            var _j = action.payload, queryCacheKey = _j.queryCacheKey, requestId = _j.requestId, options = _j.options;
            if ((_a = mutableState == null ? void 0 : mutableState[queryCacheKey]) == null ? void 0 : _a[requestId]) mutableState[queryCacheKey][requestId] = options;
            return true;
        }
        if (unsubscribeQueryResult.match(action)) {
            var _k = action.payload, queryCacheKey = _k.queryCacheKey, requestId = _k.requestId;
            if (mutableState[queryCacheKey]) delete mutableState[queryCacheKey][requestId];
            return true;
        }
        if (api.internalActions.removeQueryResult.match(action)) {
            delete mutableState[action.payload.queryCacheKey];
            return true;
        }
        if (queryThunk.pending.match(action)) {
            var _l = action.meta, arg = _l.arg, requestId = _l.requestId;
            if (arg.subscribe) {
                var substate = (_c = mutableState[_b = arg.queryCacheKey]) != null ? _c : mutableState[_b] = {};
                substate[requestId] = (_e = (_d = arg.subscriptionOptions) != null ? _d : substate[requestId]) != null ? _e : {};
                return true;
            }
        }
        if (queryThunk.rejected.match(action)) {
            var _m = action.meta, condition = _m.condition, arg = _m.arg, requestId = _m.requestId;
            if (condition && arg.subscribe) {
                var substate = (_g = mutableState[_f = arg.queryCacheKey]) != null ? _g : mutableState[_f] = {};
                substate[requestId] = (_i = (_h = arg.subscriptionOptions) != null ? _h : substate[requestId]) != null ? _i : {};
                return true;
            }
        }
        return false;
    };
    return function(action, mwApi) {
        var _a, _b;
        if (!previousSubscriptions) previousSubscriptions = JSON.parse(JSON.stringify(internalState.currentSubscriptions));
        if (api.util.resetApiState.match(action)) {
            previousSubscriptions = internalState.currentSubscriptions = {};
            return [
                true,
                false
            ];
        }
        if (api.internalActions.internal_probeSubscription.match(action)) {
            var _j = action.payload, queryCacheKey = _j.queryCacheKey, requestId = _j.requestId;
            var hasSubscription = !!((_a = internalState.currentSubscriptions[queryCacheKey]) == null ? void 0 : _a[requestId]);
            return [
                false,
                hasSubscription
            ];
        }
        var didMutate = actuallyMutateSubscriptions(internalState.currentSubscriptions, action);
        if (didMutate) {
            if (!dispatchQueued) {
                $f68da39ab4625b3c$var$queueMicrotaskShim(function() {
                    var newSubscriptions = JSON.parse(JSON.stringify(internalState.currentSubscriptions));
                    var _j = (0, $keQ1f.produceWithPatches)(previousSubscriptions, function() {
                        return newSubscriptions;
                    }), patches = _j[1];
                    mwApi.next(api.internalActions.subscriptionsUpdated(patches));
                    previousSubscriptions = newSubscriptions;
                    dispatchQueued = false;
                });
                dispatchQueued = true;
            }
            var isSubscriptionSliceAction = !!((_b = action.type) == null ? void 0 : _b.startsWith(subscriptionsPrefix));
            var isAdditionalSubscriptionAction = queryThunk.rejected.match(action) && action.meta.condition && !!action.meta.arg.subscribe;
            var actionShouldContinue = !isSubscriptionSliceAction && !isAdditionalSubscriptionAction;
            return [
                actionShouldContinue,
                false
            ];
        }
        return [
            true,
            false
        ];
    };
};
// src/query/core/buildMiddleware/index.ts
function $f68da39ab4625b3c$var$buildMiddleware(input) {
    var reducerPath = input.reducerPath, queryThunk = input.queryThunk, api = input.api, context = input.context;
    var apiUid = context.apiUid;
    var actions = {
        invalidateTags: (0, $bNLBQ.createAction)(reducerPath + "/invalidateTags")
    };
    var isThisApiSliceAction = function(action) {
        return !!action && typeof action.type === "string" && action.type.startsWith(reducerPath + "/");
    };
    var handlerBuilders = [
        $f68da39ab4625b3c$var$buildDevCheckHandler,
        $f68da39ab4625b3c$var$buildCacheCollectionHandler,
        $f68da39ab4625b3c$var$buildInvalidationByTagsHandler,
        $f68da39ab4625b3c$var$buildPollingHandler,
        $f68da39ab4625b3c$var$buildCacheLifecycleHandler,
        $f68da39ab4625b3c$var$buildQueryLifecycleHandler
    ];
    var middleware = function(mwApi) {
        var initialized2 = false;
        var internalState = {
            currentSubscriptions: {}
        };
        var builderArgs = $f68da39ab4625b3c$var$__spreadProps($f68da39ab4625b3c$var$__spreadValues({}, input), {
            internalState: internalState,
            refetchQuery: refetchQuery
        });
        var handlers = handlerBuilders.map(function(build) {
            return build(builderArgs);
        });
        var batchedActionsHandler = $f68da39ab4625b3c$var$buildBatchedActionsHandler(builderArgs);
        var windowEventsHandler = $f68da39ab4625b3c$var$buildWindowEventHandler(builderArgs);
        return function(next) {
            return function(action) {
                if (!initialized2) {
                    initialized2 = true;
                    mwApi.dispatch(api.internalActions.middlewareRegistered(apiUid));
                }
                var mwApiWithNext = $f68da39ab4625b3c$var$__spreadProps($f68da39ab4625b3c$var$__spreadValues({}, mwApi), {
                    next: next
                });
                var stateBefore = mwApi.getState();
                var _j = batchedActionsHandler(action, mwApiWithNext, stateBefore), actionShouldContinue = _j[0], hasSubscription = _j[1];
                var res;
                if (actionShouldContinue) res = next(action);
                else res = hasSubscription;
                if (!!mwApi.getState()[reducerPath]) {
                    windowEventsHandler(action, mwApiWithNext, stateBefore);
                    if (isThisApiSliceAction(action) || context.hasRehydrationInfo(action)) for(var _k = 0, handlers_1 = handlers; _k < handlers_1.length; _k++){
                        var handler = handlers_1[_k];
                        handler(action, mwApiWithNext, stateBefore);
                    }
                }
                return res;
            };
        };
    };
    return {
        middleware: middleware,
        actions: actions
    };
    function refetchQuery(querySubState, queryCacheKey, override) {
        if (override === void 0) override = {};
        return queryThunk($f68da39ab4625b3c$var$__spreadValues({
            type: "query",
            endpointName: querySubState.endpointName,
            originalArgs: querySubState.originalArgs,
            subscribe: false,
            forceRefetch: true,
            queryCacheKey: queryCacheKey
        }, override));
    }
}
// src/query/tsHelpers.ts
function $f68da39ab4625b3c$var$assertCast(v) {}
function $f68da39ab4625b3c$var$safeAssign(target) {
    var args = [];
    for(var _j = 1; _j < arguments.length; _j++)args[_j - 1] = arguments[_j];
    Object.assign.apply(Object, $f68da39ab4625b3c$var$__spreadArray([
        target
    ], args));
}
var $f68da39ab4625b3c$export$2902d0921e535c0 = /* @__PURE__ */ Symbol();
var $f68da39ab4625b3c$export$eb718ff92afd6f9b = function() {
    return {
        name: $f68da39ab4625b3c$export$2902d0921e535c0,
        init: function(api, _j, context) {
            var baseQuery = _j.baseQuery, tagTypes = _j.tagTypes, reducerPath = _j.reducerPath, serializeQueryArgs = _j.serializeQueryArgs, keepUnusedDataFor = _j.keepUnusedDataFor, refetchOnMountOrArgChange = _j.refetchOnMountOrArgChange, refetchOnFocus = _j.refetchOnFocus, refetchOnReconnect = _j.refetchOnReconnect;
            (0, $keQ1f.enablePatches)();
            $f68da39ab4625b3c$var$assertCast(serializeQueryArgs);
            var assertTagType = function(tag) {
                typeof $62jNV;
                return tag;
            };
            Object.assign(api, {
                reducerPath: reducerPath,
                endpoints: {},
                internalActions: {
                    onOnline: $f68da39ab4625b3c$var$onOnline,
                    onOffline: $f68da39ab4625b3c$var$onOffline,
                    onFocus: $f68da39ab4625b3c$var$onFocus,
                    onFocusLost: $f68da39ab4625b3c$var$onFocusLost
                },
                util: {}
            });
            var _k = $f68da39ab4625b3c$var$buildThunks({
                baseQuery: baseQuery,
                reducerPath: reducerPath,
                context: context,
                api: api,
                serializeQueryArgs: serializeQueryArgs,
                assertTagType: assertTagType
            }), queryThunk = _k.queryThunk, mutationThunk = _k.mutationThunk, patchQueryData = _k.patchQueryData, updateQueryData = _k.updateQueryData, upsertQueryData = _k.upsertQueryData, prefetch = _k.prefetch, buildMatchThunkActions = _k.buildMatchThunkActions;
            var _l = $f68da39ab4625b3c$var$buildSlice({
                context: context,
                queryThunk: queryThunk,
                mutationThunk: mutationThunk,
                reducerPath: reducerPath,
                assertTagType: assertTagType,
                config: {
                    refetchOnFocus: refetchOnFocus,
                    refetchOnReconnect: refetchOnReconnect,
                    refetchOnMountOrArgChange: refetchOnMountOrArgChange,
                    keepUnusedDataFor: keepUnusedDataFor,
                    reducerPath: reducerPath
                }
            }), reducer = _l.reducer, sliceActions = _l.actions;
            $f68da39ab4625b3c$var$safeAssign(api.util, {
                patchQueryData: patchQueryData,
                updateQueryData: updateQueryData,
                upsertQueryData: upsertQueryData,
                prefetch: prefetch,
                resetApiState: sliceActions.resetApiState
            });
            $f68da39ab4625b3c$var$safeAssign(api.internalActions, sliceActions);
            var _m = $f68da39ab4625b3c$var$buildMiddleware({
                reducerPath: reducerPath,
                context: context,
                queryThunk: queryThunk,
                mutationThunk: mutationThunk,
                api: api,
                assertTagType: assertTagType
            }), middleware = _m.middleware, middlewareActions = _m.actions;
            $f68da39ab4625b3c$var$safeAssign(api.util, middlewareActions);
            $f68da39ab4625b3c$var$safeAssign(api, {
                reducer: reducer,
                middleware: middleware
            });
            var _o = $f68da39ab4625b3c$var$buildSelectors({
                serializeQueryArgs: serializeQueryArgs,
                reducerPath: reducerPath
            }), buildQuerySelector = _o.buildQuerySelector, buildMutationSelector = _o.buildMutationSelector, selectInvalidatedBy = _o.selectInvalidatedBy;
            $f68da39ab4625b3c$var$safeAssign(api.util, {
                selectInvalidatedBy: selectInvalidatedBy
            });
            var _p = $f68da39ab4625b3c$var$buildInitiate({
                queryThunk: queryThunk,
                mutationThunk: mutationThunk,
                api: api,
                serializeQueryArgs: serializeQueryArgs,
                context: context
            }), buildInitiateQuery = _p.buildInitiateQuery, buildInitiateMutation = _p.buildInitiateMutation, getRunningMutationThunk = _p.getRunningMutationThunk, getRunningMutationsThunk = _p.getRunningMutationsThunk, getRunningQueriesThunk = _p.getRunningQueriesThunk, getRunningQueryThunk = _p.getRunningQueryThunk, getRunningOperationPromises = _p.getRunningOperationPromises, removalWarning = _p.removalWarning;
            $f68da39ab4625b3c$var$safeAssign(api.util, {
                getRunningOperationPromises: getRunningOperationPromises,
                getRunningOperationPromise: removalWarning,
                getRunningMutationThunk: getRunningMutationThunk,
                getRunningMutationsThunk: getRunningMutationsThunk,
                getRunningQueryThunk: getRunningQueryThunk,
                getRunningQueriesThunk: getRunningQueriesThunk
            });
            return {
                name: $f68da39ab4625b3c$export$2902d0921e535c0,
                injectEndpoint: function(endpointName, definition) {
                    var _a, _b;
                    var anyApi = api;
                    (_b = (_a = anyApi.endpoints)[endpointName]) != null ? _b : _a[endpointName] = {};
                    if ($f68da39ab4625b3c$var$isQueryDefinition(definition)) $f68da39ab4625b3c$var$safeAssign(anyApi.endpoints[endpointName], {
                        name: endpointName,
                        select: buildQuerySelector(endpointName, definition),
                        initiate: buildInitiateQuery(endpointName, definition)
                    }, buildMatchThunkActions(queryThunk, endpointName));
                    else if ($f68da39ab4625b3c$var$isMutationDefinition(definition)) $f68da39ab4625b3c$var$safeAssign(anyApi.endpoints[endpointName], {
                        name: endpointName,
                        select: buildMutationSelector(),
                        initiate: buildInitiateMutation(endpointName)
                    }, buildMatchThunkActions(mutationThunk, endpointName));
                }
            };
        }
    };
};
// src/query/core/index.ts
var $f68da39ab4625b3c$export$9cdc2b9a8d94c842 = /* @__PURE__ */ $f68da39ab4625b3c$export$f957748792d43646($f68da39ab4625b3c$export$eb718ff92afd6f9b());

});
parcelRegister("23PJP", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $1803feb105326c98$export$f51a9068ac82ea43);
$parcel$export(module.exports, "combineReducers", () => $1803feb105326c98$export$66e4520cdb265d18);
$parcel$export(module.exports, "compose", () => $1803feb105326c98$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $1803feb105326c98$export$9ff26e0402cc7b7);

var $122cP = parcelRequire("122cP");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $1803feb105326c98$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $1803feb105326c98$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $1803feb105326c98$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $1803feb105326c98$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $1803feb105326c98$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $1803feb105326c98$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $1803feb105326c98$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $1803feb105326c98$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $1803feb105326c98$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($1803feb105326c98$var$isDate(val)) return "date";
    if ($1803feb105326c98$var$isError(val)) return "error";
    var constructorName = $1803feb105326c98$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $1803feb105326c98$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $1803feb105326c98$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $1803feb105326c98$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $1803feb105326c98$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $1803feb105326c98$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($1803feb105326c98$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($1803feb105326c98$var$formatProdErrorMessage(1));
        return enhancer($1803feb105326c98$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($1803feb105326c98$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($1803feb105326c98$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($1803feb105326c98$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($1803feb105326c98$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($1803feb105326c98$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$1803feb105326c98$var$isPlainObject(action)) throw new Error($1803feb105326c98$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($1803feb105326c98$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($1803feb105326c98$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($1803feb105326c98$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $1803feb105326c98$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($1803feb105326c98$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$1803feb105326c98$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $1803feb105326c98$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$1803feb105326c98$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $1803feb105326c98$export$8928921ea2d3b126 = $1803feb105326c98$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $1803feb105326c98$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $1803feb105326c98$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $1803feb105326c98$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$1803feb105326c98$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $1803feb105326c98$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $1803feb105326c98$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $1803feb105326c98$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $1803feb105326c98$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($1803feb105326c98$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $1803feb105326c98$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($1803feb105326c98$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $1803feb105326c98$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $1803feb105326c98$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($1803feb105326c98$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $1803feb105326c98$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $1803feb105326c98$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $1803feb105326c98$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($1803feb105326c98$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $1803feb105326c98$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $1803feb105326c98$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $1803feb105326c98$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($1803feb105326c98$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $1803feb105326c98$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $122cP.default)((0, $122cP.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("122cP", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c07b068ad09a7c6$export$2e2bcd8739ae039);

var $eedUQ = parcelRequire("eedUQ");
function $0c07b068ad09a7c6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0c07b068ad09a7c6$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0c07b068ad09a7c6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eedUQ.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0c07b068ad09a7c6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("eedUQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5bd2ae96d952566$export$2e2bcd8739ae039);

var $aKAO3 = parcelRequire("aKAO3");
function $a5bd2ae96d952566$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $aKAO3.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});
parcelRegister("aKAO3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d3ac03b3aa365d0$export$2e2bcd8739ae039);

var $loejY = parcelRequire("loejY");

var $lGNhu = parcelRequire("lGNhu");
function $7d3ac03b3aa365d0$export$2e2bcd8739ae039(t) {
    var i = (0, $lGNhu.default)(t, "string");
    return "symbol" == (0, $loejY.default)(i) ? i : String(i);
}

});
parcelRegister("loejY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f926f2bb4318de45$export$2e2bcd8739ae039);
function $f926f2bb4318de45$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $f926f2bb4318de45$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f926f2bb4318de45$export$2e2bcd8739ae039(o);
}

});

parcelRegister("lGNhu", function(module, exports) {

$parcel$export(module.exports, "default", () => $fca3bf6b98b7671b$export$2e2bcd8739ae039);

var $loejY = parcelRequire("loejY");
function $fca3bf6b98b7671b$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $loejY.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $loejY.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});





parcelRegister("bNLBQ", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $89793390dc5096e0$export$53b83ca8eaab0383);
$parcel$export(module.exports, "createAction", () => $89793390dc5096e0$export$309c7a02b0b0bc62);
$parcel$export(module.exports, "configureStore", () => $89793390dc5096e0$export$7d8a5b498da695ac);
$parcel$export(module.exports, "createSlice", () => $89793390dc5096e0$export$4d8d9bd83c24ae8b);
$parcel$export(module.exports, "nanoid", () => $89793390dc5096e0$export$ac4959f4f1338dfc);
$parcel$export(module.exports, "createAsyncThunk", () => $89793390dc5096e0$export$6abd22dc03e5063f);
$parcel$export(module.exports, "isAnyOf", () => $89793390dc5096e0$export$2c3435c7647f7b0d);
$parcel$export(module.exports, "isAllOf", () => $89793390dc5096e0$export$9dd1fb32974da385);
$parcel$export(module.exports, "isPending", () => $89793390dc5096e0$export$872dec21e9a69476);
$parcel$export(module.exports, "isRejected", () => $89793390dc5096e0$export$a5c5d27e3994c5be);
$parcel$export(module.exports, "isRejectedWithValue", () => $89793390dc5096e0$export$fcc3388fb56de601);
$parcel$export(module.exports, "isFulfilled", () => $89793390dc5096e0$export$1da80a6ef1307441);
$parcel$export(module.exports, "isAsyncThunkAction", () => $89793390dc5096e0$export$6aa4142d99c1abce);
$parcel$export(module.exports, "SHOULD_AUTOBATCH", () => $89793390dc5096e0$export$8fb31c0f05df007b);
$parcel$export(module.exports, "prepareAutoBatched", () => $89793390dc5096e0$export$39fcd5145ec5e4e2);
$parcel$export(module.exports, "createNextState", () => (parcelRequire("keQ1f")).default);
$parcel$export(module.exports, "createSelector", () => (parcelRequire("36fSf")).createSelector);

var $keQ1f = parcelRequire("keQ1f");

var $23PJP = parcelRequire("23PJP");

var $36fSf = parcelRequire("36fSf");

var $fxAau = parcelRequire("fxAau");

var $62jNV = parcelRequire("62jNV");
var $89793390dc5096e0$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $89793390dc5096e0$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $89793390dc5096e0$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $89793390dc5096e0$var$__defProp = Object.defineProperty;
var $89793390dc5096e0$var$__defProps = Object.defineProperties;
var $89793390dc5096e0$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $89793390dc5096e0$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $89793390dc5096e0$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $89793390dc5096e0$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $89793390dc5096e0$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $89793390dc5096e0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $89793390dc5096e0$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($89793390dc5096e0$var$__hasOwnProp.call(b, prop)) $89793390dc5096e0$var$__defNormalProp(a, prop, b[prop]);
    if ($89793390dc5096e0$var$__getOwnPropSymbols) for(var _i = 0, _c = $89793390dc5096e0$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($89793390dc5096e0$var$__propIsEnum.call(b, prop)) $89793390dc5096e0$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $89793390dc5096e0$var$__spreadProps = function(a, b) {
    return $89793390dc5096e0$var$__defProps(a, $89793390dc5096e0$var$__getOwnPropDescs(b));
};
var $89793390dc5096e0$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $89793390dc5096e0$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $36fSf.createSelector).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $89793390dc5096e0$var$__spreadArray([
            (0, $keQ1f.isDraft)(value) ? (0, $keQ1f.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $89793390dc5096e0$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $23PJP.compose;
    return (0, $23PJP.compose).apply(null, arguments);
};
var $89793390dc5096e0$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $89793390dc5096e0$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/tsHelpers.ts
var $89793390dc5096e0$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $89793390dc5096e0$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $89793390dc5096e0$var$__spreadValues($89793390dc5096e0$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $89793390dc5096e0$export$b956e38827fca970(action) {
    return $89793390dc5096e0$export$53b83ca8eaab0383(action) && "type" in action;
}
function $89793390dc5096e0$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && $89793390dc5096e0$var$hasMatchFunction(action);
}
function $89793390dc5096e0$export$ebd532f9034651f3(action) {
    return $89793390dc5096e0$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($89793390dc5096e0$var$isValidKey);
}
function $89793390dc5096e0$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $89793390dc5096e0$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function $89793390dc5096e0$var$getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return 'Detected an action creator with type "' + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function $89793390dc5096e0$export$6a1fcb4ceef578f(options) {
    if (options === void 0) options = {};
    var _c, isActionCreator2;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $89793390dc5096e0$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $89793390dc5096e0$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $89793390dc5096e0$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $89793390dc5096e0$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $89793390dc5096e0$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $89793390dc5096e0$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $89793390dc5096e0$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $89793390dc5096e0$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $89793390dc5096e0$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $89793390dc5096e0$var$freezeDraftable(val) {
    return (0, $keQ1f.isDraftable)(val) ? (0, $keQ1f.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $89793390dc5096e0$var$isProduction = true;
var $89793390dc5096e0$var$prefix = "Invariant failed";
function $89793390dc5096e0$var$invariant(condition, message) {
    if (condition) return;
    if ($89793390dc5096e0$var$isProduction) throw new Error($89793390dc5096e0$var$prefix);
    throw new Error($89793390dc5096e0$var$prefix + ": " + (message || ""));
}
function $89793390dc5096e0$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $89793390dc5096e0$var$getSerialize(serializer, decycler), indent);
}
function $89793390dc5096e0$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $89793390dc5096e0$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $89793390dc5096e0$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $89793390dc5096e0$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $89793390dc5096e0$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $89793390dc5096e0$var$trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    if (checkedObjects === void 0) checkedObjects = new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $89793390dc5096e0$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $89793390dc5096e0$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $89793390dc5096e0$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $89793390dc5096e0$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $89793390dc5096e0$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $89793390dc5096e0$export$53b83ca8eaab0383(val);
}
function $89793390dc5096e0$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $89793390dc5096e0$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $89793390dc5096e0$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $89793390dc5096e0$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $89793390dc5096e0$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$89793390dc5096e0$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $89793390dc5096e0$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $89793390dc5096e0$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $89793390dc5096e0$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $89793390dc5096e0$export$36c1185aeee5b0a6(options);
    };
}
function $89793390dc5096e0$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new $89793390dc5096e0$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($89793390dc5096e0$var$isBoolean(thunk)) middlewareArray.push((0, $fxAau.default));
        else middlewareArray.push((0, $fxAau.default).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions, actionCreatorOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $89793390dc5096e0$var$IS_PRODUCTION = true;
function $89793390dc5096e0$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $89793390dc5096e0$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($89793390dc5096e0$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $23PJP.combineReducers)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$89793390dc5096e0$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$89793390dc5096e0$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $23PJP.applyMiddleware).apply(void 0, finalMiddleware);
    var finalCompose = (0, $23PJP.compose);
    if (devTools) finalCompose = $89793390dc5096e0$var$composeWithDevTools($89793390dc5096e0$var$__spreadValues({
        trace: !$89793390dc5096e0$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $89793390dc5096e0$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $89793390dc5096e0$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $23PJP.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $89793390dc5096e0$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error("`builder.addCase` cannot be called with an empty action type");
            if (type in actionsMap) throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $89793390dc5096e0$var$isStateFunction(x) {
    return typeof x === "function";
}
var $89793390dc5096e0$var$hasWarnedAboutObjectNotation = false;
function $89793390dc5096e0$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $89793390dc5096e0$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($89793390dc5096e0$var$isStateFunction(initialState)) getInitialState = function() {
        return $89793390dc5096e0$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $89793390dc5096e0$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $89793390dc5096e0$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $keQ1f.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $keQ1f.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $keQ1f.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $89793390dc5096e0$var$hasWarnedAboutObjectNotation2 = false;
function $89793390dc5096e0$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $89793390dc5096e0$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $62jNV;
    var initialState = typeof options.initialState == "function" ? options.initialState : $89793390dc5096e0$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $89793390dc5096e0$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $89793390dc5096e0$export$309c7a02b0b0bc62(type, prepareCallback) : $89793390dc5096e0$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $89793390dc5096e0$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $89793390dc5096e0$var$__spreadValues($89793390dc5096e0$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $89793390dc5096e0$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $89793390dc5096e0$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $89793390dc5096e0$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($89793390dc5096e0$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $89793390dc5096e0$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $89793390dc5096e0$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $89793390dc5096e0$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $89793390dc5096e0$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $89793390dc5096e0$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $89793390dc5096e0$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $89793390dc5096e0$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $89793390dc5096e0$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $89793390dc5096e0$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $89793390dc5096e0$var$createSingleArgumentStateOperator(mutator) {
    var operator = $89793390dc5096e0$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $89793390dc5096e0$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $89793390dc5096e0$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $keQ1f.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $keQ1f.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $89793390dc5096e0$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $89793390dc5096e0$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $89793390dc5096e0$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $89793390dc5096e0$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $89793390dc5096e0$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $89793390dc5096e0$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $89793390dc5096e0$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $89793390dc5096e0$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $89793390dc5096e0$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $89793390dc5096e0$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $89793390dc5096e0$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $89793390dc5096e0$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $89793390dc5096e0$var$__spreadValues($89793390dc5096e0$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $89793390dc5096e0$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $89793390dc5096e0$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $89793390dc5096e0$var$createStateOperator(addOneMutably),
        addMany: $89793390dc5096e0$var$createStateOperator(addManyMutably),
        setOne: $89793390dc5096e0$var$createStateOperator(setOneMutably),
        setMany: $89793390dc5096e0$var$createStateOperator(setManyMutably),
        setAll: $89793390dc5096e0$var$createStateOperator(setAllMutably),
        updateOne: $89793390dc5096e0$var$createStateOperator(updateOneMutably),
        updateMany: $89793390dc5096e0$var$createStateOperator(updateManyMutably),
        upsertOne: $89793390dc5096e0$var$createStateOperator(upsertOneMutably),
        upsertMany: $89793390dc5096e0$var$createStateOperator(upsertManyMutably),
        removeOne: $89793390dc5096e0$var$createStateOperator(removeOneMutably),
        removeMany: $89793390dc5096e0$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $89793390dc5096e0$var$createSortedStateAdapter(selectId, sort) {
    var _c = $89793390dc5096e0$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $89793390dc5096e0$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($89793390dc5096e0$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $89793390dc5096e0$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $89793390dc5096e0$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $89793390dc5096e0$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $89793390dc5096e0$var$createStateOperator(addOneMutably),
        updateOne: $89793390dc5096e0$var$createStateOperator(updateOneMutably),
        upsertOne: $89793390dc5096e0$var$createStateOperator(upsertOneMutably),
        setOne: $89793390dc5096e0$var$createStateOperator(setOneMutably),
        setMany: $89793390dc5096e0$var$createStateOperator(setManyMutably),
        setAll: $89793390dc5096e0$var$createStateOperator(setAllMutably),
        addMany: $89793390dc5096e0$var$createStateOperator(addManyMutably),
        updateMany: $89793390dc5096e0$var$createStateOperator(updateManyMutably),
        upsertMany: $89793390dc5096e0$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $89793390dc5096e0$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $89793390dc5096e0$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $89793390dc5096e0$var$createInitialStateFactory();
    var selectorsFactory = $89793390dc5096e0$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $89793390dc5096e0$var$createSortedStateAdapter(selectId, sortComparer) : $89793390dc5096e0$var$createUnsortedStateAdapter(selectId);
    return $89793390dc5096e0$var$__spreadValues($89793390dc5096e0$var$__spreadValues($89793390dc5096e0$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $89793390dc5096e0$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $89793390dc5096e0$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $89793390dc5096e0$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $89793390dc5096e0$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $89793390dc5096e0$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $89793390dc5096e0$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $89793390dc5096e0$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $89793390dc5096e0$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $89793390dc5096e0$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $89793390dc5096e0$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $89793390dc5096e0$var$__spreadProps($89793390dc5096e0$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $89793390dc5096e0$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $89793390dc5096e0$var$__spreadProps($89793390dc5096e0$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $89793390dc5096e0$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $89793390dc5096e0$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $89793390dc5096e0$var$__spreadProps($89793390dc5096e0$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $89793390dc5096e0$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $89793390dc5096e0$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $89793390dc5096e0$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$89793390dc5096e0$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $89793390dc5096e0$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $89793390dc5096e0$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $89793390dc5096e0$var$RejectWithValue) throw result;
                                                if (result instanceof $89793390dc5096e0$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $89793390dc5096e0$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($89793390dc5096e0$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $89793390dc5096e0$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $89793390dc5096e0$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var $89793390dc5096e0$var$matches = function(matcher, action) {
    if ($89793390dc5096e0$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $89793390dc5096e0$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $89793390dc5096e0$var$matches(matcher, action);
        });
    };
}
function $89793390dc5096e0$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $89793390dc5096e0$var$matches(matcher, action);
        });
    };
}
function $89793390dc5096e0$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $89793390dc5096e0$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $89793390dc5096e0$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $89793390dc5096e0$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$89793390dc5096e0$var$isAsyncThunkArray(asyncThunks)) return $89793390dc5096e0$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $89793390dc5096e0$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $89793390dc5096e0$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $89793390dc5096e0$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$89793390dc5096e0$var$isAsyncThunkArray(asyncThunks)) return $89793390dc5096e0$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $89793390dc5096e0$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $89793390dc5096e0$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $89793390dc5096e0$export$9dd1fb32974da385($89793390dc5096e0$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$89793390dc5096e0$var$isAsyncThunkArray(asyncThunks)) return $89793390dc5096e0$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $89793390dc5096e0$export$9dd1fb32974da385($89793390dc5096e0$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $89793390dc5096e0$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $89793390dc5096e0$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$89793390dc5096e0$var$isAsyncThunkArray(asyncThunks)) return $89793390dc5096e0$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $89793390dc5096e0$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $89793390dc5096e0$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $89793390dc5096e0$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$89793390dc5096e0$var$isAsyncThunkArray(asyncThunks)) return $89793390dc5096e0$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $89793390dc5096e0$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $89793390dc5096e0$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $89793390dc5096e0$var$noop = function() {};
var $89793390dc5096e0$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $89793390dc5096e0$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $89793390dc5096e0$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $89793390dc5096e0$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $89793390dc5096e0$var$task = "task";
var $89793390dc5096e0$var$listener = "listener";
var $89793390dc5096e0$var$completed = "completed";
var $89793390dc5096e0$var$cancelled = "cancelled";
var $89793390dc5096e0$var$taskCancelled = "task-" + $89793390dc5096e0$var$cancelled;
var $89793390dc5096e0$var$taskCompleted = "task-" + $89793390dc5096e0$var$completed;
var $89793390dc5096e0$var$listenerCancelled = $89793390dc5096e0$var$listener + "-" + $89793390dc5096e0$var$cancelled;
var $89793390dc5096e0$var$listenerCompleted = $89793390dc5096e0$var$listener + "-" + $89793390dc5096e0$var$completed;
var $89793390dc5096e0$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $89793390dc5096e0$var$task + " " + $89793390dc5096e0$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $89793390dc5096e0$var$validateActive = function(signal) {
    if (signal.aborted) throw new $89793390dc5096e0$export$cb1bdac908fed7f(signal.reason);
};
function $89793390dc5096e0$var$raceWithSignal(signal, promise2) {
    var cleanup = $89793390dc5096e0$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $89793390dc5096e0$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $89793390dc5096e0$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $89793390dc5096e0$var$noop;
    });
}
var $89793390dc5096e0$var$runTask = function(task2, cleanUp) {
    return $89793390dc5096e0$var$__async(void 0, null, function() {
        var value, error_1;
        return $89793390dc5096e0$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $89793390dc5096e0$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $89793390dc5096e0$var$createPause = function(signal) {
    return function(promise2) {
        return $89793390dc5096e0$var$catchRejection($89793390dc5096e0$var$raceWithSignal(signal, promise2).then(function(output) {
            $89793390dc5096e0$var$validateActive(signal);
            return output;
        }));
    };
};
var $89793390dc5096e0$var$createDelay = function(signal) {
    var pause = $89793390dc5096e0$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $89793390dc5096e0$var$assign = Object.assign;
var $89793390dc5096e0$var$INTERNAL_NIL_TOKEN = {};
var $89793390dc5096e0$var$alm = "listenerMiddleware";
var $89793390dc5096e0$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $89793390dc5096e0$var$addAbortSignalListener(parentAbortSignal, function() {
            return $89793390dc5096e0$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $89793390dc5096e0$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $89793390dc5096e0$var$runTask(function() {
            return $89793390dc5096e0$var$__async(void 0, null, function() {
                var result2;
                return $89793390dc5096e0$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $89793390dc5096e0$var$validateActive(parentAbortSignal);
                            $89793390dc5096e0$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $89793390dc5096e0$var$createPause(childAbortController.signal),
                                    delay: $89793390dc5096e0$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $89793390dc5096e0$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $89793390dc5096e0$var$abortControllerWithReason(childAbortController, $89793390dc5096e0$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result);
        return {
            result: $89793390dc5096e0$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $89793390dc5096e0$var$abortControllerWithReason(childAbortController, $89793390dc5096e0$var$taskCancelled);
            }
        };
    };
};
var $89793390dc5096e0$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $89793390dc5096e0$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $89793390dc5096e0$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $89793390dc5096e0$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $89793390dc5096e0$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $89793390dc5096e0$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $89793390dc5096e0$var$catchRejection(take(predicate, timeout));
    };
};
var $89793390dc5096e0$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $89793390dc5096e0$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $89793390dc5096e0$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $89793390dc5096e0$var$createListenerEntry = function(options) {
    var _c = $89793390dc5096e0$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $89793390dc5096e0$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $89793390dc5096e0$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $89793390dc5096e0$var$abortControllerWithReason(controller, $89793390dc5096e0$var$listenerCancelled);
    });
};
var $89793390dc5096e0$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($89793390dc5096e0$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $89793390dc5096e0$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $89793390dc5096e0$export$f03a6b845d3fb58b = $89793390dc5096e0$export$309c7a02b0b0bc62($89793390dc5096e0$var$alm + "/add");
var $89793390dc5096e0$export$b1b8022855fb2b71 = $89793390dc5096e0$export$309c7a02b0b0bc62($89793390dc5096e0$var$alm + "/removeAll");
var $89793390dc5096e0$export$b03e9483f936dccb = $89793390dc5096e0$export$309c7a02b0b0bc62($89793390dc5096e0$var$alm + "/remove");
var $89793390dc5096e0$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $89793390dc5096e0$var$__spreadArray([
        $89793390dc5096e0$var$alm + "/error"
    ], args));
};
function $89793390dc5096e0$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $89793390dc5096e0$var$defaultErrorHandler : _c;
    $89793390dc5096e0$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $89793390dc5096e0$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $89793390dc5096e0$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $89793390dc5096e0$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $89793390dc5096e0$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $89793390dc5096e0$var$__async(_this, null, function() {
            var internalTaskController, take, autoJoinPromises, listenerError_1;
            return $89793390dc5096e0$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $89793390dc5096e0$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $89793390dc5096e0$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $89793390dc5096e0$var$createDelay(internalTaskController.signal),
                                pause: $89793390dc5096e0$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $89793390dc5096e0$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $89793390dc5096e0$var$abortControllerWithReason(controller, $89793390dc5096e0$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $89793390dc5096e0$export$cb1bdac908fed7f)) $89793390dc5096e0$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            Promise.allSettled(autoJoinPromises)
                        ];
                    case 5:
                        _c.sent();
                        $89793390dc5096e0$var$abortControllerWithReason(internalTaskController, $89793390dc5096e0$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $89793390dc5096e0$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$89793390dc5096e0$export$b956e38827fca970(action)) return next(action);
                if ($89793390dc5096e0$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($89793390dc5096e0$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($89793390dc5096e0$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $89793390dc5096e0$var$INTERNAL_NIL_TOKEN) throw new Error($89793390dc5096e0$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $89793390dc5096e0$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $89793390dc5096e0$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $89793390dc5096e0$export$8fb31c0f05df007b = "RTK_autoBatch";
var $89793390dc5096e0$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$89793390dc5096e0$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $89793390dc5096e0$var$promise;
var $89793390dc5096e0$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($89793390dc5096e0$var$promise || ($89793390dc5096e0$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $89793390dc5096e0$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $89793390dc5096e0$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $89793390dc5096e0$var$createQueueWithTimer(10);
var $89793390dc5096e0$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $89793390dc5096e0$var$queueMicrotaskShim : options.type === "raf" ? $89793390dc5096e0$var$rAF : options.type === "callback" ? options.queueNotification : $89793390dc5096e0$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$89793390dc5096e0$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $keQ1f.enableES5)();

});
parcelRegister("36fSf", function(module, exports) {

$parcel$export(module.exports, "createSelector", () => $241e3eda1890e061$export$595d22ed68ca2841);
$parcel$export(module.exports, "defaultMemoize", () => (parcelRequire("iQsan")).defaultMemoize);

var $iQsan = parcelRequire("iQsan");
function $241e3eda1890e061$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $241e3eda1890e061$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $241e3eda1890e061$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $241e3eda1890e061$export$595d22ed68ca2841 = /* #__PURE__ */ $241e3eda1890e061$export$5943f4447f6ef248((0, $iQsan.defaultMemoize));
var $241e3eda1890e061$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $241e3eda1890e061$export$595d22ed68ca2841;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

});
parcelRegister("iQsan", function(module, exports) {

$parcel$export(module.exports, "defaultMemoize", () => $db82ee97f3a6bd39$export$281bff7f05488aa2);
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $db82ee97f3a6bd39$var$NOT_FOUND = "NOT_FOUND";
function $db82ee97f3a6bd39$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $db82ee97f3a6bd39$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $db82ee97f3a6bd39$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $db82ee97f3a6bd39$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $db82ee97f3a6bd39$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $db82ee97f3a6bd39$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $db82ee97f3a6bd39$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $db82ee97f3a6bd39$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $db82ee97f3a6bd39$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $db82ee97f3a6bd39$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $db82ee97f3a6bd39$var$createSingletonCache(comparator) : $db82ee97f3a6bd39$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $db82ee97f3a6bd39$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

});


parcelRegister("fxAau", function(module, exports) {

$parcel$export(module.exports, "default", () => $b505fe5765058d2b$export$2e2bcd8739ae039);
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $b505fe5765058d2b$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $b505fe5765058d2b$var$thunk = $b505fe5765058d2b$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$b505fe5765058d2b$var$thunk.withExtraArgument = $b505fe5765058d2b$var$createThunkMiddleware;
var $b505fe5765058d2b$export$2e2bcd8739ae039 = $b505fe5765058d2b$var$thunk;

});

parcelRegister("62jNV", function(module, exports) {
// shim for using process in browser
var $46524ab799ce86bb$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $46524ab799ce86bb$var$cachedSetTimeout;
var $46524ab799ce86bb$var$cachedClearTimeout;
function $46524ab799ce86bb$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $46524ab799ce86bb$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $46524ab799ce86bb$var$cachedSetTimeout = setTimeout;
        else $46524ab799ce86bb$var$cachedSetTimeout = $46524ab799ce86bb$var$defaultSetTimout;
    } catch (e) {
        $46524ab799ce86bb$var$cachedSetTimeout = $46524ab799ce86bb$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $46524ab799ce86bb$var$cachedClearTimeout = clearTimeout;
        else $46524ab799ce86bb$var$cachedClearTimeout = $46524ab799ce86bb$var$defaultClearTimeout;
    } catch (e) {
        $46524ab799ce86bb$var$cachedClearTimeout = $46524ab799ce86bb$var$defaultClearTimeout;
    }
})();
function $46524ab799ce86bb$var$runTimeout(fun) {
    if ($46524ab799ce86bb$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($46524ab799ce86bb$var$cachedSetTimeout === $46524ab799ce86bb$var$defaultSetTimout || !$46524ab799ce86bb$var$cachedSetTimeout) && setTimeout) {
        $46524ab799ce86bb$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $46524ab799ce86bb$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $46524ab799ce86bb$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $46524ab799ce86bb$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $46524ab799ce86bb$var$runClearTimeout(marker) {
    if ($46524ab799ce86bb$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($46524ab799ce86bb$var$cachedClearTimeout === $46524ab799ce86bb$var$defaultClearTimeout || !$46524ab799ce86bb$var$cachedClearTimeout) && clearTimeout) {
        $46524ab799ce86bb$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $46524ab799ce86bb$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $46524ab799ce86bb$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $46524ab799ce86bb$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $46524ab799ce86bb$var$queue = [];
var $46524ab799ce86bb$var$draining = false;
var $46524ab799ce86bb$var$currentQueue;
var $46524ab799ce86bb$var$queueIndex = -1;
function $46524ab799ce86bb$var$cleanUpNextTick() {
    if (!$46524ab799ce86bb$var$draining || !$46524ab799ce86bb$var$currentQueue) return;
    $46524ab799ce86bb$var$draining = false;
    if ($46524ab799ce86bb$var$currentQueue.length) $46524ab799ce86bb$var$queue = $46524ab799ce86bb$var$currentQueue.concat($46524ab799ce86bb$var$queue);
    else $46524ab799ce86bb$var$queueIndex = -1;
    if ($46524ab799ce86bb$var$queue.length) $46524ab799ce86bb$var$drainQueue();
}
function $46524ab799ce86bb$var$drainQueue() {
    if ($46524ab799ce86bb$var$draining) return;
    var timeout = $46524ab799ce86bb$var$runTimeout($46524ab799ce86bb$var$cleanUpNextTick);
    $46524ab799ce86bb$var$draining = true;
    var len = $46524ab799ce86bb$var$queue.length;
    while(len){
        $46524ab799ce86bb$var$currentQueue = $46524ab799ce86bb$var$queue;
        $46524ab799ce86bb$var$queue = [];
        while(++$46524ab799ce86bb$var$queueIndex < len)if ($46524ab799ce86bb$var$currentQueue) $46524ab799ce86bb$var$currentQueue[$46524ab799ce86bb$var$queueIndex].run();
        $46524ab799ce86bb$var$queueIndex = -1;
        len = $46524ab799ce86bb$var$queue.length;
    }
    $46524ab799ce86bb$var$currentQueue = null;
    $46524ab799ce86bb$var$draining = false;
    $46524ab799ce86bb$var$runClearTimeout(timeout);
}
$46524ab799ce86bb$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $46524ab799ce86bb$var$queue.push(new $46524ab799ce86bb$var$Item(fun, args));
    if ($46524ab799ce86bb$var$queue.length === 1 && !$46524ab799ce86bb$var$draining) $46524ab799ce86bb$var$runTimeout($46524ab799ce86bb$var$drainQueue);
};
// v8 likes predictible objects
function $46524ab799ce86bb$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$46524ab799ce86bb$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$46524ab799ce86bb$var$process.title = "browser";
$46524ab799ce86bb$var$process.browser = true;
$46524ab799ce86bb$var$process.env = {};
$46524ab799ce86bb$var$process.argv = [];
$46524ab799ce86bb$var$process.version = ""; // empty string to avoid regexp issues
$46524ab799ce86bb$var$process.versions = {};
function $46524ab799ce86bb$var$noop() {}
$46524ab799ce86bb$var$process.on = $46524ab799ce86bb$var$noop;
$46524ab799ce86bb$var$process.addListener = $46524ab799ce86bb$var$noop;
$46524ab799ce86bb$var$process.once = $46524ab799ce86bb$var$noop;
$46524ab799ce86bb$var$process.off = $46524ab799ce86bb$var$noop;
$46524ab799ce86bb$var$process.removeListener = $46524ab799ce86bb$var$noop;
$46524ab799ce86bb$var$process.removeAllListeners = $46524ab799ce86bb$var$noop;
$46524ab799ce86bb$var$process.emit = $46524ab799ce86bb$var$noop;
$46524ab799ce86bb$var$process.prependListener = $46524ab799ce86bb$var$noop;
$46524ab799ce86bb$var$process.prependOnceListener = $46524ab799ce86bb$var$noop;
$46524ab799ce86bb$var$process.listeners = function(name) {
    return [];
};
$46524ab799ce86bb$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$46524ab799ce86bb$var$process.cwd = function() {
    return "/";
};
$46524ab799ce86bb$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$46524ab799ce86bb$var$process.umask = function() {
    return 0;
};

});



parcelRegister("1owJc", function(module, exports) {

$parcel$export(module.exports, "createApi", () => $10416b6a180e6648$export$9cdc2b9a8d94c842);

var $laoDg = parcelRequire("laoDg");

var $bNLBQ = parcelRequire("bNLBQ");
var $36fSf = parcelRequire("36fSf");

var $3qjKr = parcelRequire("3qjKr");
parcelRequire("awG1R");
var $8Z31m = parcelRequire("8Z31m");
var $NSs2R = parcelRequire("NSs2R");
var $desaV = parcelRequire("desaV");
var $dId7s = parcelRequire("dId7s");
var $59UnK = parcelRequire("59UnK");
var $SielE = parcelRequire("SielE");

var $62jNV = parcelRequire("62jNV");
var $10416b6a180e6648$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $10416b6a180e6648$var$__defProp = Object.defineProperty;
var $10416b6a180e6648$var$__defProps = Object.defineProperties;
var $10416b6a180e6648$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $10416b6a180e6648$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $10416b6a180e6648$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $10416b6a180e6648$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $10416b6a180e6648$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $10416b6a180e6648$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $10416b6a180e6648$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($10416b6a180e6648$var$__hasOwnProp.call(b, prop)) $10416b6a180e6648$var$__defNormalProp(a, prop, b[prop]);
    if ($10416b6a180e6648$var$__getOwnPropSymbols) for(var _i = 0, _c = $10416b6a180e6648$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($10416b6a180e6648$var$__propIsEnum.call(b, prop)) $10416b6a180e6648$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $10416b6a180e6648$var$__spreadProps = function(a, b) {
    return $10416b6a180e6648$var$__defProps(a, $10416b6a180e6648$var$__getOwnPropDescs(b));
};
function $10416b6a180e6648$var$useStableQueryArgs(queryArgs, serialize, endpointDefinition, endpointName) {
    var incoming = (0, $3qjKr.useMemo)(function() {
        return {
            queryArgs: queryArgs,
            serialized: typeof queryArgs == "object" ? serialize({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            }) : queryArgs
        };
    }, [
        queryArgs,
        serialize,
        endpointDefinition,
        endpointName
    ]);
    var cache2 = (0, $3qjKr.useRef)(incoming);
    (0, $3qjKr.useEffect)(function() {
        if (cache2.current.serialized !== incoming.serialized) cache2.current = incoming;
    }, [
        incoming
    ]);
    return cache2.current.serialized === incoming.serialized ? cache2.current.queryArgs : queryArgs;
}
// src/query/react/constants.ts
var $10416b6a180e6648$var$UNINITIALIZED_VALUE = Symbol();
function $10416b6a180e6648$var$useShallowStableValue(value) {
    var cache2 = (0, $3qjKr.useRef)(value);
    (0, $3qjKr.useEffect)(function() {
        if (!(0, $desaV.default)(cache2.current, value)) cache2.current = value;
    }, [
        value
    ]);
    return (0, $desaV.default)(cache2.current, value) ? cache2.current : value;
}
var $10416b6a180e6648$var$cache = WeakMap ? new WeakMap() : void 0;
var $10416b6a180e6648$var$defaultSerializeQueryArgs = function(_c) {
    var endpointName = _c.endpointName, queryArgs = _c.queryArgs;
    var serialized = "";
    var cached = $10416b6a180e6648$var$cache == null ? void 0 : $10416b6a180e6648$var$cache.get(queryArgs);
    if (typeof cached === "string") serialized = cached;
    else {
        var stringified = JSON.stringify(queryArgs, function(key, value) {
            return (0, $bNLBQ.isPlainObject)(value) ? Object.keys(value).sort().reduce(function(acc, key2) {
                acc[key2] = value[key2];
                return acc;
            }, {}) : value;
        });
        if ((0, $bNLBQ.isPlainObject)(queryArgs)) $10416b6a180e6648$var$cache == null || $10416b6a180e6648$var$cache.set(queryArgs, stringified);
        serialized = stringified;
    }
    return endpointName + "(" + serialized + ")";
};
// src/query/react/buildHooks.ts
var $10416b6a180e6648$var$useIsomorphicLayoutEffect = typeof window !== "undefined" && !!window.document && !!window.document.createElement ? (0, $3qjKr.useLayoutEffect) : (0, $3qjKr.useEffect);
var $10416b6a180e6648$var$defaultMutationStateSelector = function(x) {
    return x;
};
var $10416b6a180e6648$var$noPendingQueryStateSelector = function(selected) {
    if (selected.isUninitialized) return $10416b6a180e6648$var$__spreadProps($10416b6a180e6648$var$__spreadValues({}, selected), {
        isUninitialized: false,
        isFetching: true,
        isLoading: selected.data !== void 0 ? false : true,
        status: (0, $laoDg.QueryStatus).pending
    });
    return selected;
};
function $10416b6a180e6648$var$buildHooks(_c) {
    var api = _c.api, _d = _c.moduleOptions, batch = _d.batch, useDispatch = _d.useDispatch, useSelector = _d.useSelector, useStore = _d.useStore, unstable__sideEffectsInRender = _d.unstable__sideEffectsInRender, serializeQueryArgs = _c.serializeQueryArgs, context = _c.context;
    var usePossiblyImmediateEffect = unstable__sideEffectsInRender ? function(cb) {
        return cb();
    } : (0, $3qjKr.useEffect);
    return {
        buildQueryHooks: buildQueryHooks,
        buildMutationHook: buildMutationHook,
        usePrefetch: usePrefetch
    };
    function queryStatePreSelector(currentState, lastResult, queryArgs) {
        if ((lastResult == null ? void 0 : lastResult.endpointName) && currentState.isUninitialized) {
            var endpointName = lastResult.endpointName;
            var endpointDefinition = context.endpointDefinitions[endpointName];
            if (serializeQueryArgs({
                queryArgs: lastResult.originalArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            }) === serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            })) lastResult = void 0;
        }
        var data = currentState.isSuccess ? currentState.data : lastResult == null ? void 0 : lastResult.data;
        if (data === void 0) data = currentState.data;
        var hasData = data !== void 0;
        var isFetching = currentState.isLoading;
        var isLoading = !hasData && isFetching;
        var isSuccess = currentState.isSuccess || isFetching && hasData;
        return $10416b6a180e6648$var$__spreadProps($10416b6a180e6648$var$__spreadValues({}, currentState), {
            data: data,
            currentData: currentState.data,
            isFetching: isFetching,
            isLoading: isLoading,
            isSuccess: isSuccess
        });
    }
    function usePrefetch(endpointName, defaultOptions) {
        var dispatch = useDispatch();
        var stableDefaultOptions = $10416b6a180e6648$var$useShallowStableValue(defaultOptions);
        return (0, $3qjKr.useCallback)(function(arg, options) {
            return dispatch(api.util.prefetch(endpointName, arg, $10416b6a180e6648$var$__spreadValues($10416b6a180e6648$var$__spreadValues({}, stableDefaultOptions), options)));
        }, [
            endpointName,
            dispatch,
            stableDefaultOptions
        ]);
    }
    function buildQueryHooks(name) {
        var useQuerySubscription = function(arg, _c) {
            var _d = _c === void 0 ? {} : _c, refetchOnReconnect = _d.refetchOnReconnect, refetchOnFocus = _d.refetchOnFocus, refetchOnMountOrArgChange = _d.refetchOnMountOrArgChange, _e = _d.skip, skip = _e === void 0 ? false : _e, _f = _d.pollingInterval, pollingInterval = _f === void 0 ? 0 : _f;
            var initiate = api.endpoints[name].initiate;
            var dispatch = useDispatch();
            var stableArg = $10416b6a180e6648$var$useStableQueryArgs(skip ? (0, $laoDg.skipToken) : arg, $10416b6a180e6648$var$defaultSerializeQueryArgs, context.endpointDefinitions[name], name);
            var stableSubscriptionOptions = $10416b6a180e6648$var$useShallowStableValue({
                refetchOnReconnect: refetchOnReconnect,
                refetchOnFocus: refetchOnFocus,
                pollingInterval: pollingInterval
            });
            var lastRenderHadSubscription = (0, $3qjKr.useRef)(false);
            var promiseRef = (0, $3qjKr.useRef)();
            var _g = promiseRef.current || {}, queryCacheKey = _g.queryCacheKey, requestId = _g.requestId;
            var currentRenderHasSubscription = false;
            if (queryCacheKey && requestId) {
                var returnedValue = dispatch(api.internalActions.internal_probeSubscription({
                    queryCacheKey: queryCacheKey,
                    requestId: requestId
                }));
                currentRenderHasSubscription = !!returnedValue;
            }
            var subscriptionRemoved = !currentRenderHasSubscription && lastRenderHadSubscription.current;
            usePossiblyImmediateEffect(function() {
                lastRenderHadSubscription.current = currentRenderHasSubscription;
            });
            usePossiblyImmediateEffect(function() {
                if (subscriptionRemoved) promiseRef.current = void 0;
            }, [
                subscriptionRemoved
            ]);
            usePossiblyImmediateEffect(function() {
                var _a;
                var lastPromise = promiseRef.current;
                typeof $62jNV;
                if (stableArg === (0, $laoDg.skipToken)) {
                    lastPromise == null || lastPromise.unsubscribe();
                    promiseRef.current = void 0;
                    return;
                }
                var lastSubscriptionOptions = (_a = promiseRef.current) == null ? void 0 : _a.subscriptionOptions;
                if (!lastPromise || lastPromise.arg !== stableArg) {
                    lastPromise == null || lastPromise.unsubscribe();
                    var promise = dispatch(initiate(stableArg, {
                        subscriptionOptions: stableSubscriptionOptions,
                        forceRefetch: refetchOnMountOrArgChange
                    }));
                    promiseRef.current = promise;
                } else if (stableSubscriptionOptions !== lastSubscriptionOptions) lastPromise.updateSubscriptionOptions(stableSubscriptionOptions);
            }, [
                dispatch,
                initiate,
                refetchOnMountOrArgChange,
                stableArg,
                stableSubscriptionOptions,
                subscriptionRemoved
            ]);
            (0, $3qjKr.useEffect)(function() {
                return function() {
                    var _a;
                    (_a = promiseRef.current) == null || _a.unsubscribe();
                    promiseRef.current = void 0;
                };
            }, []);
            return (0, $3qjKr.useMemo)(function() {
                return {
                    refetch: function() {
                        var _a;
                        if (!promiseRef.current) throw new Error("Cannot refetch a query that has not been started yet.");
                        return (_a = promiseRef.current) == null ? void 0 : _a.refetch();
                    }
                };
            }, []);
        };
        var useLazyQuerySubscription = function(_c) {
            var _d = _c === void 0 ? {} : _c, refetchOnReconnect = _d.refetchOnReconnect, refetchOnFocus = _d.refetchOnFocus, _e = _d.pollingInterval, pollingInterval = _e === void 0 ? 0 : _e;
            var initiate = api.endpoints[name].initiate;
            var dispatch = useDispatch();
            var _f = (0, $3qjKr.useState)($10416b6a180e6648$var$UNINITIALIZED_VALUE), arg = _f[0], setArg = _f[1];
            var promiseRef = (0, $3qjKr.useRef)();
            var stableSubscriptionOptions = $10416b6a180e6648$var$useShallowStableValue({
                refetchOnReconnect: refetchOnReconnect,
                refetchOnFocus: refetchOnFocus,
                pollingInterval: pollingInterval
            });
            usePossiblyImmediateEffect(function() {
                var _a, _b;
                var lastSubscriptionOptions = (_a = promiseRef.current) == null ? void 0 : _a.subscriptionOptions;
                if (stableSubscriptionOptions !== lastSubscriptionOptions) (_b = promiseRef.current) == null || _b.updateSubscriptionOptions(stableSubscriptionOptions);
            }, [
                stableSubscriptionOptions
            ]);
            var subscriptionOptionsRef = (0, $3qjKr.useRef)(stableSubscriptionOptions);
            usePossiblyImmediateEffect(function() {
                subscriptionOptionsRef.current = stableSubscriptionOptions;
            }, [
                stableSubscriptionOptions
            ]);
            var trigger = (0, $3qjKr.useCallback)(function(arg2, preferCacheValue) {
                if (preferCacheValue === void 0) preferCacheValue = false;
                var promise;
                batch(function() {
                    var _a;
                    (_a = promiseRef.current) == null || _a.unsubscribe();
                    promiseRef.current = promise = dispatch(initiate(arg2, {
                        subscriptionOptions: subscriptionOptionsRef.current,
                        forceRefetch: !preferCacheValue
                    }));
                    setArg(arg2);
                });
                return promise;
            }, [
                dispatch,
                initiate
            ]);
            (0, $3qjKr.useEffect)(function() {
                return function() {
                    var _a;
                    (_a = promiseRef == null ? void 0 : promiseRef.current) == null || _a.unsubscribe();
                };
            }, []);
            (0, $3qjKr.useEffect)(function() {
                if (arg !== $10416b6a180e6648$var$UNINITIALIZED_VALUE && !promiseRef.current) trigger(arg, true);
            }, [
                arg,
                trigger
            ]);
            return (0, $3qjKr.useMemo)(function() {
                return [
                    trigger,
                    arg
                ];
            }, [
                trigger,
                arg
            ]);
        };
        var useQueryState = function(arg, _c) {
            var _d = _c === void 0 ? {} : _c, _e = _d.skip, skip = _e === void 0 ? false : _e, selectFromResult = _d.selectFromResult;
            var select = api.endpoints[name].select;
            var stableArg = $10416b6a180e6648$var$useStableQueryArgs(skip ? (0, $laoDg.skipToken) : arg, serializeQueryArgs, context.endpointDefinitions[name], name);
            var lastValue = (0, $3qjKr.useRef)();
            var selectDefaultResult = (0, $3qjKr.useMemo)(function() {
                return (0, $36fSf.createSelector)([
                    select(stableArg),
                    function(_, lastResult) {
                        return lastResult;
                    },
                    function(_) {
                        return stableArg;
                    }
                ], queryStatePreSelector);
            }, [
                select,
                stableArg
            ]);
            var querySelector = (0, $3qjKr.useMemo)(function() {
                return selectFromResult ? (0, $36fSf.createSelector)([
                    selectDefaultResult
                ], selectFromResult) : selectDefaultResult;
            }, [
                selectDefaultResult,
                selectFromResult
            ]);
            var currentState = useSelector(function(state) {
                return querySelector(state, lastValue.current);
            }, (0, $desaV.default));
            var store = useStore();
            var newLastValue = selectDefaultResult(store.getState(), lastValue.current);
            $10416b6a180e6648$var$useIsomorphicLayoutEffect(function() {
                lastValue.current = newLastValue;
            }, [
                newLastValue
            ]);
            return currentState;
        };
        return {
            useQueryState: useQueryState,
            useQuerySubscription: useQuerySubscription,
            useLazyQuerySubscription: useLazyQuerySubscription,
            useLazyQuery: function(options) {
                var _c = useLazyQuerySubscription(options), trigger = _c[0], arg = _c[1];
                var queryStateResults = useQueryState(arg, $10416b6a180e6648$var$__spreadProps($10416b6a180e6648$var$__spreadValues({}, options), {
                    skip: arg === $10416b6a180e6648$var$UNINITIALIZED_VALUE
                }));
                var info = (0, $3qjKr.useMemo)(function() {
                    return {
                        lastArg: arg
                    };
                }, [
                    arg
                ]);
                return (0, $3qjKr.useMemo)(function() {
                    return [
                        trigger,
                        queryStateResults,
                        info
                    ];
                }, [
                    trigger,
                    queryStateResults,
                    info
                ]);
            },
            useQuery: function(arg, options) {
                var querySubscriptionResults = useQuerySubscription(arg, options);
                var queryStateResults = useQueryState(arg, $10416b6a180e6648$var$__spreadValues({
                    selectFromResult: arg === (0, $laoDg.skipToken) || (options == null ? void 0 : options.skip) ? void 0 : $10416b6a180e6648$var$noPendingQueryStateSelector
                }, options));
                var data = queryStateResults.data, status = queryStateResults.status, isLoading = queryStateResults.isLoading, isSuccess = queryStateResults.isSuccess, isError = queryStateResults.isError, error = queryStateResults.error;
                (0, $3qjKr.useDebugValue)({
                    data: data,
                    status: status,
                    isLoading: isLoading,
                    isSuccess: isSuccess,
                    isError: isError,
                    error: error
                });
                return (0, $3qjKr.useMemo)(function() {
                    return $10416b6a180e6648$var$__spreadValues($10416b6a180e6648$var$__spreadValues({}, queryStateResults), querySubscriptionResults);
                }, [
                    queryStateResults,
                    querySubscriptionResults
                ]);
            }
        };
    }
    function buildMutationHook(name) {
        return function(_c) {
            var _d = _c === void 0 ? {} : _c, _e = _d.selectFromResult, selectFromResult = _e === void 0 ? $10416b6a180e6648$var$defaultMutationStateSelector : _e, fixedCacheKey = _d.fixedCacheKey;
            var _f = api.endpoints[name], select = _f.select, initiate = _f.initiate;
            var dispatch = useDispatch();
            var _g = (0, $3qjKr.useState)(), promise = _g[0], setPromise = _g[1];
            (0, $3qjKr.useEffect)(function() {
                return function() {
                    if (!(promise == null ? void 0 : promise.arg.fixedCacheKey)) promise == null || promise.reset();
                };
            }, [
                promise
            ]);
            var triggerMutation = (0, $3qjKr.useCallback)(function(arg) {
                var promise2 = dispatch(initiate(arg, {
                    fixedCacheKey: fixedCacheKey
                }));
                setPromise(promise2);
                return promise2;
            }, [
                dispatch,
                initiate,
                fixedCacheKey
            ]);
            var requestId = (promise || {}).requestId;
            var mutationSelector = (0, $3qjKr.useMemo)(function() {
                return (0, $36fSf.createSelector)([
                    select({
                        fixedCacheKey: fixedCacheKey,
                        requestId: promise == null ? void 0 : promise.requestId
                    })
                ], selectFromResult);
            }, [
                select,
                promise,
                selectFromResult,
                fixedCacheKey
            ]);
            var currentState = useSelector(mutationSelector, (0, $desaV.default));
            var originalArgs = fixedCacheKey == null ? promise == null ? void 0 : promise.arg.originalArgs : void 0;
            var reset = (0, $3qjKr.useCallback)(function() {
                batch(function() {
                    if (promise) setPromise(void 0);
                    if (fixedCacheKey) dispatch(api.internalActions.removeMutationResult({
                        requestId: requestId,
                        fixedCacheKey: fixedCacheKey
                    }));
                });
            }, [
                dispatch,
                fixedCacheKey,
                promise,
                requestId
            ]);
            var endpointName = currentState.endpointName, data = currentState.data, status = currentState.status, isLoading = currentState.isLoading, isSuccess = currentState.isSuccess, isError = currentState.isError, error = currentState.error;
            (0, $3qjKr.useDebugValue)({
                endpointName: endpointName,
                data: data,
                status: status,
                isLoading: isLoading,
                isSuccess: isSuccess,
                isError: isError,
                error: error
            });
            var finalState = (0, $3qjKr.useMemo)(function() {
                return $10416b6a180e6648$var$__spreadProps($10416b6a180e6648$var$__spreadValues({}, currentState), {
                    originalArgs: originalArgs,
                    reset: reset
                });
            }, [
                currentState,
                originalArgs,
                reset
            ]);
            return (0, $3qjKr.useMemo)(function() {
                return [
                    triggerMutation,
                    finalState
                ];
            }, [
                triggerMutation,
                finalState
            ]);
        };
    }
}
// src/query/endpointDefinitions.ts
var $10416b6a180e6648$var$DefinitionType;
(function(DefinitionType2) {
    DefinitionType2["query"] = "query";
    DefinitionType2["mutation"] = "mutation";
})($10416b6a180e6648$var$DefinitionType || ($10416b6a180e6648$var$DefinitionType = {}));
function $10416b6a180e6648$var$isQueryDefinition(e) {
    return e.type === $10416b6a180e6648$var$DefinitionType.query;
}
function $10416b6a180e6648$var$isMutationDefinition(e) {
    return e.type === $10416b6a180e6648$var$DefinitionType.mutation;
}
// src/query/utils/capitalize.ts
function $10416b6a180e6648$var$capitalize(str) {
    return str.replace(str[0], str[0].toUpperCase());
}
// src/query/tsHelpers.ts
function $10416b6a180e6648$var$safeAssign(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    Object.assign.apply(Object, $10416b6a180e6648$var$__spreadArray([
        target
    ], args));
}
var $10416b6a180e6648$export$fba4c1b64338c09f = /* @__PURE__ */ Symbol();
var $10416b6a180e6648$export$8b98f9e72008ec90 = function(_c) {
    var _d = _c === void 0 ? {} : _c, _e = _d.batch, batch = _e === void 0 ? (0, $8Z31m.unstable_batchedUpdates) : _e, _f = _d.useDispatch, useDispatch = _f === void 0 ? (0, $dId7s.useDispatch) : _f, _g = _d.useSelector, useSelector = _g === void 0 ? (0, $59UnK.useSelector) : _g, _h = _d.useStore, useStore = _h === void 0 ? (0, $SielE.useStore) : _h, _j = _d.unstable__sideEffectsInRender, unstable__sideEffectsInRender = _j === void 0 ? false : _j;
    return {
        name: $10416b6a180e6648$export$fba4c1b64338c09f,
        init: function(api, _c, context) {
            var serializeQueryArgs = _c.serializeQueryArgs;
            var anyApi = api;
            var _d = $10416b6a180e6648$var$buildHooks({
                api: api,
                moduleOptions: {
                    batch: batch,
                    useDispatch: useDispatch,
                    useSelector: useSelector,
                    useStore: useStore,
                    unstable__sideEffectsInRender: unstable__sideEffectsInRender
                },
                serializeQueryArgs: serializeQueryArgs,
                context: context
            }), buildQueryHooks = _d.buildQueryHooks, buildMutationHook = _d.buildMutationHook, usePrefetch = _d.usePrefetch;
            $10416b6a180e6648$var$safeAssign(anyApi, {
                usePrefetch: usePrefetch
            });
            $10416b6a180e6648$var$safeAssign(context, {
                batch: batch
            });
            return {
                injectEndpoint: function(endpointName, definition) {
                    if ($10416b6a180e6648$var$isQueryDefinition(definition)) {
                        var _c = buildQueryHooks(endpointName), useQuery = _c.useQuery, useLazyQuery = _c.useLazyQuery, useLazyQuerySubscription = _c.useLazyQuerySubscription, useQueryState = _c.useQueryState, useQuerySubscription = _c.useQuerySubscription;
                        $10416b6a180e6648$var$safeAssign(anyApi.endpoints[endpointName], {
                            useQuery: useQuery,
                            useLazyQuery: useLazyQuery,
                            useLazyQuerySubscription: useLazyQuerySubscription,
                            useQueryState: useQueryState,
                            useQuerySubscription: useQuerySubscription
                        });
                        api["use" + $10416b6a180e6648$var$capitalize(endpointName) + "Query"] = useQuery;
                        api["useLazy" + $10416b6a180e6648$var$capitalize(endpointName) + "Query"] = useLazyQuery;
                    } else if ($10416b6a180e6648$var$isMutationDefinition(definition)) {
                        var useMutation = buildMutationHook(endpointName);
                        $10416b6a180e6648$var$safeAssign(anyApi.endpoints[endpointName], {
                            useMutation: useMutation
                        });
                        api["use" + $10416b6a180e6648$var$capitalize(endpointName) + "Mutation"] = useMutation;
                    }
                }
            };
        }
    };
};
function $10416b6a180e6648$export$f4e57f6132f56752(props) {
    var store = (0, (/*@__PURE__*/$parcel$interopDefault($3qjKr))).useState(function() {
        var _c;
        return (0, $bNLBQ.configureStore)({
            reducer: (_c = {}, _c[props.api.reducerPath] = props.api.reducer, _c),
            middleware: function(gDM) {
                return gDM().concat(props.api.middleware);
            }
        });
    })[0];
    (0, $3qjKr.useEffect)(function() {
        return props.setupListeners === false ? void 0 : (0, $laoDg.setupListeners)(store.dispatch, props.setupListeners);
    }, [
        props.setupListeners,
        store.dispatch
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($3qjKr))).createElement((0, $NSs2R.default), {
        store: store,
        context: props.context
    }, props.children);
}
// src/query/react/index.ts
var $10416b6a180e6648$export$9cdc2b9a8d94c842 = /* @__PURE__ */ (0, $laoDg.buildCreateApi)((0, $laoDg.coreModule)(), $10416b6a180e6648$export$8b98f9e72008ec90());

});
parcelRegister("awG1R", function(module, exports) {
$parcel$export(module.exports, "Provider", () => (parcelRequire("NSs2R")).default);
$parcel$export(module.exports, "shallowEqual", () => (parcelRequire("desaV")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("dId7s")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("59UnK")).useSelector);
$parcel$export(module.exports, "useStore", () => (parcelRequire("SielE")).useStore);

$parcel$export(module.exports, "batch", () => (parcelRequire("8Z31m")).unstable_batchedUpdates);
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $bKfyC = parcelRequire("bKfyC");

var $8cl4N = parcelRequire("8cl4N");
parcelRequire("6CcQt");
var $8Z31m = parcelRequire("8Z31m");

var $cxe0r = parcelRequire("cxe0r");

var $59UnK = parcelRequire("59UnK");

var $hqkoz = parcelRequire("hqkoz");
parcelRequire("66q2t");
(0, $59UnK.initializeUseSelector)((0, $8cl4N.useSyncExternalStoreWithSelector));
(0, $hqkoz.initializeConnect)((0, $bKfyC.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $cxe0r.setBatch)((0, $8Z31m.unstable_batchedUpdates));

});
parcelRegister("8cl4N", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ebuv3"));

});

parcelRegister("6CcQt", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("8Z31m")).unstable_batchedUpdates);

var $8Z31m = parcelRequire("8Z31m");

});
parcelRegister("8Z31m", function(module, exports) {
"use strict";
function $68a65d1dd4685a53$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($68a65d1dd4685a53$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$68a65d1dd4685a53$var$checkDCE();

module.exports = (parcelRequire("270oX"));

});


parcelRegister("cxe0r", function(module, exports) {

$parcel$export(module.exports, "setBatch", () => $025ae4e0a667e819$export$4b9874722d0da7bc);
$parcel$export(module.exports, "getBatch", () => $025ae4e0a667e819$export$fc47d4c0ba3bd2c6);
// Default to a dummy "batch" implementation that just runs the callback
function $025ae4e0a667e819$var$defaultNoopBatch(callback) {
    callback();
}
let $025ae4e0a667e819$var$batch = $025ae4e0a667e819$var$defaultNoopBatch; // Allow injecting another batching function later
const $025ae4e0a667e819$export$4b9874722d0da7bc = (newBatch)=>$025ae4e0a667e819$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $025ae4e0a667e819$export$fc47d4c0ba3bd2c6 = ()=>$025ae4e0a667e819$var$batch;

});

parcelRegister("59UnK", function(module, exports) {

$parcel$export(module.exports, "initializeUseSelector", () => $3c19874fa2920570$export$e2e6e3f3f3b782e3);
$parcel$export(module.exports, "useSelector", () => $3c19874fa2920570$export$2105062e25df4afe);

var $3qjKr = parcelRequire("3qjKr");

var $bDeiz = parcelRequire("bDeiz");

var $jX5tX = parcelRequire("jX5tX");

var $kNYrp = parcelRequire("kNYrp");
let $3c19874fa2920570$var$useSyncExternalStoreWithSelector = (0, $kNYrp.notInitialized);
const $3c19874fa2920570$export$e2e6e3f3f3b782e3 = (fn)=>{
    $3c19874fa2920570$var$useSyncExternalStoreWithSelector = fn;
};
const $3c19874fa2920570$var$refEquality = (a, b)=>a === b;
function $3c19874fa2920570$export$2b53f90d2bd1cbfb(context = (0, $jX5tX.ReactReduxContext)) {
    const useReduxContext = context === (0, $jX5tX.ReactReduxContext) ? (0, $bDeiz.useReduxContext) : (0, $bDeiz.createReduxContextHook)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $3c19874fa2920570$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $3qjKr.useRef)(true);
        const wrappedSelector = (0, $3qjKr.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $3c19874fa2920570$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $3qjKr.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $3c19874fa2920570$export$2105062e25df4afe = /*#__PURE__*/ $3c19874fa2920570$export$2b53f90d2bd1cbfb();

});
parcelRegister("bDeiz", function(module, exports) {

$parcel$export(module.exports, "createReduxContextHook", () => $877e6d9bc68864dd$export$d4d6226d5fc61558);
$parcel$export(module.exports, "useReduxContext", () => $877e6d9bc68864dd$export$c1275ca9a6fd3ec5);

var $3qjKr = parcelRequire("3qjKr");

var $jX5tX = parcelRequire("jX5tX");
function $877e6d9bc68864dd$export$d4d6226d5fc61558(context = (0, $jX5tX.ReactReduxContext)) {
    return function useReduxContext() {
        const contextValue = (0, $3qjKr.useContext)(context);
        return contextValue;
    };
}
const $877e6d9bc68864dd$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $877e6d9bc68864dd$export$d4d6226d5fc61558();

});
parcelRegister("jX5tX", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", () => $e867c7a87639bc67$export$cc80c08dc91f1c00);

var $3qjKr = parcelRequire("3qjKr");
const $e867c7a87639bc67$var$ContextKey = Symbol.for(`react-redux-context`);
const $e867c7a87639bc67$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $e867c7a87639bc67$var$getContext() {
    var _gT$ContextKey;
    if (!$3qjKr.createContext) return {};
    const contextMap = (_gT$ContextKey = $e867c7a87639bc67$var$gT[$e867c7a87639bc67$var$ContextKey]) != null ? _gT$ContextKey : $e867c7a87639bc67$var$gT[$e867c7a87639bc67$var$ContextKey] = new Map();
    let realContext = contextMap.get($3qjKr.createContext);
    if (!realContext) {
        realContext = $3qjKr.createContext(null);
        contextMap.set($3qjKr.createContext, realContext);
    }
    return realContext;
}
const $e867c7a87639bc67$export$cc80c08dc91f1c00 = /*#__PURE__*/ $e867c7a87639bc67$var$getContext();
var $e867c7a87639bc67$export$2e2bcd8739ae039 = $e867c7a87639bc67$export$cc80c08dc91f1c00;

});


parcelRegister("kNYrp", function(module, exports) {

$parcel$export(module.exports, "notInitialized", () => $f2574490a0546b2c$export$20656a4825650bd0);
const $f2574490a0546b2c$export$20656a4825650bd0 = ()=>{
    throw new Error("uSES not initialized!");
};

});


parcelRegister("hqkoz", function(module, exports) {

$parcel$export(module.exports, "initializeConnect", () => $caf4af7555d98337$export$36d45daa6a4925b8);

var $50wIY = parcelRequire("50wIY");

var $3mDYF = parcelRequire("3mDYF");

var $i7wrp = parcelRequire("i7wrp");

var $3qjKr = parcelRequire("3qjKr");

var $18dcE = parcelRequire("18dcE");

var $6lYps = parcelRequire("6lYps");

var $85AGB = parcelRequire("85AGB");

var $7WXPd = parcelRequire("7WXPd");

var $7W3XE = parcelRequire("7W3XE");

var $3V94t = parcelRequire("3V94t");

var $dsZ8a = parcelRequire("dsZ8a");

var $desaV = parcelRequire("desaV");
parcelRequire("2L986");

var $jX5tX = parcelRequire("jX5tX");

var $kNYrp = parcelRequire("kNYrp");
const $caf4af7555d98337$var$_excluded = [
    "reactReduxForwardedRef"
];
let $caf4af7555d98337$var$useSyncExternalStore = (0, $kNYrp.notInitialized);
const $caf4af7555d98337$export$36d45daa6a4925b8 = (fn)=>{
    $caf4af7555d98337$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $caf4af7555d98337$var$EMPTY_ARRAY = [
    null,
    0
];
const $caf4af7555d98337$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $caf4af7555d98337$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $caf4af7555d98337$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $dsZ8a.useIsomorphicLayoutEffect)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $caf4af7555d98337$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $caf4af7555d98337$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $caf4af7555d98337$var$initStateUpdates = ()=>$caf4af7555d98337$var$EMPTY_ARRAY;
function $caf4af7555d98337$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $caf4af7555d98337$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $caf4af7555d98337$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $caf4af7555d98337$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $desaV.default), areStatePropsEqual: areStatePropsEqual = (0, $desaV.default), areMergedPropsEqual: areMergedPropsEqual = (0, $desaV.default), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $jX5tX.ReactReduxContext) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $7WXPd.mapStateToPropsFactory)(mapStateToProps);
    const initMapDispatchToProps = (0, $85AGB.mapDispatchToPropsFactory)(mapDispatchToProps);
    const initMergeProps = (0, $7W3XE.mergePropsFactory)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $3qjKr.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $3mDYF.default)(props, $caf4af7555d98337$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $3qjKr.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $18dcE.isContextConsumer)(/*#__PURE__*/ $3qjKr.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $3qjKr.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $3qjKr.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $6lYps.default)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $3qjKr.useMemo(()=>{
                if (!shouldHandleStateChanges) return $caf4af7555d98337$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $3V94t.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $3qjKr.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $50wIY.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $3qjKr.useRef();
            const lastWrapperProps = $3qjKr.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $3qjKr.useRef();
            const renderIsScheduled = $3qjKr.useRef(false);
            const isProcessingDispatch = $3qjKr.useRef(false);
            const isMounted = $3qjKr.useRef(false);
            const latestSubscriptionCallbackError = $3qjKr.useRef();
            (0, $dsZ8a.useIsomorphicLayoutEffect)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $3qjKr.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $3qjKr.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $caf4af7555d98337$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $caf4af7555d98337$var$useIsomorphicLayoutEffectWithArgs($caf4af7555d98337$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $caf4af7555d98337$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $dsZ8a.useIsomorphicLayoutEffect)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $3qjKr.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $3qjKr.createElement(WrappedComponent, (0, $50wIY.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $3qjKr.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $3qjKr.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $3qjKr.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $3qjKr.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $3qjKr.createElement(Connect, (0, $50wIY.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($i7wrp)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($i7wrp)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $caf4af7555d98337$export$2e2bcd8739ae039 = $caf4af7555d98337$var$connect;

});
parcelRegister("3mDYF", function(module, exports) {

$parcel$export(module.exports, "default", () => $27326fdf1d89b5f9$export$2e2bcd8739ae039);
function $27326fdf1d89b5f9$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("18dcE", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dAglg"));

});

parcelRegister("6lYps", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a039056a6e90448$export$2e2bcd8739ae039);

var $3mDYF = parcelRequire("3mDYF");
parcelRequire("lbxFQ");
const $4a039056a6e90448$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $4a039056a6e90448$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $4a039056a6e90448$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $3mDYF.default)(_ref, $4a039056a6e90448$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $4a039056a6e90448$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("lbxFQ", function(module, exports) {

var $2L986 = parcelRequire("2L986");
function $f6c4befd309e2184$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $2L986.default)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $f6c4befd309e2184$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $f6c4befd309e2184$var$verify(mapStateToProps, "mapStateToProps");
    $f6c4befd309e2184$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $f6c4befd309e2184$var$verify(mergeProps, "mergeProps");
}

});
parcelRegister("2L986", function(module, exports) {

$parcel$export(module.exports, "default", () => $20270d8859705f44$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $20270d8859705f44$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});



parcelRegister("85AGB", function(module, exports) {

$parcel$export(module.exports, "mapDispatchToPropsFactory", () => $5e3b3f7913eeed2d$export$b69a785ceac019a6);

var $g2aih = parcelRequire("g2aih");

var $fWwn4 = parcelRequire("fWwn4");

var $a4XY6 = parcelRequire("a4XY6");
function $5e3b3f7913eeed2d$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $fWwn4.wrapMapToPropsConstant)((dispatch)=>(0, $g2aih.default)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $fWwn4.wrapMapToPropsConstant)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? (0, $fWwn4.wrapMapToPropsFunc)(mapDispatchToProps, "mapDispatchToProps") : (0, $a4XY6.createInvalidArgFactory)(mapDispatchToProps, "mapDispatchToProps");
}

});
parcelRegister("g2aih", function(module, exports) {

$parcel$export(module.exports, "default", () => $bac4d15e27333c66$export$2e2bcd8739ae039);
function $bac4d15e27333c66$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}

});

parcelRegister("fWwn4", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", () => $b9b56201283d2fef$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $b9b56201283d2fef$export$8d46c7f53c8c602f);
parcelRequire("7HhAu");
function $b9b56201283d2fef$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $b9b56201283d2fef$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $b9b56201283d2fef$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $b9b56201283d2fef$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $b9b56201283d2fef$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("7HhAu", function(module, exports) {

var $e60Xj = parcelRequire("e60Xj");

var $2L986 = parcelRequire("2L986");
function $59aa3112b180a25a$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $e60Xj.default)(value)) (0, $2L986.default)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}

});
parcelRegister("e60Xj", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4325e0017bb3066$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $a4325e0017bb3066$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});



parcelRegister("a4XY6", function(module, exports) {

$parcel$export(module.exports, "createInvalidArgFactory", () => $7568cb903acd8caf$export$19ef7b929f7e2559);
function $7568cb903acd8caf$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}

});


parcelRegister("7WXPd", function(module, exports) {

$parcel$export(module.exports, "mapStateToPropsFactory", () => $5c9c5b3169eeba99$export$e00e93951827eda7);

var $fWwn4 = parcelRequire("fWwn4");

var $a4XY6 = parcelRequire("a4XY6");
function $5c9c5b3169eeba99$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $fWwn4.wrapMapToPropsConstant)(()=>({})) : typeof mapStateToProps === "function" ? (0, $fWwn4.wrapMapToPropsFunc)(mapStateToProps, "mapStateToProps") : (0, $a4XY6.createInvalidArgFactory)(mapStateToProps, "mapStateToProps");
}

});

parcelRegister("7W3XE", function(module, exports) {

$parcel$export(module.exports, "mergePropsFactory", () => $5c7105ccfc4f2547$export$17457cf6fa742f84);

var $50wIY = parcelRequire("50wIY");
parcelRequire("7HhAu");

var $a4XY6 = parcelRequire("a4XY6");
function $5c7105ccfc4f2547$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $50wIY.default)({}, ownProps, stateProps, dispatchProps);
}
function $5c7105ccfc4f2547$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $5c7105ccfc4f2547$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$5c7105ccfc4f2547$export$691c327fc30bc857 : typeof mergeProps === "function" ? $5c7105ccfc4f2547$export$5b105939c84b5234(mergeProps) : (0, $a4XY6.createInvalidArgFactory)(mergeProps, "mergeProps");
}

});

parcelRegister("3V94t", function(module, exports) {

$parcel$export(module.exports, "createSubscription", () => $2dadbb4ede3c568b$export$d567d2b9af322f8f);

var $cxe0r = parcelRequire("cxe0r");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $2dadbb4ede3c568b$var$createListenerCollection() {
    const batch = (0, $cxe0r.getBatch)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $2dadbb4ede3c568b$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $2dadbb4ede3c568b$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $2dadbb4ede3c568b$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $2dadbb4ede3c568b$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $2dadbb4ede3c568b$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}

});

parcelRegister("dsZ8a", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $9cdd4f30c59b3cf5$export$700979bc83e7db82);

var $3qjKr = parcelRequire("3qjKr");
const $9cdd4f30c59b3cf5$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $9cdd4f30c59b3cf5$export$700979bc83e7db82 = $9cdd4f30c59b3cf5$export$71594e8a50f746f4 ? $3qjKr.useLayoutEffect : $3qjKr.useEffect;

});

parcelRegister("desaV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a22702d3221409f$export$2e2bcd8739ae039);
function $9a22702d3221409f$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $9a22702d3221409f$export$2e2bcd8739ae039(objA, objB) {
    if ($9a22702d3221409f$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$9a22702d3221409f$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});


parcelRegister("66q2t", function(module, exports) {

$parcel$export(module.exports, "Provider", () => (parcelRequire("NSs2R")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("dId7s")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("59UnK")).useSelector);
$parcel$export(module.exports, "useStore", () => (parcelRequire("SielE")).useStore);
$parcel$export(module.exports, "shallowEqual", () => (parcelRequire("desaV")).default);

var $NSs2R = parcelRequire("NSs2R");

var $hqkoz = parcelRequire("hqkoz");

var $jX5tX = parcelRequire("jX5tX");

var $dId7s = parcelRequire("dId7s");

var $59UnK = parcelRequire("59UnK");

var $SielE = parcelRequire("SielE");

var $desaV = parcelRequire("desaV");
parcelRequire("3nkSi");

});
parcelRegister("NSs2R", function(module, exports) {

$parcel$export(module.exports, "default", () => $095ed09ec424800d$export$2e2bcd8739ae039);

var $3qjKr = parcelRequire("3qjKr");

var $jX5tX = parcelRequire("jX5tX");

var $3V94t = parcelRequire("3V94t");

var $dsZ8a = parcelRequire("dsZ8a");
function $095ed09ec424800d$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", noopCheck: noopCheck = "once" }) {
    const contextValue = $3qjKr.useMemo(()=>{
        const subscription = (0, $3V94t.createSubscription)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $3qjKr.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $dsZ8a.useIsomorphicLayoutEffect)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $jX5tX.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $3qjKr.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $095ed09ec424800d$export$2e2bcd8739ae039 = $095ed09ec424800d$var$Provider;

});

parcelRegister("dId7s", function(module, exports) {

$parcel$export(module.exports, "useDispatch", () => $9fb98fa27274f21b$export$8ad76b76a4c905f8);

var $jX5tX = parcelRequire("jX5tX");

var $SielE = parcelRequire("SielE");
function $9fb98fa27274f21b$export$bc9b55530897c558(context = (0, $jX5tX.ReactReduxContext)) {
    const useStore = context === (0, $jX5tX.ReactReduxContext) ? (0, $SielE.useStore) : (0, $SielE.createStoreHook)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $9fb98fa27274f21b$export$8ad76b76a4c905f8 = /*#__PURE__*/ $9fb98fa27274f21b$export$bc9b55530897c558();

});
parcelRegister("SielE", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", () => $0a332f714a54cff3$export$671dba69185d0304);
$parcel$export(module.exports, "useStore", () => $0a332f714a54cff3$export$6ccbb43953eebf8);

var $jX5tX = parcelRequire("jX5tX");

var $bDeiz = parcelRequire("bDeiz");
function $0a332f714a54cff3$export$671dba69185d0304(context = (0, $jX5tX.ReactReduxContext)) {
    const useReduxContext = context === (0, $jX5tX.ReactReduxContext) ? (0, $bDeiz.useReduxContext) : (0, $bDeiz.createReduxContextHook)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $0a332f714a54cff3$export$6ccbb43953eebf8 = /*#__PURE__*/ $0a332f714a54cff3$export$671dba69185d0304();

});


parcelRegister("3nkSi", function(module, exports) {

});




parcelRegister("jDTTg", function(module, exports) {
/**
 * Copyright 2023 ALPHAGUARD CONSULTING, LLC.  All rights reserved.
 * Use of this source code is governed by a Commercial License Agreement
 * license can be found in the LICENSE file or contact legal@alphaguard.io
 */ var $73c04d934d86c90c$export$e57062a38354425e;
(function(AssetType) {
    AssetType["VIDEO"] = "video";
    AssetType["IMAGE"] = "image";
    AssetType["DOCUMENT"] = "doc";
    AssetType["AUDIO"] = "audio";
})($73c04d934d86c90c$export$e57062a38354425e || ($73c04d934d86c90c$export$e57062a38354425e = {}));
var $73c04d934d86c90c$export$c45e2bbd6aabeff6;
(function(AssetSource) {
    AssetSource["URL"] = "url";
    AssetSource["COMPUTER"] = "computer";
})($73c04d934d86c90c$export$c45e2bbd6aabeff6 || ($73c04d934d86c90c$export$c45e2bbd6aabeff6 = {}));

});


parcelRegister("7V8eP", function(module, exports) {

var $7hsUP = parcelRequire("7hsUP");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $5c443f38ee09537d$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $7hsUP(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $5c443f38ee09537d$var$get;

});
parcelRegister("7hsUP", function(module, exports) {

var $cMgbh = parcelRequire("cMgbh");

var $jWfam = parcelRequire("jWfam");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $54d08cf2decc5184$var$baseGet(object, path) {
    path = $cMgbh(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$jWfam(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $54d08cf2decc5184$var$baseGet;

});
parcelRegister("cMgbh", function(module, exports) {

var $8siA5 = parcelRequire("8siA5");

var $6Y22F = parcelRequire("6Y22F");

var $lOET2 = parcelRequire("lOET2");

var $1W71Q = parcelRequire("1W71Q");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $94d684efaa8cb88a$var$castPath(value, object) {
    if ($8siA5(value)) return value;
    return $6Y22F(value, object) ? [
        value
    ] : $lOET2($1W71Q(value));
}
module.exports = $94d684efaa8cb88a$var$castPath;

});
parcelRegister("8siA5", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $627f5a101d8cd57f$var$isArray = Array.isArray;
module.exports = $627f5a101d8cd57f$var$isArray;

});

parcelRegister("6Y22F", function(module, exports) {

var $8siA5 = parcelRequire("8siA5");

var $j6r7m = parcelRequire("j6r7m");
/** Used to match property names within property paths. */ var $5129ee30ee3e0055$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $5129ee30ee3e0055$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $5129ee30ee3e0055$var$isKey(value, object) {
    if ($8siA5(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $j6r7m(value)) return true;
    return $5129ee30ee3e0055$var$reIsPlainProp.test(value) || !$5129ee30ee3e0055$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $5129ee30ee3e0055$var$isKey;

});
parcelRegister("j6r7m", function(module, exports) {

var $1kd5l = parcelRequire("1kd5l");

var $gzaDU = parcelRequire("gzaDU");
/** `Object#toString` result references. */ var $de839cdea162b223$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $de839cdea162b223$var$isSymbol(value) {
    return typeof value == "symbol" || $gzaDU(value) && $1kd5l(value) == $de839cdea162b223$var$symbolTag;
}
module.exports = $de839cdea162b223$var$isSymbol;

});
parcelRegister("1kd5l", function(module, exports) {

var $3mT2Y = parcelRequire("3mT2Y");

var $7bX4M = parcelRequire("7bX4M");

var $hQYSg = parcelRequire("hQYSg");
/** `Object#toString` result references. */ var $0f71cf2151ae6311$var$nullTag = "[object Null]", $0f71cf2151ae6311$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $0f71cf2151ae6311$var$symToStringTag = $3mT2Y ? $3mT2Y.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $0f71cf2151ae6311$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $0f71cf2151ae6311$var$undefinedTag : $0f71cf2151ae6311$var$nullTag;
    return $0f71cf2151ae6311$var$symToStringTag && $0f71cf2151ae6311$var$symToStringTag in Object(value) ? $7bX4M(value) : $hQYSg(value);
}
module.exports = $0f71cf2151ae6311$var$baseGetTag;

});
parcelRegister("3mT2Y", function(module, exports) {

var $49zIs = parcelRequire("49zIs");
/** Built-in value references. */ var $273e20546cd2fb05$var$Symbol = $49zIs.Symbol;
module.exports = $273e20546cd2fb05$var$Symbol;

});
parcelRegister("49zIs", function(module, exports) {

var $iFdBD = parcelRequire("iFdBD");
/** Detect free variable `self`. */ var $3063b52250972dc2$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $3063b52250972dc2$var$root = $iFdBD || $3063b52250972dc2$var$freeSelf || Function("return this")();
module.exports = $3063b52250972dc2$var$root;

});
parcelRegister("iFdBD", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $d9669c34b36f08f1$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $d9669c34b36f08f1$var$freeGlobal;

});



parcelRegister("7bX4M", function(module, exports) {

var $3mT2Y = parcelRequire("3mT2Y");
/** Used for built-in method references. */ var $53c762c73e4567d3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $53c762c73e4567d3$var$hasOwnProperty = $53c762c73e4567d3$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $53c762c73e4567d3$var$nativeObjectToString = $53c762c73e4567d3$var$objectProto.toString;
/** Built-in value references. */ var $53c762c73e4567d3$var$symToStringTag = $3mT2Y ? $3mT2Y.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $53c762c73e4567d3$var$getRawTag(value) {
    var isOwn = $53c762c73e4567d3$var$hasOwnProperty.call(value, $53c762c73e4567d3$var$symToStringTag), tag = value[$53c762c73e4567d3$var$symToStringTag];
    try {
        value[$53c762c73e4567d3$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $53c762c73e4567d3$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$53c762c73e4567d3$var$symToStringTag] = tag;
        else delete value[$53c762c73e4567d3$var$symToStringTag];
    }
    return result;
}
module.exports = $53c762c73e4567d3$var$getRawTag;

});

parcelRegister("hQYSg", function(module, exports) {
/** Used for built-in method references. */ var $cff6835318845baa$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $cff6835318845baa$var$nativeObjectToString = $cff6835318845baa$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $cff6835318845baa$var$objectToString(value) {
    return $cff6835318845baa$var$nativeObjectToString.call(value);
}
module.exports = $cff6835318845baa$var$objectToString;

});


parcelRegister("gzaDU", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $c0f82bab3eddc73c$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $c0f82bab3eddc73c$var$isObjectLike;

});



parcelRegister("lOET2", function(module, exports) {

var $hPS08 = parcelRequire("hPS08");
/** Used to match property names within property paths. */ var $fe1dfbb8b03bc2b1$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $fe1dfbb8b03bc2b1$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $fe1dfbb8b03bc2b1$var$stringToPath = $hPS08(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($fe1dfbb8b03bc2b1$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($fe1dfbb8b03bc2b1$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = $fe1dfbb8b03bc2b1$var$stringToPath;

});
parcelRegister("hPS08", function(module, exports) {

var $hRfvL = parcelRequire("hRfvL");
/** Used as the maximum memoize cache size. */ var $cfc116946cc872da$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $cfc116946cc872da$var$memoizeCapped(func) {
    var result = $hRfvL(func, function(key) {
        if (cache.size === $cfc116946cc872da$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $cfc116946cc872da$var$memoizeCapped;

});
parcelRegister("hRfvL", function(module, exports) {

var $3QyJf = parcelRequire("3QyJf");
/** Error message constants. */ var $d0036b1e69d5769e$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $d0036b1e69d5769e$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($d0036b1e69d5769e$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($d0036b1e69d5769e$var$memoize.Cache || $3QyJf);
    return memoized;
}
// Expose `MapCache`.
$d0036b1e69d5769e$var$memoize.Cache = $3QyJf;
module.exports = $d0036b1e69d5769e$var$memoize;

});
parcelRegister("3QyJf", function(module, exports) {

var $1J1fj = parcelRequire("1J1fj");

var $cDRkV = parcelRequire("cDRkV");

var $6f1Sr = parcelRequire("6f1Sr");

var $22Aoz = parcelRequire("22Aoz");

var $qhRWi = parcelRequire("qhRWi");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $2cd12adbb6b3db4f$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$2cd12adbb6b3db4f$var$MapCache.prototype.clear = $1J1fj;
$2cd12adbb6b3db4f$var$MapCache.prototype["delete"] = $cDRkV;
$2cd12adbb6b3db4f$var$MapCache.prototype.get = $6f1Sr;
$2cd12adbb6b3db4f$var$MapCache.prototype.has = $22Aoz;
$2cd12adbb6b3db4f$var$MapCache.prototype.set = $qhRWi;
module.exports = $2cd12adbb6b3db4f$var$MapCache;

});
parcelRegister("1J1fj", function(module, exports) {

var $8j9vo = parcelRequire("8j9vo");

var $2oXnn = parcelRequire("2oXnn");

var $6q3UI = parcelRequire("6q3UI");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $141af5d880e24b2d$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $8j9vo,
        "map": new ($6q3UI || $2oXnn),
        "string": new $8j9vo
    };
}
module.exports = $141af5d880e24b2d$var$mapCacheClear;

});
parcelRegister("8j9vo", function(module, exports) {

var $492y7 = parcelRequire("492y7");

var $8pPTN = parcelRequire("8pPTN");

var $aAwDO = parcelRequire("aAwDO");

var $2yZai = parcelRequire("2yZai");

var $crUJL = parcelRequire("crUJL");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $60c7789e2e8c522a$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$60c7789e2e8c522a$var$Hash.prototype.clear = $492y7;
$60c7789e2e8c522a$var$Hash.prototype["delete"] = $8pPTN;
$60c7789e2e8c522a$var$Hash.prototype.get = $aAwDO;
$60c7789e2e8c522a$var$Hash.prototype.has = $2yZai;
$60c7789e2e8c522a$var$Hash.prototype.set = $crUJL;
module.exports = $60c7789e2e8c522a$var$Hash;

});
parcelRegister("492y7", function(module, exports) {

var $52O4L = parcelRequire("52O4L");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $3049faeeadde7d80$var$hashClear() {
    this.__data__ = $52O4L ? $52O4L(null) : {};
    this.size = 0;
}
module.exports = $3049faeeadde7d80$var$hashClear;

});
parcelRegister("52O4L", function(module, exports) {

var $3tgxi = parcelRequire("3tgxi");
/* Built-in method references that are verified to be native. */ var $3ac3fbaf2fcc2414$var$nativeCreate = $3tgxi(Object, "create");
module.exports = $3ac3fbaf2fcc2414$var$nativeCreate;

});
parcelRegister("3tgxi", function(module, exports) {

var $1gOR5 = parcelRequire("1gOR5");

var $hTiy6 = parcelRequire("hTiy6");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $2870e83c8ca189e6$var$getNative(object, key) {
    var value = $hTiy6(object, key);
    return $1gOR5(value) ? value : undefined;
}
module.exports = $2870e83c8ca189e6$var$getNative;

});
parcelRegister("1gOR5", function(module, exports) {

var $bGo7d = parcelRequire("bGo7d");

var $G2maN = parcelRequire("G2maN");

var $aHWMw = parcelRequire("aHWMw");

var $dBp03 = parcelRequire("dBp03");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $0ecebbdc57f37a44$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $0ecebbdc57f37a44$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $0ecebbdc57f37a44$var$funcProto = Function.prototype, $0ecebbdc57f37a44$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $0ecebbdc57f37a44$var$funcToString = $0ecebbdc57f37a44$var$funcProto.toString;
/** Used to check objects for own properties. */ var $0ecebbdc57f37a44$var$hasOwnProperty = $0ecebbdc57f37a44$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $0ecebbdc57f37a44$var$reIsNative = RegExp("^" + $0ecebbdc57f37a44$var$funcToString.call($0ecebbdc57f37a44$var$hasOwnProperty).replace($0ecebbdc57f37a44$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $0ecebbdc57f37a44$var$baseIsNative(value) {
    if (!$aHWMw(value) || $G2maN(value)) return false;
    var pattern = $bGo7d(value) ? $0ecebbdc57f37a44$var$reIsNative : $0ecebbdc57f37a44$var$reIsHostCtor;
    return pattern.test($dBp03(value));
}
module.exports = $0ecebbdc57f37a44$var$baseIsNative;

});
parcelRegister("bGo7d", function(module, exports) {

var $1kd5l = parcelRequire("1kd5l");

var $aHWMw = parcelRequire("aHWMw");
/** `Object#toString` result references. */ var $881652c1edbabec4$var$asyncTag = "[object AsyncFunction]", $881652c1edbabec4$var$funcTag = "[object Function]", $881652c1edbabec4$var$genTag = "[object GeneratorFunction]", $881652c1edbabec4$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $881652c1edbabec4$var$isFunction(value) {
    if (!$aHWMw(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $1kd5l(value);
    return tag == $881652c1edbabec4$var$funcTag || tag == $881652c1edbabec4$var$genTag || tag == $881652c1edbabec4$var$asyncTag || tag == $881652c1edbabec4$var$proxyTag;
}
module.exports = $881652c1edbabec4$var$isFunction;

});
parcelRegister("aHWMw", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $7cbb8452a6fef5a8$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $7cbb8452a6fef5a8$var$isObject;

});


parcelRegister("G2maN", function(module, exports) {

var $1uqli = parcelRequire("1uqli");
/** Used to detect methods masquerading as native. */ var $07e5c05610be9793$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($1uqli && $1uqli.keys && $1uqli.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $07e5c05610be9793$var$isMasked(func) {
    return !!$07e5c05610be9793$var$maskSrcKey && $07e5c05610be9793$var$maskSrcKey in func;
}
module.exports = $07e5c05610be9793$var$isMasked;

});
parcelRegister("1uqli", function(module, exports) {

var $49zIs = parcelRequire("49zIs");
/** Used to detect overreaching core-js shims. */ var $115d06dabc889ecc$var$coreJsData = $49zIs["__core-js_shared__"];
module.exports = $115d06dabc889ecc$var$coreJsData;

});


parcelRegister("dBp03", function(module, exports) {
/** Used for built-in method references. */ var $9e721f7ec32fe712$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9e721f7ec32fe712$var$funcToString = $9e721f7ec32fe712$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9e721f7ec32fe712$var$toSource(func) {
    if (func != null) {
        try {
            return $9e721f7ec32fe712$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = $9e721f7ec32fe712$var$toSource;

});


parcelRegister("hTiy6", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d065f632b8f77ce1$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $d065f632b8f77ce1$var$getValue;

});




parcelRegister("8pPTN", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6208ea927a2e4f3b$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $6208ea927a2e4f3b$var$hashDelete;

});

parcelRegister("aAwDO", function(module, exports) {

var $52O4L = parcelRequire("52O4L");
/** Used to stand-in for `undefined` hash values. */ var $7b56960bd8a1d036$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $7b56960bd8a1d036$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7b56960bd8a1d036$var$hasOwnProperty = $7b56960bd8a1d036$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $7b56960bd8a1d036$var$hashGet(key) {
    var data = this.__data__;
    if ($52O4L) {
        var result = data[key];
        return result === $7b56960bd8a1d036$var$HASH_UNDEFINED ? undefined : result;
    }
    return $7b56960bd8a1d036$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $7b56960bd8a1d036$var$hashGet;

});

parcelRegister("2yZai", function(module, exports) {

var $52O4L = parcelRequire("52O4L");
/** Used for built-in method references. */ var $1dde33e03fe5608a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1dde33e03fe5608a$var$hasOwnProperty = $1dde33e03fe5608a$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1dde33e03fe5608a$var$hashHas(key) {
    var data = this.__data__;
    return $52O4L ? data[key] !== undefined : $1dde33e03fe5608a$var$hasOwnProperty.call(data, key);
}
module.exports = $1dde33e03fe5608a$var$hashHas;

});

parcelRegister("crUJL", function(module, exports) {

var $52O4L = parcelRequire("52O4L");
/** Used to stand-in for `undefined` hash values. */ var $91040470dcee4923$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $91040470dcee4923$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $52O4L && value === undefined ? $91040470dcee4923$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $91040470dcee4923$var$hashSet;

});


parcelRegister("2oXnn", function(module, exports) {

var $54pOp = parcelRequire("54pOp");

var $dKQmp = parcelRequire("dKQmp");

var $kWSDj = parcelRequire("kWSDj");

var $d6uUn = parcelRequire("d6uUn");

var $7fzV1 = parcelRequire("7fzV1");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $1bfbe17c09125c5e$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$1bfbe17c09125c5e$var$ListCache.prototype.clear = $54pOp;
$1bfbe17c09125c5e$var$ListCache.prototype["delete"] = $dKQmp;
$1bfbe17c09125c5e$var$ListCache.prototype.get = $kWSDj;
$1bfbe17c09125c5e$var$ListCache.prototype.has = $d6uUn;
$1bfbe17c09125c5e$var$ListCache.prototype.set = $7fzV1;
module.exports = $1bfbe17c09125c5e$var$ListCache;

});
parcelRegister("54pOp", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $3b11593122d6b384$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $3b11593122d6b384$var$listCacheClear;

});

parcelRegister("dKQmp", function(module, exports) {

var $4WeVk = parcelRequire("4WeVk");
/** Used for built-in method references. */ var $a0382ff1abca60e6$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $a0382ff1abca60e6$var$splice = $a0382ff1abca60e6$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $a0382ff1abca60e6$var$listCacheDelete(key) {
    var data = this.__data__, index = $4WeVk(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $a0382ff1abca60e6$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $a0382ff1abca60e6$var$listCacheDelete;

});
parcelRegister("4WeVk", function(module, exports) {

var $3MOx5 = parcelRequire("3MOx5");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $398827bc6039333d$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($3MOx5(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $398827bc6039333d$var$assocIndexOf;

});
parcelRegister("3MOx5", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $2c1d0d89d61e04c6$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $2c1d0d89d61e04c6$var$eq;

});



parcelRegister("kWSDj", function(module, exports) {

var $4WeVk = parcelRequire("4WeVk");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $f4039a66e30ebd93$var$listCacheGet(key) {
    var data = this.__data__, index = $4WeVk(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $f4039a66e30ebd93$var$listCacheGet;

});

parcelRegister("d6uUn", function(module, exports) {

var $4WeVk = parcelRequire("4WeVk");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $98a3cfa5c5e2a07c$var$listCacheHas(key) {
    return $4WeVk(this.__data__, key) > -1;
}
module.exports = $98a3cfa5c5e2a07c$var$listCacheHas;

});

parcelRegister("7fzV1", function(module, exports) {

var $4WeVk = parcelRequire("4WeVk");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $5475cbd2f89b7e4d$var$listCacheSet(key, value) {
    var data = this.__data__, index = $4WeVk(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $5475cbd2f89b7e4d$var$listCacheSet;

});


parcelRegister("6q3UI", function(module, exports) {

var $3tgxi = parcelRequire("3tgxi");

var $49zIs = parcelRequire("49zIs");
/* Built-in method references that are verified to be native. */ var $4ac834fa10831467$var$Map = $3tgxi($49zIs, "Map");
module.exports = $4ac834fa10831467$var$Map;

});


parcelRegister("cDRkV", function(module, exports) {

var $k0AGh = parcelRequire("k0AGh");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9342800e5022a9fd$var$mapCacheDelete(key) {
    var result = $k0AGh(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $9342800e5022a9fd$var$mapCacheDelete;

});
parcelRegister("k0AGh", function(module, exports) {

var $ecklh = parcelRequire("ecklh");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $e91042cb093bc51a$var$getMapData(map, key) {
    var data = map.__data__;
    return $ecklh(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = $e91042cb093bc51a$var$getMapData;

});
parcelRegister("ecklh", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $a561f735160f2b03$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = $a561f735160f2b03$var$isKeyable;

});



parcelRegister("6f1Sr", function(module, exports) {

var $k0AGh = parcelRequire("k0AGh");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $48b5998dfdcc5291$var$mapCacheGet(key) {
    return $k0AGh(this, key).get(key);
}
module.exports = $48b5998dfdcc5291$var$mapCacheGet;

});

parcelRegister("22Aoz", function(module, exports) {

var $k0AGh = parcelRequire("k0AGh");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $17c80009d7953d5c$var$mapCacheHas(key) {
    return $k0AGh(this, key).has(key);
}
module.exports = $17c80009d7953d5c$var$mapCacheHas;

});

parcelRegister("qhRWi", function(module, exports) {

var $k0AGh = parcelRequire("k0AGh");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $04f04a3b3986177a$var$mapCacheSet(key, value) {
    var data = $k0AGh(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $04f04a3b3986177a$var$mapCacheSet;

});





parcelRegister("1W71Q", function(module, exports) {

var $8W2RT = parcelRequire("8W2RT");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $1690a9000f566723$var$toString(value) {
    return value == null ? "" : $8W2RT(value);
}
module.exports = $1690a9000f566723$var$toString;

});
parcelRegister("8W2RT", function(module, exports) {

var $3mT2Y = parcelRequire("3mT2Y");

var $3vAhF = parcelRequire("3vAhF");

var $8siA5 = parcelRequire("8siA5");

var $j6r7m = parcelRequire("j6r7m");
/** Used as references for various `Number` constants. */ var $6815f714cff137b4$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $6815f714cff137b4$var$symbolProto = $3mT2Y ? $3mT2Y.prototype : undefined, $6815f714cff137b4$var$symbolToString = $6815f714cff137b4$var$symbolProto ? $6815f714cff137b4$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $6815f714cff137b4$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($8siA5(value)) // Recursively convert values (susceptible to call stack limits).
    return $3vAhF(value, $6815f714cff137b4$var$baseToString) + "";
    if ($j6r7m(value)) return $6815f714cff137b4$var$symbolToString ? $6815f714cff137b4$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$6815f714cff137b4$var$INFINITY ? "-0" : result;
}
module.exports = $6815f714cff137b4$var$baseToString;

});
parcelRegister("3vAhF", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $28e069928ba8c68b$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $28e069928ba8c68b$var$arrayMap;

});




parcelRegister("jWfam", function(module, exports) {

var $j6r7m = parcelRequire("j6r7m");
/** Used as references for various `Number` constants. */ var $e83f32ca584c032d$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $e83f32ca584c032d$var$toKey(value) {
    if (typeof value == "string" || $j6r7m(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$e83f32ca584c032d$var$INFINITY ? "-0" : result;
}
module.exports = $e83f32ca584c032d$var$toKey;

});



parcelRegister("dYzX4", function(module, exports) {

$parcel$export(module.exports, "useGetAppointmentsQuery", () => $559895fab54dba05$export$a5c29d0a35d33b7f);
$parcel$export(module.exports, "default", () => $559895fab54dba05$export$2e2bcd8739ae039);
/**
 * Copyright 2023 ALPHAGUARD CONSULTING, LLC.  All rights reserved.
 * Use of this source code is governed by a Commercial License Agreement
 * license can be found in the LICENSE file or contact legal@alphaguard.io
 */ 
var $3XnHf = parcelRequire("3XnHf");

var $7V8eP = parcelRequire("7V8eP");

var $7oLjV = parcelRequire("7oLjV");
const $559895fab54dba05$var$appointmentsApi = (0, $7oLjV.default).injectEndpoints({
    endpoints: (builder)=>({
            getAppointments: builder.query({
                providesTags: (result, error, arg)=>{
                    return result ? [
                        ...result.data.map((apt)=>({
                                type: "Appointments",
                                id: (0, (/*@__PURE__*/$parcel$interopDefault($7V8eP)))(apt, "id")
                            })),
                        {
                            type: "Appointments",
                            id: "LIST"
                        }
                    ] : [
                        {
                            type: "Appointments",
                            id: "LIST"
                        }
                    ];
                },
                query: ([req, pageMeta, filters = {}])=>{
                    const query = {
                        sort: [
                            "id:desc"
                        ],
                        populate: {
                            groups: {
                                fields: [
                                    "id",
                                    "uid",
                                    "name"
                                ]
                            }
                        },
                        filters: {
                            ...filters,
                            $and: [
                                {
                                    groups: {
                                        uid: (0, (/*@__PURE__*/$parcel$interopDefault($7V8eP)))(req, "groupId"),
                                        branch: {
                                            id: (0, (/*@__PURE__*/$parcel$interopDefault($7V8eP)))(req, "branchId")
                                        }
                                    }
                                },
                                ...(0, (/*@__PURE__*/$parcel$interopDefault($7V8eP)))(filters, "$and", [])
                            ]
                        },
                        pagination: (0, (/*@__PURE__*/$parcel$interopDefault($7V8eP)))(pageMeta, "page") ? pageMeta : {
                            page: pageMeta,
                            pageSize: 100
                        }
                    };
                    return `/appointments?${(0, (/*@__PURE__*/$parcel$interopDefault($3XnHf))).stringify(query, {
                        encodeValuesOnly: true
                    })}`;
                },
                transformResponse: (res, meta, arg)=>({
                        data: (0, $7oLjV.getListModel)((0, (/*@__PURE__*/$parcel$interopDefault($7V8eP)))(res, "data", []), {
                            groups: (_, groups)=>(0, $7oLjV.getListModel)((0, (/*@__PURE__*/$parcel$interopDefault($7V8eP)))(groups, "data"))
                        }),
                        meta: (0, (/*@__PURE__*/$parcel$interopDefault($7V8eP)))(res, "meta", {}),
                        original: (0, (/*@__PURE__*/$parcel$interopDefault($7V8eP)))(res, "data")
                    })
            }),
            createAppointment: builder.mutation({
                invalidatesTags: [
                    {
                        type: "Appointments",
                        id: "LIST"
                    }
                ],
                query: (data)=>({
                        url: "/appointments",
                        method: "POST",
                        body: {
                            data: data
                        }
                    })
            }),
            updateAppointment: builder.mutation({
                query ({ id: id, ...data }) {
                    return {
                        url: `/appointments/${id}`,
                        method: "PUT",
                        body: {
                            data: data
                        }
                    };
                },
                // Invalidates all queries that subscribe to Appointment ids only.
                invalidatesTags: (result, error, { id: id })=>[
                        {
                            type: "Appointments",
                            id: id
                        }
                    ]
            }),
            bulkDeleteAppointments: builder.mutation({
                query (ids) {
                    return {
                        url: `/appointments/bulk/delete`,
                        method: "POST",
                        body: {
                            data: {
                                ids: ids
                            }
                        }
                    };
                },
                // Invalidates all queries that subscribe to Appointment ids only.
                invalidatesTags: (result, error, ids)=>ids.map((id)=>({
                            type: "Appointments",
                            id: id
                        }))
            })
        })
});
const { useGetAppointmentsQuery: $559895fab54dba05$export$a5c29d0a35d33b7f, useBulkDeleteAppointmentsMutation: $559895fab54dba05$export$e0e3924ad5f3a4f, useCreateAppointmentMutation: $559895fab54dba05$export$f4626a926078bbfa, useUpdateAppointmentMutation: $559895fab54dba05$export$2cb088be402b017c } = $559895fab54dba05$var$appointmentsApi;
var $559895fab54dba05$export$2e2bcd8739ae039 = $559895fab54dba05$var$appointmentsApi;

});

parcelRegister("LfCz8", function(module, exports) {

$parcel$export(module.exports, "useBranch", () => $b701f4335ff51b01$export$39a65fcb0428d8fa);
/**
 * Copyright 2023 ALPHAGUARD CONSULTING, LLC.  All rights reserved.
 * Use of this source code is governed by a Commercial License Agreement
 * license can be found in the LICENSE file or contact legal@alphaguard.io
 */ 
var $6MTDM = parcelRequire("6MTDM");
parcelRequire("bvqOc");
var $hjhWs = parcelRequire("hjhWs");

var $jgLFK = parcelRequire("jgLFK");

var $lQ3n3 = parcelRequire("lQ3n3");

var $eeMrw = parcelRequire("eeMrw");

var $fbl3M = parcelRequire("fbl3M");
var $b701f4335ff51b01$export$ea6a2b9dcc9dc159;
(function(ContextErrorType) {
    ContextErrorType["notAuthenticated"] = "Your session has expired. Please login again.";
    ContextErrorType["initFaliure"] = "UserContextIsNotInitialized";
    ContextErrorType["noBranchFound"] = "This branch does not exist or you don't have access.";
})($b701f4335ff51b01$export$ea6a2b9dcc9dc159 || ($b701f4335ff51b01$export$ea6a2b9dcc9dc159 = {}));
const $b701f4335ff51b01$var$isAuthenticated = ()=>{
    // if user is not authenticated then redirect to login page
    return !!(0, $fbl3M.default).getState().app.auth.isAuthenticated;
};
const $b701f4335ff51b01$export$653f0d1acaa4ad36 = async (slug)=>{
    const { dispatch: dispatch } = (0, $fbl3M.default);
    const { getUserContext: getUserContext } = (0, $eeMrw.default).endpoints;
    const { data: ctx } = await dispatch(getUserContext.initiate(slug));
    // if user is not authenticated then redirect to login page
    if (!$b701f4335ff51b01$var$isAuthenticated()) throw new Error("Your session has expired. Please login again.");
    // if there are no branches then throw an error
    if (!(0, $jgLFK.get)(ctx, "context.branches.length")) throw new Error("This branch does not exist or you don't have access.");
    return ctx;
};
const $b701f4335ff51b01$export$c905bfe60039758b = async ({ params: { branchId: branchId, ...params } })=>{
    const { dispatch: dispatch } = (0, $fbl3M.default);
    try {
        const userCtx = await $b701f4335ff51b01$export$653f0d1acaa4ad36(branchId);
        const branchSlug = (0, $jgLFK.get)(userCtx, "context.branch.slug");
        const branches = (0, $jgLFK.get)(userCtx, "context.branches");
        // if only branchId is provided, redirect to default branch
        if ((0, $jgLFK.isEmpty)((0, $jgLFK.get)(params, "*")) && !(0, $jgLFK.isEqual)(branchId, branchSlug)) return (0, $6MTDM.redirect)(`/${branchSlug}/${branchId}`);
        const branch = (0, $jgLFK.find)(branches, {
            slug: branchId
        });
        if (!branch) throw new Error("This branch does not exist or you don't have access.");
        else dispatch((0, $lQ3n3.setBranch)(branch));
    } catch (error) {
        switch(error.message){
            case "Your session has expired. Please login again.":
                return (0, $6MTDM.redirect)("/login");
            default:
                throw new Response(error.message);
        }
    }
};
const $b701f4335ff51b01$export$39a65fcb0428d8fa = ()=>{
    return (0, $hjhWs.useSelector)((0, $lQ3n3.selectBranch));
};

});
parcelRegister("6MTDM", function(module, exports) {

$parcel$export(module.exports, "Action", () => $4f1262dadea9336b$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $4f1262dadea9336b$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $4f1262dadea9336b$export$fe53371bee54353d);
$parcel$export(module.exports, "createBrowserHistory", () => $4f1262dadea9336b$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $4f1262dadea9336b$export$b71fdd3798280242);
$parcel$export(module.exports, "parsePath", () => $4f1262dadea9336b$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "invariant", () => $4f1262dadea9336b$export$f5708dca728d7177);
$parcel$export(module.exports, "matchRoutes", () => $4f1262dadea9336b$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $4f1262dadea9336b$export$b69e3301ce081aa3);
$parcel$export(module.exports, "joinPaths", () => $4f1262dadea9336b$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $4f1262dadea9336b$export$81336c211d5ff295);
$parcel$export(module.exports, "resolveTo", () => $4f1262dadea9336b$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $4f1262dadea9336b$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "redirect", () => $4f1262dadea9336b$export$89e12c5b50f7529d);
$parcel$export(module.exports, "isRouteErrorResponse", () => $4f1262dadea9336b$export$972111febbeef05b);
$parcel$export(module.exports, "createRouter", () => $4f1262dadea9336b$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $4f1262dadea9336b$var$_extends() {
    $4f1262dadea9336b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4f1262dadea9336b$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $4f1262dadea9336b$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($4f1262dadea9336b$export$e19cd5f9376f8cee || ($4f1262dadea9336b$export$e19cd5f9376f8cee = {}));
const $4f1262dadea9336b$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $4f1262dadea9336b$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $4f1262dadea9336b$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $4f1262dadea9336b$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $4f1262dadea9336b$var$warning$1(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref (to) {
            return typeof to === "string" ? to : $4f1262dadea9336b$export$fe53371bee54353d(to);
        },
        push (to, state) {
            action = $4f1262dadea9336b$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation
            });
        },
        replace (to, state) {
            action = $4f1262dadea9336b$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation
            });
        },
        go (delta) {
            action = $4f1262dadea9336b$export$e19cd5f9376f8cee.Pop;
            index = clampIndex(index + delta);
            if (listener) listener({
                action: action,
                location: getCurrentLocation()
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $4f1262dadea9336b$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $4f1262dadea9336b$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $4f1262dadea9336b$export$fe53371bee54353d(to);
    }
    return $4f1262dadea9336b$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $4f1262dadea9336b$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $4f1262dadea9336b$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        return $4f1262dadea9336b$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $4f1262dadea9336b$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $4f1262dadea9336b$var$warning$1(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $4f1262dadea9336b$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region UTILS
////////////////////////////////////////////////////////////////////////////////
function $4f1262dadea9336b$var$warning$1(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $4f1262dadea9336b$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $4f1262dadea9336b$var$getHistoryState(location) {
    return {
        usr: location.state,
        key: location.key
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $4f1262dadea9336b$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $4f1262dadea9336b$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $4f1262dadea9336b$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $4f1262dadea9336b$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $4f1262dadea9336b$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $4f1262dadea9336b$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $4f1262dadea9336b$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $4f1262dadea9336b$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function handlePop() {
        action = $4f1262dadea9336b$export$e19cd5f9376f8cee.Pop;
        if (listener) listener({
            action: action,
            location: history.location
        });
    }
    function push(to, state) {
        action = $4f1262dadea9336b$export$e19cd5f9376f8cee.Push;
        let location = $4f1262dadea9336b$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        let historyState = $4f1262dadea9336b$var$getHistoryState(location);
        let url = history.createHref(location); // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: location
        });
    }
    function replace(to, state) {
        action = $4f1262dadea9336b$export$e19cd5f9376f8cee.Replace;
        let location = $4f1262dadea9336b$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        let historyState = $4f1262dadea9336b$var$getHistoryState(location);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: location
        });
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($4f1262dadea9336b$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($4f1262dadea9336b$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
} //#endregion
var $4f1262dadea9336b$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($4f1262dadea9336b$var$ResultType || ($4f1262dadea9336b$var$ResultType = {})); // Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $4f1262dadea9336b$export$4a6d22b32134ea5d(routes, parentPath, allIds) {
    if (parentPath === void 0) parentPath = [];
    if (allIds === void 0) allIds = new Set();
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $4f1262dadea9336b$export$f5708dca728d7177(!allIds.has(id), 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        allIds.add(id);
        let dataRoute = $4f1262dadea9336b$var$_extends({}, route, {
            id: id,
            children: route.children ? $4f1262dadea9336b$export$4a6d22b32134ea5d(route.children, treePath, allIds) : undefined
        });
        return dataRoute;
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/docs/en/v6/utils/match-routes
 */ function $4f1262dadea9336b$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $4f1262dadea9336b$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $4f1262dadea9336b$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $4f1262dadea9336b$var$flattenRoutes(routes);
    $4f1262dadea9336b$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $4f1262dadea9336b$var$matchRouteBranch(branches[i], pathname);
    return matches;
}
function $4f1262dadea9336b$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    routes.forEach((route, index)=>{
        let meta = {
            relativePath: route.path || "",
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $4f1262dadea9336b$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $4f1262dadea9336b$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $4f1262dadea9336b$export$f5708dca728d7177(route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $4f1262dadea9336b$var$flattenRoutes(route.children, branches, routesMeta, path);
        } // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $4f1262dadea9336b$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    });
    return branches;
}
function $4f1262dadea9336b$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $4f1262dadea9336b$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $4f1262dadea9336b$var$paramRe = /^:\w+$/;
const $4f1262dadea9336b$var$dynamicSegmentValue = 3;
const $4f1262dadea9336b$var$indexRouteValue = 2;
const $4f1262dadea9336b$var$emptySegmentValue = 1;
const $4f1262dadea9336b$var$staticSegmentValue = 10;
const $4f1262dadea9336b$var$splatPenalty = -2;
const $4f1262dadea9336b$var$isSplat = (s)=>s === "*";
function $4f1262dadea9336b$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($4f1262dadea9336b$var$isSplat)) initialScore += $4f1262dadea9336b$var$splatPenalty;
    if (index) initialScore += $4f1262dadea9336b$var$indexRouteValue;
    return segments.filter((s)=>!$4f1262dadea9336b$var$isSplat(s)).reduce((score, segment)=>score + ($4f1262dadea9336b$var$paramRe.test(segment) ? $4f1262dadea9336b$var$dynamicSegmentValue : segment === "" ? $4f1262dadea9336b$var$emptySegmentValue : $4f1262dadea9336b$var$staticSegmentValue), initialScore);
}
function $4f1262dadea9336b$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // so they sort equally.
    0;
}
function $4f1262dadea9336b$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $4f1262dadea9336b$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $4f1262dadea9336b$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $4f1262dadea9336b$export$a5c6d149b50c1d86($4f1262dadea9336b$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $4f1262dadea9336b$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/docs/en/v6/utils/generate-path
 */ function $4f1262dadea9336b$export$82476f982757e71e(path, params) {
    if (params === void 0) params = {};
    return path.replace(/:(\w+)/g, (_, key)=>{
        $4f1262dadea9336b$export$f5708dca728d7177(params[key] != null, 'Missing ":' + key + '" param');
        return params[key];
    }).replace(/(\/?)\*/, (_, prefix, __, str)=>{
        const star = "*";
        if (params[star] == null) // If no splat was provided, trim the trailing slash _unless_ it's
        // the entire path
        return str === "/*" ? "/" : "";
         // Apply the splat
        return "" + prefix + params[star];
    });
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/docs/en/v6/utils/match-path
 */ function $4f1262dadea9336b$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $4f1262dadea9336b$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $4f1262dadea9336b$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $4f1262dadea9336b$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $4f1262dadea9336b$export$491112666e282270(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else regexpSource += end ? "\\/*$" // When matching to the end, ignore trailing slashes
     : // parent routes to matching only their own words and nothing more, e.g. parent
    // route "/home" should not match "/home2".
    // Additionally, allow paths starting with `.`, `-`, `~`, and url-encoded entities,
    // but do not consume the character in the matched path so they can match against
    // nested paths.
    "(?:(?=[@.~-]|%[0-9A-F]{2})|\\b|\\/|$)";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $4f1262dadea9336b$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $4f1262dadea9336b$export$491112666e282270(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $4f1262dadea9336b$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
     // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
function $4f1262dadea9336b$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
/**
 * @private
 */ function $4f1262dadea9336b$export$491112666e282270(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging React Router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/docs/en/v6/utils/resolve-path
 */ function $4f1262dadea9336b$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $4f1262dadea9336b$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $4f1262dadea9336b$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $4f1262dadea9336b$var$normalizeSearch(search),
        hash: $4f1262dadea9336b$var$normalizeHash(hash)
    };
}
function $4f1262dadea9336b$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
/**
 * @private
 */ function $4f1262dadea9336b$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to = typeof toArg === "string" ? $4f1262dadea9336b$export$8ccf933b0513f8d0(toArg) : $4f1262dadea9336b$var$_extends({}, toArg);
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from; // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        } // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $4f1262dadea9336b$export$b09f2ff0bbcb43c7(to, from); // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/"); // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $4f1262dadea9336b$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $4f1262dadea9336b$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $4f1262dadea9336b$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $4f1262dadea9336b$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $4f1262dadea9336b$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $4f1262dadea9336b$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $4f1262dadea9336b$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $4f1262dadea9336b$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $4f1262dadea9336b$export$42a99a7a4bc0e76a extends Error {
}
class $4f1262dadea9336b$var$DeferredData {
    constructor(data){
        this.pendingKeys = new Set();
        this.subscriber = undefined;
        $4f1262dadea9336b$export$f5708dca728d7177(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects"); // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $4f1262dadea9336b$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.pendingKeys.add(key); // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, null, data), (error)=>this.onSettle(promise, key, error)); // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $4f1262dadea9336b$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeys.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        const subscriber = this.subscriber;
        if (error) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            subscriber && subscriber(false);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        subscriber && subscriber(false);
        return data;
    }
    subscribe(fn) {
        this.subscriber = fn;
    }
    cancel() {
        this.controller.abort();
        this.pendingKeys.forEach((v, k)=>this.pendingKeys.delete(k));
        let subscriber = this.subscriber;
        subscriber && subscriber(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeys.size === 0;
    }
    get unwrappedData() {
        $4f1262dadea9336b$export$f5708dca728d7177(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $4f1262dadea9336b$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
}
function $4f1262dadea9336b$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $4f1262dadea9336b$var$unwrapTrackedPromise(value) {
    if (!$4f1262dadea9336b$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
function $4f1262dadea9336b$export$260e5c0943f31606(data) {
    return new $4f1262dadea9336b$var$DeferredData(data);
}
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $4f1262dadea9336b$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $4f1262dadea9336b$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $4f1262dadea9336b$export$acf1a680051f5031 {
    constructor(status, statusText, data){
        this.status = status;
        this.statusText = statusText || "";
        this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response throw from an action/loader
 */ function $4f1262dadea9336b$export$972111febbeef05b(e) {
    return e instanceof $4f1262dadea9336b$export$acf1a680051f5031;
}
const $4f1262dadea9336b$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $4f1262dadea9336b$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
}; //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $4f1262dadea9336b$export$baddd0131ee8c05b(init) {
    $4f1262dadea9336b$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let dataRoutes = $4f1262dadea9336b$export$4a6d22b32134ea5d(init.routes); // Cleanup function for history
    let unlistenHistory = null; // Externally-provided functions to call on all state changes
    let subscribers = new Set(); // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null; // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null; // Externally-provided function to get current scroll position
    let getScrollPosition = null; // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    let initialScrollRestored = false;
    let initialMatches = $4f1262dadea9336b$export$2708184779ceb39d(dataRoutes, init.history.location, init.basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let { matches: matches, route: route, error: error } = $4f1262dadea9336b$var$getNotFoundMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = !initialMatches.some((m)=>m.route.loader) || init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $4f1262dadea9336b$export$ed3e14b2f9e105d0,
        restoreScrollPosition: null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map()
    }; // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $4f1262dadea9336b$export$e19cd5f9376f8cee.Pop; // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false; // AbortController for the active navigation
    let pendingNavigationController; // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false; // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidate()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false; // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = []; // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = []; // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map(); // Track loads based on the order in which they started
    let incrementingLoadId = 0; // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1; // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map(); // Fetchers that triggered redirect navigations from their actions
    let fetchRedirectIds = new Set(); // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map(); // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map(); // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location } = _ref;
            return startNavigation(historyAction, location);
        }); // Kick off initial data load if needed.  Use Pop to avoid modifying history
        if (!state.initialized) startNavigation($4f1262dadea9336b$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    } // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
    } // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    } // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $4f1262dadea9336b$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    } // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a submission
        // - We're past the submitting state and into the loading state
        // - This should not be susceptible to false positives for
        //   loading/submissionRedirect since there would not be actionData in the
        //   state since the prior action would have returned a redirect response
        //   and short circuited
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && state.navigation.state === "loading"; // Always preserve any existing loaderData from re-used routes
        let newLoaderData = newState.loaderData ? {
            loaderData: $4f1262dadea9336b$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [])
        } : {};
        updateState($4f1262dadea9336b$var$_extends({}, isActionReload ? {} : {
            actionData: null
        }, newState, newLoaderData, {
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $4f1262dadea9336b$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            // Don't restore on submission navigations
            restoreScrollPosition: state.navigation.formData ? false : getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: pendingPreventScrollReset
        }));
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $4f1262dadea9336b$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $4f1262dadea9336b$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $4f1262dadea9336b$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
         // Reset stateful navigation vars
        pendingAction = $4f1262dadea9336b$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    } // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let { path: path, submission: submission, error: error } = $4f1262dadea9336b$var$normalizeNavigateOptions(to, opts);
        let location = $4f1262dadea9336b$var$createLocation(state.location, path, opts && opts.state);
        let historyAction = (opts && opts.replace) === true || submission != null ? $4f1262dadea9336b$export$e19cd5f9376f8cee.Replace : $4f1262dadea9336b$export$e19cd5f9376f8cee.Push;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        return await startNavigation(historyAction, location, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    } // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        }); // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
         // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        } // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    } // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true; // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $4f1262dadea9336b$export$2708184779ceb39d(dataRoutes, location, init.basename); // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { matches: notFoundMatches, route: route, error: error } = $4f1262dadea9336b$var$getNotFoundMatches(dataRoutes); // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        } // Short circuit if it's only a hash change
        if ($4f1262dadea9336b$var$isHashChangeOnly(state.location, location)) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        } // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $4f1262dadea9336b$var$createRequest(location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$4f1262dadea9336b$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            let navigation = $4f1262dadea9336b$var$_extends({
                state: "loading",
                location: location
            }, opts.submission);
            loadingNavigation = navigation;
        } // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
         // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: matches,
            loaderData: loaderData,
            errors: errors
        });
    } // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        interruptActiveLoads(); // Put us in a submitting state
        let navigation = $4f1262dadea9336b$var$_extends({
            state: "submitting",
            location: location
        }, submission);
        updateState({
            navigation: navigation
        }); // Call our action and get the result
        let result;
        let actionMatch = $4f1262dadea9336b$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action) result = $4f1262dadea9336b$var$getMethodNotAllowedResult(location);
        else {
            result = await $4f1262dadea9336b$var$callLoaderOrAction("action", request, actionMatch);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($4f1262dadea9336b$var$isRedirectResult(result)) {
            let redirectNavigation = $4f1262dadea9336b$var$_extends({
                state: "loading",
                location: $4f1262dadea9336b$var$createLocation(state.location, result.location)
            }, submission);
            await startRedirectNavigation(result, redirectNavigation, opts && opts.replace);
            return {
                shortCircuited: true
            };
        }
        if ($4f1262dadea9336b$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $4f1262dadea9336b$var$findNearestBoundary(matches, actionMatch.route.id); // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $4f1262dadea9336b$export$e19cd5f9376f8cee.Push;
            return {
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($4f1262dadea9336b$var$isDeferredResult(result)) throw new Error("defer() is not supported in actions");
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    } // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation;
        if (!loadingNavigation) {
            let navigation = {
                state: "loading",
                location: location,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            };
            loadingNavigation = navigation;
        }
        let [matchesToLoad, revalidatingFetchers] = $4f1262dadea9336b$var$getMatchesToLoad(state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, pendingActionData, pendingError, fetchLoadMatches); // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId)); // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            completeNavigation(location, {
                matches: matches,
                loaderData: $4f1262dadea9336b$var$mergeLoaderData(state.loaderData, {}, matches),
                // Commit pending error if we're short circuiting
                errors: pendingError || null,
                actionData: pendingActionData || null
            });
            return {
                shortCircuited: true
            };
        } // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((_ref2)=>{
                let [key] = _ref2;
                const fetcher = state.fetchers.get(key);
                let revalidatingFetcher = {
                    state: "loading",
                    data: fetcher && fetcher.data,
                    formMethod: undefined,
                    formAction: undefined,
                    formEncType: undefined,
                    formData: undefined
                };
                state.fetchers.set(key, revalidatingFetcher);
            });
            updateState($4f1262dadea9336b$var$_extends({
                navigation: loadingNavigation,
                actionData: pendingActionData || state.actionData || null
            }, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        pendingNavigationLoadId = ++incrementingLoadId;
        revalidatingFetchers.forEach((_ref3)=>{
            let [key] = _ref3;
            return fetchControllers.set(key, pendingNavigationController);
        });
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
         // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        revalidatingFetchers.forEach((_ref4)=>{
            let [key] = _ref4;
            return fetchControllers.delete(key);
        }); // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $4f1262dadea9336b$var$findRedirect(results);
        if (redirect) {
            let redirectNavigation = $4f1262dadea9336b$var$getLoaderRedirect(state, redirect);
            await startRedirectNavigation(redirect, redirectNavigation, replace);
            return {
                shortCircuited: true
            };
        } // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $4f1262dadea9336b$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds); // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        return $4f1262dadea9336b$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $4f1262dadea9336b$export$52eace9c284d3585;
    } // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (typeof AbortController === "undefined") throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let matches = $4f1262dadea9336b$export$2708184779ceb39d(dataRoutes, href, init.basename);
        if (!matches) {
            setFetcherError(key, routeId, new $4f1262dadea9336b$export$acf1a680051f5031(404, "Not Found", null));
            return;
        }
        let { path: path, submission: submission } = $4f1262dadea9336b$var$normalizeNavigateOptions(href, opts, true);
        let match = $4f1262dadea9336b$var$getTargetMatch(matches, path);
        if (submission) {
            handleFetcherAction(key, routeId, path, match, submission);
            return;
        } // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, [
            path,
            match
        ]);
        handleFetcherLoader(key, routeId, path, match);
    } // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action) {
            let { error: error } = $4f1262dadea9336b$var$getMethodNotAllowedResult(path);
            setFetcherError(key, routeId, error);
            return;
        } // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $4f1262dadea9336b$var$_extends({
            state: "submitting"
        }, submission, {
            data: existingFetcher && existingFetcher.data
        });
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $4f1262dadea9336b$var$createRequest(path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let actionResult = await $4f1262dadea9336b$var$callLoaderOrAction("action", fetchRequest, match);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($4f1262dadea9336b$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            fetchRedirectIds.add(key);
            let loadingFetcher = $4f1262dadea9336b$var$_extends({
                state: "loading"
            }, submission, {
                data: undefined
            });
            state.fetchers.set(key, loadingFetcher);
            updateState({
                fetchers: new Map(state.fetchers)
            });
            let redirectNavigation = $4f1262dadea9336b$var$_extends({
                state: "loading",
                location: $4f1262dadea9336b$var$createLocation(state.location, actionResult.location)
            }, submission);
            await startRedirectNavigation(actionResult, redirectNavigation);
            return;
        } // Process any non-redirect errors thrown
        if ($4f1262dadea9336b$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($4f1262dadea9336b$var$isDeferredResult(actionResult)) $4f1262dadea9336b$export$f5708dca728d7177(false, "defer() is not supported in actions");
         // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $4f1262dadea9336b$var$createRequest(nextLocation, abortController.signal);
        let matches = state.navigation.state !== "idle" ? $4f1262dadea9336b$export$2708184779ceb39d(dataRoutes, state.navigation.location, init.basename) : state.matches;
        $4f1262dadea9336b$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $4f1262dadea9336b$var$_extends({
            state: "loading",
            data: actionResult.data
        }, submission);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $4f1262dadea9336b$var$getMatchesToLoad(state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, {
            [match.route.id]: actionResult.data
        }, undefined, fetchLoadMatches); // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((_ref5)=>{
            let [staleKey] = _ref5;
            return staleKey !== key;
        }).forEach((_ref6)=>{
            let [staleKey] = _ref6;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = {
                state: "loading",
                data: existingFetcher && existingFetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            };
            state.fetchers.set(staleKey, revalidatingFetcher);
            fetchControllers.set(staleKey, abortController);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((_ref7)=>{
            let [staleKey] = _ref7;
            return fetchControllers.delete(staleKey);
        });
        let redirect = $4f1262dadea9336b$var$findRedirect(results);
        if (redirect) {
            let redirectNavigation = $4f1262dadea9336b$var$getLoaderRedirect(state, redirect);
            await startRedirectNavigation(redirect, redirectNavigation);
            return;
        } // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $4f1262dadea9336b$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        let doneFetcher = {
            state: "idle",
            data: actionResult.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined
        };
        state.fetchers.set(key, doneFetcher);
        let didAbortFetchLoads = abortStaleFetchLoads(loadId); // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $4f1262dadea9336b$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($4f1262dadea9336b$var$_extends({
                errors: errors,
                loaderData: $4f1262dadea9336b$var$mergeLoaderData(state.loaderData, loaderData, matches)
            }, didAbortFetchLoads ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    } // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match) {
        let existingFetcher = state.fetchers.get(key); // Put this fetcher into it's loading state
        let loadingFetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            data: existingFetcher && existingFetcher.data
        };
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $4f1262dadea9336b$var$createRequest(path, abortController.signal);
        fetchControllers.set(key, abortController);
        let result = await $4f1262dadea9336b$var$callLoaderOrAction("loader", fetchRequest, match); // Deferred isn't supported or fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($4f1262dadea9336b$var$isDeferredResult(result)) result = await $4f1262dadea9336b$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
         // We can delete this so long as we weren't aborted by ou our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
         // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($4f1262dadea9336b$var$isRedirectResult(result)) {
            let redirectNavigation = $4f1262dadea9336b$var$getLoaderRedirect(state, result);
            await startRedirectNavigation(result, redirectNavigation);
            return;
        } // Process any non-redirect errors thrown
        if ($4f1262dadea9336b$var$isErrorResult(result)) {
            let boundaryMatch = $4f1262dadea9336b$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key); // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $4f1262dadea9336b$export$f5708dca728d7177(!$4f1262dadea9336b$var$isDeferredResult(result), "Unhandled fetcher deferred data"); // Put the fetcher back into an idle state
        let doneFetcher = {
            state: "idle",
            data: result.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined
        };
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(redirect, navigation, replace) {
        if (redirect.revalidate) isRevalidationRequired = true;
        $4f1262dadea9336b$export$f5708dca728d7177(navigation.location, "Expected a location on the redirect navigation"); // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $4f1262dadea9336b$export$e19cd5f9376f8cee.Replace : $4f1262dadea9336b$export$e19cd5f9376f8cee.Push;
        await startNavigation(redirectHistoryAction, navigation.location, {
            overrideNavigation: navigation
        });
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((m)=>$4f1262dadea9336b$var$callLoaderOrAction("loader", request, m)),
            ...fetchersToLoad.map((_ref8)=>{
                let [, href, match] = _ref8;
                return $4f1262dadea9336b$var$callLoaderOrAction("loader", $4f1262dadea9336b$var$createRequest(href, request.signal), match);
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $4f1262dadea9336b$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, request.signal, false, state.loaderData),
            $4f1262dadea9336b$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((_ref9)=>{
                let [, , match] = _ref9;
                return match;
            }), fetcherResults, request.signal, true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true; // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds()); // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $4f1262dadea9336b$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        if (fetchControllers.has(key)) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $4f1262dadea9336b$export$f5708dca728d7177(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = {
                state: "idle",
                data: fetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $4f1262dadea9336b$export$f5708dca728d7177(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
            }
        }
        markFetchersDone(doneKeys);
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $4f1262dadea9336b$export$f5708dca728d7177(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    } // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || ((location)=>location.key); // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $4f1262dadea9336b$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$4f1262dadea9336b$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$4f1262dadea9336b$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    router = {
        get basename () {
            return init.basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        createHref: $4f1262dadea9336b$var$createHref,
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds
    };
    return router;
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
function $4f1262dadea9336b$export$4791cb6e2df78547(routes) {
    $4f1262dadea9336b$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to unstable_createStaticHandler");
    let dataRoutes = $4f1262dadea9336b$export$4a6d22b32134ea5d(routes);
    async function query(request) {
        let { location: location, result: result } = await queryImpl(request);
        if (result instanceof Response) return result;
         // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $4f1262dadea9336b$var$_extends({
            location: location
        }, result);
    }
    async function queryRoute(request, routeId) {
        let { result: result } = await queryImpl(request, routeId);
        if (result instanceof Response) return result;
         // Pick off the right state value to return
        let routeData = [
            result.errors,
            result.actionData,
            result.loaderData
        ].find((v)=>v);
        let value = Object.values(routeData || {})[0];
        if ($4f1262dadea9336b$export$972111febbeef05b(value)) return new Response(value.data, {
            status: value.status,
            statusText: value.statusText
        });
        return value;
    }
    async function queryImpl(request, routeId) {
        $4f1262dadea9336b$export$f5708dca728d7177(request.method !== "HEAD", "query()/queryRoute() do not support HEAD requests");
        $4f1262dadea9336b$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        let { location: location, matches: matches, shortCircuitState: shortCircuitState } = matchRequest(request, routeId);
        try {
            if (shortCircuitState) return {
                location: location,
                result: shortCircuitState
            };
            if (request.method !== "GET") {
                let result = await submit(request, matches, $4f1262dadea9336b$var$getTargetMatch(matches, location), routeId != null);
                return {
                    location: location,
                    result: result
                };
            }
            let result = await loadRouteData(request, matches, routeId != null);
            return {
                location: location,
                result: $4f1262dadea9336b$var$_extends({}, result, {
                    actionData: null,
                    actionHeaders: {}
                })
            };
        } catch (e) {
            if (e instanceof Response) return {
                location: location,
                result: e
            };
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, isRouteRequest) {
        let result;
        if (!actionMatch.route.action) {
            let href = $4f1262dadea9336b$var$createHref(new URL(request.url));
            result = $4f1262dadea9336b$var$getMethodNotAllowedResult(href);
        } else {
            result = await $4f1262dadea9336b$var$callLoaderOrAction("action", request, actionMatch, true, isRouteRequest);
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if ($4f1262dadea9336b$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // calLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($4f1262dadea9336b$var$isDeferredResult(result)) throw new Error("defer() is not supported in actions");
        if (isRouteRequest) {
            if ($4f1262dadea9336b$var$isErrorResult(result)) {
                let boundaryMatch = $4f1262dadea9336b$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    matches: [
                        actionMatch
                    ],
                    loaderData: {},
                    actionData: null,
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    // Note: statusCode + headers are unused here since queryRoute will
                    // return the raw Response or value
                    statusCode: 500,
                    loaderHeaders: {},
                    actionHeaders: {}
                };
            }
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if ($4f1262dadea9336b$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $4f1262dadea9336b$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, isRouteRequest, {
                [boundaryMatch.route.id]: result.error
            }); // action status codes take precedence over loader status codes
            return $4f1262dadea9336b$var$_extends({}, context, {
                statusCode: $4f1262dadea9336b$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $4f1262dadea9336b$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(request, matches, isRouteRequest);
        return $4f1262dadea9336b$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $4f1262dadea9336b$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, isRouteRequest, pendingActionError) {
        let matchesToLoad = $4f1262dadea9336b$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]).filter((m)=>m.route.loader); // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await Promise.all([
            ...matchesToLoad.map((m)=>$4f1262dadea9336b$var$callLoaderOrAction("loader", request, m, true, isRouteRequest))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        } // Can't do anything with these without the Remix side of things, so just
        // cancel them for now
        results.forEach((result)=>{
            if ($4f1262dadea9336b$var$isDeferredResult(result)) result.deferredData.cancel();
        }); // Process and commit output from loaders
        let context = $4f1262dadea9336b$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError);
        return $4f1262dadea9336b$var$_extends({}, context, {
            matches: matches
        });
    }
    function matchRequest(req, routeId) {
        let url = new URL(req.url);
        let location = $4f1262dadea9336b$var$createLocation("", $4f1262dadea9336b$export$fe53371bee54353d(url), null, "default");
        let matches = $4f1262dadea9336b$export$2708184779ceb39d(dataRoutes, location);
        if (matches && routeId) matches = matches.filter((m)=>m.route.id === routeId);
         // Short circuit with a 404 if we match nothing
        if (!matches) {
            let { matches: notFoundMatches, route: route, error: error } = $4f1262dadea9336b$var$getNotFoundMatches(dataRoutes);
            return {
                location: location,
                matches: notFoundMatches,
                shortCircuitState: {
                    matches: notFoundMatches,
                    loaderData: {},
                    actionData: null,
                    errors: {
                        [route.id]: error
                    },
                    statusCode: 404,
                    loaderHeaders: {},
                    actionHeaders: {}
                }
            };
        }
        return {
            location: location,
            matches: matches
        };
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $4f1262dadea9336b$export$fec11da027c70692(routes, context, error) {
    let newContext = $4f1262dadea9336b$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
} // Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $4f1262dadea9336b$var$normalizeNavigateOptions(to, opts, isFetcher) {
    if (isFetcher === void 0) isFetcher = false;
    let path = typeof to === "string" ? to : $4f1262dadea9336b$export$fe53371bee54353d(to); // Return location verbatim on non-submission navigations
    if (!opts || !("formMethod" in opts) && !("formData" in opts)) return {
        path: path
    };
     // Create a Submission on non-GET navigations
    if (opts.formMethod != null && opts.formMethod !== "get") return {
        path: path,
        submission: {
            formMethod: opts.formMethod,
            formAction: $4f1262dadea9336b$var$createHref($4f1262dadea9336b$export$8ccf933b0513f8d0(path)),
            formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
            formData: opts.formData
        }
    };
     // No formData to flatten for GET submission
    if (!opts.formData) return {
        path: path
    };
     // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $4f1262dadea9336b$export$8ccf933b0513f8d0(path);
    try {
        let searchParams = $4f1262dadea9336b$var$convertFormDataToSearchParams(opts.formData); // Since fetcher GET submissions only run a single loader (as opposed to
        // navigation GET submissions which run all loaders), we need to preserve
        // any incoming ?index params
        if (isFetcher && parsedPath.search && $4f1262dadea9336b$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
        parsedPath.search = "?" + searchParams;
    } catch (e) {
        return {
            path: path,
            error: new $4f1262dadea9336b$export$acf1a680051f5031(400, "Bad Request", "Cannot submit binary form data using GET")
        };
    }
    return {
        path: $4f1262dadea9336b$export$fe53371bee54353d(parsedPath)
    };
}
function $4f1262dadea9336b$var$getLoaderRedirect(state, redirect) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, formData: formData } = state.navigation;
    let navigation = {
        state: "loading",
        location: $4f1262dadea9336b$var$createLocation(state.location, redirect.location),
        formMethod: formMethod || undefined,
        formAction: formAction || undefined,
        formEncType: formEncType || undefined,
        formData: formData || undefined
    };
    return navigation;
} // Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $4f1262dadea9336b$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $4f1262dadea9336b$var$getMatchesToLoad(state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, pendingActionData, pendingError, fetchLoadMatches) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : null; // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $4f1262dadea9336b$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>match.route.loader != null && ($4f1262dadea9336b$var$isNewLoader(state.loaderData, state.matches[index], match) || // If this route had a pending deferred cancelled it must be revalidated
        cancelledDeferredRoutes.some((id)=>id === match.route.id) || $4f1262dadea9336b$var$shouldRevalidateLoader(state.location, state.matches[index], submission, location, match, isRevalidationRequired, actionResult))); // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches && fetchLoadMatches.forEach((_ref10, key)=>{
        let [href, match] = _ref10;
        // This fetcher was cancelled from a prior action submission - force reload
        if (cancelledFetcherLoads.includes(key)) revalidatingFetchers.push([
            key,
            href,
            match
        ]);
        else if (isRevalidationRequired) {
            let shouldRevalidate = $4f1262dadea9336b$var$shouldRevalidateLoader(href, match, submission, href, match, isRevalidationRequired, actionResult);
            if (shouldRevalidate) revalidatingFetchers.push([
                key,
                href,
                match
            ]);
        }
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $4f1262dadea9336b$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id; // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined; // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $4f1262dadea9336b$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $4f1262dadea9336b$var$shouldRevalidateLoader(currentLocation, currentMatch, submission, location, match, isRevalidationRequired, actionResult) {
    let currentUrl = $4f1262dadea9336b$var$createURL(currentLocation);
    let currentParams = currentMatch.params;
    let nextUrl = $4f1262dadea9336b$var$createURL(location);
    let nextParams = match.params; // This is the default implementation as to when we revalidate.  If the route
    // provides it's own implementation, then we give them full control but
    // provide this value so they can leverage it if needed after they check
    // their own specific use cases
    // Note that fetchers always provide the same current/next locations so the
    // URL-based checks here don't apply to fetcher shouldRevalidate calls
    let defaultShouldRevalidate = $4f1262dadea9336b$var$isNewRouteInstance(currentMatch, match) || // Clicked the same link, resubmitted a GET form
    currentUrl.toString() === nextUrl.toString() || // Search params affect all loaders
    currentUrl.search !== nextUrl.search || // Forced revalidation due to submission, useRevalidate, or X-Remix-Revalidate
    isRevalidationRequired;
    if (match.route.shouldRevalidate) {
        let routeChoice = match.route.shouldRevalidate($4f1262dadea9336b$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentParams,
            nextUrl: nextUrl,
            nextParams: nextParams
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: defaultShouldRevalidate
        }));
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return defaultShouldRevalidate;
}
async function $4f1262dadea9336b$var$callLoaderOrAction(type, request, match, skipRedirects, isRouteRequest) {
    if (skipRedirects === void 0) skipRedirects = false;
    if (isRouteRequest === void 0) isRouteRequest = false;
    let resultType;
    let result; // Setup a promise we can race against so that abort signals short circuit
    let reject;
    let abortPromise = new Promise((_, r)=>reject = r);
    let onReject = ()=>reject();
    request.signal.addEventListener("abort", onReject);
    try {
        let handler = match.route[type];
        $4f1262dadea9336b$export$f5708dca728d7177(handler, "Could not find the " + type + ' to run on the "' + match.route.id + '" route');
        result = await Promise.race([
            handler({
                request: request,
                params: match.params
            }),
            abortPromise
        ]);
    } catch (e) {
        resultType = $4f1262dadea9336b$var$ResultType.error;
        result = e;
    } finally{
        request.signal.removeEventListener("abort", onReject);
    }
    if (result instanceof Response) {
        // Process redirects
        let status = result.status;
        let location = result.headers.get("Location"); // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping
        if (isRouteRequest) throw result;
        if (status >= 300 && status <= 399 && location != null) {
            // Don't process redirects in the router during SSR document requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect
            if (skipRedirects) throw result;
            return {
                type: $4f1262dadea9336b$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null
            };
        }
        let data;
        let contentType = result.headers.get("Content-Type");
        if (contentType && contentType.startsWith("application/json")) data = await result.json();
        else data = await result.text();
        if (resultType === $4f1262dadea9336b$var$ResultType.error) return {
            type: resultType,
            error: new $4f1262dadea9336b$export$acf1a680051f5031(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $4f1262dadea9336b$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $4f1262dadea9336b$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if (result instanceof $4f1262dadea9336b$var$DeferredData) return {
        type: $4f1262dadea9336b$var$ResultType.deferred,
        deferredData: result
    };
    return {
        type: $4f1262dadea9336b$var$ResultType.data,
        data: result
    };
}
function $4f1262dadea9336b$var$createRequest(location, signal, submission) {
    let url = $4f1262dadea9336b$var$createURL(location).toString();
    let init = {
        signal: signal
    };
    if (submission) {
        let { formMethod: formMethod, formEncType: formEncType, formData: formData } = submission;
        init.method = formMethod.toUpperCase();
        init.body = formEncType === "application/x-www-form-urlencoded" ? $4f1262dadea9336b$var$convertFormDataToSearchParams(formData) : formData;
    } // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
    return new Request(url, init);
}
function $4f1262dadea9336b$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries()){
        $4f1262dadea9336b$export$f5708dca728d7177(typeof value === "string", 'File inputs are not supported with encType "application/x-www-form-urlencoded", please use "multipart/form-data" instead.');
        searchParams.append(key, value);
    }
    return searchParams;
}
function $4f1262dadea9336b$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {}; // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $4f1262dadea9336b$export$f5708dca728d7177(!$4f1262dadea9336b$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($4f1262dadea9336b$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $4f1262dadea9336b$var$findNearestBoundary(matches, id);
            let error = result.error; // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = Object.assign(errors || {}, {
                [boundaryMatch.route.id]: error
            }); // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $4f1262dadea9336b$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($4f1262dadea9336b$var$isDeferredResult(result)) {
            activeDeferreds && activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data; // TODO: Add statusCode/headers once we wire up streaming in Remix
        } else {
            loaderData[id] = result.data; // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    }); // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here
    if (pendingError) errors = pendingError;
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $4f1262dadea9336b$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $4f1262dadea9336b$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds); // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let [key, , match] = revalidatingFetchers[index];
        $4f1262dadea9336b$export$f5708dca728d7177(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index]; // Process fetcher non-redirect errors
        if ($4f1262dadea9336b$var$isErrorResult(result)) {
            let boundaryMatch = $4f1262dadea9336b$var$findNearestBoundary(state.matches, match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $4f1262dadea9336b$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($4f1262dadea9336b$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        throw new Error("Unhandled fetcher revalidation redirect");
        else if ($4f1262dadea9336b$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        throw new Error("Unhandled fetcher deferred data");
        else {
            let doneFetcher = {
                state: "idle",
                data: result.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $4f1262dadea9336b$var$mergeLoaderData(loaderData, newLoaderData, matches) {
    let mergedLoaderData = $4f1262dadea9336b$var$_extends({}, newLoaderData);
    matches.forEach((match)=>{
        let id = match.route.id;
        if (newLoaderData[id] === undefined && loaderData[id] !== undefined) mergedLoaderData[id] = loaderData[id];
    });
    return mergedLoaderData;
} // Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $4f1262dadea9336b$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $4f1262dadea9336b$var$getNotFoundMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || r.path === "" || r.path === "/") || {
        id: "__shim-404-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route,
        error: new $4f1262dadea9336b$export$acf1a680051f5031(404, "Not Found", null)
    };
}
function $4f1262dadea9336b$var$getMethodNotAllowedResult(path) {
    let href = typeof path === "string" ? path : $4f1262dadea9336b$var$createHref(path);
    console.warn("You're trying to submit to a route that does not have an action.  To fix this, please add an `action` function to the route for " + ("[" + href + "]"));
    return {
        type: $4f1262dadea9336b$var$ResultType.error,
        error: new $4f1262dadea9336b$export$acf1a680051f5031(405, "Method Not Allowed", "No action found for [" + href + "]")
    };
} // Find any returned redirect errors, starting from the lowest match
function $4f1262dadea9336b$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($4f1262dadea9336b$var$isRedirectResult(result)) return result;
    }
} // Create an href to represent a "server" URL without the hash
function $4f1262dadea9336b$var$createHref(location) {
    return (location.pathname || "") + (location.search || "");
}
function $4f1262dadea9336b$var$isHashChangeOnly(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash !== b.hash;
}
function $4f1262dadea9336b$var$isDeferredResult(result) {
    return result.type === $4f1262dadea9336b$var$ResultType.deferred;
}
function $4f1262dadea9336b$var$isErrorResult(result) {
    return result.type === $4f1262dadea9336b$var$ResultType.error;
}
function $4f1262dadea9336b$var$isRedirectResult(result) {
    return (result && result.type) === $4f1262dadea9336b$var$ResultType.redirect;
}
async function $4f1262dadea9336b$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signal, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$4f1262dadea9336b$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($4f1262dadea9336b$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $4f1262dadea9336b$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
            if (result) results[index] = result || results[index];
        });
    }
}
async function $4f1262dadea9336b$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $4f1262dadea9336b$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $4f1262dadea9336b$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $4f1262dadea9336b$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $4f1262dadea9336b$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
} // Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $4f1262dadea9336b$var$createUseMatchesMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $4f1262dadea9336b$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $4f1262dadea9336b$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && !$4f1262dadea9336b$var$hasNakedIndexQuery(search || "")) return matches.slice(-2)[0];
    return matches.slice(-1)[0];
}
function $4f1262dadea9336b$var$createURL(location) {
    let base = typeof window !== "undefined" && typeof window.location !== "undefined" ? window.location.origin : "unknown://unknown";
    let href = typeof location === "string" ? location : $4f1262dadea9336b$var$createHref(location);
    return new URL(href, base);
} //#endregion

});

parcelRegister("bvqOc", function(module, exports) {
$parcel$export(module.exports, "Provider", () => (parcelRequire("8eJ0A")).default);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("hjhWs")).useSelector);
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $bKfyC = parcelRequire("bKfyC");

var $8cl4N = parcelRequire("8cl4N");
parcelRequire("4DHDf");
var $8Z31m = parcelRequire("8Z31m");

var $cRqWe = parcelRequire("cRqWe");

var $hjhWs = parcelRequire("hjhWs");

var $6I68h = parcelRequire("6I68h");
parcelRequire("2D0Q9");
(0, $hjhWs.initializeUseSelector)((0, $8cl4N.useSyncExternalStoreWithSelector));
(0, $6I68h.initializeConnect)((0, $bKfyC.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $cRqWe.setBatch)((0, $8Z31m.unstable_batchedUpdates));

});
parcelRegister("4DHDf", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("8Z31m")).unstable_batchedUpdates);

var $8Z31m = parcelRequire("8Z31m");

});

parcelRegister("cRqWe", function(module, exports) {

$parcel$export(module.exports, "setBatch", () => $95cf54a2584054cf$export$4b9874722d0da7bc);
$parcel$export(module.exports, "getBatch", () => $95cf54a2584054cf$export$fc47d4c0ba3bd2c6);
// Default to a dummy "batch" implementation that just runs the callback
function $95cf54a2584054cf$var$defaultNoopBatch(callback) {
    callback();
}
let $95cf54a2584054cf$var$batch = $95cf54a2584054cf$var$defaultNoopBatch; // Allow injecting another batching function later
const $95cf54a2584054cf$export$4b9874722d0da7bc = (newBatch)=>$95cf54a2584054cf$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $95cf54a2584054cf$export$fc47d4c0ba3bd2c6 = ()=>$95cf54a2584054cf$var$batch;

});

parcelRegister("hjhWs", function(module, exports) {

$parcel$export(module.exports, "initializeUseSelector", () => $c9a220e4aa274116$export$e2e6e3f3f3b782e3);
$parcel$export(module.exports, "useSelector", () => $c9a220e4aa274116$export$2105062e25df4afe);

var $3qjKr = parcelRequire("3qjKr");

var $28cAC = parcelRequire("28cAC");

var $2e9Ni = parcelRequire("2e9Ni");

var $htZTh = parcelRequire("htZTh");
let $c9a220e4aa274116$var$useSyncExternalStoreWithSelector = (0, $htZTh.notInitialized);
const $c9a220e4aa274116$export$e2e6e3f3f3b782e3 = (fn)=>{
    $c9a220e4aa274116$var$useSyncExternalStoreWithSelector = fn;
};
const $c9a220e4aa274116$var$refEquality = (a, b)=>a === b;
function $c9a220e4aa274116$export$2b53f90d2bd1cbfb(context = (0, $2e9Ni.ReactReduxContext)) {
    const useReduxContext = context === (0, $2e9Ni.ReactReduxContext) ? (0, $28cAC.useReduxContext) : (0, $28cAC.createReduxContextHook)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $c9a220e4aa274116$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $3qjKr.useRef)(true);
        const wrappedSelector = (0, $3qjKr.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $c9a220e4aa274116$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $3qjKr.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $c9a220e4aa274116$export$2105062e25df4afe = /*#__PURE__*/ $c9a220e4aa274116$export$2b53f90d2bd1cbfb();

});
parcelRegister("28cAC", function(module, exports) {

$parcel$export(module.exports, "createReduxContextHook", () => $18d6182d531a298d$export$d4d6226d5fc61558);
$parcel$export(module.exports, "useReduxContext", () => $18d6182d531a298d$export$c1275ca9a6fd3ec5);

var $3qjKr = parcelRequire("3qjKr");

var $2e9Ni = parcelRequire("2e9Ni");
function $18d6182d531a298d$export$d4d6226d5fc61558(context = (0, $2e9Ni.ReactReduxContext)) {
    return function useReduxContext() {
        const contextValue = (0, $3qjKr.useContext)(context);
        return contextValue;
    };
}
const $18d6182d531a298d$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $18d6182d531a298d$export$d4d6226d5fc61558();

});
parcelRegister("2e9Ni", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", () => $19f47c8064c2b506$export$cc80c08dc91f1c00);

var $3qjKr = parcelRequire("3qjKr");
const $19f47c8064c2b506$var$ContextKey = Symbol.for(`react-redux-context`);
const $19f47c8064c2b506$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $19f47c8064c2b506$var$getContext() {
    var _gT$ContextKey;
    if (!$3qjKr.createContext) return {};
    const contextMap = (_gT$ContextKey = $19f47c8064c2b506$var$gT[$19f47c8064c2b506$var$ContextKey]) != null ? _gT$ContextKey : $19f47c8064c2b506$var$gT[$19f47c8064c2b506$var$ContextKey] = new Map();
    let realContext = contextMap.get($3qjKr.createContext);
    if (!realContext) {
        realContext = $3qjKr.createContext(null);
        contextMap.set($3qjKr.createContext, realContext);
    }
    return realContext;
}
const $19f47c8064c2b506$export$cc80c08dc91f1c00 = /*#__PURE__*/ $19f47c8064c2b506$var$getContext();
var $19f47c8064c2b506$export$2e2bcd8739ae039 = $19f47c8064c2b506$export$cc80c08dc91f1c00;

});


parcelRegister("htZTh", function(module, exports) {

$parcel$export(module.exports, "notInitialized", () => $cba5274e8208ff80$export$20656a4825650bd0);
const $cba5274e8208ff80$export$20656a4825650bd0 = ()=>{
    throw new Error("uSES not initialized!");
};

});


parcelRegister("6I68h", function(module, exports) {

$parcel$export(module.exports, "initializeConnect", () => $4e2b9bf224942ca8$export$36d45daa6a4925b8);

var $50wIY = parcelRequire("50wIY");

var $3mDYF = parcelRequire("3mDYF");

var $i7wrp = parcelRequire("i7wrp");

var $3qjKr = parcelRequire("3qjKr");

var $18dcE = parcelRequire("18dcE");

var $bp4KV = parcelRequire("bp4KV");

var $3MJoA = parcelRequire("3MJoA");

var $6c6B4 = parcelRequire("6c6B4");

var $5F4D5 = parcelRequire("5F4D5");

var $krRga = parcelRequire("krRga");

var $8r0tC = parcelRequire("8r0tC");

var $aBnXY = parcelRequire("aBnXY");
parcelRequire("knjE9");

var $2e9Ni = parcelRequire("2e9Ni");

var $htZTh = parcelRequire("htZTh");
const $4e2b9bf224942ca8$var$_excluded = [
    "reactReduxForwardedRef"
];
let $4e2b9bf224942ca8$var$useSyncExternalStore = (0, $htZTh.notInitialized);
const $4e2b9bf224942ca8$export$36d45daa6a4925b8 = (fn)=>{
    $4e2b9bf224942ca8$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $4e2b9bf224942ca8$var$EMPTY_ARRAY = [
    null,
    0
];
const $4e2b9bf224942ca8$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $4e2b9bf224942ca8$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $4e2b9bf224942ca8$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $8r0tC.useIsomorphicLayoutEffect)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $4e2b9bf224942ca8$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $4e2b9bf224942ca8$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $4e2b9bf224942ca8$var$initStateUpdates = ()=>$4e2b9bf224942ca8$var$EMPTY_ARRAY;
function $4e2b9bf224942ca8$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $4e2b9bf224942ca8$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $4e2b9bf224942ca8$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $4e2b9bf224942ca8$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $aBnXY.default), areStatePropsEqual: areStatePropsEqual = (0, $aBnXY.default), areMergedPropsEqual: areMergedPropsEqual = (0, $aBnXY.default), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $2e9Ni.ReactReduxContext) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $6c6B4.mapStateToPropsFactory)(mapStateToProps);
    const initMapDispatchToProps = (0, $3MJoA.mapDispatchToPropsFactory)(mapDispatchToProps);
    const initMergeProps = (0, $5F4D5.mergePropsFactory)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $3qjKr.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $3mDYF.default)(props, $4e2b9bf224942ca8$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $3qjKr.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $18dcE.isContextConsumer)(/*#__PURE__*/ $3qjKr.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $3qjKr.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $3qjKr.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $bp4KV.default)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $3qjKr.useMemo(()=>{
                if (!shouldHandleStateChanges) return $4e2b9bf224942ca8$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $krRga.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $3qjKr.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $50wIY.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $3qjKr.useRef();
            const lastWrapperProps = $3qjKr.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $3qjKr.useRef();
            const renderIsScheduled = $3qjKr.useRef(false);
            const isProcessingDispatch = $3qjKr.useRef(false);
            const isMounted = $3qjKr.useRef(false);
            const latestSubscriptionCallbackError = $3qjKr.useRef();
            (0, $8r0tC.useIsomorphicLayoutEffect)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $3qjKr.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $3qjKr.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $4e2b9bf224942ca8$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $4e2b9bf224942ca8$var$useIsomorphicLayoutEffectWithArgs($4e2b9bf224942ca8$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $4e2b9bf224942ca8$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $8r0tC.useIsomorphicLayoutEffect)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $3qjKr.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $3qjKr.createElement(WrappedComponent, (0, $50wIY.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $3qjKr.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $3qjKr.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $3qjKr.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $3qjKr.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $3qjKr.createElement(Connect, (0, $50wIY.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($i7wrp)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($i7wrp)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $4e2b9bf224942ca8$export$2e2bcd8739ae039 = $4e2b9bf224942ca8$var$connect;

});
parcelRegister("bp4KV", function(module, exports) {

$parcel$export(module.exports, "default", () => $84d5b7e84b3de0b9$export$2e2bcd8739ae039);

var $3mDYF = parcelRequire("3mDYF");
parcelRequire("mWO9H");
const $84d5b7e84b3de0b9$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $84d5b7e84b3de0b9$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $84d5b7e84b3de0b9$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $3mDYF.default)(_ref, $84d5b7e84b3de0b9$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $84d5b7e84b3de0b9$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("mWO9H", function(module, exports) {

var $knjE9 = parcelRequire("knjE9");
function $044fac397f1530a1$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $knjE9.default)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $044fac397f1530a1$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $044fac397f1530a1$var$verify(mapStateToProps, "mapStateToProps");
    $044fac397f1530a1$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $044fac397f1530a1$var$verify(mergeProps, "mergeProps");
}

});
parcelRegister("knjE9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed55320841c8110d$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $ed55320841c8110d$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});



parcelRegister("3MJoA", function(module, exports) {

$parcel$export(module.exports, "mapDispatchToPropsFactory", () => $2c191163ce7105be$export$b69a785ceac019a6);

var $jLSyM = parcelRequire("jLSyM");

var $iDVUC = parcelRequire("iDVUC");

var $kCmDQ = parcelRequire("kCmDQ");
function $2c191163ce7105be$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $iDVUC.wrapMapToPropsConstant)((dispatch)=>(0, $jLSyM.default)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $iDVUC.wrapMapToPropsConstant)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? (0, $iDVUC.wrapMapToPropsFunc)(mapDispatchToProps, "mapDispatchToProps") : (0, $kCmDQ.createInvalidArgFactory)(mapDispatchToProps, "mapDispatchToProps");
}

});
parcelRegister("jLSyM", function(module, exports) {

$parcel$export(module.exports, "default", () => $e64cba948cf19ad6$export$2e2bcd8739ae039);
function $e64cba948cf19ad6$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}

});

parcelRegister("iDVUC", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", () => $d928caa98f23ca21$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $d928caa98f23ca21$export$8d46c7f53c8c602f);
parcelRequire("7Z0wu");
function $d928caa98f23ca21$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $d928caa98f23ca21$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $d928caa98f23ca21$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $d928caa98f23ca21$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $d928caa98f23ca21$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("7Z0wu", function(module, exports) {

var $ePTcq = parcelRequire("ePTcq");

var $knjE9 = parcelRequire("knjE9");
function $5cfea2c9fc9c81f1$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $ePTcq.default)(value)) (0, $knjE9.default)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}

});
parcelRegister("ePTcq", function(module, exports) {

$parcel$export(module.exports, "default", () => $acd0a58cc6a8e124$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $acd0a58cc6a8e124$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});



parcelRegister("kCmDQ", function(module, exports) {

$parcel$export(module.exports, "createInvalidArgFactory", () => $f028eb65944d4414$export$19ef7b929f7e2559);
function $f028eb65944d4414$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}

});


parcelRegister("6c6B4", function(module, exports) {

$parcel$export(module.exports, "mapStateToPropsFactory", () => $4828fb10224bbef4$export$e00e93951827eda7);

var $iDVUC = parcelRequire("iDVUC");

var $kCmDQ = parcelRequire("kCmDQ");
function $4828fb10224bbef4$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $iDVUC.wrapMapToPropsConstant)(()=>({})) : typeof mapStateToProps === "function" ? (0, $iDVUC.wrapMapToPropsFunc)(mapStateToProps, "mapStateToProps") : (0, $kCmDQ.createInvalidArgFactory)(mapStateToProps, "mapStateToProps");
}

});

parcelRegister("5F4D5", function(module, exports) {

$parcel$export(module.exports, "mergePropsFactory", () => $41f45f643900983f$export$17457cf6fa742f84);

var $50wIY = parcelRequire("50wIY");
parcelRequire("7Z0wu");

var $kCmDQ = parcelRequire("kCmDQ");
function $41f45f643900983f$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $50wIY.default)({}, ownProps, stateProps, dispatchProps);
}
function $41f45f643900983f$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $41f45f643900983f$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$41f45f643900983f$export$691c327fc30bc857 : typeof mergeProps === "function" ? $41f45f643900983f$export$5b105939c84b5234(mergeProps) : (0, $kCmDQ.createInvalidArgFactory)(mergeProps, "mergeProps");
}

});

parcelRegister("krRga", function(module, exports) {

$parcel$export(module.exports, "createSubscription", () => $ee2fa48fd54a8802$export$d567d2b9af322f8f);

var $cRqWe = parcelRequire("cRqWe");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $ee2fa48fd54a8802$var$createListenerCollection() {
    const batch = (0, $cRqWe.getBatch)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $ee2fa48fd54a8802$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $ee2fa48fd54a8802$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $ee2fa48fd54a8802$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $ee2fa48fd54a8802$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $ee2fa48fd54a8802$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}

});

parcelRegister("8r0tC", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $624137066b6ce216$export$700979bc83e7db82);

var $3qjKr = parcelRequire("3qjKr");
const $624137066b6ce216$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $624137066b6ce216$export$700979bc83e7db82 = $624137066b6ce216$export$71594e8a50f746f4 ? $3qjKr.useLayoutEffect : $3qjKr.useEffect;

});

parcelRegister("aBnXY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b7ff3513141bacd$export$2e2bcd8739ae039);
function $7b7ff3513141bacd$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $7b7ff3513141bacd$export$2e2bcd8739ae039(objA, objB) {
    if ($7b7ff3513141bacd$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$7b7ff3513141bacd$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});


parcelRegister("2D0Q9", function(module, exports) {

$parcel$export(module.exports, "Provider", () => (parcelRequire("8eJ0A")).default);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("hjhWs")).useSelector);

var $8eJ0A = parcelRequire("8eJ0A");

var $6I68h = parcelRequire("6I68h");

var $2e9Ni = parcelRequire("2e9Ni");

var $jQJ9e = parcelRequire("jQJ9e");

var $hjhWs = parcelRequire("hjhWs");

var $cZKp3 = parcelRequire("cZKp3");

var $aBnXY = parcelRequire("aBnXY");
parcelRequire("3sDD8");

});
parcelRegister("8eJ0A", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ff28b4864c5dc44$export$2e2bcd8739ae039);

var $3qjKr = parcelRequire("3qjKr");

var $2e9Ni = parcelRequire("2e9Ni");

var $krRga = parcelRequire("krRga");

var $8r0tC = parcelRequire("8r0tC");
function $5ff28b4864c5dc44$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", noopCheck: noopCheck = "once" }) {
    const contextValue = $3qjKr.useMemo(()=>{
        const subscription = (0, $krRga.createSubscription)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $3qjKr.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $8r0tC.useIsomorphicLayoutEffect)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $2e9Ni.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $3qjKr.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $5ff28b4864c5dc44$export$2e2bcd8739ae039 = $5ff28b4864c5dc44$var$Provider;

});

parcelRegister("jQJ9e", function(module, exports) {

var $2e9Ni = parcelRequire("2e9Ni");

var $cZKp3 = parcelRequire("cZKp3");
function $e735e5101ea402a0$export$bc9b55530897c558(context = (0, $2e9Ni.ReactReduxContext)) {
    const useStore = context === (0, $2e9Ni.ReactReduxContext) ? (0, $cZKp3.useStore) : (0, $cZKp3.createStoreHook)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $e735e5101ea402a0$export$8ad76b76a4c905f8 = /*#__PURE__*/ $e735e5101ea402a0$export$bc9b55530897c558();

});
parcelRegister("cZKp3", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", () => $975f2d3f419c5508$export$671dba69185d0304);
$parcel$export(module.exports, "useStore", () => $975f2d3f419c5508$export$6ccbb43953eebf8);

var $2e9Ni = parcelRequire("2e9Ni");

var $28cAC = parcelRequire("28cAC");
function $975f2d3f419c5508$export$671dba69185d0304(context = (0, $2e9Ni.ReactReduxContext)) {
    const useReduxContext = context === (0, $2e9Ni.ReactReduxContext) ? (0, $28cAC.useReduxContext) : (0, $28cAC.createReduxContextHook)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $975f2d3f419c5508$export$6ccbb43953eebf8 = /*#__PURE__*/ $975f2d3f419c5508$export$671dba69185d0304();

});


parcelRegister("3sDD8", function(module, exports) {

});



parcelRegister("lQ3n3", function(module, exports) {

$parcel$export(module.exports, "APP_REDUCER_NAME", () => $f05e35081a90f841$export$121613cf84b22aa2);
$parcel$export(module.exports, "setBranch", () => $f05e35081a90f841$export$370104c785ff3ab);
$parcel$export(module.exports, "selectBranch", () => $f05e35081a90f841$export$8c38a8e02665547a);
$parcel$export(module.exports, "default", () => $f05e35081a90f841$export$2e2bcd8739ae039);
/**
 * Copyright 2023 ALPHAGUARD CONSULTING, LLC.  All rights reserved.
 * Use of this source code is governed by a Commercial License Agreement
 * license can be found in the LICENSE file or contact legal@alphaguard.io
 */ 
var $04JJq = parcelRequire("04JJq");
parcelRequire("bNLBQ");
var $36fSf = parcelRequire("36fSf");
var $bNLBQ = parcelRequire("bNLBQ");

var $jgLFK = parcelRequire("jgLFK");

var $eeMrw = parcelRequire("eeMrw");
const $f05e35081a90f841$export$121613cf84b22aa2 = "app";
const $f05e35081a90f841$var$initialState = {
    isLoading: false,
    nav: {
        isOpen: true,
        variant: "permanent"
    },
    auth: {
        isAuthenticated: !!(0, (/*@__PURE__*/$parcel$interopDefault($04JJq))).get("mwtv_jwt"),
        isLoading: false,
        jwt: (0, (/*@__PURE__*/$parcel$interopDefault($04JJq))).get("mwtv_jwt") || null,
        sessionId: (0, $jgLFK.uniqueId)()
    }
};
const $f05e35081a90f841$export$58adb3bec8346d0f = (0, $bNLBQ.createSlice)({
    name: $f05e35081a90f841$export$121613cf84b22aa2,
    initialState: $f05e35081a90f841$var$initialState,
    reducers: {
        setNavVariant: (state, { payload: payload })=>{
            state.nav.variant = payload;
        },
        setNavIsOpen: (state, { payload: payload })=>{
            state.nav.isOpen = payload;
        },
        setBranch: (state, { payload: payload })=>{
            state.branch = payload;
        },
        userLogout: (state)=>{
            state.auth.jwt = null;
            state.auth.isAuthenticated = false;
            state.auth.isLoading = false;
            delete state.auth.sessionId;
            delete state.branch;
            (0, (/*@__PURE__*/$parcel$interopDefault($04JJq))).clearAll();
        }
    },
    extraReducers: (builder)=>{
        builder.addMatcher((0, $eeMrw.default).endpoints.login.matchFulfilled, (state, action)=>{
            if (!(0, $jgLFK.get)(action, "payload.jwt")) return;
            state.auth.jwt = action.payload.jwt;
            state.auth.isAuthenticated = true;
            state.auth.sessionId = (0, $jgLFK.uniqueId)();
            (0, (/*@__PURE__*/$parcel$interopDefault($04JJq))).set("mwtv_jwt", action.payload.jwt);
        });
        builder.addMatcher((0, $eeMrw.default).endpoints.getUserContext.matchFulfilled, (state, action)=>{
            // we need to update our branch in case the context has changed
            const branch = (0, $jgLFK.get)(action, "payload.context.branch");
            if (branch?.id === state.branch?.id) state.branch = branch;
        });
        builder.addMatcher((action)=>action.type.endsWith("/rejected"), (state, { payload: payload })=>{
            const errorType = (0, $jgLFK.get)(payload, "data.error.name");
            if (payload?.status === 401 || errorType === "UnauthorizedError") {
                state.auth.isAuthenticated = false;
                state.auth.jwt = null;
                (0, (/*@__PURE__*/$parcel$interopDefault($04JJq))).remove("mwtv_jwt");
            }
        });
    }
});
const { setBranch: $f05e35081a90f841$export$370104c785ff3ab, userLogout: $f05e35081a90f841$export$e031f323d4c5324b, setNavVariant: $f05e35081a90f841$export$43d11ab1dfa71023, setNavIsOpen: $f05e35081a90f841$export$531e43ec973c20e5 } = $f05e35081a90f841$export$58adb3bec8346d0f.actions;
const $f05e35081a90f841$export$fcde68357dc20f8d = (state)=>state.app;
const $f05e35081a90f841$export$8c38a8e02665547a = (0, $36fSf.createSelector)($f05e35081a90f841$export$fcde68357dc20f8d, (app)=>app.branch);
const $f05e35081a90f841$export$81942497cd15b6c5 = (0, $36fSf.createSelector)($f05e35081a90f841$export$fcde68357dc20f8d, (app)=>app.nav);
var $f05e35081a90f841$export$2e2bcd8739ae039 = $f05e35081a90f841$export$58adb3bec8346d0f;

});
parcelRegister("04JJq", function(module, exports) {

var $jkubl = parcelRequire("jkubl");

var $8zgwB = parcelRequire("8zgwB");

var $00e3d93547a12fa0$var$plugins = [
    (parcelRequire("62rbo"))
];
module.exports = $jkubl.createStore($8zgwB, $00e3d93547a12fa0$var$plugins);

});
parcelRegister("jkubl", function(module, exports) {

var $jdIcp = parcelRequire("jdIcp");
var $e1274c12e28ecc39$var$slice = $jdIcp.slice;
var $e1274c12e28ecc39$var$pluck = $jdIcp.pluck;
var $e1274c12e28ecc39$var$each = $jdIcp.each;
var $e1274c12e28ecc39$var$bind = $jdIcp.bind;
var $e1274c12e28ecc39$var$create = $jdIcp.create;
var $e1274c12e28ecc39$var$isList = $jdIcp.isList;
var $e1274c12e28ecc39$var$isFunction = $jdIcp.isFunction;
var $e1274c12e28ecc39$var$isObject = $jdIcp.isObject;
module.exports = {
    createStore: $e1274c12e28ecc39$var$createStore
};
var $e1274c12e28ecc39$var$storeAPI = {
    version: "2.0.12",
    enabled: false,
    // get returns the value of the given key. If that value
    // is undefined, it returns optionalDefaultValue instead.
    get: function(key, optionalDefaultValue) {
        var data = this.storage.read(this._namespacePrefix + key);
        return this._deserialize(data, optionalDefaultValue);
    },
    // set will store the given value at key and returns value.
    // Calling set with value === undefined is equivalent to calling remove.
    set: function(key, value) {
        if (value === undefined) return this.remove(key);
        this.storage.write(this._namespacePrefix + key, this._serialize(value));
        return value;
    },
    // remove deletes the key and value stored at the given key.
    remove: function(key) {
        this.storage.remove(this._namespacePrefix + key);
    },
    // each will call the given callback once for each key-value pair
    // in this store.
    each: function(callback) {
        var self = this;
        this.storage.each(function(val, namespacedKey) {
            callback.call(self, self._deserialize(val), (namespacedKey || "").replace(self._namespaceRegexp, ""));
        });
    },
    // clearAll will remove all the stored key-value pairs in this store.
    clearAll: function() {
        this.storage.clearAll();
    },
    // additional functionality that can't live in plugins
    // ---------------------------------------------------
    // hasNamespace returns true if this store instance has the given namespace.
    hasNamespace: function(namespace) {
        return this._namespacePrefix == "__storejs_" + namespace + "_";
    },
    // createStore creates a store.js instance with the first
    // functioning storage in the list of storage candidates,
    // and applies the the given mixins to the instance.
    createStore: function() {
        return $e1274c12e28ecc39$var$createStore.apply(this, arguments);
    },
    addPlugin: function(plugin) {
        this._addPlugin(plugin);
    },
    namespace: function(namespace) {
        return $e1274c12e28ecc39$var$createStore(this.storage, this.plugins, namespace);
    }
};
function $e1274c12e28ecc39$var$_warn() {
    var _console = typeof console == "undefined" ? null : console;
    if (!_console) return;
    var fn = _console.warn ? _console.warn : _console.log;
    fn.apply(_console, arguments);
}
function $e1274c12e28ecc39$var$createStore(storages, plugins, namespace) {
    if (!namespace) namespace = "";
    if (storages && !$e1274c12e28ecc39$var$isList(storages)) storages = [
        storages
    ];
    if (plugins && !$e1274c12e28ecc39$var$isList(plugins)) plugins = [
        plugins
    ];
    var namespacePrefix = namespace ? "__storejs_" + namespace + "_" : "";
    var namespaceRegexp = namespace ? new RegExp("^" + namespacePrefix) : null;
    var legalNamespaces = /^[a-zA-Z0-9_\-]*$/ // alpha-numeric + underscore and dash
    ;
    if (!legalNamespaces.test(namespace)) throw new Error("store.js namespaces can only have alphanumerics + underscores and dashes");
    var _privateStoreProps = {
        _namespacePrefix: namespacePrefix,
        _namespaceRegexp: namespaceRegexp,
        _testStorage: function(storage) {
            try {
                var testStr = "__storejs__test__";
                storage.write(testStr, testStr);
                var ok = storage.read(testStr) === testStr;
                storage.remove(testStr);
                return ok;
            } catch (e) {
                return false;
            }
        },
        _assignPluginFnProp: function(pluginFnProp, propName) {
            var oldFn = this[propName];
            this[propName] = function pluginFn() {
                var args = $e1274c12e28ecc39$var$slice(arguments, 0);
                var self = this;
                // super_fn calls the old function which was overwritten by
                // this mixin.
                function super_fn() {
                    if (!oldFn) return;
                    $e1274c12e28ecc39$var$each(arguments, function(arg, i) {
                        args[i] = arg;
                    });
                    return oldFn.apply(self, args);
                }
                // Give mixing function access to super_fn by prefixing all mixin function
                // arguments with super_fn.
                var newFnArgs = [
                    super_fn
                ].concat(args);
                return pluginFnProp.apply(self, newFnArgs);
            };
        },
        _serialize: function(obj) {
            return JSON.stringify(obj);
        },
        _deserialize: function(strVal, defaultVal) {
            if (!strVal) return defaultVal;
            // It is possible that a raw string value has been previously stored
            // in a storage without using store.js, meaning it will be a raw
            // string value instead of a JSON serialized string. By defaulting
            // to the raw string value in case of a JSON parse error, we allow
            // for past stored values to be forwards-compatible with store.js
            var val = "";
            try {
                val = JSON.parse(strVal);
            } catch (e) {
                val = strVal;
            }
            return val !== undefined ? val : defaultVal;
        },
        _addStorage: function(storage) {
            if (this.enabled) return;
            if (this._testStorage(storage)) {
                this.storage = storage;
                this.enabled = true;
            }
        },
        _addPlugin: function(plugin) {
            var self = this;
            // If the plugin is an array, then add all plugins in the array.
            // This allows for a plugin to depend on other plugins.
            if ($e1274c12e28ecc39$var$isList(plugin)) {
                $e1274c12e28ecc39$var$each(plugin, function(plugin) {
                    self._addPlugin(plugin);
                });
                return;
            }
            // Keep track of all plugins we've seen so far, so that we
            // don't add any of them twice.
            var seenPlugin = $e1274c12e28ecc39$var$pluck(this.plugins, function(seenPlugin) {
                return plugin === seenPlugin;
            });
            if (seenPlugin) return;
            this.plugins.push(plugin);
            // Check that the plugin is properly formed
            if (!$e1274c12e28ecc39$var$isFunction(plugin)) throw new Error("Plugins must be function values that return objects");
            var pluginProperties = plugin.call(this);
            if (!$e1274c12e28ecc39$var$isObject(pluginProperties)) throw new Error("Plugins must return an object of function properties");
            // Add the plugin function properties to this store instance.
            $e1274c12e28ecc39$var$each(pluginProperties, function(pluginFnProp, propName) {
                if (!$e1274c12e28ecc39$var$isFunction(pluginFnProp)) throw new Error("Bad plugin property: " + propName + " from plugin " + plugin.name + ". Plugins should only return functions.");
                self._assignPluginFnProp(pluginFnProp, propName);
            });
        },
        // Put deprecated properties in the private API, so as to not expose it to accidential
        // discovery through inspection of the store object.
        // Deprecated: addStorage
        addStorage: function(storage) {
            $e1274c12e28ecc39$var$_warn("store.addStorage(storage) is deprecated. Use createStore([storages])");
            this._addStorage(storage);
        }
    };
    var store = $e1274c12e28ecc39$var$create(_privateStoreProps, $e1274c12e28ecc39$var$storeAPI, {
        plugins: []
    });
    store.raw = {};
    $e1274c12e28ecc39$var$each(store, function(prop, propName) {
        if ($e1274c12e28ecc39$var$isFunction(prop)) store.raw[propName] = $e1274c12e28ecc39$var$bind(store, prop);
    });
    $e1274c12e28ecc39$var$each(storages, function(storage) {
        store._addStorage(storage);
    });
    $e1274c12e28ecc39$var$each(plugins, function(plugin) {
        store._addPlugin(plugin);
    });
    return store;
}

});

parcelRegister("8zgwB", function(module, exports) {






module.exports = [
    // Listed in order of usage preference
    (parcelRequire("eFcLf")),
    (parcelRequire("8KDBm")),
    (parcelRequire("axeA6")),
    (parcelRequire("43GGY")),
    (parcelRequire("hJeqb")),
    (parcelRequire("ewqms"))
];

});


parcelRegister("eeMrw", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6afe7179f313970$export$2e2bcd8739ae039);
/**
 * Copyright 2023 ALPHAGUARD CONSULTING, LLC.  All rights reserved.
 * Use of this source code is governed by a Commercial License Agreement
 * license can be found in the LICENSE file or contact legal@alphaguard.io
 */ 
var $3XnHf = parcelRequire("3XnHf");

var $jgLFK = parcelRequire("jgLFK");

var $7oLjV = parcelRequire("7oLjV");
const $c6afe7179f313970$export$22b03141759b08d3 = {
    authenticated: "ADMIN",
    authenticated_member: "MEMBER",
    public: "VIEWER"
};
const $c6afe7179f313970$var$transformUserContextResponse = (res, ...args)=>({
        ...(0, $jgLFK.pick)(res.data, "id"),
        ...(0, $jgLFK.get)(res.data, "attributes", {})
    });
const $c6afe7179f313970$export$ec2937cfc2f273d0 = (0, $7oLjV.default).injectEndpoints({
    endpoints: (builder)=>({
            login: builder.mutation({
                query: (credentials)=>({
                        url: "/auth/local",
                        method: "POST",
                        body: credentials
                    })
            }),
            getUser: builder.query({
                query: ()=>`/users/me?populate=role`
            }),
            findUser: builder.query({
                query: (searchValue)=>{
                    const query = {
                        populate: {
                            role: {
                                fields: [
                                    "id"
                                ]
                            }
                        },
                        filters: {
                            $or: [
                                {
                                    email: searchValue
                                }
                            ]
                        }
                    };
                    return `/users?${(0, (/*@__PURE__*/$parcel$interopDefault($3XnHf))).stringify(query, {
                        encodeValuesOnly: true
                    })}`;
                }
            }),
            updateUser: builder.mutation({
                invalidatesTags: (result, error, { id: id })=>[
                        {
                            type: "Users",
                            id: id
                        }
                    ],
                query: (user)=>({
                        url: `/users/${user.id}`,
                        method: "PUT",
                        body: user
                    })
            }),
            getRoles: builder.query({
                query: (user)=>({
                        url: `/users-permissions/roles`,
                        method: "GET",
                        body: user
                    }),
                transformResponse: (res)=>(0, $7oLjV.getListModel)((0, $jgLFK.get)(res, "roles", []), {
                        label: (role)=>(0, $jgLFK.get)($c6afe7179f313970$export$22b03141759b08d3, role.type)
                    })
            }),
            getUserContext: builder.query({
                providesTags: [
                    "UserContext"
                ],
                query: (slug)=>`/user-context${slug ? `?slug=${slug}` : ""}`
            }),
            createUserContext: builder.mutation({
                query: ({ user: user, ...context })=>({
                        url: `/portal-contexts`,
                        method: "POST",
                        body: {
                            data: {
                                user: (0, $jgLFK.get)(user, "id", user),
                                context: context
                            }
                        }
                    }),
                transformResponse: $c6afe7179f313970$var$transformUserContextResponse
            }),
            updateUserContext: builder.mutation({
                invalidatesTags: [
                    "UserContext"
                ],
                query: ({ id: id, ...context })=>({
                        url: `/portal-contexts/${id}`,
                        method: "PUT",
                        body: {
                            data: {
                                context: context
                            }
                        }
                    }),
                transformResponse: $c6afe7179f313970$var$transformUserContextResponse
            }),
            createUser: builder.mutation({
                invalidatesTags: (result, error)=>[
                        {
                            type: "Users",
                            id: "LIST"
                        }
                    ],
                query: (user)=>({
                        url: `/users`,
                        method: "POST",
                        body: user
                    })
            }),
            forgotPassword: builder.mutation({
                query: (email)=>({
                        url: `/auth/forgot-password`,
                        method: "POST",
                        body: {
                            email: email
                        }
                    })
            }),
            resetPassword: builder.mutation({
                query: (body)=>({
                        url: `/auth/reset-password`,
                        method: "POST",
                        body: body
                    })
            })
        }),
    overrideExisting: true
});
const { useCreateUserContextMutation: $c6afe7179f313970$export$610c8ecfc3a88484, useCreateUserMutation: $c6afe7179f313970$export$989d55af39b135f7, useFindUserQuery: $c6afe7179f313970$export$657c84b0ec184109, useForgotPasswordMutation: $c6afe7179f313970$export$5cc27ec90be72f47, useGetRolesQuery: $c6afe7179f313970$export$df99cc263e9b1304, useGetUserContextQuery: $c6afe7179f313970$export$9275c2180dadf95a, useGetUserQuery: $c6afe7179f313970$export$9beb97f355b95ab9, useLazyFindUserQuery: $c6afe7179f313970$export$419cc138c8bc3436, useLoginMutation: $c6afe7179f313970$export$cddfb6c1bfa4d45f, useResetPasswordMutation: $c6afe7179f313970$export$3177acf383c684f6, useUpdateUserMutation: $c6afe7179f313970$export$d51a7f6b32955917 } = $c6afe7179f313970$export$ec2937cfc2f273d0;
var $c6afe7179f313970$export$2e2bcd8739ae039 = $c6afe7179f313970$export$ec2937cfc2f273d0;

});


parcelRegister("fbl3M", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f873ed20b5f354f$export$2e2bcd8739ae039);
/**
 * Copyright 2023 ALPHAGUARD CONSULTING, LLC.  All rights reserved.
 * Use of this source code is governed by a Commercial License Agreement
 * license can be found in the LICENSE file or contact legal@alphaguard.io
 */ 
var $bNLBQ = parcelRequire("bNLBQ");

var $lQ3n3 = parcelRequire("lQ3n3");

var $13JTy = parcelRequire("13JTy");

var $7oLjV = parcelRequire("7oLjV");
const $8f873ed20b5f354f$export$a8a69c316169e623 = {
    // slices & reducer
    [(0, $lQ3n3.default).name]: (0, $lQ3n3.default).reducer,
    [(0, $13JTy.default).name]: (0, $13JTy.default).reducer,
    // api reducers
    [(0, $7oLjV.default).reducerPath]: (0, $7oLjV.default).reducer
};
const $8f873ed20b5f354f$export$6f57813fe9f31bf9 = (0, $bNLBQ.configureStore)({
    reducer: $8f873ed20b5f354f$export$a8a69c316169e623,
    middleware: (getDefaultMiddleware)=>getDefaultMiddleware().concat((0, $7oLjV.default).middleware)
});
var $8f873ed20b5f354f$export$2e2bcd8739ae039 = $8f873ed20b5f354f$export$6f57813fe9f31bf9;

});
parcelRegister("13JTy", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f4e6b641fffdf3e$export$2e2bcd8739ae039);
/**
 * Copyright 2023 ALPHAGUARD CONSULTING, LLC.  All rights reserved.
 * Use of this source code is governed by a Commercial License Agreement
 * license can be found in the LICENSE file or contact legal@alphaguard.io
 */ parcelRequire("bNLBQ");
var $36fSf = parcelRequire("36fSf");
var $bNLBQ = parcelRequire("bNLBQ");

var $jgLFK = parcelRequire("jgLFK");

var $7ks5e = parcelRequire("7ks5e");

var $14Z8b = parcelRequire("14Z8b");

var $1S59q = parcelRequire("1S59q");

var $lQ3n3 = parcelRequire("lQ3n3");
var $5f4e6b641fffdf3e$export$7f87c855544bc1bc;
(function(EDITOR_MODE) {
    EDITOR_MODE[EDITOR_MODE["LAYOUT"] = 0] = "LAYOUT";
    EDITOR_MODE[EDITOR_MODE["EDIT"] = 1] = "EDIT";
})($5f4e6b641fffdf3e$export$7f87c855544bc1bc || ($5f4e6b641fffdf3e$export$7f87c855544bc1bc = {}));
const $5f4e6b641fffdf3e$var$initialState = {
    editorMode: 0,
    contentSelection: {
        assets: {},
        folders: {},
        textGroups: {},
        textItems: {}
    }
};
const $5f4e6b641fffdf3e$export$58adb3bec8346d0f = (0, $bNLBQ.createSlice)({
    name: "edit_display_template",
    initialState: $5f4e6b641fffdf3e$var$initialState,
    reducers: {
        editTemplate: (state, { payload: payload })=>{
            (0, $jgLFK.setWith)(state, "editableTemplate.id", payload);
        },
        setSelectedContent: (state, { payload: payload })=>{
            state.contentSelection = {
                ...state.contentSelection,
                ...payload
            };
        },
        updateTemplateSections: (state, { payload: payload })=>{
            if (!state.editableTemplate) return;
            state.editableTemplate.sections = payload;
        },
        updateTemplateSection: (state, { payload: payload })=>{
            if (!state.editableTemplate?.sections) return;
            const { sections: sections } = state.editableTemplate;
            const uid = (0, $jgLFK.pick)(payload, [
                "id",
                "blockUID"
            ]);
            const index = (0, $jgLFK.findIndex)(sections, uid);
            if (~index) {
                (0, $jgLFK.set)(sections, index, {
                    ...sections[index],
                    ...payload
                });
                if (state.selectedBlock && (0, $jgLFK.isMatch)(state.selectedBlock, uid)) state.selectedBlock = sections[index];
            }
        },
        addTemplateSection: (state, { payload: payload })=>{
            if (!state.editableTemplate) return;
            const sections = state.editableTemplate?.sections || [];
            const blankSection = (0, $1S59q.generateUISectionBlock)();
            const newSection = {
                ...blankSection,
                ...payload,
                blocks: [
                    ...(0, $jgLFK.get)(payload, "blocks", []),
                    ...blankSection.blocks
                ]
            };
            state.editableTemplate.sections = [
                ...sections,
                newSection
            ];
            state.selectedBlock = newSection;
        },
        deleteTemplateSection: (state, { payload: payload })=>{
            if (!state.editableTemplate?.sections) return;
            const selectedSection = (0, $jgLFK.pick)(payload, [
                "id",
                "blockUID"
            ]);
            const { sections: sections } = state.editableTemplate;
            state.editableTemplate.sections = sections.filter((section)=>!(0, $jgLFK.isMatch)(section, selectedSection));
            // clear selected block if it was deleted
            if (state.selectedBlock && (0, $jgLFK.isMatch)(state.selectedBlock, selectedSection)) state.selectedBlock = undefined;
        },
        selectTemplateBlock: (state, { payload: payload })=>{
            state.selectedBlock = payload;
        },
        addTemplateBlock: (state)=>{
            if (!state.selectedBlock) return;
            const selected = (0, $jgLFK.pick)(state.selectedBlock, [
                "id",
                "blockUID"
            ]);
            const section = state.editableTemplate?.sections?.find(({ blocks: blocks, ...item })=>(0, $jgLFK.isMatch)(item, selected) || (0, $jgLFK.some)(blocks, (0, $jgLFK.matches)(selected)));
            if (section) {
                const newBlock = (0, $1S59q.generateUIContentBlock)();
                section.blocks?.push(newBlock);
            }
            state.selectedBlock = section;
        },
        updateTemplateBlocks: (state, { payload: payload })=>{
            const section = state.editableTemplate?.sections?.find((section)=>payload.sectionUID && (0, $jgLFK.isMatch)(section, payload.sectionUID));
            if (!section || !section.blocks?.length) return;
            section.blocks = payload.blocks;
        },
        updateSelectedBlock: (state, { payload: payload })=>{
            const { partial: partial = true } = payload;
            const uid = (0, $jgLFK.pick)(state.selectedBlock, [
                "id",
                "blockUID"
            ]);
            if ((0, $7ks5e.isUISectionBlockType)(state.selectedBlock)) {
                const section = (0, $jgLFK.find)(state.editableTemplate?.sections, (0, $jgLFK.matches)(uid));
                // update section properties
                if (partial) (0, $jgLFK.merge)(section.properties, payload.block);
                else (0, $jgLFK.assign)(section.properties, payload.block);
                // remove config properties
                payload?.removeConfig?.forEach((path)=>(0, $jgLFK.unset)(section.properties?.config, path));
                state.selectedBlock = section;
            } else {
                const block = (0, $jgLFK.find)((0, $jgLFK.flatMap)(state.editableTemplate?.sections, "blocks"), (0, $jgLFK.matches)(uid));
                // update section properties
                if (partial) (0, $jgLFK.merge)(block, payload.block);
                else (0, $jgLFK.assign)(block, payload.block);
                // remove config properties
                payload?.removeConfig?.forEach((path)=>(0, $jgLFK.unset)(block?.config, path));
                state.selectedBlock = block;
            }
        },
        deleteTemplateBlock: (state, { payload: payload })=>{
            const section = state.editableTemplate?.sections?.find((section)=>(0, $jgLFK.isMatch)(section, payload.section));
            if (!section || !section.blocks?.length) return;
            state.selectedBlock = section;
            section.blocks = section.blocks.filter((block)=>!(0, $jgLFK.isMatch)(block, payload.block));
        },
        discardTemplateChanges: (state)=>{
            state.editableTemplate = state.originalTemplate;
        },
        setEditorLoading: (state, { payload: payload })=>{
            state.isLoading = payload;
        },
        setEditorMode: (state, { payload: payload })=>{
            state.editorMode = payload;
        }
    },
    extraReducers: (builder)=>{
        // get default template
        builder.addMatcher((0, $14Z8b.default).endpoints.getDefaultTemplate.matchRejected, (state)=>{
            if (!state.editableTemplate) {
                state.editableTemplate = (0, $1S59q.UI_DEFAULT_DISPLAY_TEMPLATE);
                state.originalTemplate = state.editableTemplate;
            }
        }).addMatcher((0, $14Z8b.default).endpoints.getDefaultTemplate.matchFulfilled, (state, action)=>{
            state.defaultTemplate = (0, $jgLFK.omit)(action.payload, [
                "id"
            ]);
            if (!state.editableTemplate) {
                state.editableTemplate = state.defaultTemplate;
                state.originalTemplate = state.editableTemplate;
            }
        });
        // get default template
        builder.addMatcher((0, $14Z8b.default).endpoints.getDisplayTemplate.matchFulfilled, (state, action)=>{
            state.editableTemplate = action.payload;
            state.originalTemplate = state.editableTemplate;
        });
        // get default template
        builder.addMatcher((0, $14Z8b.default).endpoints.createDisplayTemplate.matchFulfilled, (state, action)=>{
            const templateId = (0, $jgLFK.get)(action, "payload.data.id");
            if (templateId) state.editableTemplate = {
                id: templateId
            };
        });
        builder.addMatcher((0, $lQ3n3.setBranch).match, (state, action)=>{
            const templateId = (0, $jgLFK.get)(action, "payload.display_template.id");
            if (!templateId) state.editableTemplate = state.defaultTemplate;
            else if (templateId !== state.editableTemplate?.id) state.editableTemplate = {
                id: templateId
            };
        });
    }
});
const { addTemplateBlock: $5f4e6b641fffdf3e$export$e0f347db34d5a580, addTemplateSection: $5f4e6b641fffdf3e$export$ddca27f900aa48b5, deleteTemplateBlock: $5f4e6b641fffdf3e$export$ff27452dd899037f, deleteTemplateSection: $5f4e6b641fffdf3e$export$d327e38a94f10ef8, discardTemplateChanges: $5f4e6b641fffdf3e$export$c98bf51a2319622f, editTemplate: $5f4e6b641fffdf3e$export$45274f80049361eb, selectTemplateBlock: $5f4e6b641fffdf3e$export$663cb016aa488d83, setEditorLoading: $5f4e6b641fffdf3e$export$c3a527f7526bc17a, setEditorMode: $5f4e6b641fffdf3e$export$368c7b5307be294e, setSelectedContent: $5f4e6b641fffdf3e$export$48eb9a246269e63c, updateSelectedBlock: $5f4e6b641fffdf3e$export$2235119a659e8616, updateTemplateBlocks: $5f4e6b641fffdf3e$export$55aace42393e71a5, updateTemplateSection: $5f4e6b641fffdf3e$export$b3b3fb023bf5d693, updateTemplateSections: $5f4e6b641fffdf3e$export$a8a958bb5cb62521 } = $5f4e6b641fffdf3e$export$58adb3bec8346d0f.actions;
const $5f4e6b641fffdf3e$export$2512233a69acb03b = (state)=>state.edit_display_template;
const $5f4e6b641fffdf3e$export$e90d0f58034d3638 = (0, $36fSf.createSelector)($5f4e6b641fffdf3e$export$2512233a69acb03b, (state)=>state.editableTemplate);
const $5f4e6b641fffdf3e$export$a1822abb8344be01 = (0, $36fSf.createSelector)($5f4e6b641fffdf3e$export$2512233a69acb03b, (state)=>state.selectedBlock);
const $5f4e6b641fffdf3e$export$a712b30fb0451a31 = (0, $36fSf.createSelector)($5f4e6b641fffdf3e$export$2512233a69acb03b, (state)=>state.selectedBlock ? (0, $jgLFK.pick)(state.selectedBlock, [
        "id",
        "blockUID"
    ]) : undefined);
const $5f4e6b641fffdf3e$export$8013c6c946dbf122 = (0, $36fSf.createSelector)($5f4e6b641fffdf3e$export$2512233a69acb03b, (state)=>state.editorMode);
const $5f4e6b641fffdf3e$export$9f122041cba54f33 = (0, $36fSf.createSelector)($5f4e6b641fffdf3e$export$2512233a69acb03b, (state)=>state.contentSelection);
const $5f4e6b641fffdf3e$export$a1dce4da9436a522 = (0, $36fSf.createSelector)($5f4e6b641fffdf3e$export$2512233a69acb03b, (state)=>!(0, $jgLFK.isEqual)(state.editableTemplate, state.originalTemplate));
const $5f4e6b641fffdf3e$export$150a3e9997925533 = (0, $36fSf.createSelector)($5f4e6b641fffdf3e$export$2512233a69acb03b, (state)=>state.isLoading);
const $5f4e6b641fffdf3e$export$27b5df1e880ec508 = (0, $36fSf.createSelector)($5f4e6b641fffdf3e$export$2512233a69acb03b, (state)=>{
    const selected = (0, $jgLFK.pick)(state.selectedBlock, [
        "id",
        "blockUID"
    ]);
    const section = state.editableTemplate?.sections?.find(({ blocks: blocks, ...item })=>(0, $jgLFK.isMatch)(item, selected) || (0, $jgLFK.some)(blocks, (0, $jgLFK.matches)(selected)));
    return section;
});
var $5f4e6b641fffdf3e$export$2e2bcd8739ae039 = $5f4e6b641fffdf3e$export$58adb3bec8346d0f;

});
parcelRegister("7ks5e", function(module, exports) {

$parcel$export(module.exports, "isUISectionBlockType", () => $8185cdf5dafd9c9f$export$6020d3328982dbe5);
/**
 * Copyright 2023 ALPHAGUARD CONSULTING, LLC.  All rights reserved.
 * Use of this source code is governed by a Commercial License Agreement
 * license can be found in the LICENSE file or contact legal@alphaguard.io
 */ 
var $3qjKr = parcelRequire("3qjKr");

var $jgLFK = parcelRequire("jgLFK");
const $8185cdf5dafd9c9f$export$6020d3328982dbe5 = (block)=>block?.blocks !== undefined;
const $8185cdf5dafd9c9f$export$be074da6748bc578 = (block)=>{
    const _block = block;
    return _block?.source !== undefined || _block?.config !== undefined || _block?.blockUID !== undefined;
};
const $8185cdf5dafd9c9f$export$ddd220357f8216b3 = (section, blockUID)=>!!blockUID && (0, $jgLFK.some)(section?.blocks, (0, $jgLFK.matches)(blockUID));
const $8185cdf5dafd9c9f$export$5aee4692a48506f5 = $8185cdf5dafd9c9f$export$6020d3328982dbe5;
const $8185cdf5dafd9c9f$export$c9b156ffecf0f88f = $8185cdf5dafd9c9f$export$be074da6748bc578;
const $8185cdf5dafd9c9f$export$62346c9d6282a0a4 = (block)=>(0, (/*@__PURE__*/$parcel$interopDefault($3qjKr))).useMemo(()=>(0, $jgLFK.pick)(block, [
            "id",
            "blockUID"
        ]), [
        block
    ]);
const $8185cdf5dafd9c9f$export$dd02154d236c80f0 = (section, blockUID)=>(0, (/*@__PURE__*/$parcel$interopDefault($3qjKr))).useMemo(()=>$8185cdf5dafd9c9f$export$ddd220357f8216b3(section, blockUID), [
        section,
        blockUID
    ]);
const $8185cdf5dafd9c9f$export$40ae01be0011c1e6 = (callback, deps)=>(0, (/*@__PURE__*/$parcel$interopDefault($3qjKr))).useCallback((0, $jgLFK.debounce)(callback, 500), deps);

});

parcelRegister("14Z8b", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7453a30141e0703$export$2e2bcd8739ae039);
/**
 * Copyright 2023 ALPHAGUARD CONSULTING, LLC.  All rights reserved.
 * Use of this source code is governed by a Commercial License Agreement
 * license can be found in the LICENSE file or contact legal@alphaguard.io
 */ 
var $7V8eP = parcelRequire("7V8eP");

var $7oLjV = parcelRequire("7oLjV");
const $f7453a30141e0703$var$templatesApi = (0, $7oLjV.default).injectEndpoints({
    endpoints: (builder)=>({
            getDefaultTemplate: builder.query({
                query: ()=>`/display-templates/default`,
                transformResponse: (res, meta, arg)=>(0, (/*@__PURE__*/$parcel$interopDefault($7V8eP)))(res, "data", {})
            }),
            getDisplayTemplate: builder.query({
                providesTags: (result, error, args)=>[
                        {
                            type: "DisplayTemplates",
                            id: result?.id || "LIST"
                        },
                        {
                            type: "DisplayTemplates",
                            id: "LIST"
                        }
                    ],
                query: (id)=>`/display-templates/${id}`,
                transformResponse: (res, meta, arg)=>(0, (/*@__PURE__*/$parcel$interopDefault($7V8eP)))(res, "data", {})
            }),
            createDisplayTemplate: builder.mutation({
                invalidatesTags: [
                    {
                        type: "DisplayTemplates",
                        id: "LIST"
                    }
                ],
                query: (data)=>({
                        url: "/display-templates",
                        method: "POST",
                        body: {
                            data: data
                        }
                    })
            }),
            updateDisplayTemplate: builder.mutation({
                // Invalidates all queries that subscribe to Appointment ids only.
                invalidatesTags: (result, error, { id: id })=>[
                        {
                            type: "DisplayTemplates",
                            id: id
                        }
                    ],
                query ({ id: id, ...data }) {
                    return {
                        url: `/display-templates/${id}`,
                        method: "PUT",
                        body: {
                            data: data
                        }
                    };
                }
            })
        })
});
const { useCreateDisplayTemplateMutation: $f7453a30141e0703$export$406c586ff2c11e00, useUpdateDisplayTemplateMutation: $f7453a30141e0703$export$a035ccccccf165f5, useGetDefaultTemplateQuery: $f7453a30141e0703$export$aacfb8ec11d5d908, useGetDisplayTemplateQuery: $f7453a30141e0703$export$55cc9494946a1420 } = $f7453a30141e0703$var$templatesApi;
var $f7453a30141e0703$export$2e2bcd8739ae039 = $f7453a30141e0703$var$templatesApi;

});

parcelRegister("1S59q", function(module, exports) {

$parcel$export(module.exports, "generateUIContentBlock", () => $8c358e41426eedc7$export$ffd1a0344d6ced05);
$parcel$export(module.exports, "generateUISectionBlock", () => $8c358e41426eedc7$export$db9431b4b37bfd69);
$parcel$export(module.exports, "UI_DEFAULT_DISPLAY_TEMPLATE", () => $8c358e41426eedc7$export$2ffb63005b1a3230);

var $jgLFK = parcelRequire("jgLFK");
const $8c358e41426eedc7$export$ffd1a0344d6ced05 = (props)=>({
        blockUID: (0, $jgLFK.uniqueId)("block_"),
        config: {
            style: {
                flexGrow: 1
            }
        },
        source: "none",
        ...props
    });
const $8c358e41426eedc7$export$db9431b4b37bfd69 = (props)=>{
    const blanksection = {
        blockUID: (0, $jgLFK.uniqueId)("section_"),
        name: "New Section",
        properties: {
            source: "none",
            config: {
                style: {
                    flexGrow: 1
                }
            }
        },
        blocks: props?.blocks || [
            $8c358e41426eedc7$export$ffd1a0344d6ced05()
        ]
    };
    return (0, $jgLFK.merge)(blanksection, props);
};
const $8c358e41426eedc7$export$2ffb63005b1a3230 = {
    name: "New Scratch Template",
    sections: [
        $8c358e41426eedc7$export$db9431b4b37bfd69({
            properties: {
                config: {
                    style: {
                        height: "10%"
                    }
                }
            },
            blocks: [
                $8c358e41426eedc7$export$ffd1a0344d6ced05({
                    config: {
                        style: {
                            width: "25%"
                        }
                    }
                }),
                $8c358e41426eedc7$export$ffd1a0344d6ced05()
            ]
        }),
        $8c358e41426eedc7$export$db9431b4b37bfd69({
            blocks: [
                $8c358e41426eedc7$export$ffd1a0344d6ced05(),
                $8c358e41426eedc7$export$ffd1a0344d6ced05()
            ],
            properties: {
                config: {
                    style: {
                        height: "75%"
                    }
                }
            }
        }),
        $8c358e41426eedc7$export$db9431b4b37bfd69({
            properties: {
                config: {
                    style: {
                        height: "15%"
                    }
                }
            }
        })
    ]
};

});




parcelRegister("8lIUy", function(module, exports) {

$parcel$export(module.exports, "Box", () => $a756d429bb83bf6c$export$e71c4d32a2263218);

var $1kFN0 = parcelRequire("1kFN0");
var $1CyaF = parcelRequire("1CyaF");

var $4mwsf = parcelRequire("4mwsf");
"use client";
var $a756d429bb83bf6c$export$e71c4d32a2263218 = (0, $1kFN0.chakra)("div");
$a756d429bb83bf6c$export$e71c4d32a2263218.displayName = "Box";
var $a756d429bb83bf6c$export$b09fb900337259de = (0, $1CyaF.forwardRef)(function Square2(props, ref) {
    const { size: size, centerContent: centerContent = true, ...rest } = props;
    const styles = centerContent ? {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    } : {};
    return /* @__PURE__ */ (0, $4mwsf.jsx)($a756d429bb83bf6c$export$e71c4d32a2263218, {
        ref: ref,
        boxSize: size,
        __css: {
            ...styles,
            flexShrink: 0,
            flexGrow: 0
        },
        ...rest
    });
});
$a756d429bb83bf6c$export$b09fb900337259de.displayName = "Square";
var $a756d429bb83bf6c$export$c89a927ffc67e6fa = (0, $1CyaF.forwardRef)(function Circle2(props, ref) {
    const { size: size, ...rest } = props;
    return /* @__PURE__ */ (0, $4mwsf.jsx)($a756d429bb83bf6c$export$b09fb900337259de, {
        size: size,
        ref: ref,
        borderRadius: "9999px",
        ...rest
    });
});
$a756d429bb83bf6c$export$c89a927ffc67e6fa.displayName = "Circle";

});

parcelRegister("1BjEo", function(module, exports) {

var $icrQA = parcelRequire("icrQA");
module.exports = $icrQA("4ZgW4").then(()=>parcelRequire("e5FZa"));

});
parcelRegister("icrQA", function(module, exports) {
"use strict";

function $d3fef2ddfeba046b$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("cO2oI")).resolve(id));
}
module.exports = $d3fef2ddfeba046b$var$load;

});


parcelRegister("2Ts8H", function(module, exports) {

$parcel$export(module.exports, "HStack", () => $995ccabf6bc72ca3$export$15e411dc07b9c834);

var $ZY2xj = parcelRequire("ZY2xj");

var $1CyaF = parcelRequire("1CyaF");

var $4mwsf = parcelRequire("4mwsf");
"use client";
var $995ccabf6bc72ca3$export$15e411dc07b9c834 = (0, $1CyaF.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $4mwsf.jsx)((0, $ZY2xj.Stack), {
        align: "center",
        ...props,
        direction: "row",
        ref: ref
    }));
$995ccabf6bc72ca3$export$15e411dc07b9c834.displayName = "HStack";

});
parcelRegister("ZY2xj", function(module, exports) {

$parcel$export(module.exports, "Stack", () => $29a3e4dcab8e57e1$export$694e0d28c7ffc90c);

var $9SOw6 = parcelRequire("9SOw6");

var $jwF2f = parcelRequire("jwF2f");

var $j4HkN = parcelRequire("j4HkN");

var $iyhjB = parcelRequire("iyhjB");

var $1kFN0 = parcelRequire("1kFN0");
var $1CyaF = parcelRequire("1CyaF");

var $3qjKr = parcelRequire("3qjKr");

var $4mwsf = parcelRequire("4mwsf");
"use client";
var $29a3e4dcab8e57e1$export$694e0d28c7ffc90c = (0, $1CyaF.forwardRef)((props, ref)=>{
    const { isInline: isInline, direction: directionProp, align: align, justify: justify, spacing: spacing = "0.5rem", wrap: wrap, children: children, divider: divider, className: className, shouldWrapChildren: shouldWrapChildren, ...rest } = props;
    const direction = isInline ? "row" : directionProp != null ? directionProp : "column";
    const dividerStyle = (0, $3qjKr.useMemo)(()=>(0, $jwF2f.getDividerStyles)({
            spacing: spacing,
            direction: direction
        }), [
        spacing,
        direction
    ]);
    const hasDivider = !!divider;
    const shouldUseChildren = !shouldWrapChildren && !hasDivider;
    const clones = (0, $3qjKr.useMemo)(()=>{
        const validChildren = (0, $j4HkN.getValidChildren)(children);
        return shouldUseChildren ? validChildren : validChildren.map((child, index)=>{
            const key = typeof child.key !== "undefined" ? child.key : index;
            const isLast = index + 1 === validChildren.length;
            const wrappedChild = /* @__PURE__ */ (0, $4mwsf.jsx)((0, $9SOw6.StackItem), {
                children: child
            }, key);
            const _child = shouldWrapChildren ? wrappedChild : child;
            if (!hasDivider) return _child;
            const clonedDivider = (0, $3qjKr.cloneElement)(divider, {
                __css: dividerStyle
            });
            const _divider = isLast ? null : clonedDivider;
            return /* @__PURE__ */ (0, $4mwsf.jsxs)((0, $3qjKr.Fragment), {
                children: [
                    _child,
                    _divider
                ]
            }, key);
        });
    }, [
        divider,
        dividerStyle,
        hasDivider,
        shouldUseChildren,
        shouldWrapChildren,
        children
    ]);
    const _className = (0, $iyhjB.cx)("chakra-stack", className);
    return /* @__PURE__ */ (0, $4mwsf.jsx)((0, $1kFN0.chakra).div, {
        ref: ref,
        display: "flex",
        alignItems: align,
        justifyContent: justify,
        flexDirection: direction,
        flexWrap: wrap,
        gap: hasDivider ? void 0 : spacing,
        className: _className,
        ...rest,
        children: clones
    });
});
$29a3e4dcab8e57e1$export$694e0d28c7ffc90c.displayName = "Stack";

});
parcelRegister("9SOw6", function(module, exports) {

$parcel$export(module.exports, "StackItem", () => $e262f5533a2c2075$export$50d5391cd1a018c6);

var $1kFN0 = parcelRequire("1kFN0");

var $4mwsf = parcelRequire("4mwsf");
"use client";
var $e262f5533a2c2075$export$50d5391cd1a018c6 = (props)=>/* @__PURE__ */ (0, $4mwsf.jsx)((0, $1kFN0.chakra).div, {
        className: "chakra-stack__item",
        ...props,
        __css: {
            display: "inline-block",
            flex: "0 0 auto",
            minWidth: 0,
            ...props["__css"]
        }
    });
$e262f5533a2c2075$export$50d5391cd1a018c6.displayName = "StackItem";

});

parcelRegister("jwF2f", function(module, exports) {

$parcel$export(module.exports, "getDividerStyles", () => $ef4f32793bd75957$export$d4a6a5cc582519a5);

var $bHWUW = parcelRequire("bHWUW");
"use client";
function $ef4f32793bd75957$export$d4a6a5cc582519a5(options) {
    const { spacing: spacing, direction: direction } = options;
    const dividerStyles = {
        column: {
            my: spacing,
            mx: 0,
            borderLeftWidth: 0,
            borderBottomWidth: "1px"
        },
        "column-reverse": {
            my: spacing,
            mx: 0,
            borderLeftWidth: 0,
            borderBottomWidth: "1px"
        },
        row: {
            mx: spacing,
            my: 0,
            borderLeftWidth: "1px",
            borderBottomWidth: 0
        },
        "row-reverse": {
            mx: spacing,
            my: 0,
            borderLeftWidth: "1px",
            borderBottomWidth: 0
        }
    };
    return {
        "&": (0, $bHWUW.mapResponsive)(direction, (value)=>dividerStyles[value])
    };
}

});
parcelRegister("bHWUW", function(module, exports) {

$parcel$export(module.exports, "breakpoints", () => $7aa646f7cd760ad7$export$d07517a676ce386f);
$parcel$export(module.exports, "mapResponsive", () => $7aa646f7cd760ad7$export$eca1915781c2aaca);
$parcel$export(module.exports, "arrayToObjectNotation", () => $7aa646f7cd760ad7$export$60476530468641e7);
// src/responsive.ts

var $iyhjB = parcelRequire("iyhjB");
var $7aa646f7cd760ad7$export$d07517a676ce386f = Object.freeze([
    "base",
    "sm",
    "md",
    "lg",
    "xl",
    "2xl"
]);
function $7aa646f7cd760ad7$export$eca1915781c2aaca(prop, mapper) {
    if (Array.isArray(prop)) return prop.map((item)=>item === null ? null : mapper(item));
    if ((0, $iyhjB.isObject)(prop)) return Object.keys(prop).reduce((result, key)=>{
        result[key] = mapper(prop[key]);
        return result;
    }, {});
    if (prop != null) return mapper(prop);
    return null;
}
function $7aa646f7cd760ad7$export$d9dcf045f3ec145e(obj, bps = $7aa646f7cd760ad7$export$d07517a676ce386f) {
    const result = bps.map((br)=>{
        var _a;
        return (_a = obj[br]) != null ? _a : null;
    });
    const lastItem = result[result.length - 1];
    while(lastItem === null)result.pop();
    return result;
}
function $7aa646f7cd760ad7$export$60476530468641e7(values, bps = $7aa646f7cd760ad7$export$d07517a676ce386f) {
    const result = {};
    values.forEach((value, index)=>{
        const key = bps[index];
        if (value == null) return;
        result[key] = value;
    });
    return result;
}
function $7aa646f7cd760ad7$export$2f4b3062f5f33794(obj, bps = $7aa646f7cd760ad7$export$d07517a676ce386f) {
    const keys = Object.keys(obj);
    return keys.length > 0 && keys.every((key)=>bps.includes(key));
}
var $7aa646f7cd760ad7$export$4cdfc817e07de39e = (v)=>Number.isNaN(Number(v));

});


parcelRegister("j4HkN", function(module, exports) {

$parcel$export(module.exports, "getValidChildren", () => $9f17ffb64ae2aed4$export$b2c43d7d050b2e63);
// src/index.ts

var $3qjKr = parcelRequire("3qjKr");
function $9f17ffb64ae2aed4$export$b2c43d7d050b2e63(children) {
    return (0, $3qjKr.Children).toArray(children).filter((child)=>(0, $3qjKr.isValidElement)(child));
}

});



parcelRegister("j9JrO", function(module, exports) {

$parcel$export(module.exports, "Text", () => $5cabb3cca9a9b4d9$export$5f1af8db9871e1d6);

var $1kFN0 = parcelRequire("1kFN0");
var $1CyaF = parcelRequire("1CyaF");
var $cDoMf = parcelRequire("cDoMf");
var $9a7LB = parcelRequire("9a7LB");

var $iyhjB = parcelRequire("iyhjB");

var $hQPCH = parcelRequire("hQPCH");

var $4mwsf = parcelRequire("4mwsf");
"use client";
var $5cabb3cca9a9b4d9$export$5f1af8db9871e1d6 = (0, $1CyaF.forwardRef)(function Text2(props, ref) {
    const styles = (0, $9a7LB.useStyleConfig)("Text", props);
    const { className: className, align: align, decoration: decoration, casing: casing, ...rest } = (0, $cDoMf.omitThemingProps)(props);
    const aliasedProps = (0, $hQPCH.compact)({
        textAlign: props.align,
        textDecoration: props.decoration,
        textTransform: props.casing
    });
    return /* @__PURE__ */ (0, $4mwsf.jsx)((0, $1kFN0.chakra).p, {
        ref: ref,
        className: (0, $iyhjB.cx)("chakra-text", props.className),
        ...aliasedProps,
        ...rest,
        __css: styles
    });
});
$5cabb3cca9a9b4d9$export$5f1af8db9871e1d6.displayName = "Text";

});
parcelRegister("hQPCH", function(module, exports) {

$parcel$export(module.exports, "compact", () => $b8f18b3a0807782f$export$8e16b83750b44988);
// src/compact.ts
function $b8f18b3a0807782f$export$8e16b83750b44988(object) {
    const clone = Object.assign({}, object);
    for(let key in clone)if (clone[key] === void 0) delete clone[key];
    return clone;
}

});


parcelRegister("4Nb8r", function(module, exports) {

$parcel$export(module.exports, "VStack", () => $4faef64ea54acf89$export$e6c02a6dccfa2120);

var $ZY2xj = parcelRequire("ZY2xj");

var $1CyaF = parcelRequire("1CyaF");

var $4mwsf = parcelRequire("4mwsf");
"use client";
var $4faef64ea54acf89$export$e6c02a6dccfa2120 = (0, $1CyaF.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $4mwsf.jsx)((0, $ZY2xj.Stack), {
        align: "center",
        ...props,
        direction: "column",
        ref: ref
    }));
$4faef64ea54acf89$export$e6c02a6dccfa2120.displayName = "VStack";

});

/**
 * Copyright 2023 ALPHAGUARD CONSULTING, LLC.  All rights reserved.
 * Use of this source code is governed by a Commercial License Agreement
 * license can be found in the LICENSE file or contact legal@alphaguard.io
 */ 
var $4mwsf = parcelRequire("4mwsf");

var $3qjKr = parcelRequire("3qjKr");
var $51947a66e5305600$export$882461b6382ed46c;
var $51947a66e5305600$export$757ceba2d55c277e;
"use strict";

var $8Z31m = parcelRequire("8Z31m");
var $51947a66e5305600$var$i;
$51947a66e5305600$export$882461b6382ed46c = $8Z31m.createRoot;
$51947a66e5305600$export$757ceba2d55c277e = $8Z31m.hydrateRoot;



var $8ka9R = parcelRequire("8ka9R");

var $4mwsf = parcelRequire("4mwsf");
"use client";
var $a2776d1d153d0c85$var$css = String.raw;
var $a2776d1d153d0c85$var$vhPolyfill = $a2776d1d153d0c85$var$css`
  :root,
  :host {
    --chakra-vh: 100vh;
  }

  @supports (height: -webkit-fill-available) {
    :root,
    :host {
      --chakra-vh: -webkit-fill-available;
    }
  }

  @supports (height: -moz-fill-available) {
    :root,
    :host {
      --chakra-vh: -moz-fill-available;
    }
  }

  @supports (height: 100dvh) {
    :root,
    :host {
      --chakra-vh: 100dvh;
    }
  }
`;
var $a2776d1d153d0c85$export$43a6590e493ec44a = ()=>/* @__PURE__ */ (0, $4mwsf.jsx)((0, $8ka9R.Global), {
        styles: $a2776d1d153d0c85$var$vhPolyfill
    });
var $a2776d1d153d0c85$export$b751feffed387621 = ({ scope: scope = "" })=>/* @__PURE__ */ (0, $4mwsf.jsx)((0, $8ka9R.Global), {
        styles: $a2776d1d153d0c85$var$css`
      html {
        line-height: 1.5;
        -webkit-text-size-adjust: 100%;
        font-family: system-ui, sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        touch-action: manipulation;
      }

      body {
        position: relative;
        min-height: 100%;
        margin: 0;
        font-feature-settings: "kern";
      }

      ${scope} :where(*, *::before, *::after) {
        border-width: 0;
        border-style: solid;
        box-sizing: border-box;
        word-wrap: break-word;
      }

      main {
        display: block;
      }

      ${scope} hr {
        border-top-width: 1px;
        box-sizing: content-box;
        height: 0;
        overflow: visible;
      }

      ${scope} :where(pre, code, kbd,samp) {
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        font-size: 1em;
      }

      ${scope} a {
        background-color: transparent;
        color: inherit;
        text-decoration: inherit;
      }

      ${scope} abbr[title] {
        border-bottom: none;
        text-decoration: underline;
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
      }

      ${scope} :where(b, strong) {
        font-weight: bold;
      }

      ${scope} small {
        font-size: 80%;
      }

      ${scope} :where(sub,sup) {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
      }

      ${scope} sub {
        bottom: -0.25em;
      }

      ${scope} sup {
        top: -0.5em;
      }

      ${scope} img {
        border-style: none;
      }

      ${scope} :where(button, input, optgroup, select, textarea) {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0;
      }

      ${scope} :where(button, input) {
        overflow: visible;
      }

      ${scope} :where(button, select) {
        text-transform: none;
      }

      ${scope} :where(
          button::-moz-focus-inner,
          [type="button"]::-moz-focus-inner,
          [type="reset"]::-moz-focus-inner,
          [type="submit"]::-moz-focus-inner
        ) {
        border-style: none;
        padding: 0;
      }

      ${scope} fieldset {
        padding: 0.35em 0.75em 0.625em;
      }

      ${scope} legend {
        box-sizing: border-box;
        color: inherit;
        display: table;
        max-width: 100%;
        padding: 0;
        white-space: normal;
      }

      ${scope} progress {
        vertical-align: baseline;
      }

      ${scope} textarea {
        overflow: auto;
      }

      ${scope} :where([type="checkbox"], [type="radio"]) {
        box-sizing: border-box;
        padding: 0;
      }

      ${scope} input[type="number"]::-webkit-inner-spin-button,
      ${scope} input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
      }

      ${scope} input[type="number"] {
        -moz-appearance: textfield;
      }

      ${scope} input[type="search"] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
      }

      ${scope} input[type="search"]::-webkit-search-decoration {
        -webkit-appearance: none !important;
      }

      ${scope} ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit;
      }

      ${scope} details {
        display: block;
      }

      ${scope} summary {
        display: list-item;
      }

      template {
        display: none;
      }

      [hidden] {
        display: none !important;
      }

      ${scope} :where(
          blockquote,
          dl,
          dd,
          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          hr,
          figure,
          p,
          pre
        ) {
        margin: 0;
      }

      ${scope} button {
        background: transparent;
        padding: 0;
      }

      ${scope} fieldset {
        margin: 0;
        padding: 0;
      }

      ${scope} :where(ol, ul) {
        margin: 0;
        padding: 0;
      }

      ${scope} textarea {
        resize: vertical;
      }

      ${scope} :where(button, [role="button"]) {
        cursor: pointer;
      }

      ${scope} button::-moz-focus-inner {
        border: 0 !important;
      }

      ${scope} table {
        border-collapse: collapse;
      }

      ${scope} :where(h1, h2, h3, h4, h5, h6) {
        font-size: inherit;
        font-weight: inherit;
      }

      ${scope} :where(button, input, optgroup, select, textarea) {
        padding: 0;
        line-height: inherit;
        color: inherit;
      }

      ${scope} :where(img, svg, video, canvas, audio, iframe, embed, object) {
        display: block;
      }

      ${scope} :where(img, video) {
        max-width: 100%;
        height: auto;
      }

      [data-js-focus-visible]
        :focus:not([data-focus-visible-added]):not(
          [data-focus-visible-disabled]
        ) {
        outline: none;
        box-shadow: none;
      }

      ${scope} select::-ms-expand {
        display: none;
      }

      ${$a2776d1d153d0c85$var$vhPolyfill}
    `
    });
var $a2776d1d153d0c85$export$428e8dbfc1580f11 = $a2776d1d153d0c85$export$b751feffed387621;



var $3qjKr = parcelRequire("3qjKr");
"use client";
function $2b5826b2c930f0e8$var$getErrorMessage(hook, provider) {
    return `${hook} returned \`undefined\`. Seems you forgot to wrap component within ${provider}`;
}
function $2b5826b2c930f0e8$export$fd42f52fd3ae1109(options = {}) {
    const { name: name, strict: strict = true, hookName: hookName = "useContext", providerName: providerName = "Provider", errorMessage: errorMessage, defaultValue: defaultValue } = options;
    const Context = (0, $3qjKr.createContext)(defaultValue);
    Context.displayName = name;
    function useContext() {
        var _a;
        const context = (0, $3qjKr.useContext)(Context);
        if (!context && strict) {
            const error = new Error(errorMessage != null ? errorMessage : $2b5826b2c930f0e8$var$getErrorMessage(hookName, providerName));
            error.name = "ContextError";
            (_a = Error.captureStackTrace) == null || _a.call(Error, error, useContext);
            throw error;
        }
        return context;
    }
    return [
        Context.Provider,
        useContext,
        Context
    ];
}



var $4mwsf = parcelRequire("4mwsf");
"use client";
var [$ba2ad71ae194b416$var$PortalManagerContextProvider, $ba2ad71ae194b416$export$ef203b29c2cc1f5d] = (0, $2b5826b2c930f0e8$export$fd42f52fd3ae1109)({
    strict: false,
    name: "PortalManagerContext"
});
function $ba2ad71ae194b416$export$52c7ef79917c2f38(props) {
    const { children: children, zIndex: zIndex } = props;
    return /* @__PURE__ */ (0, $4mwsf.jsx)($ba2ad71ae194b416$var$PortalManagerContextProvider, {
        value: {
            zIndex: zIndex
        },
        children: children
    });
}
$ba2ad71ae194b416$export$52c7ef79917c2f38.displayName = "PortalManager";



var $ioRKz = parcelRequire("ioRKz");
"use client";
// src/color-mode.utils.ts
var $a2ad295c2d34707f$var$classNames = {
    light: "chakra-ui-light",
    dark: "chakra-ui-dark"
};
function $a2ad295c2d34707f$export$4bb933d353baa01c(options = {}) {
    const { preventTransition: preventTransition = true } = options;
    const utils = {
        setDataset: (value)=>{
            const cleanup = preventTransition ? utils.preventTransition() : void 0;
            document.documentElement.dataset.theme = value;
            document.documentElement.style.colorScheme = value;
            cleanup == null || cleanup();
        },
        setClassName (dark) {
            document.body.classList.add(dark ? $a2ad295c2d34707f$var$classNames.dark : $a2ad295c2d34707f$var$classNames.light);
            document.body.classList.remove(dark ? $a2ad295c2d34707f$var$classNames.light : $a2ad295c2d34707f$var$classNames.dark);
        },
        query () {
            return window.matchMedia("(prefers-color-scheme: dark)");
        },
        getSystemTheme (fallback) {
            var _a;
            const dark = (_a = utils.query().matches) != null ? _a : fallback === "dark";
            return dark ? "dark" : "light";
        },
        addListener (fn) {
            const mql = utils.query();
            const listener = (e)=>{
                fn(e.matches ? "dark" : "light");
            };
            if (typeof mql.addListener === "function") mql.addListener(listener);
            else mql.addEventListener("change", listener);
            return ()=>{
                if (typeof mql.removeListener === "function") mql.removeListener(listener);
                else mql.removeEventListener("change", listener);
            };
        },
        preventTransition () {
            const css = document.createElement("style");
            css.appendChild(document.createTextNode(`*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}`));
            document.head.appendChild(css);
            return ()=>{
                (()=>window.getComputedStyle(document.body))();
                requestAnimationFrame(()=>{
                    requestAnimationFrame(()=>{
                        document.head.removeChild(css);
                    });
                });
            };
        }
    };
    return utils;
}


"use client";
// src/storage-manager.ts
var $19d0cb1a0397ce03$export$86880b4b2e1a2384 = "chakra-ui-color-mode";
function $19d0cb1a0397ce03$export$cdf53b88b62eb393(key) {
    return {
        ssr: false,
        type: "localStorage",
        get (init) {
            if (!(globalThis == null ? void 0 : globalThis.document)) return init;
            let value;
            try {
                value = localStorage.getItem(key) || init;
            } catch (e) {}
            return value || init;
        },
        set (value) {
            try {
                localStorage.setItem(key, value);
            } catch (e) {}
        }
    };
}
var $19d0cb1a0397ce03$export$8e35886de8a54f45 = $19d0cb1a0397ce03$export$cdf53b88b62eb393($19d0cb1a0397ce03$export$86880b4b2e1a2384);
function $19d0cb1a0397ce03$var$parseCookie(cookie, key) {
    const match = cookie.match(new RegExp(`(^| )${key}=([^;]+)`));
    return match == null ? void 0 : match[2];
}
function $19d0cb1a0397ce03$export$df28b7d6efe2673c(key, cookie) {
    return {
        ssr: !!cookie,
        type: "cookie",
        get (init) {
            if (cookie) return $19d0cb1a0397ce03$var$parseCookie(cookie, key);
            if (!(globalThis == null ? void 0 : globalThis.document)) return init;
            return $19d0cb1a0397ce03$var$parseCookie(document.cookie, key) || init;
        },
        set (value) {
            document.cookie = `${key}=${value}; max-age=31536000; path=/`;
        }
    };
}
var $19d0cb1a0397ce03$export$2e2b0158437077e3 = $19d0cb1a0397ce03$export$df28b7d6efe2673c($19d0cb1a0397ce03$export$86880b4b2e1a2384);
var $19d0cb1a0397ce03$export$d76e8eed3e914fa0 = (cookie)=>$19d0cb1a0397ce03$export$df28b7d6efe2673c($19d0cb1a0397ce03$export$86880b4b2e1a2384, cookie);



var $jGf8z = parcelRequire("jGf8z");

var $3qjKr = parcelRequire("3qjKr");

var $4mwsf = parcelRequire("4mwsf");
"use client";
var $473a93c8942b262d$var$noop = ()=>{};
function $473a93c8942b262d$var$getTheme(manager, fallback) {
    return manager.type === "cookie" && manager.ssr ? manager.get(fallback) : fallback;
}
function $473a93c8942b262d$export$7a858aa3ff83dde7(props) {
    const { value: value, children: children, options: { useSystemColorMode: useSystemColorMode, initialColorMode: initialColorMode, disableTransitionOnChange: disableTransitionOnChange } = {}, colorModeManager: colorModeManager = (0, $19d0cb1a0397ce03$export$8e35886de8a54f45) } = props;
    const defaultColorMode = initialColorMode === "dark" ? "dark" : "light";
    const [colorMode, rawSetColorMode] = (0, $3qjKr.useState)(()=>$473a93c8942b262d$var$getTheme(colorModeManager, defaultColorMode));
    const [resolvedColorMode, setResolvedColorMode] = (0, $3qjKr.useState)(()=>$473a93c8942b262d$var$getTheme(colorModeManager));
    const { getSystemTheme: getSystemTheme, setClassName: setClassName, setDataset: setDataset, addListener: addListener } = (0, $3qjKr.useMemo)(()=>(0, $a2ad295c2d34707f$export$4bb933d353baa01c)({
            preventTransition: disableTransitionOnChange
        }), [
        disableTransitionOnChange
    ]);
    const resolvedValue = initialColorMode === "system" && !colorMode ? resolvedColorMode : colorMode;
    const setColorMode = (0, $3qjKr.useCallback)((value2)=>{
        const resolved = value2 === "system" ? getSystemTheme() : value2;
        rawSetColorMode(resolved);
        setClassName(resolved === "dark");
        setDataset(resolved);
        colorModeManager.set(resolved);
    }, [
        colorModeManager,
        getSystemTheme,
        setClassName,
        setDataset
    ]);
    (0, $jGf8z.useSafeLayoutEffect)(()=>{
        if (initialColorMode === "system") setResolvedColorMode(getSystemTheme());
    }, []);
    (0, $3qjKr.useEffect)(()=>{
        const managerValue = colorModeManager.get();
        if (managerValue) {
            setColorMode(managerValue);
            return;
        }
        if (initialColorMode === "system") {
            setColorMode("system");
            return;
        }
        setColorMode(defaultColorMode);
    }, [
        colorModeManager,
        defaultColorMode,
        initialColorMode,
        setColorMode
    ]);
    const toggleColorMode = (0, $3qjKr.useCallback)(()=>{
        setColorMode(resolvedValue === "dark" ? "light" : "dark");
    }, [
        resolvedValue,
        setColorMode
    ]);
    (0, $3qjKr.useEffect)(()=>{
        if (!useSystemColorMode) return;
        return addListener(setColorMode);
    }, [
        useSystemColorMode,
        addListener,
        setColorMode
    ]);
    const context = (0, $3qjKr.useMemo)(()=>({
            colorMode: value != null ? value : resolvedValue,
            toggleColorMode: value ? $473a93c8942b262d$var$noop : toggleColorMode,
            setColorMode: value ? $473a93c8942b262d$var$noop : setColorMode,
            forced: value !== void 0
        }), [
        resolvedValue,
        toggleColorMode,
        setColorMode,
        value
    ]);
    return /* @__PURE__ */ (0, $4mwsf.jsx)((0, $ioRKz.ColorModeContext).Provider, {
        value: context,
        children: children
    });
}
$473a93c8942b262d$export$7a858aa3ff83dde7.displayName = "ColorModeProvider";
function $473a93c8942b262d$export$8b41b18ed1f3731e(props) {
    const context = (0, $3qjKr.useMemo)(()=>({
            colorMode: "dark",
            toggleColorMode: $473a93c8942b262d$var$noop,
            setColorMode: $473a93c8942b262d$var$noop,
            forced: true
        }), []);
    return /* @__PURE__ */ (0, $4mwsf.jsx)((0, $ioRKz.ColorModeContext).Provider, {
        value: context,
        ...props
    });
}
$473a93c8942b262d$export$8b41b18ed1f3731e.displayName = "DarkMode";
function $473a93c8942b262d$export$cee2b1aa9166b2a3(props) {
    const context = (0, $3qjKr.useMemo)(()=>({
            colorMode: "light",
            toggleColorMode: $473a93c8942b262d$var$noop,
            setColorMode: $473a93c8942b262d$var$noop,
            forced: true
        }), []);
    return /* @__PURE__ */ (0, $4mwsf.jsx)((0, $ioRKz.ColorModeContext).Provider, {
        value: context,
        ...props
    });
}
$473a93c8942b262d$export$cee2b1aa9166b2a3.displayName = "LightMode";


var $ioRKz = parcelRequire("ioRKz");
// src/context.ts

var $3qjKr = parcelRequire("3qjKr");
function $16615edad71d929e$export$fd42f52fd3ae1109(options = {}) {
    const { strict: strict = true, errorMessage: errorMessage = "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider", name: name } = options;
    const Context = (0, $3qjKr.createContext)(void 0);
    Context.displayName = name;
    function useContext() {
        var _a;
        const context = (0, $3qjKr.useContext)(Context);
        if (!context && strict) {
            const error = new Error(errorMessage);
            error.name = "ContextError";
            (_a = Error.captureStackTrace) == null || _a.call(Error, error, useContext);
            throw error;
        }
        return context;
    }
    return [
        Context.Provider,
        useContext,
        Context
    ];
}



var $cDoMf = parcelRequire("cDoMf");

var $6SrEO = parcelRequire("6SrEO");
var $747z2 = parcelRequire("747z2");

var $8ka9R = parcelRequire("8ka9R");
var $36iMe = parcelRequire("36iMe");

var $3qjKr = parcelRequire("3qjKr");

var $4mwsf = parcelRequire("4mwsf");
"use client";
function $01e600dc3d5c8b4a$export$d8964aec282183a3(props) {
    const { cssVarsRoot: cssVarsRoot, theme: theme, children: children } = props;
    const computedTheme = (0, $3qjKr.useMemo)(()=>(0, $cDoMf.toCSSVar)(theme), [
        theme
    ]);
    return /* @__PURE__ */ (0, $4mwsf.jsxs)((0, $36iMe.a), {
        theme: computedTheme,
        children: [
            /* @__PURE__ */ (0, $4mwsf.jsx)($01e600dc3d5c8b4a$export$d767872124667db6, {
                root: cssVarsRoot
            }),
            children
        ]
    });
}
function $01e600dc3d5c8b4a$export$d767872124667db6({ root: root = ":host, :root" }) {
    const selector = [
        root,
        `[data-theme]`
    ].join(",");
    return /* @__PURE__ */ (0, $4mwsf.jsx)((0, $8ka9R.Global), {
        styles: (theme)=>({
                [selector]: theme.__cssVars
            })
    });
}
var [$01e600dc3d5c8b4a$export$dc4c659861f00dbe, $01e600dc3d5c8b4a$export$28e6b9b82ee883c] = (0, $16615edad71d929e$export$fd42f52fd3ae1109)({
    name: "StylesContext",
    errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
});
function $01e600dc3d5c8b4a$export$11d9f9905bcdc114(componentName) {
    return (0, $16615edad71d929e$export$fd42f52fd3ae1109)({
        name: `${componentName}StylesContext`,
        errorMessage: `useStyles: "styles" is undefined. Seems you forgot to wrap the components in "<${componentName} />" `
    });
}
function $01e600dc3d5c8b4a$export$f05794e648629f6c() {
    const { colorMode: colorMode } = (0, $ioRKz.useColorMode)();
    return /* @__PURE__ */ (0, $4mwsf.jsx)((0, $8ka9R.Global), {
        styles: (theme)=>{
            const styleObjectOrFn = (0, $6SrEO.memoizedGet)(theme, "styles.global");
            const globalStyles = (0, $747z2.runIfFn)(styleObjectOrFn, {
                theme: theme,
                colorMode: colorMode
            });
            if (!globalStyles) return void 0;
            const styles = (0, $cDoMf.css)(globalStyles)(theme);
            return styles;
        }
    });
}



var $ddByY = parcelRequire("ddByY");

var $4mwsf = parcelRequire("4mwsf");
"use client";
var $0d183e5f0e0944a5$export$80dbe0482bcbd25a = (props)=>{
    const { children: children, colorModeManager: colorModeManager, portalZIndex: portalZIndex, resetScope: resetScope, resetCSS: resetCSS = true, theme: theme = {}, environment: environment, cssVarsRoot: cssVarsRoot, disableEnvironment: disableEnvironment, disableGlobalStyle: disableGlobalStyle } = props;
    const _children = /* @__PURE__ */ (0, $4mwsf.jsx)((0, $ddByY.EnvironmentProvider), {
        environment: environment,
        disabled: disableEnvironment,
        children: children
    });
    return /* @__PURE__ */ (0, $4mwsf.jsx)((0, $01e600dc3d5c8b4a$export$d8964aec282183a3), {
        theme: theme,
        cssVarsRoot: cssVarsRoot,
        children: /* @__PURE__ */ (0, $4mwsf.jsxs)((0, $473a93c8942b262d$export$7a858aa3ff83dde7), {
            colorModeManager: colorModeManager,
            options: theme.config,
            children: [
                resetCSS ? /* @__PURE__ */ (0, $4mwsf.jsx)((0, $a2776d1d153d0c85$export$b751feffed387621), {
                    scope: resetScope
                }) : /* @__PURE__ */ (0, $4mwsf.jsx)((0, $a2776d1d153d0c85$export$43a6590e493ec44a), {}),
                !disableGlobalStyle && /* @__PURE__ */ (0, $4mwsf.jsx)((0, $01e600dc3d5c8b4a$export$f05794e648629f6c), {}),
                portalZIndex ? /* @__PURE__ */ (0, $4mwsf.jsx)((0, $ba2ad71ae194b416$export$52c7ef79917c2f38), {
                    zIndex: portalZIndex,
                    children: _children
                }) : _children
            ]
        })
    });
};



var $lenGy = parcelRequire("lenGy");
"use client";
// src/toast.utils.ts
var $d396037ddf0d1c2c$export$6486ede9e74d7d9d = (arr, id)=>arr.find((toast)=>toast.id === id);
function $d396037ddf0d1c2c$export$67080b9d5f0a62ea(toasts, id) {
    const position = $d396037ddf0d1c2c$export$500f52ac46324ec6(toasts, id);
    const index = position ? toasts[position].findIndex((toast)=>toast.id === id) : -1;
    return {
        position: position,
        index: index
    };
}
function $d396037ddf0d1c2c$export$500f52ac46324ec6(toasts, id) {
    for (const [position, values] of Object.entries(toasts)){
        if ($d396037ddf0d1c2c$export$6486ede9e74d7d9d(values, id)) return position;
    }
}
var $d396037ddf0d1c2c$export$795910f5f15a9633 = (toasts, id)=>!!$d396037ddf0d1c2c$export$500f52ac46324ec6(toasts, id);
function $d396037ddf0d1c2c$export$27777812cc6d52de(position) {
    const isRighty = position.includes("right");
    const isLefty = position.includes("left");
    let alignItems = "center";
    if (isRighty) alignItems = "flex-end";
    if (isLefty) alignItems = "flex-start";
    return {
        display: "flex",
        flexDirection: "column",
        alignItems: alignItems
    };
}
function $d396037ddf0d1c2c$export$55dd410e8ef136e0(position) {
    const isTopOrBottom = position === "top" || position === "bottom";
    const margin = isTopOrBottom ? "0 auto" : void 0;
    const top = position.includes("top") ? "env(safe-area-inset-top, 0px)" : void 0;
    const bottom = position.includes("bottom") ? "env(safe-area-inset-bottom, 0px)" : void 0;
    const right = !position.includes("left") ? "env(safe-area-inset-right, 0px)" : void 0;
    const left = !position.includes("right") ? "env(safe-area-inset-left, 0px)" : void 0;
    return {
        position: "fixed",
        zIndex: "var(--toast-z-index, 5500)",
        pointerEvents: "none",
        display: "flex",
        flexDirection: "column",
        margin: margin,
        top: top,
        bottom: bottom,
        right: right,
        left: left
    };
}



var $3qjKr = parcelRequire("3qjKr");

var $3qjKr = parcelRequire("3qjKr");
"use client";
function $fa16d07d3ab83f7e$export$25bec8c6f54ee79a(callback, deps = []) {
    const callbackRef = (0, $3qjKr.useRef)(callback);
    (0, $3qjKr.useEffect)(()=>{
        callbackRef.current = callback;
    });
    return (0, $3qjKr.useCallback)((...args)=>{
        var _a;
        return (_a = callbackRef.current) == null ? void 0 : _a.call(callbackRef, ...args);
    }, deps);
}


"use client";
function $673f4608062dc420$export$d8e6abf214c9ec0f(callback, delay) {
    const fn = (0, $fa16d07d3ab83f7e$export$25bec8c6f54ee79a)(callback);
    (0, $3qjKr.useEffect)(()=>{
        if (delay == null) return void 0;
        let timeoutId = null;
        timeoutId = window.setTimeout(()=>{
            fn();
        }, delay);
        return ()=>{
            if (timeoutId) window.clearTimeout(timeoutId);
        };
    }, [
        delay,
        fn
    ]);
}



var $3qjKr = parcelRequire("3qjKr");
"use client";
function $7796b7c0819e6dcf$export$496315a1608d9602(callback, deps) {
    const renderCycleRef = (0, $3qjKr.useRef)(false);
    const effectCycleRef = (0, $3qjKr.useRef)(false);
    (0, $3qjKr.useEffect)(()=>{
        const mounted = renderCycleRef.current;
        const run = mounted && effectCycleRef.current;
        if (run) return callback();
        effectCycleRef.current = true;
    }, deps);
    (0, $3qjKr.useEffect)(()=>{
        renderCycleRef.current = true;
        return ()=>{
            renderCycleRef.current = false;
        };
    }, []);
}



var $iyhjB = parcelRequire("iyhjB");

var $dRSS2 = parcelRequire("dRSS2");
var $ecotb = parcelRequire("ecotb");

var $1kFN0 = parcelRequire("1kFN0");

var $3qjKr = parcelRequire("3qjKr");

var $4mwsf = parcelRequire("4mwsf");
"use client";
var $b11a91f061d781df$var$toastMotionVariants = {
    initial: (props)=>{
        const { position: position } = props;
        const dir = [
            "top",
            "bottom"
        ].includes(position) ? "y" : "x";
        let factor = [
            "top-right",
            "bottom-right"
        ].includes(position) ? 1 : -1;
        if (position === "bottom") factor = 1;
        return {
            opacity: 0,
            [dir]: factor * 24
        };
    },
    animate: {
        opacity: 1,
        y: 0,
        x: 0,
        scale: 1,
        transition: {
            duration: 0.4,
            ease: [
                0.4,
                0,
                0.2,
                1
            ]
        }
    },
    exit: {
        opacity: 0,
        scale: 0.85,
        transition: {
            duration: 0.2,
            ease: [
                0.4,
                0,
                1,
                1
            ]
        }
    }
};
var $b11a91f061d781df$export$8743ba3ef25f9582 = (0, $3qjKr.memo)((props)=>{
    const { id: id, message: message, onCloseComplete: onCloseComplete, onRequestRemove: onRequestRemove, requestClose: requestClose = false, position: position = "bottom", duration: duration = 5e3, containerStyle: containerStyle, motionVariants: motionVariants = $b11a91f061d781df$var$toastMotionVariants, toastSpacing: toastSpacing = "0.5rem" } = props;
    const [delay, setDelay] = (0, $3qjKr.useState)(duration);
    const isPresent = (0, $ecotb.useIsPresent)();
    (0, $7796b7c0819e6dcf$export$496315a1608d9602)(()=>{
        if (!isPresent) onCloseComplete == null || onCloseComplete();
    }, [
        isPresent
    ]);
    (0, $7796b7c0819e6dcf$export$496315a1608d9602)(()=>{
        setDelay(duration);
    }, [
        duration
    ]);
    const onMouseEnter = ()=>setDelay(null);
    const onMouseLeave = ()=>setDelay(duration);
    const close = ()=>{
        if (isPresent) onRequestRemove();
    };
    (0, $3qjKr.useEffect)(()=>{
        if (isPresent && requestClose) onRequestRemove();
    }, [
        isPresent,
        requestClose,
        onRequestRemove
    ]);
    (0, $673f4608062dc420$export$d8e6abf214c9ec0f)(close, delay);
    const containerStyles = (0, $3qjKr.useMemo)(()=>({
            pointerEvents: "auto",
            maxWidth: 560,
            minWidth: 300,
            margin: toastSpacing,
            ...containerStyle
        }), [
        containerStyle,
        toastSpacing
    ]);
    const toastStyle = (0, $3qjKr.useMemo)(()=>(0, $d396037ddf0d1c2c$export$27777812cc6d52de)(position), [
        position
    ]);
    return /* @__PURE__ */ (0, $4mwsf.jsx)((0, $dRSS2.motion).div, {
        layout: true,
        className: "chakra-toast",
        variants: motionVariants,
        initial: "initial",
        animate: "animate",
        exit: "exit",
        onHoverStart: onMouseEnter,
        onHoverEnd: onMouseLeave,
        custom: {
            position: position
        },
        style: toastStyle,
        children: /* @__PURE__ */ (0, $4mwsf.jsx)((0, $1kFN0.chakra).div, {
            role: "status",
            "aria-atomic": "true",
            className: "chakra-toast__inner",
            __css: containerStyles,
            children: (0, $iyhjB.runIfFn)(message, {
                id: id,
                onClose: close
            })
        })
    });
});
$b11a91f061d781df$export$8743ba3ef25f9582.displayName = "ToastComponent";



"use client";
// src/toast.placement.ts
function $9a05c00c7c97628f$export$5b03f73d5fd4425(position, dir) {
    var _a;
    const computedPosition = position != null ? position : "bottom";
    const logicals = {
        "top-start": {
            ltr: "top-left",
            rtl: "top-right"
        },
        "top-end": {
            ltr: "top-right",
            rtl: "top-left"
        },
        "bottom-start": {
            ltr: "bottom-left",
            rtl: "bottom-right"
        },
        "bottom-end": {
            ltr: "bottom-right",
            rtl: "bottom-left"
        }
    };
    const logical = logicals[computedPosition];
    return (_a = logical == null ? void 0 : logical[dir]) != null ? _a : computedPosition;
}



var $1kFN0 = parcelRequire("1kFN0");
var $1CyaF = parcelRequire("1CyaF");
var $9a7LB = parcelRequire("9a7LB");

var $iyhjB = parcelRequire("iyhjB");

var $4mwsf = parcelRequire("4mwsf");
"use client";
var $b4f3eec673f28dae$var$fallbackIcon = {
    path: /* @__PURE__ */ (0, $4mwsf.jsxs)("g", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        children: [
            /* @__PURE__ */ (0, $4mwsf.jsx)("path", {
                strokeLinecap: "round",
                fill: "none",
                d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
            }),
            /* @__PURE__ */ (0, $4mwsf.jsx)("path", {
                fill: "currentColor",
                strokeLinecap: "round",
                d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
            }),
            /* @__PURE__ */ (0, $4mwsf.jsx)("circle", {
                fill: "none",
                strokeMiterlimit: "10",
                cx: "12",
                cy: "12",
                r: "11.25"
            })
        ]
    }),
    viewBox: "0 0 24 24"
};
var $b4f3eec673f28dae$export$f04a61298a47a40f = (0, $1CyaF.forwardRef)((props, ref)=>{
    const { as: element, viewBox: viewBox, color: color = "currentColor", focusable: focusable = false, children: children, className: className, __css: __css, ...rest } = props;
    const _className = (0, $iyhjB.cx)("chakra-icon", className);
    const customStyles = (0, $9a7LB.useStyleConfig)("Icon", props);
    const styles = {
        w: "1em",
        h: "1em",
        display: "inline-block",
        lineHeight: "1em",
        flexShrink: 0,
        color: color,
        ...__css,
        ...customStyles
    };
    const shared = {
        ref: ref,
        focusable: focusable,
        className: _className,
        __css: styles
    };
    const _viewBox = viewBox != null ? viewBox : $b4f3eec673f28dae$var$fallbackIcon.viewBox;
    if (element && typeof element !== "string") return /* @__PURE__ */ (0, $4mwsf.jsx)((0, $1kFN0.chakra).svg, {
        as: element,
        ...shared,
        ...rest
    });
    const _path = children != null ? children : $b4f3eec673f28dae$var$fallbackIcon.path;
    return /* @__PURE__ */ (0, $4mwsf.jsx)((0, $1kFN0.chakra).svg, {
        verticalAlign: "middle",
        viewBox: _viewBox,
        ...shared,
        ...rest,
        children: _path
    });
});
$b4f3eec673f28dae$export$f04a61298a47a40f.displayName = "Icon";
var $b4f3eec673f28dae$export$21036209a317fcec = $b4f3eec673f28dae$export$f04a61298a47a40f;



var $4mwsf = parcelRequire("4mwsf");
"use client";
function $57bc338917c8a4fb$export$7dd004358974b05d(props) {
    return /* @__PURE__ */ (0, $4mwsf.jsx)((0, $b4f3eec673f28dae$export$f04a61298a47a40f), {
        viewBox: "0 0 24 24",
        ...props,
        children: /* @__PURE__ */ (0, $4mwsf.jsx)("path", {
            fill: "currentColor",
            d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
        })
    });
}
function $57bc338917c8a4fb$export$2957fc44b3d2481(props) {
    return /* @__PURE__ */ (0, $4mwsf.jsx)((0, $b4f3eec673f28dae$export$f04a61298a47a40f), {
        viewBox: "0 0 24 24",
        ...props,
        children: /* @__PURE__ */ (0, $4mwsf.jsx)("path", {
            fill: "currentColor",
            d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
        })
    });
}
function $57bc338917c8a4fb$export$f7dc499a72baa103(props) {
    return /* @__PURE__ */ (0, $4mwsf.jsx)((0, $b4f3eec673f28dae$export$f04a61298a47a40f), {
        viewBox: "0 0 24 24",
        ...props,
        children: /* @__PURE__ */ (0, $4mwsf.jsx)("path", {
            fill: "currentColor",
            d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
        })
    });
}




var $dufMO = parcelRequire("dufMO");
"use client";
var [$a005141a60d2abc7$export$a7901f7b4cce70b0, $a005141a60d2abc7$export$50b520f08832063d] = (0, $2b5826b2c930f0e8$export$fd42f52fd3ae1109)({
    name: "AlertContext",
    hookName: "useAlertContext",
    providerName: "<Alert />"
});
var [$a005141a60d2abc7$export$17cf5063e294f385, $a005141a60d2abc7$export$167ececdbea67592] = (0, $2b5826b2c930f0e8$export$fd42f52fd3ae1109)({
    name: `AlertStylesContext`,
    hookName: `useAlertStyles`,
    providerName: "<Alert />"
});
var $a005141a60d2abc7$var$STATUSES = {
    info: {
        icon: (0, $57bc338917c8a4fb$export$2957fc44b3d2481),
        colorScheme: "blue"
    },
    warning: {
        icon: (0, $57bc338917c8a4fb$export$f7dc499a72baa103),
        colorScheme: "orange"
    },
    success: {
        icon: (0, $57bc338917c8a4fb$export$7dd004358974b05d),
        colorScheme: "green"
    },
    error: {
        icon: (0, $57bc338917c8a4fb$export$f7dc499a72baa103),
        colorScheme: "red"
    },
    loading: {
        icon: (0, $dufMO.Spinner),
        colorScheme: "blue"
    }
};
function $a005141a60d2abc7$export$8df8f66d0469c54d(status) {
    return $a005141a60d2abc7$var$STATUSES[status].colorScheme;
}
function $a005141a60d2abc7$export$c742923ea4ac4c1c(status) {
    return $a005141a60d2abc7$var$STATUSES[status].icon;
}



var $iyhjB = parcelRequire("iyhjB");

var $1kFN0 = parcelRequire("1kFN0");
var $1CyaF = parcelRequire("1CyaF");
var $cDoMf = parcelRequire("cDoMf");
var $9a7LB = parcelRequire("9a7LB");

var $4mwsf = parcelRequire("4mwsf");
"use client";
var $2e62656f3fb11ca7$export$caec2af78bcc877f = (0, $1CyaF.forwardRef)(function Alert2(props, ref) {
    var _a;
    const { status: status = "info", addRole: addRole = true, ...rest } = (0, $cDoMf.omitThemingProps)(props);
    const colorScheme = (_a = props.colorScheme) != null ? _a : (0, $a005141a60d2abc7$export$8df8f66d0469c54d)(status);
    const styles = (0, $9a7LB.useMultiStyleConfig)("Alert", {
        ...props,
        colorScheme: colorScheme
    });
    const alertStyles = {
        width: "100%",
        display: "flex",
        alignItems: "center",
        position: "relative",
        overflow: "hidden",
        ...styles.container
    };
    return /* @__PURE__ */ (0, $4mwsf.jsx)((0, $a005141a60d2abc7$export$a7901f7b4cce70b0), {
        value: {
            status: status
        },
        children: /* @__PURE__ */ (0, $4mwsf.jsx)((0, $a005141a60d2abc7$export$17cf5063e294f385), {
            value: styles,
            children: /* @__PURE__ */ (0, $4mwsf.jsx)((0, $1kFN0.chakra).div, {
                "data-status": status,
                role: addRole ? "alert" : void 0,
                ref: ref,
                ...rest,
                className: (0, $iyhjB.cx)("chakra-alert", props.className),
                __css: alertStyles
            })
        })
    });
});
$2e62656f3fb11ca7$export$caec2af78bcc877f.displayName = "Alert";



var $iyhjB = parcelRequire("iyhjB");

var $1kFN0 = parcelRequire("1kFN0");
var $1CyaF = parcelRequire("1CyaF");

var $4mwsf = parcelRequire("4mwsf");
"use client";
var $db0fce56293b7d4f$export$d4feae172fccda11 = (0, $1CyaF.forwardRef)(function AlertDescription2(props, ref) {
    const styles = (0, $a005141a60d2abc7$export$167ececdbea67592)();
    const { status: status } = (0, $a005141a60d2abc7$export$50b520f08832063d)();
    const descriptionStyles = {
        display: "inline",
        ...styles.description
    };
    return /* @__PURE__ */ (0, $4mwsf.jsx)((0, $1kFN0.chakra).div, {
        ref: ref,
        "data-status": status,
        ...props,
        className: (0, $iyhjB.cx)("chakra-alert__desc", props.className),
        __css: descriptionStyles
    });
});
$db0fce56293b7d4f$export$d4feae172fccda11.displayName = "AlertDescription";



var $iyhjB = parcelRequire("iyhjB");

var $1kFN0 = parcelRequire("1kFN0");

var $4mwsf = parcelRequire("4mwsf");
"use client";
function $e282b5d042d57c81$export$4a143c8822a09fb4(props) {
    const { status: status } = (0, $a005141a60d2abc7$export$50b520f08832063d)();
    const BaseIcon = (0, $a005141a60d2abc7$export$c742923ea4ac4c1c)(status);
    const styles = (0, $a005141a60d2abc7$export$167ececdbea67592)();
    const css = status === "loading" ? styles.spinner : styles.icon;
    return /* @__PURE__ */ (0, $4mwsf.jsx)((0, $1kFN0.chakra).span, {
        display: "inherit",
        "data-status": status,
        ...props,
        className: (0, $iyhjB.cx)("chakra-alert__icon", props.className),
        __css: css,
        children: props.children || /* @__PURE__ */ (0, $4mwsf.jsx)(BaseIcon, {
            h: "100%",
            w: "100%"
        })
    });
}
$e282b5d042d57c81$export$4a143c8822a09fb4.displayName = "AlertIcon";



var $iyhjB = parcelRequire("iyhjB");

var $1kFN0 = parcelRequire("1kFN0");
var $1CyaF = parcelRequire("1CyaF");

var $4mwsf = parcelRequire("4mwsf");
"use client";
var $d87d2f8da4f7aa99$export$4a7253439a300753 = (0, $1CyaF.forwardRef)(function AlertTitle2(props, ref) {
    const styles = (0, $a005141a60d2abc7$export$167ececdbea67592)();
    const { status: status } = (0, $a005141a60d2abc7$export$50b520f08832063d)();
    return /* @__PURE__ */ (0, $4mwsf.jsx)((0, $1kFN0.chakra).div, {
        ref: ref,
        "data-status": status,
        ...props,
        className: (0, $iyhjB.cx)("chakra-alert__title", props.className),
        __css: styles.title
    });
});
$d87d2f8da4f7aa99$export$4a7253439a300753.displayName = "AlertTitle";



var $1kFN0 = parcelRequire("1kFN0");


var $1kFN0 = parcelRequire("1kFN0");
var $1CyaF = parcelRequire("1CyaF");
var $cDoMf = parcelRequire("cDoMf");
var $9a7LB = parcelRequire("9a7LB");

var $4mwsf = parcelRequire("4mwsf");
"use client";
function $b7ec50bb425ce88f$var$CloseIcon(props) {
    return /* @__PURE__ */ (0, $4mwsf.jsx)((0, $b4f3eec673f28dae$export$f04a61298a47a40f), {
        focusable: "false",
        "aria-hidden": true,
        ...props,
        children: /* @__PURE__ */ (0, $4mwsf.jsx)("path", {
            fill: "currentColor",
            d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
        })
    });
}
var $b7ec50bb425ce88f$export$de65de8213222d10 = (0, $1CyaF.forwardRef)(function CloseButton2(props, ref) {
    const styles = (0, $9a7LB.useStyleConfig)("CloseButton", props);
    const { children: children, isDisabled: isDisabled, __css: __css, ...rest } = (0, $cDoMf.omitThemingProps)(props);
    const baseStyle = {
        outline: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0
    };
    return /* @__PURE__ */ (0, $4mwsf.jsx)((0, $1kFN0.chakra).button, {
        type: "button",
        "aria-label": "Close",
        ref: ref,
        disabled: isDisabled,
        __css: {
            ...baseStyle,
            ...styles,
            ...__css
        },
        ...rest,
        children: children || /* @__PURE__ */ (0, $4mwsf.jsx)($b7ec50bb425ce88f$var$CloseIcon, {
            width: "1em",
            height: "1em"
        })
    });
});
$b7ec50bb425ce88f$export$de65de8213222d10.displayName = "CloseButton";



var $iyhjB = parcelRequire("iyhjB");

var $4mwsf = parcelRequire("4mwsf");
"use client";
// src/toast.store.ts
var $4ff444d563dbf040$var$initialState = {
    top: [],
    "top-left": [],
    "top-right": [],
    "bottom-left": [],
    bottom: [],
    "bottom-right": []
};
var $4ff444d563dbf040$export$e80fa18a42ed98ef = $4ff444d563dbf040$var$createStore($4ff444d563dbf040$var$initialState);
function $4ff444d563dbf040$var$createStore(initialState2) {
    let state = initialState2;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (setStateFn)=>{
        state = setStateFn(state);
        listeners.forEach((l)=>l());
    };
    return {
        getState: ()=>state,
        subscribe: (listener)=>{
            listeners.add(listener);
            return ()=>{
                setState(()=>initialState2);
                listeners.delete(listener);
            };
        },
        /**
     * Delete a toast record at its position
     */ removeToast: (id, position)=>{
            setState((prevState)=>({
                    ...prevState,
                    // id may be string or number
                    // eslint-disable-next-line eqeqeq
                    [position]: prevState[position].filter((toast)=>toast.id != id)
                }));
        },
        notify: (message, options)=>{
            const toast = $4ff444d563dbf040$var$createToast(message, options);
            const { position: position, id: id } = toast;
            setState((prevToasts)=>{
                var _a, _b;
                const isTop = position.includes("top");
                const toasts = isTop ? [
                    toast,
                    ...(_a = prevToasts[position]) != null ? _a : []
                ] : [
                    ...(_b = prevToasts[position]) != null ? _b : [],
                    toast
                ];
                return {
                    ...prevToasts,
                    [position]: toasts
                };
            });
            return id;
        },
        update: (id, options)=>{
            if (!id) return;
            setState((prevState)=>{
                const nextState = {
                    ...prevState
                };
                const { position: position, index: index } = (0, $d396037ddf0d1c2c$export$67080b9d5f0a62ea)(nextState, id);
                if (position && index !== -1) nextState[position][index] = {
                    ...nextState[position][index],
                    ...options,
                    message: $4ff444d563dbf040$export$d9d796c483697359(options)
                };
                return nextState;
            });
        },
        closeAll: ({ positions: positions } = {})=>{
            setState((prev)=>{
                const allPositions = [
                    "bottom",
                    "bottom-right",
                    "bottom-left",
                    "top",
                    "top-left",
                    "top-right"
                ];
                const positionsToClose = positions != null ? positions : allPositions;
                return positionsToClose.reduce((acc, position)=>{
                    acc[position] = prev[position].map((toast)=>({
                            ...toast,
                            requestClose: true
                        }));
                    return acc;
                }, {
                    ...prev
                });
            });
        },
        close: (id)=>{
            setState((prevState)=>{
                const position = (0, $d396037ddf0d1c2c$export$500f52ac46324ec6)(prevState, id);
                if (!position) return prevState;
                return {
                    ...prevState,
                    [position]: prevState[position].map((toast)=>{
                        if (toast.id == id) return {
                            ...toast,
                            requestClose: true
                        };
                        return toast;
                    })
                };
            });
        },
        isActive: (id)=>Boolean((0, $d396037ddf0d1c2c$export$67080b9d5f0a62ea)($4ff444d563dbf040$export$e80fa18a42ed98ef.getState(), id).position)
    };
}
var $4ff444d563dbf040$var$counter = 0;
function $4ff444d563dbf040$var$createToast(message, options = {}) {
    var _a, _b;
    $4ff444d563dbf040$var$counter += 1;
    const id = (_a = options.id) != null ? _a : $4ff444d563dbf040$var$counter;
    const position = (_b = options.position) != null ? _b : "bottom";
    return {
        id: id,
        message: message,
        position: position,
        duration: options.duration,
        onCloseComplete: options.onCloseComplete,
        onRequestRemove: ()=>$4ff444d563dbf040$export$e80fa18a42ed98ef.removeToast(String(id), position),
        status: options.status,
        requestClose: false,
        containerStyle: options.containerStyle
    };
}
var $4ff444d563dbf040$export$8d8dc7d5f743331b = (props)=>{
    const { status: status, variant: variant = "solid", id: id, title: title, isClosable: isClosable, onClose: onClose, description: description, colorScheme: colorScheme, icon: icon } = props;
    const ids = id ? {
        root: `toast-${id}`,
        title: `toast-${id}-title`,
        description: `toast-${id}-description`
    } : void 0;
    return /* @__PURE__ */ (0, $4mwsf.jsxs)((0, $2e62656f3fb11ca7$export$caec2af78bcc877f), {
        addRole: false,
        status: status,
        variant: variant,
        id: ids == null ? void 0 : ids.root,
        alignItems: "start",
        borderRadius: "md",
        boxShadow: "lg",
        paddingEnd: 8,
        textAlign: "start",
        width: "auto",
        colorScheme: colorScheme,
        children: [
            /* @__PURE__ */ (0, $4mwsf.jsx)((0, $e282b5d042d57c81$export$4a143c8822a09fb4), {
                children: icon
            }),
            /* @__PURE__ */ (0, $4mwsf.jsxs)((0, $1kFN0.chakra).div, {
                flex: "1",
                maxWidth: "100%",
                children: [
                    title && /* @__PURE__ */ (0, $4mwsf.jsx)((0, $d87d2f8da4f7aa99$export$4a7253439a300753), {
                        id: ids == null ? void 0 : ids.title,
                        children: title
                    }),
                    description && /* @__PURE__ */ (0, $4mwsf.jsx)((0, $db0fce56293b7d4f$export$d4feae172fccda11), {
                        id: ids == null ? void 0 : ids.description,
                        display: "block",
                        children: description
                    })
                ]
            }),
            isClosable && /* @__PURE__ */ (0, $4mwsf.jsx)((0, $b7ec50bb425ce88f$export$de65de8213222d10), {
                size: "sm",
                onClick: onClose,
                position: "absolute",
                insetEnd: 1,
                top: 1
            })
        ]
    });
};
function $4ff444d563dbf040$export$d9d796c483697359(options = {}) {
    const { render: render, toastComponent: ToastComponent = $4ff444d563dbf040$export$8d8dc7d5f743331b } = options;
    const renderToast = (props)=>{
        if (typeof render === "function") return render({
            ...props,
            ...options
        });
        return /* @__PURE__ */ (0, $4mwsf.jsx)(ToastComponent, {
            ...props,
            ...options
        });
    };
    return renderToast;
}
function $4ff444d563dbf040$export$f3af62d19eb14261(dir, defaultOptions) {
    const normalizeToastOptions = (options)=>{
        var _a;
        return {
            ...defaultOptions,
            ...options,
            position: (0, $9a05c00c7c97628f$export$5b03f73d5fd4425)((_a = options == null ? void 0 : options.position) != null ? _a : defaultOptions == null ? void 0 : defaultOptions.position, dir)
        };
    };
    const toast = (options)=>{
        const normalizedToastOptions = normalizeToastOptions(options);
        const Message = $4ff444d563dbf040$export$d9d796c483697359(normalizedToastOptions);
        return $4ff444d563dbf040$export$e80fa18a42ed98ef.notify(Message, normalizedToastOptions);
    };
    toast.update = (id, options)=>{
        $4ff444d563dbf040$export$e80fa18a42ed98ef.update(id, normalizeToastOptions(options));
    };
    toast.promise = (promise, options)=>{
        const id = toast({
            ...options.loading,
            status: "loading",
            duration: null
        });
        promise.then((data)=>toast.update(id, {
                status: "success",
                duration: 5e3,
                ...(0, $iyhjB.runIfFn)(options.success, data)
            })).catch((error)=>toast.update(id, {
                status: "error",
                duration: 5e3,
                ...(0, $iyhjB.runIfFn)(options.error, error)
            }));
    };
    toast.closeAll = $4ff444d563dbf040$export$e80fa18a42ed98ef.closeAll;
    toast.close = $4ff444d563dbf040$export$e80fa18a42ed98ef.close;
    toast.isActive = $4ff444d563dbf040$export$e80fa18a42ed98ef.isActive;
    return toast;
}




var $hglk4 = parcelRequire("hglk4");


var $jGf8z = parcelRequire("jGf8z");


var $8Z31m = parcelRequire("8Z31m");

var $3qjKr = parcelRequire("3qjKr");

var $4mwsf = parcelRequire("4mwsf");
"use client";
var [$78e5a858840afb3a$var$PortalContextProvider, $78e5a858840afb3a$var$usePortalContext] = (0, $2b5826b2c930f0e8$export$fd42f52fd3ae1109)({
    strict: false,
    name: "PortalContext"
});
var $78e5a858840afb3a$var$PORTAL_CLASSNAME = "chakra-portal";
var $78e5a858840afb3a$var$PORTAL_SELECTOR = `.chakra-portal`;
var $78e5a858840afb3a$var$Container = (props)=>/* @__PURE__ */ (0, $4mwsf.jsx)("div", {
        className: "chakra-portal-zIndex",
        style: {
            position: "absolute",
            zIndex: props.zIndex,
            top: 0,
            left: 0,
            right: 0
        },
        children: props.children
    });
var $78e5a858840afb3a$var$DefaultPortal = (props)=>{
    const { appendToParentPortal: appendToParentPortal, children: children } = props;
    const [tempNode, setTempNode] = (0, $3qjKr.useState)(null);
    const portal = (0, $3qjKr.useRef)(null);
    const [, forceUpdate] = (0, $3qjKr.useState)({});
    (0, $3qjKr.useEffect)(()=>forceUpdate({}), []);
    const parentPortal = $78e5a858840afb3a$var$usePortalContext();
    const manager = (0, $ba2ad71ae194b416$export$ef203b29c2cc1f5d)();
    (0, $jGf8z.useSafeLayoutEffect)(()=>{
        if (!tempNode) return;
        const doc = tempNode.ownerDocument;
        const host = appendToParentPortal ? parentPortal != null ? parentPortal : doc.body : doc.body;
        if (!host) return;
        portal.current = doc.createElement("div");
        portal.current.className = $78e5a858840afb3a$var$PORTAL_CLASSNAME;
        host.appendChild(portal.current);
        forceUpdate({});
        const portalNode = portal.current;
        return ()=>{
            if (host.contains(portalNode)) host.removeChild(portalNode);
        };
    }, [
        tempNode
    ]);
    const _children = (manager == null ? void 0 : manager.zIndex) ? /* @__PURE__ */ (0, $4mwsf.jsx)($78e5a858840afb3a$var$Container, {
        zIndex: manager == null ? void 0 : manager.zIndex,
        children: children
    }) : children;
    return portal.current ? (0, $8Z31m.createPortal)(/* @__PURE__ */ (0, $4mwsf.jsx)($78e5a858840afb3a$var$PortalContextProvider, {
        value: portal.current,
        children: _children
    }), portal.current) : /* @__PURE__ */ (0, $4mwsf.jsx)("span", {
        ref: (el)=>{
            if (el) setTempNode(el);
        }
    });
};
var $78e5a858840afb3a$var$ContainerPortal = (props)=>{
    const { children: children, containerRef: containerRef, appendToParentPortal: appendToParentPortal } = props;
    const containerEl = containerRef.current;
    const host = containerEl != null ? containerEl : typeof window !== "undefined" ? document.body : void 0;
    const portal = (0, $3qjKr.useMemo)(()=>{
        const node = containerEl == null ? void 0 : containerEl.ownerDocument.createElement("div");
        if (node) node.className = $78e5a858840afb3a$var$PORTAL_CLASSNAME;
        return node;
    }, [
        containerEl
    ]);
    const [, forceUpdate] = (0, $3qjKr.useState)({});
    (0, $jGf8z.useSafeLayoutEffect)(()=>forceUpdate({}), []);
    (0, $jGf8z.useSafeLayoutEffect)(()=>{
        if (!portal || !host) return;
        host.appendChild(portal);
        return ()=>{
            host.removeChild(portal);
        };
    }, [
        portal,
        host
    ]);
    if (host && portal) return (0, $8Z31m.createPortal)(/* @__PURE__ */ (0, $4mwsf.jsx)($78e5a858840afb3a$var$PortalContextProvider, {
        value: appendToParentPortal ? portal : null,
        children: children
    }), portal);
    return null;
};
function $78e5a858840afb3a$export$602eac185826482c(props) {
    const portalProps = {
        appendToParentPortal: true,
        ...props
    };
    const { containerRef: containerRef, ...rest } = portalProps;
    return containerRef ? /* @__PURE__ */ (0, $4mwsf.jsx)($78e5a858840afb3a$var$ContainerPortal, {
        containerRef: containerRef,
        ...rest
    }) : /* @__PURE__ */ (0, $4mwsf.jsx)($78e5a858840afb3a$var$DefaultPortal, {
        ...rest
    });
}
$78e5a858840afb3a$export$602eac185826482c.className = $78e5a858840afb3a$var$PORTAL_CLASSNAME;
$78e5a858840afb3a$export$602eac185826482c.selector = $78e5a858840afb3a$var$PORTAL_SELECTOR;
$78e5a858840afb3a$export$602eac185826482c.displayName = "Portal";



var $3qjKr = parcelRequire("3qjKr");


var $4mwsf = parcelRequire("4mwsf");
"use client";
var [$e0ccf97000b31adf$export$cfcc07abbe2e36a8, $e0ccf97000b31adf$export$7c4af276256dc908] = (0, $2b5826b2c930f0e8$export$fd42f52fd3ae1109)({
    name: `ToastOptionsContext`,
    strict: false
});
var $e0ccf97000b31adf$export$f5d03d415824e0e = (props)=>{
    const state = (0, $3qjKr.useSyncExternalStore)((0, $4ff444d563dbf040$export$e80fa18a42ed98ef).subscribe, (0, $4ff444d563dbf040$export$e80fa18a42ed98ef).getState, (0, $4ff444d563dbf040$export$e80fa18a42ed98ef).getState);
    const { motionVariants: motionVariants, component: Component = (0, $b11a91f061d781df$export$8743ba3ef25f9582), portalProps: portalProps } = props;
    const stateKeys = Object.keys(state);
    const toastList = stateKeys.map((position)=>{
        const toasts = state[position];
        return /* @__PURE__ */ (0, $4mwsf.jsx)("div", {
            role: "region",
            "aria-live": "polite",
            "aria-label": `Notifications-${position}`,
            id: `chakra-toast-manager-${position}`,
            style: (0, $d396037ddf0d1c2c$export$55dd410e8ef136e0)(position),
            children: /* @__PURE__ */ (0, $4mwsf.jsx)((0, $hglk4.AnimatePresence), {
                initial: false,
                children: toasts.map((toast)=>/* @__PURE__ */ (0, $4mwsf.jsx)(Component, {
                        motionVariants: motionVariants,
                        ...toast
                    }, toast.id))
            })
        }, position);
    });
    return /* @__PURE__ */ (0, $4mwsf.jsx)((0, $78e5a858840afb3a$export$602eac185826482c), {
        ...portalProps,
        children: toastList
    });
};



var $4mwsf = parcelRequire("4mwsf");
"use client";
var $e79f18655b554449$var$createChakraProvider = (providerTheme)=>{
    return function ChakraProvider2({ children: children, theme: theme = providerTheme, toastOptions: toastOptions, ...restProps }) {
        return /* @__PURE__ */ (0, $4mwsf.jsxs)((0, $0d183e5f0e0944a5$export$80dbe0482bcbd25a), {
            theme: theme,
            ...restProps,
            children: [
                /* @__PURE__ */ (0, $4mwsf.jsx)((0, $e0ccf97000b31adf$export$cfcc07abbe2e36a8), {
                    value: toastOptions == null ? void 0 : toastOptions.defaultOptions,
                    children: children
                }),
                /* @__PURE__ */ (0, $4mwsf.jsx)((0, $e0ccf97000b31adf$export$f5d03d415824e0e), {
                    ...toastOptions
                })
            ]
        });
    };
};
var $e79f18655b554449$export$80dbe0482bcbd25a = $e79f18655b554449$var$createChakraProvider((0, $lenGy.theme));
var $e79f18655b554449$export$39d642dd5c97e94c = $e79f18655b554449$var$createChakraProvider((0, $lenGy.baseTheme));


parcelRequire("bvqOc");
var $8eJ0A = parcelRequire("8eJ0A");
var $hjhWs = parcelRequire("hjhWs");
/**
 * React Router DOM v6.4.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $3qjKr = parcelRequire("3qjKr");

var $6MTDM = parcelRequire("6MTDM");/**
 * React Router v6.4.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $6MTDM = parcelRequire("6MTDM");

var $3qjKr = parcelRequire("3qjKr");
function $b6ec4a53b0d9b34f$var$_extends() {
    $b6ec4a53b0d9b34f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b6ec4a53b0d9b34f$var$_extends.apply(this, arguments);
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function $b6ec4a53b0d9b34f$var$isPolyfill(x, y) {
    return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
    ;
}
const $b6ec4a53b0d9b34f$var$is = typeof Object.is === "function" ? Object.is : $b6ec4a53b0d9b34f$var$isPolyfill; // Intentionally not using named imports because Rollup uses dynamic
// dispatch for CommonJS interop named imports.
const { useState: $b6ec4a53b0d9b34f$var$useState, useEffect: $b6ec4a53b0d9b34f$var$useEffect, useLayoutEffect: $b6ec4a53b0d9b34f$var$useLayoutEffect, useDebugValue: $b6ec4a53b0d9b34f$var$useDebugValue } = $3qjKr;
let $b6ec4a53b0d9b34f$var$didWarnOld18Alpha = false;
let $b6ec4a53b0d9b34f$var$didWarnUncachedGetSnapshot = false; // Disclaimer: This shim breaks many of the rules of React, and only works
// because of a very particular set of implementation details and assumptions
// -- change any one of them and it will break. The most important assumption
// is that updates are always synchronous, because concurrent rendering is
// only available in versions of React that also have a built-in
// useSyncExternalStore API. And we only use this shim when the built-in API
// does not exist.
//
// Do not assume that the clever hacks used by this hook also work in general.
// The point of this shim is to replace the need for hacks by other libraries.
function $b6ec4a53b0d9b34f$var$useSyncExternalStore$2(subscribe, getSnapshot, // React do not expose a way to check if we're hydrating. So users of the shim
// will need to track that themselves and return the correct value
// from `getSnapshot`.
getServerSnapshot) {
    // breaks the rules of React, and only works here because of specific
    // implementation details, most importantly that updates are
    // always synchronous.
    const value = getSnapshot();
    // re-render whenever the subscribed state changes by updating an some
    // arbitrary useState hook. Then, during render, we call getSnapshot to read
    // the current value.
    //
    // Because we don't actually use the state returned by the useState hook, we
    // can save a bit of memory by storing other stuff in that slot.
    //
    // To implement the early bailout, we need to track some things on a mutable
    // object. Usually, we would put that in a useRef hook, but we can stash it in
    // our useState hook instead.
    //
    // To force a re-render, we call forceUpdate({inst}). That works because the
    // new object always fails an equality check.
    const [{ inst: inst }, forceUpdate] = $b6ec4a53b0d9b34f$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }); // Track the latest getSnapshot function with a ref. This needs to be updated
    // in the layout phase so we can access it during the tearing check that
    // happens on subscribe.
    $b6ec4a53b0d9b34f$var$useLayoutEffect(()=>{
        inst.value = value;
        inst.getSnapshot = getSnapshot; // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if ($b6ec4a53b0d9b34f$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $b6ec4a53b0d9b34f$var$useEffect(()=>{
        // Check for changes right before subscribing. Subsequent changes will be
        // detected in the subscription handler.
        if ($b6ec4a53b0d9b34f$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
        const handleStoreChange = ()=>{
            // TODO: Because there is no cross-renderer API for batching updates, it's
            // up to the consumer of this library to wrap their subscription event
            // with unstable_batchedUpdates. Should we try to detect when this isn't
            // the case and print a warning in development?
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if ($b6ec4a53b0d9b34f$var$checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe
    ]);
    $b6ec4a53b0d9b34f$var$useDebugValue(value);
    return value;
}
function $b6ec4a53b0d9b34f$var$checkIfSnapshotChanged(inst) {
    const latestGetSnapshot = inst.getSnapshot;
    const prevValue = inst.value;
    try {
        const nextValue = latestGetSnapshot();
        return !$b6ec4a53b0d9b34f$var$is(prevValue, nextValue);
    } catch (error) {
        return true;
    }
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 */ function $b6ec4a53b0d9b34f$var$useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
    // Note: The shim does not use getServerSnapshot, because pre-18 versions of
    // React do not expose a way to check if we're hydrating. So users of the shim
    // will need to track that themselves and return the correct value
    // from `getSnapshot`.
    return getSnapshot();
}
/**
 * Inlined into the react-router repo since use-sync-external-store does not
 * provide a UMD-compatible package, so we need this to be able to distribute
 * UMD react-router bundles
 */ const $b6ec4a53b0d9b34f$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $b6ec4a53b0d9b34f$var$isServerEnvironment = !$b6ec4a53b0d9b34f$var$canUseDOM;
const $b6ec4a53b0d9b34f$var$shim = $b6ec4a53b0d9b34f$var$isServerEnvironment ? $b6ec4a53b0d9b34f$var$useSyncExternalStore$1 : $b6ec4a53b0d9b34f$var$useSyncExternalStore$2;
const $b6ec4a53b0d9b34f$var$useSyncExternalStore = "useSyncExternalStore" in $3qjKr ? ((module)=>module.useSyncExternalStore)($3qjKr) : $b6ec4a53b0d9b34f$var$shim;
// Contexts for data routers
const $b6ec4a53b0d9b34f$export$30522a91b9deeaa0 = /*#__PURE__*/ $3qjKr.createContext(null);
const $b6ec4a53b0d9b34f$export$3add0d5dce533e2e = /*#__PURE__*/ $3qjKr.createContext(null);
const $b6ec4a53b0d9b34f$export$145dfa71566a64dc = /*#__PURE__*/ $3qjKr.createContext(null);
const $b6ec4a53b0d9b34f$var$AwaitContext = /*#__PURE__*/ $3qjKr.createContext(null);
const $b6ec4a53b0d9b34f$export$26749e8557646306 = /*#__PURE__*/ $3qjKr.createContext(null);
const $b6ec4a53b0d9b34f$export$c7914228fb69b0f5 = /*#__PURE__*/ $3qjKr.createContext(null);
const $b6ec4a53b0d9b34f$export$9072aa6dd1f93057 = /*#__PURE__*/ $3qjKr.createContext({
    outlet: null,
    matches: []
});
const $b6ec4a53b0d9b34f$var$RouteErrorContext = /*#__PURE__*/ $3qjKr.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-href
 */ function $b6ec4a53b0d9b34f$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$b6ec4a53b0d9b34f$export$9c954a9d03d32f4a() && (0, $6MTDM.invariant)(false);
    let { basename: basename, navigator: navigator } = $3qjKr.useContext($b6ec4a53b0d9b34f$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $b6ec4a53b0d9b34f$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname; // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $6MTDM.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-in-router-context
 */ function $b6ec4a53b0d9b34f$export$9c954a9d03d32f4a() {
    return $3qjKr.useContext($b6ec4a53b0d9b34f$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-location
 */ function $b6ec4a53b0d9b34f$export$45d76561a5302f2b() {
    !$b6ec4a53b0d9b34f$export$9c954a9d03d32f4a() && (0, $6MTDM.invariant)(false);
    return $3qjKr.useContext($b6ec4a53b0d9b34f$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-navigation-type
 */ function $b6ec4a53b0d9b34f$export$1b3f31771c5d07c() {
    return $3qjKr.useContext($b6ec4a53b0d9b34f$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns true if the URL for the given "to" value matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-match
 */ function $b6ec4a53b0d9b34f$export$6c330e8992e8a295(pattern) {
    !$b6ec4a53b0d9b34f$export$9c954a9d03d32f4a() && (0, $6MTDM.invariant)(false);
    let { pathname: pathname } = $b6ec4a53b0d9b34f$export$45d76561a5302f2b();
    return $3qjKr.useMemo(()=>(0, $6MTDM.matchPath)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ /**
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $b6ec4a53b0d9b34f$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || !match.route.index && match.pathnameBase !== matches[index - 1].pathnameBase);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-navigate
 */ function $b6ec4a53b0d9b34f$export$9770f232ac06a008() {
    !$b6ec4a53b0d9b34f$export$9c954a9d03d32f4a() && (0, $6MTDM.invariant)(false);
    let { basename: basename, navigator: navigator } = $3qjKr.useContext($b6ec4a53b0d9b34f$export$26749e8557646306);
    let { matches: matches } = $3qjKr.useContext($b6ec4a53b0d9b34f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $b6ec4a53b0d9b34f$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($b6ec4a53b0d9b34f$var$getPathContributingMatches(matches).map((match)=>match.pathnameBase));
    let activeRef = $3qjKr.useRef(false);
    $3qjKr.useEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $3qjKr.useCallback(function(to, options) {
        if (options === void 0) options = {};
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $6MTDM.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path"); // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history.  If this is a root navigation, then we
        // navigate to the raw basename which allows the basename to have full
        // control over the presence of a trailing slash on root links
        if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $6MTDM.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname
    ]);
    return navigate;
}
const $b6ec4a53b0d9b34f$var$OutletContext = /*#__PURE__*/ $3qjKr.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/docs/en/v6/hooks/use-outlet-context
 */ function $b6ec4a53b0d9b34f$export$4138103a3ae699cc() {
    return $3qjKr.useContext($b6ec4a53b0d9b34f$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-outlet
 */ function $b6ec4a53b0d9b34f$export$a3be3530d8e40d0b(context) {
    let outlet = $3qjKr.useContext($b6ec4a53b0d9b34f$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $3qjKr.createElement($b6ec4a53b0d9b34f$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-params
 */ function $b6ec4a53b0d9b34f$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $3qjKr.useContext($b6ec4a53b0d9b34f$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-resolved-path
 */ function $b6ec4a53b0d9b34f$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $3qjKr.useContext($b6ec4a53b0d9b34f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $b6ec4a53b0d9b34f$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($b6ec4a53b0d9b34f$var$getPathContributingMatches(matches).map((match)=>match.pathnameBase));
    return $3qjKr.useMemo(()=>(0, $6MTDM.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-routes
 */ function $b6ec4a53b0d9b34f$export$5d3fca4a98652595(routes, locationArg) {
    !$b6ec4a53b0d9b34f$export$9c954a9d03d32f4a() && (0, $6MTDM.invariant)(false);
    let dataRouterStateContext = $3qjKr.useContext($b6ec4a53b0d9b34f$export$145dfa71566a64dc);
    let { matches: parentMatches } = $3qjKr.useContext($b6ec4a53b0d9b34f$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $b6ec4a53b0d9b34f$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $6MTDM.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $6MTDM.invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $6MTDM.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $b6ec4a53b0d9b34f$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $6MTDM.joinPaths)([
                parentPathnameBase,
                match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $6MTDM.joinPaths)([
                parentPathnameBase,
                match.pathnameBase
            ])
        })), parentMatches, dataRouterStateContext || undefined); // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg) return /*#__PURE__*/ $3qjKr.createElement($b6ec4a53b0d9b34f$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $b6ec4a53b0d9b34f$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $6MTDM.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $b6ec4a53b0d9b34f$var$DefaultErrorElement() {
    let error = $b6ec4a53b0d9b34f$export$ed527bf60f6e05f2();
    let message = (0, $6MTDM.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    return /*#__PURE__*/ $3qjKr.createElement($3qjKr.Fragment, null, /*#__PURE__*/ $3qjKr.createElement("h2", null, "Unhandled Thrown Error!"), /*#__PURE__*/ $3qjKr.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $3qjKr.createElement("pre", {
        style: preStyles
    }, stack) : null, /*#__PURE__*/ $3qjKr.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /*#__PURE__*/ $3qjKr.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own\xa0", /*#__PURE__*/ $3qjKr.createElement("code", {
        style: codeStyles
    }, "errorElement"), " props on\xa0", /*#__PURE__*/ $3qjKr.createElement("code", {
        style: codeStyles
    }, "<Route>")));
}
class $b6ec4a53b0d9b34f$var$RenderErrorBoundary extends $3qjKr.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location) return {
            error: props.error,
            location: props.location
        };
         // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $3qjKr.createElement($b6ec4a53b0d9b34f$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        }) : this.props.children;
    }
}
function $b6ec4a53b0d9b34f$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataStaticRouterContext = $3qjKr.useContext($b6ec4a53b0d9b34f$export$30522a91b9deeaa0); // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataStaticRouterContext && match.route.errorElement) dataStaticRouterContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $3qjKr.createElement($b6ec4a53b0d9b34f$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $b6ec4a53b0d9b34f$var$_renderMatches(matches, parentMatches, dataRouterState) {
    if (parentMatches === void 0) parentMatches = [];
    if (matches == null) {
        if (dataRouterState != null && dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches; // If we have data errors, trim matches to the highest error boundary
    let errors = dataRouterState == null ? void 0 : dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $6MTDM.invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null; // Only data routers handle errors
        let errorElement = dataRouterState ? match.route.errorElement || /*#__PURE__*/ $3qjKr.createElement($b6ec4a53b0d9b34f$var$DefaultErrorElement, null) : null;
        let getChildren = ()=>/*#__PURE__*/ $3qjKr.createElement($b6ec4a53b0d9b34f$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: parentMatches.concat(renderedMatches.slice(0, index + 1))
                }
            }, error ? errorElement : match.route.element !== undefined ? match.route.element : outlet); // Only wrap in an error boundary within data router usages when we have an
        // errorElement on this route.  Otherwise let it bubble up to an ancestor
        // errorElement
        return dataRouterState && (match.route.errorElement || index === 0) ? /*#__PURE__*/ $3qjKr.createElement($b6ec4a53b0d9b34f$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            component: errorElement,
            error: error,
            children: getChildren()
        }) : getChildren();
    }, null);
}
var $b6ec4a53b0d9b34f$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseLoaderData"] = "useLoaderData";
    DataRouterHook["UseActionData"] = "useActionData";
    DataRouterHook["UseRouteError"] = "useRouteError";
    DataRouterHook["UseNavigation"] = "useNavigation";
    DataRouterHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterHook["UseMatches"] = "useMatches";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
})($b6ec4a53b0d9b34f$var$DataRouterHook || ($b6ec4a53b0d9b34f$var$DataRouterHook = {}));
function $b6ec4a53b0d9b34f$var$useDataRouterState(hookName) {
    let state = $3qjKr.useContext($b6ec4a53b0d9b34f$export$145dfa71566a64dc);
    !state && (0, $6MTDM.invariant)(false);
    return state;
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $b6ec4a53b0d9b34f$export$d0fd4b7106de2769() {
    let state = $b6ec4a53b0d9b34f$var$useDataRouterState($b6ec4a53b0d9b34f$var$DataRouterHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $b6ec4a53b0d9b34f$export$600dc272ed516c15() {
    let dataRouterContext = $3qjKr.useContext($b6ec4a53b0d9b34f$export$3add0d5dce533e2e);
    !dataRouterContext && (0, $6MTDM.invariant)(false);
    let state = $b6ec4a53b0d9b34f$var$useDataRouterState($b6ec4a53b0d9b34f$var$DataRouterHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $b6ec4a53b0d9b34f$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $b6ec4a53b0d9b34f$var$useDataRouterState($b6ec4a53b0d9b34f$var$DataRouterHook.UseMatches);
    return $3qjKr.useMemo(()=>matches.map((match)=>{
            let { pathname: pathname, params: params } = match; // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $b6ec4a53b0d9b34f$export$1448a5050d252c4d() {
    let state = $b6ec4a53b0d9b34f$var$useDataRouterState($b6ec4a53b0d9b34f$var$DataRouterHook.UseLoaderData);
    let route = $3qjKr.useContext($b6ec4a53b0d9b34f$export$9072aa6dd1f93057);
    !route && (0, $6MTDM.invariant)(false);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $6MTDM.invariant)(false);
    return state.loaderData[thisRoute.route.id];
}
/**
 * Returns the loaderData for the given routeId
 */ function $b6ec4a53b0d9b34f$export$fd5d37484eab868d(routeId) {
    let state = $b6ec4a53b0d9b34f$var$useDataRouterState($b6ec4a53b0d9b34f$var$DataRouterHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $b6ec4a53b0d9b34f$export$fdc00f3f26066d5e() {
    let state = $b6ec4a53b0d9b34f$var$useDataRouterState($b6ec4a53b0d9b34f$var$DataRouterHook.UseActionData);
    let route = $3qjKr.useContext($b6ec4a53b0d9b34f$export$9072aa6dd1f93057);
    !route && (0, $6MTDM.invariant)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * errorElement to display a proper error message.
 */ function $b6ec4a53b0d9b34f$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $3qjKr.useContext($b6ec4a53b0d9b34f$var$RouteErrorContext);
    let state = $b6ec4a53b0d9b34f$var$useDataRouterState($b6ec4a53b0d9b34f$var$DataRouterHook.UseRouteError);
    let route = $3qjKr.useContext($b6ec4a53b0d9b34f$export$9072aa6dd1f93057);
    let thisRoute = route.matches[route.matches.length - 1]; // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    !route && (0, $6MTDM.invariant)(false);
    !thisRoute.route.id && (0, $6MTDM.invariant)(false); // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[thisRoute.route.id];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $b6ec4a53b0d9b34f$export$78a72ddb39bdd145() {
    let value = $3qjKr.useContext($b6ec4a53b0d9b34f$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $b6ec4a53b0d9b34f$export$17f53340677d5831() {
    let value = $3qjKr.useContext($b6ec4a53b0d9b34f$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
const $b6ec4a53b0d9b34f$var$alreadyWarned = {};
function $b6ec4a53b0d9b34f$var$warningOnce(key, cond, message) {
    if (!cond && !$b6ec4a53b0d9b34f$var$alreadyWarned[key]) $b6ec4a53b0d9b34f$var$alreadyWarned[key] = true;
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $b6ec4a53b0d9b34f$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router } = _ref;
    // Sync router state to our component state to force re-renders
    let state = $b6ec4a53b0d9b34f$var$useSyncExternalStore(router.subscribe, ()=>router.state, // but we pass our serialized hydration data into the router so state here
    // is already synced with what the server saw
    ()=>router.state);
    let navigator = $3qjKr.useMemo(()=>{
        return {
            createHref: router.createHref,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    return /*#__PURE__*/ $3qjKr.createElement($b6ec4a53b0d9b34f$export$3add0d5dce533e2e.Provider, {
        value: {
            router: router,
            navigator: navigator,
            static: false,
            basename: // Do we need this?
            basename
        }
    }, /*#__PURE__*/ $3qjKr.createElement($b6ec4a53b0d9b34f$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $3qjKr.createElement($b6ec4a53b0d9b34f$export$55185c17a0fcbe46, {
        basename: router.basename,
        location: router.state.location,
        navigationType: router.state.historyAction,
        navigator: navigator
    }, router.state.initialized ? /*#__PURE__*/ $3qjKr.createElement($b6ec4a53b0d9b34f$export$3565eb3d00ca5a74, null) : fallbackElement)));
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/docs/en/v6/routers/memory-router
 */ function $b6ec4a53b0d9b34f$export$ae46f04cfaffe093(_ref2) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex } = _ref2;
    let historyRef = $3qjKr.useRef();
    if (historyRef.current == null) historyRef.current = (0, $6MTDM.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $3qjKr.useState({
        action: history.action,
        location: history.location
    });
    $3qjKr.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $3qjKr.createElement($b6ec4a53b0d9b34f$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/docs/en/v6/components/navigate
 */ function $b6ec4a53b0d9b34f$export$444b3ab0cb9aec40(_ref3) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref3;
    !$b6ec4a53b0d9b34f$export$9c954a9d03d32f4a() && (0, $6MTDM.invariant)(false);
    let dataRouterState = $3qjKr.useContext($b6ec4a53b0d9b34f$export$145dfa71566a64dc);
    let navigate = $b6ec4a53b0d9b34f$export$9770f232ac06a008();
    $3qjKr.useEffect(()=>{
        // Avoid kicking off multiple navigations if we're in the middle of a
        // data-router navigation, since components get re-rendered when we enter
        // a submitting/loading state
        if (dataRouterState && dataRouterState.navigation.state !== "idle") return;
        navigate(to, {
            replace: replace,
            state: state,
            relative: relative
        });
    });
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/docs/en/v6/components/outlet
 */ function $b6ec4a53b0d9b34f$export$910ae8079b2c2852(props) {
    return $b6ec4a53b0d9b34f$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/docs/en/v6/components/route
 */ function $b6ec4a53b0d9b34f$export$e7b0ac011bb776c6(_props) {
    (0, $6MTDM.invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/docs/en/v6/routers/router
 */ function $b6ec4a53b0d9b34f$export$55185c17a0fcbe46(_ref4) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $6MTDM.Action).Pop, navigator: navigator, static: staticProp = false } = _ref4;
    !!$b6ec4a53b0d9b34f$export$9c954a9d03d32f4a() && (0, $6MTDM.invariant)(false); // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $3qjKr.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $6MTDM.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let location = $3qjKr.useMemo(()=>{
        let trailingPathname = (0, $6MTDM.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            pathname: trailingPathname,
            search: search,
            hash: hash,
            state: state,
            key: key
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key
    ]);
    if (location == null) return null;
    return /*#__PURE__*/ $3qjKr.createElement($b6ec4a53b0d9b34f$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $3qjKr.createElement($b6ec4a53b0d9b34f$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: {
            location: location,
            navigationType: navigationType
        }
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/docs/en/v6/components/routes
 */ function $b6ec4a53b0d9b34f$export$3565eb3d00ca5a74(_ref5) {
    let { children: children, location: location } = _ref5;
    let dataRouterContext = $3qjKr.useContext($b6ec4a53b0d9b34f$export$3add0d5dce533e2e); // When in a DataRouterContext _without_ children, we use the router routes
    // directly.  If we have children, then we're in a descendant tree and we
    // need to use child routes.
    let routes = dataRouterContext && !children ? dataRouterContext.router.routes : $b6ec4a53b0d9b34f$export$16da398f5434bdec(children);
    return $b6ec4a53b0d9b34f$export$5d3fca4a98652595(routes, location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $b6ec4a53b0d9b34f$export$6ddabde395c8c576(_ref6) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref6;
    return /*#__PURE__*/ $3qjKr.createElement($b6ec4a53b0d9b34f$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $3qjKr.createElement($b6ec4a53b0d9b34f$var$ResolveAwait, null, children));
}
var $b6ec4a53b0d9b34f$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($b6ec4a53b0d9b34f$var$AwaitRenderStatus || ($b6ec4a53b0d9b34f$var$AwaitRenderStatus = {}));
const $b6ec4a53b0d9b34f$var$neverSettledPromise = new Promise(()=>{});
class $b6ec4a53b0d9b34f$var$AwaitErrorBoundary extends $3qjKr.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $b6ec4a53b0d9b34f$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $b6ec4a53b0d9b34f$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $b6ec4a53b0d9b34f$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $b6ec4a53b0d9b34f$var$AwaitRenderStatus.error : promise._data !== undefined ? $b6ec4a53b0d9b34f$var$AwaitRenderStatus.success : $b6ec4a53b0d9b34f$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $b6ec4a53b0d9b34f$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $b6ec4a53b0d9b34f$var$AwaitRenderStatus.error && promise._error instanceof (0, $6MTDM.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $b6ec4a53b0d9b34f$var$neverSettledPromise;
        if (status === $b6ec4a53b0d9b34f$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $b6ec4a53b0d9b34f$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $3qjKr.createElement($b6ec4a53b0d9b34f$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $b6ec4a53b0d9b34f$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $3qjKr.createElement($b6ec4a53b0d9b34f$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
         // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $b6ec4a53b0d9b34f$var$ResolveAwait(_ref7) {
    let { children: children } = _ref7;
    let data = $b6ec4a53b0d9b34f$export$78a72ddb39bdd145();
    if (typeof children === "function") return children(data);
    return /*#__PURE__*/ $3qjKr.createElement($3qjKr.Fragment, null, children);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/docs/en/v6/utils/create-routes-from-children
 */ function $b6ec4a53b0d9b34f$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $3qjKr.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $3qjKr.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        if (element.type === $3qjKr.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $b6ec4a53b0d9b34f$export$16da398f5434bdec(element.props.children, parentPath));
            return;
        }
        !(element.type === $b6ec4a53b0d9b34f$export$e7b0ac011bb776c6) && (0, $6MTDM.invariant)(false);
        let treePath = [
            ...parentPath,
            index
        ];
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            hasErrorBoundary: element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle
        };
        if (element.props.children) route.children = $b6ec4a53b0d9b34f$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $b6ec4a53b0d9b34f$export$daf73786167a7f72(matches) {
    return $b6ec4a53b0d9b34f$var$_renderMatches(matches);
}
/**
 * @private
 * Walk the route tree and add hasErrorBoundary if it's not provided, so that
 * users providing manual route arrays can just specify errorElement
 */ function $b6ec4a53b0d9b34f$export$c7b301c52f838c5f(routes) {
    return routes.map((route)=>{
        let routeClone = $b6ec4a53b0d9b34f$var$_extends({}, route);
        if (routeClone.hasErrorBoundary == null) routeClone.hasErrorBoundary = routeClone.errorElement != null;
        if (routeClone.children) routeClone.children = $b6ec4a53b0d9b34f$export$c7b301c52f838c5f(routeClone.children);
        return routeClone;
    });
}
function $b6ec4a53b0d9b34f$export$f30f7e456d254e83(routes, opts) {
    return (0, $6MTDM.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        history: (0, $6MTDM.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: $b6ec4a53b0d9b34f$export$c7b301c52f838c5f(routes)
    }).initialize();
} ///////////////////////////////////////////////////////////////////////////////



var $6MTDM = parcelRequire("6MTDM");
function $b18049b56c6fd776$var$_extends() {
    $b18049b56c6fd776$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b18049b56c6fd776$var$_extends.apply(this, arguments);
}
function $b18049b56c6fd776$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $b18049b56c6fd776$var$defaultMethod = "get";
const $b18049b56c6fd776$var$defaultEncType = "application/x-www-form-urlencoded";
function $b18049b56c6fd776$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $b18049b56c6fd776$var$isButtonElement(object) {
    return $b18049b56c6fd776$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $b18049b56c6fd776$var$isFormElement(object) {
    return $b18049b56c6fd776$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $b18049b56c6fd776$var$isInputElement(object) {
    return $b18049b56c6fd776$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $b18049b56c6fd776$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $b18049b56c6fd776$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$b18049b56c6fd776$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $b18049b56c6fd776$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $b18049b56c6fd776$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $b18049b56c6fd776$export$a2e4e2dcc7b1f22f(locationSearch);
    for (let key of defaultSearchParams.keys())if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
        searchParams.append(key, value);
    });
    return searchParams;
}
function $b18049b56c6fd776$var$getFormSubmissionInfo(target, defaultAction, options) {
    let method;
    let action;
    let encType;
    let formData;
    if ($b18049b56c6fd776$var$isFormElement(target)) {
        let submissionTrigger = options.submissionTrigger;
        method = options.method || target.getAttribute("method") || $b18049b56c6fd776$var$defaultMethod;
        action = options.action || target.getAttribute("action") || defaultAction;
        encType = options.encType || target.getAttribute("enctype") || $b18049b56c6fd776$var$defaultEncType;
        formData = new FormData(target);
        if (submissionTrigger && submissionTrigger.name) formData.append(submissionTrigger.name, submissionTrigger.value);
    } else if ($b18049b56c6fd776$var$isButtonElement(target) || $b18049b56c6fd776$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
         // <button>/<input type="submit"> may override attributes of <form>
        method = options.method || target.getAttribute("formmethod") || form.getAttribute("method") || $b18049b56c6fd776$var$defaultMethod;
        action = options.action || target.getAttribute("formaction") || form.getAttribute("action") || defaultAction;
        encType = options.encType || target.getAttribute("formenctype") || form.getAttribute("enctype") || $b18049b56c6fd776$var$defaultEncType;
        formData = new FormData(form); // Include name + value from a <button>, appending in case the button name
        // matches an existing input name
        if (target.name) formData.append(target.name, target.value);
    } else if ($b18049b56c6fd776$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = options.method || $b18049b56c6fd776$var$defaultMethod;
        action = options.action || defaultAction;
        encType = options.encType || $b18049b56c6fd776$var$defaultEncType;
        if (target instanceof FormData) formData = target;
        else {
            formData = new FormData();
            if (target instanceof URLSearchParams) for (let [name, value] of target)formData.append(name, value);
            else if (target != null) for (let name of Object.keys(target))formData.append(name, target[name]);
        }
    }
    let { protocol: protocol, host: host } = window.location;
    let url = new URL(action, protocol + "//" + host);
    return {
        url: url,
        method: method,
        encType: encType,
        formData: formData
    };
}
const $b18049b56c6fd776$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $b18049b56c6fd776$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $b18049b56c6fd776$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "fetcherKey",
    "routeId",
    "relative"
];
//#region Routers
////////////////////////////////////////////////////////////////////////////////
function $b18049b56c6fd776$export$1f3f55432a00e06d(routes, opts) {
    var _window;
    return (0, $6MTDM.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        history: (0, $6MTDM.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || ((_window = window) == null ? void 0 : _window.__staticRouterHydrationData),
        routes: (0, $b6ec4a53b0d9b34f$export$c7b301c52f838c5f)(routes)
    }).initialize();
}
function $b18049b56c6fd776$export$1ba7ed8a3a7b3765(routes, opts) {
    var _window2;
    return (0, $6MTDM.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        history: (0, $6MTDM.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || ((_window2 = window) == null ? void 0 : _window2.__staticRouterHydrationData),
        routes: (0, $b6ec4a53b0d9b34f$export$c7b301c52f838c5f)(routes)
    }).initialize();
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $b18049b56c6fd776$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, window: window1 } = _ref;
    let historyRef = $3qjKr.useRef();
    if (historyRef.current == null) historyRef.current = (0, $6MTDM.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $3qjKr.useState({
        action: history.action,
        location: history.location
    });
    $3qjKr.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $3qjKr.createElement((0, $b6ec4a53b0d9b34f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $b18049b56c6fd776$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, window: window1 } = _ref2;
    let historyRef = $3qjKr.useRef();
    if (historyRef.current == null) historyRef.current = (0, $6MTDM.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $3qjKr.useState({
        action: history.action,
        location: history.location
    });
    $3qjKr.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $3qjKr.createElement((0, $b6ec4a53b0d9b34f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $b18049b56c6fd776$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, history: history } = _ref3;
    const [state, setState] = $3qjKr.useState({
        action: history.action,
        location: history.location
    });
    $3qjKr.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $3qjKr.createElement((0, $b6ec4a53b0d9b34f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * The public API for rendering a history-aware <a>.
 */ const $b18049b56c6fd776$export$a6c7ac8248d6e38a = /*#__PURE__*/ $3qjKr.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $b18049b56c6fd776$var$_objectWithoutPropertiesLoose(_ref4, $b18049b56c6fd776$var$_excluded);
    let href = (0, $b6ec4a53b0d9b34f$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $b18049b56c6fd776$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $3qjKr.createElement("a", $b18049b56c6fd776$var$_extends({}, rest, {
        href: href,
        onClick: reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $b18049b56c6fd776$export$b0d92dbee9b5b60d = /*#__PURE__*/ $3qjKr.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $b18049b56c6fd776$var$_objectWithoutPropertiesLoose(_ref5, $b18049b56c6fd776$var$_excluded2);
    let path = (0, $b6ec4a53b0d9b34f$export$e75d2a2d1b3c245b)(to);
    let match = (0, $b6ec4a53b0d9b34f$export$6c330e8992e8a295)({
        path: path.pathname,
        end: end,
        caseSensitive: caseSensitive
    });
    let routerState = $3qjKr.useContext((0, $b6ec4a53b0d9b34f$export$145dfa71566a64dc));
    let nextLocation = routerState == null ? void 0 : routerState.navigation.location;
    let nextPath = (0, $b6ec4a53b0d9b34f$export$e75d2a2d1b3c245b)(nextLocation || "");
    let nextMatch = $3qjKr.useMemo(()=>nextLocation ? (0, $6MTDM.matchPath)({
            path: path.pathname,
            end: end,
            caseSensitive: caseSensitive
        }, nextPath.pathname) : null, [
        nextLocation,
        path.pathname,
        caseSensitive,
        end,
        nextPath.pathname
    ]);
    let isPending = nextMatch != null;
    let isActive = match != null;
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $3qjKr.createElement($b18049b56c6fd776$export$a6c7ac8248d6e38a, $b18049b56c6fd776$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $b18049b56c6fd776$export$a7fed597f4b8afd8 = /*#__PURE__*/ $3qjKr.forwardRef((props, ref)=>{
    return /*#__PURE__*/ $3qjKr.createElement($b18049b56c6fd776$var$FormImpl, $b18049b56c6fd776$var$_extends({}, props, {
        ref: ref
    }));
});
const $b18049b56c6fd776$var$FormImpl = /*#__PURE__*/ $3qjKr.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, method: method = $b18049b56c6fd776$var$defaultMethod, action: action, onSubmit: onSubmit, fetcherKey: fetcherKey, routeId: routeId, relative: relative } = _ref6, props = $b18049b56c6fd776$var$_objectWithoutPropertiesLoose(_ref6, $b18049b56c6fd776$var$_excluded3);
    let submit = $b18049b56c6fd776$var$useSubmitImpl(fetcherKey, routeId);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $b18049b56c6fd776$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        submit(submitter || event.currentTarget, {
            method: method,
            replace: replace,
            relative: relative
        });
    };
    return /*#__PURE__*/ $3qjKr.createElement("form", $b18049b56c6fd776$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $b18049b56c6fd776$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $b18049b56c6fd776$var$useScrollRestoration({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $b18049b56c6fd776$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $b6ec4a53b0d9b34f$export$9770f232ac06a008)();
    let location = (0, $b6ec4a53b0d9b34f$export$45d76561a5302f2b)();
    let path = (0, $b6ec4a53b0d9b34f$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $3qjKr.useCallback((event)=>{
        if ($b18049b56c6fd776$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $6MTDM.createPath)(location) === (0, $6MTDM.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $b18049b56c6fd776$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $3qjKr.useRef($b18049b56c6fd776$export$a2e4e2dcc7b1f22f(defaultInit));
    let location = (0, $b6ec4a53b0d9b34f$export$45d76561a5302f2b)();
    let searchParams = $3qjKr.useMemo(()=>$b18049b56c6fd776$var$getSearchParamsForLocation(location.search, defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $b6ec4a53b0d9b34f$export$9770f232ac06a008)();
    let setSearchParams = $3qjKr.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $b18049b56c6fd776$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $b18049b56c6fd776$export$47c85c6e3a081d3() {
    return $b18049b56c6fd776$var$useSubmitImpl();
}
function $b18049b56c6fd776$var$useSubmitImpl(fetcherKey, routeId) {
    let dataRouterContext = $3qjKr.useContext((0, $b6ec4a53b0d9b34f$export$3add0d5dce533e2e));
    !dataRouterContext && (0, $6MTDM.invariant)(false);
    let { router: router } = dataRouterContext;
    let defaultAction = $b18049b56c6fd776$export$89a6bd6db0d97c56();
    return $3qjKr.useCallback(function(target, options) {
        if (options === void 0) options = {};
        if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
        let { method: method, encType: encType, formData: formData, url: url } = $b18049b56c6fd776$var$getFormSubmissionInfo(target, defaultAction, options);
        let href = url.pathname + url.search;
        let opts = {
            replace: options.replace,
            formData: formData,
            formMethod: method,
            formEncType: encType
        };
        if (fetcherKey) {
            !(routeId != null) && (0, $6MTDM.invariant)(false);
            router.fetch(fetcherKey, routeId, href, opts);
        } else router.navigate(href, opts);
    }, [
        defaultAction,
        router,
        fetcherKey,
        routeId
    ]);
}
function $b18049b56c6fd776$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let routeContext = $3qjKr.useContext((0, $b6ec4a53b0d9b34f$export$9072aa6dd1f93057));
    !routeContext && (0, $6MTDM.invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    let resolvedAction = action != null ? action : ".";
    let path = (0, $b6ec4a53b0d9b34f$export$e75d2a2d1b3c245b)(resolvedAction, {
        relative: relative
    }); // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $b6ec4a53b0d9b34f$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash; // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    return (0, $6MTDM.createPath)(path);
}
function $b18049b56c6fd776$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $3qjKr.forwardRef((props, ref)=>{
        return /*#__PURE__*/ $3qjKr.createElement($b18049b56c6fd776$var$FormImpl, $b18049b56c6fd776$var$_extends({}, props, {
            ref: ref,
            fetcherKey: fetcherKey,
            routeId: routeId
        }));
    });
    return FetcherForm;
}
let $b18049b56c6fd776$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $b18049b56c6fd776$export$5b0d2d9a9921565a() {
    var _route$matches;
    let dataRouterContext = $3qjKr.useContext((0, $b6ec4a53b0d9b34f$export$3add0d5dce533e2e));
    !dataRouterContext && (0, $6MTDM.invariant)(false);
    let { router: router } = dataRouterContext;
    let route = $3qjKr.useContext((0, $b6ec4a53b0d9b34f$export$9072aa6dd1f93057));
    !route && (0, $6MTDM.invariant)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $6MTDM.invariant)(false);
    let [fetcherKey] = $3qjKr.useState(()=>String(++$b18049b56c6fd776$var$fetcherId));
    let [Form] = $3qjKr.useState(()=>{
        !routeId && (0, $6MTDM.invariant)(false);
        return $b18049b56c6fd776$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $3qjKr.useState(()=>(href)=>{
            !router && (0, $6MTDM.invariant)(false);
            !routeId && (0, $6MTDM.invariant)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $b18049b56c6fd776$var$useSubmitImpl(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $3qjKr.useMemo(()=>$b18049b56c6fd776$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $3qjKr.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No fetcher available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $b18049b56c6fd776$export$fa996778a3a31087() {
    let state = $3qjKr.useContext((0, $b6ec4a53b0d9b34f$export$145dfa71566a64dc));
    !state && (0, $6MTDM.invariant)(false);
    return [
        ...state.fetchers.values()
    ];
}
const $b18049b56c6fd776$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $b18049b56c6fd776$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $b18049b56c6fd776$var$useScrollRestoration(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let location = (0, $b6ec4a53b0d9b34f$export$45d76561a5302f2b)();
    let matches = (0, $b6ec4a53b0d9b34f$export$2378eb7f5ff86053)();
    let navigation = (0, $b6ec4a53b0d9b34f$export$d0fd4b7106de2769)();
    let dataRouterContext = $3qjKr.useContext((0, $b6ec4a53b0d9b34f$export$3add0d5dce533e2e));
    !dataRouterContext && (0, $6MTDM.invariant)(false);
    let { router: router } = dataRouterContext;
    let state = $3qjKr.useContext((0, $b6ec4a53b0d9b34f$export$145dfa71566a64dc));
    !(router != null && state != null) && (0, $6MTDM.invariant)(false);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = state; // Trigger manual scroll restoration while we're active
    $3qjKr.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []); // Save positions on unload
    $b18049b56c6fd776$var$useBeforeUnload($3qjKr.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $b18049b56c6fd776$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $b18049b56c6fd776$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($b18049b56c6fd776$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ])); // Read in any saved scroll locations
    $3qjKr.useLayoutEffect(()=>{
        try {
            let sessionPositions = sessionStorage.getItem(storageKey || $b18049b56c6fd776$var$SCROLL_RESTORATION_STORAGE_KEY);
            if (sessionPositions) $b18049b56c6fd776$var$savedScrollPositions = JSON.parse(sessionPositions);
        } catch (e) {}
    }, [
        storageKey
    ]); // Enable scroll restoration in the router
    $3qjKr.useLayoutEffect(()=>{
        let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($b18049b56c6fd776$var$savedScrollPositions, ()=>window.scrollY, getKey);
        return ()=>disableScrollRestoration && disableScrollRestoration();
    }, [
        router,
        getKey
    ]); // Restore scrolling when state.restoreScrollPosition changes
    $3qjKr.useLayoutEffect(()=>{
        // Explicit false means don't do anything (used for submissions)
        if (restoreScrollPosition === false) return;
         // been here before, scroll to it
        if (typeof restoreScrollPosition === "number") {
            window.scrollTo(0, restoreScrollPosition);
            return;
        } // try to scroll to the hash
        if (location.hash) {
            let el = document.getElementById(location.hash.slice(1));
            if (el) {
                el.scrollIntoView();
                return;
            }
        } // Opt out of scroll reset if this link requested it
        if (preventScrollReset === true) return;
         // otherwise go to the top on new locations
        window.scrollTo(0, 0);
    }, [
        location,
        restoreScrollPosition,
        preventScrollReset
    ]);
}
function $b18049b56c6fd776$var$useBeforeUnload(callback) {
    $3qjKr.useEffect(()=>{
        window.addEventListener("beforeunload", callback);
        return ()=>{
            window.removeEventListener("beforeunload", callback);
        };
    }, [
        callback
    ]);
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Utils
////////////////////////////////////////////////////////////////////////////////
function $b18049b56c6fd776$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging React Router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
} //#endregion


/**
 * Copyright 2023 ALPHAGUARD CONSULTING, LLC.  All rights reserved.
 * Use of this source code is governed by a Commercial License Agreement
 * license can be found in the LICENSE file or contact legal@alphaguard.io
 */ 
var $bNLBQ = parcelRequire("bNLBQ");
/**
 * Copyright 2023 ALPHAGUARD CONSULTING, LLC.  All rights reserved.
 * Use of this source code is governed by a Commercial License Agreement
 * license can be found in the LICENSE file or contact legal@alphaguard.io
 */ parcelRequire("bNLBQ");
var $36fSf = parcelRequire("36fSf");
var $bNLBQ = parcelRequire("bNLBQ");
var $33a16233ac4f7c55$export$2e2bcd8739ae039 = crypto;
const $33a16233ac4f7c55$export$600b5603bbac4c6 = (key)=>key instanceof CryptoKey;


const $5959832e4f60c589$var$digest = async (algorithm, data)=>{
    const subtleDigest = `SHA-${algorithm.slice(-3)}`;
    return new Uint8Array(await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.digest(subtleDigest, data));
};
var $5959832e4f60c589$export$2e2bcd8739ae039 = $5959832e4f60c589$var$digest;


const $615a589604068301$export$5486af06137bf21a = new TextEncoder();
const $615a589604068301$export$124c96e6ce37090b = new TextDecoder();
const $615a589604068301$var$MAX_INT32 = 2 ** 32;
function $615a589604068301$export$ee1b3e54f0441b22(...buffers) {
    const size = buffers.reduce((acc, { length: length })=>acc + length, 0);
    const buf = new Uint8Array(size);
    let i = 0;
    buffers.forEach((buffer)=>{
        buf.set(buffer, i);
        i += buffer.length;
    });
    return buf;
}
function $615a589604068301$export$256d3ca12372f112(alg, p2sInput) {
    return $615a589604068301$export$ee1b3e54f0441b22($615a589604068301$export$5486af06137bf21a.encode(alg), new Uint8Array([
        0
    ]), p2sInput);
}
function $615a589604068301$var$writeUInt32BE(buf, value, offset) {
    if (value < 0 || value >= $615a589604068301$var$MAX_INT32) throw new RangeError(`value must be >= 0 and <= ${$615a589604068301$var$MAX_INT32 - 1}. Received ${value}`);
    buf.set([
        value >>> 24,
        value >>> 16,
        value >>> 8,
        value & 0xff
    ], offset);
}
function $615a589604068301$export$e7b531e00a18fdd7(value) {
    const high = Math.floor(value / $615a589604068301$var$MAX_INT32);
    const low = value % $615a589604068301$var$MAX_INT32;
    const buf = new Uint8Array(8);
    $615a589604068301$var$writeUInt32BE(buf, high, 0);
    $615a589604068301$var$writeUInt32BE(buf, low, 4);
    return buf;
}
function $615a589604068301$export$74c16dba6c885532(value) {
    const buf = new Uint8Array(4);
    $615a589604068301$var$writeUInt32BE(buf, value);
    return buf;
}
function $615a589604068301$export$c1498c4a3718d967(input) {
    return $615a589604068301$export$ee1b3e54f0441b22($615a589604068301$export$74c16dba6c885532(input.length), input);
}
async function $615a589604068301$export$67163693c21af44f(secret, bits, value) {
    const iterations = Math.ceil((bits >> 3) / 32);
    const res = new Uint8Array(iterations * 32);
    for(let iter = 0; iter < iterations; iter++){
        const buf = new Uint8Array(4 + secret.length + value.length);
        buf.set($615a589604068301$export$74c16dba6c885532(iter + 1));
        buf.set(secret, 4);
        buf.set(value, 4 + secret.length);
        res.set(await (0, $5959832e4f60c589$export$2e2bcd8739ae039)("sha256", buf), iter * 32);
    }
    return res.slice(0, bits >> 3);
}


const $033bcccb44f8a8b5$export$8fb536984ec8b4d7 = (input)=>{
    let unencoded = input;
    if (typeof unencoded === "string") unencoded = (0, $615a589604068301$export$5486af06137bf21a).encode(unencoded);
    const CHUNK_SIZE = 0x8000;
    const arr = [];
    for(let i = 0; i < unencoded.length; i += CHUNK_SIZE)arr.push(String.fromCharCode.apply(null, unencoded.subarray(i, i + CHUNK_SIZE)));
    return btoa(arr.join(""));
};
const $033bcccb44f8a8b5$export$c564cdbbe6da493 = (input)=>{
    return $033bcccb44f8a8b5$export$8fb536984ec8b4d7(input).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
};
const $033bcccb44f8a8b5$export$94fdf11bafc8de6b = (encoded)=>{
    const binary = atob(encoded);
    const bytes = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
    return bytes;
};
const $033bcccb44f8a8b5$export$2f872c0f2117be69 = (input)=>{
    let encoded = input;
    if (encoded instanceof Uint8Array) encoded = (0, $615a589604068301$export$124c96e6ce37090b).decode(encoded);
    encoded = encoded.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "");
    try {
        return $033bcccb44f8a8b5$export$94fdf11bafc8de6b(encoded);
    } catch (_a) {
        throw new TypeError("The input to be decoded is not correctly encoded.");
    }
};



class $1e405ee376479e7e$export$f754d6850d76bf87 extends Error {
    static get code() {
        return "ERR_JOSE_GENERIC";
    }
    constructor(message){
        var _a;
        super(message);
        this.code = "ERR_JOSE_GENERIC";
        this.name = this.constructor.name;
        (_a = Error.captureStackTrace) === null || _a === void 0 || _a.call(Error, this, this.constructor);
    }
}
class $1e405ee376479e7e$export$f1e14efb908196e9 extends $1e405ee376479e7e$export$f754d6850d76bf87 {
    static get code() {
        return "ERR_JWT_CLAIM_VALIDATION_FAILED";
    }
    constructor(message, claim = "unspecified", reason = "unspecified"){
        super(message);
        this.code = "ERR_JWT_CLAIM_VALIDATION_FAILED";
        this.claim = claim;
        this.reason = reason;
    }
}
class $1e405ee376479e7e$export$4b386bf852b7863d extends $1e405ee376479e7e$export$f754d6850d76bf87 {
    static get code() {
        return "ERR_JWT_EXPIRED";
    }
    constructor(message, claim = "unspecified", reason = "unspecified"){
        super(message);
        this.code = "ERR_JWT_EXPIRED";
        this.claim = claim;
        this.reason = reason;
    }
}
class $1e405ee376479e7e$export$d51fd7fedeccc338 extends $1e405ee376479e7e$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JOSE_ALG_NOT_ALLOWED";
    }
    static get code() {
        return "ERR_JOSE_ALG_NOT_ALLOWED";
    }
}
class $1e405ee376479e7e$export$19ddbcbf2016ab28 extends $1e405ee376479e7e$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JOSE_NOT_SUPPORTED";
    }
    static get code() {
        return "ERR_JOSE_NOT_SUPPORTED";
    }
}
class $1e405ee376479e7e$export$1a57512ad9773b2a extends $1e405ee376479e7e$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWE_DECRYPTION_FAILED";
        this.message = "decryption operation failed";
    }
    static get code() {
        return "ERR_JWE_DECRYPTION_FAILED";
    }
}
class $1e405ee376479e7e$export$19f281f2275f6a15 extends $1e405ee376479e7e$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWE_INVALID";
    }
    static get code() {
        return "ERR_JWE_INVALID";
    }
}
class $1e405ee376479e7e$export$e838de724af3d116 extends $1e405ee376479e7e$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWS_INVALID";
    }
    static get code() {
        return "ERR_JWS_INVALID";
    }
}
class $1e405ee376479e7e$export$936b39ada0bbfceb extends $1e405ee376479e7e$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWT_INVALID";
    }
    static get code() {
        return "ERR_JWT_INVALID";
    }
}
class $1e405ee376479e7e$export$b3992e0f88fb07e3 extends $1e405ee376479e7e$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWK_INVALID";
    }
    static get code() {
        return "ERR_JWK_INVALID";
    }
}
class $1e405ee376479e7e$export$9b22c2a1e2403b8e extends $1e405ee376479e7e$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_INVALID";
    }
    static get code() {
        return "ERR_JWKS_INVALID";
    }
}
class $1e405ee376479e7e$export$3d5ed1a538bed04e extends $1e405ee376479e7e$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_NO_MATCHING_KEY";
        this.message = "no applicable key found in the JSON Web Key Set";
    }
    static get code() {
        return "ERR_JWKS_NO_MATCHING_KEY";
    }
}
class $1e405ee376479e7e$export$dc036de401a5c284 extends $1e405ee376479e7e$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
        this.message = "multiple matching keys found in the JSON Web Key Set";
    }
    static get code() {
        return "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
    }
}
Symbol.asyncIterator;
class $1e405ee376479e7e$export$3f30acebf25c04e6 extends $1e405ee376479e7e$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_TIMEOUT";
        this.message = "request timed out";
    }
    static get code() {
        return "ERR_JWKS_TIMEOUT";
    }
}
class $1e405ee376479e7e$export$c67a0218e7c50378 extends $1e405ee376479e7e$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
        this.message = "signature verification failed";
    }
    static get code() {
        return "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
    }
}




var $b68e3f962456fa36$export$2e2bcd8739ae039 = (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).getRandomValues.bind((0, $33a16233ac4f7c55$export$2e2bcd8739ae039));


function $f565ffac88c03c90$export$db433e85ac514a95(alg) {
    switch(alg){
        case "A128GCM":
        case "A128GCMKW":
        case "A192GCM":
        case "A192GCMKW":
        case "A256GCM":
        case "A256GCMKW":
            return 96;
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            return 128;
        default:
            throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)(`Unsupported JWE Algorithm: ${alg}`);
    }
}
var $f565ffac88c03c90$export$2e2bcd8739ae039 = (alg)=>(0, $b68e3f962456fa36$export$2e2bcd8739ae039)(new Uint8Array($f565ffac88c03c90$export$db433e85ac514a95(alg) >> 3));


const $49abd97cc1eb20bd$var$checkIvLength = (enc, iv)=>{
    if (iv.length << 3 !== (0, $f565ffac88c03c90$export$db433e85ac514a95)(enc)) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("Invalid Initialization Vector length");
};
var $49abd97cc1eb20bd$export$2e2bcd8739ae039 = $49abd97cc1eb20bd$var$checkIvLength;



const $82ada42bd8312473$var$checkCekLength = (cek, expected)=>{
    const actual = cek.byteLength << 3;
    if (actual !== expected) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)(`Invalid Content Encryption Key length. Expected ${expected} bits, got ${actual} bits`);
};
var $82ada42bd8312473$export$2e2bcd8739ae039 = $82ada42bd8312473$var$checkCekLength;


const $e66d3ea8aeec4699$var$timingSafeEqual = (a, b)=>{
    if (!(a instanceof Uint8Array)) throw new TypeError("First argument must be a buffer");
    if (!(b instanceof Uint8Array)) throw new TypeError("Second argument must be a buffer");
    if (a.length !== b.length) throw new TypeError("Input buffers must have the same length");
    const len = a.length;
    let out = 0;
    let i = -1;
    while(++i < len)out |= a[i] ^ b[i];
    return out === 0;
};
var $e66d3ea8aeec4699$export$2e2bcd8739ae039 = $e66d3ea8aeec4699$var$timingSafeEqual;




function $1028636d784f9436$var$unusable(name, prop = "algorithm.name") {
    return new TypeError(`CryptoKey does not support this operation, its ${prop} must be ${name}`);
}
function $1028636d784f9436$var$isAlgorithm(algorithm, name) {
    return algorithm.name === name;
}
function $1028636d784f9436$var$getHashLength(hash) {
    return parseInt(hash.name.slice(4), 10);
}
function $1028636d784f9436$var$getNamedCurve(alg) {
    switch(alg){
        case "ES256":
            return "P-256";
        case "ES384":
            return "P-384";
        case "ES512":
            return "P-521";
        default:
            throw new Error("unreachable");
    }
}
function $1028636d784f9436$var$checkUsage(key, usages) {
    if (usages.length && !usages.some((expected)=>key.usages.includes(expected))) {
        let msg = "CryptoKey does not support this operation, its usages must include ";
        if (usages.length > 2) {
            const last = usages.pop();
            msg += `one of ${usages.join(", ")}, or ${last}.`;
        } else if (usages.length === 2) msg += `one of ${usages[0]} or ${usages[1]}.`;
        else msg += `${usages[0]}.`;
        throw new TypeError(msg);
    }
}
function $1028636d784f9436$export$39a36029eee6729(key, alg, ...usages) {
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            {
                if (!$1028636d784f9436$var$isAlgorithm(key.algorithm, "HMAC")) throw $1028636d784f9436$var$unusable("HMAC");
                const expected = parseInt(alg.slice(2), 10);
                const actual = $1028636d784f9436$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $1028636d784f9436$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "RS256":
        case "RS384":
        case "RS512":
            {
                if (!$1028636d784f9436$var$isAlgorithm(key.algorithm, "RSASSA-PKCS1-v1_5")) throw $1028636d784f9436$var$unusable("RSASSA-PKCS1-v1_5");
                const expected = parseInt(alg.slice(2), 10);
                const actual = $1028636d784f9436$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $1028636d784f9436$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "PS256":
        case "PS384":
        case "PS512":
            {
                if (!$1028636d784f9436$var$isAlgorithm(key.algorithm, "RSA-PSS")) throw $1028636d784f9436$var$unusable("RSA-PSS");
                const expected = parseInt(alg.slice(2), 10);
                const actual = $1028636d784f9436$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $1028636d784f9436$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "EdDSA":
            if (key.algorithm.name !== "Ed25519" && key.algorithm.name !== "Ed448") throw $1028636d784f9436$var$unusable("Ed25519 or Ed448");
            break;
        case "ES256":
        case "ES384":
        case "ES512":
            {
                if (!$1028636d784f9436$var$isAlgorithm(key.algorithm, "ECDSA")) throw $1028636d784f9436$var$unusable("ECDSA");
                const expected = $1028636d784f9436$var$getNamedCurve(alg);
                const actual = key.algorithm.namedCurve;
                if (actual !== expected) throw $1028636d784f9436$var$unusable(expected, "algorithm.namedCurve");
                break;
            }
        default:
            throw new TypeError("CryptoKey does not support this operation");
    }
    $1028636d784f9436$var$checkUsage(key, usages);
}
function $1028636d784f9436$export$41a67f89f6678b35(key, alg, ...usages) {
    switch(alg){
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            {
                if (!$1028636d784f9436$var$isAlgorithm(key.algorithm, "AES-GCM")) throw $1028636d784f9436$var$unusable("AES-GCM");
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw $1028636d784f9436$var$unusable(expected, "algorithm.length");
                break;
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            {
                if (!$1028636d784f9436$var$isAlgorithm(key.algorithm, "AES-KW")) throw $1028636d784f9436$var$unusable("AES-KW");
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw $1028636d784f9436$var$unusable(expected, "algorithm.length");
                break;
            }
        case "ECDH":
            switch(key.algorithm.name){
                case "ECDH":
                case "X25519":
                case "X448":
                    break;
                default:
                    throw $1028636d784f9436$var$unusable("ECDH, X25519, or X448");
            }
            break;
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            if (!$1028636d784f9436$var$isAlgorithm(key.algorithm, "PBKDF2")) throw $1028636d784f9436$var$unusable("PBKDF2");
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            {
                if (!$1028636d784f9436$var$isAlgorithm(key.algorithm, "RSA-OAEP")) throw $1028636d784f9436$var$unusable("RSA-OAEP");
                const expected = parseInt(alg.slice(9), 10) || 1;
                const actual = $1028636d784f9436$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $1028636d784f9436$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        default:
            throw new TypeError("CryptoKey does not support this operation");
    }
    $1028636d784f9436$var$checkUsage(key, usages);
}


function $7c1fe397db20d285$var$message(msg, actual, ...types) {
    if (types.length > 2) {
        const last = types.pop();
        msg += `one of type ${types.join(", ")}, or ${last}.`;
    } else if (types.length === 2) msg += `one of type ${types[0]} or ${types[1]}.`;
    else msg += `of type ${types[0]}.`;
    if (actual == null) msg += ` Received ${actual}`;
    else if (typeof actual === "function" && actual.name) msg += ` Received function ${actual.name}`;
    else if (typeof actual === "object" && actual != null) {
        if (actual.constructor && actual.constructor.name) msg += ` Received an instance of ${actual.constructor.name}`;
    }
    return msg;
}
var $7c1fe397db20d285$export$2e2bcd8739ae039 = (actual, ...types)=>{
    return $7c1fe397db20d285$var$message("Key must be ", actual, ...types);
};
function $7c1fe397db20d285$export$e94f758d09bc1828(alg, actual, ...types) {
    return $7c1fe397db20d285$var$message(`Key for the ${alg} algorithm must be `, actual, ...types);
}



var $974356314552bbc8$export$2e2bcd8739ae039 = (key)=>{
    return (0, $33a16233ac4f7c55$export$600b5603bbac4c6)(key);
};
const $974356314552bbc8$export$b14ad400b1d09e0f = [
    "CryptoKey"
];


async function $de46c37ae41de88c$var$cbcDecrypt(enc, cek, ciphertext, iv, tag, aad) {
    if (!(cek instanceof Uint8Array)) throw new TypeError((0, $7c1fe397db20d285$export$2e2bcd8739ae039)(cek, "Uint8Array"));
    const keySize = parseInt(enc.slice(1, 4), 10);
    const encKey = await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.importKey("raw", cek.subarray(keySize >> 3), "AES-CBC", false, [
        "decrypt"
    ]);
    const macKey = await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.importKey("raw", cek.subarray(0, keySize >> 3), {
        hash: `SHA-${keySize << 1}`,
        name: "HMAC"
    }, false, [
        "sign"
    ]);
    const macData = (0, $615a589604068301$export$ee1b3e54f0441b22)(aad, iv, ciphertext, (0, $615a589604068301$export$e7b531e00a18fdd7)(aad.length << 3));
    const expectedTag = new Uint8Array((await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.sign("HMAC", macKey, macData)).slice(0, keySize >> 3));
    let macCheckPassed;
    try {
        macCheckPassed = (0, $e66d3ea8aeec4699$export$2e2bcd8739ae039)(tag, expectedTag);
    } catch (_a) {}
    if (!macCheckPassed) throw new (0, $1e405ee376479e7e$export$1a57512ad9773b2a)();
    let plaintext;
    try {
        plaintext = new Uint8Array(await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.decrypt({
            iv: iv,
            name: "AES-CBC"
        }, encKey, ciphertext));
    } catch (_b) {}
    if (!plaintext) throw new (0, $1e405ee376479e7e$export$1a57512ad9773b2a)();
    return plaintext;
}
async function $de46c37ae41de88c$var$gcmDecrypt(enc, cek, ciphertext, iv, tag, aad) {
    let encKey;
    if (cek instanceof Uint8Array) encKey = await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.importKey("raw", cek, "AES-GCM", false, [
        "decrypt"
    ]);
    else {
        (0, $1028636d784f9436$export$41a67f89f6678b35)(cek, enc, "decrypt");
        encKey = cek;
    }
    try {
        return new Uint8Array(await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.decrypt({
            additionalData: aad,
            iv: iv,
            name: "AES-GCM",
            tagLength: 128
        }, encKey, (0, $615a589604068301$export$ee1b3e54f0441b22)(ciphertext, tag)));
    } catch (_a) {
        throw new (0, $1e405ee376479e7e$export$1a57512ad9773b2a)();
    }
}
const $de46c37ae41de88c$var$decrypt = async (enc, cek, ciphertext, iv, tag, aad)=>{
    if (!(0, $33a16233ac4f7c55$export$600b5603bbac4c6)(cek) && !(cek instanceof Uint8Array)) throw new TypeError((0, $7c1fe397db20d285$export$2e2bcd8739ae039)(cek, ...(0, $974356314552bbc8$export$b14ad400b1d09e0f), "Uint8Array"));
    (0, $49abd97cc1eb20bd$export$2e2bcd8739ae039)(enc, iv);
    switch(enc){
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            if (cek instanceof Uint8Array) (0, $82ada42bd8312473$export$2e2bcd8739ae039)(cek, parseInt(enc.slice(-3), 10));
            return $de46c37ae41de88c$var$cbcDecrypt(enc, cek, ciphertext, iv, tag, aad);
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            if (cek instanceof Uint8Array) (0, $82ada42bd8312473$export$2e2bcd8739ae039)(cek, parseInt(enc.slice(1, 4), 10));
            return $de46c37ae41de88c$var$gcmDecrypt(enc, cek, ciphertext, iv, tag, aad);
        default:
            throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)("Unsupported JWE Content Encryption Algorithm");
    }
};
var $de46c37ae41de88c$export$2e2bcd8739ae039 = $de46c37ae41de88c$var$decrypt;



const $99bffc79943d043d$export$cae1ce83fe4a1782 = async ()=>{
    throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)('JWE "zip" (Compression Algorithm) Header Parameter is not supported by your javascript runtime. You need to use the `inflateRaw` decrypt option to provide Inflate Raw implementation.');
};
const $99bffc79943d043d$export$2316623ecd1285ab = async ()=>{
    throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)('JWE "zip" (Compression Algorithm) Header Parameter is not supported by your javascript runtime. You need to use the `deflateRaw` encrypt option to provide Deflate Raw implementation.');
};



const $33b5b90a0aee86b8$var$isDisjoint = (...headers)=>{
    const sources = headers.filter(Boolean);
    if (sources.length === 0 || sources.length === 1) return true;
    let acc;
    for (const header of sources){
        const parameters = Object.keys(header);
        if (!acc || acc.size === 0) {
            acc = new Set(parameters);
            continue;
        }
        for (const parameter of parameters){
            if (acc.has(parameter)) return false;
            acc.add(parameter);
        }
    }
    return true;
};
var $33b5b90a0aee86b8$export$2e2bcd8739ae039 = $33b5b90a0aee86b8$var$isDisjoint;


function $650ccab004d5778d$var$isObjectLike(value) {
    return typeof value === "object" && value !== null;
}
function $650ccab004d5778d$export$2e2bcd8739ae039(input) {
    if (!$650ccab004d5778d$var$isObjectLike(input) || Object.prototype.toString.call(input) !== "[object Object]") return false;
    if (Object.getPrototypeOf(input) === null) return true;
    let proto = input;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(input) === proto;
}


const $d0900a2cd9174c2e$var$bogusWebCrypto = [
    {
        hash: "SHA-256",
        name: "HMAC"
    },
    true,
    [
        "sign"
    ]
];
var $d0900a2cd9174c2e$export$2e2bcd8739ae039 = $d0900a2cd9174c2e$var$bogusWebCrypto;






function $3094dab5ef792645$var$checkKeySize(key, alg) {
    if (key.algorithm.length !== parseInt(alg.slice(1, 4), 10)) throw new TypeError(`Invalid key size for alg: ${alg}`);
}
function $3094dab5ef792645$var$getCryptoKey(key, alg, usage) {
    if ((0, $33a16233ac4f7c55$export$600b5603bbac4c6)(key)) {
        (0, $1028636d784f9436$export$41a67f89f6678b35)(key, alg, usage);
        return key;
    }
    if (key instanceof Uint8Array) return (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.importKey("raw", key, "AES-KW", true, [
        usage
    ]);
    throw new TypeError((0, $7c1fe397db20d285$export$2e2bcd8739ae039)(key, ...(0, $974356314552bbc8$export$b14ad400b1d09e0f), "Uint8Array"));
}
const $3094dab5ef792645$export$4997ffc0176396a6 = async (alg, key, cek)=>{
    const cryptoKey = await $3094dab5ef792645$var$getCryptoKey(key, alg, "wrapKey");
    $3094dab5ef792645$var$checkKeySize(cryptoKey, alg);
    const cryptoKeyCek = await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.importKey("raw", cek, ...(0, $d0900a2cd9174c2e$export$2e2bcd8739ae039));
    return new Uint8Array(await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.wrapKey("raw", cryptoKeyCek, cryptoKey, "AES-KW"));
};
const $3094dab5ef792645$export$debb760848ca95a = async (alg, key, encryptedKey)=>{
    const cryptoKey = await $3094dab5ef792645$var$getCryptoKey(key, alg, "unwrapKey");
    $3094dab5ef792645$var$checkKeySize(cryptoKey, alg);
    const cryptoKeyCek = await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.unwrapKey("raw", encryptedKey, cryptoKey, "AES-KW", ...(0, $d0900a2cd9174c2e$export$2e2bcd8739ae039));
    return new Uint8Array(await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.exportKey("raw", cryptoKeyCek));
};







async function $ba8b0aeef6c47263$export$87770b6b245073b5(publicKey, privateKey, algorithm, keyLength, apu = new Uint8Array(0), apv = new Uint8Array(0)) {
    if (!(0, $33a16233ac4f7c55$export$600b5603bbac4c6)(publicKey)) throw new TypeError((0, $7c1fe397db20d285$export$2e2bcd8739ae039)(publicKey, ...(0, $974356314552bbc8$export$b14ad400b1d09e0f)));
    (0, $1028636d784f9436$export$41a67f89f6678b35)(publicKey, "ECDH");
    if (!(0, $33a16233ac4f7c55$export$600b5603bbac4c6)(privateKey)) throw new TypeError((0, $7c1fe397db20d285$export$2e2bcd8739ae039)(privateKey, ...(0, $974356314552bbc8$export$b14ad400b1d09e0f)));
    (0, $1028636d784f9436$export$41a67f89f6678b35)(privateKey, "ECDH", "deriveBits");
    const value = (0, $615a589604068301$export$ee1b3e54f0441b22)((0, $615a589604068301$export$c1498c4a3718d967)((0, $615a589604068301$export$5486af06137bf21a).encode(algorithm)), (0, $615a589604068301$export$c1498c4a3718d967)(apu), (0, $615a589604068301$export$c1498c4a3718d967)(apv), (0, $615a589604068301$export$74c16dba6c885532)(keyLength));
    let length;
    if (publicKey.algorithm.name === "X25519") length = 256;
    else if (publicKey.algorithm.name === "X448") length = 448;
    else length = Math.ceil(parseInt(publicKey.algorithm.namedCurve.substr(-3), 10) / 8) << 3;
    const sharedSecret = new Uint8Array(await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.deriveBits({
        name: publicKey.algorithm.name,
        public: publicKey
    }, privateKey, length));
    return (0, $615a589604068301$export$67163693c21af44f)(sharedSecret, keyLength, value);
}
async function $ba8b0aeef6c47263$export$1338dee8c889e310(key) {
    if (!(0, $33a16233ac4f7c55$export$600b5603bbac4c6)(key)) throw new TypeError((0, $7c1fe397db20d285$export$2e2bcd8739ae039)(key, ...(0, $974356314552bbc8$export$b14ad400b1d09e0f)));
    return (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.generateKey(key.algorithm, true, [
        "deriveBits"
    ]);
}
function $ba8b0aeef6c47263$export$f28ab77d793719b2(key) {
    if (!(0, $33a16233ac4f7c55$export$600b5603bbac4c6)(key)) throw new TypeError((0, $7c1fe397db20d285$export$2e2bcd8739ae039)(key, ...(0, $974356314552bbc8$export$b14ad400b1d09e0f)));
    return [
        "P-256",
        "P-384",
        "P-521"
    ].includes(key.algorithm.namedCurve) || key.algorithm.name === "X25519" || key.algorithm.name === "X448";
}







function $1f3536ee78871bbd$export$2e2bcd8739ae039(p2s) {
    if (!(p2s instanceof Uint8Array) || p2s.length < 8) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("PBES2 Salt Input must be 8 or more octets");
}






function $a874dffc129d670f$var$getCryptoKey(key, alg) {
    if (key instanceof Uint8Array) return (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.importKey("raw", key, "PBKDF2", false, [
        "deriveBits"
    ]);
    if ((0, $33a16233ac4f7c55$export$600b5603bbac4c6)(key)) {
        (0, $1028636d784f9436$export$41a67f89f6678b35)(key, alg, "deriveBits", "deriveKey");
        return key;
    }
    throw new TypeError((0, $7c1fe397db20d285$export$2e2bcd8739ae039)(key, ...(0, $974356314552bbc8$export$b14ad400b1d09e0f), "Uint8Array"));
}
async function $a874dffc129d670f$var$deriveKey(p2s, alg, p2c, key) {
    (0, $1f3536ee78871bbd$export$2e2bcd8739ae039)(p2s);
    const salt = (0, $615a589604068301$export$256d3ca12372f112)(alg, p2s);
    const keylen = parseInt(alg.slice(13, 16), 10);
    const subtleAlg = {
        hash: `SHA-${alg.slice(8, 11)}`,
        iterations: p2c,
        name: "PBKDF2",
        salt: salt
    };
    const wrapAlg = {
        length: keylen,
        name: "AES-KW"
    };
    const cryptoKey = await $a874dffc129d670f$var$getCryptoKey(key, alg);
    if (cryptoKey.usages.includes("deriveBits")) return new Uint8Array(await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.deriveBits(subtleAlg, cryptoKey, keylen));
    if (cryptoKey.usages.includes("deriveKey")) return (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.deriveKey(subtleAlg, cryptoKey, wrapAlg, false, [
        "wrapKey",
        "unwrapKey"
    ]);
    throw new TypeError('PBKDF2 key "usages" must include "deriveBits" or "deriveKey"');
}
const $a874dffc129d670f$export$5b0f6292f11d1d18 = async (alg, key, cek, p2c = 2048, p2s = (0, $b68e3f962456fa36$export$2e2bcd8739ae039)(new Uint8Array(16)))=>{
    const derived = await $a874dffc129d670f$var$deriveKey(p2s, alg, p2c, key);
    const encryptedKey = await (0, $3094dab5ef792645$export$4997ffc0176396a6)(alg.slice(-6), derived, cek);
    return {
        encryptedKey: encryptedKey,
        p2c: p2c,
        p2s: (0, $033bcccb44f8a8b5$export$c564cdbbe6da493)(p2s)
    };
};
const $a874dffc129d670f$export$e85a0c9a1067c5d3 = async (alg, key, encryptedKey, p2c, p2s)=>{
    const derived = await $a874dffc129d670f$var$deriveKey(p2s, alg, p2c, key);
    return (0, $3094dab5ef792645$export$debb760848ca95a)(alg.slice(-6), derived, encryptedKey);
};



function $4d5e6226bcde39cb$export$2e2bcd8739ae039(alg) {
    switch(alg){
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            return "RSA-OAEP";
        default:
            throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)(`alg ${alg} is not supported either by JOSE or your javascript runtime`);
    }
}





var $d54a6598b64741e7$export$2e2bcd8739ae039 = (alg, key)=>{
    if (alg.startsWith("RS") || alg.startsWith("PS")) {
        const { modulusLength: modulusLength } = key.algorithm;
        if (typeof modulusLength !== "number" || modulusLength < 2048) throw new TypeError(`${alg} requires key modulusLength to be 2048 bits or larger`);
    }
};




const $bbb33ee555688b3b$export$5b0f6292f11d1d18 = async (alg, key, cek)=>{
    if (!(0, $33a16233ac4f7c55$export$600b5603bbac4c6)(key)) throw new TypeError((0, $7c1fe397db20d285$export$2e2bcd8739ae039)(key, ...(0, $974356314552bbc8$export$b14ad400b1d09e0f)));
    (0, $1028636d784f9436$export$41a67f89f6678b35)(key, alg, "encrypt", "wrapKey");
    (0, $d54a6598b64741e7$export$2e2bcd8739ae039)(alg, key);
    if (key.usages.includes("encrypt")) return new Uint8Array(await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.encrypt((0, $4d5e6226bcde39cb$export$2e2bcd8739ae039)(alg), key, cek));
    if (key.usages.includes("wrapKey")) {
        const cryptoKeyCek = await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.importKey("raw", cek, ...(0, $d0900a2cd9174c2e$export$2e2bcd8739ae039));
        return new Uint8Array(await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.wrapKey("raw", cryptoKeyCek, key, (0, $4d5e6226bcde39cb$export$2e2bcd8739ae039)(alg)));
    }
    throw new TypeError('RSA-OAEP key "usages" must include "encrypt" or "wrapKey" for this operation');
};
const $bbb33ee555688b3b$export$e85a0c9a1067c5d3 = async (alg, key, encryptedKey)=>{
    if (!(0, $33a16233ac4f7c55$export$600b5603bbac4c6)(key)) throw new TypeError((0, $7c1fe397db20d285$export$2e2bcd8739ae039)(key, ...(0, $974356314552bbc8$export$b14ad400b1d09e0f)));
    (0, $1028636d784f9436$export$41a67f89f6678b35)(key, alg, "decrypt", "unwrapKey");
    (0, $d54a6598b64741e7$export$2e2bcd8739ae039)(alg, key);
    if (key.usages.includes("decrypt")) return new Uint8Array(await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.decrypt((0, $4d5e6226bcde39cb$export$2e2bcd8739ae039)(alg), key, encryptedKey));
    if (key.usages.includes("unwrapKey")) {
        const cryptoKeyCek = await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.unwrapKey("raw", encryptedKey, key, (0, $4d5e6226bcde39cb$export$2e2bcd8739ae039)(alg), ...(0, $d0900a2cd9174c2e$export$2e2bcd8739ae039));
        return new Uint8Array(await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.exportKey("raw", cryptoKeyCek));
    }
    throw new TypeError('RSA-OAEP key "usages" must include "decrypt" or "unwrapKey" for this operation');
};






function $c7571d8e6fd96313$export$db433e85ac514a95(alg) {
    switch(alg){
        case "A128GCM":
            return 128;
        case "A192GCM":
            return 192;
        case "A256GCM":
        case "A128CBC-HS256":
            return 256;
        case "A192CBC-HS384":
            return 384;
        case "A256CBC-HS512":
            return 512;
        default:
            throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)(`Unsupported JWE Algorithm: ${alg}`);
    }
}
var $c7571d8e6fd96313$export$2e2bcd8739ae039 = (alg)=>(0, $b68e3f962456fa36$export$2e2bcd8739ae039)(new Uint8Array($c7571d8e6fd96313$export$db433e85ac514a95(alg) >> 3));






var $3abab953c071c1cd$export$2e2bcd8739ae039 = (b64, descriptor)=>{
    const newlined = (b64.match(/.{1,64}/g) || []).join("\n");
    return `-----BEGIN ${descriptor}-----\n${newlined}\n-----END ${descriptor}-----`;
};




const $5cc0bded5bc6cfb0$var$genericExport = async (keyType, keyFormat, key)=>{
    if (!(0, $33a16233ac4f7c55$export$600b5603bbac4c6)(key)) throw new TypeError((0, $7c1fe397db20d285$export$2e2bcd8739ae039)(key, ...(0, $974356314552bbc8$export$b14ad400b1d09e0f)));
    if (!key.extractable) throw new TypeError("CryptoKey is not extractable");
    if (key.type !== keyType) throw new TypeError(`key is not a ${keyType} key`);
    return (0, $3abab953c071c1cd$export$2e2bcd8739ae039)((0, $033bcccb44f8a8b5$export$8fb536984ec8b4d7)(new Uint8Array(await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.exportKey(keyFormat, key))), `${keyType.toUpperCase()} KEY`);
};
const $5cc0bded5bc6cfb0$export$cfba7e924fe414ca = (key)=>{
    return $5cc0bded5bc6cfb0$var$genericExport("public", "spki", key);
};
const $5cc0bded5bc6cfb0$export$cac76a78a90b914d = (key)=>{
    return $5cc0bded5bc6cfb0$var$genericExport("private", "pkcs8", key);
};
const $5cc0bded5bc6cfb0$var$findOid = (keyData, oid, from = 0)=>{
    if (from === 0) {
        oid.unshift(oid.length);
        oid.unshift(0x06);
    }
    let i = keyData.indexOf(oid[0], from);
    if (i === -1) return false;
    const sub = keyData.subarray(i, i + oid.length);
    if (sub.length !== oid.length) return false;
    return sub.every((value, index)=>value === oid[index]) || $5cc0bded5bc6cfb0$var$findOid(keyData, oid, i + 1);
};
const $5cc0bded5bc6cfb0$var$getNamedCurve = (keyData)=>{
    switch(true){
        case $5cc0bded5bc6cfb0$var$findOid(keyData, [
            0x2a,
            0x86,
            0x48,
            0xce,
            0x3d,
            0x03,
            0x01,
            0x07
        ]):
            return "P-256";
        case $5cc0bded5bc6cfb0$var$findOid(keyData, [
            0x2b,
            0x81,
            0x04,
            0x00,
            0x22
        ]):
            return "P-384";
        case $5cc0bded5bc6cfb0$var$findOid(keyData, [
            0x2b,
            0x81,
            0x04,
            0x00,
            0x23
        ]):
            return "P-521";
        case $5cc0bded5bc6cfb0$var$findOid(keyData, [
            0x2b,
            0x65,
            0x6e
        ]):
            return "X25519";
        case $5cc0bded5bc6cfb0$var$findOid(keyData, [
            0x2b,
            0x65,
            0x6f
        ]):
            return "X448";
        case $5cc0bded5bc6cfb0$var$findOid(keyData, [
            0x2b,
            0x65,
            0x70
        ]):
            return "Ed25519";
        case $5cc0bded5bc6cfb0$var$findOid(keyData, [
            0x2b,
            0x65,
            0x71
        ]):
            return "Ed448";
        default:
            throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)("Invalid or unsupported EC Key Curve or OKP Key Sub Type");
    }
};
const $5cc0bded5bc6cfb0$var$genericImport = async (replace, keyFormat, pem, alg, options)=>{
    var _a;
    let algorithm;
    let keyUsages;
    const keyData = new Uint8Array(atob(pem.replace(replace, "")).split("").map((c)=>c.charCodeAt(0)));
    const isPublic = keyFormat === "spki";
    switch(alg){
        case "PS256":
        case "PS384":
        case "PS512":
            algorithm = {
                name: "RSA-PSS",
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "RS256":
        case "RS384":
        case "RS512":
            algorithm = {
                name: "RSASSA-PKCS1-v1_5",
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            algorithm = {
                name: "RSA-OAEP",
                hash: `SHA-${parseInt(alg.slice(-3), 10) || 1}`
            };
            keyUsages = isPublic ? [
                "encrypt",
                "wrapKey"
            ] : [
                "decrypt",
                "unwrapKey"
            ];
            break;
        case "ES256":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-256"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ES384":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-384"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ES512":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-521"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                const namedCurve = $5cc0bded5bc6cfb0$var$getNamedCurve(keyData);
                algorithm = namedCurve.startsWith("P-") ? {
                    name: "ECDH",
                    namedCurve: namedCurve
                } : {
                    name: namedCurve
                };
                keyUsages = isPublic ? [] : [
                    "deriveBits"
                ];
                break;
            }
        case "EdDSA":
            algorithm = {
                name: $5cc0bded5bc6cfb0$var$getNamedCurve(keyData)
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        default:
            throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)('Invalid or unsupported "alg" (Algorithm) value');
    }
    return (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.importKey(keyFormat, keyData, algorithm, (_a = options === null || options === void 0 ? void 0 : options.extractable) !== null && _a !== void 0 ? _a : false, keyUsages);
};
const $5cc0bded5bc6cfb0$export$224b0a6339c7267f = (pem, alg, options)=>{
    return $5cc0bded5bc6cfb0$var$genericImport(/(?:-----(?:BEGIN|END) PRIVATE KEY-----|\s)/g, "pkcs8", pem, alg, options);
};
const $5cc0bded5bc6cfb0$export$f9a3505cdaa1fb3e = (pem, alg, options)=>{
    return $5cc0bded5bc6cfb0$var$genericImport(/(?:-----(?:BEGIN|END) PUBLIC KEY-----|\s)/g, "spki", pem, alg, options);
};
function $5cc0bded5bc6cfb0$var$getElement(seq) {
    let result = [];
    let next = 0;
    while(next < seq.length){
        let nextPart = $5cc0bded5bc6cfb0$var$parseElement(seq.subarray(next));
        result.push(nextPart);
        next += nextPart.byteLength;
    }
    return result;
}
function $5cc0bded5bc6cfb0$var$parseElement(bytes) {
    let position = 0;
    let tag = bytes[0] & 0x1f;
    position++;
    if (tag === 0x1f) {
        tag = 0;
        while(bytes[position] >= 0x80){
            tag = tag * 128 + bytes[position] - 0x80;
            position++;
        }
        tag = tag * 128 + bytes[position] - 0x80;
        position++;
    }
    let length = 0;
    if (bytes[position] < 0x80) {
        length = bytes[position];
        position++;
    } else if (length === 0x80) {
        length = 0;
        while(bytes[position + length] !== 0 || bytes[position + length + 1] !== 0){
            if (length > bytes.byteLength) throw new TypeError("invalid indefinite form length");
            length++;
        }
        const byteLength = position + length + 2;
        return {
            byteLength: byteLength,
            contents: bytes.subarray(position, position + length),
            raw: bytes.subarray(0, byteLength)
        };
    } else {
        let numberOfDigits = bytes[position] & 0x7f;
        position++;
        length = 0;
        for(let i = 0; i < numberOfDigits; i++){
            length = length * 256 + bytes[position];
            position++;
        }
    }
    const byteLength = position + length;
    return {
        byteLength: byteLength,
        contents: bytes.subarray(position, byteLength),
        raw: bytes.subarray(0, byteLength)
    };
}
function $5cc0bded5bc6cfb0$var$spkiFromX509(buf) {
    const tbsCertificate = $5cc0bded5bc6cfb0$var$getElement($5cc0bded5bc6cfb0$var$getElement($5cc0bded5bc6cfb0$var$parseElement(buf).contents)[0].contents);
    return (0, $033bcccb44f8a8b5$export$8fb536984ec8b4d7)(tbsCertificate[tbsCertificate[0].raw[0] === 0xa0 ? 6 : 5].raw);
}
function $5cc0bded5bc6cfb0$var$getSPKI(x509) {
    const pem = x509.replace(/(?:-----(?:BEGIN|END) CERTIFICATE-----|\s)/g, "");
    const raw = (0, $033bcccb44f8a8b5$export$94fdf11bafc8de6b)(pem);
    return (0, $3abab953c071c1cd$export$2e2bcd8739ae039)($5cc0bded5bc6cfb0$var$spkiFromX509(raw), "PUBLIC KEY");
}
const $5cc0bded5bc6cfb0$export$ed788b6a8533858f = (pem, alg, options)=>{
    let spki;
    try {
        spki = $5cc0bded5bc6cfb0$var$getSPKI(pem);
    } catch (cause) {
        throw new TypeError("Failed to parse the X.509 certificate", {
            cause: cause
        });
    }
    return $5cc0bded5bc6cfb0$export$f9a3505cdaa1fb3e(spki, alg, options);
};





function $7c989000c3bc9d3c$var$subtleMapping(jwk) {
    let algorithm;
    let keyUsages;
    switch(jwk.kty){
        case "oct":
            switch(jwk.alg){
                case "HS256":
                case "HS384":
                case "HS512":
                    algorithm = {
                        name: "HMAC",
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = [
                        "sign",
                        "verify"
                    ];
                    break;
                case "A128CBC-HS256":
                case "A192CBC-HS384":
                case "A256CBC-HS512":
                    throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)(`${jwk.alg} keys cannot be imported as CryptoKey instances`);
                case "A128GCM":
                case "A192GCM":
                case "A256GCM":
                case "A128GCMKW":
                case "A192GCMKW":
                case "A256GCMKW":
                    algorithm = {
                        name: "AES-GCM"
                    };
                    keyUsages = [
                        "encrypt",
                        "decrypt"
                    ];
                    break;
                case "A128KW":
                case "A192KW":
                case "A256KW":
                    algorithm = {
                        name: "AES-KW"
                    };
                    keyUsages = [
                        "wrapKey",
                        "unwrapKey"
                    ];
                    break;
                case "PBES2-HS256+A128KW":
                case "PBES2-HS384+A192KW":
                case "PBES2-HS512+A256KW":
                    algorithm = {
                        name: "PBKDF2"
                    };
                    keyUsages = [
                        "deriveBits"
                    ];
                    break;
                default:
                    throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case "RSA":
            switch(jwk.alg){
                case "PS256":
                case "PS384":
                case "PS512":
                    algorithm = {
                        name: "RSA-PSS",
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "RS256":
                case "RS384":
                case "RS512":
                    algorithm = {
                        name: "RSASSA-PKCS1-v1_5",
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "RSA-OAEP":
                case "RSA-OAEP-256":
                case "RSA-OAEP-384":
                case "RSA-OAEP-512":
                    algorithm = {
                        name: "RSA-OAEP",
                        hash: `SHA-${parseInt(jwk.alg.slice(-3), 10) || 1}`
                    };
                    keyUsages = jwk.d ? [
                        "decrypt",
                        "unwrapKey"
                    ] : [
                        "encrypt",
                        "wrapKey"
                    ];
                    break;
                default:
                    throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case "EC":
            switch(jwk.alg){
                case "ES256":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-256"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ES384":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-384"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ES512":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-521"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ECDH-ES":
                case "ECDH-ES+A128KW":
                case "ECDH-ES+A192KW":
                case "ECDH-ES+A256KW":
                    algorithm = {
                        name: "ECDH",
                        namedCurve: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "deriveBits"
                    ] : [];
                    break;
                default:
                    throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case "OKP":
            switch(jwk.alg){
                case "EdDSA":
                    algorithm = {
                        name: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ECDH-ES":
                case "ECDH-ES+A128KW":
                case "ECDH-ES+A192KW":
                case "ECDH-ES+A256KW":
                    algorithm = {
                        name: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "deriveBits"
                    ] : [];
                    break;
                default:
                    throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        default:
            throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
    }
    return {
        algorithm: algorithm,
        keyUsages: keyUsages
    };
}
const $7c989000c3bc9d3c$var$parse = async (jwk)=>{
    var _a, _b;
    if (!jwk.alg) throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
    const { algorithm: algorithm, keyUsages: keyUsages } = $7c989000c3bc9d3c$var$subtleMapping(jwk);
    const rest = [
        algorithm,
        (_a = jwk.ext) !== null && _a !== void 0 ? _a : false,
        (_b = jwk.key_ops) !== null && _b !== void 0 ? _b : keyUsages
    ];
    if (algorithm.name === "PBKDF2") return (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.importKey("raw", (0, $033bcccb44f8a8b5$export$2f872c0f2117be69)(jwk.k), ...rest);
    const keyData = {
        ...jwk
    };
    delete keyData.alg;
    delete keyData.use;
    return (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.importKey("jwk", keyData, ...rest);
};
var $7c989000c3bc9d3c$export$2e2bcd8739ae039 = $7c989000c3bc9d3c$var$parse;




async function $9944bc715090102a$export$7cdfc961c11d0266(spki, alg, options) {
    if (typeof spki !== "string" || spki.indexOf("-----BEGIN PUBLIC KEY-----") !== 0) throw new TypeError('"spki" must be SPKI formatted string');
    return (0, $5cc0bded5bc6cfb0$export$f9a3505cdaa1fb3e)(spki, alg, options);
}
async function $9944bc715090102a$export$948757ecbbf4a918(x509, alg, options) {
    if (typeof x509 !== "string" || x509.indexOf("-----BEGIN CERTIFICATE-----") !== 0) throw new TypeError('"x509" must be X.509 formatted string');
    return (0, $5cc0bded5bc6cfb0$export$ed788b6a8533858f)(x509, alg, options);
}
async function $9944bc715090102a$export$17f5e7f6d2848df5(pkcs8, alg, options) {
    if (typeof pkcs8 !== "string" || pkcs8.indexOf("-----BEGIN PRIVATE KEY-----") !== 0) throw new TypeError('"pkcs8" must be PKCS#8 formatted string');
    return (0, $5cc0bded5bc6cfb0$export$224b0a6339c7267f)(pkcs8, alg, options);
}
async function $9944bc715090102a$export$2b70d37b4d0b888b(jwk, alg, octAsKeyObject) {
    var _a;
    if (!(0, $650ccab004d5778d$export$2e2bcd8739ae039)(jwk)) throw new TypeError("JWK must be an object");
    alg || (alg = jwk.alg);
    switch(jwk.kty){
        case "oct":
            if (typeof jwk.k !== "string" || !jwk.k) throw new TypeError('missing "k" (Key Value) Parameter value');
            octAsKeyObject !== null && octAsKeyObject !== void 0 ? octAsKeyObject : octAsKeyObject = jwk.ext !== true;
            if (octAsKeyObject) return (0, $7c989000c3bc9d3c$export$2e2bcd8739ae039)({
                ...jwk,
                alg: alg,
                ext: (_a = jwk.ext) !== null && _a !== void 0 ? _a : false
            });
            return (0, $033bcccb44f8a8b5$export$2f872c0f2117be69)(jwk.k);
        case "RSA":
            if (jwk.oth !== undefined) throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)('RSA JWK "oth" (Other Primes Info) Parameter value is not supported');
        case "EC":
        case "OKP":
            return (0, $7c989000c3bc9d3c$export$2e2bcd8739ae039)({
                ...jwk,
                alg: alg
            });
        default:
            throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)('Unsupported "kty" (Key Type) Parameter value');
    }
}




const $b8cfe7360b22a960$var$symmetricTypeCheck = (alg, key)=>{
    if (key instanceof Uint8Array) return;
    if (!(0, $974356314552bbc8$export$2e2bcd8739ae039)(key)) throw new TypeError((0, $7c1fe397db20d285$export$e94f758d09bc1828)(alg, key, ...(0, $974356314552bbc8$export$b14ad400b1d09e0f), "Uint8Array"));
    if (key.type !== "secret") throw new TypeError(`${(0, $974356314552bbc8$export$b14ad400b1d09e0f).join(" or ")} instances for symmetric algorithms must be of type "secret"`);
};
const $b8cfe7360b22a960$var$asymmetricTypeCheck = (alg, key, usage)=>{
    if (!(0, $974356314552bbc8$export$2e2bcd8739ae039)(key)) throw new TypeError((0, $7c1fe397db20d285$export$e94f758d09bc1828)(alg, key, ...(0, $974356314552bbc8$export$b14ad400b1d09e0f)));
    if (key.type === "secret") throw new TypeError(`${(0, $974356314552bbc8$export$b14ad400b1d09e0f).join(" or ")} instances for asymmetric algorithms must not be of type "secret"`);
    if (usage === "sign" && key.type === "public") throw new TypeError(`${(0, $974356314552bbc8$export$b14ad400b1d09e0f).join(" or ")} instances for asymmetric algorithm signing must be of type "private"`);
    if (usage === "decrypt" && key.type === "public") throw new TypeError(`${(0, $974356314552bbc8$export$b14ad400b1d09e0f).join(" or ")} instances for asymmetric algorithm decryption must be of type "private"`);
    if (key.algorithm && usage === "verify" && key.type === "private") throw new TypeError(`${(0, $974356314552bbc8$export$b14ad400b1d09e0f).join(" or ")} instances for asymmetric algorithm verifying must be of type "public"`);
    if (key.algorithm && usage === "encrypt" && key.type === "private") throw new TypeError(`${(0, $974356314552bbc8$export$b14ad400b1d09e0f).join(" or ")} instances for asymmetric algorithm encryption must be of type "public"`);
};
const $b8cfe7360b22a960$var$checkKeyType = (alg, key, usage)=>{
    const symmetric = alg.startsWith("HS") || alg === "dir" || alg.startsWith("PBES2") || /^A\d{3}(?:GCM)?KW$/.test(alg);
    if (symmetric) $b8cfe7360b22a960$var$symmetricTypeCheck(alg, key);
    else $b8cfe7360b22a960$var$asymmetricTypeCheck(alg, key, usage);
};
var $b8cfe7360b22a960$export$2e2bcd8739ae039 = $b8cfe7360b22a960$var$checkKeyType;











async function $1f1f83589071ba14$var$cbcEncrypt(enc, plaintext, cek, iv, aad) {
    if (!(cek instanceof Uint8Array)) throw new TypeError((0, $7c1fe397db20d285$export$2e2bcd8739ae039)(cek, "Uint8Array"));
    const keySize = parseInt(enc.slice(1, 4), 10);
    const encKey = await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.importKey("raw", cek.subarray(keySize >> 3), "AES-CBC", false, [
        "encrypt"
    ]);
    const macKey = await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.importKey("raw", cek.subarray(0, keySize >> 3), {
        hash: `SHA-${keySize << 1}`,
        name: "HMAC"
    }, false, [
        "sign"
    ]);
    const ciphertext = new Uint8Array(await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.encrypt({
        iv: iv,
        name: "AES-CBC"
    }, encKey, plaintext));
    const macData = (0, $615a589604068301$export$ee1b3e54f0441b22)(aad, iv, ciphertext, (0, $615a589604068301$export$e7b531e00a18fdd7)(aad.length << 3));
    const tag = new Uint8Array((await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.sign("HMAC", macKey, macData)).slice(0, keySize >> 3));
    return {
        ciphertext: ciphertext,
        tag: tag
    };
}
async function $1f1f83589071ba14$var$gcmEncrypt(enc, plaintext, cek, iv, aad) {
    let encKey;
    if (cek instanceof Uint8Array) encKey = await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.importKey("raw", cek, "AES-GCM", false, [
        "encrypt"
    ]);
    else {
        (0, $1028636d784f9436$export$41a67f89f6678b35)(cek, enc, "encrypt");
        encKey = cek;
    }
    const encrypted = new Uint8Array(await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.encrypt({
        additionalData: aad,
        iv: iv,
        name: "AES-GCM",
        tagLength: 128
    }, encKey, plaintext));
    const tag = encrypted.slice(-16);
    const ciphertext = encrypted.slice(0, -16);
    return {
        ciphertext: ciphertext,
        tag: tag
    };
}
const $1f1f83589071ba14$var$encrypt = async (enc, plaintext, cek, iv, aad)=>{
    if (!(0, $33a16233ac4f7c55$export$600b5603bbac4c6)(cek) && !(cek instanceof Uint8Array)) throw new TypeError((0, $7c1fe397db20d285$export$2e2bcd8739ae039)(cek, ...(0, $974356314552bbc8$export$b14ad400b1d09e0f), "Uint8Array"));
    (0, $49abd97cc1eb20bd$export$2e2bcd8739ae039)(enc, iv);
    switch(enc){
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            if (cek instanceof Uint8Array) (0, $82ada42bd8312473$export$2e2bcd8739ae039)(cek, parseInt(enc.slice(-3), 10));
            return $1f1f83589071ba14$var$cbcEncrypt(enc, plaintext, cek, iv, aad);
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            if (cek instanceof Uint8Array) (0, $82ada42bd8312473$export$2e2bcd8739ae039)(cek, parseInt(enc.slice(1, 4), 10));
            return $1f1f83589071ba14$var$gcmEncrypt(enc, plaintext, cek, iv, aad);
        default:
            throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)("Unsupported JWE Content Encryption Algorithm");
    }
};
var $1f1f83589071ba14$export$2e2bcd8739ae039 = $1f1f83589071ba14$var$encrypt;





async function $369ebf973cc285d8$export$4997ffc0176396a6(alg, key, cek, iv) {
    const jweAlgorithm = alg.slice(0, 7);
    iv || (iv = (0, $f565ffac88c03c90$export$2e2bcd8739ae039)(jweAlgorithm));
    const { ciphertext: encryptedKey, tag: tag } = await (0, $1f1f83589071ba14$export$2e2bcd8739ae039)(jweAlgorithm, cek, key, iv, new Uint8Array(0));
    return {
        encryptedKey: encryptedKey,
        iv: (0, $033bcccb44f8a8b5$export$c564cdbbe6da493)(iv),
        tag: (0, $033bcccb44f8a8b5$export$c564cdbbe6da493)(tag)
    };
}
async function $369ebf973cc285d8$export$debb760848ca95a(alg, key, encryptedKey, iv, tag) {
    const jweAlgorithm = alg.slice(0, 7);
    return (0, $de46c37ae41de88c$export$2e2bcd8739ae039)(jweAlgorithm, key, encryptedKey, iv, tag, new Uint8Array(0));
}


async function $fa674119b378dadf$var$decryptKeyManagement(alg, key, encryptedKey, joseHeader, options) {
    (0, $b8cfe7360b22a960$export$2e2bcd8739ae039)(alg, key, "decrypt");
    switch(alg){
        case "dir":
            if (encryptedKey !== undefined) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("Encountered unexpected JWE Encrypted Key");
            return key;
        case "ECDH-ES":
            if (encryptedKey !== undefined) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("Encountered unexpected JWE Encrypted Key");
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                if (!(0, $650ccab004d5778d$export$2e2bcd8739ae039)(joseHeader.epk)) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)(`JOSE Header "epk" (Ephemeral Public Key) missing or invalid`);
                if (!$ba8b0aeef6c47263$export$f28ab77d793719b2(key)) throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)("ECDH with the provided key is not allowed or not supported by your javascript runtime");
                const epk = await (0, $9944bc715090102a$export$2b70d37b4d0b888b)(joseHeader.epk, alg);
                let partyUInfo;
                let partyVInfo;
                if (joseHeader.apu !== undefined) {
                    if (typeof joseHeader.apu !== "string") throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)(`JOSE Header "apu" (Agreement PartyUInfo) invalid`);
                    try {
                        partyUInfo = (0, $033bcccb44f8a8b5$export$2f872c0f2117be69)(joseHeader.apu);
                    } catch (_a) {
                        throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("Failed to base64url decode the apu");
                    }
                }
                if (joseHeader.apv !== undefined) {
                    if (typeof joseHeader.apv !== "string") throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)(`JOSE Header "apv" (Agreement PartyVInfo) invalid`);
                    try {
                        partyVInfo = (0, $033bcccb44f8a8b5$export$2f872c0f2117be69)(joseHeader.apv);
                    } catch (_b) {
                        throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("Failed to base64url decode the apv");
                    }
                }
                const sharedSecret = await $ba8b0aeef6c47263$export$87770b6b245073b5(epk, key, alg === "ECDH-ES" ? joseHeader.enc : alg, alg === "ECDH-ES" ? (0, $c7571d8e6fd96313$export$db433e85ac514a95)(joseHeader.enc) : parseInt(alg.slice(-5, -2), 10), partyUInfo, partyVInfo);
                if (alg === "ECDH-ES") return sharedSecret;
                if (encryptedKey === undefined) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("JWE Encrypted Key missing");
                return (0, $3094dab5ef792645$export$debb760848ca95a)(alg.slice(-6), sharedSecret, encryptedKey);
            }
        case "RSA1_5":
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            if (encryptedKey === undefined) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("JWE Encrypted Key missing");
            return (0, $bbb33ee555688b3b$export$e85a0c9a1067c5d3)(alg, key, encryptedKey);
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            {
                if (encryptedKey === undefined) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("JWE Encrypted Key missing");
                if (typeof joseHeader.p2c !== "number") throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)(`JOSE Header "p2c" (PBES2 Count) missing or invalid`);
                const p2cLimit = (options === null || options === void 0 ? void 0 : options.maxPBES2Count) || 10000;
                if (joseHeader.p2c > p2cLimit) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)(`JOSE Header "p2c" (PBES2 Count) out is of acceptable bounds`);
                if (typeof joseHeader.p2s !== "string") throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)(`JOSE Header "p2s" (PBES2 Salt) missing or invalid`);
                let p2s;
                try {
                    p2s = (0, $033bcccb44f8a8b5$export$2f872c0f2117be69)(joseHeader.p2s);
                } catch (_c) {
                    throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("Failed to base64url decode the p2s");
                }
                return (0, $a874dffc129d670f$export$e85a0c9a1067c5d3)(alg, key, encryptedKey, joseHeader.p2c, p2s);
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            if (encryptedKey === undefined) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("JWE Encrypted Key missing");
            return (0, $3094dab5ef792645$export$debb760848ca95a)(alg, key, encryptedKey);
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
            {
                if (encryptedKey === undefined) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("JWE Encrypted Key missing");
                if (typeof joseHeader.iv !== "string") throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)(`JOSE Header "iv" (Initialization Vector) missing or invalid`);
                if (typeof joseHeader.tag !== "string") throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)(`JOSE Header "tag" (Authentication Tag) missing or invalid`);
                let iv;
                try {
                    iv = (0, $033bcccb44f8a8b5$export$2f872c0f2117be69)(joseHeader.iv);
                } catch (_d) {
                    throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("Failed to base64url decode the iv");
                }
                let tag;
                try {
                    tag = (0, $033bcccb44f8a8b5$export$2f872c0f2117be69)(joseHeader.tag);
                } catch (_e) {
                    throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("Failed to base64url decode the tag");
                }
                return (0, $369ebf973cc285d8$export$debb760848ca95a)(alg, key, encryptedKey, iv, tag);
            }
        default:
            throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)('Invalid or unsupported "alg" (JWE Algorithm) header value');
    }
}
var $fa674119b378dadf$export$2e2bcd8739ae039 = $fa674119b378dadf$var$decryptKeyManagement;





function $415d99021769b108$var$validateCrit(Err, recognizedDefault, recognizedOption, protectedHeader, joseHeader) {
    if (joseHeader.crit !== undefined && protectedHeader.crit === undefined) throw new Err('"crit" (Critical) Header Parameter MUST be integrity protected');
    if (!protectedHeader || protectedHeader.crit === undefined) return new Set();
    if (!Array.isArray(protectedHeader.crit) || protectedHeader.crit.length === 0 || protectedHeader.crit.some((input)=>typeof input !== "string" || input.length === 0)) throw new Err('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
    let recognized;
    if (recognizedOption !== undefined) recognized = new Map([
        ...Object.entries(recognizedOption),
        ...recognizedDefault.entries()
    ]);
    else recognized = recognizedDefault;
    for (const parameter of protectedHeader.crit){
        if (!recognized.has(parameter)) throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)(`Extension Header Parameter "${parameter}" is not recognized`);
        if (joseHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" is missing`);
        else if (recognized.get(parameter) && protectedHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" MUST be integrity protected`);
    }
    return new Set(protectedHeader.crit);
}
var $415d99021769b108$export$2e2bcd8739ae039 = $415d99021769b108$var$validateCrit;


const $d58be98cc14cc4a2$var$validateAlgorithms = (option, algorithms)=>{
    if (algorithms !== undefined && (!Array.isArray(algorithms) || algorithms.some((s)=>typeof s !== "string"))) throw new TypeError(`"${option}" option must be an array of strings`);
    if (!algorithms) return undefined;
    return new Set(algorithms);
};
var $d58be98cc14cc4a2$export$2e2bcd8739ae039 = $d58be98cc14cc4a2$var$validateAlgorithms;


async function $d1904d2d7b2f147c$export$b75cd12892ae94d2(jwe, key, options) {
    var _a;
    if (!(0, $650ccab004d5778d$export$2e2bcd8739ae039)(jwe)) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("Flattened JWE must be an object");
    if (jwe.protected === undefined && jwe.header === undefined && jwe.unprotected === undefined) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("JOSE Header missing");
    if (typeof jwe.iv !== "string") throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("JWE Initialization Vector missing or incorrect type");
    if (typeof jwe.ciphertext !== "string") throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("JWE Ciphertext missing or incorrect type");
    if (typeof jwe.tag !== "string") throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("JWE Authentication Tag missing or incorrect type");
    if (jwe.protected !== undefined && typeof jwe.protected !== "string") throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("JWE Protected Header incorrect type");
    if (jwe.encrypted_key !== undefined && typeof jwe.encrypted_key !== "string") throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("JWE Encrypted Key incorrect type");
    if (jwe.aad !== undefined && typeof jwe.aad !== "string") throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("JWE AAD incorrect type");
    if (jwe.header !== undefined && !(0, $650ccab004d5778d$export$2e2bcd8739ae039)(jwe.header)) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("JWE Shared Unprotected Header incorrect type");
    if (jwe.unprotected !== undefined && !(0, $650ccab004d5778d$export$2e2bcd8739ae039)(jwe.unprotected)) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("JWE Per-Recipient Unprotected Header incorrect type");
    let parsedProt;
    if (jwe.protected) try {
        const protectedHeader = (0, $033bcccb44f8a8b5$export$2f872c0f2117be69)(jwe.protected);
        parsedProt = JSON.parse((0, $615a589604068301$export$124c96e6ce37090b).decode(protectedHeader));
    } catch (_b) {
        throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("JWE Protected Header is invalid");
    }
    if (!(0, $33b5b90a0aee86b8$export$2e2bcd8739ae039)(parsedProt, jwe.header, jwe.unprotected)) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("JWE Protected, JWE Unprotected Header, and JWE Per-Recipient Unprotected Header Parameter names must be disjoint");
    const joseHeader = {
        ...parsedProt,
        ...jwe.header,
        ...jwe.unprotected
    };
    (0, $415d99021769b108$export$2e2bcd8739ae039)((0, $1e405ee376479e7e$export$19f281f2275f6a15), new Map(), options === null || options === void 0 ? void 0 : options.crit, parsedProt, joseHeader);
    if (joseHeader.zip !== undefined) {
        if (!parsedProt || !parsedProt.zip) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)('JWE "zip" (Compression Algorithm) Header MUST be integrity protected');
        if (joseHeader.zip !== "DEF") throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)('Unsupported JWE "zip" (Compression Algorithm) Header Parameter value');
    }
    const { alg: alg, enc: enc } = joseHeader;
    if (typeof alg !== "string" || !alg) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("missing JWE Algorithm (alg) in JWE Header");
    if (typeof enc !== "string" || !enc) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("missing JWE Encryption Algorithm (enc) in JWE Header");
    const keyManagementAlgorithms = options && (0, $d58be98cc14cc4a2$export$2e2bcd8739ae039)("keyManagementAlgorithms", options.keyManagementAlgorithms);
    const contentEncryptionAlgorithms = options && (0, $d58be98cc14cc4a2$export$2e2bcd8739ae039)("contentEncryptionAlgorithms", options.contentEncryptionAlgorithms);
    if (keyManagementAlgorithms && !keyManagementAlgorithms.has(alg)) throw new (0, $1e405ee376479e7e$export$d51fd7fedeccc338)('"alg" (Algorithm) Header Parameter not allowed');
    if (contentEncryptionAlgorithms && !contentEncryptionAlgorithms.has(enc)) throw new (0, $1e405ee376479e7e$export$d51fd7fedeccc338)('"enc" (Encryption Algorithm) Header Parameter not allowed');
    let encryptedKey;
    if (jwe.encrypted_key !== undefined) try {
        encryptedKey = (0, $033bcccb44f8a8b5$export$2f872c0f2117be69)(jwe.encrypted_key);
    } catch (_c) {
        throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("Failed to base64url decode the encrypted_key");
    }
    let resolvedKey = false;
    if (typeof key === "function") {
        key = await key(parsedProt, jwe);
        resolvedKey = true;
    }
    let cek;
    try {
        cek = await (0, $fa674119b378dadf$export$2e2bcd8739ae039)(alg, key, encryptedKey, joseHeader, options);
    } catch (err) {
        if (err instanceof TypeError || err instanceof (0, $1e405ee376479e7e$export$19f281f2275f6a15) || err instanceof (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)) throw err;
        cek = (0, $c7571d8e6fd96313$export$2e2bcd8739ae039)(enc);
    }
    let iv;
    let tag;
    try {
        iv = (0, $033bcccb44f8a8b5$export$2f872c0f2117be69)(jwe.iv);
    } catch (_d) {
        throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("Failed to base64url decode the iv");
    }
    try {
        tag = (0, $033bcccb44f8a8b5$export$2f872c0f2117be69)(jwe.tag);
    } catch (_e) {
        throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("Failed to base64url decode the tag");
    }
    const protectedHeader = (0, $615a589604068301$export$5486af06137bf21a).encode((_a = jwe.protected) !== null && _a !== void 0 ? _a : "");
    let additionalData;
    if (jwe.aad !== undefined) additionalData = (0, $615a589604068301$export$ee1b3e54f0441b22)(protectedHeader, (0, $615a589604068301$export$5486af06137bf21a).encode("."), (0, $615a589604068301$export$5486af06137bf21a).encode(jwe.aad));
    else additionalData = protectedHeader;
    let ciphertext;
    try {
        ciphertext = (0, $033bcccb44f8a8b5$export$2f872c0f2117be69)(jwe.ciphertext);
    } catch (_f) {
        throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("Failed to base64url decode the ciphertext");
    }
    let plaintext = await (0, $de46c37ae41de88c$export$2e2bcd8739ae039)(enc, cek, ciphertext, iv, tag, additionalData);
    if (joseHeader.zip === "DEF") plaintext = await ((options === null || options === void 0 ? void 0 : options.inflateRaw) || (0, $99bffc79943d043d$export$cae1ce83fe4a1782))(plaintext);
    const result = {
        plaintext: plaintext
    };
    if (jwe.protected !== undefined) result.protectedHeader = parsedProt;
    if (jwe.aad !== undefined) try {
        result.additionalAuthenticatedData = (0, $033bcccb44f8a8b5$export$2f872c0f2117be69)(jwe.aad);
    } catch (_g) {
        throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("Failed to base64url decode the aad");
    }
    if (jwe.unprotected !== undefined) result.sharedUnprotectedHeader = jwe.unprotected;
    if (jwe.header !== undefined) result.unprotectedHeader = jwe.header;
    if (resolvedKey) return {
        ...result,
        key: key
    };
    return result;
}




async function $0f2a276e78e6d6cc$export$c9a8efe6bfd872ce(jwe, key, options) {
    if (jwe instanceof Uint8Array) jwe = (0, $615a589604068301$export$124c96e6ce37090b).decode(jwe);
    if (typeof jwe !== "string") throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("Compact JWE must be a string or Uint8Array");
    const { 0: protectedHeader, 1: encryptedKey, 2: iv, 3: ciphertext, 4: tag, length: length } = jwe.split(".");
    if (length !== 5) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("Invalid Compact JWE");
    const decrypted = await (0, $d1904d2d7b2f147c$export$b75cd12892ae94d2)({
        ciphertext: ciphertext,
        iv: iv || undefined,
        protected: protectedHeader || undefined,
        tag: tag || undefined,
        encrypted_key: encryptedKey || undefined
    }, key, options);
    const result = {
        plaintext: decrypted.plaintext,
        protectedHeader: decrypted.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: decrypted.key
    };
    return result;
}






async function $517e3573a6a0b187$export$56bc728c88264430(jwe, key, options) {
    if (!(0, $650ccab004d5778d$export$2e2bcd8739ae039)(jwe)) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("General JWE must be an object");
    if (!Array.isArray(jwe.recipients) || !jwe.recipients.every((0, $650ccab004d5778d$export$2e2bcd8739ae039))) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("JWE Recipients missing or incorrect type");
    if (!jwe.recipients.length) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("JWE Recipients has no members");
    for (const recipient of jwe.recipients)try {
        return await (0, $d1904d2d7b2f147c$export$b75cd12892ae94d2)({
            aad: jwe.aad,
            ciphertext: jwe.ciphertext,
            encrypted_key: recipient.encrypted_key,
            header: recipient.header,
            iv: jwe.iv,
            protected: jwe.protected,
            tag: jwe.tag,
            unprotected: jwe.unprotected
        }, key, options);
    } catch (_a) {}
    throw new (0, $1e405ee376479e7e$export$1a57512ad9773b2a)();
}


















const $0d540ce9d31e526f$var$keyToJWK = async (key)=>{
    if (key instanceof Uint8Array) return {
        kty: "oct",
        k: (0, $033bcccb44f8a8b5$export$c564cdbbe6da493)(key)
    };
    if (!(0, $33a16233ac4f7c55$export$600b5603bbac4c6)(key)) throw new TypeError((0, $7c1fe397db20d285$export$2e2bcd8739ae039)(key, ...(0, $974356314552bbc8$export$b14ad400b1d09e0f), "Uint8Array"));
    if (!key.extractable) throw new TypeError("non-extractable CryptoKey cannot be exported as a JWK");
    const { ext: ext, key_ops: key_ops, alg: alg, use: use, ...jwk } = await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.exportKey("jwk", key);
    return jwk;
};
var $0d540ce9d31e526f$export$2e2bcd8739ae039 = $0d540ce9d31e526f$var$keyToJWK;


async function $4a866014613178cb$export$7f687badbeed246d(key) {
    return (0, $5cc0bded5bc6cfb0$export$cfba7e924fe414ca)(key);
}
async function $4a866014613178cb$export$ba4a7192ac1a47fe(key) {
    return (0, $5cc0bded5bc6cfb0$export$cac76a78a90b914d)(key);
}
async function $4a866014613178cb$export$ffb510cfd482ce82(key) {
    return (0, $0d540ce9d31e526f$export$2e2bcd8739ae039)(key);
}




async function $f44a3a23141d820e$var$encryptKeyManagement(alg, enc, key, providedCek, providedParameters = {}) {
    let encryptedKey;
    let parameters;
    let cek;
    (0, $b8cfe7360b22a960$export$2e2bcd8739ae039)(alg, key, "encrypt");
    switch(alg){
        case "dir":
            cek = key;
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                if (!$ba8b0aeef6c47263$export$f28ab77d793719b2(key)) throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)("ECDH with the provided key is not allowed or not supported by your javascript runtime");
                const { apu: apu, apv: apv } = providedParameters;
                let { epk: ephemeralKey } = providedParameters;
                ephemeralKey || (ephemeralKey = (await $ba8b0aeef6c47263$export$1338dee8c889e310(key)).privateKey);
                const { x: x, y: y, crv: crv, kty: kty } = await (0, $4a866014613178cb$export$ffb510cfd482ce82)(ephemeralKey);
                const sharedSecret = await $ba8b0aeef6c47263$export$87770b6b245073b5(key, ephemeralKey, alg === "ECDH-ES" ? enc : alg, alg === "ECDH-ES" ? (0, $c7571d8e6fd96313$export$db433e85ac514a95)(enc) : parseInt(alg.slice(-5, -2), 10), apu, apv);
                parameters = {
                    epk: {
                        x: x,
                        crv: crv,
                        kty: kty
                    }
                };
                if (kty === "EC") parameters.epk.y = y;
                if (apu) parameters.apu = (0, $033bcccb44f8a8b5$export$c564cdbbe6da493)(apu);
                if (apv) parameters.apv = (0, $033bcccb44f8a8b5$export$c564cdbbe6da493)(apv);
                if (alg === "ECDH-ES") {
                    cek = sharedSecret;
                    break;
                }
                cek = providedCek || (0, $c7571d8e6fd96313$export$2e2bcd8739ae039)(enc);
                const kwAlg = alg.slice(-6);
                encryptedKey = await (0, $3094dab5ef792645$export$4997ffc0176396a6)(kwAlg, sharedSecret, cek);
                break;
            }
        case "RSA1_5":
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            cek = providedCek || (0, $c7571d8e6fd96313$export$2e2bcd8739ae039)(enc);
            encryptedKey = await (0, $bbb33ee555688b3b$export$5b0f6292f11d1d18)(alg, key, cek);
            break;
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            {
                cek = providedCek || (0, $c7571d8e6fd96313$export$2e2bcd8739ae039)(enc);
                const { p2c: p2c, p2s: p2s } = providedParameters;
                ({ encryptedKey: encryptedKey, ...parameters } = await (0, $a874dffc129d670f$export$5b0f6292f11d1d18)(alg, key, cek, p2c, p2s));
                break;
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            cek = providedCek || (0, $c7571d8e6fd96313$export$2e2bcd8739ae039)(enc);
            encryptedKey = await (0, $3094dab5ef792645$export$4997ffc0176396a6)(alg, key, cek);
            break;
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
            {
                cek = providedCek || (0, $c7571d8e6fd96313$export$2e2bcd8739ae039)(enc);
                const { iv: iv } = providedParameters;
                ({ encryptedKey: encryptedKey, ...parameters } = await (0, $369ebf973cc285d8$export$4997ffc0176396a6)(alg, key, cek, iv));
                break;
            }
        default:
            throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)('Invalid or unsupported "alg" (JWE Algorithm) header value');
    }
    return {
        cek: cek,
        encryptedKey: encryptedKey,
        parameters: parameters
    };
}
var $f44a3a23141d820e$export$2e2bcd8739ae039 = $f44a3a23141d820e$var$encryptKeyManagement;






const $b8c2de1573b3a4e8$export$39c45cb77eaf132 = Symbol();
class $b8c2de1573b3a4e8$export$eec23736d3c24809 {
    constructor(plaintext){
        if (!(plaintext instanceof Uint8Array)) throw new TypeError("plaintext must be an instance of Uint8Array");
        this._plaintext = plaintext;
    }
    setKeyManagementParameters(parameters) {
        if (this._keyManagementParameters) throw new TypeError("setKeyManagementParameters can only be called once");
        this._keyManagementParameters = parameters;
        return this;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setSharedUnprotectedHeader(sharedUnprotectedHeader) {
        if (this._sharedUnprotectedHeader) throw new TypeError("setSharedUnprotectedHeader can only be called once");
        this._sharedUnprotectedHeader = sharedUnprotectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this._unprotectedHeader = unprotectedHeader;
        return this;
    }
    setAdditionalAuthenticatedData(aad) {
        this._aad = aad;
        return this;
    }
    setContentEncryptionKey(cek) {
        if (this._cek) throw new TypeError("setContentEncryptionKey can only be called once");
        this._cek = cek;
        return this;
    }
    setInitializationVector(iv) {
        if (this._iv) throw new TypeError("setInitializationVector can only be called once");
        this._iv = iv;
        return this;
    }
    async encrypt(key, options) {
        if (!this._protectedHeader && !this._unprotectedHeader && !this._sharedUnprotectedHeader) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("either setProtectedHeader, setUnprotectedHeader, or sharedUnprotectedHeader must be called before #encrypt()");
        if (!(0, $33b5b90a0aee86b8$export$2e2bcd8739ae039)(this._protectedHeader, this._unprotectedHeader, this._sharedUnprotectedHeader)) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("JWE Protected, JWE Shared Unprotected and JWE Per-Recipient Header Parameter names must be disjoint");
        const joseHeader = {
            ...this._protectedHeader,
            ...this._unprotectedHeader,
            ...this._sharedUnprotectedHeader
        };
        (0, $415d99021769b108$export$2e2bcd8739ae039)((0, $1e405ee376479e7e$export$19f281f2275f6a15), new Map(), options === null || options === void 0 ? void 0 : options.crit, this._protectedHeader, joseHeader);
        if (joseHeader.zip !== undefined) {
            if (!this._protectedHeader || !this._protectedHeader.zip) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)('JWE "zip" (Compression Algorithm) Header MUST be integrity protected');
            if (joseHeader.zip !== "DEF") throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)('Unsupported JWE "zip" (Compression Algorithm) Header Parameter value');
        }
        const { alg: alg, enc: enc } = joseHeader;
        if (typeof alg !== "string" || !alg) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)('JWE "alg" (Algorithm) Header Parameter missing or invalid');
        if (typeof enc !== "string" || !enc) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)('JWE "enc" (Encryption Algorithm) Header Parameter missing or invalid');
        let encryptedKey;
        if (alg === "dir") {
            if (this._cek) throw new TypeError("setContentEncryptionKey cannot be called when using Direct Encryption");
        } else if (alg === "ECDH-ES") {
            if (this._cek) throw new TypeError("setContentEncryptionKey cannot be called when using Direct Key Agreement");
        }
        let cek;
        {
            let parameters;
            ({ cek: cek, encryptedKey: encryptedKey, parameters: parameters } = await (0, $f44a3a23141d820e$export$2e2bcd8739ae039)(alg, enc, key, this._cek, this._keyManagementParameters));
            if (parameters) {
                if (options && $b8c2de1573b3a4e8$export$39c45cb77eaf132 in options) {
                    if (!this._unprotectedHeader) this.setUnprotectedHeader(parameters);
                    else this._unprotectedHeader = {
                        ...this._unprotectedHeader,
                        ...parameters
                    };
                } else if (!this._protectedHeader) this.setProtectedHeader(parameters);
                else this._protectedHeader = {
                    ...this._protectedHeader,
                    ...parameters
                };
            }
        }
        this._iv || (this._iv = (0, $f565ffac88c03c90$export$2e2bcd8739ae039)(enc));
        let additionalData;
        let protectedHeader;
        let aadMember;
        if (this._protectedHeader) protectedHeader = (0, $615a589604068301$export$5486af06137bf21a).encode((0, $033bcccb44f8a8b5$export$c564cdbbe6da493)(JSON.stringify(this._protectedHeader)));
        else protectedHeader = (0, $615a589604068301$export$5486af06137bf21a).encode("");
        if (this._aad) {
            aadMember = (0, $033bcccb44f8a8b5$export$c564cdbbe6da493)(this._aad);
            additionalData = (0, $615a589604068301$export$ee1b3e54f0441b22)(protectedHeader, (0, $615a589604068301$export$5486af06137bf21a).encode("."), (0, $615a589604068301$export$5486af06137bf21a).encode(aadMember));
        } else additionalData = protectedHeader;
        let ciphertext;
        let tag;
        if (joseHeader.zip === "DEF") {
            const deflated = await ((options === null || options === void 0 ? void 0 : options.deflateRaw) || (0, $99bffc79943d043d$export$2316623ecd1285ab))(this._plaintext);
            ({ ciphertext: ciphertext, tag: tag } = await (0, $1f1f83589071ba14$export$2e2bcd8739ae039)(enc, deflated, cek, this._iv, additionalData));
        } else ({ ciphertext: ciphertext, tag: tag } = await (0, $1f1f83589071ba14$export$2e2bcd8739ae039)(enc, this._plaintext, cek, this._iv, additionalData));
        const jwe = {
            ciphertext: (0, $033bcccb44f8a8b5$export$c564cdbbe6da493)(ciphertext),
            iv: (0, $033bcccb44f8a8b5$export$c564cdbbe6da493)(this._iv),
            tag: (0, $033bcccb44f8a8b5$export$c564cdbbe6da493)(tag)
        };
        if (encryptedKey) jwe.encrypted_key = (0, $033bcccb44f8a8b5$export$c564cdbbe6da493)(encryptedKey);
        if (aadMember) jwe.aad = aadMember;
        if (this._protectedHeader) jwe.protected = (0, $615a589604068301$export$124c96e6ce37090b).decode(protectedHeader);
        if (this._sharedUnprotectedHeader) jwe.unprotected = this._sharedUnprotectedHeader;
        if (this._unprotectedHeader) jwe.header = this._unprotectedHeader;
        return jwe;
    }
}








class $7b0d7e61bf621038$var$IndividualRecipient {
    constructor(enc, key, options){
        this.parent = enc;
        this.key = key;
        this.options = options;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this.unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this.unprotectedHeader = unprotectedHeader;
        return this;
    }
    addRecipient(...args) {
        return this.parent.addRecipient(...args);
    }
    encrypt(...args) {
        return this.parent.encrypt(...args);
    }
    done() {
        return this.parent;
    }
}
class $7b0d7e61bf621038$export$44234adffc6b0b92 {
    constructor(plaintext){
        this._recipients = [];
        this._plaintext = plaintext;
    }
    addRecipient(key, options) {
        const recipient = new $7b0d7e61bf621038$var$IndividualRecipient(this, key, {
            crit: options === null || options === void 0 ? void 0 : options.crit
        });
        this._recipients.push(recipient);
        return recipient;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setSharedUnprotectedHeader(sharedUnprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setSharedUnprotectedHeader can only be called once");
        this._unprotectedHeader = sharedUnprotectedHeader;
        return this;
    }
    setAdditionalAuthenticatedData(aad) {
        this._aad = aad;
        return this;
    }
    async encrypt(options) {
        var _a, _b, _c;
        if (!this._recipients.length) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("at least one recipient must be added");
        options = {
            deflateRaw: options === null || options === void 0 ? void 0 : options.deflateRaw
        };
        if (this._recipients.length === 1) {
            const [recipient] = this._recipients;
            const flattened = await new (0, $b8c2de1573b3a4e8$export$eec23736d3c24809)(this._plaintext).setAdditionalAuthenticatedData(this._aad).setProtectedHeader(this._protectedHeader).setSharedUnprotectedHeader(this._unprotectedHeader).setUnprotectedHeader(recipient.unprotectedHeader).encrypt(recipient.key, {
                ...recipient.options,
                ...options
            });
            let jwe = {
                ciphertext: flattened.ciphertext,
                iv: flattened.iv,
                recipients: [
                    {}
                ],
                tag: flattened.tag
            };
            if (flattened.aad) jwe.aad = flattened.aad;
            if (flattened.protected) jwe.protected = flattened.protected;
            if (flattened.unprotected) jwe.unprotected = flattened.unprotected;
            if (flattened.encrypted_key) jwe.recipients[0].encrypted_key = flattened.encrypted_key;
            if (flattened.header) jwe.recipients[0].header = flattened.header;
            return jwe;
        }
        let enc;
        for(let i = 0; i < this._recipients.length; i++){
            const recipient = this._recipients[i];
            if (!(0, $33b5b90a0aee86b8$export$2e2bcd8739ae039)(this._protectedHeader, this._unprotectedHeader, recipient.unprotectedHeader)) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)("JWE Protected, JWE Shared Unprotected and JWE Per-Recipient Header Parameter names must be disjoint");
            const joseHeader = {
                ...this._protectedHeader,
                ...this._unprotectedHeader,
                ...recipient.unprotectedHeader
            };
            const { alg: alg } = joseHeader;
            if (typeof alg !== "string" || !alg) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)('JWE "alg" (Algorithm) Header Parameter missing or invalid');
            if (alg === "dir" || alg === "ECDH-ES") throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)('"dir" and "ECDH-ES" alg may only be used with a single recipient');
            if (typeof joseHeader.enc !== "string" || !joseHeader.enc) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)('JWE "enc" (Encryption Algorithm) Header Parameter missing or invalid');
            if (!enc) enc = joseHeader.enc;
            else if (enc !== joseHeader.enc) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)('JWE "enc" (Encryption Algorithm) Header Parameter must be the same for all recipients');
            (0, $415d99021769b108$export$2e2bcd8739ae039)((0, $1e405ee376479e7e$export$19f281f2275f6a15), new Map(), recipient.options.crit, this._protectedHeader, joseHeader);
            if (joseHeader.zip !== undefined) {
                if (!this._protectedHeader || !this._protectedHeader.zip) throw new (0, $1e405ee376479e7e$export$19f281f2275f6a15)('JWE "zip" (Compression Algorithm) Header MUST be integrity protected');
            }
        }
        const cek = (0, $c7571d8e6fd96313$export$2e2bcd8739ae039)(enc);
        let jwe = {
            ciphertext: "",
            iv: "",
            recipients: [],
            tag: ""
        };
        for(let i = 0; i < this._recipients.length; i++){
            const recipient = this._recipients[i];
            const target = {};
            jwe.recipients.push(target);
            const joseHeader = {
                ...this._protectedHeader,
                ...this._unprotectedHeader,
                ...recipient.unprotectedHeader
            };
            const p2c = joseHeader.alg.startsWith("PBES2") ? 2048 + i : undefined;
            if (i === 0) {
                const flattened = await new (0, $b8c2de1573b3a4e8$export$eec23736d3c24809)(this._plaintext).setAdditionalAuthenticatedData(this._aad).setContentEncryptionKey(cek).setProtectedHeader(this._protectedHeader).setSharedUnprotectedHeader(this._unprotectedHeader).setUnprotectedHeader(recipient.unprotectedHeader).setKeyManagementParameters({
                    p2c: p2c
                }).encrypt(recipient.key, {
                    ...recipient.options,
                    ...options,
                    [(0, $b8c2de1573b3a4e8$export$39c45cb77eaf132)]: true
                });
                jwe.ciphertext = flattened.ciphertext;
                jwe.iv = flattened.iv;
                jwe.tag = flattened.tag;
                if (flattened.aad) jwe.aad = flattened.aad;
                if (flattened.protected) jwe.protected = flattened.protected;
                if (flattened.unprotected) jwe.unprotected = flattened.unprotected;
                target.encrypted_key = flattened.encrypted_key;
                if (flattened.header) target.header = flattened.header;
                continue;
            }
            const { encryptedKey: encryptedKey, parameters: parameters } = await (0, $f44a3a23141d820e$export$2e2bcd8739ae039)(((_a = recipient.unprotectedHeader) === null || _a === void 0 ? void 0 : _a.alg) || ((_b = this._protectedHeader) === null || _b === void 0 ? void 0 : _b.alg) || ((_c = this._unprotectedHeader) === null || _c === void 0 ? void 0 : _c.alg), enc, recipient.key, cek, {
                p2c: p2c
            });
            target.encrypted_key = (0, $033bcccb44f8a8b5$export$c564cdbbe6da493)(encryptedKey);
            if (recipient.unprotectedHeader || parameters) target.header = {
                ...recipient.unprotectedHeader,
                ...parameters
            };
        }
        return jwe;
    }
}




function $c50d391949d055b8$export$2e2bcd8739ae039(alg, algorithm) {
    const hash = `SHA-${alg.slice(-3)}`;
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            return {
                hash: hash,
                name: "HMAC"
            };
        case "PS256":
        case "PS384":
        case "PS512":
            return {
                hash: hash,
                name: "RSA-PSS",
                saltLength: alg.slice(-3) >> 3
            };
        case "RS256":
        case "RS384":
        case "RS512":
            return {
                hash: hash,
                name: "RSASSA-PKCS1-v1_5"
            };
        case "ES256":
        case "ES384":
        case "ES512":
            return {
                hash: hash,
                name: "ECDSA",
                namedCurve: algorithm.namedCurve
            };
        case "EdDSA":
            return {
                name: algorithm.name
            };
        default:
            throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)(`alg ${alg} is not supported either by JOSE or your javascript runtime`);
    }
}








function $b8360f8b6703fb44$export$2e2bcd8739ae039(alg, key, usage) {
    if ((0, $33a16233ac4f7c55$export$600b5603bbac4c6)(key)) {
        (0, $1028636d784f9436$export$39a36029eee6729)(key, alg, usage);
        return key;
    }
    if (key instanceof Uint8Array) {
        if (!alg.startsWith("HS")) throw new TypeError((0, $7c1fe397db20d285$export$2e2bcd8739ae039)(key, ...(0, $974356314552bbc8$export$b14ad400b1d09e0f)));
        return (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.importKey("raw", key, {
            hash: `SHA-${alg.slice(-3)}`,
            name: "HMAC"
        }, false, [
            usage
        ]);
    }
    throw new TypeError((0, $7c1fe397db20d285$export$2e2bcd8739ae039)(key, ...(0, $974356314552bbc8$export$b14ad400b1d09e0f), "Uint8Array"));
}


const $c35dfbd8b531dc6c$var$verify = async (alg, key, signature, data)=>{
    const cryptoKey = await (0, $b8360f8b6703fb44$export$2e2bcd8739ae039)(alg, key, "verify");
    (0, $d54a6598b64741e7$export$2e2bcd8739ae039)(alg, cryptoKey);
    const algorithm = (0, $c50d391949d055b8$export$2e2bcd8739ae039)(alg, cryptoKey.algorithm);
    try {
        return await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.verify(algorithm, cryptoKey, signature, data);
    } catch (_a) {
        return false;
    }
};
var $c35dfbd8b531dc6c$export$2e2bcd8739ae039 = $c35dfbd8b531dc6c$var$verify;









async function $14d53191ced4f4f7$export$b2614975507c40c9(jws, key, options) {
    var _a;
    if (!(0, $650ccab004d5778d$export$2e2bcd8739ae039)(jws)) throw new (0, $1e405ee376479e7e$export$e838de724af3d116)("Flattened JWS must be an object");
    if (jws.protected === undefined && jws.header === undefined) throw new (0, $1e405ee376479e7e$export$e838de724af3d116)('Flattened JWS must have either of the "protected" or "header" members');
    if (jws.protected !== undefined && typeof jws.protected !== "string") throw new (0, $1e405ee376479e7e$export$e838de724af3d116)("JWS Protected Header incorrect type");
    if (jws.payload === undefined) throw new (0, $1e405ee376479e7e$export$e838de724af3d116)("JWS Payload missing");
    if (typeof jws.signature !== "string") throw new (0, $1e405ee376479e7e$export$e838de724af3d116)("JWS Signature missing or incorrect type");
    if (jws.header !== undefined && !(0, $650ccab004d5778d$export$2e2bcd8739ae039)(jws.header)) throw new (0, $1e405ee376479e7e$export$e838de724af3d116)("JWS Unprotected Header incorrect type");
    let parsedProt = {};
    if (jws.protected) try {
        const protectedHeader = (0, $033bcccb44f8a8b5$export$2f872c0f2117be69)(jws.protected);
        parsedProt = JSON.parse((0, $615a589604068301$export$124c96e6ce37090b).decode(protectedHeader));
    } catch (_b) {
        throw new (0, $1e405ee376479e7e$export$e838de724af3d116)("JWS Protected Header is invalid");
    }
    if (!(0, $33b5b90a0aee86b8$export$2e2bcd8739ae039)(parsedProt, jws.header)) throw new (0, $1e405ee376479e7e$export$e838de724af3d116)("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
    const joseHeader = {
        ...parsedProt,
        ...jws.header
    };
    const extensions = (0, $415d99021769b108$export$2e2bcd8739ae039)((0, $1e405ee376479e7e$export$e838de724af3d116), new Map([
        [
            "b64",
            true
        ]
    ]), options === null || options === void 0 ? void 0 : options.crit, parsedProt, joseHeader);
    let b64 = true;
    if (extensions.has("b64")) {
        b64 = parsedProt.b64;
        if (typeof b64 !== "boolean") throw new (0, $1e405ee376479e7e$export$e838de724af3d116)('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
    }
    const { alg: alg } = joseHeader;
    if (typeof alg !== "string" || !alg) throw new (0, $1e405ee376479e7e$export$e838de724af3d116)('JWS "alg" (Algorithm) Header Parameter missing or invalid');
    const algorithms = options && (0, $d58be98cc14cc4a2$export$2e2bcd8739ae039)("algorithms", options.algorithms);
    if (algorithms && !algorithms.has(alg)) throw new (0, $1e405ee376479e7e$export$d51fd7fedeccc338)('"alg" (Algorithm) Header Parameter not allowed');
    if (b64) {
        if (typeof jws.payload !== "string") throw new (0, $1e405ee376479e7e$export$e838de724af3d116)("JWS Payload must be a string");
    } else if (typeof jws.payload !== "string" && !(jws.payload instanceof Uint8Array)) throw new (0, $1e405ee376479e7e$export$e838de724af3d116)("JWS Payload must be a string or an Uint8Array instance");
    let resolvedKey = false;
    if (typeof key === "function") {
        key = await key(parsedProt, jws);
        resolvedKey = true;
    }
    (0, $b8cfe7360b22a960$export$2e2bcd8739ae039)(alg, key, "verify");
    const data = (0, $615a589604068301$export$ee1b3e54f0441b22)((0, $615a589604068301$export$5486af06137bf21a).encode((_a = jws.protected) !== null && _a !== void 0 ? _a : ""), (0, $615a589604068301$export$5486af06137bf21a).encode("."), typeof jws.payload === "string" ? (0, $615a589604068301$export$5486af06137bf21a).encode(jws.payload) : jws.payload);
    let signature;
    try {
        signature = (0, $033bcccb44f8a8b5$export$2f872c0f2117be69)(jws.signature);
    } catch (_c) {
        throw new (0, $1e405ee376479e7e$export$e838de724af3d116)("Failed to base64url decode the signature");
    }
    const verified = await (0, $c35dfbd8b531dc6c$export$2e2bcd8739ae039)(alg, key, signature, data);
    if (!verified) throw new (0, $1e405ee376479e7e$export$c67a0218e7c50378)();
    let payload;
    if (b64) try {
        payload = (0, $033bcccb44f8a8b5$export$2f872c0f2117be69)(jws.payload);
    } catch (_d) {
        throw new (0, $1e405ee376479e7e$export$e838de724af3d116)("Failed to base64url decode the payload");
    }
    else if (typeof jws.payload === "string") payload = (0, $615a589604068301$export$5486af06137bf21a).encode(jws.payload);
    else payload = jws.payload;
    const result = {
        payload: payload
    };
    if (jws.protected !== undefined) result.protectedHeader = parsedProt;
    if (jws.header !== undefined) result.unprotectedHeader = jws.header;
    if (resolvedKey) return {
        ...result,
        key: key
    };
    return result;
}




async function $3eb16d8b7a2a7e01$export$996150e72a8992e(jws, key, options) {
    if (jws instanceof Uint8Array) jws = (0, $615a589604068301$export$124c96e6ce37090b).decode(jws);
    if (typeof jws !== "string") throw new (0, $1e405ee376479e7e$export$e838de724af3d116)("Compact JWS must be a string or Uint8Array");
    const { 0: protectedHeader, 1: payload, 2: signature, length: length } = jws.split(".");
    if (length !== 3) throw new (0, $1e405ee376479e7e$export$e838de724af3d116)("Invalid Compact JWS");
    const verified = await (0, $14d53191ced4f4f7$export$b2614975507c40c9)({
        payload: payload,
        protected: protectedHeader,
        signature: signature
    }, key, options);
    const result = {
        payload: verified.payload,
        protectedHeader: verified.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: verified.key
    };
    return result;
}






async function $39b2470c22efa55c$export$45b643129436bc63(jws, key, options) {
    if (!(0, $650ccab004d5778d$export$2e2bcd8739ae039)(jws)) throw new (0, $1e405ee376479e7e$export$e838de724af3d116)("General JWS must be an object");
    if (!Array.isArray(jws.signatures) || !jws.signatures.every((0, $650ccab004d5778d$export$2e2bcd8739ae039))) throw new (0, $1e405ee376479e7e$export$e838de724af3d116)("JWS Signatures missing or incorrect type");
    for (const signature of jws.signatures)try {
        return await (0, $14d53191ced4f4f7$export$b2614975507c40c9)({
            header: signature.header,
            payload: jws.payload,
            protected: signature.protected,
            signature: signature.signature
        }, key, options);
    } catch (_a) {}
    throw new (0, $1e405ee376479e7e$export$c67a0218e7c50378)();
}





var $fc25420d7f3b2820$export$2e2bcd8739ae039 = (date)=>Math.floor(date.getTime() / 1000);


const $9ecffe4d85ebe41c$var$minute = 60;
const $9ecffe4d85ebe41c$var$hour = $9ecffe4d85ebe41c$var$minute * 60;
const $9ecffe4d85ebe41c$var$day = $9ecffe4d85ebe41c$var$hour * 24;
const $9ecffe4d85ebe41c$var$week = $9ecffe4d85ebe41c$var$day * 7;
const $9ecffe4d85ebe41c$var$year = $9ecffe4d85ebe41c$var$day * 365.25;
const $9ecffe4d85ebe41c$var$REGEX = /^(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)$/i;
var $9ecffe4d85ebe41c$export$2e2bcd8739ae039 = (str)=>{
    const matched = $9ecffe4d85ebe41c$var$REGEX.exec(str);
    if (!matched) throw new TypeError("Invalid time period format");
    const value = parseFloat(matched[1]);
    const unit = matched[2].toLowerCase();
    switch(unit){
        case "sec":
        case "secs":
        case "second":
        case "seconds":
        case "s":
            return Math.round(value);
        case "minute":
        case "minutes":
        case "min":
        case "mins":
        case "m":
            return Math.round(value * $9ecffe4d85ebe41c$var$minute);
        case "hour":
        case "hours":
        case "hr":
        case "hrs":
        case "h":
            return Math.round(value * $9ecffe4d85ebe41c$var$hour);
        case "day":
        case "days":
        case "d":
            return Math.round(value * $9ecffe4d85ebe41c$var$day);
        case "week":
        case "weeks":
        case "w":
            return Math.round(value * $9ecffe4d85ebe41c$var$week);
        default:
            return Math.round(value * $9ecffe4d85ebe41c$var$year);
    }
};



const $3d5601cdf8f9077f$var$normalizeTyp = (value)=>value.toLowerCase().replace(/^application\//, "");
const $3d5601cdf8f9077f$var$checkAudiencePresence = (audPayload, audOption)=>{
    if (typeof audPayload === "string") return audOption.includes(audPayload);
    if (Array.isArray(audPayload)) return audOption.some(Set.prototype.has.bind(new Set(audPayload)));
    return false;
};
var $3d5601cdf8f9077f$export$2e2bcd8739ae039 = (protectedHeader, encodedPayload, options = {})=>{
    const { typ: typ } = options;
    if (typ && (typeof protectedHeader.typ !== "string" || $3d5601cdf8f9077f$var$normalizeTyp(protectedHeader.typ) !== $3d5601cdf8f9077f$var$normalizeTyp(typ))) throw new (0, $1e405ee376479e7e$export$f1e14efb908196e9)('unexpected "typ" JWT header value', "typ", "check_failed");
    let payload;
    try {
        payload = JSON.parse((0, $615a589604068301$export$124c96e6ce37090b).decode(encodedPayload));
    } catch (_a) {}
    if (!(0, $650ccab004d5778d$export$2e2bcd8739ae039)(payload)) throw new (0, $1e405ee376479e7e$export$936b39ada0bbfceb)("JWT Claims Set must be a top-level JSON object");
    const { requiredClaims: requiredClaims = [], issuer: issuer, subject: subject, audience: audience, maxTokenAge: maxTokenAge } = options;
    if (maxTokenAge !== undefined) requiredClaims.push("iat");
    if (audience !== undefined) requiredClaims.push("aud");
    if (subject !== undefined) requiredClaims.push("sub");
    if (issuer !== undefined) requiredClaims.push("iss");
    for (const claim of new Set(requiredClaims.reverse())){
        if (!(claim in payload)) throw new (0, $1e405ee376479e7e$export$f1e14efb908196e9)(`missing required "${claim}" claim`, claim, "missing");
    }
    if (issuer && !(Array.isArray(issuer) ? issuer : [
        issuer
    ]).includes(payload.iss)) throw new (0, $1e405ee376479e7e$export$f1e14efb908196e9)('unexpected "iss" claim value', "iss", "check_failed");
    if (subject && payload.sub !== subject) throw new (0, $1e405ee376479e7e$export$f1e14efb908196e9)('unexpected "sub" claim value', "sub", "check_failed");
    if (audience && !$3d5601cdf8f9077f$var$checkAudiencePresence(payload.aud, typeof audience === "string" ? [
        audience
    ] : audience)) throw new (0, $1e405ee376479e7e$export$f1e14efb908196e9)('unexpected "aud" claim value', "aud", "check_failed");
    let tolerance;
    switch(typeof options.clockTolerance){
        case "string":
            tolerance = (0, $9ecffe4d85ebe41c$export$2e2bcd8739ae039)(options.clockTolerance);
            break;
        case "number":
            tolerance = options.clockTolerance;
            break;
        case "undefined":
            tolerance = 0;
            break;
        default:
            throw new TypeError("Invalid clockTolerance option type");
    }
    const { currentDate: currentDate } = options;
    const now = (0, $fc25420d7f3b2820$export$2e2bcd8739ae039)(currentDate || new Date());
    if ((payload.iat !== undefined || maxTokenAge) && typeof payload.iat !== "number") throw new (0, $1e405ee376479e7e$export$f1e14efb908196e9)('"iat" claim must be a number', "iat", "invalid");
    if (payload.nbf !== undefined) {
        if (typeof payload.nbf !== "number") throw new (0, $1e405ee376479e7e$export$f1e14efb908196e9)('"nbf" claim must be a number', "nbf", "invalid");
        if (payload.nbf > now + tolerance) throw new (0, $1e405ee376479e7e$export$f1e14efb908196e9)('"nbf" claim timestamp check failed', "nbf", "check_failed");
    }
    if (payload.exp !== undefined) {
        if (typeof payload.exp !== "number") throw new (0, $1e405ee376479e7e$export$f1e14efb908196e9)('"exp" claim must be a number', "exp", "invalid");
        if (payload.exp <= now - tolerance) throw new (0, $1e405ee376479e7e$export$4b386bf852b7863d)('"exp" claim timestamp check failed', "exp", "check_failed");
    }
    if (maxTokenAge) {
        const age = now - payload.iat;
        const max = typeof maxTokenAge === "number" ? maxTokenAge : (0, $9ecffe4d85ebe41c$export$2e2bcd8739ae039)(maxTokenAge);
        if (age - tolerance > max) throw new (0, $1e405ee376479e7e$export$4b386bf852b7863d)('"iat" claim timestamp check failed (too far in the past)', "iat", "check_failed");
        if (age < 0 - tolerance) throw new (0, $1e405ee376479e7e$export$f1e14efb908196e9)('"iat" claim timestamp check failed (it should be in the past)', "iat", "check_failed");
    }
    return payload;
};



async function $2c06230c34f184a4$export$c878fd0f8381da51(jwt, key, options) {
    var _a;
    const verified = await (0, $3eb16d8b7a2a7e01$export$996150e72a8992e)(jwt, key, options);
    if (((_a = verified.protectedHeader.crit) === null || _a === void 0 ? void 0 : _a.includes("b64")) && verified.protectedHeader.b64 === false) throw new (0, $1e405ee376479e7e$export$936b39ada0bbfceb)("JWTs MUST NOT use unencoded payload");
    const payload = (0, $3d5601cdf8f9077f$export$2e2bcd8739ae039)(verified.protectedHeader, verified.payload, options);
    const result = {
        payload: payload,
        protectedHeader: verified.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: verified.key
    };
    return result;
}





async function $03ac11d114c4942b$export$6ee899505bc40a19(jwt, key, options) {
    const decrypted = await (0, $0f2a276e78e6d6cc$export$c9a8efe6bfd872ce)(jwt, key, options);
    const payload = (0, $3d5601cdf8f9077f$export$2e2bcd8739ae039)(decrypted.protectedHeader, decrypted.plaintext, options);
    const { protectedHeader: protectedHeader } = decrypted;
    if (protectedHeader.iss !== undefined && protectedHeader.iss !== payload.iss) throw new (0, $1e405ee376479e7e$export$f1e14efb908196e9)('replicated "iss" claim header parameter mismatch', "iss", "mismatch");
    if (protectedHeader.sub !== undefined && protectedHeader.sub !== payload.sub) throw new (0, $1e405ee376479e7e$export$f1e14efb908196e9)('replicated "sub" claim header parameter mismatch', "sub", "mismatch");
    if (protectedHeader.aud !== undefined && JSON.stringify(protectedHeader.aud) !== JSON.stringify(payload.aud)) throw new (0, $1e405ee376479e7e$export$f1e14efb908196e9)('replicated "aud" claim header parameter mismatch', "aud", "mismatch");
    const result = {
        payload: payload,
        protectedHeader: protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: decrypted.key
    };
    return result;
}



class $d213d9f963ca4f52$export$965e4de9938e070e {
    constructor(plaintext){
        this._flattened = new (0, $b8c2de1573b3a4e8$export$eec23736d3c24809)(plaintext);
    }
    setContentEncryptionKey(cek) {
        this._flattened.setContentEncryptionKey(cek);
        return this;
    }
    setInitializationVector(iv) {
        this._flattened.setInitializationVector(iv);
        return this;
    }
    setProtectedHeader(protectedHeader) {
        this._flattened.setProtectedHeader(protectedHeader);
        return this;
    }
    setKeyManagementParameters(parameters) {
        this._flattened.setKeyManagementParameters(parameters);
        return this;
    }
    async encrypt(key, options) {
        const jwe = await this._flattened.encrypt(key, options);
        return [
            jwe.protected,
            jwe.encrypted_key,
            jwe.iv,
            jwe.ciphertext,
            jwe.tag
        ].join(".");
    }
}








const $1c1102062dd01fcc$var$sign = async (alg, key, data)=>{
    const cryptoKey = await (0, $b8360f8b6703fb44$export$2e2bcd8739ae039)(alg, key, "sign");
    (0, $d54a6598b64741e7$export$2e2bcd8739ae039)(alg, cryptoKey);
    const signature = await (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.sign((0, $c50d391949d055b8$export$2e2bcd8739ae039)(alg, cryptoKey.algorithm), cryptoKey, data);
    return new Uint8Array(signature);
};
var $1c1102062dd01fcc$export$2e2bcd8739ae039 = $1c1102062dd01fcc$var$sign;







class $e14a579724c7e565$export$9a8af5200da5ddb1 {
    constructor(payload){
        if (!(payload instanceof Uint8Array)) throw new TypeError("payload must be an instance of Uint8Array");
        this._payload = payload;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this._unprotectedHeader = unprotectedHeader;
        return this;
    }
    async sign(key, options) {
        if (!this._protectedHeader && !this._unprotectedHeader) throw new (0, $1e405ee376479e7e$export$e838de724af3d116)("either setProtectedHeader or setUnprotectedHeader must be called before #sign()");
        if (!(0, $33b5b90a0aee86b8$export$2e2bcd8739ae039)(this._protectedHeader, this._unprotectedHeader)) throw new (0, $1e405ee376479e7e$export$e838de724af3d116)("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
        const joseHeader = {
            ...this._protectedHeader,
            ...this._unprotectedHeader
        };
        const extensions = (0, $415d99021769b108$export$2e2bcd8739ae039)((0, $1e405ee376479e7e$export$e838de724af3d116), new Map([
            [
                "b64",
                true
            ]
        ]), options === null || options === void 0 ? void 0 : options.crit, this._protectedHeader, joseHeader);
        let b64 = true;
        if (extensions.has("b64")) {
            b64 = this._protectedHeader.b64;
            if (typeof b64 !== "boolean") throw new (0, $1e405ee376479e7e$export$e838de724af3d116)('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
        }
        const { alg: alg } = joseHeader;
        if (typeof alg !== "string" || !alg) throw new (0, $1e405ee376479e7e$export$e838de724af3d116)('JWS "alg" (Algorithm) Header Parameter missing or invalid');
        (0, $b8cfe7360b22a960$export$2e2bcd8739ae039)(alg, key, "sign");
        let payload = this._payload;
        if (b64) payload = (0, $615a589604068301$export$5486af06137bf21a).encode((0, $033bcccb44f8a8b5$export$c564cdbbe6da493)(payload));
        let protectedHeader;
        if (this._protectedHeader) protectedHeader = (0, $615a589604068301$export$5486af06137bf21a).encode((0, $033bcccb44f8a8b5$export$c564cdbbe6da493)(JSON.stringify(this._protectedHeader)));
        else protectedHeader = (0, $615a589604068301$export$5486af06137bf21a).encode("");
        const data = (0, $615a589604068301$export$ee1b3e54f0441b22)(protectedHeader, (0, $615a589604068301$export$5486af06137bf21a).encode("."), payload);
        const signature = await (0, $1c1102062dd01fcc$export$2e2bcd8739ae039)(alg, key, data);
        const jws = {
            signature: (0, $033bcccb44f8a8b5$export$c564cdbbe6da493)(signature),
            payload: ""
        };
        if (b64) jws.payload = (0, $615a589604068301$export$124c96e6ce37090b).decode(payload);
        if (this._unprotectedHeader) jws.header = this._unprotectedHeader;
        if (this._protectedHeader) jws.protected = (0, $615a589604068301$export$124c96e6ce37090b).decode(protectedHeader);
        return jws;
    }
}


class $c49e118f2c817f37$export$b6738d8e70498d17 {
    constructor(payload){
        this._flattened = new (0, $e14a579724c7e565$export$9a8af5200da5ddb1)(payload);
    }
    setProtectedHeader(protectedHeader) {
        this._flattened.setProtectedHeader(protectedHeader);
        return this;
    }
    async sign(key, options) {
        const jws = await this._flattened.sign(key, options);
        if (jws.payload === undefined) throw new TypeError("use the flattened module for creating JWS with b64: false");
        return `${jws.protected}.${jws.payload}.${jws.signature}`;
    }
}





class $f5058e8f5281e73c$var$IndividualSignature {
    constructor(sig, key, options){
        this.parent = sig;
        this.key = key;
        this.options = options;
    }
    setProtectedHeader(protectedHeader) {
        if (this.protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this.protectedHeader = protectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this.unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this.unprotectedHeader = unprotectedHeader;
        return this;
    }
    addSignature(...args) {
        return this.parent.addSignature(...args);
    }
    sign(...args) {
        return this.parent.sign(...args);
    }
    done() {
        return this.parent;
    }
}
class $f5058e8f5281e73c$export$7e2f94727ed1a34b {
    constructor(payload){
        this._signatures = [];
        this._payload = payload;
    }
    addSignature(key, options) {
        const signature = new $f5058e8f5281e73c$var$IndividualSignature(this, key, options);
        this._signatures.push(signature);
        return signature;
    }
    async sign() {
        if (!this._signatures.length) throw new (0, $1e405ee376479e7e$export$e838de724af3d116)("at least one signature must be added");
        const jws = {
            signatures: [],
            payload: ""
        };
        for(let i = 0; i < this._signatures.length; i++){
            const signature = this._signatures[i];
            const flattened = new (0, $e14a579724c7e565$export$9a8af5200da5ddb1)(this._payload);
            flattened.setProtectedHeader(signature.protectedHeader);
            flattened.setUnprotectedHeader(signature.unprotectedHeader);
            const { payload: payload, ...rest } = await flattened.sign(signature.key, signature.options);
            if (i === 0) jws.payload = payload;
            else if (jws.payload !== payload) throw new (0, $1e405ee376479e7e$export$e838de724af3d116)("inconsistent use of JWS Unencoded Payload (RFC7797)");
            jws.signatures.push(rest);
        }
        return jws;
    }
}








class $50b267cfd1995b1a$export$2ef1b74b7c7e6eb3 {
    constructor(payload){
        if (!(0, $650ccab004d5778d$export$2e2bcd8739ae039)(payload)) throw new TypeError("JWT Claims Set MUST be an object");
        this._payload = payload;
    }
    setIssuer(issuer) {
        this._payload = {
            ...this._payload,
            iss: issuer
        };
        return this;
    }
    setSubject(subject) {
        this._payload = {
            ...this._payload,
            sub: subject
        };
        return this;
    }
    setAudience(audience) {
        this._payload = {
            ...this._payload,
            aud: audience
        };
        return this;
    }
    setJti(jwtId) {
        this._payload = {
            ...this._payload,
            jti: jwtId
        };
        return this;
    }
    setNotBefore(input) {
        if (typeof input === "number") this._payload = {
            ...this._payload,
            nbf: input
        };
        else this._payload = {
            ...this._payload,
            nbf: (0, $fc25420d7f3b2820$export$2e2bcd8739ae039)(new Date()) + (0, $9ecffe4d85ebe41c$export$2e2bcd8739ae039)(input)
        };
        return this;
    }
    setExpirationTime(input) {
        if (typeof input === "number") this._payload = {
            ...this._payload,
            exp: input
        };
        else this._payload = {
            ...this._payload,
            exp: (0, $fc25420d7f3b2820$export$2e2bcd8739ae039)(new Date()) + (0, $9ecffe4d85ebe41c$export$2e2bcd8739ae039)(input)
        };
        return this;
    }
    setIssuedAt(input) {
        if (typeof input === "undefined") this._payload = {
            ...this._payload,
            iat: (0, $fc25420d7f3b2820$export$2e2bcd8739ae039)(new Date())
        };
        else this._payload = {
            ...this._payload,
            iat: input
        };
        return this;
    }
}


class $327a80d5f216e1c6$export$88d4e5d23fbe6c84 extends (0, $50b267cfd1995b1a$export$2ef1b74b7c7e6eb3) {
    setProtectedHeader(protectedHeader) {
        this._protectedHeader = protectedHeader;
        return this;
    }
    async sign(key, options) {
        var _a;
        const sig = new (0, $c49e118f2c817f37$export$b6738d8e70498d17)((0, $615a589604068301$export$5486af06137bf21a).encode(JSON.stringify(this._payload)));
        sig.setProtectedHeader(this._protectedHeader);
        if (Array.isArray((_a = this._protectedHeader) === null || _a === void 0 ? void 0 : _a.crit) && this._protectedHeader.crit.includes("b64") && this._protectedHeader.b64 === false) throw new (0, $1e405ee376479e7e$export$936b39ada0bbfceb)("JWTs MUST NOT use unencoded payload");
        return sig.sign(key, options);
    }
}





class $337da0ae55bb3b43$export$28c9f8d29aec6f3d extends (0, $50b267cfd1995b1a$export$2ef1b74b7c7e6eb3) {
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setKeyManagementParameters(parameters) {
        if (this._keyManagementParameters) throw new TypeError("setKeyManagementParameters can only be called once");
        this._keyManagementParameters = parameters;
        return this;
    }
    setContentEncryptionKey(cek) {
        if (this._cek) throw new TypeError("setContentEncryptionKey can only be called once");
        this._cek = cek;
        return this;
    }
    setInitializationVector(iv) {
        if (this._iv) throw new TypeError("setInitializationVector can only be called once");
        this._iv = iv;
        return this;
    }
    replicateIssuerAsHeader() {
        this._replicateIssuerAsHeader = true;
        return this;
    }
    replicateSubjectAsHeader() {
        this._replicateSubjectAsHeader = true;
        return this;
    }
    replicateAudienceAsHeader() {
        this._replicateAudienceAsHeader = true;
        return this;
    }
    async encrypt(key, options) {
        const enc = new (0, $d213d9f963ca4f52$export$965e4de9938e070e)((0, $615a589604068301$export$5486af06137bf21a).encode(JSON.stringify(this._payload)));
        if (this._replicateIssuerAsHeader) this._protectedHeader = {
            ...this._protectedHeader,
            iss: this._payload.iss
        };
        if (this._replicateSubjectAsHeader) this._protectedHeader = {
            ...this._protectedHeader,
            sub: this._payload.sub
        };
        if (this._replicateAudienceAsHeader) this._protectedHeader = {
            ...this._protectedHeader,
            aud: this._payload.aud
        };
        enc.setProtectedHeader(this._protectedHeader);
        if (this._iv) enc.setInitializationVector(this._iv);
        if (this._cek) enc.setContentEncryptionKey(this._cek);
        if (this._keyManagementParameters) enc.setKeyManagementParameters(this._keyManagementParameters);
        return enc.encrypt(key, options);
    }
}







const $1c0786eef970403f$var$check = (value, description)=>{
    if (typeof value !== "string" || !value) throw new (0, $1e405ee376479e7e$export$b3992e0f88fb07e3)(`${description} missing or invalid`);
};
async function $1c0786eef970403f$export$f1ec189735e8660f(jwk, digestAlgorithm) {
    if (!(0, $650ccab004d5778d$export$2e2bcd8739ae039)(jwk)) throw new TypeError("JWK must be an object");
    digestAlgorithm !== null && digestAlgorithm !== void 0 ? digestAlgorithm : digestAlgorithm = "sha256";
    if (digestAlgorithm !== "sha256" && digestAlgorithm !== "sha384" && digestAlgorithm !== "sha512") throw new TypeError('digestAlgorithm must one of "sha256", "sha384", or "sha512"');
    let components;
    switch(jwk.kty){
        case "EC":
            $1c0786eef970403f$var$check(jwk.crv, '"crv" (Curve) Parameter');
            $1c0786eef970403f$var$check(jwk.x, '"x" (X Coordinate) Parameter');
            $1c0786eef970403f$var$check(jwk.y, '"y" (Y Coordinate) Parameter');
            components = {
                crv: jwk.crv,
                kty: jwk.kty,
                x: jwk.x,
                y: jwk.y
            };
            break;
        case "OKP":
            $1c0786eef970403f$var$check(jwk.crv, '"crv" (Subtype of Key Pair) Parameter');
            $1c0786eef970403f$var$check(jwk.x, '"x" (Public Key) Parameter');
            components = {
                crv: jwk.crv,
                kty: jwk.kty,
                x: jwk.x
            };
            break;
        case "RSA":
            $1c0786eef970403f$var$check(jwk.e, '"e" (Exponent) Parameter');
            $1c0786eef970403f$var$check(jwk.n, '"n" (Modulus) Parameter');
            components = {
                e: jwk.e,
                kty: jwk.kty,
                n: jwk.n
            };
            break;
        case "oct":
            $1c0786eef970403f$var$check(jwk.k, '"k" (Key Value) Parameter');
            components = {
                k: jwk.k,
                kty: jwk.kty
            };
            break;
        default:
            throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)('"kty" (Key Type) Parameter missing or unsupported');
    }
    const data = (0, $615a589604068301$export$5486af06137bf21a).encode(JSON.stringify(components));
    return (0, $033bcccb44f8a8b5$export$c564cdbbe6da493)(await (0, $5959832e4f60c589$export$2e2bcd8739ae039)(digestAlgorithm, data));
}
async function $1c0786eef970403f$export$b9879ebc49d4fd7a(jwk, digestAlgorithm) {
    digestAlgorithm !== null && digestAlgorithm !== void 0 ? digestAlgorithm : digestAlgorithm = "sha256";
    const thumbprint = await $1c0786eef970403f$export$f1ec189735e8660f(jwk, digestAlgorithm);
    return `urn:ietf:params:oauth:jwk-thumbprint:sha-${digestAlgorithm.slice(-3)}:${thumbprint}`;
}





async function $050639afe95c4cdd$export$c51e3062a159ef59(protectedHeader, token) {
    const joseHeader = {
        ...protectedHeader,
        ...token === null || token === void 0 ? void 0 : token.header
    };
    if (!(0, $650ccab004d5778d$export$2e2bcd8739ae039)(joseHeader.jwk)) throw new (0, $1e405ee376479e7e$export$e838de724af3d116)('"jwk" (JSON Web Key) Header Parameter must be a JSON object');
    const key = await (0, $9944bc715090102a$export$2b70d37b4d0b888b)({
        ...joseHeader.jwk,
        ext: true
    }, joseHeader.alg, true);
    if (key instanceof Uint8Array || key.type !== "public") throw new (0, $1e405ee376479e7e$export$e838de724af3d116)('"jwk" (JSON Web Key) Header Parameter must be a public key');
    return key;
}





function $5c5678ece69ae391$var$getKtyFromAlg(alg) {
    switch(typeof alg === "string" && alg.slice(0, 2)){
        case "RS":
        case "PS":
            return "RSA";
        case "ES":
            return "EC";
        case "Ed":
            return "OKP";
        default:
            throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)('Unsupported "alg" value for a JSON Web Key Set');
    }
}
function $5c5678ece69ae391$export$d01e0ebadbb4baf(jwks) {
    return jwks && typeof jwks === "object" && Array.isArray(jwks.keys) && jwks.keys.every($5c5678ece69ae391$var$isJWKLike);
}
function $5c5678ece69ae391$var$isJWKLike(key) {
    return (0, $650ccab004d5778d$export$2e2bcd8739ae039)(key);
}
function $5c5678ece69ae391$var$clone(obj) {
    if (typeof structuredClone === "function") return structuredClone(obj);
    return JSON.parse(JSON.stringify(obj));
}
class $5c5678ece69ae391$export$cfeaec9a672ea12b {
    constructor(jwks){
        this._cached = new WeakMap();
        if (!$5c5678ece69ae391$export$d01e0ebadbb4baf(jwks)) throw new (0, $1e405ee376479e7e$export$9b22c2a1e2403b8e)("JSON Web Key Set malformed");
        this._jwks = $5c5678ece69ae391$var$clone(jwks);
    }
    async getKey(protectedHeader, token) {
        const { alg: alg, kid: kid } = {
            ...protectedHeader,
            ...token === null || token === void 0 ? void 0 : token.header
        };
        const kty = $5c5678ece69ae391$var$getKtyFromAlg(alg);
        const candidates = this._jwks.keys.filter((jwk)=>{
            let candidate = kty === jwk.kty;
            if (candidate && typeof kid === "string") candidate = kid === jwk.kid;
            if (candidate && typeof jwk.alg === "string") candidate = alg === jwk.alg;
            if (candidate && typeof jwk.use === "string") candidate = jwk.use === "sig";
            if (candidate && Array.isArray(jwk.key_ops)) candidate = jwk.key_ops.includes("verify");
            if (candidate && alg === "EdDSA") candidate = jwk.crv === "Ed25519" || jwk.crv === "Ed448";
            if (candidate) switch(alg){
                case "ES256":
                    candidate = jwk.crv === "P-256";
                    break;
                case "ES256K":
                    candidate = jwk.crv === "secp256k1";
                    break;
                case "ES384":
                    candidate = jwk.crv === "P-384";
                    break;
                case "ES512":
                    candidate = jwk.crv === "P-521";
                    break;
            }
            return candidate;
        });
        const { 0: jwk, length: length } = candidates;
        if (length === 0) throw new (0, $1e405ee376479e7e$export$3d5ed1a538bed04e)();
        else if (length !== 1) {
            const error = new (0, $1e405ee376479e7e$export$dc036de401a5c284)();
            const { _cached: _cached } = this;
            error[Symbol.asyncIterator] = async function*() {
                for (const jwk of candidates)try {
                    yield await $5c5678ece69ae391$var$importWithAlgCache(_cached, jwk, alg);
                } catch (_a) {
                    continue;
                }
            };
            throw error;
        }
        return $5c5678ece69ae391$var$importWithAlgCache(this._cached, jwk, alg);
    }
}
async function $5c5678ece69ae391$var$importWithAlgCache(cache, jwk, alg) {
    const cached = cache.get(jwk) || cache.set(jwk, {}).get(jwk);
    if (cached[alg] === undefined) {
        const key = await (0, $9944bc715090102a$export$2b70d37b4d0b888b)({
            ...jwk,
            ext: true
        }, alg);
        if (key instanceof Uint8Array || key.type !== "public") throw new (0, $1e405ee376479e7e$export$9b22c2a1e2403b8e)("JSON Web Key Set members must be public keys");
        cached[alg] = key;
    }
    return cached[alg];
}
function $5c5678ece69ae391$export$4892abc640e5f80e(jwks) {
    const set = new $5c5678ece69ae391$export$cfeaec9a672ea12b(jwks);
    return async function(protectedHeader, token) {
        return set.getKey(protectedHeader, token);
    };
}



const $e1dfb359571a43fb$var$fetchJwks = async (url, timeout, options)=>{
    let controller;
    let id;
    let timedOut = false;
    if (typeof AbortController === "function") {
        controller = new AbortController();
        id = setTimeout(()=>{
            timedOut = true;
            controller.abort();
        }, timeout);
    }
    const response = await fetch(url.href, {
        signal: controller ? controller.signal : undefined,
        redirect: "manual",
        headers: options.headers
    }).catch((err)=>{
        if (timedOut) throw new (0, $1e405ee376479e7e$export$3f30acebf25c04e6)();
        throw err;
    });
    if (id !== undefined) clearTimeout(id);
    if (response.status !== 200) throw new (0, $1e405ee376479e7e$export$f754d6850d76bf87)("Expected 200 OK from the JSON Web Key Set HTTP response");
    try {
        return await response.json();
    } catch (_a) {
        throw new (0, $1e405ee376479e7e$export$f754d6850d76bf87)("Failed to parse the JSON Web Key Set HTTP response as JSON");
    }
};
var $e1dfb359571a43fb$export$2e2bcd8739ae039 = $e1dfb359571a43fb$var$fetchJwks;




function $dd093a9261b0ecce$var$isCloudflareWorkers() {
    return typeof WebSocketPair !== "undefined" || typeof navigator !== "undefined" && navigator.userAgent === "Cloudflare-Workers" || typeof EdgeRuntime !== "undefined" && EdgeRuntime === "vercel";
}
class $dd093a9261b0ecce$var$RemoteJWKSet extends (0, $5c5678ece69ae391$export$cfeaec9a672ea12b) {
    constructor(url, options){
        super({
            keys: []
        });
        this._jwks = undefined;
        if (!(url instanceof URL)) throw new TypeError("url must be an instance of URL");
        this._url = new URL(url.href);
        this._options = {
            agent: options === null || options === void 0 ? void 0 : options.agent,
            headers: options === null || options === void 0 ? void 0 : options.headers
        };
        this._timeoutDuration = typeof (options === null || options === void 0 ? void 0 : options.timeoutDuration) === "number" ? options === null || options === void 0 ? void 0 : options.timeoutDuration : 5000;
        this._cooldownDuration = typeof (options === null || options === void 0 ? void 0 : options.cooldownDuration) === "number" ? options === null || options === void 0 ? void 0 : options.cooldownDuration : 30000;
        this._cacheMaxAge = typeof (options === null || options === void 0 ? void 0 : options.cacheMaxAge) === "number" ? options === null || options === void 0 ? void 0 : options.cacheMaxAge : 600000;
    }
    coolingDown() {
        return typeof this._jwksTimestamp === "number" ? Date.now() < this._jwksTimestamp + this._cooldownDuration : false;
    }
    fresh() {
        return typeof this._jwksTimestamp === "number" ? Date.now() < this._jwksTimestamp + this._cacheMaxAge : false;
    }
    async getKey(protectedHeader, token) {
        if (!this._jwks || !this.fresh()) await this.reload();
        try {
            return await super.getKey(protectedHeader, token);
        } catch (err) {
            if (err instanceof (0, $1e405ee376479e7e$export$3d5ed1a538bed04e)) {
                if (this.coolingDown() === false) {
                    await this.reload();
                    return super.getKey(protectedHeader, token);
                }
            }
            throw err;
        }
    }
    async reload() {
        if (this._pendingFetch && $dd093a9261b0ecce$var$isCloudflareWorkers()) this._pendingFetch = undefined;
        this._pendingFetch || (this._pendingFetch = (0, $e1dfb359571a43fb$export$2e2bcd8739ae039)(this._url, this._timeoutDuration, this._options).then((json)=>{
            if (!(0, $5c5678ece69ae391$export$d01e0ebadbb4baf)(json)) throw new (0, $1e405ee376479e7e$export$9b22c2a1e2403b8e)("JSON Web Key Set malformed");
            this._jwks = {
                keys: json.keys
            };
            this._jwksTimestamp = Date.now();
            this._pendingFetch = undefined;
        }).catch((err)=>{
            this._pendingFetch = undefined;
            throw err;
        }));
        await this._pendingFetch;
    }
}
function $dd093a9261b0ecce$export$78ce35c2df51c333(url, options) {
    const set = new $dd093a9261b0ecce$var$RemoteJWKSet(url, options);
    return async function(protectedHeader, token) {
        return set.getKey(protectedHeader, token);
    };
}







class $4210bdd5fcb38337$export$6404fb90f16d8733 extends (0, $50b267cfd1995b1a$export$2ef1b74b7c7e6eb3) {
    encode() {
        const header = $033bcccb44f8a8b5$export$c564cdbbe6da493(JSON.stringify({
            alg: "none"
        }));
        const payload = $033bcccb44f8a8b5$export$c564cdbbe6da493(JSON.stringify(this._payload));
        return `${header}.${payload}.`;
    }
    static decode(jwt, options) {
        if (typeof jwt !== "string") throw new (0, $1e405ee376479e7e$export$936b39ada0bbfceb)("Unsecured JWT must be a string");
        const { 0: encodedHeader, 1: encodedPayload, 2: signature, length: length } = jwt.split(".");
        if (length !== 3 || signature !== "") throw new (0, $1e405ee376479e7e$export$936b39ada0bbfceb)("Invalid Unsecured JWT");
        let header;
        try {
            header = JSON.parse((0, $615a589604068301$export$124c96e6ce37090b).decode($033bcccb44f8a8b5$export$2f872c0f2117be69(encodedHeader)));
            if (header.alg !== "none") throw new Error();
        } catch (_a) {
            throw new (0, $1e405ee376479e7e$export$936b39ada0bbfceb)("Invalid Unsecured JWT");
        }
        const payload = (0, $3d5601cdf8f9077f$export$2e2bcd8739ae039)(header, $033bcccb44f8a8b5$export$2f872c0f2117be69(encodedPayload), options);
        return {
            payload: payload,
            header: header
        };
    }
}





const $317caa07042fa2ab$export$c564cdbbe6da493 = $033bcccb44f8a8b5$export$c564cdbbe6da493;
const $317caa07042fa2ab$export$2f872c0f2117be69 = $033bcccb44f8a8b5$export$2f872c0f2117be69;




function $9b48751f4459b364$export$ca23208356ba8d90(token) {
    let protectedB64u;
    if (typeof token === "string") {
        const parts = token.split(".");
        if (parts.length === 3 || parts.length === 5) [protectedB64u] = parts;
    } else if (typeof token === "object" && token) {
        if ("protected" in token) protectedB64u = token.protected;
        else throw new TypeError("Token does not contain a Protected Header");
    }
    try {
        if (typeof protectedB64u !== "string" || !protectedB64u) throw new Error();
        const result = JSON.parse((0, $615a589604068301$export$124c96e6ce37090b).decode((0, $317caa07042fa2ab$export$2f872c0f2117be69)(protectedB64u)));
        if (!(0, $650ccab004d5778d$export$2e2bcd8739ae039)(result)) throw new Error();
        return result;
    } catch (_a) {
        throw new TypeError("Invalid Token or Protected Header formatting");
    }
}






function $4ff4874d0e73f593$export$dcef71b8fb9a6794(jwt) {
    if (typeof jwt !== "string") throw new (0, $1e405ee376479e7e$export$936b39ada0bbfceb)("JWTs must use Compact JWS serialization, JWT must be a string");
    const { 1: payload, length: length } = jwt.split(".");
    if (length === 5) throw new (0, $1e405ee376479e7e$export$936b39ada0bbfceb)("Only JWTs using Compact JWS serialization can be decoded");
    if (length !== 3) throw new (0, $1e405ee376479e7e$export$936b39ada0bbfceb)("Invalid JWT");
    if (!payload) throw new (0, $1e405ee376479e7e$export$936b39ada0bbfceb)("JWTs must contain a payload");
    let decoded;
    try {
        decoded = (0, $317caa07042fa2ab$export$2f872c0f2117be69)(payload);
    } catch (_a) {
        throw new (0, $1e405ee376479e7e$export$936b39ada0bbfceb)("Failed to base64url decode the payload");
    }
    let result;
    try {
        result = JSON.parse((0, $615a589604068301$export$124c96e6ce37090b).decode(decoded));
    } catch (_b) {
        throw new (0, $1e405ee376479e7e$export$936b39ada0bbfceb)("Failed to parse the decoded payload as JSON");
    }
    if (!(0, $650ccab004d5778d$export$2e2bcd8739ae039)(result)) throw new (0, $1e405ee376479e7e$export$936b39ada0bbfceb)("Invalid JWT Claims Set");
    return result;
}






async function $484616cf5e365b98$export$25395fe8d170ad7(alg, options) {
    var _a;
    let length;
    let algorithm;
    let keyUsages;
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            length = parseInt(alg.slice(-3), 10);
            algorithm = {
                name: "HMAC",
                hash: `SHA-${length}`,
                length: length
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            length = parseInt(alg.slice(-3), 10);
            return (0, $b68e3f962456fa36$export$2e2bcd8739ae039)(new Uint8Array(length >> 3));
        case "A128KW":
        case "A192KW":
        case "A256KW":
            length = parseInt(alg.slice(1, 4), 10);
            algorithm = {
                name: "AES-KW",
                length: length
            };
            keyUsages = [
                "wrapKey",
                "unwrapKey"
            ];
            break;
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            length = parseInt(alg.slice(1, 4), 10);
            algorithm = {
                name: "AES-GCM",
                length: length
            };
            keyUsages = [
                "encrypt",
                "decrypt"
            ];
            break;
        default:
            throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
    }
    return (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.generateKey(algorithm, (_a = options === null || options === void 0 ? void 0 : options.extractable) !== null && _a !== void 0 ? _a : false, keyUsages);
}
function $484616cf5e365b98$var$getModulusLengthOption(options) {
    var _a;
    const modulusLength = (_a = options === null || options === void 0 ? void 0 : options.modulusLength) !== null && _a !== void 0 ? _a : 2048;
    if (typeof modulusLength !== "number" || modulusLength < 2048) throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)("Invalid or unsupported modulusLength option provided, 2048 bits or larger keys must be used");
    return modulusLength;
}
async function $484616cf5e365b98$export$a949d36eab55b41f(alg, options) {
    var _a, _b, _c;
    let algorithm;
    let keyUsages;
    switch(alg){
        case "PS256":
        case "PS384":
        case "PS512":
            algorithm = {
                name: "RSA-PSS",
                hash: `SHA-${alg.slice(-3)}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $484616cf5e365b98$var$getModulusLengthOption(options)
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "RS256":
        case "RS384":
        case "RS512":
            algorithm = {
                name: "RSASSA-PKCS1-v1_5",
                hash: `SHA-${alg.slice(-3)}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $484616cf5e365b98$var$getModulusLengthOption(options)
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            algorithm = {
                name: "RSA-OAEP",
                hash: `SHA-${parseInt(alg.slice(-3), 10) || 1}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $484616cf5e365b98$var$getModulusLengthOption(options)
            };
            keyUsages = [
                "decrypt",
                "unwrapKey",
                "encrypt",
                "wrapKey"
            ];
            break;
        case "ES256":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-256"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "ES384":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-384"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "ES512":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-521"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "EdDSA":
            keyUsages = [
                "sign",
                "verify"
            ];
            const crv = (_a = options === null || options === void 0 ? void 0 : options.crv) !== null && _a !== void 0 ? _a : "Ed25519";
            switch(crv){
                case "Ed25519":
                case "Ed448":
                    algorithm = {
                        name: crv
                    };
                    break;
                default:
                    throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)("Invalid or unsupported crv option provided");
            }
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                keyUsages = [
                    "deriveKey",
                    "deriveBits"
                ];
                const crv = (_b = options === null || options === void 0 ? void 0 : options.crv) !== null && _b !== void 0 ? _b : "P-256";
                switch(crv){
                    case "P-256":
                    case "P-384":
                    case "P-521":
                        algorithm = {
                            name: "ECDH",
                            namedCurve: crv
                        };
                        break;
                    case "X25519":
                    case "X448":
                        algorithm = {
                            name: crv
                        };
                        break;
                    default:
                        throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)("Invalid or unsupported crv option provided, supported values are P-256, P-384, P-521, X25519, and X448");
                }
                break;
            }
        default:
            throw new (0, $1e405ee376479e7e$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
    }
    return (0, $33a16233ac4f7c55$export$2e2bcd8739ae039).subtle.generateKey(algorithm, (_c = options === null || options === void 0 ? void 0 : options.extractable) !== null && _c !== void 0 ? _c : false, keyUsages);
}


async function $dd400e659b27bdcf$export$a949d36eab55b41f(alg, options) {
    return (0, $484616cf5e365b98$export$a949d36eab55b41f)(alg, options);
}



async function $5327e2a9a55dea0f$export$25395fe8d170ad7(alg, options) {
    return (0, $484616cf5e365b98$export$25395fe8d170ad7)(alg, options);
}



var $fe9c1ea9c48d60f8$export$2e2bcd8739ae039 = "WebCryptoAPI";


var $601f7658ace1eb8c$export$2e2bcd8739ae039 = (0, $fe9c1ea9c48d60f8$export$2e2bcd8739ae039);





var $jgLFK = parcelRequire("jgLFK");

var $04JJq = parcelRequire("04JJq");
var $dfb4108c2e3b89d6$exports = {};
!function(e, i) {
    var t, n;
    $dfb4108c2e3b89d6$exports = i();
}($dfb4108c2e3b89d6$exports, function() {
    return function(e) {
        var i = {};
        function t(n) {
            if (i[n]) return i[n].exports;
            var o = i[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
        }
        return t.m = e, t.c = i, t.d = function(e, i, n) {
            t.o(e, i) || Object.defineProperty(e, i, {
                enumerable: !0,
                get: n
            });
        }, t.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, t.t = function(e, i) {
            if (1 & i && (e = t(e)), 8 & i) return e;
            if (4 & i && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (t.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & i && "string" != typeof e) for(var o in e)t.d(n, o, (function(i) {
                return e[i];
            }).bind(null, o));
            return n;
        }, t.n = function(e) {
            var i = e && e.__esModule ? function() {
                return e["default"];
            } : function() {
                return e;
            };
            return t.d(i, "a", i), i;
        }, t.o = function(e, i) {
            return Object.prototype.hasOwnProperty.call(e, i);
        }, t.p = "", t(t.s = 0);
    }([
        function(e, i, t) {
            "use strict";
            var n, o, r = t(1)(), a = t(3), s = t(4), l = t(6), u = function() {
                var e = new s;
                return n = e.getResult(), o = new l, this;
            };
            u.prototype = {
                getSoftwareVersion: function() {
                    return "0.1.11";
                },
                getBrowserData: function() {
                    return n;
                },
                getFingerprint: function() {
                    var e = "|", i = n.ua, t = this.getScreenPrint(), o = this.getPlugins(), r = this.getFonts(), s = this.isLocalStorage(), l = this.isSessionStorage(), u = this.getTimeZone(), c = this.getLanguage(), d = this.getSystemLanguage(), b = this.isCookie(), m = this.getCanvasPrint();
                    return a(i + e + t + e + o + e + r + e + s + e + l + e + u + e + c + e + d + e + b + e + m, 256);
                },
                getCustomFingerprint: function() {
                    for(var e = "|", i = "", t = 0; t < arguments.length; t++)i += arguments[t] + e;
                    return a(i, 256);
                },
                getUserAgent: function() {
                    return n.ua;
                },
                getUserAgentLowerCase: function() {
                    return n.ua.toLowerCase();
                },
                getBrowser: function() {
                    return n.browser.name;
                },
                getBrowserVersion: function() {
                    return n.browser.version;
                },
                getBrowserMajorVersion: function() {
                    return n.browser.major;
                },
                isIE: function() {
                    return /IE/i.test(n.browser.name);
                },
                isChrome: function() {
                    return /Chrome/i.test(n.browser.name);
                },
                isFirefox: function() {
                    return /Firefox/i.test(n.browser.name);
                },
                isSafari: function() {
                    return /Safari/i.test(n.browser.name);
                },
                isMobileSafari: function() {
                    return /Mobile\sSafari/i.test(n.browser.name);
                },
                isOpera: function() {
                    return /Opera/i.test(n.browser.name);
                },
                getEngine: function() {
                    return n.engine.name;
                },
                getEngineVersion: function() {
                    return n.engine.version;
                },
                getOS: function() {
                    return n.os.name;
                },
                getOSVersion: function() {
                    return n.os.version;
                },
                isWindows: function() {
                    return /Windows/i.test(n.os.name);
                },
                isMac: function() {
                    return /Mac/i.test(n.os.name);
                },
                isLinux: function() {
                    return /Linux/i.test(n.os.name);
                },
                isUbuntu: function() {
                    return /Ubuntu/i.test(n.os.name);
                },
                isSolaris: function() {
                    return /Solaris/i.test(n.os.name);
                },
                getDevice: function() {
                    return n.device.model;
                },
                getDeviceType: function() {
                    return n.device.type;
                },
                getDeviceVendor: function() {
                    return n.device.vendor;
                },
                getCPU: function() {
                    return n.cpu.architecture;
                },
                isMobile: function() {
                    var e = n.ua || navigator.vendor || window.opera;
                    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(e.substr(0, 4));
                },
                isMobileMajor: function() {
                    return this.isMobileAndroid() || this.isMobileBlackBerry() || this.isMobileIOS() || this.isMobileOpera() || this.isMobileWindows();
                },
                isMobileAndroid: function() {
                    return !!n.ua.match(/Android/i);
                },
                isMobileOpera: function() {
                    return !!n.ua.match(/Opera Mini/i);
                },
                isMobileWindows: function() {
                    return !!n.ua.match(/IEMobile/i);
                },
                isMobileBlackBerry: function() {
                    return !!n.ua.match(/BlackBerry/i);
                },
                isMobileIOS: function() {
                    return !!n.ua.match(/iPhone|iPad|iPod/i);
                },
                isIphone: function() {
                    return !!n.ua.match(/iPhone/i);
                },
                isIpad: function() {
                    return !!n.ua.match(/iPad/i);
                },
                isIpod: function() {
                    return !!n.ua.match(/iPod/i);
                },
                getScreenPrint: function() {
                    return "Current Resolution: " + this.getCurrentResolution() + ", Available Resolution: " + this.getAvailableResolution() + ", Color Depth: " + this.getColorDepth() + ", Device XDPI: " + this.getDeviceXDPI() + ", Device YDPI: " + this.getDeviceYDPI();
                },
                getColorDepth: function() {
                    return screen.colorDepth;
                },
                getCurrentResolution: function() {
                    return screen.width + "x" + screen.height;
                },
                getAvailableResolution: function() {
                    return screen.availWidth + "x" + screen.availHeight;
                },
                getDeviceXDPI: function() {
                    return screen.deviceXDPI;
                },
                getDeviceYDPI: function() {
                    return screen.deviceYDPI;
                },
                getPlugins: function() {
                    for(var e = "", i = 0; i < navigator.plugins.length; i++)i == navigator.plugins.length - 1 ? e += navigator.plugins[i].name : e += navigator.plugins[i].name + ", ";
                    return e;
                },
                isJava: function() {
                    return navigator.javaEnabled();
                },
                getJavaVersion: function() {
                    throw new Error("Please use client.java.js or client.js if you need this functionality!");
                },
                isFlash: function() {
                    return !!navigator.plugins["Shockwave Flash"];
                },
                getFlashVersion: function() {
                    throw new Error("Please use client.flash.js or client.js if you need this functionality!");
                },
                isSilverlight: function() {
                    return !!navigator.plugins["Silverlight Plug-In"];
                },
                getSilverlightVersion: function() {
                    return this.isSilverlight() ? navigator.plugins["Silverlight Plug-In"].description : "";
                },
                isMimeTypes: function() {
                    return !(!navigator.mimeTypes || !navigator.mimeTypes.length);
                },
                getMimeTypes: function() {
                    var e = "";
                    if (navigator.mimeTypes) for(var i = 0; i < navigator.mimeTypes.length; i++)i == navigator.mimeTypes.length - 1 ? e += navigator.mimeTypes[i].description : e += navigator.mimeTypes[i].description + ", ";
                    return e;
                },
                isFont: function(e) {
                    return o.detect(e);
                },
                getFonts: function() {
                    for(var e = [
                        "Abadi MT Condensed Light",
                        "Adobe Fangsong Std",
                        "Adobe Hebrew",
                        "Adobe Ming Std",
                        "Agency FB",
                        "Aharoni",
                        "Andalus",
                        "Angsana New",
                        "AngsanaUPC",
                        "Aparajita",
                        "Arab",
                        "Arabic Transparent",
                        "Arabic Typesetting",
                        "Arial Baltic",
                        "Arial Black",
                        "Arial CE",
                        "Arial CYR",
                        "Arial Greek",
                        "Arial TUR",
                        "Arial",
                        "Batang",
                        "BatangChe",
                        "Bauhaus 93",
                        "Bell MT",
                        "Bitstream Vera Serif",
                        "Bodoni MT",
                        "Bookman Old Style",
                        "Braggadocio",
                        "Broadway",
                        "Browallia New",
                        "BrowalliaUPC",
                        "Calibri Light",
                        "Calibri",
                        "Californian FB",
                        "Cambria Math",
                        "Cambria",
                        "Candara",
                        "Castellar",
                        "Casual",
                        "Centaur",
                        "Century Gothic",
                        "Chalkduster",
                        "Colonna MT",
                        "Comic Sans MS",
                        "Consolas",
                        "Constantia",
                        "Copperplate Gothic Light",
                        "Corbel",
                        "Cordia New",
                        "CordiaUPC",
                        "Courier New Baltic",
                        "Courier New CE",
                        "Courier New CYR",
                        "Courier New Greek",
                        "Courier New TUR",
                        "Courier New",
                        "DFKai-SB",
                        "DaunPenh",
                        "David",
                        "DejaVu LGC Sans Mono",
                        "Desdemona",
                        "DilleniaUPC",
                        "DokChampa",
                        "Dotum",
                        "DotumChe",
                        "Ebrima",
                        "Engravers MT",
                        "Eras Bold ITC",
                        "Estrangelo Edessa",
                        "EucrosiaUPC",
                        "Euphemia",
                        "Eurostile",
                        "FangSong",
                        "Forte",
                        "FrankRuehl",
                        "Franklin Gothic Heavy",
                        "Franklin Gothic Medium",
                        "FreesiaUPC",
                        "French Script MT",
                        "Gabriola",
                        "Gautami",
                        "Georgia",
                        "Gigi",
                        "Gisha",
                        "Goudy Old Style",
                        "Gulim",
                        "GulimChe",
                        "GungSeo",
                        "Gungsuh",
                        "GungsuhChe",
                        "Haettenschweiler",
                        "Harrington",
                        "Hei S",
                        "HeiT",
                        "Heisei Kaku Gothic",
                        "Hiragino Sans GB",
                        "Impact",
                        "Informal Roman",
                        "IrisUPC",
                        "Iskoola Pota",
                        "JasmineUPC",
                        "KacstOne",
                        "KaiTi",
                        "Kalinga",
                        "Kartika",
                        "Khmer UI",
                        "Kino MT",
                        "KodchiangUPC",
                        "Kokila",
                        "Kozuka Gothic Pr6N",
                        "Lao UI",
                        "Latha",
                        "Leelawadee",
                        "Levenim MT",
                        "LilyUPC",
                        "Lohit Gujarati",
                        "Loma",
                        "Lucida Bright",
                        "Lucida Console",
                        "Lucida Fax",
                        "Lucida Sans Unicode",
                        "MS Gothic",
                        "MS Mincho",
                        "MS PGothic",
                        "MS PMincho",
                        "MS Reference Sans Serif",
                        "MS UI Gothic",
                        "MV Boli",
                        "Magneto",
                        "Malgun Gothic",
                        "Mangal",
                        "Marlett",
                        "Matura MT Script Capitals",
                        "Meiryo UI",
                        "Meiryo",
                        "Menlo",
                        "Microsoft Himalaya",
                        "Microsoft JhengHei",
                        "Microsoft New Tai Lue",
                        "Microsoft PhagsPa",
                        "Microsoft Sans Serif",
                        "Microsoft Tai Le",
                        "Microsoft Uighur",
                        "Microsoft YaHei",
                        "Microsoft Yi Baiti",
                        "MingLiU",
                        "MingLiU-ExtB",
                        "MingLiU_HKSCS",
                        "MingLiU_HKSCS-ExtB",
                        "Miriam Fixed",
                        "Miriam",
                        "Mongolian Baiti",
                        "MoolBoran",
                        "NSimSun",
                        "Narkisim",
                        "News Gothic MT",
                        "Niagara Solid",
                        "Nyala",
                        "PMingLiU",
                        "PMingLiU-ExtB",
                        "Palace Script MT",
                        "Palatino Linotype",
                        "Papyrus",
                        "Perpetua",
                        "Plantagenet Cherokee",
                        "Playbill",
                        "Prelude Bold",
                        "Prelude Condensed Bold",
                        "Prelude Condensed Medium",
                        "Prelude Medium",
                        "PreludeCompressedWGL Black",
                        "PreludeCompressedWGL Bold",
                        "PreludeCompressedWGL Light",
                        "PreludeCompressedWGL Medium",
                        "PreludeCondensedWGL Black",
                        "PreludeCondensedWGL Bold",
                        "PreludeCondensedWGL Light",
                        "PreludeCondensedWGL Medium",
                        "PreludeWGL Black",
                        "PreludeWGL Bold",
                        "PreludeWGL Light",
                        "PreludeWGL Medium",
                        "Raavi",
                        "Rachana",
                        "Rockwell",
                        "Rod",
                        "Sakkal Majalla",
                        "Sawasdee",
                        "Script MT Bold",
                        "Segoe Print",
                        "Segoe Script",
                        "Segoe UI Light",
                        "Segoe UI Semibold",
                        "Segoe UI Symbol",
                        "Segoe UI",
                        "Shonar Bangla",
                        "Showcard Gothic",
                        "Shruti",
                        "SimHei",
                        "SimSun",
                        "SimSun-ExtB",
                        "Simplified Arabic Fixed",
                        "Simplified Arabic",
                        "Snap ITC",
                        "Sylfaen",
                        "Symbol",
                        "Tahoma",
                        "Times New Roman Baltic",
                        "Times New Roman CE",
                        "Times New Roman CYR",
                        "Times New Roman Greek",
                        "Times New Roman TUR",
                        "Times New Roman",
                        "TlwgMono",
                        "Traditional Arabic",
                        "Trebuchet MS",
                        "Tunga",
                        "Tw Cen MT Condensed Extra Bold",
                        "Ubuntu",
                        "Umpush",
                        "Univers",
                        "Utopia",
                        "Utsaah",
                        "Vani",
                        "Verdana",
                        "Vijaya",
                        "Vladimir Script",
                        "Vrinda",
                        "Webdings",
                        "Wide Latin",
                        "Wingdings"
                    ], i = "", t = 0; t < e.length; t++)o.detect(e[t]) && (i += t == e.length - 1 ? e[t] : e[t] + ", ");
                    return i;
                },
                isLocalStorage: function() {
                    try {
                        return !!r.localStorage;
                    } catch (e) {
                        return !0;
                    }
                },
                isSessionStorage: function() {
                    try {
                        return !!r.sessionStorage;
                    } catch (e) {
                        return !0;
                    }
                },
                isCookie: function() {
                    return navigator.cookieEnabled;
                },
                getTimeZone: function() {
                    var e, i;
                    return e = new Date, (i = String(-e.getTimezoneOffset() / 60)) < 0 ? "-" + ("0" + (i *= -1)).slice(-2) : "+" + ("0" + i).slice(-2);
                },
                getLanguage: function() {
                    return navigator.language;
                },
                getSystemLanguage: function() {
                    return navigator.systemLanguage || window.navigator.language;
                },
                isCanvas: function() {
                    var e = document.createElement("canvas");
                    try {
                        return !(!e.getContext || !e.getContext("2d"));
                    } catch (i) {
                        return !1;
                    }
                },
                getCanvasPrint: function() {
                    var e, i = document.createElement("canvas");
                    try {
                        e = i.getContext("2d");
                    } catch (n) {
                        return "";
                    }
                    var t = "ClientJS,org <canvas> 1.0";
                    return e.textBaseline = "top", e.font = "14px 'Arial'", e.textBaseline = "alphabetic", e.fillStyle = "#f60", e.fillRect(125, 1, 62, 20), e.fillStyle = "#069", e.fillText(t, 2, 15), e.fillStyle = "rgba(102, 204, 0, 0.7)", e.fillText(t, 4, 17), i.toDataURL();
                }
            }, i.ClientJS = u;
        },
        function(e, i, t) {
            "use strict";
            var n = t(2);
            e.exports = function() {
                return "object" == typeof $parcel$global && $parcel$global && $parcel$global.Math === Math && $parcel$global.Array === Array ? $parcel$global : n;
            };
        },
        function(e, i, t) {
            "use strict";
            "undefined" != typeof self ? e.exports = self : "undefined" != typeof window ? e.exports = window : e.exports = Function("return this")();
        },
        function(e, i, t) {
            e.exports = function(e, i) {
                var t, n, o, r, a, s, l, u;
                for(t = 3 & e.length, n = e.length - t, o = i, a = 3432918353, s = 461845907, u = 0; u < n;)l = 255 & e.charCodeAt(u) | (255 & e.charCodeAt(++u)) << 8 | (255 & e.charCodeAt(++u)) << 16 | (255 & e.charCodeAt(++u)) << 24, ++u, o = 27492 + (65535 & (r = 5 * (65535 & (o = (o ^= l = (65535 & (l = (l = (65535 & l) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295) << 13 | o >>> 19)) + ((5 * (o >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (r >>> 16) & 65535) << 16);
                switch(l = 0, t){
                    case 3:
                        l ^= (255 & e.charCodeAt(u + 2)) << 16;
                    case 2:
                        l ^= (255 & e.charCodeAt(u + 1)) << 8;
                    case 1:
                        o ^= l = (65535 & (l = (l = (65535 & (l ^= 255 & e.charCodeAt(u))) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295;
                }
                return o ^= e.length, o = 2246822507 * (65535 & (o ^= o >>> 16)) + ((2246822507 * (o >>> 16) & 65535) << 16) & 4294967295, o = 3266489909 * (65535 & (o ^= o >>> 13)) + ((3266489909 * (o >>> 16) & 65535) << 16) & 4294967295, (o ^= o >>> 16) >>> 0;
            };
        },
        function(e, i, t) {
            var n;
            !function(o, r) {
                "use strict";
                var a = "function", s = "undefined", l = "object", u = "string", c = "model", d = "name", b = "type", m = "vendor", w = "version", g = "architecture", p = "console", f = "mobile", h = "tablet", v = "smarttv", y = "wearable", x = "embedded", k = "Amazon", S = "Apple", C = "ASUS", M = "BlackBerry", P = "Firefox", T = "Google", B = "Huawei", A = "LG", L = "Microsoft", U = "Motorola", E = "Opera", G = "Samsung", N = "Sony", j = "Xiaomi", _ = "Zebra", R = "Facebook", D = function(e) {
                    var i = {};
                    for(var t in e)i[e[t].toUpperCase()] = e[t];
                    return i;
                }, I = function(e, i) {
                    return typeof e === u && -1 !== O(i).indexOf(O(e));
                }, O = function(e) {
                    return e.toLowerCase();
                }, z = function(e, i) {
                    if (typeof e === u) return e = e.replace(/^\s\s*/, "").replace(/\s\s*$/, ""), typeof i === s ? e : e.substring(0, 255);
                }, F = function(e, i) {
                    for(var t, n, o, s, u, c, d = 0; d < i.length && !u;){
                        var b = i[d], m = i[d + 1];
                        for(t = n = 0; t < b.length && !u;)if (u = b[t++].exec(e)) for(o = 0; o < m.length; o++)c = u[++n], typeof (s = m[o]) === l && s.length > 0 ? 2 == s.length ? typeof s[1] == a ? this[s[0]] = s[1].call(this, c) : this[s[0]] = s[1] : 3 == s.length ? typeof s[1] !== a || s[1].exec && s[1].test ? this[s[0]] = c ? c.replace(s[1], s[2]) : r : this[s[0]] = c ? s[1].call(this, c, s[2]) : r : 4 == s.length && (this[s[0]] = c ? s[3].call(this, c.replace(s[1], s[2])) : r) : this[s] = c || r;
                        d += 2;
                    }
                }, q = function(e, i) {
                    for(var t in i)if (typeof i[t] === l && i[t].length > 0) {
                        for(var n = 0; n < i[t].length; n++)if (I(i[t][n], e)) return "?" === t ? r : t;
                    } else if (I(i[t], e)) return "?" === t ? r : t;
                    return e;
                }, W = {
                    ME: "4.90",
                    "NT 3.11": "NT3.51",
                    "NT 4.0": "NT4.0",
                    2e3: "NT 5.0",
                    XP: [
                        "NT 5.1",
                        "NT 5.2"
                    ],
                    Vista: "NT 6.0",
                    7: "NT 6.1",
                    8: "NT 6.2",
                    8.1: "NT 6.3",
                    10: [
                        "NT 6.4",
                        "NT 10.0"
                    ],
                    RT: "ARM"
                }, V = {
                    browser: [
                        [
                            /\b(?:crmo|crios)\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Chrome"
                            ]
                        ],
                        [
                            /edg(?:e|ios|a)?\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Edge"
                            ]
                        ],
                        [
                            /(opera mini)\/([-\w\.]+)/i,
                            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
                        ],
                        [
                            d,
                            w
                        ],
                        [
                            /opios[\/ ]+([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Opera Mini"
                            ]
                        ],
                        [
                            /\bopr\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                E
                            ]
                        ],
                        [
                            /(kindle)\/([\w\.]+)/i,
                            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                            /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
                            /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
                            /(?:ms|\()(ie) ([\w\.]+)/i,
                            /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i,
                            /(weibo)__([\d\.]+)/i
                        ],
                        [
                            d,
                            w
                        ],
                        [
                            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "UCBrowser"
                            ]
                        ],
                        [
                            /\bqbcore\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "WeChat(Win) Desktop"
                            ]
                        ],
                        [
                            /micromessenger\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "WeChat"
                            ]
                        ],
                        [
                            /konqueror\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Konqueror"
                            ]
                        ],
                        [
                            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
                        ],
                        [
                            w,
                            [
                                d,
                                "IE"
                            ]
                        ],
                        [
                            /yabrowser\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Yandex"
                            ]
                        ],
                        [
                            /(avast|avg)\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                /(.+)/,
                                "$1 Secure Browser"
                            ],
                            w
                        ],
                        [
                            /\bfocus\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Firefox Focus"
                            ]
                        ],
                        [
                            /\bopt\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Opera Touch"
                            ]
                        ],
                        [
                            /coc_coc\w+\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Coc Coc"
                            ]
                        ],
                        [
                            /dolfin\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Dolphin"
                            ]
                        ],
                        [
                            /coast\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Opera Coast"
                            ]
                        ],
                        [
                            /miuibrowser\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "MIUI Browser"
                            ]
                        ],
                        [
                            /fxios\/([-\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                P
                            ]
                        ],
                        [
                            /\bqihu|(qi?ho?o?|360)browser/i
                        ],
                        [
                            [
                                d,
                                "360 Browser"
                            ]
                        ],
                        [
                            /(oculus|samsung|sailfish)browser\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                /(.+)/,
                                "$1 Browser"
                            ],
                            w
                        ],
                        [
                            /(comodo_dragon)\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                /_/g,
                                " "
                            ],
                            w
                        ],
                        [
                            /(electron)\/([\w\.]+) safari/i,
                            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                            /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i
                        ],
                        [
                            d,
                            w
                        ],
                        [
                            /(metasr)[\/ ]?([\w\.]+)/i,
                            /(lbbrowser)/i
                        ],
                        [
                            d
                        ],
                        [
                            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
                        ],
                        [
                            [
                                d,
                                R
                            ],
                            w
                        ],
                        [
                            /safari (line)\/([\w\.]+)/i,
                            /\b(line)\/([\w\.]+)\/iab/i,
                            /(chromium|instagram)[\/ ]([-\w\.]+)/i
                        ],
                        [
                            d,
                            w
                        ],
                        [
                            /\bgsa\/([\w\.]+) .*safari\//i
                        ],
                        [
                            w,
                            [
                                d,
                                "GSA"
                            ]
                        ],
                        [
                            /headlesschrome(?:\/([\w\.]+)| )/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Chrome Headless"
                            ]
                        ],
                        [
                            / wv\).+(chrome)\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                "Chrome WebView"
                            ],
                            w
                        ],
                        [
                            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Android Browser"
                            ]
                        ],
                        [
                            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
                        ],
                        [
                            d,
                            w
                        ],
                        [
                            /version\/([\w\.]+) .*mobile\/\w+ (safari)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Mobile Safari"
                            ]
                        ],
                        [
                            /version\/([\w\.]+) .*(mobile ?safari|safari)/i
                        ],
                        [
                            w,
                            d
                        ],
                        [
                            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
                        ],
                        [
                            d,
                            [
                                w,
                                q,
                                {
                                    "1.0": "/8",
                                    1.2: "/1",
                                    1.3: "/3",
                                    "2.0": "/412",
                                    "2.0.2": "/416",
                                    "2.0.3": "/417",
                                    "2.0.4": "/419",
                                    "?": "/"
                                }
                            ]
                        ],
                        [
                            /(webkit|khtml)\/([\w\.]+)/i
                        ],
                        [
                            d,
                            w
                        ],
                        [
                            /(navigator|netscape\d?)\/([-\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                "Netscape"
                            ],
                            w
                        ],
                        [
                            /mobile vr; rv:([\w\.]+)\).+firefox/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Firefox Reality"
                            ]
                        ],
                        [
                            /ekiohf.+(flow)\/([\w\.]+)/i,
                            /(swiftfox)/i,
                            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                            /(firefox)\/([\w\.]+)/i,
                            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                            /(links) \(([\w\.]+)/i
                        ],
                        [
                            d,
                            w
                        ]
                    ],
                    cpu: [
                        [
                            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
                        ],
                        [
                            [
                                g,
                                "amd64"
                            ]
                        ],
                        [
                            /(ia32(?=;))/i
                        ],
                        [
                            [
                                g,
                                O
                            ]
                        ],
                        [
                            /((?:i[346]|x)86)[;\)]/i
                        ],
                        [
                            [
                                g,
                                "ia32"
                            ]
                        ],
                        [
                            /\b(aarch64|arm(v?8e?l?|_?64))\b/i
                        ],
                        [
                            [
                                g,
                                "arm64"
                            ]
                        ],
                        [
                            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
                        ],
                        [
                            [
                                g,
                                "armhf"
                            ]
                        ],
                        [
                            /windows (ce|mobile); ppc;/i
                        ],
                        [
                            [
                                g,
                                "arm"
                            ]
                        ],
                        [
                            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
                        ],
                        [
                            [
                                g,
                                /ower/,
                                "",
                                O
                            ]
                        ],
                        [
                            /(sun4\w)[;\)]/i
                        ],
                        [
                            [
                                g,
                                "sparc"
                            ]
                        ],
                        [
                            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                        ],
                        [
                            [
                                g,
                                O
                            ]
                        ]
                    ],
                    device: [
                        [
                            /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
                        ],
                        [
                            c,
                            [
                                m,
                                G
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,
                            /samsung[- ]([-\w]+)/i,
                            /sec-(sgh\w+)/i
                        ],
                        [
                            c,
                            [
                                m,
                                G
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\((ip(?:hone|od)[\w ]*);/i
                        ],
                        [
                            c,
                            [
                                m,
                                S
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\((ipad);[-\w\),; ]+apple/i,
                            /applecoremedia\/[\w\.]+ \((ipad)/i,
                            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
                        ],
                        [
                            c,
                            [
                                m,
                                S
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
                        ],
                        [
                            c,
                            [
                                m,
                                B
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /(?:huawei|honor)([-\w ]+)[;\)]/i,
                            /\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i
                        ],
                        [
                            c,
                            [
                                m,
                                B
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\b(poco[\w ]+)(?: bui|\))/i,
                            /\b; (\w+) build\/hm\1/i,
                            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
                        ],
                        [
                            [
                                c,
                                /_/g,
                                " "
                            ],
                            [
                                m,
                                j
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
                        ],
                        [
                            [
                                c,
                                /_/g,
                                " "
                            ],
                            [
                                m,
                                j
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /; (\w+) bui.+ oppo/i,
                            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007)\b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "OPPO"
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /vivo (\w+)(?: bui|\))/i,
                            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Vivo"
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\b(rmx[12]\d{3})(?: bui|;|\))/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Realme"
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                            /\bmot(?:orola)?[- ](\w*)/i,
                            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
                        ],
                        [
                            c,
                            [
                                m,
                                U
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
                        ],
                        [
                            c,
                            [
                                m,
                                U
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
                        ],
                        [
                            c,
                            [
                                m,
                                A
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                            /\blg-?([\d\w]+) bui/i
                        ],
                        [
                            c,
                            [
                                m,
                                A
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /(ideatab[-\w ]+)/i,
                            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Lenovo"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /(?:maemo|nokia).*(n900|lumia \d+)/i,
                            /nokia[-_ ]?([-\w\.]*)/i
                        ],
                        [
                            [
                                c,
                                /_/g,
                                " "
                            ],
                            [
                                m,
                                "Nokia"
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /(pixel c)\b/i
                        ],
                        [
                            c,
                            [
                                m,
                                T
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
                        ],
                        [
                            c,
                            [
                                m,
                                T
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /droid.+ ([c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
                        ],
                        [
                            c,
                            [
                                m,
                                N
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /sony tablet [ps]/i,
                            /\b(?:sony)?sgp\w+(?: bui|\))/i
                        ],
                        [
                            [
                                c,
                                "Xperia Tablet"
                            ],
                            [
                                m,
                                N
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            / (kb2005|in20[12]5|be20[12][59])\b/i,
                            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
                        ],
                        [
                            c,
                            [
                                m,
                                "OnePlus"
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /(alexa)webm/i,
                            /(kf[a-z]{2}wi)( bui|\))/i,
                            /(kf[a-z]+)( bui|\)).+silk\//i
                        ],
                        [
                            c,
                            [
                                m,
                                k
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
                        ],
                        [
                            [
                                c,
                                /(.+)/g,
                                "Fire Phone $1"
                            ],
                            [
                                m,
                                k
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /(playbook);[-\w\),; ]+(rim)/i
                        ],
                        [
                            c,
                            m,
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b((?:bb[a-f]|st[hv])100-\d)/i,
                            /\(bb10; (\w+)/i
                        ],
                        [
                            c,
                            [
                                m,
                                M
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
                        ],
                        [
                            c,
                            [
                                m,
                                C
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
                        ],
                        [
                            c,
                            [
                                m,
                                C
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /(nexus 9)/i
                        ],
                        [
                            c,
                            [
                                m,
                                "HTC"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                            /(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i
                        ],
                        [
                            m,
                            [
                                c,
                                /_/g,
                                " "
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Acer"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /droid.+; (m[1-5] note) bui/i,
                            /\bmz-([-\w]{2,})/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Meizu"
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Sharp"
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
                            /(hp) ([\w ]+\w)/i,
                            /(asus)-?(\w+)/i,
                            /(microsoft); (lumia[\w ]+)/i,
                            /(lenovo)[-_ ]?([-\w]+)/i,
                            /(jolla)/i,
                            /(oppo) ?([\w ]+) bui/i
                        ],
                        [
                            m,
                            c,
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /(archos) (gamepad2?)/i,
                            /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                            /(kindle)\/([\w\.]+)/i,
                            /(nook)[\w ]+build\/(\w+)/i,
                            /(dell) (strea[kpr\d ]*[\dko])/i,
                            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                            /(trinity)[- ]*(t\d{3}) bui/i,
                            /(gigaset)[- ]+(q\w{1,9}) bui/i,
                            /(vodafone) ([\w ]+)(?:\)| bui)/i
                        ],
                        [
                            m,
                            c,
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /(surface duo)/i
                        ],
                        [
                            c,
                            [
                                m,
                                L
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /droid [\d\.]+; (fp\du?)(?: b|\))/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Fairphone"
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /(u304aa)/i
                        ],
                        [
                            c,
                            [
                                m,
                                "AT&T"
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\bsie-(\w*)/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Siemens"
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\b(rct\w+) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "RCA"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b(venue[\d ]{2,7}) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Dell"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b(q(?:mv|ta)\w+) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Verizon"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Barnes & Noble"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b(tm\d{3}\w+) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "NuVision"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b(k88) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "ZTE"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b(nx\d{3}j) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "ZTE"
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\b(gen\d{3}) b.+49h/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Swiss"
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\b(zur\d{3}) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Swiss"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b((zeki)?tb.*\b) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Zeki"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b([yr]\d{2}) b/i,
                            /\b(dragon[- ]+touch |dt)(\w{5}) b/i
                        ],
                        [
                            [
                                m,
                                "Dragon Touch"
                            ],
                            c,
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b(ns-?\w{0,9}) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Insignia"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b((nxa|next)-?\w{0,9}) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "NextBook"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
                        ],
                        [
                            [
                                m,
                                "Voice"
                            ],
                            c,
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\b(lvtel\-)?(v1[12]) b/i
                        ],
                        [
                            [
                                m,
                                "LvTel"
                            ],
                            c,
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\b(ph-1) /i
                        ],
                        [
                            c,
                            [
                                m,
                                "Essential"
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\b(v(100md|700na|7011|917g).*\b) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Envizen"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b(trio[-\w\. ]+) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "MachSpeed"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\btu_(1491) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Rotor"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /(shield[\w ]+) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Nvidia"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /(sprint) (\w+)/i
                        ],
                        [
                            m,
                            c,
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /(kin\.[onetw]{3})/i
                        ],
                        [
                            [
                                c,
                                /\./g,
                                " "
                            ],
                            [
                                m,
                                L
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
                        ],
                        [
                            c,
                            [
                                m,
                                _
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
                        ],
                        [
                            c,
                            [
                                m,
                                _
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /(ouya)/i,
                            /(nintendo) ([wids3utch]+)/i
                        ],
                        [
                            m,
                            c,
                            [
                                b,
                                p
                            ]
                        ],
                        [
                            /droid.+; (shield) bui/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Nvidia"
                            ],
                            [
                                b,
                                p
                            ]
                        ],
                        [
                            /(playstation [345portablevi]+)/i
                        ],
                        [
                            c,
                            [
                                m,
                                N
                            ],
                            [
                                b,
                                p
                            ]
                        ],
                        [
                            /\b(xbox(?: one)?(?!; xbox))[\); ]/i
                        ],
                        [
                            c,
                            [
                                m,
                                L
                            ],
                            [
                                b,
                                p
                            ]
                        ],
                        [
                            /smart-tv.+(samsung)/i
                        ],
                        [
                            m,
                            [
                                b,
                                v
                            ]
                        ],
                        [
                            /hbbtv.+maple;(\d+)/i
                        ],
                        [
                            [
                                c,
                                /^/,
                                "SmartTV"
                            ],
                            [
                                m,
                                G
                            ],
                            [
                                b,
                                v
                            ]
                        ],
                        [
                            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
                        ],
                        [
                            [
                                m,
                                A
                            ],
                            [
                                b,
                                v
                            ]
                        ],
                        [
                            /(apple) ?tv/i
                        ],
                        [
                            m,
                            [
                                c,
                                "Apple TV"
                            ],
                            [
                                b,
                                v
                            ]
                        ],
                        [
                            /crkey/i
                        ],
                        [
                            [
                                c,
                                "Chromecast"
                            ],
                            [
                                m,
                                T
                            ],
                            [
                                b,
                                v
                            ]
                        ],
                        [
                            /droid.+aft(\w)( bui|\))/i
                        ],
                        [
                            c,
                            [
                                m,
                                k
                            ],
                            [
                                b,
                                v
                            ]
                        ],
                        [
                            /\(dtv[\);].+(aquos)/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Sharp"
                            ],
                            [
                                b,
                                v
                            ]
                        ],
                        [
                            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                            /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i
                        ],
                        [
                            [
                                m,
                                z
                            ],
                            [
                                c,
                                z
                            ],
                            [
                                b,
                                v
                            ]
                        ],
                        [
                            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
                        ],
                        [
                            [
                                b,
                                v
                            ]
                        ],
                        [
                            /((pebble))app/i
                        ],
                        [
                            m,
                            c,
                            [
                                b,
                                y
                            ]
                        ],
                        [
                            /droid.+; (glass) \d/i
                        ],
                        [
                            c,
                            [
                                m,
                                T
                            ],
                            [
                                b,
                                y
                            ]
                        ],
                        [
                            /droid.+; (wt63?0{2,3})\)/i
                        ],
                        [
                            c,
                            [
                                m,
                                _
                            ],
                            [
                                b,
                                y
                            ]
                        ],
                        [
                            /(quest( 2)?)/i
                        ],
                        [
                            c,
                            [
                                m,
                                R
                            ],
                            [
                                b,
                                y
                            ]
                        ],
                        [
                            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                b,
                                x
                            ]
                        ],
                        [
                            /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i
                        ],
                        [
                            c,
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
                        ],
                        [
                            c,
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
                        ],
                        [
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i
                        ],
                        [
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /(android[-\w\. ]{0,9});.+buil/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Generic"
                            ]
                        ]
                    ],
                    engine: [
                        [
                            /windows.+ edge\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "EdgeHTML"
                            ]
                        ],
                        [
                            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Blink"
                            ]
                        ],
                        [
                            /(presto)\/([\w\.]+)/i,
                            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                            /ekioh(flow)\/([\w\.]+)/i,
                            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                            /(icab)[\/ ]([23]\.[\d\.]+)/i
                        ],
                        [
                            d,
                            w
                        ],
                        [
                            /rv\:([\w\.]{1,9})\b.+(gecko)/i
                        ],
                        [
                            w,
                            d
                        ]
                    ],
                    os: [
                        [
                            /microsoft (windows) (vista|xp)/i
                        ],
                        [
                            d,
                            w
                        ],
                        [
                            /(windows) nt 6\.2; (arm)/i,
                            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
                            /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
                        ],
                        [
                            d,
                            [
                                w,
                                q,
                                W
                            ]
                        ],
                        [
                            /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
                        ],
                        [
                            [
                                d,
                                "Windows"
                            ],
                            [
                                w,
                                q,
                                W
                            ]
                        ],
                        [
                            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                            /cfnetwork\/.+darwin/i
                        ],
                        [
                            [
                                w,
                                /_/g,
                                "."
                            ],
                            [
                                d,
                                "iOS"
                            ]
                        ],
                        [
                            /(mac os x) ?([\w\. ]*)/i,
                            /(macintosh|mac_powerpc\b)(?!.+haiku)/i
                        ],
                        [
                            [
                                d,
                                "Mac OS"
                            ],
                            [
                                w,
                                /_/g,
                                "."
                            ]
                        ],
                        [
                            /droid ([\w\.]+)\b.+(android[- ]x86)/i
                        ],
                        [
                            w,
                            d
                        ],
                        [
                            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                            /(blackberry)\w*\/([\w\.]*)/i,
                            /(tizen|kaios)[\/ ]([\w\.]+)/i,
                            /\((series40);/i
                        ],
                        [
                            d,
                            w
                        ],
                        [
                            /\(bb(10);/i
                        ],
                        [
                            w,
                            [
                                d,
                                M
                            ]
                        ],
                        [
                            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Symbian"
                            ]
                        ],
                        [
                            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Firefox OS"
                            ]
                        ],
                        [
                            /web0s;.+rt(tv)/i,
                            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "webOS"
                            ]
                        ],
                        [
                            /crkey\/([\d\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Chromecast"
                            ]
                        ],
                        [
                            /(cros) [\w]+ ([\w\.]+\w)/i
                        ],
                        [
                            [
                                d,
                                "Chromium OS"
                            ],
                            w
                        ],
                        [
                            /(nintendo|playstation) ([wids345portablevuch]+)/i,
                            /(xbox); +xbox ([^\);]+)/i,
                            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                            /(mint)[\/\(\) ]?(\w*)/i,
                            /(mageia|vectorlinux)[; ]/i,
                            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                            /(hurd|linux) ?([\w\.]*)/i,
                            /(gnu) ?([\w\.]*)/i,
                            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                            /(haiku) (\w+)/i
                        ],
                        [
                            d,
                            w
                        ],
                        [
                            /(sunos) ?([\w\.\d]*)/i
                        ],
                        [
                            [
                                d,
                                "Solaris"
                            ],
                            w
                        ],
                        [
                            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,
                            /(unix) ?([\w\.]*)/i
                        ],
                        [
                            d,
                            w
                        ]
                    ]
                }, H = function(e, i) {
                    if (typeof e === l && (i = e, e = r), !(this instanceof H)) return new H(e, i).getResult();
                    var t = e || (typeof o !== s && o.navigator && o.navigator.userAgent ? o.navigator.userAgent : ""), n = i ? function(e, i) {
                        var t = {};
                        for(var n in e)i[n] && i[n].length % 2 == 0 ? t[n] = i[n].concat(e[n]) : t[n] = e[n];
                        return t;
                    }(V, i) : V;
                    return this.getBrowser = function() {
                        var e, i = {};
                        return i.name = r, i.version = r, F.call(i, t, n.browser), i.major = typeof (e = i.version) === u ? e.replace(/[^\d\.]/g, "").split(".")[0] : r, i;
                    }, this.getCPU = function() {
                        var e = {};
                        return e.architecture = r, F.call(e, t, n.cpu), e;
                    }, this.getDevice = function() {
                        var e = {};
                        return e.vendor = r, e.model = r, e.type = r, F.call(e, t, n.device), e;
                    }, this.getEngine = function() {
                        var e = {};
                        return e.name = r, e.version = r, F.call(e, t, n.engine), e;
                    }, this.getOS = function() {
                        var e = {};
                        return e.name = r, e.version = r, F.call(e, t, n.os), e;
                    }, this.getResult = function() {
                        return {
                            ua: this.getUA(),
                            browser: this.getBrowser(),
                            engine: this.getEngine(),
                            os: this.getOS(),
                            device: this.getDevice(),
                            cpu: this.getCPU()
                        };
                    }, this.getUA = function() {
                        return t;
                    }, this.setUA = function(e) {
                        return t = typeof e === u && e.length > 255 ? z(e, 255) : e, this;
                    }, this.setUA(t), this;
                };
                H.VERSION = "0.7.30", H.BROWSER = D([
                    d,
                    w,
                    "major"
                ]), H.CPU = D([
                    g
                ]), H.DEVICE = D([
                    c,
                    m,
                    b,
                    p,
                    f,
                    v,
                    h,
                    y,
                    x
                ]), H.ENGINE = H.OS = D([
                    d,
                    w
                ]), typeof i !== s ? (typeof e !== s && e.exports && (i = e.exports = H), i.UAParser = H) : t(5) ? (n = (function() {
                    return H;
                }).call(i, t, i, e)) === r || (e.exports = n) : typeof o !== s && (o.UAParser = H);
                var K = typeof o !== s && (o.jQuery || o.Zepto);
                if (K && !K.ua) {
                    var Y = new H;
                    K.ua = Y.getResult(), K.ua.get = function() {
                        return Y.getUA();
                    }, K.ua.set = function(e) {
                        Y.setUA(e);
                        var i = Y.getResult();
                        for(var t in i)K.ua[t] = i[t];
                    };
                }
            }("object" == typeof window ? window : this);
        },
        function(e, i) {
            (function(i) {
                e.exports = i;
            }).call(this, {});
        },
        function(e, i) {
            e.exports = function() {
                var e = [
                    "monospace",
                    "sans-serif",
                    "serif"
                ], i = document.getElementsByTagName("body")[0], t = document.createElement("span");
                t.style.fontSize = "72px", t.innerHTML = "mmmmmmmmmmlli";
                var n = {}, o = {};
                for(var r in e)t.style.fontFamily = e[r], i.appendChild(t), n[e[r]] = t.offsetWidth, o[e[r]] = t.offsetHeight, i.removeChild(t);
                this.detect = function(r) {
                    var a = !1;
                    for(var s in e){
                        t.style.fontFamily = r + "," + e[s], i.appendChild(t);
                        var l = t.offsetWidth != n[e[s]] || t.offsetHeight != o[e[s]];
                        i.removeChild(t), a = a || l;
                    }
                    return a;
                };
            };
        }
    ]);
});


/**
 * Copyright 2023 ALPHAGUARD CONSULTING, LLC.  All rights reserved.
 * Use of this source code is governed by a Commercial License Agreement
 * license can be found in the LICENSE file or contact legal@alphaguard.io
 */ 
var $3XnHf = parcelRequire("3XnHf");

var $7oLjV = parcelRequire("7oLjV");

var $7V8eP = parcelRequire("7V8eP");
const $56f021744c00b1a4$var$playerApi = (0, $7oLjV.default).injectEndpoints({
    endpoints: (builder)=>({
            authenticate: builder.query({
                query: (data)=>({
                        url: "/display/authenticate",
                        method: "POST",
                        body: {
                            data: data
                        }
                    })
            }),
            registerDisplay: builder.mutation({
                query (data) {
                    return {
                        url: `/displays`,
                        method: "POST",
                        body: {
                            data: data
                        }
                    };
                }
            }),
            statusUpdate: builder.query({
                query: (id)=>`/display/${id}/status`
            }),
            getDisplayCode: builder.query({
                queryFn: async (req, api)=>{
                    const res = await api.dispatch($56f021744c00b1a4$var$playerApi.endpoints.registerDisplay.initiate(req));
                    return res;
                }
            }),
            getDisplayGroups: builder.query({
                query: (id)=>{
                    const query = {
                        populate: {
                            groups: {
                                fields: [
                                    "id"
                                ]
                            }
                        }
                    };
                    return `/displays/${id}?${(0, (/*@__PURE__*/$parcel$interopDefault($3XnHf))).stringify(query, {
                        encodeValuesOnly: true
                    })}`;
                },
                transformResponse: (res, meta, arg)=>({
                        data: (0, $7oLjV.getListModel)((0, (/*@__PURE__*/$parcel$interopDefault($7V8eP)))(res, "data.attributes.groups.data", [])),
                        meta: (0, (/*@__PURE__*/$parcel$interopDefault($7V8eP)))(res, "meta", {}),
                        original: (0, (/*@__PURE__*/$parcel$interopDefault($7V8eP)))(res, "data")
                    })
            }),
            getBranchTemplate: builder.query({
                providesTags: (result, error, arg)=>[
                        {
                            type: "DisplayTemplates",
                            id: result?.id || "LIST"
                        }
                    ],
                query: (branchId)=>`/display-templates?${(0, (/*@__PURE__*/$parcel$interopDefault($3XnHf))).stringify({
                        branchId: branchId,
                        default: true
                    }, {
                        encodeValuesOnly: true
                    })}`,
                transformResponse: (res, meta, arg)=>(0, (/*@__PURE__*/$parcel$interopDefault($7V8eP)))(res, "data", {})
            })
        }),
    overrideExisting: false
});
const { useGetDisplayGroupsQuery: $56f021744c00b1a4$export$f76eb9f1722003ca, useGetBranchTemplateQuery: $56f021744c00b1a4$export$814b52391038d2bf, useAuthenticateQuery: $56f021744c00b1a4$export$6d2000fc9897b03d, useDisplayCodeMutation: $56f021744c00b1a4$export$a515e49efc16da7e, useGetDisplayCodeQuery: $56f021744c00b1a4$export$df52b11a007552ab, useRegisterDisplayMutation: $56f021744c00b1a4$export$e3b4dc7264a67b3b, useStatusUpdateQuery: $56f021744c00b1a4$export$39d9d702b23ca703 } = $56f021744c00b1a4$var$playerApi;
var $56f021744c00b1a4$export$2e2bcd8739ae039 = $56f021744c00b1a4$var$playerApi;



var $dYzX4 = parcelRequire("dYzX4");
function $09c8514a3acd9d5d$var$fareyApproximation(val, lim) {
    let lower = [
        0,
        1
    ];
    let upper = [
        1,
        0
    ];
    while(true){
        let mediant = [
            lower[0] + upper[0],
            lower[1] + upper[1]
        ];
        if (val * mediant[1] > mediant[0]) {
            if (lim < mediant[1]) return upper;
            lower = mediant;
        } else if (val * mediant[1] === mediant[0]) {
            if (lim >= mediant[1]) return mediant;
            return lower[1] < upper[1] ? lower : upper;
        } else {
            if (lim < mediant[1]) return lower;
            upper = mediant;
        }
    }
}
const $09c8514a3acd9d5d$export$402482a772100d68 = ()=>{
    const width = window.screen.width * window.devicePixelRatio;
    const height = window.screen.height * window.devicePixelRatio;
    const ratio = $09c8514a3acd9d5d$var$fareyApproximation(width / height, Math.max(width, height));
    return `${ratio[0]}:${ratio[1]}`;
};



var $lQ3n3 = parcelRequire("lQ3n3");
// Create a new ClientJS object
const $c42107aeec692061$export$b08658138c4f5ab9 = new (0, $dfb4108c2e3b89d6$exports.ClientJS)();
const $c42107aeec692061$var$TOKEN_KEY = "player_ctx";
const $c42107aeec692061$var$getStateFromObject = (data)=>({
        displayId: (0, $jgLFK.get)(data, "displayId"),
        auth: {
            isAuthenticated: !!(0, $jgLFK.get)(data, "accessToken"),
            jwt: (0, $jgLFK.get)(data, "accessToken"),
            id: (0, $jgLFK.get)(data, "id")
        },
        branch: {
            id: (0, $jgLFK.get)(data, "branchId"),
            groups: (0, $jgLFK.get)(data, "groups", [])
        }
    });
const $c42107aeec692061$var$initFromStorage = ()=>{
    const browserInfo = {
        browserDetails: {
            browserName: $c42107aeec692061$export$b08658138c4f5ab9.getBrowser(),
            browserMajorVersion: $c42107aeec692061$export$b08658138c4f5ab9.getBrowserMajorVersion(),
            browserFullVersion: $c42107aeec692061$export$b08658138c4f5ab9.getBrowserVersion(),
            // Operating system name. Examples: 'Mac OS X', 'Android'.
            os: $c42107aeec692061$export$b08658138c4f5ab9.getOS(),
            osVersion: $c42107aeec692061$export$b08658138c4f5ab9.getOSVersion(),
            // Device. For desktop/laptop devices, the value will be "Other". Example: 'Samsung SM-J330F'.
            device: $c42107aeec692061$export$b08658138c4f5ab9.getDevice() || "Other",
            userAgent: $c42107aeec692061$export$b08658138c4f5ab9.getUserAgent(),
            browserId: $c42107aeec692061$export$b08658138c4f5ab9.getFingerprint()
        },
        screenDetails: {
            aspectRatio: (0, $09c8514a3acd9d5d$export$402482a772100d68)(),
            width: window.screen.width * window.devicePixelRatio,
            height: window.screen.height * window.devicePixelRatio
        }
    };
    try {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($04JJq))).get($c42107aeec692061$var$TOKEN_KEY)) throw new Error("no display_ctx");
        const data = $4ff4874d0e73f593$export$dcef71b8fb9a6794((0, (/*@__PURE__*/$parcel$interopDefault($04JJq))).get($c42107aeec692061$var$TOKEN_KEY));
        const newState = $c42107aeec692061$var$getStateFromObject(data);
        return {
            ...newState,
            ...browserInfo
        };
    } catch (e) {
        (0, (/*@__PURE__*/$parcel$interopDefault($04JJq))).remove($c42107aeec692061$var$TOKEN_KEY); // jwt is invalid clear it from storage
        return {
            auth: {
                isAuthenticated: false
            },
            ...browserInfo
        };
    }
};
const $c42107aeec692061$export$58adb3bec8346d0f = (0, $bNLBQ.createSlice)({
    name: (0, $lQ3n3.APP_REDUCER_NAME),
    initialState: $c42107aeec692061$var$initFromStorage(),
    reducers: {},
    extraReducers: (builder)=>{
        builder.addMatcher((0, $56f021744c00b1a4$export$2e2bcd8739ae039).endpoints.authenticate.matchFulfilled, (state, action)=>{
            const token = (0, $jgLFK.get)(action, "payload.data.jwt");
            if (!token) return;
            const data = $4ff4874d0e73f593$export$dcef71b8fb9a6794(token);
            const newState = $c42107aeec692061$var$getStateFromObject({
                ...data,
                groups: (0, $jgLFK.get)(action, "payload.data.groups", [])
            });
            state.branch = newState.branch;
            state.auth = newState.auth;
            state.displayId = newState.displayId;
            // store the jwt  as display_ctx in local storage
            (0, (/*@__PURE__*/$parcel$interopDefault($04JJq))).set($c42107aeec692061$var$TOKEN_KEY, token);
        });
        builder.addMatcher((0, $56f021744c00b1a4$export$2e2bcd8739ae039).endpoints.getDisplayGroups.matchFulfilled, (state, action)=>{
            (0, $jgLFK.set)(state, "branch.groups", action.payload.data);
        });
        builder.addMatcher((action)=>[
                // if any of these actions are rejected, check if the error is a 401
                (0, $56f021744c00b1a4$export$2e2bcd8739ae039).endpoints.getBranchTemplate.matchRejected,
                (0, $56f021744c00b1a4$export$2e2bcd8739ae039).endpoints.getDisplayGroups.matchRejected,
                (0, $56f021744c00b1a4$export$2e2bcd8739ae039).endpoints.statusUpdate.matchRejected,
                (0, $dYzX4.default).endpoints.getAppointments.matchRejected
            ].some((matcher)=>matcher(action)), (state, { payload: payload })=>{
            const error = (0, $jgLFK.get)(payload, "data.error");
            if (payload?.status === 401 || error?.status === 401 || error?.name === "UnauthorizedError") {
                state.auth.isAuthenticated = false;
                (0, (/*@__PURE__*/$parcel$interopDefault($04JJq))).remove($c42107aeec692061$var$TOKEN_KEY);
            }
        });
    }
});
const {} = $c42107aeec692061$export$58adb3bec8346d0f.actions;
const $c42107aeec692061$export$79fe358774725ae6 = (state)=>state.app;
const $c42107aeec692061$export$f3e93df765e61690 = (0, $36fSf.createSelector)($c42107aeec692061$export$79fe358774725ae6, (state)=>state.auth);
const $c42107aeec692061$export$2ab5b65636cd4f8b = (0, $36fSf.createSelector)($c42107aeec692061$export$79fe358774725ae6, (state)=>({
        screen: state.screenDetails,
        device: {
            browserDetails: state.browserDetails
        }
    }));
const $c42107aeec692061$export$50d08395b3233712 = (0, $36fSf.createSelector)($c42107aeec692061$export$79fe358774725ae6, (state)=>state.displayId);
var $c42107aeec692061$export$2e2bcd8739ae039 = $c42107aeec692061$export$58adb3bec8346d0f;



var $7oLjV = parcelRequire("7oLjV");
const $d6800a42d5821884$export$a8a69c316169e623 = {
    // slices & reducer
    [(0, $c42107aeec692061$export$2e2bcd8739ae039).name]: (0, $c42107aeec692061$export$2e2bcd8739ae039).reducer,
    // api reducers
    [(0, $7oLjV.default).reducerPath]: (0, $7oLjV.default).reducer
};
const $d6800a42d5821884$export$6f57813fe9f31bf9 = (0, $bNLBQ.configureStore)({
    reducer: $d6800a42d5821884$export$a8a69c316169e623,
    middleware: (getDefaultMiddleware)=>getDefaultMiddleware().concat((0, $7oLjV.default).middleware)
});
var $d6800a42d5821884$export$2e2bcd8739ae039 = $d6800a42d5821884$export$6f57813fe9f31bf9;


/**
 * Copyright 2023 ALPHAGUARD CONSULTING, LLC.  All rights reserved.
 * Use of this source code is governed by a Commercial License Agreement
 * license can be found in the LICENSE file or contact legal@alphaguard.io
 */ 
var $9dHn5 = parcelRequire("9dHn5");
/**
 * Copyright 2023 ALPHAGUARD CONSULTING, LLC.  All rights reserved.
 * Use of this source code is governed by a Commercial License Agreement
 * license can be found in the LICENSE file or contact legal@alphaguard.io
 */ 
var $cDoMf = parcelRequire("cDoMf");
/**
 * Copyright 2023 ALPHAGUARD CONSULTING, LLC.  All rights reserved.
 * Use of this source code is governed by a Commercial License Agreement
 * license can be found in the LICENSE file or contact legal@alphaguard.io
 */ 
var $cDoMf = parcelRequire("cDoMf");
const { defineMultiStyleConfig: $e9ab3ed032e855f5$var$defineMultiStyleConfig } = (0, $cDoMf.createMultiStyleConfigHelpers)([
    "root",
    "nav",
    "navlist",
    "item",
    "overlay"
]);
const $e9ab3ed032e855f5$var$maxWidth = 280;
const $e9ab3ed032e855f5$export$1a35787d6353cf6a = $e9ab3ed032e855f5$var$defineMultiStyleConfig({
    baseStyle: {
        root: {
            maxWidth: $e9ab3ed032e855f5$var$maxWidth,
            width: $e9ab3ed032e855f5$var$maxWidth,
            overflow: "hidden",
            overflowY: "auto",
            height: "calc(100vh - 64px)",
            zIndex: "docked"
        },
        nav: {
            h: "full",
            p: 4,
            bg: "body",
            borderRight: "1px solid #F2F4F7",
            zIndex: "docked"
        },
        navlist: {
            w: "full",
            spacing: 2
        },
        item: {
            w: "full",
            spacing: 3,
            alignContent: "center",
            color: "blue"
        },
        overlay: {
            bg: "blackAlpha.600",
            pos: "fixed",
            left: "0",
            top: "0",
            w: "100vw",
            h: "100vh"
        }
    },
    variants: {
        // They cannot be closed and is always visible, same elevation as other content
        permanent: {
            root: {
                position: "relative"
            }
        },
        // toggle can be open and closed, rendered above other content as mini variant
        persistent: ({ ariaExpanded: ariaExpanded })=>({
                ...!ariaExpanded && {
                    item: {
                        display: "none"
                    },
                    nav: {
                        px: 0
                    },
                    root: {
                        width: 80
                    }
                }
            }),
        // open above all other content.
        temporary: ({ ariaExpanded: ariaExpanded })=>({
                nav: {
                    position: "relative"
                },
                navlist: {
                    mt: 5
                },
                root: {
                    top: 0,
                    height: "100vh",
                    position: "fixed",
                    zIndex: "modal",
                    width: ariaExpanded ? $e9ab3ed032e855f5$var$maxWidth : 0
                }
            })
    },
    defaultProps: {
        variant: "persistent"
    }
});


/**
 * Copyright 2023 ALPHAGUARD CONSULTING, LLC.  All rights reserved.
 * Use of this source code is governed by a Commercial License Agreement
 * license can be found in the LICENSE file or contact legal@alphaguard.io
 */ 
var $cDoMf = parcelRequire("cDoMf");
// This function creates a set of function that helps us create multipart component styles.
const { defineMultiStyleConfig: $aa9dadcdb94a9111$var$defineMultiStyleConfig } = (0, $cDoMf.createMultiStyleConfigHelpers)([
    "asset_card",
    "asset_card_tag"
]);
const $aa9dadcdb94a9111$export$eff93e4e59ccc3b8 = $aa9dadcdb94a9111$var$defineMultiStyleConfig({
    baseStyle: {},
    variants: {
        MyWelcomeTv: {
            asset_card_tag: {
                color: "white",
                bg: "#4d8dba"
            }
        },
        branch: {
            asset_card_tag: {
                bg: "gray.100"
            }
        },
        organization: {
            asset_card_tag: {
                bg: "primary.500"
            }
        }
    }
});


const $bd6a3c1fc1baa00e$export$353f5b6fc5456de1 = (0, $cDoMf.defineStyleConfig)({
    variants: {
        "nav-item": {
            justifyContent: "start",
            _hover: {
                bg: "neutral.100"
            },
            _active: {
                bg: "neutral.150"
            }
        },
        outline: ({ dropShadow: dropShadow, boxShadow: boxShadow })=>({
                boxShadow: dropShadow ? "0px 1px 4px 0px #2121341A" : boxShadow
            })
    }
});
const $bd6a3c1fc1baa00e$export$48513f6b9f8ce62d = (0, $cDoMf.defineStyleConfig)({
    baseStyle: {
        control: {
            borderColor: "blackAlpha.700"
        }
    }
});



const $d95b419e1c705dae$var$theme = (0, $9dHn5.extendTheme)({
    fonts: {
    },
    styles: {
        global: {
            body: {
                bg: "body"
            },
            "#id": {
                bg: "red"
            },
            svg: {
                maxH: "4rem",
                maxW: "4rem",
                minH: "1rem",
                minW: "1rem"
            }
        }
    },
    components: {
        AssetCard: $aa9dadcdb94a9111$export$eff93e4e59ccc3b8,
        Button: $bd6a3c1fc1baa00e$export$353f5b6fc5456de1,
        Checkbox: $bd6a3c1fc1baa00e$export$48513f6b9f8ce62d,
        SideNav: $e9ab3ed032e855f5$export$1a35787d6353cf6a
    },
    colors: {
        body: "#FCFCFD",
        template: {
            bg: "rgba(0, 86, 248, 0.63)",
            "blockBoxShadow": "inset 0 0 0 4px  var(--chakra-colors-blue-400)"
        },
        media: {
            grid: "repeating-conic-gradient(rgb(246, 246, 249) 0%, rgb(246, 246, 249) 25%, transparent 0%, transparent 50%) 50% center / 20px 20px"
        }
    }
});
var $d95b419e1c705dae$export$2e2bcd8739ae039 = $d95b419e1c705dae$var$theme;



/**
 * Copyright 2023 ALPHAGUARD CONSULTING, LLC.  All rights reserved.
 * Use of this source code is governed by a Commercial License Agreement
 * license can be found in the LICENSE file or contact legal@alphaguard.io
 */ 
var $4mwsf = parcelRequire("4mwsf");

var $3qjKr = parcelRequire("3qjKr");


var $LfCz8 = parcelRequire("LfCz8");

var $8lIUy = parcelRequire("8lIUy");
parcelRequire("bvqOc");
var $hjhWs = parcelRequire("hjhWs");


const $8ae388fcec2239ec$var$DisplayTemplate = /*#__PURE__*/ (0, $3qjKr.lazy)(()=>(parcelRequire("1BjEo")));
const $8ae388fcec2239ec$var$refetchGroupsInterval = 20000; // 20 seconds
const $8ae388fcec2239ec$var$reportStatusInterval = 60000; // 1 minute
const $8ae388fcec2239ec$var$refetchTemplateInterval = 600000; // 10 minutes
const $8ae388fcec2239ec$var$TemplateSnapshot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3qjKr))).memo($8ae388fcec2239ec$var$DisplayTemplate);
const $8ae388fcec2239ec$var$PlayerTemplate = ()=>{
    const branch = (0, $LfCz8.useBranch)();
    const { id: displayDbId } = (0, $hjhWs.useSelector)((0, $c42107aeec692061$export$f3e93df765e61690));
    // report the status of the display
    (0, $56f021744c00b1a4$export$39d9d702b23ca703)(displayDbId, {
        skip: !displayDbId,
        pollingInterval: $8ae388fcec2239ec$var$reportStatusInterval
    });
    const { isLoading: isLoadingTemplate, data: templateRes } = (0, $56f021744c00b1a4$export$814b52391038d2bf)(branch?.id, {
        skip: !branch?.id,
        pollingInterval: $8ae388fcec2239ec$var$refetchTemplateInterval
    });
    // we need to update the display groups for the template appoinments
    (0, $56f021744c00b1a4$export$f76eb9f1722003ca)(displayDbId, {
        skip: !displayDbId,
        pollingInterval: $8ae388fcec2239ec$var$refetchGroupsInterval
    });
    return /*#__PURE__*/ (0, $4mwsf.jsx)((0, $3qjKr.Suspense), {
        children: /*#__PURE__*/ (0, $4mwsf.jsx)((0, $8lIUy.Box), {
            h: "100vh",
            w: "100vw",
            overflow: "hidden",
            children: /*#__PURE__*/ (0, $4mwsf.jsx)($8ae388fcec2239ec$var$TemplateSnapshot, {
                isLive: true,
                template: templateRes,
                isLoading: isLoadingTemplate
            })
        })
    });
};
var $8ae388fcec2239ec$export$2e2bcd8739ae039 = $8ae388fcec2239ec$var$PlayerTemplate;


/**
 * Copyright 2023 ALPHAGUARD CONSULTING, LLC.  All rights reserved.
 * Use of this source code is governed by a Commercial License Agreement
 * license can be found in the LICENSE file or contact legal@alphaguard.io
 */ 
var $4mwsf = parcelRequire("4mwsf");

var $3qjKr = parcelRequire("3qjKr");

var $04JJq = parcelRequire("04JJq");

var $7V8eP = parcelRequire("7V8eP");

parcelRequire("bvqOc");
var $hjhWs = parcelRequire("hjhWs");

var $8lIUy = parcelRequire("8lIUy");
var $1kFN0 = parcelRequire("1kFN0");
var $1CyaF = parcelRequire("1CyaF");
var $cDoMf = parcelRequire("cDoMf");
var $9a7LB = parcelRequire("9a7LB");

var $iyhjB = parcelRequire("iyhjB");

var $4mwsf = parcelRequire("4mwsf");
"use client";
var $c4c4ee06f738d851$export$42a852a2b6b56249 = (0, $1CyaF.forwardRef)(function Container2(props, ref) {
    const { className: className, centerContent: centerContent, ...rest } = (0, $cDoMf.omitThemingProps)(props);
    const styles = (0, $9a7LB.useStyleConfig)("Container", props);
    return /* @__PURE__ */ (0, $4mwsf.jsx)((0, $1kFN0.chakra).div, {
        ref: ref,
        className: (0, $iyhjB.cx)("chakra-container", className),
        ...rest,
        __css: {
            ...styles,
            ...centerContent && {
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
            }
        }
    });
});
$c4c4ee06f738d851$export$42a852a2b6b56249.displayName = "Container";


var $1kFN0 = parcelRequire("1kFN0");
var $1CyaF = parcelRequire("1CyaF");
var $cDoMf = parcelRequire("cDoMf");
var $9a7LB = parcelRequire("9a7LB");

var $iyhjB = parcelRequire("iyhjB");

var $4mwsf = parcelRequire("4mwsf");
"use client";
var $698b985c9e2476e0$export$a8a3e93435678ff9 = (0, $1CyaF.forwardRef)(function Heading2(props, ref) {
    const styles = (0, $9a7LB.useStyleConfig)("Heading", props);
    const { className: className, ...rest } = (0, $cDoMf.omitThemingProps)(props);
    return /* @__PURE__ */ (0, $4mwsf.jsx)((0, $1kFN0.chakra).h2, {
        ref: ref,
        className: (0, $iyhjB.cx)("chakra-heading", props.className),
        ...rest,
        __css: styles
    });
});
$698b985c9e2476e0$export$a8a3e93435678ff9.displayName = "Heading";


var $2Ts8H = parcelRequire("2Ts8H");
var $3qjKr = parcelRequire("3qjKr");
"use client";
function $576daeca67a6c3f2$export$5964c316e853650f() {
    const isFirstRender = (0, $3qjKr.useRef)(true);
    (0, $3qjKr.useEffect)(()=>{
        isFirstRender.current = false;
    }, []);
    return isFirstRender.current;
}



var $3qjKr = parcelRequire("3qjKr");
"use client";
function $644baf57e92fbe4e$export$5cae361ad82dce8b(value) {
    const ref = (0, $3qjKr.useRef)();
    (0, $3qjKr.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}



var $iyhjB = parcelRequire("iyhjB");

var $1kFN0 = parcelRequire("1kFN0");
var $cDoMf = parcelRequire("cDoMf");
var $1CyaF = parcelRequire("1CyaF");
var $8ka9R = parcelRequire("8ka9R");
var $9a7LB = parcelRequire("9a7LB");
var $fNpZk = parcelRequire("fNpZk");

var $4mwsf = parcelRequire("4mwsf");
"use client";
var $c467432091d3f1cc$var$StyledSkeleton = (0, $1kFN0.chakra)("div", {
    baseStyle: {
        boxShadow: "none",
        backgroundClip: "padding-box",
        cursor: "default",
        color: "transparent",
        pointerEvents: "none",
        userSelect: "none",
        "&::before, &::after, *": {
            visibility: "hidden"
        }
    }
});
var $c467432091d3f1cc$var$$startColor = (0, $cDoMf.cssVar)("skeleton-start-color");
var $c467432091d3f1cc$var$$endColor = (0, $cDoMf.cssVar)("skeleton-end-color");
var $c467432091d3f1cc$var$fade = (0, $8ka9R.keyframes)({
    from: {
        opacity: 0
    },
    to: {
        opacity: 1
    }
});
var $c467432091d3f1cc$var$bgFade = (0, $8ka9R.keyframes)({
    from: {
        borderColor: $c467432091d3f1cc$var$$startColor.reference,
        background: $c467432091d3f1cc$var$$startColor.reference
    },
    to: {
        borderColor: $c467432091d3f1cc$var$$endColor.reference,
        background: $c467432091d3f1cc$var$$endColor.reference
    }
});
var $c467432091d3f1cc$export$8f31e4c4a37b8e9c = (0, $1CyaF.forwardRef)((props, ref)=>{
    const skeletonProps = {
        ...props,
        fadeDuration: typeof props.fadeDuration === "number" ? props.fadeDuration : 0.4,
        speed: typeof props.speed === "number" ? props.speed : 0.8
    };
    const styles = (0, $9a7LB.useStyleConfig)("Skeleton", skeletonProps);
    const isFirstRender = (0, $576daeca67a6c3f2$export$5964c316e853650f)();
    const { startColor: startColor = "", endColor: endColor = "", isLoaded: isLoaded, fadeDuration: fadeDuration, speed: speed, className: className, fitContent: fitContent, ...rest } = (0, $cDoMf.omitThemingProps)(skeletonProps);
    const [startColorVar, endColorVar] = (0, $fNpZk.useToken)("colors", [
        startColor,
        endColor
    ]);
    const wasPreviouslyLoaded = (0, $644baf57e92fbe4e$export$5cae361ad82dce8b)(isLoaded);
    const _className = (0, $iyhjB.cx)("chakra-skeleton", className);
    const cssVarStyles = {
        ...startColorVar && {
            [$c467432091d3f1cc$var$$startColor.variable]: startColorVar
        },
        ...endColorVar && {
            [$c467432091d3f1cc$var$$endColor.variable]: endColorVar
        }
    };
    if (isLoaded) {
        const animation = isFirstRender || wasPreviouslyLoaded ? "none" : `${$c467432091d3f1cc$var$fade} ${fadeDuration}s`;
        return /* @__PURE__ */ (0, $4mwsf.jsx)((0, $1kFN0.chakra).div, {
            ref: ref,
            className: _className,
            __css: {
                animation: animation
            },
            ...rest
        });
    }
    return /* @__PURE__ */ (0, $4mwsf.jsx)($c467432091d3f1cc$var$StyledSkeleton, {
        ref: ref,
        className: _className,
        ...rest,
        __css: {
            width: fitContent ? "fit-content" : void 0,
            ...styles,
            ...cssVarStyles,
            _dark: {
                ...styles["_dark"],
                ...cssVarStyles
            },
            animation: `${speed}s linear infinite alternate ${$c467432091d3f1cc$var$bgFade}`
        }
    });
});
$c467432091d3f1cc$export$8f31e4c4a37b8e9c.displayName = "Skeleton";




var $1kFN0 = parcelRequire("1kFN0");
var $1CyaF = parcelRequire("1CyaF");
var $cDoMf = parcelRequire("cDoMf");
var $9a7LB = parcelRequire("9a7LB");

var $4mwsf = parcelRequire("4mwsf");
"use client";
var [$ccc4806c733578f7$var$TagStylesProvider, $ccc4806c733578f7$export$fa5e32657e7ee8a0] = (0, $2b5826b2c930f0e8$export$fd42f52fd3ae1109)({
    name: `TagStylesContext`,
    errorMessage: `useTagStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Tag />" `
});
var $ccc4806c733578f7$export$3288d34c523a1192 = (0, $1CyaF.forwardRef)((props, ref)=>{
    const styles = (0, $9a7LB.useMultiStyleConfig)("Tag", props);
    const ownProps = (0, $cDoMf.omitThemingProps)(props);
    const containerStyles = {
        display: "inline-flex",
        verticalAlign: "top",
        alignItems: "center",
        maxWidth: "100%",
        ...styles.container
    };
    return /* @__PURE__ */ (0, $4mwsf.jsx)($ccc4806c733578f7$var$TagStylesProvider, {
        value: styles,
        children: /* @__PURE__ */ (0, $4mwsf.jsx)((0, $1kFN0.chakra).span, {
            ref: ref,
            ...ownProps,
            __css: containerStyles
        })
    });
});
$ccc4806c733578f7$export$3288d34c523a1192.displayName = "Tag";
var $ccc4806c733578f7$export$f5486329f0fd0847 = (0, $1CyaF.forwardRef)((props, ref)=>{
    const styles = $ccc4806c733578f7$export$fa5e32657e7ee8a0();
    return /* @__PURE__ */ (0, $4mwsf.jsx)((0, $1kFN0.chakra).span, {
        ref: ref,
        noOfLines: 1,
        ...props,
        __css: styles.label
    });
});
$ccc4806c733578f7$export$f5486329f0fd0847.displayName = "TagLabel";
var $ccc4806c733578f7$export$1b1a9388acf57360 = (0, $1CyaF.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $4mwsf.jsx)((0, $b4f3eec673f28dae$export$f04a61298a47a40f), {
        ref: ref,
        verticalAlign: "top",
        marginEnd: "0.5rem",
        ...props
    }));
$ccc4806c733578f7$export$1b1a9388acf57360.displayName = "TagLeftIcon";
var $ccc4806c733578f7$export$469b69b26b54518e = (0, $1CyaF.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $4mwsf.jsx)((0, $b4f3eec673f28dae$export$f04a61298a47a40f), {
        ref: ref,
        verticalAlign: "top",
        marginStart: "0.5rem",
        ...props
    }));
$ccc4806c733578f7$export$469b69b26b54518e.displayName = "TagRightIcon";
var $ccc4806c733578f7$var$TagCloseIcon = (props)=>/* @__PURE__ */ (0, $4mwsf.jsx)((0, $b4f3eec673f28dae$export$f04a61298a47a40f), {
        verticalAlign: "inherit",
        viewBox: "0 0 512 512",
        ...props,
        children: /* @__PURE__ */ (0, $4mwsf.jsx)("path", {
            fill: "currentColor",
            d: "M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"
        })
    });
$ccc4806c733578f7$var$TagCloseIcon.displayName = "TagCloseIcon";
var $ccc4806c733578f7$export$2c1e51182f03e1ee = (0, $1CyaF.forwardRef)((props, ref)=>{
    const { isDisabled: isDisabled, children: children, ...rest } = props;
    const styles = $ccc4806c733578f7$export$fa5e32657e7ee8a0();
    const btnStyles = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        outline: "0",
        ...styles.closeButton
    };
    return /* @__PURE__ */ (0, $4mwsf.jsx)((0, $1kFN0.chakra).button, {
        ref: ref,
        "aria-label": "close",
        ...rest,
        type: "button",
        disabled: isDisabled,
        __css: btnStyles,
        children: children || /* @__PURE__ */ (0, $4mwsf.jsx)($ccc4806c733578f7$var$TagCloseIcon, {})
    });
});
$ccc4806c733578f7$export$2c1e51182f03e1ee.displayName = "TagCloseButton";


var $j9JrO = parcelRequire("j9JrO");
var $4Nb8r = parcelRequire("4Nb8r");


var $aa8072855a81e027$exports = {};
$aa8072855a81e027$exports = new URL("waves-2.a99ba250.webm", import.meta.url).toString();


const $e897a5788e6832e9$var$bgImage = new URL($aa8072855a81e027$exports);
const $e897a5788e6832e9$var$useRetryRegisterDisplay = ({ delayInSeconds: delayInSeconds = 10, maxAttempts: maxAttempts = 3 })=>{
    const displayInfo = (0, $hjhWs.useSelector)((0, $c42107aeec692061$export$2ab5b65636cd4f8b));
    const attempts = (0, (/*@__PURE__*/$parcel$interopDefault($3qjKr))).useRef(0);
    const waitForRetry = (0, (/*@__PURE__*/$parcel$interopDefault($3qjKr))).useRef(false);
    const [registerDisplay, state] = (0, $56f021744c00b1a4$export$e3b4dc7264a67b3b)();
    const retry = (0, (/*@__PURE__*/$parcel$interopDefault($3qjKr))).useCallback(async (displayId)=>{
        if (attempts.current >= maxAttempts || waitForRetry.current) return;
        attempts.current += 1; // Increment the attempts counter
        try {
            waitForRetry.current = true;
            const display = await registerDisplay({
                displayId: displayId,
                ...displayInfo
            }); // Try to run the passed async function
            if (display?.error) throw new Error("shouldRetry");
            waitForRetry.current = false;
            (0, (/*@__PURE__*/$parcel$interopDefault($04JJq))).set("displayId", displayId);
        } catch (err) {
            setTimeout(()=>{
                waitForRetry.current = false;
                retry(displayId);
            }, delayInSeconds * 1000); // Schedule a retry after the delay
        }
    }, [
        delayInSeconds,
        maxAttempts
    ]);
    return [
        retry,
        {
            ...state,
            isRetrying: !state.isSuccess && attempts.current < maxAttempts
        }
    ];
};
// NOTE: displayID needs to be atleast 10 characters long
const $e897a5788e6832e9$var$RegisterDisplay = ()=>{
    const { displayId: urlDisplayId } = (0, $b6ec4a53b0d9b34f$export$99eaa27ddbbb95ef)();
    const { hostname: hostname } = new URL(window.location.href);
    const { isAuthenticated: isAuthenticated } = (0, $hjhWs.useSelector)((0, $c42107aeec692061$export$f3e93df765e61690));
    const currentDisplayId = (0, $hjhWs.useSelector)((0, $c42107aeec692061$export$50d08395b3233712));
    const [registerDisplay, { isError: isRegistrationError, isRetrying: isRetrying, data: registrationData }] = $e897a5788e6832e9$var$useRetryRegisterDisplay({
        delayInSeconds: 1,
        maxAttempts: 5
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($3qjKr))).useEffect(()=>{
        // Removed the fingerprint in favor of the random number
        // const fingerprint = clientJs.getFingerprint();
        // const genID =
        //   currentDisplayId ||
        //   (clientJs.isMobile()
        //     ? `rn_${crypto?.randomUUID()}`
        //     : `fp_${fingerprint}`);
        // NOTE: displayID needs to be atleast 10 characters long, so we pad it with the fingerprint
        const displayId = (0, (/*@__PURE__*/$parcel$interopDefault($04JJq))).get("displayId") || crypto?.randomUUID();
        const guid = [
            urlDisplayId,
            displayId
        ].join(urlDisplayId ? "-" : "");
        registerDisplay(guid);
    }, [
        urlDisplayId,
        currentDisplayId
    ]);
    const displayCode = (0, (/*@__PURE__*/$parcel$interopDefault($7V8eP)))(registrationData, "code");
    const displayId = (0, (/*@__PURE__*/$parcel$interopDefault($7V8eP)))(registrationData, "displayId", currentDisplayId);
    // start polling for authentication
    (0, $56f021744c00b1a4$export$6d2000fc9897b03d)({
        displayId: displayId,
        code: displayCode
    }, {
        skip: !displayCode,
        pollingInterval: 2000
    });
    if (isAuthenticated) return /*#__PURE__*/ (0, $4mwsf.jsx)((0, $b6ec4a53b0d9b34f$export$444b3ab0cb9aec40), {
        to: "/"
    });
    return /*#__PURE__*/ (0, $4mwsf.jsxs)((0, $4mwsf.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4mwsf.jsx)((0, $8lIUy.Box), {
                h: "100vh",
                bg: "#0056f873",
                color: "white",
                overflow: "hidden",
                children: /*#__PURE__*/ (0, $4mwsf.jsxs)((0, $c4c4ee06f738d851$export$42a852a2b6b56249), {
                    maxW: "8xl",
                    centerContent: true,
                    h: "full",
                    as: (0, $4Nb8r.VStack),
                    children: [
                        isRegistrationError && !isRetrying ? /*#__PURE__*/ (0, $4mwsf.jsxs)((0, $4mwsf.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $4mwsf.jsx)((0, $698b985c9e2476e0$export$a8a3e93435678ff9), {
                                    my: "3rem",
                                    textAlign: "center",
                                    children: "An unknown error occurred during display registration."
                                }),
                                /*#__PURE__*/ (0, $4mwsf.jsx)((0, $4Nb8r.VStack), {
                                    align: "start",
                                    spacing: 10,
                                    children: /*#__PURE__*/ (0, $4mwsf.jsx)((0, $j9JrO.Text), {
                                        fontSize: "2rem",
                                        children: "Please contact WelcomeTv support if this issue persists."
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $4mwsf.jsx)((0, $4mwsf.Fragment), {
                            children: /*#__PURE__*/ (0, $4mwsf.jsxs)((0, $4mwsf.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $4mwsf.jsx)((0, $698b985c9e2476e0$export$a8a3e93435678ff9), {
                                        my: "3rem",
                                        children: "Follow these steps on your computer or mobile device"
                                    }),
                                    /*#__PURE__*/ (0, $4mwsf.jsxs)((0, $4Nb8r.VStack), {
                                        align: "start",
                                        spacing: 10,
                                        children: [
                                            /*#__PURE__*/ (0, $4mwsf.jsxs)((0, $2Ts8H.HStack), {
                                                align: "start",
                                                children: [
                                                    /*#__PURE__*/ (0, $4mwsf.jsx)((0, $ccc4806c733578f7$export$3288d34c523a1192), {
                                                        m: 3,
                                                        size: "lg",
                                                        px: "5",
                                                        fontWeight: "bold",
                                                        children: "STEP 1"
                                                    }),
                                                    /*#__PURE__*/ (0, $4mwsf.jsxs)((0, $8lIUy.Box), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $4mwsf.jsx)((0, $j9JrO.Text), {
                                                                fontSize: "2rem",
                                                                children: "Open a web browser and go to"
                                                            }),
                                                            /*#__PURE__*/ (0, $4mwsf.jsx)((0, $698b985c9e2476e0$export$a8a3e93435678ff9), {
                                                                children: hostname
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4mwsf.jsxs)((0, $2Ts8H.HStack), {
                                                align: "start",
                                                children: [
                                                    /*#__PURE__*/ (0, $4mwsf.jsx)((0, $ccc4806c733578f7$export$3288d34c523a1192), {
                                                        m: 3,
                                                        size: "lg",
                                                        px: "5",
                                                        fontWeight: "bold",
                                                        children: "STEP 2"
                                                    }),
                                                    /*#__PURE__*/ (0, $4mwsf.jsxs)((0, $8lIUy.Box), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $4mwsf.jsx)((0, $j9JrO.Text), {
                                                                fontSize: "2rem",
                                                                children: "Enter sign-in code:"
                                                            }),
                                                            /*#__PURE__*/ (0, $4mwsf.jsx)((0, $c467432091d3f1cc$export$8f31e4c4a37b8e9c), {
                                                                height: "40px",
                                                                isLoaded: !isRetrying || !!displayCode,
                                                                children: /*#__PURE__*/ (0, $4mwsf.jsx)((0, $698b985c9e2476e0$export$a8a3e93435678ff9), {
                                                                    children: displayCode
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4mwsf.jsxs)((0, $2Ts8H.HStack), {
                                                align: "start",
                                                children: [
                                                    /*#__PURE__*/ (0, $4mwsf.jsx)((0, $ccc4806c733578f7$export$3288d34c523a1192), {
                                                        m: 3,
                                                        size: "lg",
                                                        px: "5",
                                                        fontWeight: "bold",
                                                        children: "STEP 3"
                                                    }),
                                                    /*#__PURE__*/ (0, $4mwsf.jsx)((0, $8lIUy.Box), {
                                                        children: /*#__PURE__*/ (0, $4mwsf.jsx)((0, $j9JrO.Text), {
                                                            fontSize: "2rem",
                                                            children: "Sign in to WelcomeTv. Your Display will be ready!"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $4mwsf.jsx)((0, $c467432091d3f1cc$export$8f31e4c4a37b8e9c), {
                            height: "40px",
                            isLoaded: !isRetrying || !!displayCode,
                            children: /*#__PURE__*/ (0, $4mwsf.jsx)((0, $j9JrO.Text), {
                                as: "kbd",
                                pos: "fixed",
                                bottom: 0,
                                right: 0,
                                children: displayId || "Error: No display found"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $4mwsf.jsx)("video", {
                autoPlay: true,
                loop: true,
                muted: true,
                style: {
                    objectFit: "cover",
                    height: "100vh",
                    width: "100vw",
                    filter: "blur(0.5rem) opacity(1)",
                    position: "fixed",
                    top: "0",
                    left: "0",
                    zIndex: "-1"
                },
                children: /*#__PURE__*/ (0, $4mwsf.jsx)("source", {
                    src: $e897a5788e6832e9$var$bgImage.href,
                    type: "video/webm"
                })
            })
        ]
    });
};
var $e897a5788e6832e9$export$2e2bcd8739ae039 = $e897a5788e6832e9$var$RegisterDisplay;


const $e39dc1f96b6fb328$export$f01b3d7c7bbe3997 = ({ children: children })=>{
    const { isAuthenticated: isAuthenticated } = (0, $hjhWs.useSelector)((0, $c42107aeec692061$export$f3e93df765e61690));
    const { displayId: urlDisplayId } = (0, $b6ec4a53b0d9b34f$export$99eaa27ddbbb95ef)();
    if (!isAuthenticated) return urlDisplayId ? /*#__PURE__*/ (0, $4mwsf.jsx)((0, $b6ec4a53b0d9b34f$export$444b3ab0cb9aec40), {
        to: `/register/${urlDisplayId}`,
        replace: true
    }) : /*#__PURE__*/ (0, $4mwsf.jsx)((0, $b6ec4a53b0d9b34f$export$444b3ab0cb9aec40), {
        to: "/register",
        replace: true
    });
    return children ? children : /*#__PURE__*/ (0, $4mwsf.jsx)((0, $b6ec4a53b0d9b34f$export$910ae8079b2c2852), {});
};
const $e39dc1f96b6fb328$var$router = (0, $b18049b56c6fd776$export$1f3f55432a00e06d)((0, $b6ec4a53b0d9b34f$export$16da398f5434bdec)(/*#__PURE__*/ (0, $4mwsf.jsxs)((0, $b6ec4a53b0d9b34f$export$e7b0ac011bb776c6), {
    path: "/",
    element: /*#__PURE__*/ (0, $4mwsf.jsx)((0, $b6ec4a53b0d9b34f$export$910ae8079b2c2852), {}),
    children: [
        /*#__PURE__*/ (0, $4mwsf.jsx)((0, $b6ec4a53b0d9b34f$export$e7b0ac011bb776c6), {
            index: true,
            element: /*#__PURE__*/ (0, $4mwsf.jsx)($e39dc1f96b6fb328$export$f01b3d7c7bbe3997, {
                children: /*#__PURE__*/ (0, $4mwsf.jsx)((0, $8ae388fcec2239ec$export$2e2bcd8739ae039), {})
            })
        }),
        /*#__PURE__*/ (0, $4mwsf.jsxs)((0, $b6ec4a53b0d9b34f$export$e7b0ac011bb776c6), {
            path: "register",
            children: [
                /*#__PURE__*/ (0, $4mwsf.jsx)((0, $b6ec4a53b0d9b34f$export$e7b0ac011bb776c6), {
                    index: true,
                    element: /*#__PURE__*/ (0, $4mwsf.jsx)((0, $e897a5788e6832e9$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $4mwsf.jsx)((0, $b6ec4a53b0d9b34f$export$e7b0ac011bb776c6), {
                    path: ":displayId",
                    element: /*#__PURE__*/ (0, $4mwsf.jsx)((0, $e897a5788e6832e9$export$2e2bcd8739ae039), {})
                })
            ]
        }),
        /*#__PURE__*/ (0, $4mwsf.jsx)((0, $b6ec4a53b0d9b34f$export$e7b0ac011bb776c6), {
            path: ":displayId",
            element: /*#__PURE__*/ (0, $4mwsf.jsx)($e39dc1f96b6fb328$export$f01b3d7c7bbe3997, {})
        })
    ]
})));
const $e39dc1f96b6fb328$var$root = $51947a66e5305600$export$882461b6382ed46c(document.getElementById("root"));
$e39dc1f96b6fb328$var$root.render(/*#__PURE__*/ (0, $4mwsf.jsx)((0, $3qjKr.StrictMode), {
    children: /*#__PURE__*/ (0, $4mwsf.jsx)((0, $8eJ0A.default), {
        store: (0, $d6800a42d5821884$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $4mwsf.jsx)((0, $e79f18655b554449$export$80dbe0482bcbd25a), {
            theme: (0, $d95b419e1c705dae$export$2e2bcd8739ae039),
            children: /*#__PURE__*/ (0, $4mwsf.jsx)((0, $b6ec4a53b0d9b34f$export$323e4fc2fa4753fb), {
                router: $e39dc1f96b6fb328$var$router
            })
        })
    })
}));


//# sourceMappingURL=index.571728d4.js.map
